[
  {
    "id": 1,
    "name_th": "กรุงเทพมหานคร",
    "name_en": "Bangkok",
    "geography_id": 2,
    "created_at": "2019-08-09T03:33:09.000+07:00",
    "updated_at": "2025-09-20T06:31:26.000+07:00",
    "deleted_at": null,
    "districts": [
      {
        "id": 1001,
        "name_th": "เขตพระนคร",
        "name_en": "Khet Phra Nakhon",
        "province_id": 1,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 100101,
            "zip_code": 10200,
            "name_th": "พระบรมมหาราชวัง",
            "name_en": "Phra Borom Maha Ratchawang",
            "district_id": 1001,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 100102,
            "zip_code": 10200,
            "name_th": "วังบูรพาภิรมย์",
            "name_en": "Wang Burapha Phirom",
            "district_id": 1001,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 100103,
            "zip_code": 10200,
            "name_th": "วัดราชบพิธ",
            "name_en": "Wat Ratchabophit",
            "district_id": 1001,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 100104,
            "zip_code": 10200,
            "name_th": "สำราญราษฎร์",
            "name_en": "Samran Rat",
            "district_id": 1001,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 100105,
            "zip_code": 10200,
            "name_th": "ศาลเจ้าพ่อเสือ",
            "name_en": "San Chao Pho Suea",
            "district_id": 1001,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 100106,
            "zip_code": 10200,
            "name_th": "เสาชิงช้า",
            "name_en": "Sao Chingcha",
            "district_id": 1001,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 100107,
            "zip_code": 10200,
            "name_th": "บวรนิเวศ",
            "name_en": "Bowon Niwet",
            "district_id": 1001,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 100108,
            "zip_code": 10200,
            "name_th": "ตลาดยอด",
            "name_en": "Talat Yot",
            "district_id": 1001,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 100109,
            "zip_code": 10200,
            "name_th": "ชนะสงคราม",
            "name_en": "Chana Songkhram",
            "district_id": 1001,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 100110,
            "zip_code": 10200,
            "name_th": "บ้านพานถม",
            "name_en": "Ban Phan Thom",
            "district_id": 1001,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 100111,
            "zip_code": 10200,
            "name_th": "บางขุนพรหม",
            "name_en": "Bang Khun Phrom",
            "district_id": 1001,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 100112,
            "zip_code": 10200,
            "name_th": "วัดสามพระยา",
            "name_en": "Wat Sam Phraya",
            "district_id": 1001,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 1002,
        "name_th": "เขตดุสิต",
        "name_en": "Khet Dusit",
        "province_id": 1,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 100201,
            "zip_code": 10300,
            "name_th": "ดุสิต",
            "name_en": "Dusit",
            "district_id": 1002,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 100202,
            "zip_code": 10300,
            "name_th": "วชิรพยาบาล",
            "name_en": "Wachiraphayaban",
            "district_id": 1002,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 100203,
            "zip_code": 10300,
            "name_th": "สวนจิตรลดา",
            "name_en": "Suan Chit Lada",
            "district_id": 1002,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 100204,
            "zip_code": 10300,
            "name_th": "สี่แยกมหานาค",
            "name_en": "Si Yaek Maha Nak",
            "district_id": 1002,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 100206,
            "zip_code": 10300,
            "name_th": "ถนนนครไชยศรี",
            "name_en": "Thanon Nakhon Chai Si",
            "district_id": 1002,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 1003,
        "name_th": "เขตหนองจอก",
        "name_en": "Khet Nong Chok",
        "province_id": 1,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 100301,
            "zip_code": 10530,
            "name_th": "กระทุ่มราย",
            "name_en": "Krathum Rai",
            "district_id": 1003,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 100302,
            "zip_code": 10530,
            "name_th": "หนองจอก",
            "name_en": "Nong Chok",
            "district_id": 1003,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 100303,
            "zip_code": 10530,
            "name_th": "คลองสิบ",
            "name_en": "Khlong Sip",
            "district_id": 1003,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 100304,
            "zip_code": 10530,
            "name_th": "คลองสิบสอง",
            "name_en": "Khlong Sip Song",
            "district_id": 1003,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 100305,
            "zip_code": 10530,
            "name_th": "โคกแฝด",
            "name_en": "Khok Faet",
            "district_id": 1003,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 100306,
            "zip_code": 10530,
            "name_th": "คู้ฝั่งเหนือ",
            "name_en": "Khu Fang Nuea",
            "district_id": 1003,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 100307,
            "zip_code": 10530,
            "name_th": "ลำผักชี",
            "name_en": "Lam Phak Chi",
            "district_id": 1003,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 100308,
            "zip_code": 10530,
            "name_th": "ลำต้อยติ่ง",
            "name_en": "Lam Toiting",
            "district_id": 1003,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 1004,
        "name_th": "เขตบางรัก",
        "name_en": "Khet Bang Rak",
        "province_id": 1,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 100401,
            "zip_code": 10500,
            "name_th": "มหาพฤฒาราม",
            "name_en": "Maha Phruettharam",
            "district_id": 1004,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 100402,
            "zip_code": 10500,
            "name_th": "สีลม",
            "name_en": "Si Lom",
            "district_id": 1004,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 100403,
            "zip_code": 10500,
            "name_th": "สุริยวงศ์",
            "name_en": "Suriyawong",
            "district_id": 1004,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 100404,
            "zip_code": 10500,
            "name_th": "บางรัก",
            "name_en": "Bang Rak",
            "district_id": 1004,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 100405,
            "zip_code": 10500,
            "name_th": "สี่พระยา",
            "name_en": "Si Phraya",
            "district_id": 1004,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 1005,
        "name_th": "เขตบางเขน",
        "name_en": "Khet Bang Khen",
        "province_id": 1,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 100502,
            "zip_code": 10220,
            "name_th": "อนุสาวรีย์",
            "name_en": "Anusawari",
            "district_id": 1005,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 100508,
            "zip_code": 10220,
            "name_th": "ท่าแร้ง",
            "name_en": "Tha Raeng",
            "district_id": 1005,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 1006,
        "name_th": "เขตบางกะปิ",
        "name_en": "Khet Bang Kapi",
        "province_id": 1,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 100601,
            "zip_code": 10240,
            "name_th": "คลองจั่น",
            "name_en": "Khlong Chan",
            "district_id": 1006,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 100608,
            "zip_code": 10240,
            "name_th": "หัวหมาก",
            "name_en": "Hua Mak",
            "district_id": 1006,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 1007,
        "name_th": "เขตปทุมวัน",
        "name_en": "Khet Pathum Wan",
        "province_id": 1,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 100701,
            "zip_code": 10330,
            "name_th": "รองเมือง",
            "name_en": "Rong Mueang",
            "district_id": 1007,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 100702,
            "zip_code": 10330,
            "name_th": "วังใหม่",
            "name_en": "Wang Mai",
            "district_id": 1007,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 100703,
            "zip_code": 10330,
            "name_th": "ปทุมวัน",
            "name_en": "Pathum Wan",
            "district_id": 1007,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 100704,
            "zip_code": 10330,
            "name_th": "ลุมพินี",
            "name_en": "Lumphini",
            "district_id": 1007,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 1008,
        "name_th": "เขตป้อมปราบศัตรูพ่าย",
        "name_en": "Khet Pom Prap Sattru Phai",
        "province_id": 1,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 100801,
            "zip_code": 10100,
            "name_th": "ป้อมปราบ",
            "name_en": "Pom Prap",
            "district_id": 1008,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 100802,
            "zip_code": 10100,
            "name_th": "วัดเทพศิรินทร์",
            "name_en": "Wat Thep Sirin",
            "district_id": 1008,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 100803,
            "zip_code": 10100,
            "name_th": "คลองมหานาค",
            "name_en": "Khlong Maha Nak",
            "district_id": 1008,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 100804,
            "zip_code": 10100,
            "name_th": "บ้านบาตร",
            "name_en": "Ban Bat",
            "district_id": 1008,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 100805,
            "zip_code": 10100,
            "name_th": "วัดโสมนัส",
            "name_en": "Wat Sommanat",
            "district_id": 1008,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 1009,
        "name_th": "เขตพระโขนง",
        "name_en": "Khet Phra Khanong",
        "province_id": 1,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 100905,
            "zip_code": 10260,
            "name_th": "บางจาก",
            "name_en": "Bang Chak",
            "district_id": 1009,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 1010,
        "name_th": "เขตมีนบุรี",
        "name_en": "Khet Min Buri",
        "province_id": 1,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 101001,
            "zip_code": 10510,
            "name_th": "มีนบุรี",
            "name_en": "Min Buri",
            "district_id": 1010,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 101002,
            "zip_code": 10510,
            "name_th": "แสนแสบ",
            "name_en": "Saen Saep",
            "district_id": 1010,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 1011,
        "name_th": "เขตลาดกระบัง",
        "name_en": "Khet Lat Krabang",
        "province_id": 1,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 101101,
            "zip_code": 10520,
            "name_th": "ลาดกระบัง",
            "name_en": "Lat Krabang",
            "district_id": 1011,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 101102,
            "zip_code": 10520,
            "name_th": "คลองสองต้นนุ่น",
            "name_en": "Khlong Song Ton Nun",
            "district_id": 1011,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 101103,
            "zip_code": 10520,
            "name_th": "คลองสามประเวศ",
            "name_en": "Khlong Sam Prawet",
            "district_id": 1011,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 101104,
            "zip_code": 10520,
            "name_th": "ลำปลาทิว",
            "name_en": "Lam Pla Thio",
            "district_id": 1011,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 101105,
            "zip_code": 10520,
            "name_th": "ทับยาว",
            "name_en": "Thap Yao",
            "district_id": 1011,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 101106,
            "zip_code": 10520,
            "name_th": "ขุมทอง",
            "name_en": "Khum Thong",
            "district_id": 1011,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 1012,
        "name_th": "เขตยานนาวา",
        "name_en": "Khet Yan Nawa",
        "province_id": 1,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 101203,
            "zip_code": 10120,
            "name_th": "ช่องนนทรี",
            "name_en": "Chong Nonsi",
            "district_id": 1012,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 101204,
            "zip_code": 10120,
            "name_th": "บางโพงพาง",
            "name_en": "Bang Phongphang",
            "district_id": 1012,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 1013,
        "name_th": "เขตสัมพันธวงศ์",
        "name_en": "Khet Samphanthawong",
        "province_id": 1,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 101301,
            "zip_code": 10100,
            "name_th": "จักรวรรดิ",
            "name_en": "Chakkrawat",
            "district_id": 1013,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 101302,
            "zip_code": 10100,
            "name_th": "สัมพันธวงศ์",
            "name_en": "Samphanthawong",
            "district_id": 1013,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 101303,
            "zip_code": 10100,
            "name_th": "ตลาดน้อย",
            "name_en": "Talat Noi",
            "district_id": 1013,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 1014,
        "name_th": "เขตพญาไท",
        "name_en": "Khet Phaya Thai",
        "province_id": 1,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 101401,
            "zip_code": 10400,
            "name_th": "สามเสนใน",
            "name_en": "Samsen Nai",
            "district_id": 1014,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 1015,
        "name_th": "เขตธนบุรี",
        "name_en": "Khet Thon Buri",
        "province_id": 1,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 101501,
            "zip_code": 10600,
            "name_th": "วัดกัลยาณ์",
            "name_en": "Wat Kanlaya",
            "district_id": 1015,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 101502,
            "zip_code": 10600,
            "name_th": "หิรัญรูจี",
            "name_en": "Hiran Ruchi",
            "district_id": 1015,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 101503,
            "zip_code": 10600,
            "name_th": "บางยี่เรือ",
            "name_en": "Bang Yi Ruea",
            "district_id": 1015,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 101504,
            "zip_code": 10600,
            "name_th": "บุคคโล",
            "name_en": "Bukkhalo",
            "district_id": 1015,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 101505,
            "zip_code": 10600,
            "name_th": "ตลาดพลู",
            "name_en": "Talat Phlu",
            "district_id": 1015,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 101506,
            "zip_code": 10600,
            "name_th": "ดาวคะนอง",
            "name_en": "Dao Khanong",
            "district_id": 1015,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 101507,
            "zip_code": 10600,
            "name_th": "สำเหร่",
            "name_en": "Samre",
            "district_id": 1015,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 1016,
        "name_th": "เขตบางกอกใหญ่",
        "name_en": "Khet Bangkok Yai",
        "province_id": 1,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 101601,
            "zip_code": 10600,
            "name_th": "วัดอรุณ",
            "name_en": "Wat Arun",
            "district_id": 1016,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 101602,
            "zip_code": 10600,
            "name_th": "วัดท่าพระ",
            "name_en": "Wat Tha Phra",
            "district_id": 1016,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 1017,
        "name_th": "เขตห้วยขวาง",
        "name_en": "Khet Huai Khwang",
        "province_id": 1,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 101701,
            "zip_code": 10310,
            "name_th": "ห้วยขวาง",
            "name_en": "Huai Khwang",
            "district_id": 1017,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 101702,
            "zip_code": 10310,
            "name_th": "บางกะปิ",
            "name_en": "Bang Kapi",
            "district_id": 1017,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 101704,
            "zip_code": 10310,
            "name_th": "สามเสนนอก",
            "name_en": "Samsen Nok",
            "district_id": 1017,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 1018,
        "name_th": "เขตคลองสาน",
        "name_en": "Khet Khlong San",
        "province_id": 1,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 101801,
            "zip_code": 10600,
            "name_th": "สมเด็จเจ้าพระยา",
            "name_en": "Somdet Chao Phraya",
            "district_id": 1018,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 101802,
            "zip_code": 10600,
            "name_th": "คลองสาน",
            "name_en": "Khlong San",
            "district_id": 1018,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 101803,
            "zip_code": 10600,
            "name_th": "บางลำภูล่าง",
            "name_en": "Bang Lamphu Lang",
            "district_id": 1018,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 101804,
            "zip_code": 10600,
            "name_th": "คลองต้นไทร",
            "name_en": "Khlong Ton Sai",
            "district_id": 1018,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 1019,
        "name_th": "เขตตลิ่งชัน",
        "name_en": "Khet Taling Chan",
        "province_id": 1,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 101901,
            "zip_code": 10170,
            "name_th": "คลองชักพระ",
            "name_en": "Khlong Chak Phra",
            "district_id": 1019,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 101902,
            "zip_code": 10170,
            "name_th": "ตลิ่งชัน",
            "name_en": "Taling Chan",
            "district_id": 1019,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 101903,
            "zip_code": 10170,
            "name_th": "ฉิมพลี",
            "name_en": "Chimphli",
            "district_id": 1019,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 101904,
            "zip_code": 10170,
            "name_th": "บางพรม",
            "name_en": "Bang Phrom",
            "district_id": 1019,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 101905,
            "zip_code": 10170,
            "name_th": "บางระมาด",
            "name_en": "Bang Ramat",
            "district_id": 1019,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 101907,
            "zip_code": 10170,
            "name_th": "บางเชือกหนัง",
            "name_en": "Bang Chueak Nang",
            "district_id": 1019,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 1020,
        "name_th": "เขตบางกอกน้อย",
        "name_en": "Khet Bangkok Noi",
        "province_id": 1,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 102004,
            "zip_code": 10700,
            "name_th": "ศิริราช",
            "name_en": "Siri Rat",
            "district_id": 1020,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 102005,
            "zip_code": 10700,
            "name_th": "บ้านช่างหล่อ",
            "name_en": "Ban Chang Lo",
            "district_id": 1020,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 102006,
            "zip_code": 10700,
            "name_th": "บางขุนนนท์",
            "name_en": "Bang Khun Non",
            "district_id": 1020,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 102007,
            "zip_code": 10700,
            "name_th": "บางขุนศรี",
            "name_en": "Bang Khun Si",
            "district_id": 1020,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 102009,
            "zip_code": 10700,
            "name_th": "อรุณอมรินทร์",
            "name_en": "Arun Ammarin",
            "district_id": 1020,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 1021,
        "name_th": "เขตบางขุนเทียน",
        "name_en": "Khet Bang Khun Thian",
        "province_id": 1,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 102105,
            "zip_code": 10150,
            "name_th": "ท่าข้าม",
            "name_en": "Tha Kham",
            "district_id": 1021,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 102107,
            "zip_code": 10150,
            "name_th": "แสมดำ",
            "name_en": "Samae Dam",
            "district_id": 1021,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 1022,
        "name_th": "เขตภาษีเจริญ",
        "name_en": "Khet Phasi Charoen",
        "province_id": 1,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 102201,
            "zip_code": 10160,
            "name_th": "บางหว้า",
            "name_en": "Bang Wa",
            "district_id": 1022,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 102202,
            "zip_code": 10160,
            "name_th": "บางด้วน",
            "name_en": "Bang Duan",
            "district_id": 1022,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 102203,
            "zip_code": 10160,
            "name_th": "บางแค",
            "name_en": "Bang Kae",
            "district_id": 1022,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 102204,
            "zip_code": 10160,
            "name_th": "บางแคเหนือ",
            "name_en": "Bang Kae Nua",
            "district_id": 1022,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 102205,
            "zip_code": 10160,
            "name_th": "บางไผ่",
            "name_en": "Bang Phai",
            "district_id": 1022,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 102206,
            "zip_code": 10160,
            "name_th": "บางจาก",
            "name_en": "Bang Chak",
            "district_id": 1022,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 102207,
            "zip_code": 10160,
            "name_th": "บางแวก",
            "name_en": "Bang Waek",
            "district_id": 1022,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 102208,
            "zip_code": 10160,
            "name_th": "คลองขวาง",
            "name_en": "Khlong Khwang",
            "district_id": 1022,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 102209,
            "zip_code": 10160,
            "name_th": "ปากคลองภาษีเจริญ",
            "name_en": "Pak Khlong Phasi Charoen",
            "district_id": 1022,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 102210,
            "zip_code": 10160,
            "name_th": "คูหาสวรรค์",
            "name_en": "Khuha Sawan",
            "district_id": 1022,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 1023,
        "name_th": "เขตหนองแขม",
        "name_en": "Khet Nong Khaem",
        "province_id": 1,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 102302,
            "zip_code": 10160,
            "name_th": "หนองแขม",
            "name_en": "Nong Khaem",
            "district_id": 1023,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 102303,
            "zip_code": 10160,
            "name_th": "หนองค้างพลู",
            "name_en": "Nong Khang Phlu",
            "district_id": 1023,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 1024,
        "name_th": "เขตราษฎร์บูรณะ",
        "name_en": "Khet Rat Burana",
        "province_id": 1,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 102401,
            "zip_code": 10140,
            "name_th": "ราษฎร์บูรณะ",
            "name_en": "Rat Burana",
            "district_id": 1024,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 102402,
            "zip_code": 10140,
            "name_th": "บางปะกอก",
            "name_en": "Bang Pakok",
            "district_id": 1024,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 1025,
        "name_th": "เขตบางพลัด",
        "name_en": "Khet Bang Phlat",
        "province_id": 1,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 102501,
            "zip_code": 10700,
            "name_th": "บางพลัด",
            "name_en": "Bang Phlat",
            "district_id": 1025,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 102502,
            "zip_code": 10700,
            "name_th": "บางอ้อ",
            "name_en": "Bang O",
            "district_id": 1025,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 102503,
            "zip_code": 10700,
            "name_th": "บางบำหรุ",
            "name_en": "Bang Bamru",
            "district_id": 1025,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 102504,
            "zip_code": 10700,
            "name_th": "บางยี่ขัน",
            "name_en": "Bang Yi Khan",
            "district_id": 1025,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 1026,
        "name_th": "เขตดินแดง",
        "name_en": "Khet Din Daeng",
        "province_id": 1,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 102601,
            "zip_code": 10400,
            "name_th": "ดินแดง",
            "name_en": "Din Daeng",
            "district_id": 1026,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 102602,
            "zip_code": 10400,
            "name_th": "รัชดาภิเษก",
            "name_en": "Ratchadaphisek",
            "district_id": 1026,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2026-02-17T00:00:00.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 1027,
        "name_th": "เขตบึงกุ่ม",
        "name_en": "Khet Bueng Kum",
        "province_id": 1,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 102701,
            "zip_code": 10240,
            "name_th": "คลองกุ่ม",
            "name_en": "Khlong Kum",
            "district_id": 1027,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 102702,
            "zip_code": 10240,
            "name_th": "สะพานสูง",
            "name_en": "Saphan Sung",
            "district_id": 1027,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 102703,
            "zip_code": 10240,
            "name_th": "คันนายาว",
            "name_en": "Khan Na Yao",
            "district_id": 1027,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 1028,
        "name_th": "เขตสาทร",
        "name_en": "Khet Sathon",
        "province_id": 1,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 102801,
            "zip_code": 10120,
            "name_th": "ทุ่งวัดดอน",
            "name_en": "Thung Wat Don",
            "district_id": 1028,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 102802,
            "zip_code": 10120,
            "name_th": "ยานนาวา",
            "name_en": "Yan Nawa",
            "district_id": 1028,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 102803,
            "zip_code": 10120,
            "name_th": "ทุ่งมหาเมฆ",
            "name_en": "Thung Maha Mek",
            "district_id": 1028,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 1029,
        "name_th": "เขตบางซื่อ",
        "name_en": "Khet Bang Sue",
        "province_id": 1,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 102901,
            "zip_code": 10800,
            "name_th": "บางซื่อ",
            "name_en": "Bang Sue",
            "district_id": 1029,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 1030,
        "name_th": "เขตจตุจักร",
        "name_en": "Khet Chatuchak",
        "province_id": 1,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 103001,
            "zip_code": 10900,
            "name_th": "ลาดยาว",
            "name_en": "Lat Yao",
            "district_id": 1030,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 103002,
            "zip_code": 10900,
            "name_th": "เสนานิคม",
            "name_en": "Sena Nikhom",
            "district_id": 1030,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 103003,
            "zip_code": 10900,
            "name_th": "จันทรเกษม",
            "name_en": "Chan Kasem",
            "district_id": 1030,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 103004,
            "zip_code": 10900,
            "name_th": "จอมพล",
            "name_en": "Chom Phon",
            "district_id": 1030,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 103005,
            "zip_code": 10900,
            "name_th": "จตุจักร",
            "name_en": "Chatuchak",
            "district_id": 1030,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 1031,
        "name_th": "เขตบางคอแหลม",
        "name_en": "Khet Bang Kho Laem",
        "province_id": 1,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 103101,
            "zip_code": 10120,
            "name_th": "บางคอแหลม",
            "name_en": "Bang Kho Laem",
            "district_id": 1031,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 103102,
            "zip_code": 10120,
            "name_th": "วัดพระยาไกร",
            "name_en": "Wat Phraya Krai",
            "district_id": 1031,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 103103,
            "zip_code": 10120,
            "name_th": "บางโคล่",
            "name_en": "Bang Khlo",
            "district_id": 1031,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 1032,
        "name_th": "เขตประเวศ",
        "name_en": "Khet Prawet",
        "province_id": 1,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 103201,
            "zip_code": 10250,
            "name_th": "ประเวศ",
            "name_en": "Prawet",
            "district_id": 1032,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 103202,
            "zip_code": 10250,
            "name_th": "หนองบอน",
            "name_en": "Nong Bon",
            "district_id": 1032,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 103203,
            "zip_code": 10250,
            "name_th": "ดอกไม้",
            "name_en": "Dokmai",
            "district_id": 1032,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 103204,
            "zip_code": 10250,
            "name_th": "สวนหลวง",
            "name_en": "Suan Luang",
            "district_id": 1032,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 1033,
        "name_th": "เขตคลองเตย",
        "name_en": "Khet Khlong Toei",
        "province_id": 1,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 103301,
            "zip_code": 10110,
            "name_th": "คลองเตย",
            "name_en": "Khlong Toei",
            "district_id": 1033,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 103302,
            "zip_code": 10110,
            "name_th": "คลองตัน",
            "name_en": "Khlong Tan",
            "district_id": 1033,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 103303,
            "zip_code": 10110,
            "name_th": "พระโขนง",
            "name_en": "Phra Khanong",
            "district_id": 1033,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 103304,
            "zip_code": 10110,
            "name_th": "คลองเตยเหนือ",
            "name_en": "Khlong Toei Nua",
            "district_id": 1033,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 103305,
            "zip_code": 10110,
            "name_th": "คลองตันเหนือ",
            "name_en": "Khlong Tan Nua",
            "district_id": 1033,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 103306,
            "zip_code": 10110,
            "name_th": "พระโขนงเหนือ",
            "name_en": "Phra Khanong Nua",
            "district_id": 1033,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 1034,
        "name_th": "เขตสวนหลวง",
        "name_en": "Khet Suan Luang",
        "province_id": 1,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 103401,
            "zip_code": 10250,
            "name_th": "สวนหลวง",
            "name_en": "Suan Luang",
            "district_id": 1034,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 1035,
        "name_th": "เขตจอมทอง",
        "name_en": "Khet Chom Thong",
        "province_id": 1,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 103501,
            "zip_code": 10150,
            "name_th": "บางขุนเทียน",
            "name_en": "Bang Khun Thian",
            "district_id": 1035,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 103502,
            "zip_code": 10150,
            "name_th": "บางค้อ",
            "name_en": "Bang Kho",
            "district_id": 1035,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 103503,
            "zip_code": 10150,
            "name_th": "บางมด",
            "name_en": "Bang Mot",
            "district_id": 1035,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 103504,
            "zip_code": 10150,
            "name_th": "จอมทอง",
            "name_en": "Chom Thong",
            "district_id": 1035,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 1036,
        "name_th": "เขตดอนเมือง",
        "name_en": "Khet Don Mueang",
        "province_id": 1,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 103602,
            "zip_code": 10210,
            "name_th": "สีกัน",
            "name_en": "Si Kan",
            "district_id": 1036,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 1037,
        "name_th": "เขตราชเทวี",
        "name_en": "Khet Ratchathewi",
        "province_id": 1,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 103701,
            "zip_code": 10400,
            "name_th": "ทุ่งพญาไท",
            "name_en": "Thung Phaya Thai",
            "district_id": 1037,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 103702,
            "zip_code": 10400,
            "name_th": "ถนนพญาไท",
            "name_en": "Thanon Phaya Thai",
            "district_id": 1037,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 103703,
            "zip_code": 10400,
            "name_th": "ถนนเพชรบุรี",
            "name_en": "Thanon Phetchaburi",
            "district_id": 1037,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 103704,
            "zip_code": 10400,
            "name_th": "มักกะสัน",
            "name_en": "Makkasan",
            "district_id": 1037,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 1038,
        "name_th": "เขตลาดพร้าว",
        "name_en": "Khet Lat Phrao",
        "province_id": 1,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 103801,
            "zip_code": 10230,
            "name_th": "ลาดพร้าว",
            "name_en": "Lat Phrao",
            "district_id": 1038,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 103802,
            "zip_code": 10230,
            "name_th": "จรเข้บัว",
            "name_en": "Chorakhe Bua",
            "district_id": 1038,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 1039,
        "name_th": "เขตวัฒนา",
        "name_en": "Khet Watthana",
        "province_id": 1,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 103901,
            "zip_code": 10110,
            "name_th": "คลองเตยเหนือ",
            "name_en": "Khlong Toei Nuea",
            "district_id": 1039,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 103902,
            "zip_code": 10110,
            "name_th": "คลองตันเหนือ",
            "name_en": "Khlong Tan Nuea",
            "district_id": 1039,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 103903,
            "zip_code": 10110,
            "name_th": "พระโขนงเหนือ",
            "name_en": "Phra Khanong Nuea",
            "district_id": 1039,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 1040,
        "name_th": "เขตบางแค",
        "name_en": "Khet Bang Khae",
        "province_id": 1,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 104001,
            "zip_code": 10160,
            "name_th": "บางแค",
            "name_en": "Bang Khae",
            "district_id": 1040,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 104002,
            "zip_code": 10160,
            "name_th": "บางแคเหนือ",
            "name_en": "Bang Khae Nuea",
            "district_id": 1040,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 104003,
            "zip_code": 10160,
            "name_th": "บางไผ่",
            "name_en": "Bang Phai",
            "district_id": 1040,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 104004,
            "zip_code": 10160,
            "name_th": "หลักสอง",
            "name_en": "Lak Song",
            "district_id": 1040,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 1041,
        "name_th": "เขตหลักสี่",
        "name_en": "Khet Lak Si",
        "province_id": 1,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 104101,
            "zip_code": 10210,
            "name_th": "ทุ่งสองห้อง",
            "name_en": "Thung Song Hong",
            "district_id": 1041,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 104102,
            "zip_code": 10210,
            "name_th": "ตลาดบางเขน",
            "name_en": "Talat Bang Khen",
            "district_id": 1041,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 1042,
        "name_th": "เขตสายไหม",
        "name_en": "Khet Sai Mai",
        "province_id": 1,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 104201,
            "zip_code": 10220,
            "name_th": "สายไหม",
            "name_en": "Sai Mai",
            "district_id": 1042,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 104202,
            "zip_code": 10220,
            "name_th": "ออเงิน",
            "name_en": "O Ngoen",
            "district_id": 1042,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 104203,
            "zip_code": 10220,
            "name_th": "คลองถนน",
            "name_en": "Khlong Thanon",
            "district_id": 1042,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 1043,
        "name_th": "เขตคันนายาว",
        "name_en": "Khet Khan Na Yao",
        "province_id": 1,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 104301,
            "zip_code": 10230,
            "name_th": "คันนายาว",
            "name_en": "Khan Na Yao",
            "district_id": 1043,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 1044,
        "name_th": "เขตสะพานสูง",
        "name_en": "Khet Saphan Sung",
        "province_id": 1,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 104401,
            "zip_code": 10240,
            "name_th": "สะพานสูง",
            "name_en": "Sapan Sung",
            "district_id": 1044,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 1045,
        "name_th": "เขตวังทองหลาง",
        "name_en": "Khet Wang Thonglang",
        "province_id": 1,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 104501,
            "zip_code": 10310,
            "name_th": "วังทองหลาง",
            "name_en": "Wang Thonglang",
            "district_id": 1045,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 1046,
        "name_th": "เขตคลองสามวา",
        "name_en": "Khet Khlong Sam Wa",
        "province_id": 1,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 104601,
            "zip_code": 10510,
            "name_th": "สามวาตะวันตก",
            "name_en": "Sam Wa Tawantok",
            "district_id": 1046,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 104602,
            "zip_code": 10510,
            "name_th": "สามวาตะวันออก",
            "name_en": "Sam Wa Tawan-ok",
            "district_id": 1046,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 104603,
            "zip_code": 10510,
            "name_th": "บางชัน",
            "name_en": "Bang Chan",
            "district_id": 1046,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 104604,
            "zip_code": 10510,
            "name_th": "ทรายกองดิน",
            "name_en": "Sai Kong Din",
            "district_id": 1046,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 104605,
            "zip_code": 10510,
            "name_th": "ทรายกองดินใต้",
            "name_en": "Sai Kong Din Tai",
            "district_id": 1046,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 1047,
        "name_th": "เขตบางนา",
        "name_en": "Khet Bang Na",
        "province_id": 1,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 104701,
            "zip_code": 10260,
            "name_th": "บางนา",
            "name_en": "Bang Na",
            "district_id": 1047,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 1048,
        "name_th": "เขตทวีวัฒนา",
        "name_en": "Khet Thawi Watthana",
        "province_id": 1,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 104801,
            "zip_code": 10170,
            "name_th": "ทวีวัฒนา",
            "name_en": "Thawi Watthana",
            "district_id": 1048,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 104802,
            "zip_code": 10170,
            "name_th": "ศาลาธรรมสพน์",
            "name_en": "Sala Thammasop",
            "district_id": 1048,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 1049,
        "name_th": "เขตทุ่งครุ",
        "name_en": "Khet Thung Khru",
        "province_id": 1,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 104901,
            "zip_code": 10140,
            "name_th": "บางมด",
            "name_en": "Bang Mot",
            "district_id": 1049,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 104902,
            "zip_code": 10140,
            "name_th": "ทุ่งครุ",
            "name_en": "Thung Khru",
            "district_id": 1049,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 1050,
        "name_th": "เขตบางบอน",
        "name_en": "Khet Bang Bon",
        "province_id": 1,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 105001,
            "zip_code": 10150,
            "name_th": "บางบอน",
            "name_en": "Bang Bon",
            "district_id": 1050,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      }
    ]
  },
  {
    "id": 2,
    "name_th": "สมุทรปราการ",
    "name_en": "Samut Prakan",
    "geography_id": 2,
    "created_at": "2019-08-09T03:33:09.000+07:00",
    "updated_at": "2025-09-20T06:31:26.000+07:00",
    "deleted_at": null,
    "districts": [
      {
        "id": 1101,
        "name_th": "เมืองสมุทรปราการ",
        "name_en": "Mueang Samut Prakan",
        "province_id": 2,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 110101,
            "zip_code": 10270,
            "name_th": "ปากน้ำ",
            "name_en": "Pak Nam",
            "district_id": 1101,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 110102,
            "zip_code": 10270,
            "name_th": "สำโรงเหนือ",
            "name_en": "Samrong Nuea",
            "district_id": 1101,
            "lat": 13.649,
            "long": 100.617,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 110103,
            "zip_code": 10270,
            "name_th": "บางเมือง",
            "name_en": "Bang Mueang",
            "district_id": 1101,
            "lat": 13.601,
            "long": 100.622,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 110104,
            "zip_code": 10280,
            "name_th": "ท้ายบ้าน",
            "name_en": "Thai Ban",
            "district_id": 1101,
            "lat": 13.556,
            "long": 100.599,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 110108,
            "zip_code": 10280,
            "name_th": "บางปูใหม่",
            "name_en": "Bang Pu Mai",
            "district_id": 1101,
            "lat": 13.526,
            "long": 100.67,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 110110,
            "zip_code": 10280,
            "name_th": "แพรกษา",
            "name_en": "Phraek Sa",
            "district_id": 1101,
            "lat": 13.564,
            "long": 100.653,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 110111,
            "zip_code": 10270,
            "name_th": "บางโปรง",
            "name_en": "Bang Prong",
            "district_id": 1101,
            "lat": 13.623,
            "long": 100.565,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 110112,
            "zip_code": 10270,
            "name_th": "บางปู",
            "name_en": "Bang Pu",
            "district_id": 1101,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 110113,
            "zip_code": 10270,
            "name_th": "บางด้วน",
            "name_en": "Bang Duan",
            "district_id": 1101,
            "lat": 13.622,
            "long": 100.581,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 110114,
            "zip_code": 10270,
            "name_th": "บางเมืองใหม่",
            "name_en": "Bang Mueang Mai",
            "district_id": 1101,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 110115,
            "zip_code": 10270,
            "name_th": "เทพารักษ์",
            "name_en": "Thepharak",
            "district_id": 1101,
            "lat": 13.634,
            "long": 100.61,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 110116,
            "zip_code": 10280,
            "name_th": "ท้ายบ้านใหม่",
            "name_en": "Thai Ban Mai",
            "district_id": 1101,
            "lat": 13.572,
            "long": 100.621,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 110117,
            "zip_code": 10280,
            "name_th": "แพรกษาใหม่",
            "name_en": "Phraek Sa Mai",
            "district_id": 1101,
            "lat": 13.559,
            "long": 100.691,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 1102,
        "name_th": "บางบ่อ",
        "name_en": "Bang Bo",
        "province_id": 2,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 110201,
            "zip_code": 10560,
            "name_th": "บางบ่อ",
            "name_en": "Bang Bo",
            "district_id": 1102,
            "lat": 13.611,
            "long": 100.862,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 110202,
            "zip_code": 10560,
            "name_th": "บ้านระกาศ",
            "name_en": "Ban Rakat",
            "district_id": 1102,
            "lat": 13.639,
            "long": 100.904,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 110203,
            "zip_code": 10560,
            "name_th": "บางพลีน้อย",
            "name_en": "Bang Phli Noi",
            "district_id": 1102,
            "lat": 13.574,
            "long": 100.9,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 110204,
            "zip_code": 10560,
            "name_th": "บางเพรียง",
            "name_en": "Bang Phriang",
            "district_id": 1102,
            "lat": 13.545,
            "long": 100.805,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 110205,
            "zip_code": 10550,
            "name_th": "คลองด่าน",
            "name_en": "Khlong Dan",
            "district_id": 1102,
            "lat": 13.511,
            "long": 100.835,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 110206,
            "zip_code": 10560,
            "name_th": "คลองสวน",
            "name_en": "Khlong Suan",
            "district_id": 1102,
            "lat": 13.659,
            "long": 100.925,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 110207,
            "zip_code": 10560,
            "name_th": "เปร็ง",
            "name_en": "Preng",
            "district_id": 1102,
            "lat": 13.672,
            "long": 100.881,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 110208,
            "zip_code": 10560,
            "name_th": "คลองนิยมยาตรา",
            "name_en": "Khlong Niyom Yattra",
            "district_id": 1102,
            "lat": 13.624,
            "long": 100.935,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 1103,
        "name_th": "บางพลี",
        "name_en": "Bang Phli",
        "province_id": 2,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 110301,
            "zip_code": 10540,
            "name_th": "บางพลีใหญ่",
            "name_en": "Bang Phli Yai",
            "district_id": 1103,
            "lat": 13.618,
            "long": 100.694,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 110302,
            "zip_code": 10540,
            "name_th": "บางแก้ว",
            "name_en": "Bang Kaeo",
            "district_id": 1103,
            "lat": 13.642,
            "long": 100.662,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 110303,
            "zip_code": 10540,
            "name_th": "บางปลา",
            "name_en": "Bang Pla",
            "district_id": 1103,
            "lat": 13.561,
            "long": 100.739,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 110304,
            "zip_code": 10540,
            "name_th": "บางโฉลง",
            "name_en": "Bang Chalong",
            "district_id": 1103,
            "lat": 13.623,
            "long": 100.755,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 110308,
            "zip_code": 10540,
            "name_th": "ราชาเทวะ",
            "name_en": "Racha Thewa",
            "district_id": 1103,
            "lat": 13.681,
            "long": 100.733,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 110309,
            "zip_code": 10540,
            "name_th": "หนองปรือ",
            "name_en": "Nong Prue",
            "district_id": 1103,
            "lat": 13.678,
            "long": 100.75,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 1104,
        "name_th": "พระประแดง",
        "name_en": "Phra Pradaeng",
        "province_id": 2,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 110401,
            "zip_code": 10130,
            "name_th": "ตลาด",
            "name_en": "Talat",
            "district_id": 1104,
            "lat": 13.671,
            "long": 100.52,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 110402,
            "zip_code": 10130,
            "name_th": "บางพึ่ง",
            "name_en": "Bang Phueng",
            "district_id": 1104,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 110403,
            "zip_code": 10130,
            "name_th": "บางจาก",
            "name_en": "Bang Chak",
            "district_id": 1104,
            "lat": 13.616,
            "long": 100.536,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 110404,
            "zip_code": 10130,
            "name_th": "บางครุ",
            "name_en": "Bang Khru",
            "district_id": 1104,
            "lat": 13.631,
            "long": 100.526,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 110405,
            "zip_code": 10130,
            "name_th": "บางหญ้าแพรก",
            "name_en": "Bang Ya Phraek",
            "district_id": 1104,
            "lat": 13.645,
            "long": 100.546,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 110406,
            "zip_code": 10130,
            "name_th": "บางหัวเสือ",
            "name_en": "Bang Hua Suea",
            "district_id": 1104,
            "lat": 13.625,
            "long": 100.549,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 110407,
            "zip_code": 10130,
            "name_th": "สำโรงใต้",
            "name_en": "Samrong Tai",
            "district_id": 1104,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 110408,
            "zip_code": 10130,
            "name_th": "บางยอ",
            "name_en": "Bang Yo",
            "district_id": 1104,
            "lat": 13.679,
            "long": 100.558,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 110409,
            "zip_code": 10130,
            "name_th": "บางกะเจ้า",
            "name_en": "Bang Kachao",
            "district_id": 1104,
            "lat": 13.697,
            "long": 100.561,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 110410,
            "zip_code": 10130,
            "name_th": "บางน้ำผึ้ง",
            "name_en": "Bang Namphueng",
            "district_id": 1104,
            "lat": 13.679,
            "long": 100.578,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 110411,
            "zip_code": 10130,
            "name_th": "บางกระสอบ",
            "name_en": "Bang Krasop",
            "district_id": 1104,
            "lat": 13.666,
            "long": 100.566,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 110412,
            "zip_code": 10130,
            "name_th": "บางกอบัว",
            "name_en": "Bang Ko Bua",
            "district_id": 1104,
            "lat": 13.693,
            "long": 100.577,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 110413,
            "zip_code": 10130,
            "name_th": "ทรงคนอง",
            "name_en": "Song Khanong",
            "district_id": 1104,
            "lat": 13.665,
            "long": 100.545,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 110414,
            "zip_code": 10130,
            "name_th": "สำโรง",
            "name_en": "Samrong",
            "district_id": 1104,
            "lat": 13.659,
            "long": 100.584,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 110415,
            "zip_code": 10130,
            "name_th": "สำโรงกลาง",
            "name_en": "Samrong Klang",
            "district_id": 1104,
            "lat": 13.653,
            "long": 100.564,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 1105,
        "name_th": "พระสมุทรเจดีย์",
        "name_en": "Phra Samut Chedi",
        "province_id": 2,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 110501,
            "zip_code": 10290,
            "name_th": "นาเกลือ",
            "name_en": "Na Kluea",
            "district_id": 1105,
            "lat": 13.53,
            "long": 100.494,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 110502,
            "zip_code": 10290,
            "name_th": "บ้านคลองสวน",
            "name_en": "Ban Khlong Suan",
            "district_id": 1105,
            "lat": 13.571,
            "long": 100.476,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 110503,
            "zip_code": 10290,
            "name_th": "แหลมฟ้าผ่า",
            "name_en": "Laem Fa Pha",
            "district_id": 1105,
            "lat": 13.539,
            "long": 100.559,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 110504,
            "zip_code": 10290,
            "name_th": "ปากคลองบางปลากด",
            "name_en": "Pak Klong Bang Pla Kot",
            "district_id": 1105,
            "lat": 13.606,
            "long": 100.567,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 110505,
            "zip_code": 10290,
            "name_th": "ในคลองบางปลากด",
            "name_en": "Nai Khlong Bang Pla Kot",
            "district_id": 1105,
            "lat": 13.588,
            "long": 100.541,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 1106,
        "name_th": "บางเสาธง",
        "name_en": "Bang Sao Thong",
        "province_id": 2,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 110601,
            "zip_code": 10540,
            "name_th": "บางเสาธง",
            "name_en": "Bang Sao Thong",
            "district_id": 1106,
            "lat": 13.6,
            "long": 100.815,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 110602,
            "zip_code": 10540,
            "name_th": "ศีรษะจรเข้น้อย",
            "name_en": "Sisa Chorakhe Noi",
            "district_id": 1106,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 110603,
            "zip_code": 10540,
            "name_th": "ศีรษะจรเข้ใหญ่",
            "name_en": "Sisa Chorakhe Yai",
            "district_id": 1106,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      }
    ]
  },
  {
    "id": 3,
    "name_th": "นนทบุรี",
    "name_en": "Nonthaburi",
    "geography_id": 2,
    "created_at": "2019-08-09T03:33:09.000+07:00",
    "updated_at": "2025-09-20T06:31:26.000+07:00",
    "deleted_at": null,
    "districts": [
      {
        "id": 1201,
        "name_th": "เมืองนนทบุรี",
        "name_en": "Mueang Nonthaburi",
        "province_id": 3,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 120101,
            "zip_code": 11000,
            "name_th": "สวนใหญ่",
            "name_en": "Suan Yai",
            "district_id": 1201,
            "lat": 13.842,
            "long": 100.494,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 120102,
            "zip_code": 11000,
            "name_th": "ตลาดขวัญ",
            "name_en": "Talat Khwan",
            "district_id": 1201,
            "lat": 13.85,
            "long": 100.509,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 120103,
            "zip_code": 11000,
            "name_th": "บางเขน",
            "name_en": "Bang Khen",
            "district_id": 1201,
            "lat": 13.835,
            "long": 100.516,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 120104,
            "zip_code": 11000,
            "name_th": "บางกระสอ",
            "name_en": "Bang Kraso",
            "district_id": 1201,
            "lat": 13.869,
            "long": 100.491,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 120105,
            "zip_code": 11000,
            "name_th": "ท่าทราย",
            "name_en": "Tha Sai",
            "district_id": 1201,
            "lat": 13.884,
            "long": 100.501,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 120106,
            "zip_code": 11000,
            "name_th": "บางไผ่",
            "name_en": "Bang Phai",
            "district_id": 1201,
            "lat": 13.823,
            "long": 100.492,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 120107,
            "zip_code": 11000,
            "name_th": "บางศรีเมือง",
            "name_en": "Bang Si Mueang",
            "district_id": 1201,
            "lat": 13.841,
            "long": 100.475,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 120108,
            "zip_code": 11000,
            "name_th": "บางกร่าง",
            "name_en": "Bang Krang",
            "district_id": 1201,
            "lat": 13.835,
            "long": 100.438,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 120109,
            "zip_code": 11000,
            "name_th": "ไทรม้า",
            "name_en": "Sai Ma",
            "district_id": 1201,
            "lat": 13.87,
            "long": 100.472,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 120110,
            "zip_code": 11000,
            "name_th": "บางรักน้อย",
            "name_en": "Bang Rak Noi",
            "district_id": 1201,
            "lat": 13.859,
            "long": 100.464,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 1202,
        "name_th": "บางกรวย",
        "name_en": "Bang Kruai",
        "province_id": 3,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 120201,
            "zip_code": 11130,
            "name_th": "วัดชลอ",
            "name_en": "Wat Chalo",
            "district_id": 1202,
            "lat": 13.802,
            "long": 100.476,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 120202,
            "zip_code": 11130,
            "name_th": "บางกรวย",
            "name_en": "Bang Kruai",
            "district_id": 1202,
            "lat": 13.809,
            "long": 100.499,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 120203,
            "zip_code": 11130,
            "name_th": "บางสีทอง",
            "name_en": "Bang Si Thong",
            "district_id": 1202,
            "lat": 13.818,
            "long": 100.479,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 120204,
            "zip_code": 11130,
            "name_th": "บางขนุน",
            "name_en": "Bang Khanun",
            "district_id": 1202,
            "lat": 13.811,
            "long": 100.453,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 120205,
            "zip_code": 11130,
            "name_th": "บางขุนกอง",
            "name_en": "Bang Khun Kong",
            "district_id": 1202,
            "lat": 13.821,
            "long": 100.444,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 120206,
            "zip_code": 11130,
            "name_th": "บางคูเวียง",
            "name_en": "Bang Khu Wiang",
            "district_id": 1202,
            "lat": 13.822,
            "long": 100.417,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 120207,
            "zip_code": 11130,
            "name_th": "มหาสวัสดิ์",
            "name_en": "Maha Sawat",
            "district_id": 1202,
            "lat": 13.806,
            "long": 100.434,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 120208,
            "zip_code": 11130,
            "name_th": "ปลายบาง",
            "name_en": "Plai Bang",
            "district_id": 1202,
            "lat": 13.814,
            "long": 100.402,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 120209,
            "zip_code": 11130,
            "name_th": "ศาลากลาง",
            "name_en": "Sala Klang",
            "district_id": 1202,
            "lat": 13.81,
            "long": 100.358,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 1203,
        "name_th": "บางใหญ่",
        "name_en": "Bang Yai",
        "province_id": 3,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 120301,
            "zip_code": 11140,
            "name_th": "บางม่วง",
            "name_en": "Bang Muang",
            "district_id": 1203,
            "lat": 13.838,
            "long": 100.406,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 120302,
            "zip_code": 11140,
            "name_th": "บางแม่นาง",
            "name_en": "Bang Mae Nang",
            "district_id": 1203,
            "lat": 13.868,
            "long": 100.381,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 120303,
            "zip_code": 11140,
            "name_th": "บางเลน",
            "name_en": "Bang Len",
            "district_id": 1203,
            "lat": 13.854,
            "long": 100.434,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 120304,
            "zip_code": 11140,
            "name_th": "เสาธงหิน",
            "name_en": "Sao Thong Hin",
            "district_id": 1203,
            "lat": 13.875,
            "long": 100.404,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 120305,
            "zip_code": 11140,
            "name_th": "บางใหญ่",
            "name_en": "Bang Yai",
            "district_id": 1203,
            "lat": 13.837,
            "long": 100.375,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 120306,
            "zip_code": 11140,
            "name_th": "บ้านใหม่",
            "name_en": "Ban Mai",
            "district_id": 1203,
            "lat": 13.861,
            "long": 100.333,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 1204,
        "name_th": "บางบัวทอง",
        "name_en": "Bang Bua Thong",
        "province_id": 3,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 120401,
            "zip_code": 11110,
            "name_th": "โสนลอย",
            "name_en": "Sano Loi",
            "district_id": 1204,
            "lat": 13.914,
            "long": 100.422,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 120402,
            "zip_code": 11110,
            "name_th": "บางบัวทอง",
            "name_en": "Bang Bua Thong",
            "district_id": 1204,
            "lat": 13.944,
            "long": 100.39,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 120403,
            "zip_code": 11110,
            "name_th": "บางรักใหญ่",
            "name_en": "Bang Rak Yai",
            "district_id": 1204,
            "lat": 13.878,
            "long": 100.438,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 120404,
            "zip_code": 11110,
            "name_th": "บางคูรัด",
            "name_en": "Bang Khu Rat",
            "district_id": 1204,
            "lat": 13.907,
            "long": 100.351,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 120405,
            "zip_code": 11110,
            "name_th": "ละหาร",
            "name_en": "Lahan",
            "district_id": 1204,
            "lat": 13.964,
            "long": 100.401,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 120406,
            "zip_code": 11110,
            "name_th": "ลำโพ",
            "name_en": "Lam Pho",
            "district_id": 1204,
            "lat": 13.97,
            "long": 100.416,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 120407,
            "zip_code": 11110,
            "name_th": "พิมลราช",
            "name_en": "Phimon Rat",
            "district_id": 1204,
            "lat": 13.934,
            "long": 100.366,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 120408,
            "zip_code": 11110,
            "name_th": "บางรักพัฒนา",
            "name_en": "Bang Rak Phatthana",
            "district_id": 1204,
            "lat": 13.894,
            "long": 100.41,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 1205,
        "name_th": "ไทรน้อย",
        "name_en": "Sai Noi",
        "province_id": 3,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 120501,
            "zip_code": 11150,
            "name_th": "ไทรน้อย",
            "name_en": "Sai Noi",
            "district_id": 1205,
            "lat": 13.976,
            "long": 100.344,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 120502,
            "zip_code": 11150,
            "name_th": "ราษฎร์นิยม",
            "name_en": "Rat Niyom",
            "district_id": 1205,
            "lat": 14.088,
            "long": 100.329,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 120503,
            "zip_code": 11150,
            "name_th": "หนองเพรางาย",
            "name_en": "Nong Phrao Ngai",
            "district_id": 1205,
            "lat": 13.906,
            "long": 100.322,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 120504,
            "zip_code": 11150,
            "name_th": "ไทรใหญ่",
            "name_en": "Sai Yai",
            "district_id": 1205,
            "lat": 14.085,
            "long": 100.292,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 120505,
            "zip_code": 11150,
            "name_th": "ขุนศรี",
            "name_en": "Khun Si",
            "district_id": 1205,
            "lat": 14.005,
            "long": 100.287,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 120506,
            "zip_code": 11150,
            "name_th": "คลองขวาง",
            "name_en": "Khlong Khwang",
            "district_id": 1205,
            "lat": 14.004,
            "long": 100.306,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 120507,
            "zip_code": 11150,
            "name_th": "ทวีวัฒนา",
            "name_en": "Thawi Watthana",
            "district_id": 1205,
            "lat": 13.942,
            "long": 100.312,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 1206,
        "name_th": "ปากเกร็ด",
        "name_en": "Pak Kret",
        "province_id": 3,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 120601,
            "zip_code": 11120,
            "name_th": "ปากเกร็ด",
            "name_en": "Pak Kret",
            "district_id": 1206,
            "lat": 13.912,
            "long": 100.506,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 120602,
            "zip_code": 11120,
            "name_th": "บางตลาด",
            "name_en": "Bang Talat",
            "district_id": 1206,
            "lat": 13.896,
            "long": 100.521,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 120603,
            "zip_code": 11120,
            "name_th": "บ้านใหม่",
            "name_en": "Ban Mai",
            "district_id": 1206,
            "lat": 13.93,
            "long": 100.546,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 120604,
            "zip_code": 11120,
            "name_th": "บางพูด",
            "name_en": "Bang Phut",
            "district_id": 1206,
            "lat": 13.927,
            "long": 100.516,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 120605,
            "zip_code": 11120,
            "name_th": "บางตะไนย์",
            "name_en": "Bang Tanai",
            "district_id": 1206,
            "lat": 13.931,
            "long": 100.492,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 120606,
            "zip_code": 11120,
            "name_th": "คลองพระอุดม",
            "name_en": "Khlong Phra Udom",
            "district_id": 1206,
            "lat": 13.93,
            "long": 100.479,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 120607,
            "zip_code": 11120,
            "name_th": "ท่าอิฐ",
            "name_en": "Tha It",
            "district_id": 1206,
            "lat": 13.894,
            "long": 100.48,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 120608,
            "zip_code": 11120,
            "name_th": "เกาะเกร็ด",
            "name_en": "Ko Kret",
            "district_id": 1206,
            "lat": 13.91,
            "long": 100.472,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 120609,
            "zip_code": 11120,
            "name_th": "อ้อมเกร็ด",
            "name_en": "Om Kret",
            "district_id": 1206,
            "lat": 13.909,
            "long": 100.453,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 120610,
            "zip_code": 11120,
            "name_th": "คลองข่อย",
            "name_en": "Khlong Khoi",
            "district_id": 1206,
            "lat": 13.959,
            "long": 100.45,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 120611,
            "zip_code": 11120,
            "name_th": "บางพลับ",
            "name_en": "Bang Phlap",
            "district_id": 1206,
            "lat": 13.929,
            "long": 100.458,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 120612,
            "zip_code": 11120,
            "name_th": "คลองเกลือ",
            "name_en": "Khlong Kluea",
            "district_id": 1206,
            "lat": 13.902,
            "long": 100.55,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      }
    ]
  },
  {
    "id": 4,
    "name_th": "ปทุมธานี",
    "name_en": "Pathum Thani",
    "geography_id": 2,
    "created_at": "2019-08-09T03:33:09.000+07:00",
    "updated_at": "2025-09-20T06:31:26.000+07:00",
    "deleted_at": null,
    "districts": [
      {
        "id": 1301,
        "name_th": "เมืองปทุมธานี",
        "name_en": "Mueang Pathum Thani",
        "province_id": 4,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 130101,
            "zip_code": 12000,
            "name_th": "บางปรอก",
            "name_en": "Bang Parok",
            "district_id": 1301,
            "lat": 14.012,
            "long": 100.528,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 130102,
            "zip_code": 12000,
            "name_th": "บ้านใหม่",
            "name_en": "Ban Mai",
            "district_id": 1301,
            "lat": 13.963,
            "long": 100.553,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 130103,
            "zip_code": 12000,
            "name_th": "บ้านกลาง",
            "name_en": "Ban Klang",
            "district_id": 1301,
            "lat": 14.001,
            "long": 100.558,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 130104,
            "zip_code": 12000,
            "name_th": "บ้านฉาง",
            "name_en": "Ban Chang",
            "district_id": 1301,
            "lat": 14.029,
            "long": 100.507,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 130105,
            "zip_code": 12000,
            "name_th": "บ้านกระแชง",
            "name_en": "Ban Krachaeng",
            "district_id": 1301,
            "lat": 14.031,
            "long": 100.552,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 130106,
            "zip_code": 12000,
            "name_th": "บางขะแยง",
            "name_en": "Bang Khayaeng",
            "district_id": 1301,
            "lat": 13.967,
            "long": 100.523,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 130107,
            "zip_code": 12000,
            "name_th": "บางคูวัด",
            "name_en": "Bang Khu Wat",
            "district_id": 1301,
            "lat": 13.963,
            "long": 100.495,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 130108,
            "zip_code": 12000,
            "name_th": "บางหลวง",
            "name_en": "Bang Luang",
            "district_id": 1301,
            "lat": 14.007,
            "long": 100.509,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 130109,
            "zip_code": 12000,
            "name_th": "บางเดื่อ",
            "name_en": "Bang Duea",
            "district_id": 1301,
            "lat": 13.99,
            "long": 100.487,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 130110,
            "zip_code": 12000,
            "name_th": "บางพูด",
            "name_en": "Bang Phut",
            "district_id": 1301,
            "lat": 14.035,
            "long": 100.572,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 130111,
            "zip_code": 12000,
            "name_th": "บางพูน",
            "name_en": "Bang Phun",
            "district_id": 1301,
            "lat": 13.988,
            "long": 100.594,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 130112,
            "zip_code": 12000,
            "name_th": "บางกะดี",
            "name_en": "Bang Kadi",
            "district_id": 1301,
            "lat": 13.983,
            "long": 100.537,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 130113,
            "zip_code": 12000,
            "name_th": "สวนพริกไทย",
            "name_en": "Suan Phrikthai",
            "district_id": 1301,
            "lat": 14.018,
            "long": 100.568,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 130114,
            "zip_code": 12000,
            "name_th": "หลักหก",
            "name_en": "Lak Hok",
            "district_id": 1301,
            "lat": 13.963,
            "long": 100.59,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 1302,
        "name_th": "คลองหลวง",
        "name_en": "Khlong Luang",
        "province_id": 4,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 130201,
            "zip_code": 12120,
            "name_th": "คลองหนึ่ง",
            "name_en": "Khlong Nueng",
            "district_id": 1302,
            "lat": 14.066,
            "long": 100.607,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 130202,
            "zip_code": 12120,
            "name_th": "คลองสอง",
            "name_en": "Khlong Song",
            "district_id": 1302,
            "lat": 14.079,
            "long": 100.642,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 130203,
            "zip_code": 12120,
            "name_th": "คลองสาม",
            "name_en": "Khlong Sam",
            "district_id": 1302,
            "lat": 14.087,
            "long": 100.664,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 130204,
            "zip_code": 12120,
            "name_th": "คลองสี่",
            "name_en": "Khlong Si",
            "district_id": 1302,
            "lat": 14.097,
            "long": 100.687,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 130205,
            "zip_code": 12120,
            "name_th": "คลองห้า",
            "name_en": "Khlong Ha",
            "district_id": 1302,
            "lat": 14.106,
            "long": 100.71,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 130206,
            "zip_code": 12120,
            "name_th": "คลองหก",
            "name_en": "Khlong Hok",
            "district_id": 1302,
            "lat": 14.117,
            "long": 100.733,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 130207,
            "zip_code": 12120,
            "name_th": "คลองเจ็ด",
            "name_en": "Khlong Chet",
            "district_id": 1302,
            "lat": 14.125,
            "long": 100.75,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 1303,
        "name_th": "ธัญบุรี",
        "name_en": "Thanyaburi",
        "province_id": 4,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 130301,
            "zip_code": 12130,
            "name_th": "ประชาธิปัตย์",
            "name_en": "Prachathipat",
            "district_id": 1303,
            "lat": 13.987,
            "long": 100.632,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 130302,
            "zip_code": 12130,
            "name_th": "บึงยี่โถ",
            "name_en": "Bueng Yitho",
            "district_id": 1303,
            "lat": 13.999,
            "long": 100.687,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 130303,
            "zip_code": 12110,
            "name_th": "รังสิต",
            "name_en": "Rangsit",
            "district_id": 1303,
            "lat": 14.018,
            "long": 100.731,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 130304,
            "zip_code": 12110,
            "name_th": "ลำผักกูด",
            "name_en": "Lam Phak Kut",
            "district_id": 1303,
            "lat": 14.036,
            "long": 100.779,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 130305,
            "zip_code": 12110,
            "name_th": "บึงสนั่น",
            "name_en": "Bueng Sanan",
            "district_id": 1303,
            "lat": 14.052,
            "long": 100.824,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 130306,
            "zip_code": 12110,
            "name_th": "บึงน้ำรักษ์",
            "name_en": "Bueng Nam Rak",
            "district_id": 1303,
            "lat": 14.071,
            "long": 100.88,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 1304,
        "name_th": "หนองเสือ",
        "name_en": "Nong Suea",
        "province_id": 4,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 130401,
            "zip_code": 12170,
            "name_th": "บึงบา",
            "name_en": "Bueng Ba",
            "district_id": 1304,
            "lat": 14.112,
            "long": 100.824,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 130402,
            "zip_code": 12170,
            "name_th": "บึงบอน",
            "name_en": "Bueng Bon",
            "district_id": 1304,
            "lat": 14.087,
            "long": 100.778,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 130403,
            "zip_code": 12170,
            "name_th": "บึงกาสาม",
            "name_en": "Bueng Ka Sam",
            "district_id": 1304,
            "lat": 14.2,
            "long": 100.824,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 130404,
            "zip_code": 12170,
            "name_th": "บึงชำอ้อ",
            "name_en": "Bueng Cham O",
            "district_id": 1304,
            "lat": 14.172,
            "long": 100.778,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 130405,
            "zip_code": 12170,
            "name_th": "หนองสามวัง",
            "name_en": "Nong Sam Wang",
            "district_id": 1304,
            "lat": 14.13,
            "long": 100.881,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 130406,
            "zip_code": 12170,
            "name_th": "ศาลาครุ",
            "name_en": "Sala Khru",
            "district_id": 1304,
            "lat": 14.244,
            "long": 100.928,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 130407,
            "zip_code": 12170,
            "name_th": "นพรัตน์",
            "name_en": "Noppharat",
            "district_id": 1304,
            "lat": 14.223,
            "long": 100.866,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 1305,
        "name_th": "ลาดหลุมแก้ว",
        "name_en": "Lat Lum Kaeo",
        "province_id": 4,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 130501,
            "zip_code": 12140,
            "name_th": "ระแหง",
            "name_en": "Rahaeng",
            "district_id": 1305,
            "lat": 14.059,
            "long": 100.396,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 130502,
            "zip_code": 12140,
            "name_th": "ลาดหลุมแก้ว",
            "name_en": "Lat Lum Kaeo",
            "district_id": 1305,
            "lat": 14.006,
            "long": 100.41,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 130503,
            "zip_code": 12140,
            "name_th": "คูบางหลวง",
            "name_en": "Khu Bang Luang",
            "district_id": 1305,
            "lat": 14.047,
            "long": 100.467,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 130504,
            "zip_code": 12140,
            "name_th": "คูขวาง",
            "name_en": "Khu Khwang",
            "district_id": 1305,
            "lat": 14.068,
            "long": 100.437,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 130505,
            "zip_code": 12140,
            "name_th": "คลองพระอุดม",
            "name_en": "Khlong Phra Udom",
            "district_id": 1305,
            "lat": 13.99,
            "long": 100.449,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 130506,
            "zip_code": 12140,
            "name_th": "บ่อเงิน",
            "name_en": "Bo Ngoen",
            "district_id": 1305,
            "lat": 14.102,
            "long": 100.383,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 130507,
            "zip_code": 12140,
            "name_th": "หน้าไม้",
            "name_en": "Na Mai",
            "district_id": 1305,
            "lat": 14.034,
            "long": 100.359,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 1306,
        "name_th": "ลำลูกกา",
        "name_en": "Lam Luk Ka",
        "province_id": 4,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 130601,
            "zip_code": 12130,
            "name_th": "คูคต",
            "name_en": "Khu Khot",
            "district_id": 1306,
            "lat": 13.955,
            "long": 100.641,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 130602,
            "zip_code": 12150,
            "name_th": "ลาดสวาย",
            "name_en": "Lat Sawai",
            "district_id": 1306,
            "lat": 13.958,
            "long": 100.685,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 130603,
            "zip_code": 12150,
            "name_th": "บึงคำพร้อย",
            "name_en": "Bueng Kham Phroi",
            "district_id": 1306,
            "lat": 13.961,
            "long": 100.731,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 130604,
            "zip_code": 12150,
            "name_th": "ลำลูกกา",
            "name_en": "Lam Luk Ka",
            "district_id": 1306,
            "lat": 13.972,
            "long": 100.774,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 130605,
            "zip_code": 12150,
            "name_th": "บึงทองหลาง",
            "name_en": "Bueng Thonglang",
            "district_id": 1306,
            "lat": 13.984,
            "long": 100.82,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 130606,
            "zip_code": 12150,
            "name_th": "ลำไทร",
            "name_en": "Lam Sai",
            "district_id": 1306,
            "lat": 13.973,
            "long": 100.861,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 130607,
            "zip_code": 12150,
            "name_th": "บึงคอไห",
            "name_en": "Bueng Kho Hai",
            "district_id": 1306,
            "lat": 14.029,
            "long": 100.862,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 130608,
            "zip_code": 12150,
            "name_th": "พืชอุดม",
            "name_en": "Phuet Udom",
            "district_id": 1306,
            "lat": 13.975,
            "long": 100.896,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 1307,
        "name_th": "สามโคก",
        "name_en": "Sam Khok",
        "province_id": 4,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 130701,
            "zip_code": 12160,
            "name_th": "บางเตย",
            "name_en": "Bang Toei",
            "district_id": 1307,
            "lat": 14.062,
            "long": 100.504,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 130702,
            "zip_code": 12160,
            "name_th": "คลองควาย",
            "name_en": "Khlong Khwai",
            "district_id": 1307,
            "lat": 14.097,
            "long": 100.478,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 130703,
            "zip_code": 12160,
            "name_th": "สามโคก",
            "name_en": "Sam Khok",
            "district_id": 1307,
            "lat": 14.052,
            "long": 100.529,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 130704,
            "zip_code": 12160,
            "name_th": "กระแชง",
            "name_en": "Krachaeng",
            "district_id": 1307,
            "lat": 14.043,
            "long": 100.544,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 130705,
            "zip_code": 12160,
            "name_th": "บางโพธิ์เหนือ",
            "name_en": "Bang Pho Nuea",
            "district_id": 1307,
            "lat": 14.042,
            "long": 100.515,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 130706,
            "zip_code": 12160,
            "name_th": "เชียงรากใหญ่",
            "name_en": "Chiang Rak Yai",
            "district_id": 1307,
            "lat": 14.057,
            "long": 100.574,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 130707,
            "zip_code": 12160,
            "name_th": "บ้านปทุม",
            "name_en": "Ban Pathum",
            "district_id": 1307,
            "lat": 14.067,
            "long": 100.546,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 130708,
            "zip_code": 12160,
            "name_th": "บ้านงิ้ว",
            "name_en": "Ban Ngio",
            "district_id": 1307,
            "lat": 14.084,
            "long": 100.539,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 130709,
            "zip_code": 12160,
            "name_th": "เชียงรากน้อย",
            "name_en": "Chiang Rak Noi",
            "district_id": 1307,
            "lat": 14.105,
            "long": 100.567,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 130710,
            "zip_code": 12160,
            "name_th": "บางกระบือ",
            "name_en": "Bang Krabue",
            "district_id": 1307,
            "lat": 14.103,
            "long": 100.538,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 130711,
            "zip_code": 12160,
            "name_th": "ท้ายเกาะ",
            "name_en": "Thai Ko",
            "district_id": 1307,
            "lat": 14.105,
            "long": 100.496,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      }
    ]
  },
  {
    "id": 5,
    "name_th": "พระนครศรีอยุธยา",
    "name_en": "Phra Nakhon Si Ayutthaya",
    "geography_id": 2,
    "created_at": "2019-08-09T03:33:09.000+07:00",
    "updated_at": "2025-09-20T06:31:26.000+07:00",
    "deleted_at": null,
    "districts": [
      {
        "id": 1401,
        "name_th": "พระนครศรีอยุธยา",
        "name_en": "Phra Nakhon Si Ayutthaya",
        "province_id": 5,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 140101,
            "zip_code": 13000,
            "name_th": "ประตูชัย",
            "name_en": "Pratu Chai",
            "district_id": 1401,
            "lat": 14.349,
            "long": 100.551,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 140102,
            "zip_code": 13000,
            "name_th": "กะมัง",
            "name_en": "Kamang",
            "district_id": 1401,
            "lat": 14.341,
            "long": 100.581,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 140103,
            "zip_code": 13000,
            "name_th": "หอรัตนไชย",
            "name_en": "Ho Rattanachai",
            "district_id": 1401,
            "lat": 14.354,
            "long": 100.578,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 140104,
            "zip_code": 13000,
            "name_th": "หัวรอ",
            "name_en": "Hua Ro",
            "district_id": 1401,
            "lat": 14.368,
            "long": 100.578,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 140105,
            "zip_code": 13000,
            "name_th": "ท่าวาสุกรี",
            "name_en": "Tha Wasukri",
            "district_id": 1401,
            "lat": 14.361,
            "long": 100.552,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 140106,
            "zip_code": 13000,
            "name_th": "ไผ่ลิง",
            "name_en": "Phai Ling",
            "district_id": 1401,
            "lat": 14.356,
            "long": 100.589,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 140107,
            "zip_code": 13000,
            "name_th": "ปากกราน",
            "name_en": "Pak Kran",
            "district_id": 1401,
            "lat": 14.31,
            "long": 100.532,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 140108,
            "zip_code": 13000,
            "name_th": "ภูเขาทอง",
            "name_en": "Phukhao Thong",
            "district_id": 1401,
            "lat": 14.365,
            "long": 100.542,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 140109,
            "zip_code": 13000,
            "name_th": "สำเภาล่ม",
            "name_en": "Samphao Lom",
            "district_id": 1401,
            "lat": 14.34,
            "long": 100.57,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 140110,
            "zip_code": 13000,
            "name_th": "สวนพริก",
            "name_en": "Suan Phrik",
            "district_id": 1401,
            "lat": 14.391,
            "long": 100.558,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 140111,
            "zip_code": 13000,
            "name_th": "คลองตะเคียน",
            "name_en": "Khlong Takhian",
            "district_id": 1401,
            "lat": 14.331,
            "long": 100.554,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 140112,
            "zip_code": 13000,
            "name_th": "วัดตูม",
            "name_en": "Wat Tum",
            "district_id": 1401,
            "lat": 14.39,
            "long": 100.539,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 140113,
            "zip_code": 13000,
            "name_th": "หันตรา",
            "name_en": "Hantra",
            "district_id": 1401,
            "lat": 14.371,
            "long": 100.6,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 140114,
            "zip_code": 13000,
            "name_th": "ลุมพลี",
            "name_en": "Lumphli",
            "district_id": 1401,
            "lat": 14.376,
            "long": 100.548,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 140115,
            "zip_code": 13000,
            "name_th": "บ้านใหม่",
            "name_en": "Ban Mai",
            "district_id": 1401,
            "lat": 14.39,
            "long": 100.521,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 140116,
            "zip_code": 13000,
            "name_th": "บ้านเกาะ",
            "name_en": "Ban Ko",
            "district_id": 1401,
            "lat": 14.389,
            "long": 100.582,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 140117,
            "zip_code": 13000,
            "name_th": "คลองสวนพลู",
            "name_en": "Khlong Suan Phlu",
            "district_id": 1401,
            "lat": 14.334,
            "long": 100.595,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 140118,
            "zip_code": 13000,
            "name_th": "คลองสระบัว",
            "name_en": "Khlong Sa Bua",
            "district_id": 1401,
            "lat": 14.371,
            "long": 100.563,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 140119,
            "zip_code": 13000,
            "name_th": "เกาะเรียน",
            "name_en": "Ko Rian",
            "district_id": 1401,
            "lat": 14.318,
            "long": 100.579,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 140120,
            "zip_code": 13000,
            "name_th": "บ้านป้อม",
            "name_en": "Ban Pom",
            "district_id": 1401,
            "lat": 14.347,
            "long": 100.529,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 140121,
            "zip_code": 13000,
            "name_th": "บ้านรุน",
            "name_en": "Ban Run",
            "district_id": 1401,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 1402,
        "name_th": "ท่าเรือ",
        "name_en": "Tha Ruea",
        "province_id": 5,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 140201,
            "zip_code": 13130,
            "name_th": "ท่าเรือ",
            "name_en": "Tha Ruea",
            "district_id": 1402,
            "lat": 14.566,
            "long": 100.719,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 140202,
            "zip_code": 13130,
            "name_th": "จำปา",
            "name_en": "Champa",
            "district_id": 1402,
            "lat": 14.55,
            "long": 100.741,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 140203,
            "zip_code": 13130,
            "name_th": "ท่าหลวง",
            "name_en": "Tha Luang",
            "district_id": 1402,
            "lat": 14.548,
            "long": 100.764,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 140204,
            "zip_code": 13130,
            "name_th": "บ้านร่อม",
            "name_en": "Ban Rom",
            "district_id": 1402,
            "lat": 14.567,
            "long": 100.698,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 140205,
            "zip_code": 13130,
            "name_th": "ศาลาลอย",
            "name_en": "Sala Loi",
            "district_id": 1402,
            "lat": 14.532,
            "long": 100.7,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 140206,
            "zip_code": 13130,
            "name_th": "วังแดง",
            "name_en": "Wang Daeng",
            "district_id": 1402,
            "lat": 14.541,
            "long": 100.67,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 140207,
            "zip_code": 13130,
            "name_th": "โพธิ์เอน",
            "name_en": "Pho En",
            "district_id": 1402,
            "lat": 14.519,
            "long": 100.676,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 140208,
            "zip_code": 13130,
            "name_th": "ปากท่า",
            "name_en": "Pak Tha",
            "district_id": 1402,
            "lat": 14.504,
            "long": 100.692,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 140209,
            "zip_code": 13130,
            "name_th": "หนองขนาก",
            "name_en": "Nong Khanak",
            "district_id": 1402,
            "lat": 14.512,
            "long": 100.732,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 140210,
            "zip_code": 13130,
            "name_th": "ท่าเจ้าสนุก",
            "name_en": "Tha Chao Sanuk",
            "district_id": 1402,
            "lat": 14.543,
            "long": 100.717,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 1403,
        "name_th": "นครหลวง",
        "name_en": "Nakhon Luang",
        "province_id": 5,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 140301,
            "zip_code": 13260,
            "name_th": "นครหลวง",
            "name_en": "Nakhon Luang",
            "district_id": 1403,
            "lat": 14.469,
            "long": 100.622,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 140302,
            "zip_code": 13260,
            "name_th": "ท่าช้าง",
            "name_en": "Tha Chang",
            "district_id": 1403,
            "lat": 14.511,
            "long": 100.652,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 140303,
            "zip_code": 13260,
            "name_th": "บ่อโพง",
            "name_en": "Bo Phong",
            "district_id": 1403,
            "lat": 14.406,
            "long": 100.603,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 140304,
            "zip_code": 13260,
            "name_th": "บ้านชุ้ง",
            "name_en": "Ban Chung",
            "district_id": 1403,
            "lat": 14.458,
            "long": 100.655,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 140305,
            "zip_code": 13260,
            "name_th": "ปากจั่น",
            "name_en": "Pak Chan",
            "district_id": 1403,
            "lat": 14.44,
            "long": 100.62,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 140306,
            "zip_code": 13260,
            "name_th": "บางระกำ",
            "name_en": "Bang Rakam",
            "district_id": 1403,
            "lat": 14.466,
            "long": 100.589,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 140307,
            "zip_code": 13260,
            "name_th": "บางพระครู",
            "name_en": "Bang Phra Khru",
            "district_id": 1403,
            "lat": 14.483,
            "long": 100.613,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 140308,
            "zip_code": 13260,
            "name_th": "แม่ลา",
            "name_en": "Mae La",
            "district_id": 1403,
            "lat": 14.503,
            "long": 100.619,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 140309,
            "zip_code": 13260,
            "name_th": "หนองปลิง",
            "name_en": "Nong Pling",
            "district_id": 1403,
            "lat": 14.423,
            "long": 100.64,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 140310,
            "zip_code": 13260,
            "name_th": "คลองสะแก",
            "name_en": "Khlong Sakae",
            "district_id": 1403,
            "lat": 14.424,
            "long": 100.604,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 140311,
            "zip_code": 13260,
            "name_th": "สามไถ",
            "name_en": "Sam Thai",
            "district_id": 1403,
            "lat": 14.489,
            "long": 100.675,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 140312,
            "zip_code": 13260,
            "name_th": "พระนอน",
            "name_en": "Phra Non",
            "district_id": 1403,
            "lat": 14.485,
            "long": 100.65,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 1404,
        "name_th": "บางไทร",
        "name_en": "Bang Sai",
        "province_id": 5,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 140401,
            "zip_code": 13190,
            "name_th": "บางไทร",
            "name_en": "Bang Sai",
            "district_id": 1404,
            "lat": 14.191,
            "long": 100.48,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 140402,
            "zip_code": 13190,
            "name_th": "บางพลี",
            "name_en": "Bang Phli",
            "district_id": 1404,
            "lat": 14.212,
            "long": 100.465,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 140403,
            "zip_code": 13190,
            "name_th": "สนามชัย",
            "name_en": "Sanam Chai",
            "district_id": 1404,
            "lat": 14.213,
            "long": 100.522,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 140404,
            "zip_code": 13190,
            "name_th": "บ้านแป้ง",
            "name_en": "Ban Paeng",
            "district_id": 1404,
            "lat": 14.232,
            "long": 100.507,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 140405,
            "zip_code": 13190,
            "name_th": "หน้าไม้",
            "name_en": "Na Mai",
            "district_id": 1404,
            "lat": 14.315,
            "long": 100.462,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 140406,
            "zip_code": 13190,
            "name_th": "บางยี่โท",
            "name_en": "Bang Yi Tho",
            "district_id": 1404,
            "lat": 14.299,
            "long": 100.445,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 140407,
            "zip_code": 13190,
            "name_th": "แคออก",
            "name_en": "Khae Ok",
            "district_id": 1404,
            "lat": 14.305,
            "long": 100.472,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 140408,
            "zip_code": 13190,
            "name_th": "แคตก",
            "name_en": "Khae Tok",
            "district_id": 1404,
            "lat": 14.287,
            "long": 100.48,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 140409,
            "zip_code": 13190,
            "name_th": "ช่างเหล็ก",
            "name_en": "Chang Lek",
            "district_id": 1404,
            "lat": 14.278,
            "long": 100.453,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 140410,
            "zip_code": 13190,
            "name_th": "กระแชง",
            "name_en": "Krachaeng",
            "district_id": 1404,
            "lat": 14.279,
            "long": 100.505,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 140411,
            "zip_code": 13190,
            "name_th": "บ้านกลึง",
            "name_en": "Ban Klueng",
            "district_id": 1404,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 140412,
            "zip_code": 13190,
            "name_th": "ช้างน้อย",
            "name_en": "Chang Noi",
            "district_id": 1404,
            "lat": 14.252,
            "long": 100.505,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 140413,
            "zip_code": 13190,
            "name_th": "ห่อหมก",
            "name_en": "Homok",
            "district_id": 1404,
            "lat": 14.259,
            "long": 100.474,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 140414,
            "zip_code": 13190,
            "name_th": "ไผ่พระ",
            "name_en": "Phai Phra",
            "district_id": 1404,
            "lat": 14.222,
            "long": 100.432,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 140415,
            "zip_code": 13190,
            "name_th": "กกแก้วบูรพา",
            "name_en": "Kok Kaeo Burapha",
            "district_id": 1404,
            "lat": 14.188,
            "long": 100.435,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 140416,
            "zip_code": 13190,
            "name_th": "ไม้ตรา",
            "name_en": "Mai Tra",
            "district_id": 1404,
            "lat": 14.164,
            "long": 100.473,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 140417,
            "zip_code": 13190,
            "name_th": "บ้านม้า",
            "name_en": "Ban Ma",
            "district_id": 1404,
            "lat": 14.141,
            "long": 100.49,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 140418,
            "zip_code": 13190,
            "name_th": "บ้านเกาะ",
            "name_en": "Ban Ko",
            "district_id": 1404,
            "lat": 14.236,
            "long": 100.46,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 140419,
            "zip_code": 13290,
            "name_th": "ราชคราม",
            "name_en": "Ratchakhram",
            "district_id": 1404,
            "lat": 14.186,
            "long": 100.519,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 140420,
            "zip_code": 13290,
            "name_th": "ช้างใหญ่",
            "name_en": "Chang Yai",
            "district_id": 1404,
            "lat": 14.161,
            "long": 100.522,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 140421,
            "zip_code": 13290,
            "name_th": "โพแตง",
            "name_en": "Pho Taeng",
            "district_id": 1404,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 140422,
            "zip_code": 13290,
            "name_th": "เชียงรากน้อย",
            "name_en": "Chiang Rak Noi",
            "district_id": 1404,
            "lat": 14.134,
            "long": 100.561,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 140423,
            "zip_code": 13190,
            "name_th": "โคกช้าง",
            "name_en": "Khok Chang",
            "district_id": 1404,
            "lat": 14.123,
            "long": 100.492,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 1405,
        "name_th": "บางบาล",
        "name_en": "Bang Ban",
        "province_id": 5,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 140501,
            "zip_code": 13250,
            "name_th": "บางบาล",
            "name_en": "Bang Ban",
            "district_id": 1405,
            "lat": 14.41,
            "long": 100.464,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 140502,
            "zip_code": 13250,
            "name_th": "วัดยม",
            "name_en": "Wat Yom",
            "district_id": 1405,
            "lat": 14.39,
            "long": 100.497,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 140503,
            "zip_code": 13250,
            "name_th": "ไทรน้อย",
            "name_en": "Sai Noi",
            "district_id": 1405,
            "lat": 14.407,
            "long": 100.486,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 140504,
            "zip_code": 13250,
            "name_th": "สะพานไทย",
            "name_en": "Saphan Thai",
            "district_id": 1405,
            "lat": 14.363,
            "long": 100.486,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 140505,
            "zip_code": 13250,
            "name_th": "มหาพราหมณ์",
            "name_en": "Maha Phram",
            "district_id": 1405,
            "lat": 14.364,
            "long": 100.505,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 140506,
            "zip_code": 13250,
            "name_th": "กบเจา",
            "name_en": "Kop Chao",
            "district_id": 1405,
            "lat": 14.347,
            "long": 100.485,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 140507,
            "zip_code": 13250,
            "name_th": "บ้านคลัง",
            "name_en": "Ban Khlang",
            "district_id": 1405,
            "lat": 14.347,
            "long": 100.457,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 140508,
            "zip_code": 13250,
            "name_th": "พระขาว",
            "name_en": "Phra Khao",
            "district_id": 1405,
            "lat": 14.328,
            "long": 100.482,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 140509,
            "zip_code": 13250,
            "name_th": "น้ำเต้า",
            "name_en": "Namtao",
            "district_id": 1405,
            "lat": 14.339,
            "long": 100.438,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 140510,
            "zip_code": 13250,
            "name_th": "ทางช้าง",
            "name_en": "Thang Chang",
            "district_id": 1405,
            "lat": 14.375,
            "long": 100.432,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 140511,
            "zip_code": 13250,
            "name_th": "วัดตะกู",
            "name_en": "Wat Taku",
            "district_id": 1405,
            "lat": 14.388,
            "long": 100.424,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 140512,
            "zip_code": 13250,
            "name_th": "บางหลวง",
            "name_en": "Bang Luang",
            "district_id": 1405,
            "lat": 14.403,
            "long": 100.433,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 140513,
            "zip_code": 13250,
            "name_th": "บางหลวงโดด",
            "name_en": "Bang Luang Dot",
            "district_id": 1405,
            "lat": 14.419,
            "long": 100.43,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 140514,
            "zip_code": 13250,
            "name_th": "บางหัก",
            "name_en": "Bang Hak",
            "district_id": 1405,
            "lat": 14.436,
            "long": 100.439,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 140515,
            "zip_code": 13250,
            "name_th": "บางชะนี",
            "name_en": "Bang Chani",
            "district_id": 1405,
            "lat": 14.429,
            "long": 100.461,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 140516,
            "zip_code": 13250,
            "name_th": "บ้านกุ่ม",
            "name_en": "Ban Kum",
            "district_id": 1405,
            "lat": 14.436,
            "long": 100.492,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 1406,
        "name_th": "บางปะอิน",
        "name_en": "Bang Pa-in",
        "province_id": 5,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 140601,
            "zip_code": 13160,
            "name_th": "บ้านเลน",
            "name_en": "Ban Len",
            "district_id": 1406,
            "lat": 14.241,
            "long": 100.598,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 140602,
            "zip_code": 13180,
            "name_th": "เชียงรากน้อย",
            "name_en": "Chiang Rak Noi",
            "district_id": 1406,
            "lat": 14.16,
            "long": 100.594,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 140603,
            "zip_code": 13160,
            "name_th": "บ้านโพ",
            "name_en": "Ban Pho",
            "district_id": 1406,
            "lat": 14.272,
            "long": 100.588,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 140604,
            "zip_code": 13160,
            "name_th": "บ้านกรด",
            "name_en": "Ban Krot",
            "district_id": 1406,
            "lat": 14.307,
            "long": 100.604,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 140605,
            "zip_code": 13160,
            "name_th": "บางกระสั้น",
            "name_en": "Bang Krasan",
            "district_id": 1406,
            "lat": 14.189,
            "long": 100.565,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 140606,
            "zip_code": 13160,
            "name_th": "คลองจิก",
            "name_en": "Khlong Chik",
            "district_id": 1406,
            "lat": 14.214,
            "long": 100.597,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 140607,
            "zip_code": 13160,
            "name_th": "บ้านหว้า",
            "name_en": "Ban Wa",
            "district_id": 1406,
            "lat": 14.258,
            "long": 100.616,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 140608,
            "zip_code": 13160,
            "name_th": "วัดยม",
            "name_en": "Wat Yom",
            "district_id": 1406,
            "lat": 14.26,
            "long": 100.568,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 140609,
            "zip_code": 13160,
            "name_th": "บางประแดง",
            "name_en": "Bang Pradaeng",
            "district_id": 1406,
            "lat": 14.288,
            "long": 100.544,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 140610,
            "zip_code": 13160,
            "name_th": "สามเรือน",
            "name_en": "Sam Ruean",
            "district_id": 1406,
            "lat": 14.292,
            "long": 100.647,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 140611,
            "zip_code": 13160,
            "name_th": "เกาะเกิด",
            "name_en": "Ko Koet",
            "district_id": 1406,
            "lat": 14.206,
            "long": 100.539,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 140612,
            "zip_code": 13160,
            "name_th": "บ้านพลับ",
            "name_en": "Ban Phlap",
            "district_id": 1406,
            "lat": 14.223,
            "long": 100.552,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 140613,
            "zip_code": 13160,
            "name_th": "บ้านแป้ง",
            "name_en": "Ban Paeng",
            "district_id": 1406,
            "lat": 14.239,
            "long": 100.557,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 140614,
            "zip_code": 13160,
            "name_th": "คุ้งลาน",
            "name_en": "Khung Lan",
            "district_id": 1406,
            "lat": 14.295,
            "long": 100.621,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 140615,
            "zip_code": 13160,
            "name_th": "ตลิ่งชัน",
            "name_en": "Taling Chan",
            "district_id": 1406,
            "lat": 14.25,
            "long": 100.642,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 140616,
            "zip_code": 13170,
            "name_th": "บ้านสร้าง",
            "name_en": "Ban Sang",
            "district_id": 1406,
            "lat": 14.289,
            "long": 100.668,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 140617,
            "zip_code": 13160,
            "name_th": "ตลาดเกรียบ",
            "name_en": "Talat Kriap",
            "district_id": 1406,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 140618,
            "zip_code": 13160,
            "name_th": "ขนอนหลวง",
            "name_en": "Khanon Luang",
            "district_id": 1406,
            "lat": 14.266,
            "long": 100.542,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 1407,
        "name_th": "บางปะหัน",
        "name_en": "Bang Pahan",
        "province_id": 5,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 140701,
            "zip_code": 13220,
            "name_th": "บางปะหัน",
            "name_en": "Bang Pahan",
            "district_id": 1407,
            "lat": 14.458,
            "long": 100.558,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 140702,
            "zip_code": 13220,
            "name_th": "ขยาย",
            "name_en": "Khayai",
            "district_id": 1407,
            "lat": 14.414,
            "long": 100.564,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 140703,
            "zip_code": 13220,
            "name_th": "บางเดื่อ",
            "name_en": "Bang Duea",
            "district_id": 1407,
            "lat": 14.436,
            "long": 100.576,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 140704,
            "zip_code": 13220,
            "name_th": "เสาธง",
            "name_en": "Sao Thong",
            "district_id": 1407,
            "lat": 14.496,
            "long": 100.549,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 140705,
            "zip_code": 13220,
            "name_th": "ทางกลาง",
            "name_en": "Thang Klang",
            "district_id": 1407,
            "lat": 14.513,
            "long": 100.544,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 140706,
            "zip_code": 13220,
            "name_th": "บางเพลิง",
            "name_en": "Bang Phloeng",
            "district_id": 1407,
            "lat": 14.5,
            "long": 100.577,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 140707,
            "zip_code": 13220,
            "name_th": "หันสัง",
            "name_en": "Hansang",
            "district_id": 1407,
            "lat": 14.512,
            "long": 100.517,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 140708,
            "zip_code": 13220,
            "name_th": "บางนางร้า",
            "name_en": "Bang Nang Ra",
            "district_id": 1407,
            "lat": 14.474,
            "long": 100.531,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 140709,
            "zip_code": 13220,
            "name_th": "ตานิม",
            "name_en": "Ta Nim",
            "district_id": 1407,
            "lat": 14.491,
            "long": 100.532,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 140710,
            "zip_code": 13220,
            "name_th": "ทับน้ำ",
            "name_en": "Thap Nam",
            "district_id": 1407,
            "lat": 14.464,
            "long": 100.508,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 140711,
            "zip_code": 13220,
            "name_th": "บ้านม้า",
            "name_en": "Ban Ma",
            "district_id": 1407,
            "lat": 14.492,
            "long": 100.51,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 140712,
            "zip_code": 13220,
            "name_th": "ขวัญเมือง",
            "name_en": "Khwan Mueang",
            "district_id": 1407,
            "lat": 14.444,
            "long": 100.536,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 140713,
            "zip_code": 13220,
            "name_th": "บ้านลี่",
            "name_en": "Ban Li",
            "district_id": 1407,
            "lat": 14.449,
            "long": 100.521,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 140714,
            "zip_code": 13220,
            "name_th": "โพธิ์สามต้น",
            "name_en": "Pho Sam Ton",
            "district_id": 1407,
            "lat": 14.421,
            "long": 100.547,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 140715,
            "zip_code": 13220,
            "name_th": "พุทเลา",
            "name_en": "Phutlao",
            "district_id": 1407,
            "lat": 14.419,
            "long": 100.525,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 140716,
            "zip_code": 13220,
            "name_th": "ตาลเอน",
            "name_en": "Tan En",
            "district_id": 1407,
            "lat": 14.524,
            "long": 100.563,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 140717,
            "zip_code": 13220,
            "name_th": "บ้านขล้อ",
            "name_en": "Ban Khlo",
            "district_id": 1407,
            "lat": 14.532,
            "long": 100.586,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 1408,
        "name_th": "ผักไห่",
        "name_en": "Phak Hai",
        "province_id": 5,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 140801,
            "zip_code": 13120,
            "name_th": "ผักไห่",
            "name_en": "Phak Hai",
            "district_id": 1408,
            "lat": 14.462,
            "long": 100.379,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 140802,
            "zip_code": 13120,
            "name_th": "อมฤต",
            "name_en": "Ammarit",
            "district_id": 1408,
            "lat": 14.472,
            "long": 100.361,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 140803,
            "zip_code": 13120,
            "name_th": "บ้านแค",
            "name_en": "Ban Khae",
            "district_id": 1408,
            "lat": 14.495,
            "long": 100.405,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 140804,
            "zip_code": 13120,
            "name_th": "ลาดน้ำเค็ม",
            "name_en": "Lat Nam Khem",
            "district_id": 1408,
            "lat": 14.482,
            "long": 100.393,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 140805,
            "zip_code": 13120,
            "name_th": "ตาลาน",
            "name_en": "Ta Lan",
            "district_id": 1408,
            "lat": 14.446,
            "long": 100.387,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 140806,
            "zip_code": 13120,
            "name_th": "ท่าดินแดง",
            "name_en": "Tha Din Daeng",
            "district_id": 1408,
            "lat": 14.416,
            "long": 100.388,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 140807,
            "zip_code": 13280,
            "name_th": "ดอนลาน",
            "name_en": "Don Lan",
            "district_id": 1408,
            "lat": 14.433,
            "long": 100.286,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 140808,
            "zip_code": 13280,
            "name_th": "นาคู",
            "name_en": "Na Khu",
            "district_id": 1408,
            "lat": 14.468,
            "long": 100.272,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 140809,
            "zip_code": 13120,
            "name_th": "กุฎี",
            "name_en": "Kudi",
            "district_id": 1408,
            "lat": 14.439,
            "long": 100.407,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 140810,
            "zip_code": 13280,
            "name_th": "ลำตะเคียน",
            "name_en": "Lam Takhian",
            "district_id": 1408,
            "lat": 14.419,
            "long": 100.318,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 140811,
            "zip_code": 13120,
            "name_th": "โคกช้าง",
            "name_en": "Khok Chang",
            "district_id": 1408,
            "lat": 14.5,
            "long": 100.388,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 140812,
            "zip_code": 13280,
            "name_th": "จักราช",
            "name_en": "Chakkarat",
            "district_id": 1408,
            "lat": 14.447,
            "long": 100.34,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 140813,
            "zip_code": 13280,
            "name_th": "หนองน้ำใหญ่",
            "name_en": "Nong Nam Yai",
            "district_id": 1408,
            "lat": 14.474,
            "long": 100.311,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 140814,
            "zip_code": 13120,
            "name_th": "ลาดชิด",
            "name_en": "Lat Chit",
            "district_id": 1408,
            "lat": 14.422,
            "long": 100.358,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 140815,
            "zip_code": 13120,
            "name_th": "หน้าโคก",
            "name_en": "Na Khok",
            "district_id": 1408,
            "lat": 14.49,
            "long": 100.351,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 140816,
            "zip_code": 13120,
            "name_th": "บ้านใหญ่",
            "name_en": "Ban Yai",
            "district_id": 1408,
            "lat": 14.435,
            "long": 100.384,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 1409,
        "name_th": "ภาชี",
        "name_en": "Phachi",
        "province_id": 5,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 140901,
            "zip_code": 13140,
            "name_th": "ภาชี",
            "name_en": "Phachi",
            "district_id": 1409,
            "lat": 14.442,
            "long": 100.725,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 140902,
            "zip_code": 13140,
            "name_th": "โคกม่วง",
            "name_en": "Khok Muang",
            "district_id": 1409,
            "lat": 14.428,
            "long": 100.75,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 140903,
            "zip_code": 13140,
            "name_th": "ระโสม",
            "name_en": "Rasom",
            "district_id": 1409,
            "lat": 14.39,
            "long": 100.77,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 140904,
            "zip_code": 13140,
            "name_th": "หนองน้ำใส",
            "name_en": "Nong Nam Sai",
            "district_id": 1409,
            "lat": 14.457,
            "long": 100.751,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 140905,
            "zip_code": 13140,
            "name_th": "ดอนหญ้านาง",
            "name_en": "Don Ya Nang",
            "district_id": 1409,
            "lat": 14.478,
            "long": 100.739,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 140906,
            "zip_code": 13140,
            "name_th": "ไผ่ล้อม",
            "name_en": "Phai Lom",
            "district_id": 1409,
            "lat": 14.474,
            "long": 100.693,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 140907,
            "zip_code": 13140,
            "name_th": "กระจิว",
            "name_en": "Krachio",
            "district_id": 1409,
            "lat": 14.42,
            "long": 100.69,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 140908,
            "zip_code": 13140,
            "name_th": "พระแก้ว",
            "name_en": "Phra Kaeo",
            "district_id": 1409,
            "lat": 14.44,
            "long": 100.675,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 1410,
        "name_th": "ลาดบัวหลวง",
        "name_en": "Lat Bua Luang",
        "province_id": 5,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 141001,
            "zip_code": 13230,
            "name_th": "ลาดบัวหลวง",
            "name_en": "Lat Bua Luang",
            "district_id": 1410,
            "lat": 14.193,
            "long": 100.319,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 141002,
            "zip_code": 13230,
            "name_th": "หลักชัย",
            "name_en": "Lak Chai",
            "district_id": 1410,
            "lat": 14.195,
            "long": 100.277,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 141003,
            "zip_code": 13230,
            "name_th": "สามเมือง",
            "name_en": "Sam Mueang",
            "district_id": 1410,
            "lat": 14.153,
            "long": 100.297,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 141004,
            "zip_code": 13230,
            "name_th": "พระยาบันลือ",
            "name_en": "Phraya Banlue",
            "district_id": 1410,
            "lat": 14.161,
            "long": 100.395,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 141005,
            "zip_code": 13230,
            "name_th": "สิงหนาท",
            "name_en": "Singhanat",
            "district_id": 1410,
            "lat": 14.132,
            "long": 100.423,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 141006,
            "zip_code": 13230,
            "name_th": "คู้สลอด",
            "name_en": "Khu Salot",
            "district_id": 1410,
            "lat": 14.196,
            "long": 100.369,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 141007,
            "zip_code": 13230,
            "name_th": "คลองพระยาบันลือ",
            "name_en": "Khlong Phraya Banlue",
            "district_id": 1410,
            "lat": 14.134,
            "long": 100.368,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 1411,
        "name_th": "วังน้อย",
        "name_en": "Wang Noi",
        "province_id": 5,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 141101,
            "zip_code": 13170,
            "name_th": "ลำตาเสา",
            "name_en": "Lam Ta Sao",
            "district_id": 1411,
            "lat": 14.275,
            "long": 100.708,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 141102,
            "zip_code": 13170,
            "name_th": "บ่อตาโล่",
            "name_en": "Bo Ta Lo",
            "district_id": 1411,
            "lat": 14.241,
            "long": 100.674,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 141103,
            "zip_code": 13170,
            "name_th": "วังน้อย",
            "name_en": "Wang Noi",
            "district_id": 1411,
            "lat": 14.201,
            "long": 100.699,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 141104,
            "zip_code": 13170,
            "name_th": "ลำไทร",
            "name_en": "Lam Sai",
            "district_id": 1411,
            "lat": 14.2,
            "long": 100.641,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 141105,
            "zip_code": 13170,
            "name_th": "สนับทึบ",
            "name_en": "Sanap Thuep",
            "district_id": 1411,
            "lat": 14.298,
            "long": 100.813,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 141106,
            "zip_code": 13170,
            "name_th": "พยอม",
            "name_en": "Phayom",
            "district_id": 1411,
            "lat": 14.166,
            "long": 100.632,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 141107,
            "zip_code": 13170,
            "name_th": "หันตะเภา",
            "name_en": "Han Taphao",
            "district_id": 1411,
            "lat": 14.304,
            "long": 100.78,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 141108,
            "zip_code": 13170,
            "name_th": "วังจุฬา",
            "name_en": "Wang Chula",
            "district_id": 1411,
            "lat": 14.249,
            "long": 100.8,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 141109,
            "zip_code": 13170,
            "name_th": "ข้าวงาม",
            "name_en": "Khao Ngam",
            "district_id": 1411,
            "lat": 14.229,
            "long": 100.758,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 141110,
            "zip_code": 13170,
            "name_th": "ชะแมบ",
            "name_en": "Chamaep",
            "district_id": 1411,
            "lat": 14.257,
            "long": 100.748,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 1412,
        "name_th": "เสนา",
        "name_en": "Sena",
        "province_id": 5,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 141201,
            "zip_code": 13110,
            "name_th": "เสนา",
            "name_en": "Sena",
            "district_id": 1412,
            "lat": 14.328,
            "long": 100.404,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 141202,
            "zip_code": 13110,
            "name_th": "บ้านแพน",
            "name_en": "Ban Phaen",
            "district_id": 1412,
            "lat": 14.342,
            "long": 100.417,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 141203,
            "zip_code": 13110,
            "name_th": "เจ้าเจ็ด",
            "name_en": "Chao Chet",
            "district_id": 1412,
            "lat": 14.303,
            "long": 100.378,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 141204,
            "zip_code": 13110,
            "name_th": "สามกอ",
            "name_en": "Sam Ko",
            "district_id": 1412,
            "lat": 14.306,
            "long": 100.399,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 141205,
            "zip_code": 13110,
            "name_th": "บางนมโค",
            "name_en": "Bang Nom Kho",
            "district_id": 1412,
            "lat": 14.292,
            "long": 100.424,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 141206,
            "zip_code": 13110,
            "name_th": "หัวเวียง",
            "name_en": "Hua Wiang",
            "district_id": 1412,
            "lat": 14.376,
            "long": 100.402,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 141207,
            "zip_code": 13110,
            "name_th": "มารวิชัย",
            "name_en": "Manrawichai",
            "district_id": 1412,
            "lat": 14.24,
            "long": 100.371,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 141208,
            "zip_code": 13110,
            "name_th": "บ้านโพธิ์",
            "name_en": "Ban Pho",
            "district_id": 1412,
            "lat": 14.351,
            "long": 100.394,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 141209,
            "zip_code": 13110,
            "name_th": "รางจรเข้",
            "name_en": "Rang Chorakhe",
            "district_id": 1412,
            "lat": 14.351,
            "long": 100.366,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 141210,
            "zip_code": 13110,
            "name_th": "บ้านกระทุ่ม",
            "name_en": "Ban Krathum",
            "district_id": 1412,
            "lat": 14.39,
            "long": 100.383,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 141211,
            "zip_code": 13110,
            "name_th": "บ้านแถว",
            "name_en": "Ban Thaeo",
            "district_id": 1412,
            "lat": 14.301,
            "long": 100.348,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 141212,
            "zip_code": 13110,
            "name_th": "ชายนา",
            "name_en": "Chai Na",
            "district_id": 1412,
            "lat": 14.258,
            "long": 100.348,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 141213,
            "zip_code": 13110,
            "name_th": "สามตุ่ม",
            "name_en": "Sam Tum",
            "district_id": 1412,
            "lat": 14.24,
            "long": 100.406,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 141214,
            "zip_code": 13110,
            "name_th": "ลาดงา",
            "name_en": "Lat Nga",
            "district_id": 1412,
            "lat": 14.372,
            "long": 100.358,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 141215,
            "zip_code": 13110,
            "name_th": "ดอนทอง",
            "name_en": "Don Thong",
            "district_id": 1412,
            "lat": 14.24,
            "long": 100.306,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 141216,
            "zip_code": 13110,
            "name_th": "บ้านหลวง",
            "name_en": "Ban Luang",
            "district_id": 1412,
            "lat": 14.278,
            "long": 100.401,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 141217,
            "zip_code": 13110,
            "name_th": "เจ้าเสด็จ",
            "name_en": "Chao Sadet",
            "district_id": 1412,
            "lat": 14.331,
            "long": 100.363,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 1413,
        "name_th": "บางซ้าย",
        "name_en": "Bang Sai",
        "province_id": 5,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 141301,
            "zip_code": 13270,
            "name_th": "บางซ้าย",
            "name_en": "Bang Sai",
            "district_id": 1413,
            "lat": 14.314,
            "long": 100.286,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 141302,
            "zip_code": 13270,
            "name_th": "แก้วฟ้า",
            "name_en": "Kaeo Fa",
            "district_id": 1413,
            "lat": 14.313,
            "long": 100.326,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 141303,
            "zip_code": 13270,
            "name_th": "เต่าเล่า",
            "name_en": "Tao Lao",
            "district_id": 1413,
            "lat": 14.34,
            "long": 100.319,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 141304,
            "zip_code": 13270,
            "name_th": "ปลายกลัด",
            "name_en": "Plai Klat",
            "district_id": 1413,
            "lat": 14.382,
            "long": 100.315,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 141305,
            "zip_code": 13270,
            "name_th": "เทพมงคล",
            "name_en": "Thep Mongkhon",
            "district_id": 1413,
            "lat": 14.236,
            "long": 100.258,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 141306,
            "zip_code": 13270,
            "name_th": "วังพัฒนา",
            "name_en": "Wang Phatthana",
            "district_id": 1413,
            "lat": 14.272,
            "long": 100.296,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 1414,
        "name_th": "อุทัย",
        "name_en": "Uthai",
        "province_id": 5,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 141401,
            "zip_code": 13210,
            "name_th": "คานหาม",
            "name_en": "Khan Ham",
            "district_id": 1414,
            "lat": 14.335,
            "long": 100.641,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 141402,
            "zip_code": 13210,
            "name_th": "บ้านช้าง",
            "name_en": "Ban Chang",
            "district_id": 1414,
            "lat": 14.322,
            "long": 100.68,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 141403,
            "zip_code": 13210,
            "name_th": "สามบัณฑิต",
            "name_en": "Sam Bandit",
            "district_id": 1414,
            "lat": 14.349,
            "long": 100.742,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 141404,
            "zip_code": 13210,
            "name_th": "บ้านหีบ",
            "name_en": "Ban Hip",
            "district_id": 1414,
            "lat": 14.372,
            "long": 100.712,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 141405,
            "zip_code": 13210,
            "name_th": "หนองไม้ซุง",
            "name_en": "Nong Mai Sung",
            "district_id": 1414,
            "lat": 14.376,
            "long": 100.751,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 141406,
            "zip_code": 13210,
            "name_th": "อุทัย",
            "name_en": "Uthai",
            "district_id": 1414,
            "lat": 14.373,
            "long": 100.655,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 141407,
            "zip_code": 13210,
            "name_th": "เสนา",
            "name_en": "Sena",
            "district_id": 1414,
            "lat": 14.392,
            "long": 100.689,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 141408,
            "zip_code": 13210,
            "name_th": "หนองน้ำส้ม",
            "name_en": "Nong Nam Som",
            "district_id": 1414,
            "lat": 14.32,
            "long": 100.714,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 141409,
            "zip_code": 13210,
            "name_th": "โพสาวหาญ",
            "name_en": "Pho Sao Han",
            "district_id": 1414,
            "lat": 14.332,
            "long": 100.759,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 141410,
            "zip_code": 13210,
            "name_th": "ธนู",
            "name_en": "Thanu",
            "district_id": 1414,
            "lat": 14.355,
            "long": 100.622,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 141411,
            "zip_code": 13210,
            "name_th": "ข้าวเม่า",
            "name_en": "Khao Mao",
            "district_id": 1414,
            "lat": 14.379,
            "long": 100.624,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 1415,
        "name_th": "มหาราช",
        "name_en": "Maha Rat",
        "province_id": 5,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 141501,
            "zip_code": 13150,
            "name_th": "หัวไผ่",
            "name_en": "Hua Phai",
            "district_id": 1415,
            "lat": 14.532,
            "long": 100.525,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 141502,
            "zip_code": 13150,
            "name_th": "กะทุ่ม",
            "name_en": "Kathum",
            "district_id": 1415,
            "lat": 14.546,
            "long": 100.556,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 141503,
            "zip_code": 13150,
            "name_th": "มหาราช",
            "name_en": "Maha Rat",
            "district_id": 1415,
            "lat": 14.552,
            "long": 100.528,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 141504,
            "zip_code": 13150,
            "name_th": "น้ำเต้า",
            "name_en": "Namtao",
            "district_id": 1415,
            "lat": 14.566,
            "long": 100.542,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 141505,
            "zip_code": 13150,
            "name_th": "บางนา",
            "name_en": "Bang Na",
            "district_id": 1415,
            "lat": 14.576,
            "long": 100.581,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 141506,
            "zip_code": 13150,
            "name_th": "โรงช้าง",
            "name_en": "Rong Chang",
            "district_id": 1415,
            "lat": 14.602,
            "long": 100.563,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 141507,
            "zip_code": 13150,
            "name_th": "เจ้าปลุก",
            "name_en": "Chao Pluk",
            "district_id": 1415,
            "lat": 14.584,
            "long": 100.538,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 141508,
            "zip_code": 13150,
            "name_th": "พิตเพียน",
            "name_en": "Phitphian",
            "district_id": 1415,
            "lat": 14.608,
            "long": 100.544,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 141509,
            "zip_code": 13150,
            "name_th": "บ้านนา",
            "name_en": "Ban Na",
            "district_id": 1415,
            "lat": 14.606,
            "long": 100.51,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 141510,
            "zip_code": 13150,
            "name_th": "บ้านขวาง",
            "name_en": "Ban Khwang",
            "district_id": 1415,
            "lat": 14.576,
            "long": 100.518,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 141511,
            "zip_code": 13150,
            "name_th": "ท่าตอ",
            "name_en": "Tha To",
            "district_id": 1415,
            "lat": 14.556,
            "long": 100.511,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 141512,
            "zip_code": 13150,
            "name_th": "บ้านใหม่",
            "name_en": "Ban Mai",
            "district_id": 1415,
            "lat": 14.531,
            "long": 100.5,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 1416,
        "name_th": "บ้านแพรก",
        "name_en": "Ban Phraek",
        "province_id": 5,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 141601,
            "zip_code": 13240,
            "name_th": "บ้านแพรก",
            "name_en": "Ban Phraek",
            "district_id": 1416,
            "lat": 14.64,
            "long": 100.585,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 141602,
            "zip_code": 13240,
            "name_th": "บ้านใหม่",
            "name_en": "Ban Mai",
            "district_id": 1416,
            "lat": 14.655,
            "long": 100.586,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 141603,
            "zip_code": 13240,
            "name_th": "สำพะเนียง",
            "name_en": "Sam Phaniang",
            "district_id": 1416,
            "lat": 14.638,
            "long": 100.567,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 141604,
            "zip_code": 13240,
            "name_th": "คลองน้อย",
            "name_en": "Khlong Noi",
            "district_id": 1416,
            "lat": 14.627,
            "long": 100.553,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 141605,
            "zip_code": 13240,
            "name_th": "สองห้อง",
            "name_en": "Song Hong",
            "district_id": 1416,
            "lat": 14.646,
            "long": 100.519,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      }
    ]
  },
  {
    "id": 6,
    "name_th": "อ่างทอง",
    "name_en": "Ang Thong",
    "geography_id": 2,
    "created_at": "2019-08-09T03:33:09.000+07:00",
    "updated_at": "2025-09-20T06:31:26.000+07:00",
    "deleted_at": null,
    "districts": [
      {
        "id": 1501,
        "name_th": "เมืองอ่างทอง",
        "name_en": "Mueang Ang Thong",
        "province_id": 6,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 150101,
            "zip_code": 14000,
            "name_th": "ตลาดหลวง",
            "name_en": "Talat Luang",
            "district_id": 1501,
            "lat": 14.592,
            "long": 100.453,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 150102,
            "zip_code": 14000,
            "name_th": "บางแก้ว",
            "name_en": "Bang Kaeo",
            "district_id": 1501,
            "lat": 14.588,
            "long": 100.459,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 150103,
            "zip_code": 14000,
            "name_th": "ศาลาแดง",
            "name_en": "Sala Daeng",
            "district_id": 1501,
            "lat": 14.599,
            "long": 100.445,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 150104,
            "zip_code": 14000,
            "name_th": "ป่างิ้ว",
            "name_en": "Pa Ngio",
            "district_id": 1501,
            "lat": 14.612,
            "long": 100.413,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 150105,
            "zip_code": 14000,
            "name_th": "บ้านแห",
            "name_en": "Ban Hae",
            "district_id": 1501,
            "lat": 14.565,
            "long": 100.434,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 150106,
            "zip_code": 14000,
            "name_th": "ตลาดกรวด",
            "name_en": "Talat Kruat",
            "district_id": 1501,
            "lat": 14.619,
            "long": 100.478,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 150107,
            "zip_code": 14000,
            "name_th": "มหาดไทย",
            "name_en": "Mahatthai",
            "district_id": 1501,
            "lat": 14.568,
            "long": 100.4,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 150108,
            "zip_code": 14000,
            "name_th": "บ้านอิฐ",
            "name_en": "Ban It",
            "district_id": 1501,
            "lat": 14.583,
            "long": 100.476,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 150109,
            "zip_code": 14000,
            "name_th": "หัวไผ่",
            "name_en": "Hua Phai",
            "district_id": 1501,
            "lat": 14.553,
            "long": 100.474,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 150110,
            "zip_code": 14000,
            "name_th": "จำปาหล่อ",
            "name_en": "Champa Lo",
            "district_id": 1501,
            "lat": 14.539,
            "long": 100.433,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 150111,
            "zip_code": 14000,
            "name_th": "โพสะ",
            "name_en": "Phosa",
            "district_id": 1501,
            "lat": 14.542,
            "long": 100.457,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 150112,
            "zip_code": 14000,
            "name_th": "บ้านรี",
            "name_en": "Ban Ri",
            "district_id": 1501,
            "lat": 14.605,
            "long": 100.485,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 150113,
            "zip_code": 14000,
            "name_th": "คลองวัว",
            "name_en": "Khlong Wua",
            "district_id": 1501,
            "lat": 14.578,
            "long": 100.432,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 150114,
            "zip_code": 14000,
            "name_th": "ย่านซื่อ",
            "name_en": "Yan Sue",
            "district_id": 1501,
            "lat": 14.619,
            "long": 100.447,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 1502,
        "name_th": "ไชโย",
        "name_en": "Chaiyo",
        "province_id": 6,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 150201,
            "zip_code": 14140,
            "name_th": "จรเข้ร้อง",
            "name_en": "Chorakhe Rong",
            "district_id": 1502,
            "lat": 14.658,
            "long": 100.482,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 150202,
            "zip_code": 14140,
            "name_th": "ไชยภูมิ",
            "name_en": "Chaiyaphum",
            "district_id": 1502,
            "lat": 14.705,
            "long": 100.465,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 150203,
            "zip_code": 14140,
            "name_th": "ชัยฤทธิ์",
            "name_en": "Chaiyarit",
            "district_id": 1502,
            "lat": 14.637,
            "long": 100.472,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 150204,
            "zip_code": 14140,
            "name_th": "เทวราช",
            "name_en": "Thewarat",
            "district_id": 1502,
            "lat": 14.646,
            "long": 100.449,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 150205,
            "zip_code": 14140,
            "name_th": "ราชสถิตย์",
            "name_en": "Ratchasathit",
            "district_id": 1502,
            "lat": 14.672,
            "long": 100.456,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 150206,
            "zip_code": 14140,
            "name_th": "ไชโย",
            "name_en": "Chaiyo",
            "district_id": 1502,
            "lat": 14.707,
            "long": 100.436,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 150207,
            "zip_code": 14140,
            "name_th": "หลักฟ้า",
            "name_en": "Lak Fa",
            "district_id": 1502,
            "lat": 14.684,
            "long": 100.462,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 150208,
            "zip_code": 14140,
            "name_th": "ชะไว",
            "name_en": "Chawai",
            "district_id": 1502,
            "lat": 14.687,
            "long": 100.494,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 150209,
            "zip_code": 14140,
            "name_th": "ตรีณรงค์",
            "name_en": "Tri Narong",
            "district_id": 1502,
            "lat": 14.676,
            "long": 100.498,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 1503,
        "name_th": "ป่าโมก",
        "name_en": "Pa Mok",
        "province_id": 6,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 150301,
            "zip_code": 14130,
            "name_th": "บางปลากด",
            "name_en": "Bang Pla Kot",
            "district_id": 1503,
            "lat": 14.509,
            "long": 100.461,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 150302,
            "zip_code": 14130,
            "name_th": "ป่าโมก",
            "name_en": "Pa Mok",
            "district_id": 1503,
            "lat": 14.501,
            "long": 100.437,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 150303,
            "zip_code": 14130,
            "name_th": "สายทอง",
            "name_en": "Sai Thong",
            "district_id": 1503,
            "lat": 14.513,
            "long": 100.484,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 150304,
            "zip_code": 14130,
            "name_th": "โรงช้าง",
            "name_en": "Rong Chang",
            "district_id": 1503,
            "lat": 14.488,
            "long": 100.472,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 150305,
            "zip_code": 14130,
            "name_th": "บางเสด็จ",
            "name_en": "Bang Sadet",
            "district_id": 1503,
            "lat": 14.461,
            "long": 100.473,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 150306,
            "zip_code": 14130,
            "name_th": "นรสิงห์",
            "name_en": "Norasing",
            "district_id": 1503,
            "lat": 14.518,
            "long": 100.431,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 150307,
            "zip_code": 14130,
            "name_th": "เอกราช",
            "name_en": "Ekkarat",
            "district_id": 1503,
            "lat": 14.477,
            "long": 100.426,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 150308,
            "zip_code": 14130,
            "name_th": "โผงเผง",
            "name_en": "Phong Pheng",
            "district_id": 1503,
            "lat": 14.455,
            "long": 100.442,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 1504,
        "name_th": "โพธิ์ทอง",
        "name_en": "Pho Thong",
        "province_id": 6,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 150401,
            "zip_code": 14120,
            "name_th": "อ่างแก้ว",
            "name_en": "Ang Kaeo",
            "district_id": 1504,
            "lat": 14.666,
            "long": 100.393,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 150402,
            "zip_code": 14120,
            "name_th": "อินทประมูล",
            "name_en": "Inthapramun",
            "district_id": 1504,
            "lat": 14.651,
            "long": 100.425,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 150403,
            "zip_code": 14120,
            "name_th": "บางพลับ",
            "name_en": "Bang Phlap",
            "district_id": 1504,
            "lat": 14.641,
            "long": 100.406,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 150404,
            "zip_code": 14120,
            "name_th": "หนองแม่ไก่",
            "name_en": "Nong Mae Kai",
            "district_id": 1504,
            "lat": 14.708,
            "long": 100.351,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 150405,
            "zip_code": 14120,
            "name_th": "รำมะสัก",
            "name_en": "Ram Ma Sak",
            "district_id": 1504,
            "lat": 14.679,
            "long": 100.242,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 150406,
            "zip_code": 14120,
            "name_th": "บางระกำ",
            "name_en": "Bang Rakam",
            "district_id": 1504,
            "lat": 14.691,
            "long": 100.428,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 150407,
            "zip_code": 14120,
            "name_th": "โพธิ์รังนก",
            "name_en": "Pho Rang Nok",
            "district_id": 1504,
            "lat": 14.614,
            "long": 100.378,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 150408,
            "zip_code": 14120,
            "name_th": "องครักษ์",
            "name_en": "Ongkharak",
            "district_id": 1504,
            "lat": 14.731,
            "long": 100.398,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 150409,
            "zip_code": 14120,
            "name_th": "โคกพุทรา",
            "name_en": "Khok Phutsa",
            "district_id": 1504,
            "lat": 14.689,
            "long": 100.375,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 150410,
            "zip_code": 14120,
            "name_th": "ยางช้าย",
            "name_en": "Yang Chai",
            "district_id": 1504,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 150411,
            "zip_code": 14120,
            "name_th": "บ่อแร่",
            "name_en": "Bo Rae",
            "district_id": 1504,
            "lat": 14.637,
            "long": 100.372,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 150412,
            "zip_code": 14120,
            "name_th": "ทางพระ",
            "name_en": "Thang Phra",
            "district_id": 1504,
            "lat": 14.677,
            "long": 100.36,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 150413,
            "zip_code": 14120,
            "name_th": "สามง่าม",
            "name_en": "Sam Ngam",
            "district_id": 1504,
            "lat": 14.638,
            "long": 100.389,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 150414,
            "zip_code": 14120,
            "name_th": "บางเจ้าฉ่า",
            "name_en": "Bang Chao Cha",
            "district_id": 1504,
            "lat": 14.695,
            "long": 100.398,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 150415,
            "zip_code": 14120,
            "name_th": "คำหยาด",
            "name_en": "Kham Yat",
            "district_id": 1504,
            "lat": 14.676,
            "long": 100.323,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 1505,
        "name_th": "แสวงหา",
        "name_en": "Sawaeng Ha",
        "province_id": 6,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 150501,
            "zip_code": 14150,
            "name_th": "แสวงหา",
            "name_en": "Sawaeng Ha",
            "district_id": 1505,
            "lat": 14.763,
            "long": 100.31,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 150502,
            "zip_code": 14150,
            "name_th": "ศรีพราน",
            "name_en": "Si Phran",
            "district_id": 1505,
            "lat": 14.725,
            "long": 100.328,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 150503,
            "zip_code": 14150,
            "name_th": "บ้านพราน",
            "name_en": "Ban Phran",
            "district_id": 1505,
            "lat": 14.709,
            "long": 100.306,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 150504,
            "zip_code": 14150,
            "name_th": "วังน้ำเย็น",
            "name_en": "Wang Nam Yen",
            "district_id": 1505,
            "lat": 14.738,
            "long": 100.221,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 150505,
            "zip_code": 14150,
            "name_th": "สีบัวทอง",
            "name_en": "Si Bua Thong",
            "district_id": 1505,
            "lat": 14.769,
            "long": 100.248,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 150506,
            "zip_code": 14150,
            "name_th": "ห้วยไผ่",
            "name_en": "Huai Phai",
            "district_id": 1505,
            "lat": 14.789,
            "long": 100.324,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 150507,
            "zip_code": 14150,
            "name_th": "จำลอง",
            "name_en": "Chamlong",
            "district_id": 1505,
            "lat": 14.741,
            "long": 100.364,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 1506,
        "name_th": "วิเศษชัยชาญ",
        "name_en": "Wiset Chai Chan",
        "province_id": 6,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 150601,
            "zip_code": 14110,
            "name_th": "ไผ่จำศิล",
            "name_en": "Phai Cham Sin",
            "district_id": 1506,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 150602,
            "zip_code": 14110,
            "name_th": "ศาลเจ้าโรงทอง",
            "name_en": "San Chao Rong Thong",
            "district_id": 1506,
            "lat": 14.597,
            "long": 100.34,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 150603,
            "zip_code": 14110,
            "name_th": "ไผ่ดำพัฒนา",
            "name_en": "Phai Dam Phatthana",
            "district_id": 1506,
            "lat": 14.529,
            "long": 100.392,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 150604,
            "zip_code": 14110,
            "name_th": "สาวร้องไห้",
            "name_en": "Sao Rong Hai",
            "district_id": 1506,
            "lat": 14.546,
            "long": 100.223,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 150605,
            "zip_code": 14110,
            "name_th": "ท่าช้าง",
            "name_en": "Tha Chang",
            "district_id": 1506,
            "lat": 14.562,
            "long": 100.333,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 150606,
            "zip_code": 14110,
            "name_th": "ยี่ล้น",
            "name_en": "Yi Lon",
            "district_id": 1506,
            "lat": 14.579,
            "long": 100.301,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 150607,
            "zip_code": 14110,
            "name_th": "บางจัก",
            "name_en": "Bang Chak",
            "district_id": 1506,
            "lat": 14.502,
            "long": 100.33,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 150608,
            "zip_code": 14110,
            "name_th": "ห้วยคันแหลน",
            "name_en": "Huai Khan Laen",
            "district_id": 1506,
            "lat": 14.555,
            "long": 100.294,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 150609,
            "zip_code": 14110,
            "name_th": "คลองขนาก",
            "name_en": "Khlong Khanak",
            "district_id": 1506,
            "lat": 14.53,
            "long": 100.337,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 150610,
            "zip_code": 14110,
            "name_th": "ไผ่วง",
            "name_en": "Phai Wong",
            "district_id": 1506,
            "lat": 14.505,
            "long": 100.251,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 150611,
            "zip_code": 14110,
            "name_th": "สี่ร้อย",
            "name_en": "Si Roi",
            "district_id": 1506,
            "lat": 14.55,
            "long": 100.37,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 150612,
            "zip_code": 14110,
            "name_th": "ม่วงเตี้ย",
            "name_en": "Muang Tia",
            "district_id": 1506,
            "lat": 14.636,
            "long": 100.323,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 150613,
            "zip_code": 14110,
            "name_th": "หัวตะพาน",
            "name_en": "Hua Taphan",
            "district_id": 1506,
            "lat": 14.583,
            "long": 100.387,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 150614,
            "zip_code": 14110,
            "name_th": "หลักแก้ว",
            "name_en": "Lak Kaeo",
            "district_id": 1506,
            "lat": 14.517,
            "long": 100.289,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 150615,
            "zip_code": 14110,
            "name_th": "ตลาดใหม่",
            "name_en": "Talat Mai",
            "district_id": 1506,
            "lat": 14.542,
            "long": 100.315,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 1507,
        "name_th": "สามโก้",
        "name_en": "Samko",
        "province_id": 6,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 150701,
            "zip_code": 14160,
            "name_th": "สามโก้",
            "name_en": "Samko",
            "district_id": 1507,
            "lat": 14.606,
            "long": 100.252,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 150702,
            "zip_code": 14160,
            "name_th": "ราษฎรพัฒนา",
            "name_en": "Ratsadon Phatthana",
            "district_id": 1507,
            "lat": 14.605,
            "long": 100.293,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 150703,
            "zip_code": 14160,
            "name_th": "อบทม",
            "name_en": "Op Thom",
            "district_id": 1507,
            "lat": 14.581,
            "long": 100.246,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 150704,
            "zip_code": 14160,
            "name_th": "โพธิ์ม่วงพันธ์",
            "name_en": "Pho Muang Phan",
            "district_id": 1507,
            "lat": 14.561,
            "long": 100.254,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 150705,
            "zip_code": 14160,
            "name_th": "มงคลธรรมนิมิต",
            "name_en": "Mongkhon Tham Nimit",
            "district_id": 1507,
            "lat": 14.64,
            "long": 100.26,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      }
    ]
  },
  {
    "id": 7,
    "name_th": "ลพบุรี",
    "name_en": "Lopburi",
    "geography_id": 2,
    "created_at": "2019-08-09T03:33:09.000+07:00",
    "updated_at": "2025-09-20T06:31:26.000+07:00",
    "deleted_at": null,
    "districts": [
      {
        "id": 1601,
        "name_th": "เมืองลพบุรี",
        "name_en": "Mueang Lop Buri",
        "province_id": 7,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 160101,
            "zip_code": 15000,
            "name_th": "ทะเลชุบศร",
            "name_en": "Thale Chup Son",
            "district_id": 1601,
            "lat": 14.804,
            "long": 100.634,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 160102,
            "zip_code": 15000,
            "name_th": "ท่าหิน",
            "name_en": "Tha Hin",
            "district_id": 1601,
            "lat": 14.802,
            "long": 100.611,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 160103,
            "zip_code": 15000,
            "name_th": "กกโก",
            "name_en": "Kok Ko",
            "district_id": 1601,
            "lat": 14.767,
            "long": 100.684,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 160104,
            "zip_code": 13240,
            "name_th": "โก่งธนู",
            "name_en": "Kong Thanu",
            "district_id": 1601,
            "lat": 14.674,
            "long": 100.597,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 160105,
            "zip_code": 15000,
            "name_th": "เขาพระงาม",
            "name_en": "Khao Phra Ngam",
            "district_id": 1601,
            "lat": 14.901,
            "long": 100.67,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 160106,
            "zip_code": 15000,
            "name_th": "เขาสามยอด",
            "name_en": "Khao Sam Yot",
            "district_id": 1601,
            "lat": 14.83,
            "long": 100.671,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 160107,
            "zip_code": 15000,
            "name_th": "โคกกะเทียม",
            "name_en": "Khok Kathiam",
            "district_id": 1601,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 160108,
            "zip_code": 15000,
            "name_th": "โคกลำพาน",
            "name_en": "Khok Lam Phan",
            "district_id": 1601,
            "lat": 14.74,
            "long": 100.64,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 160109,
            "zip_code": 15210,
            "name_th": "โคกตูม",
            "name_en": "Khok Tum",
            "district_id": 1601,
            "lat": 14.866,
            "long": 100.817,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 160110,
            "zip_code": 15000,
            "name_th": "งิ้วราย",
            "name_en": "Ngio Rai",
            "district_id": 1601,
            "lat": 14.704,
            "long": 100.592,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 160111,
            "zip_code": 15000,
            "name_th": "ดอนโพธิ์",
            "name_en": "Don Pho",
            "district_id": 1601,
            "lat": 14.691,
            "long": 100.627,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 160112,
            "zip_code": 15000,
            "name_th": "ตะลุง",
            "name_en": "Talung",
            "district_id": 1601,
            "lat": 14.737,
            "long": 100.601,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 160114,
            "zip_code": 15000,
            "name_th": "ท่าแค",
            "name_en": "Tha Khae",
            "district_id": 1601,
            "lat": 14.865,
            "long": 100.619,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 160115,
            "zip_code": 15000,
            "name_th": "ท่าศาลา",
            "name_en": "Tha Sala",
            "district_id": 1601,
            "lat": 14.792,
            "long": 100.671,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 160116,
            "zip_code": 15000,
            "name_th": "นิคมสร้างตนเอง",
            "name_en": "Nikhom Sang Ton-eng",
            "district_id": 1601,
            "lat": 14.824,
            "long": 100.732,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 160117,
            "zip_code": 15000,
            "name_th": "บางขันหมาก",
            "name_en": "Bang Khan Mak",
            "district_id": 1601,
            "lat": 14.82,
            "long": 100.583,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 160118,
            "zip_code": 15000,
            "name_th": "บ้านข่อย",
            "name_en": "Ban Khoi",
            "district_id": 1601,
            "lat": 14.683,
            "long": 100.529,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 160119,
            "zip_code": 15000,
            "name_th": "ท้ายตลาด",
            "name_en": "Thai Talat",
            "district_id": 1601,
            "lat": 14.725,
            "long": 100.563,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 160120,
            "zip_code": 15000,
            "name_th": "ป่าตาล",
            "name_en": "Pa Tan",
            "district_id": 1601,
            "lat": 14.778,
            "long": 100.64,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 160121,
            "zip_code": 15000,
            "name_th": "พรหมมาสตร์",
            "name_en": "Phrommat",
            "district_id": 1601,
            "lat": 14.82,
            "long": 100.603,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 160122,
            "zip_code": 15000,
            "name_th": "โพธิ์เก้าต้น",
            "name_en": "Pho Kao Ton",
            "district_id": 1601,
            "lat": 14.775,
            "long": 100.599,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 160123,
            "zip_code": 15000,
            "name_th": "โพธิ์ตรุ",
            "name_en": "Pho Tru",
            "district_id": 1601,
            "lat": 14.725,
            "long": 100.532,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 160124,
            "zip_code": 15000,
            "name_th": "สี่คลอง",
            "name_en": "Si Khlong",
            "district_id": 1601,
            "lat": 14.681,
            "long": 100.563,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 160125,
            "zip_code": 15000,
            "name_th": "ถนนใหญ่",
            "name_en": "Thanon Yai",
            "district_id": 1601,
            "lat": 14.831,
            "long": 100.629,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 1602,
        "name_th": "พัฒนานิคม",
        "name_en": "Phatthana Nikhom",
        "province_id": 7,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 160201,
            "zip_code": 15140,
            "name_th": "พัฒนานิคม",
            "name_en": "Phatthana Nikhom",
            "district_id": 1602,
            "lat": 14.896,
            "long": 100.966,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 160202,
            "zip_code": 15220,
            "name_th": "ช่องสาริกา",
            "name_en": "Chong Sarika",
            "district_id": 1602,
            "lat": 14.802,
            "long": 100.909,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 160203,
            "zip_code": 15140,
            "name_th": "มะนาวหวาน",
            "name_en": "Manao Wan",
            "district_id": 1602,
            "lat": 14.934,
            "long": 101.093,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 160204,
            "zip_code": 15220,
            "name_th": "ดีลัง",
            "name_en": "Di Lang",
            "district_id": 1602,
            "lat": 14.94,
            "long": 100.852,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 160205,
            "zip_code": 15140,
            "name_th": "โคกสลุง",
            "name_en": "Khok Salung",
            "district_id": 1602,
            "lat": 15.01,
            "long": 100.969,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 160206,
            "zip_code": 15140,
            "name_th": "ชอนน้อย",
            "name_en": "Chon Noi",
            "district_id": 1602,
            "lat": 14.795,
            "long": 100.985,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 160207,
            "zip_code": 15140,
            "name_th": "หนองบัว",
            "name_en": "Nong Bua",
            "district_id": 1602,
            "lat": 14.851,
            "long": 101.054,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 160208,
            "zip_code": 18220,
            "name_th": "ห้วยขุนราม",
            "name_en": "Huai Khun Ram",
            "district_id": 1602,
            "lat": 14.951,
            "long": 101.205,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 160209,
            "zip_code": 15140,
            "name_th": "น้ำสุด",
            "name_en": "Nam Sut",
            "district_id": 1602,
            "lat": 14.952,
            "long": 101.146,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 1603,
        "name_th": "โคกสำโรง",
        "name_en": "Khok Samrong",
        "province_id": 7,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 160301,
            "zip_code": 15120,
            "name_th": "โคกสำโรง",
            "name_en": "Khok Samrong",
            "district_id": 1603,
            "lat": 15.071,
            "long": 100.713,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 160302,
            "zip_code": 15120,
            "name_th": "เกาะแก้ว",
            "name_en": "Ko Kaeo",
            "district_id": 1603,
            "lat": 15.136,
            "long": 100.736,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 160303,
            "zip_code": 15120,
            "name_th": "ถลุงเหล็ก",
            "name_en": "Thalung Lek",
            "district_id": 1603,
            "lat": 15.064,
            "long": 100.68,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 160304,
            "zip_code": 15120,
            "name_th": "หลุมข้าว",
            "name_en": "Lum Khao",
            "district_id": 1603,
            "lat": 15.024,
            "long": 100.642,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 160305,
            "zip_code": 15120,
            "name_th": "ห้วยโป่ง",
            "name_en": "Huai Pong",
            "district_id": 1603,
            "lat": 14.981,
            "long": 100.677,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 160306,
            "zip_code": 15120,
            "name_th": "คลองเกตุ",
            "name_en": "Khlong Ket",
            "district_id": 1603,
            "lat": 14.967,
            "long": 100.802,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 160307,
            "zip_code": 15120,
            "name_th": "สะแกราบ",
            "name_en": "Sakae Rap",
            "district_id": 1603,
            "lat": 15.12,
            "long": 100.797,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 160308,
            "zip_code": 15120,
            "name_th": "เพนียด",
            "name_en": "Phaniat",
            "district_id": 1603,
            "lat": 15.036,
            "long": 100.812,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 160309,
            "zip_code": 15120,
            "name_th": "วังเพลิง",
            "name_en": "Wang Phloeng",
            "district_id": 1603,
            "lat": 15.062,
            "long": 100.841,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 160310,
            "zip_code": 15120,
            "name_th": "ดงมะรุม",
            "name_en": "Dong Marum",
            "district_id": 1603,
            "lat": 15.127,
            "long": 100.877,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 160318,
            "zip_code": 15120,
            "name_th": "วังขอนขว้าง",
            "name_en": "Wang Khon Khwang",
            "district_id": 1603,
            "lat": 15.023,
            "long": 100.697,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 160320,
            "zip_code": 15120,
            "name_th": "วังจั่น",
            "name_en": "Wang Chan",
            "district_id": 1603,
            "lat": 15.102,
            "long": 100.673,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 160322,
            "zip_code": 15120,
            "name_th": "หนองแขม",
            "name_en": "Nong Khaem",
            "district_id": 1603,
            "lat": 15.143,
            "long": 100.685,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 1604,
        "name_th": "ชัยบาดาล",
        "name_en": "Chai Badan",
        "province_id": 7,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 160401,
            "zip_code": 15130,
            "name_th": "ลำนารายณ์",
            "name_en": "Lam Narai",
            "district_id": 1604,
            "lat": 15.214,
            "long": 101.146,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 160402,
            "zip_code": 15130,
            "name_th": "ชัยนารายณ์",
            "name_en": "Chai Narai",
            "district_id": 1604,
            "lat": 15.195,
            "long": 101.037,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 160403,
            "zip_code": 15130,
            "name_th": "ศิลาทิพย์",
            "name_en": "Sila Thip",
            "district_id": 1604,
            "lat": 15.314,
            "long": 101.087,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 160404,
            "zip_code": 15130,
            "name_th": "ห้วยหิน",
            "name_en": "Huai Hin",
            "district_id": 1604,
            "lat": 15.154,
            "long": 101.044,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 160405,
            "zip_code": 15230,
            "name_th": "ม่วงค่อม",
            "name_en": "Muang Khom",
            "district_id": 1604,
            "lat": 15.078,
            "long": 101.024,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 160406,
            "zip_code": 15130,
            "name_th": "บัวชุม",
            "name_en": "Bua Chum",
            "district_id": 1604,
            "lat": 15.176,
            "long": 101.238,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 160407,
            "zip_code": 15130,
            "name_th": "ท่าดินดำ",
            "name_en": "Tha Din Dam",
            "district_id": 1604,
            "lat": 15.15,
            "long": 101.134,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 160408,
            "zip_code": 15230,
            "name_th": "มะกอกหวาน",
            "name_en": "Makok Wan",
            "district_id": 1604,
            "lat": 15.059,
            "long": 101.077,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 160409,
            "zip_code": 15130,
            "name_th": "ซับตะเคียน",
            "name_en": "Sap Takhian",
            "district_id": 1604,
            "lat": 15.112,
            "long": 101.327,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 160410,
            "zip_code": 15190,
            "name_th": "นาโสม",
            "name_en": "Na Som",
            "district_id": 1604,
            "lat": 15.245,
            "long": 101.282,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 160411,
            "zip_code": 15130,
            "name_th": "หนองยายโต๊ะ",
            "name_en": "Nong Yai To",
            "district_id": 1604,
            "lat": 15.22,
            "long": 101.264,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 160412,
            "zip_code": 15130,
            "name_th": "เกาะรัง",
            "name_en": "Ko Rang",
            "district_id": 1604,
            "lat": 15.318,
            "long": 101.251,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 160414,
            "zip_code": 15130,
            "name_th": "ท่ามะนาว",
            "name_en": "Tha Manao",
            "district_id": 1604,
            "lat": 15.187,
            "long": 101.162,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 160417,
            "zip_code": 15130,
            "name_th": "นิคมลำนารายณ์",
            "name_en": "Nikhom Lam Narai",
            "district_id": 1604,
            "lat": 15.264,
            "long": 101.15,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 160418,
            "zip_code": 15230,
            "name_th": "ชัยบาดาล",
            "name_en": "Chai Badan",
            "district_id": 1604,
            "lat": 15.095,
            "long": 101.058,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 160419,
            "zip_code": 15130,
            "name_th": "บ้านใหม่สามัคคี",
            "name_en": "Ban Mai Samakkhi",
            "district_id": 1604,
            "lat": 15.258,
            "long": 101.022,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 160422,
            "zip_code": 15130,
            "name_th": "เขาแหลม",
            "name_en": "Khao Laem",
            "district_id": 1604,
            "lat": 15.126,
            "long": 100.964,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 1605,
        "name_th": "ท่าวุ้ง",
        "name_en": "Tha Wung",
        "province_id": 7,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 160501,
            "zip_code": 15150,
            "name_th": "ท่าวุ้ง",
            "name_en": "Tha Wung",
            "district_id": 1605,
            "lat": 14.82,
            "long": 100.496,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 160502,
            "zip_code": 15150,
            "name_th": "บางคู้",
            "name_en": "Bang Khu",
            "district_id": 1605,
            "lat": 14.804,
            "long": 100.529,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 160503,
            "zip_code": 15150,
            "name_th": "โพตลาดแก้ว",
            "name_en": "Pho Talat Kaeo",
            "district_id": 1605,
            "lat": 14.795,
            "long": 100.558,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 160504,
            "zip_code": 15150,
            "name_th": "บางลี่",
            "name_en": "Bang Li",
            "district_id": 1605,
            "lat": 14.849,
            "long": 100.526,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 160505,
            "zip_code": 15150,
            "name_th": "บางงา",
            "name_en": "Bang Nga",
            "district_id": 1605,
            "lat": 14.85,
            "long": 100.492,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 160506,
            "zip_code": 15150,
            "name_th": "โคกสลุด",
            "name_en": "Khok Salut",
            "district_id": 1605,
            "lat": 14.881,
            "long": 100.482,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 160507,
            "zip_code": 15180,
            "name_th": "เขาสมอคอน",
            "name_en": "Khao Samo Khon",
            "district_id": 1605,
            "lat": 14.906,
            "long": 100.447,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 160508,
            "zip_code": 15150,
            "name_th": "หัวสำโรง",
            "name_en": "Hua Samrong",
            "district_id": 1605,
            "lat": 14.776,
            "long": 100.494,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 160509,
            "zip_code": 15150,
            "name_th": "ลาดสาลี่",
            "name_en": "Lat Sali",
            "district_id": 1605,
            "lat": 14.723,
            "long": 100.487,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 160510,
            "zip_code": 15150,
            "name_th": "บ้านเบิก",
            "name_en": "Ban Boek",
            "district_id": 1605,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 160511,
            "zip_code": 15150,
            "name_th": "มุจลินท์",
            "name_en": "Mutchalin",
            "district_id": 1605,
            "lat": 14.876,
            "long": 100.509,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 1606,
        "name_th": "บ้านหมี่",
        "name_en": "Ban Mi",
        "province_id": 7,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 160601,
            "zip_code": 15110,
            "name_th": "ไผ่ใหญ่",
            "name_en": "Phai Yai",
            "district_id": 1606,
            "lat": 15.089,
            "long": 100.459,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 160602,
            "zip_code": 15110,
            "name_th": "บ้านทราย",
            "name_en": "Ban Sai",
            "district_id": 1606,
            "lat": 15.034,
            "long": 100.582,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 160603,
            "zip_code": 15110,
            "name_th": "บ้านกล้วย",
            "name_en": "Ban Kluai",
            "district_id": 1606,
            "lat": 15.016,
            "long": 100.578,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 160604,
            "zip_code": 15110,
            "name_th": "ดงพลับ",
            "name_en": "Dong Phlap",
            "district_id": 1606,
            "lat": 15.059,
            "long": 100.63,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 160605,
            "zip_code": 15180,
            "name_th": "บ้านชี",
            "name_en": "Ban Chi",
            "district_id": 1606,
            "lat": 14.947,
            "long": 100.5,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 160606,
            "zip_code": 15110,
            "name_th": "พุคา",
            "name_en": "Phu Kha",
            "district_id": 1606,
            "lat": 14.953,
            "long": 100.598,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 160607,
            "zip_code": 15110,
            "name_th": "หินปัก",
            "name_en": "Hin Pak",
            "district_id": 1606,
            "lat": 15.048,
            "long": 100.592,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 160608,
            "zip_code": 15110,
            "name_th": "บางพึ่ง",
            "name_en": "Bang Phueng",
            "district_id": 1606,
            "lat": 14.994,
            "long": 100.496,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 160609,
            "zip_code": 15110,
            "name_th": "หนองทรายขาว",
            "name_en": "Nong Sai Khao",
            "district_id": 1606,
            "lat": 14.996,
            "long": 100.597,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 160610,
            "zip_code": 15110,
            "name_th": "บางกะพี้",
            "name_en": "Bang Kaphi",
            "district_id": 1606,
            "lat": 15.073,
            "long": 100.613,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 160611,
            "zip_code": 15110,
            "name_th": "หนองเต่า",
            "name_en": "Nong Tao",
            "district_id": 1606,
            "lat": 14.963,
            "long": 100.555,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 160612,
            "zip_code": 15110,
            "name_th": "โพนทอง",
            "name_en": "Phon Thong",
            "district_id": 1606,
            "lat": 15.04,
            "long": 100.559,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 160613,
            "zip_code": 15180,
            "name_th": "บางขาม",
            "name_en": "Bang Kham",
            "district_id": 1606,
            "lat": 14.953,
            "long": 100.457,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 160614,
            "zip_code": 15110,
            "name_th": "ดอนดึง",
            "name_en": "Don Dueng",
            "district_id": 1606,
            "lat": 15.146,
            "long": 100.612,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 160615,
            "zip_code": 15110,
            "name_th": "ชอนม่วง",
            "name_en": "Chon Muang",
            "district_id": 1606,
            "lat": 15.21,
            "long": 100.61,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 160616,
            "zip_code": 15110,
            "name_th": "หนองกระเบียน",
            "name_en": "Nong Krabian",
            "district_id": 1606,
            "lat": 15.148,
            "long": 100.534,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 160617,
            "zip_code": 15110,
            "name_th": "สายห้วยแก้ว",
            "name_en": "Sai Huai Kaeo",
            "district_id": 1606,
            "lat": 15.095,
            "long": 100.509,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 160618,
            "zip_code": 15110,
            "name_th": "มหาสอน",
            "name_en": "Maha Son",
            "district_id": 1606,
            "lat": 15.021,
            "long": 100.484,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 160619,
            "zip_code": 15110,
            "name_th": "บ้านหมี่",
            "name_en": "Ban Mi",
            "district_id": 1606,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 160620,
            "zip_code": 15110,
            "name_th": "เชียงงา",
            "name_en": "Chiang Nga",
            "district_id": 1606,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 160621,
            "zip_code": 15110,
            "name_th": "หนองเมือง",
            "name_en": "Nong Mueang",
            "district_id": 1606,
            "lat": 15.124,
            "long": 100.569,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 160622,
            "zip_code": 15110,
            "name_th": "สนามแจง",
            "name_en": "Sanam Chaeng",
            "district_id": 1606,
            "lat": 15.008,
            "long": 100.538,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 1607,
        "name_th": "ท่าหลวง",
        "name_en": "Tha Luang",
        "province_id": 7,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 160701,
            "zip_code": 15230,
            "name_th": "ท่าหลวง",
            "name_en": "Tha Luang",
            "district_id": 1607,
            "lat": 15.071,
            "long": 101.117,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 160702,
            "zip_code": 15230,
            "name_th": "แก่งผักกูด",
            "name_en": "Kaeng Phak Kut",
            "district_id": 1607,
            "lat": 15.014,
            "long": 101.085,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 160703,
            "zip_code": 15230,
            "name_th": "ซับจำปา",
            "name_en": "Sap Champa",
            "district_id": 1607,
            "lat": 15.026,
            "long": 101.228,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 160704,
            "zip_code": 15230,
            "name_th": "หนองผักแว่น",
            "name_en": "Nong Phak Waen",
            "district_id": 1607,
            "lat": 15.119,
            "long": 101.216,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 160705,
            "zip_code": 15230,
            "name_th": "ทะเลวังวัด",
            "name_en": "Thale Wang Wat",
            "district_id": 1607,
            "lat": 15.023,
            "long": 101.184,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 160706,
            "zip_code": 15230,
            "name_th": "หัวลำ",
            "name_en": "Hua Lam",
            "district_id": 1607,
            "lat": 15.029,
            "long": 101.292,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 1608,
        "name_th": "สระโบสถ์",
        "name_en": "Sa Bot",
        "province_id": 7,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 160801,
            "zip_code": 15240,
            "name_th": "สระโบสถ์",
            "name_en": "Sa Bot",
            "district_id": 1608,
            "lat": 15.224,
            "long": 100.846,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 160802,
            "zip_code": 15240,
            "name_th": "มหาโพธิ",
            "name_en": "Maha Phot",
            "district_id": 1608,
            "lat": 15.289,
            "long": 100.861,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 160803,
            "zip_code": 15240,
            "name_th": "ทุ่งท่าช้าง",
            "name_en": "Thung Tha Chang",
            "district_id": 1608,
            "lat": 15.169,
            "long": 100.817,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 160804,
            "zip_code": 15240,
            "name_th": "ห้วยใหญ่",
            "name_en": "Huai Yai",
            "district_id": 1608,
            "lat": 15.169,
            "long": 100.793,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 160805,
            "zip_code": 15240,
            "name_th": "นิยมชัย",
            "name_en": "Niyom Chai",
            "district_id": 1608,
            "lat": 15.183,
            "long": 100.904,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 1609,
        "name_th": "โคกเจริญ",
        "name_en": "Khok Charoen",
        "province_id": 7,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 160901,
            "zip_code": 15250,
            "name_th": "โคกเจริญ",
            "name_en": "Khok Charoen",
            "district_id": 1609,
            "lat": 15.408,
            "long": 100.777,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 160902,
            "zip_code": 15250,
            "name_th": "ยางราก",
            "name_en": "Yang Rak",
            "district_id": 1609,
            "lat": 15.366,
            "long": 100.935,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 160903,
            "zip_code": 15250,
            "name_th": "หนองมะค่า",
            "name_en": "Nong Makha",
            "district_id": 1609,
            "lat": 15.515,
            "long": 100.839,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 160904,
            "zip_code": 15250,
            "name_th": "วังทอง",
            "name_en": "Wang Thong",
            "district_id": 1609,
            "lat": 15.469,
            "long": 100.811,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 160905,
            "zip_code": 15250,
            "name_th": "โคกแสมสาร",
            "name_en": "Khok Samae San",
            "district_id": 1609,
            "lat": 15.344,
            "long": 100.85,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 1610,
        "name_th": "ลำสนธิ",
        "name_en": "Lam Sonthi",
        "province_id": 7,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 161001,
            "zip_code": 15190,
            "name_th": "ลำสนธิ",
            "name_en": "Lam Sonthi",
            "district_id": 1610,
            "lat": 15.341,
            "long": 101.362,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 161002,
            "zip_code": 15190,
            "name_th": "ซับสมบูรณ์",
            "name_en": "Sap Sombun",
            "district_id": 1610,
            "lat": 15.193,
            "long": 101.354,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 161003,
            "zip_code": 15190,
            "name_th": "หนองรี",
            "name_en": "Nong Ri",
            "district_id": 1610,
            "lat": 15.282,
            "long": 101.319,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 161004,
            "zip_code": 15190,
            "name_th": "กุดตาเพชร",
            "name_en": "Kut Ta Phet",
            "district_id": 1610,
            "lat": 15.523,
            "long": 101.346,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 161005,
            "zip_code": 15190,
            "name_th": "เขารวก",
            "name_en": "Khao Ruak",
            "district_id": 1610,
            "lat": 15.374,
            "long": 101.33,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 161006,
            "zip_code": 15130,
            "name_th": "เขาน้อย",
            "name_en": "Khao Noi",
            "district_id": 1610,
            "lat": 15.112,
            "long": 101.387,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 1611,
        "name_th": "หนองม่วง",
        "name_en": "Nong Muang",
        "province_id": 7,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 161101,
            "zip_code": 15170,
            "name_th": "หนองม่วง",
            "name_en": "Nong Muang",
            "district_id": 1611,
            "lat": 15.23,
            "long": 100.664,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 161102,
            "zip_code": 15170,
            "name_th": "บ่อทอง",
            "name_en": "Bo Thong",
            "district_id": 1611,
            "lat": 15.293,
            "long": 100.652,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 161103,
            "zip_code": 15170,
            "name_th": "ดงดินแดง",
            "name_en": "Dong Din Daeng",
            "district_id": 1611,
            "lat": 15.385,
            "long": 100.679,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 161104,
            "zip_code": 15170,
            "name_th": "ชอนสมบูรณ์",
            "name_en": "Chon Sombun",
            "district_id": 1611,
            "lat": 15.288,
            "long": 100.763,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 161105,
            "zip_code": 15170,
            "name_th": "ยางโทน",
            "name_en": "Yang Thon",
            "district_id": 1611,
            "lat": 15.248,
            "long": 100.702,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 161106,
            "zip_code": 15170,
            "name_th": "ชอนสารเดช",
            "name_en": "Chon Saradet",
            "district_id": 1611,
            "lat": 15.195,
            "long": 100.709,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      }
    ]
  },
  {
    "id": 8,
    "name_th": "สิงห์บุรี",
    "name_en": "Sing Buri",
    "geography_id": 2,
    "created_at": "2019-08-09T03:33:09.000+07:00",
    "updated_at": "2025-09-20T06:31:26.000+07:00",
    "deleted_at": null,
    "districts": [
      {
        "id": 1701,
        "name_th": "เมืองสิงห์บุรี",
        "name_en": "Mueang Sing Buri",
        "province_id": 8,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 170101,
            "zip_code": 16000,
            "name_th": "บางพุทรา",
            "name_en": "Bang Phutsa",
            "district_id": 1701,
            "lat": 14.89,
            "long": 100.404,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 170102,
            "zip_code": 16000,
            "name_th": "บางมัญ",
            "name_en": "Bang Man",
            "district_id": 1701,
            "lat": 14.916,
            "long": 100.4,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 170103,
            "zip_code": 16000,
            "name_th": "โพกรวม",
            "name_en": "Phok Ruam",
            "district_id": 1701,
            "lat": 14.944,
            "long": 100.394,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 170104,
            "zip_code": 16000,
            "name_th": "ม่วงหมู่",
            "name_en": "Muang Mu",
            "district_id": 1701,
            "lat": 14.869,
            "long": 100.432,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 170105,
            "zip_code": 16000,
            "name_th": "หัวไผ่",
            "name_en": "Hua Phai",
            "district_id": 1701,
            "lat": 14.965,
            "long": 100.429,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 170106,
            "zip_code": 16000,
            "name_th": "ต้นโพธิ์",
            "name_en": "Ton Pho",
            "district_id": 1701,
            "lat": 14.869,
            "long": 100.398,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 170107,
            "zip_code": 16000,
            "name_th": "จักรสีห์",
            "name_en": "Chaksi",
            "district_id": 1701,
            "lat": 14.836,
            "long": 100.398,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 170108,
            "zip_code": 16000,
            "name_th": "บางกระบือ",
            "name_en": "Bang Krabue",
            "district_id": 1701,
            "lat": 14.907,
            "long": 100.363,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 1702,
        "name_th": "บางระจัน",
        "name_en": "Bang Rachan",
        "province_id": 8,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 170201,
            "zip_code": 16130,
            "name_th": "สิงห์",
            "name_en": "Sing",
            "district_id": 1702,
            "lat": 14.89,
            "long": 100.338,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 170202,
            "zip_code": 16130,
            "name_th": "ไม้ดัด",
            "name_en": "Mai Dat",
            "district_id": 1702,
            "lat": 14.858,
            "long": 100.345,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 170203,
            "zip_code": 16130,
            "name_th": "เชิงกลัด",
            "name_en": "Choeng Klat",
            "district_id": 1702,
            "lat": 14.91,
            "long": 100.269,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 170204,
            "zip_code": 16130,
            "name_th": "โพชนไก่",
            "name_en": "Pho Chon Kai",
            "district_id": 1702,
            "lat": 14.929,
            "long": 100.292,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 170205,
            "zip_code": 16130,
            "name_th": "แม่ลา",
            "name_en": "Mae La",
            "district_id": 1702,
            "lat": 14.941,
            "long": 100.319,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 170206,
            "zip_code": 16130,
            "name_th": "บ้านจ่า",
            "name_en": "Ban Cha",
            "district_id": 1702,
            "lat": 14.852,
            "long": 100.284,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 170207,
            "zip_code": 16130,
            "name_th": "พักทัน",
            "name_en": "Phak Than",
            "district_id": 1702,
            "lat": 14.924,
            "long": 100.22,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 170208,
            "zip_code": 16130,
            "name_th": "สระแจง",
            "name_en": "Sa Chaeng",
            "district_id": 1702,
            "lat": 14.873,
            "long": 100.235,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 1703,
        "name_th": "ค่ายบางระจัน",
        "name_en": "Khai Bang Rachan",
        "province_id": 8,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 170301,
            "zip_code": 16150,
            "name_th": "โพทะเล",
            "name_en": "Pho Thale",
            "district_id": 1703,
            "lat": 14.829,
            "long": 100.257,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 170302,
            "zip_code": 16150,
            "name_th": "บางระจัน",
            "name_en": "Bang Rachan",
            "district_id": 1703,
            "lat": 14.799,
            "long": 100.296,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 170303,
            "zip_code": 16150,
            "name_th": "โพสังโฆ",
            "name_en": "Pho Sangkho",
            "district_id": 1703,
            "lat": 14.833,
            "long": 100.349,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 170304,
            "zip_code": 16150,
            "name_th": "ท่าข้าม",
            "name_en": "Tha Kham",
            "district_id": 1703,
            "lat": 14.827,
            "long": 100.368,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 170305,
            "zip_code": 16150,
            "name_th": "คอทราย",
            "name_en": "Kho Sai",
            "district_id": 1703,
            "lat": 14.817,
            "long": 100.281,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 170306,
            "zip_code": 16150,
            "name_th": "หนองกระทุ่ม",
            "name_en": "Nong Krathum",
            "district_id": 1703,
            "lat": 14.82,
            "long": 100.225,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 1704,
        "name_th": "พรหมบุรี",
        "name_en": "Phrom Buri",
        "province_id": 8,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 170401,
            "zip_code": 16120,
            "name_th": "พระงาม",
            "name_en": "Phra Ngam",
            "district_id": 1704,
            "lat": 14.748,
            "long": 100.422,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 170402,
            "zip_code": 16160,
            "name_th": "พรหมบุรี",
            "name_en": "Phrom Buri",
            "district_id": 1704,
            "lat": 14.837,
            "long": 100.451,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 170403,
            "zip_code": 16120,
            "name_th": "บางน้ำเชี่ยว",
            "name_en": "Bang Nam Chiao",
            "district_id": 1704,
            "lat": 14.783,
            "long": 100.458,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 170404,
            "zip_code": 16120,
            "name_th": "บ้านหม้อ",
            "name_en": "Ban Mo",
            "district_id": 1704,
            "lat": 14.746,
            "long": 100.461,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 170405,
            "zip_code": 16120,
            "name_th": "บ้านแป้ง",
            "name_en": "Ban Paeng",
            "district_id": 1704,
            "lat": 14.811,
            "long": 100.458,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 170406,
            "zip_code": 16120,
            "name_th": "หัวป่า",
            "name_en": "Hua Pa",
            "district_id": 1704,
            "lat": 14.831,
            "long": 100.425,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 170407,
            "zip_code": 16120,
            "name_th": "โรงช้าง",
            "name_en": "Rong Chang",
            "district_id": 1704,
            "lat": 14.801,
            "long": 100.425,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 1705,
        "name_th": "ท่าช้าง",
        "name_en": "Tha Chang",
        "province_id": 8,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 170501,
            "zip_code": 16140,
            "name_th": "ถอนสมอ",
            "name_en": "Thon Samo",
            "district_id": 1705,
            "lat": 14.765,
            "long": 100.384,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 170502,
            "zip_code": 16140,
            "name_th": "โพประจักษ์",
            "name_en": "Pho Prachak",
            "district_id": 1705,
            "lat": 14.774,
            "long": 100.36,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 170503,
            "zip_code": 16140,
            "name_th": "วิหารขาว",
            "name_en": "Wihan Khao",
            "district_id": 1705,
            "lat": 14.801,
            "long": 100.409,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 170504,
            "zip_code": 16140,
            "name_th": "พิกุลทอง",
            "name_en": "Phikun Thong",
            "district_id": 1705,
            "lat": 14.772,
            "long": 100.41,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 1706,
        "name_th": "อินทร์บุรี",
        "name_en": "In Buri",
        "province_id": 8,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 170601,
            "zip_code": 16110,
            "name_th": "อินทร์บุรี",
            "name_en": "In Buri",
            "district_id": 1706,
            "lat": 15.009,
            "long": 100.329,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 170602,
            "zip_code": 16110,
            "name_th": "ประศุก",
            "name_en": "Prasuk",
            "district_id": 1706,
            "lat": 15.042,
            "long": 100.291,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 170603,
            "zip_code": 16110,
            "name_th": "ทับยา",
            "name_en": "Thap Ya",
            "district_id": 1706,
            "lat": 14.96,
            "long": 100.334,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 170604,
            "zip_code": 16110,
            "name_th": "งิ้วราย",
            "name_en": "Ngio Rai",
            "district_id": 1706,
            "lat": 14.988,
            "long": 100.389,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 170605,
            "zip_code": 16110,
            "name_th": "ชีน้ำร้าย",
            "name_en": "Chi Nam Rai",
            "district_id": 1706,
            "lat": 15.081,
            "long": 100.331,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 170606,
            "zip_code": 16110,
            "name_th": "ท่างาม",
            "name_en": "Tha Ngam",
            "district_id": 1706,
            "lat": 15.041,
            "long": 100.343,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 170607,
            "zip_code": 16110,
            "name_th": "น้ำตาล",
            "name_en": "Namtan",
            "district_id": 1706,
            "lat": 14.976,
            "long": 100.361,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 170608,
            "zip_code": 16110,
            "name_th": "ทองเอน",
            "name_en": "Thong En",
            "district_id": 1706,
            "lat": 15.046,
            "long": 100.385,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 170609,
            "zip_code": 16110,
            "name_th": "ห้วยชัน",
            "name_en": "Huai Chan",
            "district_id": 1706,
            "lat": 15.019,
            "long": 100.269,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 170610,
            "zip_code": 16110,
            "name_th": "โพธิ์ชัย",
            "name_en": "Pho Chai",
            "district_id": 1706,
            "lat": 15.027,
            "long": 100.439,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      }
    ]
  },
  {
    "id": 9,
    "name_th": "ชัยนาท",
    "name_en": "Chai Nat",
    "geography_id": 2,
    "created_at": "2019-08-09T03:33:09.000+07:00",
    "updated_at": "2025-09-20T06:31:26.000+07:00",
    "deleted_at": null,
    "districts": [
      {
        "id": 1801,
        "name_th": "เมืองชัยนาท",
        "name_en": "Mueang Chai Nat",
        "province_id": 9,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 180101,
            "zip_code": 17000,
            "name_th": "ในเมือง",
            "name_en": "Nai Mueang",
            "district_id": 1801,
            "lat": 15.181,
            "long": 100.127,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 180102,
            "zip_code": 17000,
            "name_th": "บ้านกล้วย",
            "name_en": "Ban Kluai",
            "district_id": 1801,
            "lat": 15.182,
            "long": 100.153,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 180103,
            "zip_code": 17000,
            "name_th": "ท่าชัย",
            "name_en": "Tha Chai",
            "district_id": 1801,
            "lat": 15.163,
            "long": 100.113,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 180104,
            "zip_code": 17000,
            "name_th": "ชัยนาท",
            "name_en": "Chai Nat",
            "district_id": 1801,
            "lat": 15.129,
            "long": 100.151,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 180105,
            "zip_code": 17000,
            "name_th": "เขาท่าพระ",
            "name_en": "Khao Tha Phra",
            "district_id": 1801,
            "lat": 15.218,
            "long": 100.134,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 180106,
            "zip_code": 17000,
            "name_th": "หาดท่าเสา",
            "name_en": "Hat Tha Sao",
            "district_id": 1801,
            "lat": 15.2,
            "long": 100.079,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 180107,
            "zip_code": 17000,
            "name_th": "ธรรมามูล",
            "name_en": "Thammamun",
            "district_id": 1801,
            "lat": 15.264,
            "long": 100.133,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 180108,
            "zip_code": 17000,
            "name_th": "เสือโฮก",
            "name_en": "Suea Hok",
            "district_id": 1801,
            "lat": 15.238,
            "long": 100.224,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 180109,
            "zip_code": 17000,
            "name_th": "นางลือ",
            "name_en": "Nang Lue",
            "district_id": 1801,
            "lat": 15.122,
            "long": 100.082,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 1802,
        "name_th": "มโนรมย์",
        "name_en": "Manorom",
        "province_id": 9,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 180201,
            "zip_code": 17110,
            "name_th": "คุ้งสำเภา",
            "name_en": "Khung Samphao",
            "district_id": 1802,
            "lat": 15.291,
            "long": 100.091,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 180202,
            "zip_code": 17110,
            "name_th": "วัดโคก",
            "name_en": "Wat Khok",
            "district_id": 1802,
            "lat": 15.326,
            "long": 100.107,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 180203,
            "zip_code": 17110,
            "name_th": "ศิลาดาน",
            "name_en": "Sila Dan",
            "district_id": 1802,
            "lat": 15.354,
            "long": 100.122,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 180204,
            "zip_code": 17110,
            "name_th": "ท่าฉนวน",
            "name_en": "Tha Chanuan",
            "district_id": 1802,
            "lat": 15.379,
            "long": 100.138,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 180205,
            "zip_code": 17170,
            "name_th": "หางน้ำสาคร",
            "name_en": "Hang Nam Sakhon",
            "district_id": 1802,
            "lat": 15.292,
            "long": 100.146,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 180206,
            "zip_code": 17170,
            "name_th": "ไร่พัฒนา",
            "name_en": "Rai Phatthana",
            "district_id": 1802,
            "lat": 15.333,
            "long": 100.225,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 180207,
            "zip_code": 17170,
            "name_th": "อู่ตะเภา",
            "name_en": "U Taphao",
            "district_id": 1802,
            "lat": 15.274,
            "long": 100.219,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 1803,
        "name_th": "วัดสิงห์",
        "name_en": "Wat Sing",
        "province_id": 9,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 180301,
            "zip_code": 17120,
            "name_th": "วัดสิงห์",
            "name_en": "Wat Sing",
            "district_id": 1803,
            "lat": 15.263,
            "long": 100.041,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 180302,
            "zip_code": 17120,
            "name_th": "มะขามเฒ่า",
            "name_en": "Makham Thao",
            "district_id": 1803,
            "lat": 15.227,
            "long": 100.04,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 180303,
            "zip_code": 17120,
            "name_th": "หนองน้อย",
            "name_en": "Nong Noi",
            "district_id": 1803,
            "lat": 15.177,
            "long": 100.015,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 180304,
            "zip_code": 17120,
            "name_th": "หนองบัว",
            "name_en": "Nong Bua",
            "district_id": 1803,
            "lat": 15.283,
            "long": 100.013,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 180306,
            "zip_code": 17120,
            "name_th": "หนองขุ่น",
            "name_en": "Bo Rae",
            "district_id": 1803,
            "lat": 15.235,
            "long": 99.97,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 180307,
            "zip_code": 17120,
            "name_th": "บ่อแร่",
            "name_en": "Wang Man",
            "district_id": 1803,
            "lat": 15.283,
            "long": 99.958,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 180311,
            "zip_code": 17120,
            "name_th": "วังหมัน",
            "name_en": "Wang Man",
            "district_id": 1803,
            "lat": 15.171,
            "long": 99.916,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 1804,
        "name_th": "สรรพยา",
        "name_en": "Sapphaya",
        "province_id": 9,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 180401,
            "zip_code": 17150,
            "name_th": "สรรพยา",
            "name_en": "Sapphaya",
            "district_id": 1804,
            "lat": 15.128,
            "long": 100.233,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 180402,
            "zip_code": 17150,
            "name_th": "ตลุก",
            "name_en": "Taluk",
            "district_id": 1804,
            "lat": 15.195,
            "long": 100.198,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 180403,
            "zip_code": 17150,
            "name_th": "เขาแก้ว",
            "name_en": "Khao Kaeo",
            "district_id": 1804,
            "lat": 15.142,
            "long": 100.316,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 180404,
            "zip_code": 17150,
            "name_th": "โพนางดำตก",
            "name_en": "Pho Nang Dam Tok",
            "district_id": 1804,
            "lat": 15.084,
            "long": 100.272,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 180405,
            "zip_code": 17150,
            "name_th": "โพนางดำออก",
            "name_en": "Pho Nang Dam Ok",
            "district_id": 1804,
            "lat": 15.12,
            "long": 100.283,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 180406,
            "zip_code": 17150,
            "name_th": "บางหลวง",
            "name_en": "Bang Luang",
            "district_id": 1804,
            "lat": 15.143,
            "long": 100.197,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 180407,
            "zip_code": 17150,
            "name_th": "หาดอาษา",
            "name_en": "Hat Asa",
            "district_id": 1804,
            "lat": 15.165,
            "long": 100.262,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 1805,
        "name_th": "สรรคบุรี",
        "name_en": "Sankhaburi",
        "province_id": 9,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 180501,
            "zip_code": 17140,
            "name_th": "แพรกศรีราชา",
            "name_en": "Phraek Si Racha",
            "district_id": 1805,
            "lat": 15.062,
            "long": 100.107,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 180502,
            "zip_code": 17140,
            "name_th": "เที่ยงแท้",
            "name_en": "Thiang Thae",
            "district_id": 1805,
            "lat": 15.089,
            "long": 100.161,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 180503,
            "zip_code": 17140,
            "name_th": "ห้วยกรด",
            "name_en": "Huai Krot",
            "district_id": 1805,
            "lat": 15.096,
            "long": 100.203,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 180504,
            "zip_code": 17140,
            "name_th": "โพงาม",
            "name_en": "Pho Ngam",
            "district_id": 1805,
            "lat": 14.995,
            "long": 100.249,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 180505,
            "zip_code": 17140,
            "name_th": "บางขุด",
            "name_en": "Bang Khut",
            "district_id": 1805,
            "lat": 14.991,
            "long": 100.194,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 180506,
            "zip_code": 17140,
            "name_th": "ดงคอน",
            "name_en": "Dong Khon",
            "district_id": 1805,
            "lat": 14.976,
            "long": 100.135,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 180507,
            "zip_code": 17140,
            "name_th": "ดอนกำ",
            "name_en": "Don Kam",
            "district_id": 1805,
            "lat": 14.966,
            "long": 100.236,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 180508,
            "zip_code": 17140,
            "name_th": "ห้วยกรดพัฒนา",
            "name_en": "Huai Krot Phatthana",
            "district_id": 1805,
            "lat": 15.074,
            "long": 100.228,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 1806,
        "name_th": "หันคา",
        "name_en": "Hankha",
        "province_id": 9,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 180601,
            "zip_code": 17130,
            "name_th": "หันคา",
            "name_en": "Hankha",
            "district_id": 1806,
            "lat": 15.016,
            "long": 99.998,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 180602,
            "zip_code": 17130,
            "name_th": "บ้านเชี่ยน",
            "name_en": "Ban Chian",
            "district_id": 1806,
            "lat": 14.942,
            "long": 99.997,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 180605,
            "zip_code": 17130,
            "name_th": "ไพรนกยูง",
            "name_en": "Phrai Nok Yung",
            "district_id": 1806,
            "lat": 15.081,
            "long": 99.856,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 180606,
            "zip_code": 17160,
            "name_th": "หนองแซง",
            "name_en": "Nong Saeng",
            "district_id": 1806,
            "lat": 15.107,
            "long": 99.973,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 180607,
            "zip_code": 17160,
            "name_th": "ห้วยงู",
            "name_en": "Huai Ngu",
            "district_id": 1806,
            "lat": 15.072,
            "long": 100.067,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 180608,
            "zip_code": 17130,
            "name_th": "วังไก่เถื่อน",
            "name_en": "Wang Kai Thuean",
            "district_id": 1806,
            "lat": 15.004,
            "long": 100.056,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 180609,
            "zip_code": 17130,
            "name_th": "เด่นใหญ่",
            "name_en": "Den Yai",
            "district_id": 1806,
            "lat": 15.017,
            "long": 99.93,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 180611,
            "zip_code": 17160,
            "name_th": "สามง่ามท่าโบสถ์",
            "name_en": "Sam Ngam Tha Bot",
            "district_id": 1806,
            "lat": 15.065,
            "long": 100.026,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 1807,
        "name_th": "หนองมะโมง",
        "name_en": "Nong Mamong",
        "province_id": 9,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 180701,
            "zip_code": 17120,
            "name_th": "หนองมะโมง",
            "name_en": "Nong Mamong",
            "district_id": 1807,
            "lat": 15.216,
            "long": 99.772,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 180702,
            "zip_code": 17120,
            "name_th": "วังตะเคียน",
            "name_en": "Wang Takhian",
            "district_id": 1807,
            "lat": 15.278,
            "long": 99.802,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 180703,
            "zip_code": 17120,
            "name_th": "สะพานหิน",
            "name_en": "Saphan Hin",
            "district_id": 1807,
            "lat": 15.197,
            "long": 99.827,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 180704,
            "zip_code": 17120,
            "name_th": "กุดจอก",
            "name_en": "Kut Chok",
            "district_id": 1807,
            "lat": 15.241,
            "long": 99.894,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 1808,
        "name_th": "เนินขาม",
        "name_en": "Noen Kham",
        "province_id": 9,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 180801,
            "zip_code": 17130,
            "name_th": "เนินขาม",
            "name_en": "Noen Kham",
            "district_id": 1808,
            "lat": 14.957,
            "long": 99.901,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 180802,
            "zip_code": 17130,
            "name_th": "กะบกเตี้ย",
            "name_en": "Kabok Tia",
            "district_id": 1808,
            "lat": 15.036,
            "long": 99.816,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 180803,
            "zip_code": 17130,
            "name_th": "สุขเดือนห้า",
            "name_en": "Suk Duean Ha",
            "district_id": 1808,
            "lat": 14.968,
            "long": 99.828,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      }
    ]
  },
  {
    "id": 10,
    "name_th": "สระบุรี",
    "name_en": "Saraburi",
    "geography_id": 2,
    "created_at": "2019-08-09T03:33:09.000+07:00",
    "updated_at": "2025-09-20T06:31:26.000+07:00",
    "deleted_at": null,
    "districts": [
      {
        "id": 1901,
        "name_th": "เมืองสระบุรี",
        "name_en": "Mueang Saraburi",
        "province_id": 10,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 190101,
            "zip_code": 18000,
            "name_th": "ปากเพรียว",
            "name_en": "Pak Phriao",
            "district_id": 1901,
            "lat": 14.527,
            "long": 100.915,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 190105,
            "zip_code": 18000,
            "name_th": "ดาวเรือง",
            "name_en": "Dao Rueang",
            "district_id": 1901,
            "lat": 14.563,
            "long": 100.901,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 190106,
            "zip_code": 18000,
            "name_th": "นาโฉง",
            "name_en": "Na Chong",
            "district_id": 1901,
            "lat": 14.529,
            "long": 100.886,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 190107,
            "zip_code": 18000,
            "name_th": "โคกสว่าง",
            "name_en": "Khok Sawang",
            "district_id": 1901,
            "lat": 14.51,
            "long": 100.886,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 190108,
            "zip_code": 18000,
            "name_th": "หนองโน",
            "name_en": "Nong No",
            "district_id": 1901,
            "lat": 14.489,
            "long": 100.861,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 190109,
            "zip_code": 18000,
            "name_th": "หนองยาว",
            "name_en": "Nong Yao",
            "district_id": 1901,
            "lat": 14.472,
            "long": 100.89,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 190110,
            "zip_code": 18000,
            "name_th": "ปากข้าวสาร",
            "name_en": "Pak Khao San",
            "district_id": 1901,
            "lat": 14.49,
            "long": 100.913,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 190111,
            "zip_code": 18000,
            "name_th": "หนองปลาไหล",
            "name_en": "Nong Pla Lai",
            "district_id": 1901,
            "lat": 14.456,
            "long": 100.962,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 190112,
            "zip_code": 18000,
            "name_th": "กุดนกเปล้า",
            "name_en": "Kut Nok Plao",
            "district_id": 1901,
            "lat": 14.502,
            "long": 100.976,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 190113,
            "zip_code": 18000,
            "name_th": "ตลิ่งชัน",
            "name_en": "Taling Chan",
            "district_id": 1901,
            "lat": 14.544,
            "long": 100.956,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 190114,
            "zip_code": 18000,
            "name_th": "ตะกุด",
            "name_en": "Takut",
            "district_id": 1901,
            "lat": 14.553,
            "long": 100.933,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 1902,
        "name_th": "แก่งคอย",
        "name_en": "Kaeng Khoi",
        "province_id": 10,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 190201,
            "zip_code": 18110,
            "name_th": "แก่งคอย",
            "name_en": "Kaeng Khoi",
            "district_id": 1902,
            "lat": 14.586,
            "long": 101.002,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 190202,
            "zip_code": 18260,
            "name_th": "ทับกวาง",
            "name_en": "Thap Kwang",
            "district_id": 1902,
            "lat": 14.605,
            "long": 101.095,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 190203,
            "zip_code": 18110,
            "name_th": "ตาลเดี่ยว",
            "name_en": "Tan Diao",
            "district_id": 1902,
            "lat": 14.552,
            "long": 101.015,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 190204,
            "zip_code": 18110,
            "name_th": "ห้วยแห้ง",
            "name_en": "Huai Haeng",
            "district_id": 1902,
            "lat": 14.477,
            "long": 101.004,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 190205,
            "zip_code": 18110,
            "name_th": "ท่าคล้อ",
            "name_en": "Tha Khlo",
            "district_id": 1902,
            "lat": 14.712,
            "long": 100.993,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 190206,
            "zip_code": 18110,
            "name_th": "หินซ้อน",
            "name_en": "Hin Son",
            "district_id": 1902,
            "lat": 14.753,
            "long": 101.033,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 190207,
            "zip_code": 18110,
            "name_th": "บ้านธาตุ",
            "name_en": "Ban That",
            "district_id": 1902,
            "lat": 14.626,
            "long": 100.997,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 190208,
            "zip_code": 18110,
            "name_th": "บ้านป่า",
            "name_en": "Ban Pa",
            "district_id": 1902,
            "lat": 14.622,
            "long": 101.029,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 190209,
            "zip_code": 18110,
            "name_th": "ท่าตูม",
            "name_en": "Tha Tum",
            "district_id": 1902,
            "lat": 14.662,
            "long": 100.993,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 190210,
            "zip_code": 18110,
            "name_th": "ชะอม",
            "name_en": "Cha-om",
            "district_id": 1902,
            "lat": 14.418,
            "long": 101.134,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 190211,
            "zip_code": 18110,
            "name_th": "สองคอน",
            "name_en": "Song Khon",
            "district_id": 1902,
            "lat": 14.636,
            "long": 100.968,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 190212,
            "zip_code": 18110,
            "name_th": "เตาปูน",
            "name_en": "Tao Pun",
            "district_id": 1902,
            "lat": 14.603,
            "long": 100.956,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 190213,
            "zip_code": 18110,
            "name_th": "ชำผักแพว",
            "name_en": "Cham Phak Phaeo",
            "district_id": 1902,
            "lat": 14.529,
            "long": 101.09,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 190215,
            "zip_code": 18110,
            "name_th": "ท่ามะปราง",
            "name_en": "Tha Maprang",
            "district_id": 1902,
            "lat": 14.483,
            "long": 101.103,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 1903,
        "name_th": "หนองแค",
        "name_en": "Nong Khae",
        "province_id": 10,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 190301,
            "zip_code": 18140,
            "name_th": "หนองแค",
            "name_en": "Nong Khae",
            "district_id": 1903,
            "lat": 14.337,
            "long": 100.869,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 190302,
            "zip_code": 18140,
            "name_th": "กุ่มหัก",
            "name_en": "Kum Hak",
            "district_id": 1903,
            "lat": 14.312,
            "long": 100.863,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 190303,
            "zip_code": 18250,
            "name_th": "คชสิทธิ์",
            "name_en": "Khotchasit",
            "district_id": 1903,
            "lat": 14.391,
            "long": 100.807,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 190304,
            "zip_code": 18250,
            "name_th": "โคกตูม",
            "name_en": "Khok Tum",
            "district_id": 1903,
            "lat": 14.421,
            "long": 100.784,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 190305,
            "zip_code": 18230,
            "name_th": "โคกแย้",
            "name_en": "Khok Yae",
            "district_id": 1903,
            "lat": 14.387,
            "long": 100.928,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 190306,
            "zip_code": 18230,
            "name_th": "บัวลอย",
            "name_en": "Bua Loi",
            "district_id": 1903,
            "lat": 14.404,
            "long": 100.851,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 190307,
            "zip_code": 18140,
            "name_th": "ไผ่ต่ำ",
            "name_en": "Phai Tam",
            "district_id": 1903,
            "lat": 14.326,
            "long": 100.834,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 190308,
            "zip_code": 18250,
            "name_th": "โพนทอง",
            "name_en": "Phon Thong",
            "district_id": 1903,
            "lat": 14.425,
            "long": 100.813,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 190309,
            "zip_code": 18230,
            "name_th": "ห้วยขมิ้น",
            "name_en": "Huai Khamin",
            "district_id": 1903,
            "lat": 14.381,
            "long": 100.871,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 190310,
            "zip_code": 18230,
            "name_th": "ห้วยทราย",
            "name_en": "Huai Sai",
            "district_id": 1903,
            "lat": 14.42,
            "long": 100.933,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 190311,
            "zip_code": 18140,
            "name_th": "หนองไข่น้ำ",
            "name_en": "Nong Khai Nam",
            "district_id": 1903,
            "lat": 14.36,
            "long": 100.878,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 190312,
            "zip_code": 18140,
            "name_th": "หนองแขม",
            "name_en": "Nong Khaem",
            "district_id": 1903,
            "lat": 14.339,
            "long": 100.797,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 190313,
            "zip_code": 18230,
            "name_th": "หนองจิก",
            "name_en": "Nong Chik",
            "district_id": 1903,
            "lat": 14.441,
            "long": 100.866,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 190314,
            "zip_code": 18140,
            "name_th": "หนองจรเข้",
            "name_en": "Nong Chorakhe",
            "district_id": 1903,
            "lat": 14.334,
            "long": 100.907,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 190315,
            "zip_code": 18230,
            "name_th": "หนองนาก",
            "name_en": "Nong Nak",
            "district_id": 1903,
            "lat": 14.444,
            "long": 100.891,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 190316,
            "zip_code": 18140,
            "name_th": "หนองปลาหมอ",
            "name_en": "Nong Pla Mo",
            "district_id": 1903,
            "lat": 14.369,
            "long": 100.845,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 190317,
            "zip_code": 18140,
            "name_th": "หนองปลิง",
            "name_en": "Nong Pling",
            "district_id": 1903,
            "lat": 14.37,
            "long": 100.829,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 190318,
            "zip_code": 18140,
            "name_th": "หนองโรง",
            "name_en": "Nong Rong",
            "district_id": 1903,
            "lat": 14.279,
            "long": 100.865,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 1904,
        "name_th": "วิหารแดง",
        "name_en": "Wihan Daeng",
        "province_id": 10,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 190401,
            "zip_code": 18150,
            "name_th": "หนองหมู",
            "name_en": "Nong Mu",
            "district_id": 1904,
            "lat": 14.288,
            "long": 100.932,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 190402,
            "zip_code": 18150,
            "name_th": "บ้านลำ",
            "name_en": "Ban Lam",
            "district_id": 1904,
            "lat": 14.391,
            "long": 100.979,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 190403,
            "zip_code": 18150,
            "name_th": "คลองเรือ",
            "name_en": "Khlong Ruea",
            "district_id": 1904,
            "lat": 14.366,
            "long": 101.032,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 190404,
            "zip_code": 18150,
            "name_th": "วิหารแดง",
            "name_en": "Wihan Daeng",
            "district_id": 1904,
            "lat": 14.313,
            "long": 100.99,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 190405,
            "zip_code": 18150,
            "name_th": "หนองสรวง",
            "name_en": "Nong Suang",
            "district_id": 1904,
            "lat": 14.34,
            "long": 100.983,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 190406,
            "zip_code": 18150,
            "name_th": "เจริญธรรม",
            "name_en": "Charoen Tham",
            "district_id": 1904,
            "lat": 14.387,
            "long": 101.006,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 1905,
        "name_th": "หนองแซง",
        "name_en": "Nong Saeng",
        "province_id": 10,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 190501,
            "zip_code": 18170,
            "name_th": "หนองแซง",
            "name_en": "Nong Saeng",
            "district_id": 1905,
            "lat": 14.51,
            "long": 100.759,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 190502,
            "zip_code": 18170,
            "name_th": "หนองควายโซ",
            "name_en": "Nong Khwai So",
            "district_id": 1905,
            "lat": 14.487,
            "long": 100.795,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 190503,
            "zip_code": 18170,
            "name_th": "หนองหัวโพ",
            "name_en": "Nong Hua Pho",
            "district_id": 1905,
            "lat": 14.483,
            "long": 100.817,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 190504,
            "zip_code": 18170,
            "name_th": "หนองสีดา",
            "name_en": "Nong Sida",
            "district_id": 1905,
            "lat": 14.515,
            "long": 100.841,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 190505,
            "zip_code": 18170,
            "name_th": "หนองกบ",
            "name_en": "Nong Kop",
            "district_id": 1905,
            "lat": 14.456,
            "long": 100.776,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 190506,
            "zip_code": 18170,
            "name_th": "ไก่เส่า",
            "name_en": "Kai Sao",
            "district_id": 1905,
            "lat": 14.516,
            "long": 100.793,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 190507,
            "zip_code": 18170,
            "name_th": "โคกสะอาด",
            "name_en": "Khok Sa-at",
            "district_id": 1905,
            "lat": 14.456,
            "long": 100.802,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 190508,
            "zip_code": 18170,
            "name_th": "ม่วงหวาน",
            "name_en": "Muang Wan",
            "district_id": 1905,
            "lat": 14.476,
            "long": 100.836,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 190509,
            "zip_code": 18170,
            "name_th": "เขาดิน",
            "name_en": "Khao Din",
            "district_id": 1905,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 1906,
        "name_th": "บ้านหมอ",
        "name_en": "Ban Mo",
        "province_id": 10,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 190601,
            "zip_code": 18130,
            "name_th": "บ้านหมอ",
            "name_en": "Ban Mo",
            "district_id": 1906,
            "lat": 14.616,
            "long": 100.724,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 190602,
            "zip_code": 18130,
            "name_th": "บางโขมด",
            "name_en": "Bang Khamot",
            "district_id": 1906,
            "lat": 14.591,
            "long": 100.742,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 190603,
            "zip_code": 18130,
            "name_th": "สร่างโศก",
            "name_en": "Sang Sok",
            "district_id": 1906,
            "lat": 14.622,
            "long": 100.754,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 190604,
            "zip_code": 18130,
            "name_th": "ตลาดน้อย",
            "name_en": "Talat Noi",
            "district_id": 1906,
            "lat": 14.643,
            "long": 100.716,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 190605,
            "zip_code": 18130,
            "name_th": "หรเทพ",
            "name_en": "Horathep",
            "district_id": 1906,
            "lat": 14.628,
            "long": 100.67,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 190606,
            "zip_code": 18130,
            "name_th": "โคกใหญ่",
            "name_en": "Khok Yai",
            "district_id": 1906,
            "lat": 14.606,
            "long": 100.677,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 190607,
            "zip_code": 18130,
            "name_th": "ไผ่ขวาง",
            "name_en": "Phai Khwang",
            "district_id": 1906,
            "lat": 14.579,
            "long": 100.648,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 190608,
            "zip_code": 18270,
            "name_th": "บ้านครัว",
            "name_en": "Ban Khrua",
            "district_id": 1906,
            "lat": 14.584,
            "long": 100.767,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 190609,
            "zip_code": 18130,
            "name_th": "หนองบัว",
            "name_en": "Nong Bua",
            "district_id": 1906,
            "lat": 14.618,
            "long": 100.774,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 1907,
        "name_th": "ดอนพุด",
        "name_en": "Don Phut",
        "province_id": 10,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 190701,
            "zip_code": 18210,
            "name_th": "ดอนพุด",
            "name_en": "Don Phut",
            "district_id": 1907,
            "lat": 14.596,
            "long": 100.621,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 190702,
            "zip_code": 18210,
            "name_th": "ไผ่หลิ่ว",
            "name_en": "Phai Lio",
            "district_id": 1907,
            "lat": 14.625,
            "long": 100.632,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 190703,
            "zip_code": 18210,
            "name_th": "บ้านหลวง",
            "name_en": "Ban Luang",
            "district_id": 1907,
            "lat": 14.571,
            "long": 100.62,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 190704,
            "zip_code": 18210,
            "name_th": "ดงตะงาว",
            "name_en": "Dong Ta-ngao",
            "district_id": 1907,
            "lat": 14.624,
            "long": 100.599,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 1908,
        "name_th": "หนองโดน",
        "name_en": "Nong Don",
        "province_id": 10,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 190801,
            "zip_code": 18190,
            "name_th": "หนองโดน",
            "name_en": "Nong Don",
            "district_id": 1908,
            "lat": 14.688,
            "long": 100.693,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 190802,
            "zip_code": 18190,
            "name_th": "บ้านกลับ",
            "name_en": "Ban Klap",
            "district_id": 1908,
            "lat": 14.73,
            "long": 100.684,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 190803,
            "zip_code": 18190,
            "name_th": "ดอนทอง",
            "name_en": "Don Thong",
            "district_id": 1908,
            "lat": 14.664,
            "long": 100.654,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 190804,
            "zip_code": 18190,
            "name_th": "บ้านโปร่ง",
            "name_en": "Ban Prong",
            "district_id": 1908,
            "lat": 14.716,
            "long": 100.734,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 1909,
        "name_th": "พระพุทธบาท",
        "name_en": "Phra Phutthabat",
        "province_id": 10,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 190901,
            "zip_code": 18120,
            "name_th": "พระพุทธบาท",
            "name_en": "Phra Phutthabat",
            "district_id": 1909,
            "lat": 14.732,
            "long": 100.782,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 190902,
            "zip_code": 18120,
            "name_th": "ขุนโขลน",
            "name_en": "Khun Khlon",
            "district_id": 1909,
            "lat": 14.713,
            "long": 100.831,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 190903,
            "zip_code": 18120,
            "name_th": "ธารเกษม",
            "name_en": "Than Kasem",
            "district_id": 1909,
            "lat": 14.763,
            "long": 100.812,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 190904,
            "zip_code": 18120,
            "name_th": "นายาว",
            "name_en": "Na Yao",
            "district_id": 1909,
            "lat": 14.768,
            "long": 100.763,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 190905,
            "zip_code": 18120,
            "name_th": "พุคำจาน",
            "name_en": "Phu Kham Chan",
            "district_id": 1909,
            "lat": 14.744,
            "long": 100.847,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 190906,
            "zip_code": 18120,
            "name_th": "เขาวง",
            "name_en": "Khao Wong",
            "district_id": 1909,
            "lat": 14.679,
            "long": 100.83,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 190907,
            "zip_code": 18120,
            "name_th": "ห้วยป่าหวาย",
            "name_en": "Huai Pa Wai",
            "district_id": 1909,
            "lat": 14.638,
            "long": 100.83,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 190908,
            "zip_code": 18120,
            "name_th": "พุกร่าง",
            "name_en": "Phu Krang",
            "district_id": 1909,
            "lat": 14.682,
            "long": 100.784,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 190909,
            "zip_code": 18120,
            "name_th": "หนองแก",
            "name_en": "Nong Kae",
            "district_id": 1909,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 1910,
        "name_th": "เสาไห้",
        "name_en": "Sao Hai",
        "province_id": 10,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 191001,
            "zip_code": 18160,
            "name_th": "เสาไห้",
            "name_en": "Sao Hai",
            "district_id": 1910,
            "lat": 14.538,
            "long": 100.85,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 191002,
            "zip_code": 18160,
            "name_th": "บ้านยาง",
            "name_en": "Ban Yang",
            "district_id": 1910,
            "lat": 14.582,
            "long": 100.816,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 191003,
            "zip_code": 18160,
            "name_th": "หัวปลวก",
            "name_en": "Hua Pluak",
            "district_id": 1910,
            "lat": 14.615,
            "long": 100.844,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 191004,
            "zip_code": 18160,
            "name_th": "งิ้วงาม",
            "name_en": "Ngio Ngam",
            "district_id": 1910,
            "lat": 14.59,
            "long": 100.851,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 191005,
            "zip_code": 18160,
            "name_th": "ศาลารีไทย",
            "name_en": "Sala Ri Thai",
            "district_id": 1910,
            "lat": 14.565,
            "long": 100.848,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 191006,
            "zip_code": 18160,
            "name_th": "ต้นตาล",
            "name_en": "Ton Tan",
            "district_id": 1910,
            "lat": 14.574,
            "long": 100.885,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 191007,
            "zip_code": 18160,
            "name_th": "ท่าช้าง",
            "name_en": "Tha Chang",
            "district_id": 1910,
            "lat": 14.586,
            "long": 100.863,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 191008,
            "zip_code": 18160,
            "name_th": "พระยาทด",
            "name_en": "Phraya Thot",
            "district_id": 1910,
            "lat": 14.572,
            "long": 100.871,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 191009,
            "zip_code": 18160,
            "name_th": "ม่วงงาม",
            "name_en": "Muang Ngam",
            "district_id": 1910,
            "lat": 14.544,
            "long": 100.807,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 191010,
            "zip_code": 18160,
            "name_th": "เริงราง",
            "name_en": "Roeng Rang",
            "district_id": 1910,
            "lat": 14.558,
            "long": 100.786,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 191011,
            "zip_code": 18160,
            "name_th": "เมืองเก่า",
            "name_en": "Mueang Kao",
            "district_id": 1910,
            "lat": 14.54,
            "long": 100.825,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 191012,
            "zip_code": 18160,
            "name_th": "สวนดอกไม้",
            "name_en": "Suan Dok Mai",
            "district_id": 1910,
            "lat": 14.54,
            "long": 100.868,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 1911,
        "name_th": "มวกเหล็ก",
        "name_en": "Muak Lek",
        "province_id": 10,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 191101,
            "zip_code": 18180,
            "name_th": "มวกเหล็ก",
            "name_en": "Muak Lek",
            "district_id": 1911,
            "lat": 14.705,
            "long": 101.151,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 191102,
            "zip_code": 18180,
            "name_th": "มิตรภาพ",
            "name_en": "Mittraphap",
            "district_id": 1911,
            "lat": 14.474,
            "long": 101.213,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 191104,
            "zip_code": 18180,
            "name_th": "หนองย่างเสือ",
            "name_en": "Nong Yang Suea",
            "district_id": 1911,
            "lat": 14.789,
            "long": 101.27,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 191105,
            "zip_code": 18180,
            "name_th": "ลำสมพุง",
            "name_en": "Lam Somphung",
            "district_id": 1911,
            "lat": 15.007,
            "long": 101.381,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 191107,
            "zip_code": 18180,
            "name_th": "ลำพญากลาง",
            "name_en": "Lam Phaya Klang",
            "district_id": 1911,
            "lat": 14.871,
            "long": 101.367,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 191109,
            "zip_code": 18220,
            "name_th": "ซับสนุ่น",
            "name_en": "Sap Sanun",
            "district_id": 1911,
            "lat": 14.932,
            "long": 101.309,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 1912,
        "name_th": "วังม่วง",
        "name_en": "Wang Muang",
        "province_id": 10,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 191201,
            "zip_code": 18220,
            "name_th": "แสลงพัน",
            "name_en": "Salaeng Phan",
            "district_id": 1912,
            "lat": 14.745,
            "long": 101.116,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 191202,
            "zip_code": 18220,
            "name_th": "คำพราน",
            "name_en": "Kham Phran",
            "district_id": 1912,
            "lat": 14.818,
            "long": 101.132,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 191203,
            "zip_code": 18220,
            "name_th": "วังม่วง",
            "name_en": "Wang Muang",
            "district_id": 1912,
            "lat": 14.861,
            "long": 101.151,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 1913,
        "name_th": "เฉลิมพระเกียรติ",
        "name_en": "Chaloem Phra Kiat",
        "province_id": 10,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 191301,
            "zip_code": 18000,
            "name_th": "เขาดินพัฒนา",
            "name_en": "Khao Din Phatthana",
            "district_id": 1913,
            "lat": 14.612,
            "long": 100.906,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 191302,
            "zip_code": 18000,
            "name_th": "บ้านแก้ง",
            "name_en": "Ban Kaeng",
            "district_id": 1913,
            "lat": 14.582,
            "long": 100.936,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 191303,
            "zip_code": 18000,
            "name_th": "ผึ้งรวง",
            "name_en": "Phueng Ruang",
            "district_id": 1913,
            "lat": 14.607,
            "long": 100.931,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 191304,
            "zip_code": 18240,
            "name_th": "พุแค",
            "name_en": "Phu Khae",
            "district_id": 1913,
            "lat": 14.656,
            "long": 100.905,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 191305,
            "zip_code": 18000,
            "name_th": "ห้วยบง",
            "name_en": "Huai Bong",
            "district_id": 1913,
            "lat": 14.626,
            "long": 100.877,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 191306,
            "zip_code": 18240,
            "name_th": "หน้าพระลาน",
            "name_en": "Na Phra Lan",
            "district_id": 1913,
            "lat": 14.713,
            "long": 100.904,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      }
    ]
  },
  {
    "id": 11,
    "name_th": "ชลบุรี",
    "name_en": "Chon Buri",
    "geography_id": 5,
    "created_at": "2019-08-09T03:33:09.000+07:00",
    "updated_at": "2025-09-20T06:31:26.000+07:00",
    "deleted_at": null,
    "districts": [
      {
        "id": 2001,
        "name_th": "เมืองชลบุรี",
        "name_en": "Mueang Chon Buri",
        "province_id": 11,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 200101,
            "zip_code": 20000,
            "name_th": "บางปลาสร้อย",
            "name_en": "Bang Pla Soi",
            "district_id": 2001,
            "lat": 13.364,
            "long": 100.987,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 200102,
            "zip_code": 20000,
            "name_th": "มะขามหย่ง",
            "name_en": "Makham Yong",
            "district_id": 2001,
            "lat": 13.372,
            "long": 100.985,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 200103,
            "zip_code": 20000,
            "name_th": "บ้านโขด",
            "name_en": "Ban Khot",
            "district_id": 2001,
            "lat": 13.376,
            "long": 100.99,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 200104,
            "zip_code": 20000,
            "name_th": "แสนสุข",
            "name_en": "Saen Suk",
            "district_id": 2001,
            "lat": 13.274,
            "long": 100.928,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 200105,
            "zip_code": 20000,
            "name_th": "บ้านสวน",
            "name_en": "Ban Suan",
            "district_id": 2001,
            "lat": 13.347,
            "long": 100.977,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 200106,
            "zip_code": 20000,
            "name_th": "หนองรี",
            "name_en": "Nong Ri",
            "district_id": 2001,
            "lat": 13.307,
            "long": 101.057,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 200107,
            "zip_code": 20000,
            "name_th": "นาป่า",
            "name_en": "Na Pa",
            "district_id": 2001,
            "lat": 13.385,
            "long": 101.03,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 200108,
            "zip_code": 20000,
            "name_th": "หนองข้างคอก",
            "name_en": "Nong Khang Khok",
            "district_id": 2001,
            "lat": 13.305,
            "long": 101.006,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 200109,
            "zip_code": 20000,
            "name_th": "ดอนหัวฬ่อ",
            "name_en": "Don Hua Lo",
            "district_id": 2001,
            "lat": 13.421,
            "long": 101.044,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 200110,
            "zip_code": 20000,
            "name_th": "หนองไม้แดง",
            "name_en": "Nong Mai Daeng",
            "district_id": 2001,
            "lat": 13.406,
            "long": 101.003,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 200111,
            "zip_code": 20000,
            "name_th": "บางทราย",
            "name_en": "Bang Sai",
            "district_id": 2001,
            "lat": 13.393,
            "long": 100.996,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 200112,
            "zip_code": 20000,
            "name_th": "คลองตำหรุ",
            "name_en": "Khlong Tamru",
            "district_id": 2001,
            "lat": 13.441,
            "long": 100.982,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 200113,
            "zip_code": 20130,
            "name_th": "เหมือง",
            "name_en": "Mueang",
            "district_id": 2001,
            "lat": 13.263,
            "long": 100.959,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 200114,
            "zip_code": 20130,
            "name_th": "บ้านปึก",
            "name_en": "Ban Puek",
            "district_id": 2001,
            "lat": 13.302,
            "long": 100.928,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 200115,
            "zip_code": 20000,
            "name_th": "ห้วยกะปิ",
            "name_en": "Huai Kapi",
            "district_id": 2001,
            "lat": 13.304,
            "long": 100.968,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 200116,
            "zip_code": 20130,
            "name_th": "เสม็ด",
            "name_en": "Samet",
            "district_id": 2001,
            "lat": 13.326,
            "long": 100.951,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 200117,
            "zip_code": 20000,
            "name_th": "อ่างศิลา",
            "name_en": "Ang Sila",
            "district_id": 2001,
            "lat": 13.325,
            "long": 100.929,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 200118,
            "zip_code": 20000,
            "name_th": "สำนักบก",
            "name_en": "Samnak Bok",
            "district_id": 2001,
            "lat": 13.368,
            "long": 101.061,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 2002,
        "name_th": "บ้านบึง",
        "name_en": "Ban Bueng",
        "province_id": 11,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 200201,
            "zip_code": 20170,
            "name_th": "บ้านบึง",
            "name_en": "Ban Bueng",
            "district_id": 2002,
            "lat": 13.297,
            "long": 101.107,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 200202,
            "zip_code": 20220,
            "name_th": "คลองกิ่ว",
            "name_en": "Khlong Kio",
            "district_id": 2002,
            "lat": 13.225,
            "long": 101.107,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 200203,
            "zip_code": 20170,
            "name_th": "มาบไผ่",
            "name_en": "Map Phai",
            "district_id": 2002,
            "lat": 13.359,
            "long": 101.093,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 200204,
            "zip_code": 20170,
            "name_th": "หนองซ้ำซาก",
            "name_en": "Nong Samsak",
            "district_id": 2002,
            "lat": 13.33,
            "long": 101.072,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 200205,
            "zip_code": 20170,
            "name_th": "หนองบอนแดง",
            "name_en": "Nong Bon Daeng",
            "district_id": 2002,
            "lat": 13.353,
            "long": 101.159,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 200206,
            "zip_code": 20170,
            "name_th": "หนองชาก",
            "name_en": "Nong Chak",
            "district_id": 2002,
            "lat": 13.298,
            "long": 101.172,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 200207,
            "zip_code": 20220,
            "name_th": "หนองอิรุณ",
            "name_en": "Nong Irun",
            "district_id": 2002,
            "lat": 13.28,
            "long": 101.247,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 200208,
            "zip_code": 20220,
            "name_th": "หนองไผ่แก้ว",
            "name_en": "Nong Phai Kaeo",
            "district_id": 2002,
            "lat": 13.213,
            "long": 101.246,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 2003,
        "name_th": "หนองใหญ่",
        "name_en": "Nong Yai",
        "province_id": 11,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 200301,
            "zip_code": 20190,
            "name_th": "หนองใหญ่",
            "name_en": "Nong Yai",
            "district_id": 2003,
            "lat": 13.153,
            "long": 101.375,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 200302,
            "zip_code": 20190,
            "name_th": "คลองพลู",
            "name_en": "Khlong Phlu",
            "district_id": 2003,
            "lat": 13.115,
            "long": 101.476,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 200303,
            "zip_code": 20190,
            "name_th": "หนองเสือช้าง",
            "name_en": "Nong Suea Chang",
            "district_id": 2003,
            "lat": 13.117,
            "long": 101.283,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 200304,
            "zip_code": 20190,
            "name_th": "ห้างสูง",
            "name_en": "Hang Sung",
            "district_id": 2003,
            "lat": 13.243,
            "long": 101.347,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 200305,
            "zip_code": 20190,
            "name_th": "เขาซก",
            "name_en": "Khao Sok",
            "district_id": 2003,
            "lat": 13.07,
            "long": 101.42,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 2004,
        "name_th": "บางละมุง",
        "name_en": "Bang Lamung",
        "province_id": 11,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 200401,
            "zip_code": 20150,
            "name_th": "บางละมุง",
            "name_en": "Bang Lamung",
            "district_id": 2004,
            "lat": 13.052,
            "long": 100.922,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 200402,
            "zip_code": 20150,
            "name_th": "หนองปรือ",
            "name_en": "Nong Prue",
            "district_id": 2004,
            "lat": 12.92,
            "long": 100.935,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 200403,
            "zip_code": 20150,
            "name_th": "หนองปลาไหล",
            "name_en": "Nong Pla Lai",
            "district_id": 2004,
            "lat": 12.982,
            "long": 100.945,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 200404,
            "zip_code": 20150,
            "name_th": "โป่ง",
            "name_en": "Pong",
            "district_id": 2004,
            "lat": 12.933,
            "long": 100.987,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 200405,
            "zip_code": 20150,
            "name_th": "เขาไม้แก้ว",
            "name_en": "Khao Mai Kaeo",
            "district_id": 2004,
            "lat": 12.951,
            "long": 101.057,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 200406,
            "zip_code": 20150,
            "name_th": "ห้วยใหญ่",
            "name_en": "Huai Yai",
            "district_id": 2004,
            "lat": 12.835,
            "long": 100.985,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 200407,
            "zip_code": 20150,
            "name_th": "ตะเคียนเตี้ย",
            "name_en": "Takhian Tia",
            "district_id": 2004,
            "lat": 13.002,
            "long": 101.015,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 200408,
            "zip_code": 20150,
            "name_th": "นาเกลือ",
            "name_en": "Na Kluea",
            "district_id": 2004,
            "lat": 12.928,
            "long": 100.805,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 2005,
        "name_th": "พานทอง",
        "name_en": "Phan Thong",
        "province_id": 11,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 200501,
            "zip_code": 20160,
            "name_th": "พานทอง",
            "name_en": "Phan Thong",
            "district_id": 2005,
            "lat": 13.461,
            "long": 101.084,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 200502,
            "zip_code": 20160,
            "name_th": "หนองตำลึง",
            "name_en": "Nong Tamlueng",
            "district_id": 2005,
            "lat": 13.408,
            "long": 101.078,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 200503,
            "zip_code": 20160,
            "name_th": "มาบโป่ง",
            "name_en": "Map Pong",
            "district_id": 2005,
            "lat": 13.431,
            "long": 101.121,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 200504,
            "zip_code": 20160,
            "name_th": "หนองกะขะ",
            "name_en": "Nong Kakha",
            "district_id": 2005,
            "lat": 13.431,
            "long": 101.095,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 200505,
            "zip_code": 20160,
            "name_th": "หนองหงษ์",
            "name_en": "Nong Hong",
            "district_id": 2005,
            "lat": 13.389,
            "long": 101.113,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 200506,
            "zip_code": 20160,
            "name_th": "โคกขี้หนอน",
            "name_en": "Khok Khi Non",
            "district_id": 2005,
            "lat": 13.552,
            "long": 101.114,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 200507,
            "zip_code": 20160,
            "name_th": "บ้านเก่า",
            "name_en": "Ban Kao",
            "district_id": 2005,
            "lat": 13.454,
            "long": 101.059,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 200508,
            "zip_code": 20160,
            "name_th": "หน้าประดู่",
            "name_en": "Na Pradu",
            "district_id": 2005,
            "lat": 13.497,
            "long": 101.099,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 200509,
            "zip_code": 20160,
            "name_th": "บางนาง",
            "name_en": "Bang Nang",
            "district_id": 2005,
            "lat": 13.487,
            "long": 101.067,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 200510,
            "zip_code": 20160,
            "name_th": "เกาะลอย",
            "name_en": "Ko Loi",
            "district_id": 2005,
            "lat": 13.519,
            "long": 101.074,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 200511,
            "zip_code": 20160,
            "name_th": "บางหัก",
            "name_en": "Bang Hak",
            "district_id": 2005,
            "lat": 13.544,
            "long": 101.075,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 2006,
        "name_th": "พนัสนิคม",
        "name_en": "Phanat Nikhom",
        "province_id": 11,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 200601,
            "zip_code": 20140,
            "name_th": "พนัสนิคม",
            "name_en": "Phanat Nikhom",
            "district_id": 2006,
            "lat": 13.45,
            "long": 101.18,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 200602,
            "zip_code": 20140,
            "name_th": "หน้าพระธาตุ",
            "name_en": "Na Phra That",
            "district_id": 2006,
            "lat": 13.468,
            "long": 101.147,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 200603,
            "zip_code": 20140,
            "name_th": "วัดหลวง",
            "name_en": "Wat Luang",
            "district_id": 2006,
            "lat": 13.518,
            "long": 101.161,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 200604,
            "zip_code": 20140,
            "name_th": "บ้านเซิด",
            "name_en": "Ban Soet",
            "district_id": 2006,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 200605,
            "zip_code": 20140,
            "name_th": "นาเริก",
            "name_en": "Na Roek",
            "district_id": 2006,
            "lat": 13.405,
            "long": 101.248,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 200606,
            "zip_code": 20140,
            "name_th": "หมอนนาง",
            "name_en": "Mon Nang",
            "district_id": 2006,
            "lat": 13.346,
            "long": 101.257,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 200607,
            "zip_code": 20140,
            "name_th": "สระสี่เหลี่ยม",
            "name_en": "Sa Si Liam",
            "district_id": 2006,
            "lat": 13.554,
            "long": 101.239,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 200608,
            "zip_code": 20140,
            "name_th": "วัดโบสถ์",
            "name_en": "Wat Bot",
            "district_id": 2006,
            "lat": 13.498,
            "long": 101.139,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 200609,
            "zip_code": 20140,
            "name_th": "กุฎโง้ง",
            "name_en": "Kut Ngong",
            "district_id": 2006,
            "lat": 13.444,
            "long": 101.165,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 200610,
            "zip_code": 20140,
            "name_th": "หัวถนน",
            "name_en": "Hua Thanon",
            "district_id": 2006,
            "lat": 13.531,
            "long": 101.265,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 200611,
            "zip_code": 20140,
            "name_th": "ท่าข้าม",
            "name_en": "Tha Kham",
            "district_id": 2006,
            "lat": 13.559,
            "long": 101.177,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 200613,
            "zip_code": 20140,
            "name_th": "หนองปรือ",
            "name_en": "Nong Prue",
            "district_id": 2006,
            "lat": 13.511,
            "long": 101.254,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 200614,
            "zip_code": 20140,
            "name_th": "หนองขยาด",
            "name_en": "Nong Khayat",
            "district_id": 2006,
            "lat": 13.402,
            "long": 101.151,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 200615,
            "zip_code": 20140,
            "name_th": "ทุ่งขวาง",
            "name_en": "Thung Khwang",
            "district_id": 2006,
            "lat": 13.4,
            "long": 101.188,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 200616,
            "zip_code": 20140,
            "name_th": "หนองเหียง",
            "name_en": "Nong Hiang",
            "district_id": 2006,
            "lat": 13.464,
            "long": 101.33,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 200617,
            "zip_code": 20140,
            "name_th": "นาวังหิน",
            "name_en": "Na Wang Hin",
            "district_id": 2006,
            "lat": 13.442,
            "long": 101.251,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 200618,
            "zip_code": 20140,
            "name_th": "บ้านช้าง",
            "name_en": "Ban Chang",
            "district_id": 2006,
            "lat": 13.435,
            "long": 101.213,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 200620,
            "zip_code": 20140,
            "name_th": "โคกเพลาะ",
            "name_en": "Khok Phlo",
            "district_id": 2006,
            "lat": 13.52,
            "long": 101.121,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 200621,
            "zip_code": 20140,
            "name_th": "ไร่หลักทอง",
            "name_en": "Rai Lak Thong",
            "district_id": 2006,
            "lat": 13.484,
            "long": 101.184,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 200622,
            "zip_code": 20140,
            "name_th": "นามะตูม",
            "name_en": "Na Matum",
            "district_id": 2006,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 2007,
        "name_th": "ศรีราชา",
        "name_en": "Si Racha",
        "province_id": 11,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 200701,
            "zip_code": 20110,
            "name_th": "ศรีราชา",
            "name_en": "Si Racha",
            "district_id": 2007,
            "lat": 13.174,
            "long": 100.92,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 200702,
            "zip_code": 20110,
            "name_th": "สุรศักดิ์",
            "name_en": "Surasak",
            "district_id": 2007,
            "lat": 13.16,
            "long": 100.983,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 200703,
            "zip_code": 20230,
            "name_th": "ทุ่งสุขลา",
            "name_en": "Thung Sukhla",
            "district_id": 2007,
            "lat": 13.097,
            "long": 100.912,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 200704,
            "zip_code": 20230,
            "name_th": "บึง",
            "name_en": "Bueng",
            "district_id": 2007,
            "lat": 13.073,
            "long": 101.006,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 200705,
            "zip_code": 20110,
            "name_th": "หนองขาม",
            "name_en": "Nong Kham",
            "district_id": 2007,
            "lat": 13.134,
            "long": 101.038,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 200706,
            "zip_code": 20110,
            "name_th": "เขาคันทรง",
            "name_en": "Khao Khansong",
            "district_id": 2007,
            "lat": 13.129,
            "long": 101.123,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 200707,
            "zip_code": 20110,
            "name_th": "บางพระ",
            "name_en": "Bang Phra",
            "district_id": 2007,
            "lat": 13.223,
            "long": 101.007,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 200708,
            "zip_code": 20230,
            "name_th": "บ่อวิน",
            "name_en": "Bo Win",
            "district_id": 2007,
            "lat": 13.052,
            "long": 101.093,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 2008,
        "name_th": "เกาะสีชัง",
        "name_en": "Ko Sichang",
        "province_id": 11,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 200801,
            "zip_code": 20120,
            "name_th": "ท่าเทววงษ์",
            "name_en": "Tha Tewatong",
            "district_id": 2008,
            "lat": 13.151,
            "long": 100.809,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 2009,
        "name_th": "สัตหีบ",
        "name_en": "Sattahip",
        "province_id": 11,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 200901,
            "zip_code": 20180,
            "name_th": "สัตหีบ",
            "name_en": "Sattahip",
            "district_id": 2009,
            "lat": 12.611,
            "long": 100.889,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 200902,
            "zip_code": 20250,
            "name_th": "นาจอมเทียน",
            "name_en": "Na Chom Thian",
            "district_id": 2009,
            "lat": 12.775,
            "long": 100.94,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 200903,
            "zip_code": 20180,
            "name_th": "พลูตาหลวง",
            "name_en": "Phlu Ta Luang",
            "district_id": 2009,
            "lat": 12.701,
            "long": 100.967,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 200904,
            "zip_code": 20250,
            "name_th": "บางเสร่",
            "name_en": "Bang Sare",
            "district_id": 2009,
            "lat": 12.761,
            "long": 100.844,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 200905,
            "zip_code": 20180,
            "name_th": "แสมสาร",
            "name_en": "Samaesan",
            "district_id": 2009,
            "lat": 12.616,
            "long": 100.918,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 2010,
        "name_th": "บ่อทอง",
        "name_en": "Bo Thong",
        "province_id": 11,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 201001,
            "zip_code": 20270,
            "name_th": "บ่อทอง",
            "name_en": "Bo Thong",
            "district_id": 2010,
            "lat": 13.193,
            "long": 101.504,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 201002,
            "zip_code": 20270,
            "name_th": "วัดสุวรรณ",
            "name_en": "Wat Suwan",
            "district_id": 2010,
            "lat": 13.332,
            "long": 101.419,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 201003,
            "zip_code": 20270,
            "name_th": "บ่อกวางทอง",
            "name_en": "Bo Kwang Thong",
            "district_id": 2010,
            "lat": 13.318,
            "long": 101.308,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 201004,
            "zip_code": 20270,
            "name_th": "ธาตุทอง",
            "name_en": "That Thong",
            "district_id": 2010,
            "lat": 13.259,
            "long": 101.389,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 201005,
            "zip_code": 20270,
            "name_th": "เกษตรสุวรรณ",
            "name_en": "Kaset Suwan",
            "district_id": 2010,
            "lat": 13.326,
            "long": 101.526,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 201006,
            "zip_code": 20270,
            "name_th": "พลวงทอง",
            "name_en": "Phluang Thong",
            "district_id": 2010,
            "lat": 13.217,
            "long": 101.626,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 2011,
        "name_th": "เกาะจันทร์",
        "name_en": "Ko Chan",
        "province_id": 11,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 201101,
            "zip_code": 20240,
            "name_th": "เกาะจันทร์",
            "name_en": "Ko Chan",
            "district_id": 2011,
            "lat": 13.403,
            "long": 101.421,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 201102,
            "zip_code": 20240,
            "name_th": "ท่าบุญมี",
            "name_en": "Tha Bun Mi",
            "district_id": 2011,
            "lat": 13.389,
            "long": 101.288,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      }
    ]
  },
  {
    "id": 12,
    "name_th": "ระยอง",
    "name_en": "Rayong",
    "geography_id": 5,
    "created_at": "2019-08-09T03:33:09.000+07:00",
    "updated_at": "2025-09-20T06:31:26.000+07:00",
    "deleted_at": null,
    "districts": [
      {
        "id": 2101,
        "name_th": "เมืองระยอง",
        "name_en": "Mueang Rayong",
        "province_id": 12,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 210101,
            "zip_code": 21000,
            "name_th": "ท่าประดู่",
            "name_en": "Tha Pradu",
            "district_id": 2101,
            "lat": 12.672,
            "long": 101.266,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 210102,
            "zip_code": 21000,
            "name_th": "เชิงเนิน",
            "name_en": "Choeng Noen",
            "district_id": 2101,
            "lat": 12.677,
            "long": 101.318,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 210103,
            "zip_code": 21000,
            "name_th": "ตะพง",
            "name_en": "Taphong",
            "district_id": 2101,
            "lat": 12.653,
            "long": 101.364,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 210104,
            "zip_code": 21000,
            "name_th": "ปากน้ำ",
            "name_en": "Pak Nam",
            "district_id": 2101,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 210105,
            "zip_code": 21160,
            "name_th": "เพ",
            "name_en": "Phe",
            "district_id": 2101,
            "lat": 12.568,
            "long": 101.455,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 210106,
            "zip_code": 21160,
            "name_th": "แกลง",
            "name_en": "Klaeng",
            "district_id": 2101,
            "lat": 12.663,
            "long": 101.467,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 210107,
            "zip_code": 21000,
            "name_th": "บ้านแลง",
            "name_en": "Ban Laeng",
            "district_id": 2101,
            "lat": 12.707,
            "long": 101.377,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 210108,
            "zip_code": 21000,
            "name_th": "นาตาขวัญ",
            "name_en": "Na Ta Khwan",
            "district_id": 2101,
            "lat": 12.741,
            "long": 101.369,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 210109,
            "zip_code": 21000,
            "name_th": "เนินพระ",
            "name_en": "Noen Phra",
            "district_id": 2101,
            "lat": 12.681,
            "long": 101.223,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 210110,
            "zip_code": 21100,
            "name_th": "กะเฉด",
            "name_en": "Kachet",
            "district_id": 2101,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 210111,
            "zip_code": 21000,
            "name_th": "ทับมา",
            "name_en": "Thap Ma",
            "district_id": 2101,
            "lat": 12.708,
            "long": 101.247,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 210112,
            "zip_code": 21000,
            "name_th": "น้ำคอก",
            "name_en": "Nam Khok",
            "district_id": 2101,
            "lat": 12.716,
            "long": 101.269,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 210113,
            "zip_code": 21150,
            "name_th": "ห้วยโป่ง",
            "name_en": "Huai Pong",
            "district_id": 2101,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 210114,
            "zip_code": 21150,
            "name_th": "มาบตาพุด",
            "name_en": "Map Ta Phut",
            "district_id": 2101,
            "lat": 12.646,
            "long": 101.171,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 210115,
            "zip_code": 21100,
            "name_th": "สำนักทอง",
            "name_en": "Samnak Thong",
            "district_id": 2101,
            "lat": 12.721,
            "long": 101.472,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 2102,
        "name_th": "บ้านฉาง",
        "name_en": "Ban Chang",
        "province_id": 12,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 210201,
            "zip_code": 21130,
            "name_th": "สำนักท้อน",
            "name_en": "Samnak Thon",
            "district_id": 2102,
            "lat": 12.804,
            "long": 101.066,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 210202,
            "zip_code": 21130,
            "name_th": "พลา",
            "name_en": "Phla",
            "district_id": 2102,
            "lat": 12.688,
            "long": 101.025,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 210203,
            "zip_code": 21130,
            "name_th": "บ้านฉาง",
            "name_en": "Ban Chang",
            "district_id": 2102,
            "lat": 12.732,
            "long": 101.076,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 2103,
        "name_th": "แกลง",
        "name_en": "Klaeng",
        "province_id": 12,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 210301,
            "zip_code": 21110,
            "name_th": "ทางเกวียน",
            "name_en": "Thang Kwian",
            "district_id": 2103,
            "lat": 12.807,
            "long": 101.625,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 210302,
            "zip_code": 21110,
            "name_th": "วังหว้า",
            "name_en": "Wang Wa",
            "district_id": 2103,
            "lat": 12.763,
            "long": 101.624,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 210303,
            "zip_code": 21110,
            "name_th": "ชากโดน",
            "name_en": "Chak Don",
            "district_id": 2103,
            "lat": 12.7,
            "long": 101.604,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 210304,
            "zip_code": 21110,
            "name_th": "เนินฆ้อ",
            "name_en": "Noen Kho",
            "district_id": 2103,
            "lat": 12.704,
            "long": 101.678,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 210305,
            "zip_code": 21190,
            "name_th": "กร่ำ",
            "name_en": "Kram",
            "district_id": 2103,
            "lat": 12.584,
            "long": 101.51,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 210306,
            "zip_code": 21190,
            "name_th": "ชากพง",
            "name_en": "Chak Phong",
            "district_id": 2103,
            "lat": 12.668,
            "long": 101.549,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 210307,
            "zip_code": 21110,
            "name_th": "กระแสบน",
            "name_en": "Krasae Bon",
            "district_id": 2103,
            "lat": 12.871,
            "long": 101.611,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 210308,
            "zip_code": 21110,
            "name_th": "บ้านนา",
            "name_en": "Ban Na",
            "district_id": 2103,
            "lat": 12.846,
            "long": 101.674,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 210309,
            "zip_code": 21110,
            "name_th": "ทุ่งควายกิน",
            "name_en": "Thung Khwai Kin",
            "district_id": 2103,
            "lat": 12.808,
            "long": 101.733,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 210310,
            "zip_code": 22160,
            "name_th": "กองดิน",
            "name_en": "Kong Din",
            "district_id": 2103,
            "lat": 12.815,
            "long": 101.792,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 210311,
            "zip_code": 21170,
            "name_th": "คลองปูน",
            "name_en": "Khlong Pun",
            "district_id": 2103,
            "lat": 12.765,
            "long": 101.75,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 210312,
            "zip_code": 21110,
            "name_th": "พังราด",
            "name_en": "Phang Rat",
            "district_id": 2103,
            "lat": 12.729,
            "long": 101.772,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 210313,
            "zip_code": 21170,
            "name_th": "ปากน้ำกระแส",
            "name_en": "Pak Nam Krasae",
            "district_id": 2103,
            "lat": 12.717,
            "long": 101.709,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 210317,
            "zip_code": 21110,
            "name_th": "ห้วยยาง",
            "name_en": "Huai Yang",
            "district_id": 2103,
            "lat": 12.812,
            "long": 101.533,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 210318,
            "zip_code": 21110,
            "name_th": "สองสลึง",
            "name_en": "Song Salueng",
            "district_id": 2103,
            "lat": 12.743,
            "long": 101.548,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 2104,
        "name_th": "วังจันทร์",
        "name_en": "Wang Chan",
        "province_id": 12,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 210401,
            "zip_code": 21210,
            "name_th": "วังจันทร์",
            "name_en": "Wang Chan",
            "district_id": 2104,
            "lat": 12.858,
            "long": 101.528,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 210402,
            "zip_code": 21210,
            "name_th": "ชุมแสง",
            "name_en": "Chum Saeng",
            "district_id": 2104,
            "lat": 12.956,
            "long": 101.526,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 210403,
            "zip_code": 21210,
            "name_th": "ป่ายุบใน",
            "name_en": "Pa Yup Nai",
            "district_id": 2104,
            "lat": 13.005,
            "long": 101.479,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 210404,
            "zip_code": 21210,
            "name_th": "พลงตาเอี่ยม",
            "name_en": "Phlong Ta Iam",
            "district_id": 2104,
            "lat": 12.912,
            "long": 101.541,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 2105,
        "name_th": "บ้านค่าย",
        "name_en": "Ban Khai",
        "province_id": 12,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 210501,
            "zip_code": 21120,
            "name_th": "บ้านค่าย",
            "name_en": "Ban Khai",
            "district_id": 2105,
            "lat": 12.775,
            "long": 101.304,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 210502,
            "zip_code": 21120,
            "name_th": "หนองละลอก",
            "name_en": "Nong Lalok",
            "district_id": 2105,
            "lat": 12.821,
            "long": 101.256,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 210503,
            "zip_code": 21120,
            "name_th": "หนองตะพาน",
            "name_en": "Nong Taphan",
            "district_id": 2105,
            "lat": 12.752,
            "long": 101.258,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 210504,
            "zip_code": 21120,
            "name_th": "ตาขัน",
            "name_en": "Ta Khan",
            "district_id": 2105,
            "lat": 12.735,
            "long": 101.321,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 210505,
            "zip_code": 21120,
            "name_th": "บางบุตร",
            "name_en": "Bang But",
            "district_id": 2105,
            "lat": 12.848,
            "long": 101.391,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 210506,
            "zip_code": 21120,
            "name_th": "หนองบัว",
            "name_en": "Nong Bua",
            "district_id": 2105,
            "lat": 12.906,
            "long": 101.373,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 210507,
            "zip_code": 21120,
            "name_th": "ชากบก",
            "name_en": "Chak Bok",
            "district_id": 2105,
            "lat": 12.783,
            "long": 101.364,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 2106,
        "name_th": "ปลวกแดง",
        "name_en": "Pluak Daeng",
        "province_id": 12,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 210601,
            "zip_code": 21140,
            "name_th": "ปลวกแดง",
            "name_en": "Pluak Daeng",
            "district_id": 2106,
            "lat": 12.978,
            "long": 101.226,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 210602,
            "zip_code": 21140,
            "name_th": "ตาสิทธิ์",
            "name_en": "Ta Sit",
            "district_id": 2106,
            "lat": 13.038,
            "long": 101.225,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 210603,
            "zip_code": 21140,
            "name_th": "ละหาร",
            "name_en": "Lahan",
            "district_id": 2106,
            "lat": 12.973,
            "long": 101.311,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 210604,
            "zip_code": 21140,
            "name_th": "แม่น้ำคู้",
            "name_en": "Maenam Khu",
            "district_id": 2106,
            "lat": 12.908,
            "long": 101.23,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 210605,
            "zip_code": 21140,
            "name_th": "มาบยางพร",
            "name_en": "Map Yang Phon",
            "district_id": 2106,
            "lat": 12.97,
            "long": 101.136,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 210606,
            "zip_code": 21140,
            "name_th": "หนองไร่",
            "name_en": "Nong Rai",
            "district_id": 2106,
            "lat": 13.039,
            "long": 101.338,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 2107,
        "name_th": "เขาชะเมา",
        "name_en": "Khao Chamao",
        "province_id": 12,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 210701,
            "zip_code": 21110,
            "name_th": "น้ำเป็น",
            "name_en": "Nam Pen",
            "district_id": 2107,
            "lat": 12.901,
            "long": 101.749,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 210702,
            "zip_code": 21110,
            "name_th": "ห้วยทับมอญ",
            "name_en": "Huai Thap Mon",
            "district_id": 2107,
            "lat": 13.027,
            "long": 101.686,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 210703,
            "zip_code": 21110,
            "name_th": "ชำฆ้อ",
            "name_en": "Cham Kho",
            "district_id": 2107,
            "lat": 12.933,
            "long": 101.641,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 210704,
            "zip_code": 21110,
            "name_th": "เขาน้อย",
            "name_en": "Khao Noy",
            "district_id": 2107,
            "lat": 13.062,
            "long": 101.617,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 2108,
        "name_th": "นิคมพัฒนา",
        "name_en": "Nikhom Phatthana",
        "province_id": 12,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 210801,
            "zip_code": 21180,
            "name_th": "นิคมพัฒนา",
            "name_en": "Nikhom Phatthana",
            "district_id": 2108,
            "lat": 12.856,
            "long": 101.177,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 210802,
            "zip_code": 21180,
            "name_th": "มาบข่า",
            "name_en": "Map Kha",
            "district_id": 2108,
            "lat": 12.782,
            "long": 101.193,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 210803,
            "zip_code": 21180,
            "name_th": "พนานิคม",
            "name_en": "Phana Nikhom",
            "district_id": 2108,
            "lat": 12.902,
            "long": 101.135,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 210804,
            "zip_code": 21180,
            "name_th": "มะขามคู่",
            "name_en": "Makham Khu",
            "district_id": 2108,
            "lat": 12.847,
            "long": 101.101,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      }
    ]
  },
  {
    "id": 13,
    "name_th": "จันทบุรี",
    "name_en": "Chanthaburi",
    "geography_id": 5,
    "created_at": "2019-08-09T03:33:09.000+07:00",
    "updated_at": "2025-09-20T06:31:26.000+07:00",
    "deleted_at": null,
    "districts": [
      {
        "id": 2201,
        "name_th": "เมืองจันทบุรี",
        "name_en": "Mueang Chanthaburi",
        "province_id": 13,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 220101,
            "zip_code": 22000,
            "name_th": "ตลาด",
            "name_en": "Talat",
            "district_id": 2201,
            "lat": 12.591,
            "long": 102.087,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 220102,
            "zip_code": 22000,
            "name_th": "วัดใหม่",
            "name_en": "Wat Mai",
            "district_id": 2201,
            "lat": 12.611,
            "long": 102.105,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 220103,
            "zip_code": 22000,
            "name_th": "คลองนารายณ์",
            "name_en": "Khlong Narai",
            "district_id": 2201,
            "lat": 12.574,
            "long": 102.166,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 220104,
            "zip_code": 22000,
            "name_th": "เกาะขวาง",
            "name_en": "Ko Khwang",
            "district_id": 2201,
            "lat": 12.562,
            "long": 102.09,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 220105,
            "zip_code": 22000,
            "name_th": "คมบาง",
            "name_en": "Khom Bang",
            "district_id": 2201,
            "lat": 12.542,
            "long": 102.169,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 220106,
            "zip_code": 22000,
            "name_th": "ท่าช้าง",
            "name_en": "Tha Chang",
            "district_id": 2201,
            "lat": 12.644,
            "long": 102.098,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 220107,
            "zip_code": 22000,
            "name_th": "จันทนิมิต",
            "name_en": "Chanthanimit",
            "district_id": 2201,
            "lat": 12.61,
            "long": 102.123,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 220108,
            "zip_code": 22000,
            "name_th": "บางกะจะ",
            "name_en": "Bang Kacha",
            "district_id": 2201,
            "lat": 12.563,
            "long": 102.056,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 220109,
            "zip_code": 22000,
            "name_th": "แสลง",
            "name_en": "Salaeng",
            "district_id": 2201,
            "lat": 12.694,
            "long": 102.107,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 220110,
            "zip_code": 22000,
            "name_th": "หนองบัว",
            "name_en": "Nong Bua",
            "district_id": 2201,
            "lat": 12.534,
            "long": 102.101,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 220111,
            "zip_code": 22000,
            "name_th": "พลับพลา",
            "name_en": "Phlapphla",
            "district_id": 2201,
            "lat": 12.605,
            "long": 102.172,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 2202,
        "name_th": "ขลุง",
        "name_en": "Khlung",
        "province_id": 13,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 220201,
            "zip_code": 22110,
            "name_th": "ขลุง",
            "name_en": "Khlung",
            "district_id": 2202,
            "lat": 12.452,
            "long": 102.218,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 220202,
            "zip_code": 22110,
            "name_th": "บ่อ",
            "name_en": "Bo",
            "district_id": 2202,
            "lat": 12.412,
            "long": 102.279,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 220203,
            "zip_code": 22110,
            "name_th": "เกวียนหัก",
            "name_en": "Kwian Hak",
            "district_id": 2202,
            "lat": 12.468,
            "long": 102.2,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 220204,
            "zip_code": 22110,
            "name_th": "ตะปอน",
            "name_en": "Tapon",
            "district_id": 2202,
            "lat": 12.493,
            "long": 102.175,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 220205,
            "zip_code": 22110,
            "name_th": "บางชัน",
            "name_en": "Bang Chan",
            "district_id": 2202,
            "lat": 12.288,
            "long": 102.251,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 220206,
            "zip_code": 22110,
            "name_th": "วันยาว",
            "name_en": "Wan Yao",
            "district_id": 2202,
            "lat": 12.439,
            "long": 102.234,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 220207,
            "zip_code": 22110,
            "name_th": "ซึ้ง",
            "name_en": "Sueng",
            "district_id": 2202,
            "lat": 12.487,
            "long": 102.288,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 220208,
            "zip_code": 22110,
            "name_th": "มาบไพ",
            "name_en": "Map Phai",
            "district_id": 2202,
            "lat": 12.598,
            "long": 102.258,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 220209,
            "zip_code": 22110,
            "name_th": "วังสรรพรส",
            "name_en": "Wang Sappharot",
            "district_id": 2202,
            "lat": 12.56,
            "long": 102.29,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 220210,
            "zip_code": 22110,
            "name_th": "ตรอกนอง",
            "name_en": "Trok Nong",
            "district_id": 2202,
            "lat": 12.533,
            "long": 102.275,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 220211,
            "zip_code": 22110,
            "name_th": "ตกพรม",
            "name_en": "Tok Phrom",
            "district_id": 2202,
            "lat": 12.625,
            "long": 102.339,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 220212,
            "zip_code": 22150,
            "name_th": "บ่อเวฬุ",
            "name_en": "Bo Welu",
            "district_id": 2202,
            "lat": 12.723,
            "long": 102.367,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 2203,
        "name_th": "ท่าใหม่",
        "name_en": "Tha Mai",
        "province_id": 13,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 220301,
            "zip_code": 22120,
            "name_th": "ท่าใหม่",
            "name_en": "Tha Mai",
            "district_id": 2203,
            "lat": 12.628,
            "long": 101.985,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 220302,
            "zip_code": 22120,
            "name_th": "ยายร้า",
            "name_en": "Yai Ra",
            "district_id": 2203,
            "lat": 12.612,
            "long": 102.027,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 220303,
            "zip_code": 22120,
            "name_th": "สีพยา",
            "name_en": "Si Phaya",
            "district_id": 2203,
            "lat": 12.578,
            "long": 102.029,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 220304,
            "zip_code": 22120,
            "name_th": "บ่อพุ",
            "name_en": "Bo Phu",
            "district_id": 2203,
            "lat": 12.595,
            "long": 102.028,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 220305,
            "zip_code": 22120,
            "name_th": "พลอยแหวน",
            "name_en": "Phloi Waen",
            "district_id": 2203,
            "lat": 12.617,
            "long": 102.053,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 220306,
            "zip_code": 22120,
            "name_th": "เขาวัว",
            "name_en": "Khao Wua",
            "district_id": 2203,
            "lat": 12.637,
            "long": 102.035,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 220307,
            "zip_code": 22120,
            "name_th": "เขาบายศรี",
            "name_en": "Khao Baisi",
            "district_id": 2203,
            "lat": 12.74,
            "long": 102.061,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 220308,
            "zip_code": 22120,
            "name_th": "สองพี่น้อง",
            "name_en": "Song Phi Nong",
            "district_id": 2203,
            "lat": 12.672,
            "long": 101.973,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 220309,
            "zip_code": 22170,
            "name_th": "ทุ่งเบญจา",
            "name_en": "Ramphan",
            "district_id": 2203,
            "lat": 12.814,
            "long": 102.014,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 220311,
            "zip_code": 22170,
            "name_th": "รำพัน",
            "name_en": "Ramphan",
            "district_id": 2203,
            "lat": 12.669,
            "long": 101.914,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 220312,
            "zip_code": 22170,
            "name_th": "โขมง",
            "name_en": "Khamong",
            "district_id": 2203,
            "lat": 12.62,
            "long": 101.94,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 220313,
            "zip_code": 22120,
            "name_th": "ตะกาดเง้า",
            "name_en": "Takat Ngao",
            "district_id": 2203,
            "lat": 12.581,
            "long": 101.989,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 220314,
            "zip_code": 22120,
            "name_th": "คลองขุด",
            "name_en": "Khlong Khut",
            "district_id": 2203,
            "lat": 12.512,
            "long": 101.95,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 220324,
            "zip_code": 22170,
            "name_th": "เขาแก้ว",
            "name_en": "Khao Kaeo",
            "district_id": 2203,
            "lat": 12.867,
            "long": 101.939,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 2204,
        "name_th": "โป่งน้ำร้อน",
        "name_en": "Pong Nam Ron",
        "province_id": 13,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 220401,
            "zip_code": 22140,
            "name_th": "ทับไทร",
            "name_en": "Thap Sai",
            "district_id": 2204,
            "lat": 12.95,
            "long": 102.247,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 220402,
            "zip_code": 22140,
            "name_th": "โป่งน้ำร้อน",
            "name_en": "Pong Nam Ron",
            "district_id": 2204,
            "lat": 12.89,
            "long": 102.382,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 220404,
            "zip_code": 22140,
            "name_th": "หนองตาคง",
            "name_en": "Nong Ta Khong",
            "district_id": 2204,
            "lat": 13.067,
            "long": 102.381,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 220409,
            "zip_code": 22140,
            "name_th": "เทพนิมิต",
            "name_en": "Thep Nimit",
            "district_id": 2204,
            "lat": 13.044,
            "long": 102.453,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 220410,
            "zip_code": 22140,
            "name_th": "คลองใหญ่",
            "name_en": "Khlong Yai",
            "district_id": 2204,
            "lat": 12.873,
            "long": 102.476,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 2205,
        "name_th": "มะขาม",
        "name_en": "Makham",
        "province_id": 13,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 220501,
            "zip_code": 22150,
            "name_th": "มะขาม",
            "name_en": "Makham",
            "district_id": 2205,
            "lat": 12.677,
            "long": 102.187,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 220502,
            "zip_code": 22150,
            "name_th": "ท่าหลวง",
            "name_en": "Tha Luang",
            "district_id": 2205,
            "lat": 12.7,
            "long": 102.147,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 220503,
            "zip_code": 22150,
            "name_th": "ปัถวี",
            "name_en": "Patthawi",
            "district_id": 2205,
            "lat": 12.743,
            "long": 102.272,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 220504,
            "zip_code": 22150,
            "name_th": "วังแซ้ม",
            "name_en": "Wang Saem",
            "district_id": 2205,
            "lat": 12.756,
            "long": 102.156,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 220506,
            "zip_code": 22150,
            "name_th": "ฉมัน",
            "name_en": "Chaman",
            "district_id": 2205,
            "lat": 12.817,
            "long": 102.224,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 220508,
            "zip_code": 22150,
            "name_th": "อ่างคีรี",
            "name_en": "Ang Khiri",
            "district_id": 2205,
            "lat": 12.644,
            "long": 102.226,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 2206,
        "name_th": "แหลมสิงห์",
        "name_en": "Laem Sing",
        "province_id": 13,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 220601,
            "zip_code": 22130,
            "name_th": "ปากน้ำแหลมสิงห์",
            "name_en": "Pak Nam Laem Sing",
            "district_id": 2206,
            "lat": 12.452,
            "long": 102.122,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 220602,
            "zip_code": 22130,
            "name_th": "เกาะเปริด",
            "name_en": "Ko Proet",
            "district_id": 2206,
            "lat": 12.424,
            "long": 102.109,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 220603,
            "zip_code": 22130,
            "name_th": "หนองชิ่ม",
            "name_en": "Nong Chim",
            "district_id": 2206,
            "lat": 12.417,
            "long": 102.178,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 220604,
            "zip_code": 22190,
            "name_th": "พลิ้ว",
            "name_en": "Phlio",
            "district_id": 2206,
            "lat": 12.516,
            "long": 102.161,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 220605,
            "zip_code": 22190,
            "name_th": "คลองน้ำเค็ม",
            "name_en": "Khlong Nam Khem",
            "district_id": 2206,
            "lat": 12.498,
            "long": 102.123,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 220606,
            "zip_code": 22190,
            "name_th": "บางสระเก้า",
            "name_en": "Bang Sa Kao",
            "district_id": 2206,
            "lat": 12.511,
            "long": 102.109,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 220607,
            "zip_code": 22120,
            "name_th": "บางกะไชย",
            "name_en": "Bang Kachai",
            "district_id": 2206,
            "lat": 12.465,
            "long": 102.066,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 2207,
        "name_th": "สอยดาว",
        "name_en": "Soi Dao",
        "province_id": 13,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 220701,
            "zip_code": 22180,
            "name_th": "ปะตง",
            "name_en": "Patong",
            "district_id": 2207,
            "lat": 13.17,
            "long": 102.194,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 220702,
            "zip_code": 22180,
            "name_th": "ทุ่งขนาน",
            "name_en": "Thung Khanan",
            "district_id": 2207,
            "lat": 13.232,
            "long": 102.319,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 220703,
            "zip_code": 22180,
            "name_th": "ทับช้าง",
            "name_en": "Thap Chang",
            "district_id": 2207,
            "lat": 13.265,
            "long": 102.161,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 220704,
            "zip_code": 22180,
            "name_th": "ทรายขาว",
            "name_en": "Sai Khao",
            "district_id": 2207,
            "lat": 13.086,
            "long": 102.197,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 220705,
            "zip_code": 22180,
            "name_th": "สะตอน",
            "name_en": "Saton",
            "district_id": 2207,
            "lat": 13.174,
            "long": 102.371,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 2208,
        "name_th": "แก่งหางแมว",
        "name_en": "Kaeng Hang Maeo",
        "province_id": 13,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 220801,
            "zip_code": 22160,
            "name_th": "แก่งหางแมว",
            "name_en": "Kaeng Hang Maeo",
            "district_id": 2208,
            "lat": 12.982,
            "long": 101.929,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 220802,
            "zip_code": 22160,
            "name_th": "ขุนซ่อง",
            "name_en": "Khun Song",
            "district_id": 2208,
            "lat": 13.169,
            "long": 101.961,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 220803,
            "zip_code": 22160,
            "name_th": "สามพี่น้อง",
            "name_en": "Sam Phi Nong",
            "district_id": 2208,
            "lat": 12.977,
            "long": 101.817,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 220804,
            "zip_code": 22160,
            "name_th": "พวา",
            "name_en": "Phawa",
            "district_id": 2208,
            "lat": 13.105,
            "long": 101.791,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 220805,
            "zip_code": 22160,
            "name_th": "เขาวงกต",
            "name_en": "Khao Wongkot",
            "district_id": 2208,
            "lat": 12.881,
            "long": 101.848,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 2209,
        "name_th": "นายายอาม",
        "name_en": "Na Yai Am",
        "province_id": 13,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 220901,
            "zip_code": 22160,
            "name_th": "นายายอาม",
            "name_en": "Na Yai Am",
            "district_id": 2209,
            "lat": 12.782,
            "long": 101.847,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 220902,
            "zip_code": 22170,
            "name_th": "วังโตนด",
            "name_en": "Wang Tanot",
            "district_id": 2209,
            "lat": 12.701,
            "long": 101.933,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 220903,
            "zip_code": 22170,
            "name_th": "กระแจะ",
            "name_en": "Krachae",
            "district_id": 2209,
            "lat": 12.689,
            "long": 101.861,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 220904,
            "zip_code": 22170,
            "name_th": "สนามไชย",
            "name_en": "Sanam Chai",
            "district_id": 2209,
            "lat": 12.625,
            "long": 101.874,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 220905,
            "zip_code": 22160,
            "name_th": "ช้างข้าม",
            "name_en": "Chang Kham",
            "district_id": 2209,
            "lat": 12.707,
            "long": 101.819,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 220906,
            "zip_code": 22170,
            "name_th": "วังใหม่",
            "name_en": "Wang Mai",
            "district_id": 2209,
            "lat": 12.764,
            "long": 101.904,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 2210,
        "name_th": "เขาคิชฌกูฏ",
        "name_en": "Khoa Khitchakut",
        "province_id": 13,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 221001,
            "zip_code": 22210,
            "name_th": "ชากไทย",
            "name_en": "Chak Thai",
            "district_id": 2210,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 221002,
            "zip_code": 22210,
            "name_th": "พลวง",
            "name_en": "Phluang",
            "district_id": 2210,
            "lat": 12.822,
            "long": 102.106,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 221003,
            "zip_code": 22210,
            "name_th": "ตะเคียนทอง",
            "name_en": "Takhian Thong",
            "district_id": 2210,
            "lat": 12.903,
            "long": 102.132,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 221004,
            "zip_code": 22210,
            "name_th": "คลองพลู",
            "name_en": "Khlong Phlu",
            "district_id": 2210,
            "lat": 12.931,
            "long": 102.014,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 221005,
            "zip_code": 22210,
            "name_th": "จันทเขลม",
            "name_en": "Chanthakhlem",
            "district_id": 2210,
            "lat": 13.071,
            "long": 102.09,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      }
    ]
  },
  {
    "id": 14,
    "name_th": "ตราด",
    "name_en": "Trat",
    "geography_id": 5,
    "created_at": "2019-08-09T03:33:09.000+07:00",
    "updated_at": "2025-09-20T06:31:26.000+07:00",
    "deleted_at": null,
    "districts": [
      {
        "id": 2301,
        "name_th": "เมืองตราด",
        "name_en": "Mueang Trat",
        "province_id": 14,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 230101,
            "zip_code": 23000,
            "name_th": "บางพระ",
            "name_en": "Bang Phra",
            "district_id": 2301,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 230102,
            "zip_code": 23000,
            "name_th": "หนองเสม็ด",
            "name_en": "Nong Samet",
            "district_id": 2301,
            "lat": 12.216,
            "long": 102.504,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 230103,
            "zip_code": 23000,
            "name_th": "หนองโสน",
            "name_en": "Nong Sano",
            "district_id": 2301,
            "lat": 12.184,
            "long": 102.488,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 230104,
            "zip_code": 23000,
            "name_th": "หนองคันทรง",
            "name_en": "Nong Khan Song",
            "district_id": 2301,
            "lat": 12.194,
            "long": 102.542,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 230105,
            "zip_code": 23000,
            "name_th": "ห้วงน้ำขาว",
            "name_en": "Huang Nam Khao",
            "district_id": 2301,
            "lat": 12.143,
            "long": 102.518,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 230106,
            "zip_code": 23000,
            "name_th": "อ่าวใหญ่",
            "name_en": "Ao Yai",
            "district_id": 2301,
            "lat": 12.078,
            "long": 102.562,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 230107,
            "zip_code": 23000,
            "name_th": "วังกระแจะ",
            "name_en": "Wang Krachae",
            "district_id": 2301,
            "lat": 12.272,
            "long": 102.479,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 230108,
            "zip_code": 23000,
            "name_th": "ห้วยแร้ง",
            "name_en": "Huai Raeng",
            "district_id": 2301,
            "lat": 12.387,
            "long": 102.56,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 230109,
            "zip_code": 23000,
            "name_th": "เนินทราย",
            "name_en": "Noen Sai",
            "district_id": 2301,
            "lat": 12.283,
            "long": 102.547,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 230110,
            "zip_code": 23000,
            "name_th": "ท่าพริก",
            "name_en": "Tha Phrik",
            "district_id": 2301,
            "lat": 12.243,
            "long": 102.589,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 230111,
            "zip_code": 23000,
            "name_th": "ท่ากุ่ม",
            "name_en": "Tha Kum",
            "district_id": 2301,
            "lat": 12.345,
            "long": 102.675,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 230112,
            "zip_code": 23000,
            "name_th": "ตะกาง",
            "name_en": "Takang",
            "district_id": 2301,
            "lat": 12.25,
            "long": 102.659,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 230113,
            "zip_code": 23000,
            "name_th": "ชำราก",
            "name_en": "Chamrak",
            "district_id": 2301,
            "lat": 12.194,
            "long": 102.677,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 230114,
            "zip_code": 23000,
            "name_th": "แหลมกลัด",
            "name_en": "Laem Klat",
            "district_id": 2301,
            "lat": 12.117,
            "long": 102.704,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 2302,
        "name_th": "คลองใหญ่",
        "name_en": "Khlong Yai",
        "province_id": 14,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 230201,
            "zip_code": 23110,
            "name_th": "คลองใหญ่",
            "name_en": "Khlong Yai",
            "district_id": 2302,
            "lat": 11.774,
            "long": 102.889,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 230202,
            "zip_code": 23110,
            "name_th": "ไม้รูด",
            "name_en": "Mai Rut",
            "district_id": 2302,
            "lat": 11.91,
            "long": 102.805,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 230203,
            "zip_code": 23110,
            "name_th": "หาดเล็ก",
            "name_en": "Hat Lek",
            "district_id": 2302,
            "lat": 11.699,
            "long": 102.909,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 2303,
        "name_th": "เขาสมิง",
        "name_en": "Khao Saming",
        "province_id": 14,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 230301,
            "zip_code": 23130,
            "name_th": "เขาสมิง",
            "name_en": "Khao Saming",
            "district_id": 2303,
            "lat": 12.34,
            "long": 102.437,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 230302,
            "zip_code": 23150,
            "name_th": "แสนตุ้ง",
            "name_en": "Saen Tung",
            "district_id": 2303,
            "lat": 12.398,
            "long": 102.382,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 230303,
            "zip_code": 23130,
            "name_th": "วังตะเคียน",
            "name_en": "Wang Takhian",
            "district_id": 2303,
            "lat": 12.478,
            "long": 102.531,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 230304,
            "zip_code": 23150,
            "name_th": "ท่าโสม",
            "name_en": "Tha Som",
            "district_id": 2303,
            "lat": 12.296,
            "long": 102.346,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 230305,
            "zip_code": 23150,
            "name_th": "สะตอ",
            "name_en": "Sato",
            "district_id": 2303,
            "lat": 12.553,
            "long": 102.434,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 230306,
            "zip_code": 23150,
            "name_th": "ประณีต",
            "name_en": "Pranit",
            "district_id": 2303,
            "lat": 12.525,
            "long": 102.359,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 230307,
            "zip_code": 23150,
            "name_th": "เทพนิมิต",
            "name_en": "Thep Nimit",
            "district_id": 2303,
            "lat": 12.469,
            "long": 102.435,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 230308,
            "zip_code": 23130,
            "name_th": "ทุ่งนนทรี",
            "name_en": "Thung Nonsi",
            "district_id": 2303,
            "lat": 12.405,
            "long": 102.501,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 2304,
        "name_th": "บ่อไร่",
        "name_en": "Bo Rai",
        "province_id": 14,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 230401,
            "zip_code": 23140,
            "name_th": "บ่อพลอย",
            "name_en": "Bo Phloi",
            "district_id": 2304,
            "lat": 12.604,
            "long": 102.559,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 230402,
            "zip_code": 23140,
            "name_th": "ช้างทูน",
            "name_en": "Chang Thun",
            "district_id": 2304,
            "lat": 12.585,
            "long": 102.469,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 230403,
            "zip_code": 23140,
            "name_th": "ด่านชุมพล",
            "name_en": "Dan Chumphon",
            "district_id": 2304,
            "lat": 12.461,
            "long": 102.664,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 230404,
            "zip_code": 23140,
            "name_th": "หนองบอน",
            "name_en": "Nong Bon",
            "district_id": 2304,
            "lat": 12.683,
            "long": 102.447,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 230405,
            "zip_code": 23140,
            "name_th": "นนทรีย์",
            "name_en": "Nonsi",
            "district_id": 2304,
            "lat": 12.544,
            "long": 102.6,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 2305,
        "name_th": "แหลมงอบ",
        "name_en": "Laem Ngop",
        "province_id": 14,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 230501,
            "zip_code": 23120,
            "name_th": "แหลมงอบ",
            "name_en": "Laem Ngop",
            "district_id": 2305,
            "lat": 12.186,
            "long": 102.419,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 230502,
            "zip_code": 23120,
            "name_th": "น้ำเชี่ยว",
            "name_en": "Nam Chiao",
            "district_id": 2305,
            "lat": 12.209,
            "long": 102.436,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 230503,
            "zip_code": 23120,
            "name_th": "บางปิด",
            "name_en": "Bang Pit",
            "district_id": 2305,
            "lat": 12.241,
            "long": 102.301,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 230507,
            "zip_code": 23120,
            "name_th": "คลองใหญ่",
            "name_en": "Khlong Yai",
            "district_id": 2305,
            "lat": 12.226,
            "long": 102.362,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 2306,
        "name_th": "เกาะกูด",
        "name_en": "Ko Kut",
        "province_id": 14,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 230601,
            "zip_code": 23000,
            "name_th": "เกาะหมาก",
            "name_en": "Ko Mak",
            "district_id": 2306,
            "lat": 11.817,
            "long": 102.397,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 230602,
            "zip_code": 23000,
            "name_th": "เกาะกูด",
            "name_en": "Ko Kut",
            "district_id": 2306,
            "lat": 11.719,
            "long": 102.519,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 2307,
        "name_th": "เกาะช้าง",
        "name_en": "Ko Chang",
        "province_id": 14,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 230701,
            "zip_code": 23170,
            "name_th": "เกาะช้าง",
            "name_en": "Ko Chang",
            "district_id": 2307,
            "lat": 12.161,
            "long": 102.247,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 230702,
            "zip_code": 23170,
            "name_th": "เกาะช้างใต้",
            "name_en": "Ko Chang Tai",
            "district_id": 2307,
            "lat": 11.996,
            "long": 102.331,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      }
    ]
  },
  {
    "id": 15,
    "name_th": "ฉะเชิงเทรา",
    "name_en": "Chachoengsao",
    "geography_id": 5,
    "created_at": "2019-08-09T03:33:09.000+07:00",
    "updated_at": "2025-09-20T06:31:26.000+07:00",
    "deleted_at": null,
    "districts": [
      {
        "id": 2401,
        "name_th": "เมืองฉะเชิงเทรา",
        "name_en": "Mueang Chachoengsao",
        "province_id": 15,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 240101,
            "zip_code": 24000,
            "name_th": "หน้าเมือง",
            "name_en": "Na Mueang",
            "district_id": 2401,
            "lat": 13.686,
            "long": 101.066,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 240102,
            "zip_code": 24000,
            "name_th": "ท่าไข่",
            "name_en": "Tha Khai",
            "district_id": 2401,
            "lat": 13.736,
            "long": 101.06,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 240103,
            "zip_code": 24000,
            "name_th": "บ้านใหม่",
            "name_en": "Ban Mai",
            "district_id": 2401,
            "lat": 13.707,
            "long": 101.1,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 240104,
            "zip_code": 24000,
            "name_th": "คลองนา",
            "name_en": "Khlong Na",
            "district_id": 2401,
            "lat": 13.648,
            "long": 101.102,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 240105,
            "zip_code": 24000,
            "name_th": "บางตีนเป็ด",
            "name_en": "Khlong Na",
            "district_id": 2401,
            "lat": 13.661,
            "long": 101.075,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 240106,
            "zip_code": 24000,
            "name_th": "บางไผ่",
            "name_en": "Bang Phai",
            "district_id": 2401,
            "lat": 13.692,
            "long": 101.102,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 240107,
            "zip_code": 24000,
            "name_th": "คลองจุกกระเฌอ",
            "name_en": "Khlong Chuk Krachoe",
            "district_id": 2401,
            "lat": 13.686,
            "long": 101.125,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 240108,
            "zip_code": 24000,
            "name_th": "บางแก้ว",
            "name_en": "Bang Kaeo",
            "district_id": 2401,
            "lat": 13.765,
            "long": 101.094,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 240109,
            "zip_code": 24000,
            "name_th": "บางขวัญ",
            "name_en": "Bang Khwan",
            "district_id": 2401,
            "lat": 13.78,
            "long": 101.054,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 240110,
            "zip_code": 24000,
            "name_th": "คลองนครเนื่องเขต",
            "name_en": "Khlong Nakhon Nueang Khet",
            "district_id": 2401,
            "lat": 13.766,
            "long": 101.008,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 240111,
            "zip_code": 24000,
            "name_th": "วังตะเคียน",
            "name_en": "Wang Takhian",
            "district_id": 2401,
            "lat": 13.719,
            "long": 101.034,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 240112,
            "zip_code": 24000,
            "name_th": "โสธร",
            "name_en": "Sothon",
            "district_id": 2401,
            "lat": 13.68,
            "long": 101.053,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 240113,
            "zip_code": 24000,
            "name_th": "บางพระ",
            "name_en": "Bang Phra",
            "district_id": 2401,
            "lat": 13.653,
            "long": 101.02,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 240114,
            "zip_code": 24000,
            "name_th": "บางกะไห",
            "name_en": "Bang Kahai",
            "district_id": 2401,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 240115,
            "zip_code": 24000,
            "name_th": "หนามแดง",
            "name_en": "Nam Daeng",
            "district_id": 2401,
            "lat": 13.736,
            "long": 100.989,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 240116,
            "zip_code": 24000,
            "name_th": "คลองเปรง",
            "name_en": "Khlong Preng",
            "district_id": 2401,
            "lat": 13.707,
            "long": 100.933,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 240117,
            "zip_code": 24000,
            "name_th": "คลองอุดมชลจร",
            "name_en": "Khlong Udom Chonlachon",
            "district_id": 2401,
            "lat": 13.736,
            "long": 100.92,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 240118,
            "zip_code": 24000,
            "name_th": "คลองหลวงแพ่ง",
            "name_en": "Khlong Luang Phaeng",
            "district_id": 2401,
            "lat": 13.78,
            "long": 100.927,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 240119,
            "zip_code": 24000,
            "name_th": "บางเตย",
            "name_en": "Bang Toei",
            "district_id": 2401,
            "lat": 13.706,
            "long": 100.993,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 2402,
        "name_th": "บางคล้า",
        "name_en": "Bang Khla",
        "province_id": 15,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 240201,
            "zip_code": 24110,
            "name_th": "บางคล้า",
            "name_en": "Bang Khla",
            "district_id": 2402,
            "lat": 13.722,
            "long": 101.21,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 240204,
            "zip_code": 24110,
            "name_th": "บางสวน",
            "name_en": "Bang Suan",
            "district_id": 2402,
            "lat": 13.696,
            "long": 101.177,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 240208,
            "zip_code": 24110,
            "name_th": "บางกระเจ็ด",
            "name_en": "Bang Krachet",
            "district_id": 2402,
            "lat": 13.852,
            "long": 101.208,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 240209,
            "zip_code": 24110,
            "name_th": "ปากน้ำ",
            "name_en": "Pak Nam",
            "district_id": 2402,
            "lat": 13.753,
            "long": 101.212,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 240210,
            "zip_code": 24110,
            "name_th": "ท่าทองหลาง",
            "name_en": "Tha Thonglang",
            "district_id": 2402,
            "lat": 13.694,
            "long": 101.229,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 240211,
            "zip_code": 24110,
            "name_th": "สาวชะโงก",
            "name_en": "Sao Cha-ngok",
            "district_id": 2402,
            "lat": 13.683,
            "long": 101.152,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 240212,
            "zip_code": 24110,
            "name_th": "เสม็ดเหนือ",
            "name_en": "Samet Nuea",
            "district_id": 2402,
            "lat": 13.673,
            "long": 101.201,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 240213,
            "zip_code": 24110,
            "name_th": "เสม็ดใต้",
            "name_en": "Samet Tai",
            "district_id": 2402,
            "lat": 13.653,
            "long": 101.162,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 240214,
            "zip_code": 24110,
            "name_th": "หัวไทร",
            "name_en": "Hua Sai",
            "district_id": 2402,
            "lat": 13.799,
            "long": 101.221,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 2403,
        "name_th": "บางน้ำเปรี้ยว",
        "name_en": "Bang Nam Priao",
        "province_id": 15,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 240301,
            "zip_code": 24150,
            "name_th": "บางน้ำเปรี้ยว",
            "name_en": "Bang Nam Priao",
            "district_id": 2403,
            "lat": 13.829,
            "long": 101.002,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 240302,
            "zip_code": 24150,
            "name_th": "บางขนาก",
            "name_en": "Bang Khanak",
            "district_id": 2403,
            "lat": 13.858,
            "long": 101.115,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 240303,
            "zip_code": 24150,
            "name_th": "สิงโตทอง",
            "name_en": "Singto Thong",
            "district_id": 2403,
            "lat": 13.911,
            "long": 101.073,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 240304,
            "zip_code": 24150,
            "name_th": "หมอนทอง",
            "name_en": "Mon Thong",
            "district_id": 2403,
            "lat": 13.874,
            "long": 101.043,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 240305,
            "zip_code": 24170,
            "name_th": "บึงน้ำรักษ์",
            "name_en": "Bueng Nam Rak",
            "district_id": 2403,
            "lat": 13.908,
            "long": 100.926,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 240306,
            "zip_code": 24170,
            "name_th": "ดอนเกาะกา",
            "name_en": "Don Ko Ka",
            "district_id": 2403,
            "lat": 13.944,
            "long": 101.016,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 240307,
            "zip_code": 24150,
            "name_th": "โยธะกา",
            "name_en": "Yothaka",
            "district_id": 2403,
            "lat": 13.925,
            "long": 101.128,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 240308,
            "zip_code": 24170,
            "name_th": "ดอนฉิมพลี",
            "name_en": "Don Chimphli",
            "district_id": 2403,
            "lat": 13.908,
            "long": 100.964,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 240309,
            "zip_code": 24000,
            "name_th": "ศาลาแดง",
            "name_en": "Sala Daeng",
            "district_id": 2403,
            "lat": 13.838,
            "long": 100.928,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 240310,
            "zip_code": 24150,
            "name_th": "โพรงอากาศ",
            "name_en": "Phrong Akat",
            "district_id": 2403,
            "lat": 13.827,
            "long": 101.062,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 2404,
        "name_th": "บางปะกง",
        "name_en": "Bang Pakong",
        "province_id": 15,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 240401,
            "zip_code": 24130,
            "name_th": "บางปะกง",
            "name_en": "Bang Pakong",
            "district_id": 2404,
            "lat": 13.496,
            "long": 100.966,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 240402,
            "zip_code": 24130,
            "name_th": "ท่าสะอ้าน",
            "name_en": "Tha Sa-an",
            "district_id": 2404,
            "lat": 13.553,
            "long": 100.995,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 240403,
            "zip_code": 24180,
            "name_th": "บางวัว",
            "name_en": "Bang Wua",
            "district_id": 2404,
            "lat": 13.569,
            "long": 100.964,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 240404,
            "zip_code": 24180,
            "name_th": "บางสมัคร",
            "name_en": "Bang Samak",
            "district_id": 2404,
            "lat": 13.575,
            "long": 100.936,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 240405,
            "zip_code": 24130,
            "name_th": "บางผึ้ง",
            "name_en": "Bang Phueng",
            "district_id": 2404,
            "lat": 13.527,
            "long": 101.054,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 240406,
            "zip_code": 24180,
            "name_th": "บางเกลือ",
            "name_en": "Bang Kluea",
            "district_id": 2404,
            "lat": 13.526,
            "long": 100.919,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 240407,
            "zip_code": 24130,
            "name_th": "สองคลอง",
            "name_en": "Song Khlong",
            "district_id": 2404,
            "lat": 13.484,
            "long": 100.91,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 240408,
            "zip_code": 24130,
            "name_th": "หนองจอก",
            "name_en": "Nong Chok",
            "district_id": 2404,
            "lat": 13.603,
            "long": 100.989,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 240409,
            "zip_code": 24130,
            "name_th": "พิมพา",
            "name_en": "Phimpha",
            "district_id": 2404,
            "lat": 13.599,
            "long": 100.937,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 240410,
            "zip_code": 24130,
            "name_th": "ท่าข้าม",
            "name_en": "Tha Kham",
            "district_id": 2404,
            "lat": 13.479,
            "long": 100.994,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 240411,
            "zip_code": 24180,
            "name_th": "หอมศีล",
            "name_en": "Hom Sin",
            "district_id": 2404,
            "lat": 13.543,
            "long": 100.892,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 240412,
            "zip_code": 24130,
            "name_th": "เขาดิน",
            "name_en": "Khao Din",
            "district_id": 2404,
            "lat": 13.528,
            "long": 101.026,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 2405,
        "name_th": "บ้านโพธิ์",
        "name_en": "Ban Pho",
        "province_id": 15,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 240501,
            "zip_code": 24140,
            "name_th": "บ้านโพธิ์",
            "name_en": "Ban Pho",
            "district_id": 2405,
            "lat": 13.588,
            "long": 101.086,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 240502,
            "zip_code": 24140,
            "name_th": "เกาะไร่",
            "name_en": "Ko Rai",
            "district_id": 2405,
            "lat": 13.678,
            "long": 100.958,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 240503,
            "zip_code": 24140,
            "name_th": "คลองขุด",
            "name_en": "Khlong Khut",
            "district_id": 2405,
            "lat": 13.611,
            "long": 101.194,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 240504,
            "zip_code": 24140,
            "name_th": "คลองบ้านโพธิ์",
            "name_en": "Khlong Ban Pho",
            "district_id": 2405,
            "lat": 13.572,
            "long": 101.057,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 240505,
            "zip_code": 24140,
            "name_th": "คลองประเวศ",
            "name_en": "Khlong Prawet",
            "district_id": 2405,
            "lat": 13.63,
            "long": 101.024,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 240506,
            "zip_code": 24140,
            "name_th": "ดอนทราย",
            "name_en": "Don Sai",
            "district_id": 2405,
            "lat": 13.631,
            "long": 101.125,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 240507,
            "zip_code": 24140,
            "name_th": "เทพราช",
            "name_en": "Theppharat",
            "district_id": 2405,
            "lat": 13.641,
            "long": 100.982,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 240508,
            "zip_code": 24140,
            "name_th": "ท่าพลับ",
            "name_en": "Tha Phlap",
            "district_id": 2405,
            "lat": 13.616,
            "long": 101.075,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 240509,
            "zip_code": 24140,
            "name_th": "หนองตีนนก",
            "name_en": "Nong Tin Nok",
            "district_id": 2405,
            "lat": 13.585,
            "long": 101.107,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 240510,
            "zip_code": 24140,
            "name_th": "หนองบัว",
            "name_en": "Nong Bua",
            "district_id": 2405,
            "lat": 13.617,
            "long": 101.101,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 240511,
            "zip_code": 24140,
            "name_th": "บางซ่อน",
            "name_en": "Bang Son",
            "district_id": 2405,
            "lat": 13.558,
            "long": 101.058,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 240512,
            "zip_code": 24140,
            "name_th": "บางกรูด",
            "name_en": "Bang Krut",
            "district_id": 2405,
            "lat": 13.633,
            "long": 101.078,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 240513,
            "zip_code": 24140,
            "name_th": "แหลมประดู่",
            "name_en": "Laem Pradu",
            "district_id": 2405,
            "lat": 13.597,
            "long": 101.209,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 240514,
            "zip_code": 24140,
            "name_th": "ลาดขวาง",
            "name_en": "Lat Khwang",
            "district_id": 2405,
            "lat": 13.605,
            "long": 101.023,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 240515,
            "zip_code": 24140,
            "name_th": "สนามจันทร์",
            "name_en": "Sanam Chan",
            "district_id": 2405,
            "lat": 13.594,
            "long": 101.066,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 240516,
            "zip_code": 24140,
            "name_th": "แสนภูดาษ",
            "name_en": "Saen Phu Dat",
            "district_id": 2405,
            "lat": 13.582,
            "long": 101.015,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 240517,
            "zip_code": 24140,
            "name_th": "สิบเอ็ดศอก",
            "name_en": "Sip Et Sok",
            "district_id": 2405,
            "lat": 13.605,
            "long": 101.148,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 2406,
        "name_th": "พนมสารคาม",
        "name_en": "Phanom Sarakham",
        "province_id": 15,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 240601,
            "zip_code": 24120,
            "name_th": "เกาะขนุน",
            "name_en": "Ko Khanun",
            "district_id": 2406,
            "lat": 13.695,
            "long": 101.399,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 240602,
            "zip_code": 24120,
            "name_th": "บ้านซ่อง",
            "name_en": "Ban Song",
            "district_id": 2406,
            "lat": 13.803,
            "long": 101.403,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 240603,
            "zip_code": 24120,
            "name_th": "พนมสารคาม",
            "name_en": "Phanom Sarakham",
            "district_id": 2406,
            "lat": 13.771,
            "long": 101.324,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 240604,
            "zip_code": 24120,
            "name_th": "เมืองเก่า",
            "name_en": "Mueang Kao",
            "district_id": 2406,
            "lat": 13.728,
            "long": 101.319,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 240605,
            "zip_code": 24120,
            "name_th": "หนองยาว",
            "name_en": "Nong Yao",
            "district_id": 2406,
            "lat": 13.816,
            "long": 101.351,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 240606,
            "zip_code": 24120,
            "name_th": "ท่าถ่าน",
            "name_en": "Tha Than",
            "district_id": 2406,
            "lat": 13.76,
            "long": 101.383,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 240607,
            "zip_code": 24120,
            "name_th": "หนองแหน",
            "name_en": "Nong Nae",
            "district_id": 2406,
            "lat": 13.661,
            "long": 101.335,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 240608,
            "zip_code": 24120,
            "name_th": "เขาหินซ้อน",
            "name_en": "Khao Hin Son",
            "district_id": 2406,
            "lat": 13.75,
            "long": 101.494,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 2407,
        "name_th": "ราชสาส์น",
        "name_en": "Ratchasan",
        "province_id": 15,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 240701,
            "zip_code": 24120,
            "name_th": "บางคา",
            "name_en": "Bang Kha",
            "district_id": 2407,
            "lat": 13.788,
            "long": 101.278,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 240702,
            "zip_code": 24120,
            "name_th": "เมืองใหม่",
            "name_en": "Mueang Mai",
            "district_id": 2407,
            "lat": 13.715,
            "long": 101.278,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 240703,
            "zip_code": 24120,
            "name_th": "ดงน้อย",
            "name_en": "Dong Noi",
            "district_id": 2407,
            "lat": 13.836,
            "long": 101.291,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 2408,
        "name_th": "สนามชัยเขต",
        "name_en": "Sanam Chai Khet",
        "province_id": 15,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 240801,
            "zip_code": 24160,
            "name_th": "คู้ยายหมี",
            "name_en": "Khu Yai Mi",
            "district_id": 2408,
            "lat": 13.644,
            "long": 101.461,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 240802,
            "zip_code": 24160,
            "name_th": "ท่ากระดาน",
            "name_en": "Tha Kradan",
            "district_id": 2408,
            "lat": 13.606,
            "long": 101.71,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 240803,
            "zip_code": 24160,
            "name_th": "ทุ่งพระยา",
            "name_en": "Thung Phraya",
            "district_id": 2408,
            "lat": 13.687,
            "long": 101.745,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 240805,
            "zip_code": 24160,
            "name_th": "ลาดกระทิง",
            "name_en": "Lat Krathing",
            "district_id": 2408,
            "lat": 13.548,
            "long": 101.475,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 2409,
        "name_th": "แปลงยาว",
        "name_en": "Plaeng Yao",
        "province_id": 15,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 240901,
            "zip_code": 24190,
            "name_th": "แปลงยาว",
            "name_en": "Plaeng Yao",
            "district_id": 2409,
            "lat": 13.599,
            "long": 101.293,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 240902,
            "zip_code": 24190,
            "name_th": "วังเย็น",
            "name_en": "Wang Yen",
            "district_id": 2409,
            "lat": 13.536,
            "long": 101.334,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 240903,
            "zip_code": 24190,
            "name_th": "หัวสำโรง",
            "name_en": "Hua Samrong",
            "district_id": 2409,
            "lat": 13.624,
            "long": 101.315,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 240904,
            "zip_code": 24190,
            "name_th": "หนองไม้แก่น",
            "name_en": "Nong Mai Kaen",
            "district_id": 2409,
            "lat": 13.504,
            "long": 101.404,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 2410,
        "name_th": "ท่าตะเกียบ",
        "name_en": "Tha Takiap",
        "province_id": 15,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 241001,
            "zip_code": 24160,
            "name_th": "ท่าตะเกียบ",
            "name_en": "Tha Takiap",
            "district_id": 2410,
            "lat": 13.508,
            "long": 101.639,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 241002,
            "zip_code": 24160,
            "name_th": "คลองตะเกรา",
            "name_en": "Khlong Takrao",
            "district_id": 2410,
            "lat": 13.299,
            "long": 101.739,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 2411,
        "name_th": "คลองเขื่อน",
        "name_en": "Khlong Khuean",
        "province_id": 15,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 241101,
            "zip_code": 24000,
            "name_th": "ก้อนแก้ว",
            "name_en": "Kon Kaeo",
            "district_id": 2411,
            "lat": 13.765,
            "long": 101.136,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 241102,
            "zip_code": 24000,
            "name_th": "คลองเขื่อน",
            "name_en": "Khlong Khuean",
            "district_id": 2411,
            "lat": 13.772,
            "long": 101.185,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 241103,
            "zip_code": 24000,
            "name_th": "บางเล่า",
            "name_en": "Bang Lao",
            "district_id": 2411,
            "lat": 13.721,
            "long": 101.15,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 241104,
            "zip_code": 24000,
            "name_th": "บางโรง",
            "name_en": "Bang Rong",
            "district_id": 2411,
            "lat": 13.824,
            "long": 101.137,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 241105,
            "zip_code": 24110,
            "name_th": "บางตลาด",
            "name_en": "Bang Talat",
            "district_id": 2411,
            "lat": 13.736,
            "long": 101.165,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      }
    ]
  },
  {
    "id": 16,
    "name_th": "ปราจีนบุรี",
    "name_en": "Prachin Buri",
    "geography_id": 5,
    "created_at": "2019-08-09T03:33:09.000+07:00",
    "updated_at": "2025-09-20T06:31:26.000+07:00",
    "deleted_at": null,
    "districts": [
      {
        "id": 2501,
        "name_th": "เมืองปราจีนบุรี",
        "name_en": "Mueang Prachin Buri",
        "province_id": 16,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 250101,
            "zip_code": 25000,
            "name_th": "หน้าเมือง",
            "name_en": "Na Mueang",
            "district_id": 2501,
            "lat": 14.057,
            "long": 101.374,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 250102,
            "zip_code": 25000,
            "name_th": "รอบเมือง",
            "name_en": "Na Mueang",
            "district_id": 2501,
            "lat": 14.066,
            "long": 101.327,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 250103,
            "zip_code": 25000,
            "name_th": "วัดโบสถ์",
            "name_en": "Wat Bot",
            "district_id": 2501,
            "lat": 14.034,
            "long": 101.31,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 250104,
            "zip_code": 25000,
            "name_th": "บางเดชะ",
            "name_en": "Bang Decha",
            "district_id": 2501,
            "lat": 13.991,
            "long": 101.33,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 250105,
            "zip_code": 25000,
            "name_th": "ท่างาม",
            "name_en": "Tha Ngam",
            "district_id": 2501,
            "lat": 14.017,
            "long": 101.413,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 250106,
            "zip_code": 25000,
            "name_th": "บางบริบูรณ์",
            "name_en": "Bang Boribun",
            "district_id": 2501,
            "lat": 14.039,
            "long": 101.429,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 250107,
            "zip_code": 25000,
            "name_th": "ดงพระราม",
            "name_en": "Dong Phra Ram",
            "district_id": 2501,
            "lat": 14.072,
            "long": 101.394,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 250108,
            "zip_code": 25230,
            "name_th": "บ้านพระ",
            "name_en": "Ban Phra",
            "district_id": 2501,
            "lat": 14.116,
            "long": 101.361,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 250109,
            "zip_code": 25230,
            "name_th": "โคกไม้ลาย",
            "name_en": "Khok Mai Lai",
            "district_id": 2501,
            "lat": 14.14,
            "long": 101.298,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 250110,
            "zip_code": 25230,
            "name_th": "ไม้เค็ด",
            "name_en": "Mai Khet",
            "district_id": 2501,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 250111,
            "zip_code": 25000,
            "name_th": "ดงขี้เหล็ก",
            "name_en": "Dong Khilek",
            "district_id": 2501,
            "lat": 14.132,
            "long": 101.439,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 250112,
            "zip_code": 25230,
            "name_th": "เนินหอม",
            "name_en": "Noen Hom",
            "district_id": 2501,
            "lat": 14.181,
            "long": 101.378,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 250113,
            "zip_code": 25000,
            "name_th": "โนนห้อม",
            "name_en": "Non Hom",
            "district_id": 2501,
            "lat": 14.094,
            "long": 101.463,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 2502,
        "name_th": "กบินทร์บุรี",
        "name_en": "Kabin Buri",
        "province_id": 16,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 250201,
            "zip_code": 25110,
            "name_th": "กบินทร์",
            "name_en": "Kabin",
            "district_id": 2502,
            "lat": 13.939,
            "long": 101.711,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 250202,
            "zip_code": 25240,
            "name_th": "เมืองเก่า",
            "name_en": "Mueang Kao",
            "district_id": 2502,
            "lat": 13.999,
            "long": 101.77,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 250203,
            "zip_code": 25110,
            "name_th": "วังดาล",
            "name_en": "Wang Dan",
            "district_id": 2502,
            "lat": 14.006,
            "long": 101.645,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 250204,
            "zip_code": 25110,
            "name_th": "นนทรี",
            "name_en": "Nonsi",
            "district_id": 2502,
            "lat": 14.056,
            "long": 101.668,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 250205,
            "zip_code": 25110,
            "name_th": "ย่านรี",
            "name_en": "Yan Ri",
            "district_id": 2502,
            "lat": 13.897,
            "long": 101.785,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 250206,
            "zip_code": 25110,
            "name_th": "วังตะเคียน",
            "name_en": "Wang Takhian",
            "district_id": 2502,
            "lat": 13.849,
            "long": 101.87,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 250207,
            "zip_code": 25110,
            "name_th": "หาดนางแก้ว",
            "name_en": "Hat Nang Kaeo",
            "district_id": 2502,
            "lat": 13.963,
            "long": 101.642,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 250208,
            "zip_code": 25110,
            "name_th": "ลาดตะเคียน",
            "name_en": "Lat Takhian",
            "district_id": 2502,
            "lat": 13.873,
            "long": 101.658,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 250209,
            "zip_code": 25110,
            "name_th": "บ้านนา",
            "name_en": "Ban Na",
            "district_id": 2502,
            "lat": 13.99,
            "long": 101.88,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 250210,
            "zip_code": 25110,
            "name_th": "บ่อทอง",
            "name_en": "Bo Thong",
            "district_id": 2502,
            "lat": 13.935,
            "long": 101.881,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 250211,
            "zip_code": 25110,
            "name_th": "หนองกี่",
            "name_en": "Nong Ki",
            "district_id": 2502,
            "lat": 14.068,
            "long": 101.841,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 250212,
            "zip_code": 25110,
            "name_th": "นาแขม",
            "name_en": "Na Khaem",
            "district_id": 2502,
            "lat": 14.052,
            "long": 101.723,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 250213,
            "zip_code": 25110,
            "name_th": "เขาไม้แก้ว",
            "name_en": "Khao Mai Kaeo",
            "district_id": 2502,
            "lat": 13.801,
            "long": 101.775,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 250214,
            "zip_code": 25110,
            "name_th": "วังท่าช้าง",
            "name_en": "Wang Tha Chang",
            "district_id": 2502,
            "lat": 13.694,
            "long": 101.885,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 2503,
        "name_th": "นาดี",
        "name_en": "Na Di",
        "province_id": 16,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 250301,
            "zip_code": 25220,
            "name_th": "นาดี",
            "name_en": "Na Di",
            "district_id": 2503,
            "lat": 14.189,
            "long": 101.792,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 250302,
            "zip_code": 25220,
            "name_th": "สำพันตา",
            "name_en": "Samphan Ta",
            "district_id": 2503,
            "lat": 14.081,
            "long": 101.766,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 250303,
            "zip_code": 25220,
            "name_th": "สะพานหิน",
            "name_en": "Saphan Hin",
            "district_id": 2503,
            "lat": 14.152,
            "long": 101.665,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 250304,
            "zip_code": 25220,
            "name_th": "ทุ่งโพธิ์",
            "name_en": "Thung Pho",
            "district_id": 2503,
            "lat": 14.141,
            "long": 101.889,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 250305,
            "zip_code": 25220,
            "name_th": "แก่งดินสอ",
            "name_en": "Kaeng Dinso",
            "district_id": 2503,
            "lat": 14.095,
            "long": 101.984,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 250306,
            "zip_code": 25220,
            "name_th": "บุพราหมณ์",
            "name_en": "Bu Phram",
            "district_id": 2503,
            "lat": 14.268,
            "long": 101.872,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 2506,
        "name_th": "บ้านสร้าง",
        "name_en": "Ban Sang",
        "province_id": 16,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 250601,
            "zip_code": 25150,
            "name_th": "บ้านสร้าง",
            "name_en": "Ban Sang",
            "district_id": 2506,
            "lat": 14.026,
            "long": 101.21,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 250602,
            "zip_code": 25150,
            "name_th": "บางกระเบา",
            "name_en": "Bang Krabao",
            "district_id": 2506,
            "lat": 13.984,
            "long": 101.202,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 250603,
            "zip_code": 25150,
            "name_th": "บางเตย",
            "name_en": "Bang Toei",
            "district_id": 2506,
            "lat": 13.946,
            "long": 101.223,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 250604,
            "zip_code": 25150,
            "name_th": "บางยาง",
            "name_en": "Bang Yang",
            "district_id": 2506,
            "lat": 13.94,
            "long": 101.175,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 250605,
            "zip_code": 25150,
            "name_th": "บางแตน",
            "name_en": "Bang Taen",
            "district_id": 2506,
            "lat": 13.89,
            "long": 101.177,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 250606,
            "zip_code": 25150,
            "name_th": "บางพลวง",
            "name_en": "Bang Phluang",
            "district_id": 2506,
            "lat": 13.986,
            "long": 101.282,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 250607,
            "zip_code": 25150,
            "name_th": "บางปลาร้า",
            "name_en": "Bang Pla Ra",
            "district_id": 2506,
            "lat": 13.926,
            "long": 101.313,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 250608,
            "zip_code": 25150,
            "name_th": "บางขาม",
            "name_en": "Bang Kham",
            "district_id": 2506,
            "lat": 13.893,
            "long": 101.274,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 250609,
            "zip_code": 25150,
            "name_th": "กระทุ่มแพ้ว",
            "name_en": "Krathum Phaeo",
            "district_id": 2506,
            "lat": 13.891,
            "long": 101.346,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 2507,
        "name_th": "ประจันตคาม",
        "name_en": "Prachantakham",
        "province_id": 16,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 250701,
            "zip_code": 25130,
            "name_th": "ประจันตคาม",
            "name_en": "Prachantakham",
            "district_id": 2507,
            "lat": 14.055,
            "long": 101.497,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 250702,
            "zip_code": 25130,
            "name_th": "เกาะลอย",
            "name_en": "Ko Loi",
            "district_id": 2507,
            "lat": 14.021,
            "long": 101.515,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 250703,
            "zip_code": 25130,
            "name_th": "บ้านหอย",
            "name_en": "Ban Hoi",
            "district_id": 2507,
            "lat": 13.996,
            "long": 101.567,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 250704,
            "zip_code": 25130,
            "name_th": "หนองแสง",
            "name_en": "Nong Saeng",
            "district_id": 2507,
            "lat": 14.052,
            "long": 101.563,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 250705,
            "zip_code": 25130,
            "name_th": "ดงบัง",
            "name_en": "Dong Bang",
            "district_id": 2507,
            "lat": 14.02,
            "long": 101.579,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 250706,
            "zip_code": 25130,
            "name_th": "คำโตนด",
            "name_en": "Kham Tanot",
            "district_id": 2507,
            "lat": 14.112,
            "long": 101.597,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 250707,
            "zip_code": 25130,
            "name_th": "บุฝ้าย",
            "name_en": "Bu Fai",
            "district_id": 2507,
            "lat": 14.298,
            "long": 101.601,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 250708,
            "zip_code": 25130,
            "name_th": "หนองแก้ว",
            "name_en": "Nong Kaeo",
            "district_id": 2507,
            "lat": 14.111,
            "long": 101.548,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 250709,
            "zip_code": 25130,
            "name_th": "โพธิ์งาม",
            "name_en": "Pho Ngam",
            "district_id": 2507,
            "lat": 14.214,
            "long": 101.466,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 2508,
        "name_th": "ศรีมหาโพธิ",
        "name_en": "Si Maha Phot",
        "province_id": 16,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 250801,
            "zip_code": 25140,
            "name_th": "ศรีมหาโพธิ",
            "name_en": "Si Maha Phot",
            "district_id": 2508,
            "lat": 13.849,
            "long": 101.567,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 250802,
            "zip_code": 25140,
            "name_th": "สัมพันธ์",
            "name_en": "Samphan",
            "district_id": 2508,
            "lat": 13.997,
            "long": 101.48,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 250803,
            "zip_code": 25140,
            "name_th": "บ้านทาม",
            "name_en": "Ban Tham",
            "district_id": 2508,
            "lat": 13.976,
            "long": 101.552,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 250804,
            "zip_code": 25140,
            "name_th": "ท่าตูม",
            "name_en": "Tha Tum",
            "district_id": 2508,
            "lat": 13.932,
            "long": 101.571,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 250805,
            "zip_code": 25140,
            "name_th": "บางกุ้ง",
            "name_en": "Bang Kung",
            "district_id": 2508,
            "lat": 13.964,
            "long": 101.483,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 250806,
            "zip_code": 25140,
            "name_th": "ดงกระทงยาม",
            "name_en": "Dong Krathong Yam",
            "district_id": 2508,
            "lat": 13.958,
            "long": 101.426,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 250807,
            "zip_code": 25140,
            "name_th": "หนองโพรง",
            "name_en": "Nong Phrong",
            "district_id": 2508,
            "lat": 13.787,
            "long": 101.581,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 250808,
            "zip_code": 25140,
            "name_th": "หัวหว้า",
            "name_en": "Hua Wa",
            "district_id": 2508,
            "lat": 13.908,
            "long": 101.461,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 250809,
            "zip_code": 25140,
            "name_th": "หาดยาง",
            "name_en": "Hat Yang",
            "district_id": 2508,
            "lat": 13.988,
            "long": 101.432,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 250810,
            "zip_code": 25140,
            "name_th": "กรอกสมบูรณ์",
            "name_en": "Krok Sombun",
            "district_id": 2508,
            "lat": 13.767,
            "long": 101.66,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 2509,
        "name_th": "ศรีมโหสถ",
        "name_en": "Si Mahosot",
        "province_id": 16,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 250901,
            "zip_code": 25190,
            "name_th": "โคกปีบ",
            "name_en": "Khok Pip",
            "district_id": 2509,
            "lat": 13.88,
            "long": 101.412,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 250902,
            "zip_code": 25190,
            "name_th": "โคกไทย",
            "name_en": "Khok Thai",
            "district_id": 2509,
            "lat": 13.845,
            "long": 101.448,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 250903,
            "zip_code": 25190,
            "name_th": "คู้ลำพัน",
            "name_en": "Khu Lam Phan",
            "district_id": 2509,
            "lat": 13.926,
            "long": 101.41,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 250904,
            "zip_code": 25190,
            "name_th": "ไผ่ชะเลือด",
            "name_en": "Phai Cha Lueat",
            "district_id": 2509,
            "lat": 13.919,
            "long": 101.372,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      }
    ]
  },
  {
    "id": 17,
    "name_th": "นครนายก",
    "name_en": "Nakhon Nayok",
    "geography_id": 2,
    "created_at": "2019-08-09T03:33:09.000+07:00",
    "updated_at": "2025-09-20T06:31:26.000+07:00",
    "deleted_at": null,
    "districts": [
      {
        "id": 2601,
        "name_th": "เมืองนครนายก",
        "name_en": "Mueang Nakhon Nayok",
        "province_id": 17,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 260101,
            "zip_code": 26000,
            "name_th": "นครนายก",
            "name_en": "Nakhon Nayok",
            "district_id": 2601,
            "lat": 14.204,
            "long": 101.219,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 260102,
            "zip_code": 26000,
            "name_th": "ท่าช้าง",
            "name_en": "Tha Chang",
            "district_id": 2601,
            "lat": 14.192,
            "long": 101.176,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 260103,
            "zip_code": 26000,
            "name_th": "บ้านใหญ่",
            "name_en": "Ban Yai",
            "district_id": 2601,
            "lat": 14.221,
            "long": 101.225,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 260104,
            "zip_code": 26000,
            "name_th": "วังกระโจม",
            "name_en": "Wang Krachom",
            "district_id": 2601,
            "lat": 14.176,
            "long": 101.212,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 260105,
            "zip_code": 26000,
            "name_th": "ท่าทราย",
            "name_en": "Tha Sai",
            "district_id": 2601,
            "lat": 14.174,
            "long": 101.111,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 260106,
            "zip_code": 26000,
            "name_th": "ดอนยอ",
            "name_en": "Don Yo",
            "district_id": 2601,
            "lat": 14.128,
            "long": 101.109,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 260107,
            "zip_code": 26000,
            "name_th": "ศรีจุฬา",
            "name_en": "Si Chula",
            "district_id": 2601,
            "lat": 14.072,
            "long": 101.132,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 260108,
            "zip_code": 26000,
            "name_th": "ดงละคร",
            "name_en": "Dong Lakhon",
            "district_id": 2601,
            "lat": 14.136,
            "long": 101.167,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 260109,
            "zip_code": 26000,
            "name_th": "ศรีนาวา",
            "name_en": "Si Nawa",
            "district_id": 2601,
            "lat": 14.209,
            "long": 101.267,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 260110,
            "zip_code": 26000,
            "name_th": "สาริกา",
            "name_en": "Sarika",
            "district_id": 2601,
            "lat": 14.359,
            "long": 101.261,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 260111,
            "zip_code": 26000,
            "name_th": "หินตั้ง",
            "name_en": "Hin Tang",
            "district_id": 2601,
            "lat": 14.408,
            "long": 101.352,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 260112,
            "zip_code": 26000,
            "name_th": "เขาพระ",
            "name_en": "Khao Phra",
            "district_id": 2601,
            "lat": 14.301,
            "long": 101.212,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 260113,
            "zip_code": 26000,
            "name_th": "พรหมณี",
            "name_en": "Phrommani",
            "district_id": 2601,
            "lat": 14.264,
            "long": 101.164,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 2602,
        "name_th": "ปากพลี",
        "name_en": "Pak Phli",
        "province_id": 17,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 260201,
            "zip_code": 26130,
            "name_th": "เกาะหวาย",
            "name_en": "Ko Wai",
            "district_id": 2602,
            "lat": 14.175,
            "long": 101.271,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 260202,
            "zip_code": 26130,
            "name_th": "เกาะโพธิ์",
            "name_en": "Ko Pho",
            "district_id": 2602,
            "lat": 14.156,
            "long": 101.231,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 260203,
            "zip_code": 26130,
            "name_th": "ปากพลี",
            "name_en": "Pak Phli",
            "district_id": 2602,
            "lat": 14.132,
            "long": 101.263,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 260204,
            "zip_code": 26130,
            "name_th": "โคกกรวด",
            "name_en": "Khok Kruat",
            "district_id": 2602,
            "lat": 14.18,
            "long": 101.306,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 260205,
            "zip_code": 26130,
            "name_th": "ท่าเรือ",
            "name_en": "Tha Ruea",
            "district_id": 2602,
            "lat": 14.085,
            "long": 101.235,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 260206,
            "zip_code": 26130,
            "name_th": "หนองแสง",
            "name_en": "Nong Saeng",
            "district_id": 2602,
            "lat": 14.211,
            "long": 101.307,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 260207,
            "zip_code": 26130,
            "name_th": "นาหินลาด",
            "name_en": "Na Hin Lat",
            "district_id": 2602,
            "lat": 14.317,
            "long": 101.457,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 2603,
        "name_th": "บ้านนา",
        "name_en": "Ban Na",
        "province_id": 17,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 260301,
            "zip_code": 26110,
            "name_th": "บ้านนา",
            "name_en": "Ban Na",
            "district_id": 2603,
            "lat": 14.262,
            "long": 101.059,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 260302,
            "zip_code": 26110,
            "name_th": "บ้านพร้าว",
            "name_en": "Ban Phrao",
            "district_id": 2603,
            "lat": 14.222,
            "long": 101.101,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 260303,
            "zip_code": 26110,
            "name_th": "บ้านพริก",
            "name_en": "Ban Phrik",
            "district_id": 2603,
            "lat": 14.252,
            "long": 100.976,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 260304,
            "zip_code": 26110,
            "name_th": "อาษา",
            "name_en": "Asa",
            "district_id": 2603,
            "lat": 14.226,
            "long": 101.009,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 260305,
            "zip_code": 26110,
            "name_th": "ทองหลาง",
            "name_en": "Thonglang",
            "district_id": 2603,
            "lat": 14.207,
            "long": 101.037,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 260306,
            "zip_code": 26110,
            "name_th": "บางอ้อ",
            "name_en": "Bang O",
            "district_id": 2603,
            "lat": 14.176,
            "long": 101.069,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 260307,
            "zip_code": 26110,
            "name_th": "พิกุลออก",
            "name_en": "Phikun Ok",
            "district_id": 2603,
            "lat": 14.244,
            "long": 101.027,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 260308,
            "zip_code": 26110,
            "name_th": "ป่าขะ",
            "name_en": "Pa Kha",
            "district_id": 2603,
            "lat": 14.297,
            "long": 101.065,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 260309,
            "zip_code": 26110,
            "name_th": "เขาเพิ่ม",
            "name_en": "Khao Phoem",
            "district_id": 2603,
            "lat": 14.362,
            "long": 101.096,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 260310,
            "zip_code": 26110,
            "name_th": "ศรีกะอาง",
            "name_en": "Si Ka-ang",
            "district_id": 2603,
            "lat": 14.308,
            "long": 101.117,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 2604,
        "name_th": "องครักษ์",
        "name_en": "Ongkharak",
        "province_id": 17,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 260401,
            "zip_code": 26120,
            "name_th": "พระอาจารย์",
            "name_en": "Phra Achan",
            "district_id": 2604,
            "lat": 13.986,
            "long": 101.02,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 260402,
            "zip_code": 26120,
            "name_th": "บึงศาล",
            "name_en": "Bueng San",
            "district_id": 2604,
            "lat": 14.052,
            "long": 100.938,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 260403,
            "zip_code": 26120,
            "name_th": "ศีรษะกระบือ",
            "name_en": "Sisa Krabue",
            "district_id": 2604,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 260404,
            "zip_code": 26120,
            "name_th": "โพธิ์แทน",
            "name_en": "Pho Thaen",
            "district_id": 2604,
            "lat": 14.208,
            "long": 100.949,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 260405,
            "zip_code": 26120,
            "name_th": "บางสมบูรณ์",
            "name_en": "Bang Sombun",
            "district_id": 2604,
            "lat": 14.021,
            "long": 101.112,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 260406,
            "zip_code": 26120,
            "name_th": "ทรายมูล",
            "name_en": "Sai Mun",
            "district_id": 2604,
            "lat": 14.123,
            "long": 101.069,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 260407,
            "zip_code": 26120,
            "name_th": "บางปลากด",
            "name_en": "Bang Pla Kot",
            "district_id": 2604,
            "lat": 14.166,
            "long": 100.971,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 260408,
            "zip_code": 26120,
            "name_th": "บางลูกเสือ",
            "name_en": "Bang Luk Suea",
            "district_id": 2604,
            "lat": 14.054,
            "long": 101.066,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 260409,
            "zip_code": 26120,
            "name_th": "องครักษ์",
            "name_en": "Ongkharak",
            "district_id": 2604,
            "lat": 14.107,
            "long": 101.005,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 260410,
            "zip_code": 26120,
            "name_th": "ชุมพล",
            "name_en": "Chumphon",
            "district_id": 2604,
            "lat": 13.99,
            "long": 100.937,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 260411,
            "zip_code": 26120,
            "name_th": "คลองใหญ่",
            "name_en": "Khlong Yai",
            "district_id": 2604,
            "lat": 14.127,
            "long": 100.98,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      }
    ]
  },
  {
    "id": 18,
    "name_th": "สระแก้ว",
    "name_en": "Sa Kaeo",
    "geography_id": 5,
    "created_at": "2019-08-09T03:33:09.000+07:00",
    "updated_at": "2025-09-20T06:31:26.000+07:00",
    "deleted_at": null,
    "districts": [
      {
        "id": 2701,
        "name_th": "เมืองสระแก้ว",
        "name_en": "Mueang Sa Kaeo",
        "province_id": 18,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 270101,
            "zip_code": 27000,
            "name_th": "สระแก้ว",
            "name_en": "Sa Kaeo",
            "district_id": 2701,
            "lat": 13.803,
            "long": 102.077,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 270102,
            "zip_code": 27000,
            "name_th": "บ้านแก้ง",
            "name_en": "Ban Kaeng",
            "district_id": 2701,
            "lat": 13.984,
            "long": 101.99,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 270103,
            "zip_code": 27000,
            "name_th": "ศาลาลำดวน",
            "name_en": "Sala Lamduan",
            "district_id": 2701,
            "lat": 13.838,
            "long": 101.964,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 270104,
            "zip_code": 27000,
            "name_th": "โคกปี่ฆ้อง",
            "name_en": "Khok Pi Khong",
            "district_id": 2701,
            "lat": 13.925,
            "long": 102.028,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 270105,
            "zip_code": 27000,
            "name_th": "ท่าแยก",
            "name_en": "Tha Yaek",
            "district_id": 2701,
            "lat": 14.064,
            "long": 102.266,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 270106,
            "zip_code": 27000,
            "name_th": "ท่าเกษม",
            "name_en": "Tha Kasem",
            "district_id": 2701,
            "lat": 13.766,
            "long": 102.164,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 270108,
            "zip_code": 27000,
            "name_th": "สระขวัญ",
            "name_en": "Sa Khwan",
            "district_id": 2701,
            "lat": 13.763,
            "long": 102.008,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 270111,
            "zip_code": 27000,
            "name_th": "หนองบอน",
            "name_en": "Nong Bon",
            "district_id": 2701,
            "lat": 13.85,
            "long": 102.087,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 2702,
        "name_th": "คลองหาด",
        "name_en": "Khlong Hat",
        "province_id": 18,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 270201,
            "zip_code": 27260,
            "name_th": "คลองหาด",
            "name_en": "Khlong Hat",
            "district_id": 2702,
            "lat": 13.429,
            "long": 102.329,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 270202,
            "zip_code": 27260,
            "name_th": "ไทยอุดม",
            "name_en": "Thai Udom",
            "district_id": 2702,
            "lat": 13.407,
            "long": 102.26,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 270203,
            "zip_code": 27260,
            "name_th": "ซับมะกรูด",
            "name_en": "Sap Makrut",
            "district_id": 2702,
            "lat": 13.519,
            "long": 102.228,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 270204,
            "zip_code": 27260,
            "name_th": "ไทรเดี่ยว",
            "name_en": "Sai Diao",
            "district_id": 2702,
            "lat": 13.593,
            "long": 102.212,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 270205,
            "zip_code": 27260,
            "name_th": "คลองไก่เถื่อน",
            "name_en": "Khlong Kai Thuean",
            "district_id": 2702,
            "lat": 13.346,
            "long": 102.301,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 270206,
            "zip_code": 27260,
            "name_th": "เบญจขร",
            "name_en": "Benchakhon",
            "district_id": 2702,
            "lat": 13.542,
            "long": 102.307,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 270207,
            "zip_code": 27260,
            "name_th": "ไทรทอง",
            "name_en": "Sai Thong",
            "district_id": 2702,
            "lat": 13.614,
            "long": 102.309,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 2703,
        "name_th": "ตาพระยา",
        "name_en": "Ta Phraya",
        "province_id": 18,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 270301,
            "zip_code": 27180,
            "name_th": "ตาพระยา",
            "name_en": "Ta Phraya",
            "district_id": 2703,
            "lat": 13.956,
            "long": 102.764,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 270302,
            "zip_code": 27180,
            "name_th": "ทัพเสด็จ",
            "name_en": "Thap Sadet",
            "district_id": 2703,
            "lat": 14.047,
            "long": 102.813,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 270306,
            "zip_code": 27180,
            "name_th": "ทัพราช",
            "name_en": "Thap Rat",
            "district_id": 2703,
            "lat": 14.079,
            "long": 102.639,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 270307,
            "zip_code": 27180,
            "name_th": "ทัพไทย",
            "name_en": "Thap Thai",
            "district_id": 2703,
            "lat": 14.123,
            "long": 102.845,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 270309,
            "zip_code": 27180,
            "name_th": "โคคลาน",
            "name_en": "Kho Khlan",
            "district_id": 2703,
            "lat": 13.968,
            "long": 102.65,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 2704,
        "name_th": "วังน้ำเย็น",
        "name_en": "Wang Nam Yen",
        "province_id": 18,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 270401,
            "zip_code": 27210,
            "name_th": "วังน้ำเย็น",
            "name_en": "Wang Nam Yen",
            "district_id": 2704,
            "lat": 13.517,
            "long": 102.166,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 270403,
            "zip_code": 27210,
            "name_th": "ตาหลังใน",
            "name_en": "Ta Lang Nai",
            "district_id": 2704,
            "lat": 13.471,
            "long": 102.13,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 270405,
            "zip_code": 27210,
            "name_th": "คลองหินปูน",
            "name_en": "Khlong Hin Pun",
            "district_id": 2704,
            "lat": 13.606,
            "long": 102.104,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 270406,
            "zip_code": 27210,
            "name_th": "ทุ่งมหาเจริญ",
            "name_en": "Thung Maha Charoen",
            "district_id": 2704,
            "lat": 13.482,
            "long": 102.009,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 2705,
        "name_th": "วัฒนานคร",
        "name_en": "Watthana Nakhon",
        "province_id": 18,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 270501,
            "zip_code": 27160,
            "name_th": "วัฒนานคร",
            "name_en": "Watthana Nakhon",
            "district_id": 2705,
            "lat": 13.741,
            "long": 102.325,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 270502,
            "zip_code": 27160,
            "name_th": "ท่าเกวียน",
            "name_en": "Tha Kwian",
            "district_id": 2705,
            "lat": 13.666,
            "long": 102.251,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 270503,
            "zip_code": 27160,
            "name_th": "ผักขะ",
            "name_en": "Phak Kha",
            "district_id": 2705,
            "lat": 13.71,
            "long": 102.382,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 270504,
            "zip_code": 27160,
            "name_th": "โนนหมากเค็ง",
            "name_en": "Non Mak Kheng",
            "district_id": 2705,
            "lat": 13.824,
            "long": 102.315,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 270505,
            "zip_code": 27160,
            "name_th": "หนองน้ำใส",
            "name_en": "Nong Nam Sai",
            "district_id": 2705,
            "lat": 13.871,
            "long": 102.341,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 270506,
            "zip_code": 27160,
            "name_th": "ช่องกุ่ม",
            "name_en": "Chong Kum",
            "district_id": 2705,
            "lat": 14.001,
            "long": 102.449,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 270507,
            "zip_code": 27160,
            "name_th": "หนองแวง",
            "name_en": "Nong Waeng",
            "district_id": 2705,
            "lat": 13.799,
            "long": 102.372,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 270508,
            "zip_code": 27160,
            "name_th": "แซร์ออ",
            "name_en": "Sae-o",
            "district_id": 2705,
            "lat": 13.974,
            "long": 102.518,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 270509,
            "zip_code": 27160,
            "name_th": "หนองหมากฝ้าย",
            "name_en": "Nong Mak Fai",
            "district_id": 2705,
            "lat": 14.024,
            "long": 102.358,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 270510,
            "zip_code": 27160,
            "name_th": "หนองตะเคียนบอน",
            "name_en": "Nong Takhian Bon",
            "district_id": 2705,
            "lat": 13.916,
            "long": 102.265,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 270511,
            "zip_code": 27160,
            "name_th": "ห้วยโจด",
            "name_en": "Huai Chot",
            "district_id": 2705,
            "lat": 13.771,
            "long": 102.281,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 2706,
        "name_th": "อรัญประเทศ",
        "name_en": "Aranyaprathet",
        "province_id": 18,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 270601,
            "zip_code": 27120,
            "name_th": "อรัญประเทศ",
            "name_en": "Aranprathet",
            "district_id": 2706,
            "lat": 13.68,
            "long": 102.517,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 270602,
            "zip_code": 27120,
            "name_th": "เมืองไผ่",
            "name_en": "Mueang Phai",
            "district_id": 2706,
            "lat": 13.651,
            "long": 102.427,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 270603,
            "zip_code": 27120,
            "name_th": "หันทราย",
            "name_en": "Han Sai",
            "district_id": 2706,
            "lat": 13.806,
            "long": 102.452,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 270604,
            "zip_code": 27120,
            "name_th": "คลองน้ำใส",
            "name_en": "Khlong Nam Sai",
            "district_id": 2706,
            "lat": 13.59,
            "long": 102.514,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 270605,
            "zip_code": 27120,
            "name_th": "ท่าข้าม",
            "name_en": "Tha Kham",
            "district_id": 2706,
            "lat": 13.639,
            "long": 102.531,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 270606,
            "zip_code": 27120,
            "name_th": "ป่าไร่",
            "name_en": "Pa Rai",
            "district_id": 2706,
            "lat": 13.745,
            "long": 102.585,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 270607,
            "zip_code": 27120,
            "name_th": "ทับพริก",
            "name_en": "Thap Phrik",
            "district_id": 2706,
            "lat": 13.506,
            "long": 102.336,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 270608,
            "zip_code": 27120,
            "name_th": "บ้านใหม่หนองไทร",
            "name_en": "Ban Mai Nong Sai",
            "district_id": 2706,
            "lat": 13.715,
            "long": 102.51,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 270609,
            "zip_code": 27120,
            "name_th": "ผ่านศึก",
            "name_en": "Phan Suek",
            "district_id": 2706,
            "lat": 13.592,
            "long": 102.432,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 270610,
            "zip_code": 27120,
            "name_th": "หนองสังข์",
            "name_en": "Nong Sang",
            "district_id": 2706,
            "lat": 13.804,
            "long": 102.539,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 270611,
            "zip_code": 27120,
            "name_th": "คลองทับจันทร์",
            "name_en": "Khlong Thap Chan",
            "district_id": 2706,
            "lat": 13.643,
            "long": 102.387,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 270612,
            "zip_code": 27120,
            "name_th": "ฟากห้วย",
            "name_en": "Fak Huai",
            "district_id": 2706,
            "lat": 13.646,
            "long": 102.48,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 270613,
            "zip_code": 27120,
            "name_th": "บ้านด่าน",
            "name_en": "Ban Dan",
            "district_id": 2706,
            "lat": 13.746,
            "long": 102.526,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 2707,
        "name_th": "เขาฉกรรจ์",
        "name_en": "Khao Chakan",
        "province_id": 18,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 270701,
            "zip_code": 27000,
            "name_th": "เขาฉกรรจ์",
            "name_en": "Khao Chakan",
            "district_id": 2707,
            "lat": 13.663,
            "long": 102.098,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 270702,
            "zip_code": 27000,
            "name_th": "หนองหว้า",
            "name_en": "Nong Wa",
            "district_id": 2707,
            "lat": 13.672,
            "long": 102.037,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 270703,
            "zip_code": 27000,
            "name_th": "พระเพลิง",
            "name_en": "Phra Phloeng",
            "district_id": 2707,
            "lat": 13.596,
            "long": 102.042,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 270704,
            "zip_code": 27000,
            "name_th": "เขาสามสิบ",
            "name_en": "Khao Sam Sip",
            "district_id": 2707,
            "lat": 13.708,
            "long": 102.118,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 2708,
        "name_th": "โคกสูง",
        "name_en": "Khok Sung",
        "province_id": 18,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 270801,
            "zip_code": 27120,
            "name_th": "โคกสูง",
            "name_en": "Khok Sung",
            "district_id": 2708,
            "lat": 13.831,
            "long": 102.719,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 270802,
            "zip_code": 27180,
            "name_th": "หนองม่วง",
            "name_en": "Nong Muang",
            "district_id": 2708,
            "lat": 13.874,
            "long": 102.582,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 270803,
            "zip_code": 27180,
            "name_th": "หนองแวง",
            "name_en": "Nong Waeng",
            "district_id": 2708,
            "lat": 13.866,
            "long": 102.674,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 270804,
            "zip_code": 27120,
            "name_th": "โนนหมากมุ่น",
            "name_en": "Non Mak Mun",
            "district_id": 2708,
            "lat": 13.774,
            "long": 102.664,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 2709,
        "name_th": "วังสมบูรณ์",
        "name_en": "Wang Sombun",
        "province_id": 18,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 270901,
            "zip_code": 27250,
            "name_th": "วังสมบูรณ์",
            "name_en": "Wang Sombun",
            "district_id": 2709,
            "lat": 13.344,
            "long": 102.207,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 270902,
            "zip_code": 27250,
            "name_th": "วังใหม่",
            "name_en": "Wang Mai",
            "district_id": 2709,
            "lat": 13.413,
            "long": 102.039,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 270903,
            "zip_code": 27250,
            "name_th": "วังทอง",
            "name_en": "Wang Thong",
            "district_id": 2709,
            "lat": 13.338,
            "long": 102.081,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      }
    ]
  },
  {
    "id": 19,
    "name_th": "นครราชสีมา",
    "name_en": "Nakhon Ratchasima",
    "geography_id": 3,
    "created_at": "2019-08-09T03:33:09.000+07:00",
    "updated_at": "2025-09-20T06:31:26.000+07:00",
    "deleted_at": null,
    "districts": [
      {
        "id": 3001,
        "name_th": "เมืองนครราชสีมา",
        "name_en": "Mueang Nakhon Ratchasima",
        "province_id": 19,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 300101,
            "zip_code": 30000,
            "name_th": "ในเมือง",
            "name_en": "Nai Mueang",
            "district_id": 3001,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 300102,
            "zip_code": 30000,
            "name_th": "โพธิ์กลาง",
            "name_en": "Pho Klang",
            "district_id": 3001,
            "lat": 14.906,
            "long": 102.102,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 300103,
            "zip_code": 30000,
            "name_th": "หนองจะบก",
            "name_en": "Nong Chabok",
            "district_id": 3001,
            "lat": 14.916,
            "long": 102.064,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 300104,
            "zip_code": 30310,
            "name_th": "โคกสูง",
            "name_en": "Khok Sung",
            "district_id": 3001,
            "lat": 15.095,
            "long": 102.116,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 300105,
            "zip_code": 30000,
            "name_th": "มะเริง",
            "name_en": "Maroeng",
            "district_id": 3001,
            "lat": 14.98,
            "long": 102.164,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 300106,
            "zip_code": 30000,
            "name_th": "หนองระเวียง",
            "name_en": "Nong Rawiang",
            "district_id": 3001,
            "lat": 14.946,
            "long": 102.199,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 300107,
            "zip_code": 30000,
            "name_th": "ปรุใหญ่",
            "name_en": "Pru Yai",
            "district_id": 3001,
            "lat": 14.994,
            "long": 102.052,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 300108,
            "zip_code": 30000,
            "name_th": "หมื่นไวย",
            "name_en": "Muen Wai",
            "district_id": 3001,
            "lat": 15.011,
            "long": 102.108,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 300109,
            "zip_code": 30000,
            "name_th": "พลกรัง",
            "name_en": "Phon Krang",
            "district_id": 3001,
            "lat": 15.026,
            "long": 102.011,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 300110,
            "zip_code": 30000,
            "name_th": "หนองไผ่ล้อม",
            "name_en": "Nong Phai Lom",
            "district_id": 3001,
            "lat": 14.947,
            "long": 102.085,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 300111,
            "zip_code": 30000,
            "name_th": "หัวทะเล",
            "name_en": "Hua Thale",
            "district_id": 3001,
            "lat": 14.965,
            "long": 102.14,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 300112,
            "zip_code": 30000,
            "name_th": "บ้านเกาะ",
            "name_en": "Ban Ko",
            "district_id": 3001,
            "lat": 14.981,
            "long": 102.091,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 300113,
            "zip_code": 30000,
            "name_th": "บ้านใหม่",
            "name_en": "Ban Mai",
            "district_id": 3001,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 300114,
            "zip_code": 30000,
            "name_th": "พุดซา",
            "name_en": "Phutsa",
            "district_id": 3001,
            "lat": 15.049,
            "long": 102.043,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 300115,
            "zip_code": 30310,
            "name_th": "บ้านโพธิ์",
            "name_en": "Ban Pho",
            "district_id": 3001,
            "lat": 15.038,
            "long": 102.191,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 300116,
            "zip_code": 30310,
            "name_th": "จอหอ",
            "name_en": "Cho Ho",
            "district_id": 3001,
            "lat": 15.055,
            "long": 102.148,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 300117,
            "zip_code": 30280,
            "name_th": "โคกกรวด",
            "name_en": "Khok Kruat",
            "district_id": 3001,
            "lat": 14.897,
            "long": 101.974,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 300118,
            "zip_code": 30000,
            "name_th": "ไชยมงคล",
            "name_en": "Chai Mongkhon",
            "district_id": 3001,
            "lat": 14.849,
            "long": 102.08,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 300119,
            "zip_code": 30000,
            "name_th": "หนองบัวศาลา",
            "name_en": "Nong Bua Sala",
            "district_id": 3001,
            "lat": 14.899,
            "long": 102.152,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 300120,
            "zip_code": 30000,
            "name_th": "สุรนารี",
            "name_en": "Suranari",
            "district_id": 3001,
            "lat": 14.915,
            "long": 102.037,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 300121,
            "zip_code": 30000,
            "name_th": "สีมุม",
            "name_en": "Si Mum",
            "district_id": 3001,
            "lat": 14.986,
            "long": 102.007,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 300122,
            "zip_code": 30310,
            "name_th": "ตลาด",
            "name_en": "Talat",
            "district_id": 3001,
            "lat": 15.018,
            "long": 102.154,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 300123,
            "zip_code": 30000,
            "name_th": "พะเนา",
            "name_en": "Phanao",
            "district_id": 3001,
            "lat": 14.986,
            "long": 102.189,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 300124,
            "zip_code": 30000,
            "name_th": "หนองกระทุ่ม",
            "name_en": "Nong Krathum",
            "district_id": 3001,
            "lat": 15.009,
            "long": 102.086,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 300125,
            "zip_code": 30310,
            "name_th": "หนองไข่น้ำ",
            "name_en": "Nong Khai Nam",
            "district_id": 3001,
            "lat": 15.105,
            "long": 102.174,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 3002,
        "name_th": "ครบุรี",
        "name_en": "Khon Buri",
        "province_id": 19,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 300201,
            "zip_code": 30250,
            "name_th": "แชะ",
            "name_en": "Chae",
            "district_id": 3002,
            "lat": 14.569,
            "long": 102.278,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 300202,
            "zip_code": 30250,
            "name_th": "เฉลียง",
            "name_en": "Chaliang",
            "district_id": 3002,
            "lat": 14.489,
            "long": 102.279,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 300203,
            "zip_code": 30250,
            "name_th": "ครบุรี",
            "name_en": "Khon Buri",
            "district_id": 3002,
            "lat": 14.599,
            "long": 102.13,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 300204,
            "zip_code": 30250,
            "name_th": "โคกกระชาย",
            "name_en": "Khok Krachai",
            "district_id": 3002,
            "lat": 14.301,
            "long": 102.196,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 300205,
            "zip_code": 30250,
            "name_th": "จระเข้หิน",
            "name_en": "Chorakhe Hin",
            "district_id": 3002,
            "lat": 14.367,
            "long": 102.1,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 300206,
            "zip_code": 30250,
            "name_th": "มาบตะโกเอน",
            "name_en": "Map Tako En",
            "district_id": 3002,
            "lat": 14.57,
            "long": 102.385,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 300207,
            "zip_code": 30250,
            "name_th": "อรพิมพ์",
            "name_en": "Oraphim",
            "district_id": 3002,
            "lat": 14.569,
            "long": 102.207,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 300208,
            "zip_code": 30250,
            "name_th": "บ้านใหม่",
            "name_en": "Ban Mai",
            "district_id": 3002,
            "lat": 14.449,
            "long": 102.207,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 300209,
            "zip_code": 30250,
            "name_th": "ลำเพียก",
            "name_en": "Lam Phiak",
            "district_id": 3002,
            "lat": 14.255,
            "long": 102.302,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 300210,
            "zip_code": 30250,
            "name_th": "ครบุรีใต้",
            "name_en": "Khon Buri Tai",
            "district_id": 3002,
            "lat": 14.529,
            "long": 102.103,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 300211,
            "zip_code": 30250,
            "name_th": "ตะแบกบาน",
            "name_en": "Tabaek Ban",
            "district_id": 3002,
            "lat": 14.462,
            "long": 102.343,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 300212,
            "zip_code": 30250,
            "name_th": "สระว่านพระยา",
            "name_en": "Sa Wan Phraya",
            "district_id": 3002,
            "lat": 14.528,
            "long": 102.384,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 3003,
        "name_th": "เสิงสาง",
        "name_en": "Soeng Sang",
        "province_id": 19,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 300301,
            "zip_code": 30330,
            "name_th": "เสิงสาง",
            "name_en": "Soeng Sang",
            "district_id": 3003,
            "lat": 14.426,
            "long": 102.429,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 300302,
            "zip_code": 30330,
            "name_th": "สระตะเคียน",
            "name_en": "Sa Takhian",
            "district_id": 3003,
            "lat": 14.325,
            "long": 102.552,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 300303,
            "zip_code": 30330,
            "name_th": "โนนสมบูรณ์",
            "name_en": "Non Sombun",
            "district_id": 3003,
            "lat": 14.278,
            "long": 102.398,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 300304,
            "zip_code": 30330,
            "name_th": "กุดโบสถ์",
            "name_en": "Kut Bot",
            "district_id": 3003,
            "lat": 14.457,
            "long": 102.54,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 300305,
            "zip_code": 30330,
            "name_th": "สุขไพบูลย์",
            "name_en": "Suk Phaibun",
            "district_id": 3003,
            "lat": 14.526,
            "long": 102.448,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 300306,
            "zip_code": 30330,
            "name_th": "บ้านราษฎร์",
            "name_en": "Ban Rat",
            "district_id": 3003,
            "lat": 14.247,
            "long": 102.474,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 3004,
        "name_th": "คง",
        "name_en": "Khong",
        "province_id": 19,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 300401,
            "zip_code": 30260,
            "name_th": "เมืองคง",
            "name_en": "Mueang Khong",
            "district_id": 3004,
            "lat": 15.451,
            "long": 102.334,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 300402,
            "zip_code": 30260,
            "name_th": "คูขาด",
            "name_en": "Khu Khat",
            "district_id": 3004,
            "lat": 15.445,
            "long": 102.407,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 300403,
            "zip_code": 30260,
            "name_th": "เทพาลัย",
            "name_en": "Thephalai",
            "district_id": 3004,
            "lat": 15.368,
            "long": 102.466,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 300404,
            "zip_code": 30260,
            "name_th": "ตาจั่น",
            "name_en": "Ta Chan",
            "district_id": 3004,
            "lat": 15.314,
            "long": 102.368,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 300405,
            "zip_code": 30260,
            "name_th": "บ้านปรางค์",
            "name_en": "Ban Prang",
            "district_id": 3004,
            "lat": 15.474,
            "long": 102.08,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 300406,
            "zip_code": 30260,
            "name_th": "หนองมะนาว",
            "name_en": "Nong Manao",
            "district_id": 3004,
            "lat": 15.5,
            "long": 102.28,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 300407,
            "zip_code": 30260,
            "name_th": "หนองบัว",
            "name_en": "Nong Bua",
            "district_id": 3004,
            "lat": 15.496,
            "long": 102.167,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 300408,
            "zip_code": 30260,
            "name_th": "โนนเต็ง",
            "name_en": "Non Teng",
            "district_id": 3004,
            "lat": 15.449,
            "long": 102.266,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 300409,
            "zip_code": 30260,
            "name_th": "ดอนใหญ่",
            "name_en": "Don Yai",
            "district_id": 3004,
            "lat": 15.397,
            "long": 102.357,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 300410,
            "zip_code": 30260,
            "name_th": "ขามสมบูรณ์",
            "name_en": "Kham Sombun",
            "district_id": 3004,
            "lat": 15.371,
            "long": 102.403,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 3005,
        "name_th": "บ้านเหลื่อม",
        "name_en": "Ban Lueam",
        "province_id": 19,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 300501,
            "zip_code": 30350,
            "name_th": "บ้านเหลื่อม",
            "name_en": "Ban Lueam",
            "district_id": 3005,
            "lat": 15.625,
            "long": 102.136,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 300502,
            "zip_code": 30350,
            "name_th": "วังโพธิ์",
            "name_en": "Wang Pho",
            "district_id": 3005,
            "lat": 15.571,
            "long": 102.103,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 300503,
            "zip_code": 30350,
            "name_th": "โคกกระเบื้อง",
            "name_en": "Khok Krabueang",
            "district_id": 3005,
            "lat": 15.571,
            "long": 102.187,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 300504,
            "zip_code": 30350,
            "name_th": "ช่อระกา",
            "name_en": "Cho Raka",
            "district_id": 3005,
            "lat": 15.54,
            "long": 102.057,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 3006,
        "name_th": "จักราช",
        "name_en": "Chakkarat",
        "province_id": 19,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 300601,
            "zip_code": 30230,
            "name_th": "จักราช",
            "name_en": "Chakkarat",
            "district_id": 3006,
            "lat": 15.027,
            "long": 102.432,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 300602,
            "zip_code": 30230,
            "name_th": "ท่าช้าง",
            "name_en": "Tha Chang",
            "district_id": 3006,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 300603,
            "zip_code": 30230,
            "name_th": "ทองหลาง",
            "name_en": "Thonglang",
            "district_id": 3006,
            "lat": 15.052,
            "long": 102.353,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 300604,
            "zip_code": 30230,
            "name_th": "สีสุก",
            "name_en": "Si Suk",
            "district_id": 3006,
            "lat": 14.874,
            "long": 102.385,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 300605,
            "zip_code": 30230,
            "name_th": "หนองขาม",
            "name_en": "Nong Kham",
            "district_id": 3006,
            "lat": 14.931,
            "long": 102.506,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 300606,
            "zip_code": 30230,
            "name_th": "หนองงูเหลือม",
            "name_en": "Nong Ngu Luam",
            "district_id": 3006,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 300607,
            "zip_code": 30230,
            "name_th": "หนองพลวง",
            "name_en": "Nong Phluang",
            "district_id": 3006,
            "lat": 15.07,
            "long": 102.424,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 300608,
            "zip_code": 30230,
            "name_th": "หนองยาง",
            "name_en": "Nong Yang",
            "district_id": 3006,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 300609,
            "zip_code": 30230,
            "name_th": "พระพุทธ",
            "name_en": "Phra Phut",
            "district_id": 3006,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 300610,
            "zip_code": 30230,
            "name_th": "ศรีละกอ",
            "name_en": "Si Lako",
            "district_id": 3006,
            "lat": 14.938,
            "long": 102.427,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 300611,
            "zip_code": 30230,
            "name_th": "คลองเมือง",
            "name_en": "Khlong Mueang",
            "district_id": 3006,
            "lat": 14.852,
            "long": 102.502,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 300612,
            "zip_code": 30230,
            "name_th": "ช้างทอง",
            "name_en": "Chang Thong",
            "district_id": 3006,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 300613,
            "zip_code": 30230,
            "name_th": "หินโคน",
            "name_en": "Hin Khon",
            "district_id": 3006,
            "lat": 15.013,
            "long": 102.498,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 3007,
        "name_th": "โชคชัย",
        "name_en": "Chok Chai",
        "province_id": 19,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 300701,
            "zip_code": 30190,
            "name_th": "กระโทก",
            "name_en": "Krathok",
            "district_id": 3007,
            "lat": 14.714,
            "long": 102.189,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 300702,
            "zip_code": 30190,
            "name_th": "พลับพลา",
            "name_en": "Phlapphla",
            "district_id": 3007,
            "lat": 14.755,
            "long": 102.129,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 300703,
            "zip_code": 30190,
            "name_th": "ท่าอ่าง",
            "name_en": "Tha Ang",
            "district_id": 3007,
            "lat": 14.821,
            "long": 102.16,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 300704,
            "zip_code": 30190,
            "name_th": "ทุ่งอรุณ",
            "name_en": "Thung Arun",
            "district_id": 3007,
            "lat": 14.631,
            "long": 102.184,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 300705,
            "zip_code": 30190,
            "name_th": "ท่าลาดขาว",
            "name_en": "Tha Lat Khao",
            "district_id": 3007,
            "lat": 14.672,
            "long": 102.154,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 300706,
            "zip_code": 30190,
            "name_th": "ท่าจะหลุง",
            "name_en": "Tha Chalung",
            "district_id": 3007,
            "lat": 14.87,
            "long": 102.264,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 300707,
            "zip_code": 30190,
            "name_th": "ท่าเยี่ยม",
            "name_en": "Tha Yiam",
            "district_id": 3007,
            "lat": 14.716,
            "long": 102.237,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 300708,
            "zip_code": 30190,
            "name_th": "โชคชัย",
            "name_en": "Chok Chai",
            "district_id": 3007,
            "lat": 14.763,
            "long": 102.172,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 300709,
            "zip_code": 30190,
            "name_th": "ละลมใหม่พัฒนา",
            "name_en": "Lalom Mai Phatthana",
            "district_id": 3007,
            "lat": 14.811,
            "long": 102.243,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 300710,
            "zip_code": 30190,
            "name_th": "ด่านเกวียน",
            "name_en": "Dan Kwian",
            "district_id": 3007,
            "lat": 14.864,
            "long": 102.189,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 3008,
        "name_th": "ด่านขุนทด",
        "name_en": "Dan Khun Thot",
        "province_id": 19,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 300801,
            "zip_code": 30210,
            "name_th": "กุดพิมาน",
            "name_en": "Kut Phiman",
            "district_id": 3008,
            "lat": 15.303,
            "long": 101.759,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 300802,
            "zip_code": 30210,
            "name_th": "ด่านขุนทด",
            "name_en": "Dan Khun Thot",
            "district_id": 3008,
            "lat": 15.214,
            "long": 101.788,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 300803,
            "zip_code": 30210,
            "name_th": "ด่านนอก",
            "name_en": "Dan Nok",
            "district_id": 3008,
            "lat": 15.157,
            "long": 101.87,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 300804,
            "zip_code": 30210,
            "name_th": "ด่านใน",
            "name_en": "Dan Nai",
            "district_id": 3008,
            "lat": 15.119,
            "long": 101.855,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 300805,
            "zip_code": 30210,
            "name_th": "ตะเคียน",
            "name_en": "Takhian",
            "district_id": 3008,
            "lat": 15.124,
            "long": 101.724,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 300806,
            "zip_code": 30210,
            "name_th": "บ้านเก่า",
            "name_en": "Ban Kao",
            "district_id": 3008,
            "lat": 15.211,
            "long": 101.673,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 300807,
            "zip_code": 36220,
            "name_th": "บ้านแปรง",
            "name_en": "Ban Praeng",
            "district_id": 3008,
            "lat": 15.372,
            "long": 101.809,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 300808,
            "zip_code": 30210,
            "name_th": "พันชนะ",
            "name_en": "Phan Chana",
            "district_id": 3008,
            "lat": 15.27,
            "long": 101.689,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 300809,
            "zip_code": 30210,
            "name_th": "สระจรเข้",
            "name_en": "Sa Chorakhe",
            "district_id": 3008,
            "lat": 15.147,
            "long": 101.808,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 300810,
            "zip_code": 30210,
            "name_th": "หนองกราด",
            "name_en": "Nong Krat",
            "district_id": 3008,
            "lat": 15.348,
            "long": 101.667,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 300811,
            "zip_code": 30210,
            "name_th": "หนองบัวตะเกียด",
            "name_en": "Nong Bua Takiat",
            "district_id": 3008,
            "lat": 15.281,
            "long": 101.821,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 300812,
            "zip_code": 30210,
            "name_th": "หนองบัวละคร",
            "name_en": "Nong Bua Lakhon",
            "district_id": 3008,
            "lat": 15.243,
            "long": 101.863,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 300813,
            "zip_code": 30210,
            "name_th": "หินดาด",
            "name_en": "Hin Dat",
            "district_id": 3008,
            "lat": 15.149,
            "long": 101.618,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 300815,
            "zip_code": 30210,
            "name_th": "ห้วยบง",
            "name_en": "Huai Bong",
            "district_id": 3008,
            "lat": 15.161,
            "long": 101.486,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 300817,
            "zip_code": 30210,
            "name_th": "โนนเมืองพัฒนา",
            "name_en": "Non Mueang Phatthana",
            "district_id": 3008,
            "lat": 15.304,
            "long": 101.897,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 300818,
            "zip_code": 36220,
            "name_th": "หนองไทร",
            "name_en": "Nong Sai",
            "district_id": 3008,
            "lat": 15.36,
            "long": 101.855,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 3009,
        "name_th": "โนนไทย",
        "name_en": "Non Thai",
        "province_id": 19,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 300901,
            "zip_code": 30220,
            "name_th": "โนนไทย",
            "name_en": "Non Thai",
            "district_id": 3009,
            "lat": 15.213,
            "long": 102.061,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 300902,
            "zip_code": 30220,
            "name_th": "ด่านจาก",
            "name_en": "Dan Chak",
            "district_id": 3009,
            "lat": 15.162,
            "long": 102.095,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 300903,
            "zip_code": 30220,
            "name_th": "กำปัง",
            "name_en": "Kampang",
            "district_id": 3009,
            "lat": 15.118,
            "long": 102.06,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 300904,
            "zip_code": 30220,
            "name_th": "สำโรง",
            "name_en": "Samrong",
            "district_id": 3009,
            "lat": 15.128,
            "long": 102.018,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 300905,
            "zip_code": 30220,
            "name_th": "ค้างพลู",
            "name_en": "Khang Phlu",
            "district_id": 3009,
            "lat": 15.149,
            "long": 101.973,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 300906,
            "zip_code": 30220,
            "name_th": "บ้านวัง",
            "name_en": "Ban Wang",
            "district_id": 3009,
            "lat": 15.152,
            "long": 101.914,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 300907,
            "zip_code": 30220,
            "name_th": "บัลลังก์",
            "name_en": "Banlang",
            "district_id": 3009,
            "lat": 15.223,
            "long": 101.928,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 300908,
            "zip_code": 30220,
            "name_th": "สายออ",
            "name_en": "Sai O",
            "district_id": 3009,
            "lat": 15.226,
            "long": 102.002,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 300909,
            "zip_code": 30220,
            "name_th": "ถนนโพธิ์",
            "name_en": "Thanon Pho",
            "district_id": 3009,
            "lat": 15.274,
            "long": 102.138,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 300910,
            "zip_code": 30220,
            "name_th": "พังเทียม",
            "name_en": "Phung Theam",
            "district_id": 3009,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 300911,
            "zip_code": 30220,
            "name_th": "สระพระ",
            "name_en": "Sra Pra",
            "district_id": 3009,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 300912,
            "zip_code": 30220,
            "name_th": "ทัพรั้ง",
            "name_en": "Tup Rang",
            "district_id": 3009,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 300913,
            "zip_code": 30220,
            "name_th": "หนองหอย",
            "name_en": "Nong Hoi",
            "district_id": 3009,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 300914,
            "zip_code": 30220,
            "name_th": "มะค่า",
            "name_en": "Makha",
            "district_id": 3009,
            "lat": 15.265,
            "long": 102.098,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 300915,
            "zip_code": 30220,
            "name_th": "มาบกราด",
            "name_en": "Mab Krad",
            "district_id": 3009,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 3010,
        "name_th": "โนนสูง",
        "name_en": "Non Sung",
        "province_id": 19,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 301001,
            "zip_code": 30160,
            "name_th": "โนนสูง",
            "name_en": "Non Sung",
            "district_id": 3010,
            "lat": 15.179,
            "long": 102.256,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 301002,
            "zip_code": 30160,
            "name_th": "ใหม่",
            "name_en": "Mai",
            "district_id": 3010,
            "lat": 15.152,
            "long": 102.287,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 301003,
            "zip_code": 30160,
            "name_th": "โตนด",
            "name_en": "Tanot",
            "district_id": 3010,
            "lat": 15.097,
            "long": 102.293,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 301004,
            "zip_code": 30160,
            "name_th": "บิง",
            "name_en": "Bing",
            "district_id": 3010,
            "lat": 15.118,
            "long": 102.333,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 301005,
            "zip_code": 30160,
            "name_th": "ดอนชมพู",
            "name_en": "Don Chomphu",
            "district_id": 3010,
            "lat": 15.171,
            "long": 102.339,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 301006,
            "zip_code": 30240,
            "name_th": "ธารปราสาท",
            "name_en": "Than Prasat",
            "district_id": 3010,
            "lat": 15.263,
            "long": 102.392,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 301007,
            "zip_code": 30160,
            "name_th": "หลุมข้าว",
            "name_en": "Lum Khao",
            "district_id": 3010,
            "lat": 15.224,
            "long": 102.313,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 301008,
            "zip_code": 30160,
            "name_th": "มะค่า",
            "name_en": "Makha",
            "district_id": 3010,
            "lat": 15.315,
            "long": 102.321,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 301009,
            "zip_code": 30160,
            "name_th": "พลสงคราม",
            "name_en": "Phon Songkhram",
            "district_id": 3010,
            "lat": 15.299,
            "long": 102.273,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 301010,
            "zip_code": 30160,
            "name_th": "จันอัด",
            "name_en": "Chan-at",
            "district_id": 3010,
            "lat": 15.161,
            "long": 102.158,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 301011,
            "zip_code": 30160,
            "name_th": "ขามเฒ่า",
            "name_en": "Kham Thao",
            "district_id": 3010,
            "lat": 15.305,
            "long": 102.219,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 301012,
            "zip_code": 30160,
            "name_th": "ด่านคล้า",
            "name_en": "Dan Khla",
            "district_id": 3010,
            "lat": 15.152,
            "long": 102.212,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 301013,
            "zip_code": 30160,
            "name_th": "ลำคอหงษ์",
            "name_en": "Lam Kho Hong",
            "district_id": 3010,
            "lat": 15.252,
            "long": 102.21,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 301014,
            "zip_code": 30160,
            "name_th": "เมืองปราสาท",
            "name_en": "Mueang Prasat",
            "district_id": 3010,
            "lat": 15.201,
            "long": 102.194,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 301015,
            "zip_code": 30160,
            "name_th": "ดอนหวาย",
            "name_en": "Don Wai",
            "district_id": 3010,
            "lat": 15.116,
            "long": 102.287,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 301016,
            "zip_code": 30160,
            "name_th": "ลำมูล",
            "name_en": "Lam Mun",
            "district_id": 3010,
            "lat": 15.072,
            "long": 102.308,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 3011,
        "name_th": "ขามสะแกแสง",
        "name_en": "Kham Sakaesaeng",
        "province_id": 19,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 301101,
            "zip_code": 30290,
            "name_th": "ขามสะแกแสง",
            "name_en": "Kham Sakaesaeng",
            "district_id": 3011,
            "lat": 15.36,
            "long": 102.195,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 301102,
            "zip_code": 30290,
            "name_th": "โนนเมือง",
            "name_en": "Non Mueang",
            "district_id": 3011,
            "lat": 15.416,
            "long": 102.116,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 301103,
            "zip_code": 30290,
            "name_th": "เมืองนาท",
            "name_en": "Mueang Nat",
            "district_id": 3011,
            "lat": 15.386,
            "long": 102.248,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 301104,
            "zip_code": 30290,
            "name_th": "ชีวึก",
            "name_en": "Chiwuek",
            "district_id": 3011,
            "lat": 15.351,
            "long": 102.099,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 301105,
            "zip_code": 30290,
            "name_th": "พะงาด",
            "name_en": "Pha-ngat",
            "district_id": 3011,
            "lat": 15.334,
            "long": 102.149,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 301106,
            "zip_code": 30290,
            "name_th": "หนองหัวฟาน",
            "name_en": "Nong Hua Fan",
            "district_id": 3011,
            "lat": 15.433,
            "long": 102.237,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 301107,
            "zip_code": 30290,
            "name_th": "เมืองเกษตร",
            "name_en": "Mueang Kaset",
            "district_id": 3011,
            "lat": 15.424,
            "long": 102.159,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 3012,
        "name_th": "บัวใหญ่",
        "name_en": "Bua Yai",
        "province_id": 19,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 301201,
            "zip_code": 30120,
            "name_th": "บัวใหญ่",
            "name_en": "Bua Yai",
            "district_id": 3012,
            "lat": 15.602,
            "long": 102.438,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 301203,
            "zip_code": 30120,
            "name_th": "ห้วยยาง",
            "name_en": "Huai Yang",
            "district_id": 3012,
            "lat": 15.626,
            "long": 102.363,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 301204,
            "zip_code": 30120,
            "name_th": "เสมาใหญ่",
            "name_en": "Sema Yai",
            "district_id": 3012,
            "lat": 15.516,
            "long": 102.429,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 301206,
            "zip_code": 30120,
            "name_th": "ดอนตะหนิน",
            "name_en": "Don Tanin",
            "district_id": 3012,
            "lat": 15.486,
            "long": 102.466,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 301207,
            "zip_code": 30120,
            "name_th": "หนองบัวสะอาด",
            "name_en": "Nong Bua Sa-at",
            "district_id": 3012,
            "lat": 15.593,
            "long": 102.3,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 301208,
            "zip_code": 30120,
            "name_th": "โนนทองหลาง",
            "name_en": "Non Thonglang",
            "district_id": 3012,
            "lat": 15.522,
            "long": 102.374,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 301209,
            "zip_code": 30120,
            "name_th": "หนองหว้า",
            "name_en": "Nong Wha",
            "district_id": 3012,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 301210,
            "zip_code": 30120,
            "name_th": "บัวลาย",
            "name_en": "Bua Lai",
            "district_id": 3012,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 301211,
            "zip_code": 30120,
            "name_th": "สีดา",
            "name_en": "Sri Da",
            "district_id": 3012,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 301212,
            "zip_code": 30120,
            "name_th": "โพนทอง",
            "name_en": "Pon Thong",
            "district_id": 3012,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 301214,
            "zip_code": 30120,
            "name_th": "กุดจอก",
            "name_en": "Kut Chok",
            "district_id": 3012,
            "lat": 15.571,
            "long": 102.502,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 301215,
            "zip_code": 30120,
            "name_th": "ด่านช้าง",
            "name_en": "Dan Chang",
            "district_id": 3012,
            "lat": 15.623,
            "long": 102.407,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 301216,
            "zip_code": 30120,
            "name_th": "โนนจาน",
            "name_en": "Non Jan",
            "district_id": 3012,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 301218,
            "zip_code": 30120,
            "name_th": "สามเมือง",
            "name_en": "Sam Muang",
            "district_id": 3012,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 301220,
            "zip_code": 30120,
            "name_th": "ขุนทอง",
            "name_en": "Khun Thong",
            "district_id": 3012,
            "lat": 15.683,
            "long": 102.364,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 301221,
            "zip_code": 30120,
            "name_th": "หนองตาดใหญ่",
            "name_en": "Nong Tad Yai",
            "district_id": 3012,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 301222,
            "zip_code": 30120,
            "name_th": "เมืองพะไล",
            "name_en": "Mueang Pa Lai",
            "district_id": 3012,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 301223,
            "zip_code": 30120,
            "name_th": "โนนประดู่",
            "name_en": "Non Pradoo",
            "district_id": 3012,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 301224,
            "zip_code": 30120,
            "name_th": "หนองแจ้งใหญ่",
            "name_en": "Nong Chaeng Yai",
            "district_id": 3012,
            "lat": 15.567,
            "long": 102.372,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 3013,
        "name_th": "ประทาย",
        "name_en": "Prathai",
        "province_id": 19,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 301301,
            "zip_code": 30180,
            "name_th": "ประทาย",
            "name_en": "Prathai",
            "district_id": 3013,
            "lat": 15.536,
            "long": 102.724,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 301303,
            "zip_code": 30180,
            "name_th": "กระทุ่มราย",
            "name_en": "Krathum Rai",
            "district_id": 3013,
            "lat": 15.53,
            "long": 102.659,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 301304,
            "zip_code": 30180,
            "name_th": "วังไม้แดง",
            "name_en": "Wang Mai Daeng",
            "district_id": 3013,
            "lat": 15.684,
            "long": 102.632,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 301306,
            "zip_code": 30180,
            "name_th": "ตลาดไทร",
            "name_en": "Talat Sai",
            "district_id": 3013,
            "lat": 15.528,
            "long": 102.78,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 301307,
            "zip_code": 30180,
            "name_th": "หนองพลวง",
            "name_en": "Nong Phluang",
            "district_id": 3013,
            "lat": 15.583,
            "long": 102.707,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 301308,
            "zip_code": 30180,
            "name_th": "หนองค่าย",
            "name_en": "Nong Khai",
            "district_id": 3013,
            "lat": 15.596,
            "long": 102.759,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 301309,
            "zip_code": 30180,
            "name_th": "หันห้วยทราย",
            "name_en": "Han Huai Sai",
            "district_id": 3013,
            "lat": 15.611,
            "long": 102.656,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 301310,
            "zip_code": 30180,
            "name_th": "ดอนมัน",
            "name_en": "Don Man",
            "district_id": 3013,
            "lat": 15.491,
            "long": 102.822,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 301313,
            "zip_code": 30180,
            "name_th": "นางรำ",
            "name_en": "Nang Ram",
            "district_id": 3013,
            "lat": 15.484,
            "long": 102.623,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 301314,
            "zip_code": 30180,
            "name_th": "โนนเพ็ด",
            "name_en": "Non Phet",
            "district_id": 3013,
            "lat": 15.677,
            "long": 102.684,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 301315,
            "zip_code": 30180,
            "name_th": "ทุ่งสว่าง",
            "name_en": "Thung Sawang",
            "district_id": 3013,
            "lat": 15.493,
            "long": 102.686,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 301317,
            "zip_code": 30180,
            "name_th": "โคกกลาง",
            "name_en": "Khok Klang",
            "district_id": 3013,
            "lat": 15.463,
            "long": 102.737,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 301318,
            "zip_code": 30180,
            "name_th": "เมืองโดน",
            "name_en": "Mueang Don",
            "district_id": 3013,
            "lat": 15.635,
            "long": 102.712,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 3014,
        "name_th": "ปักธงชัย",
        "name_en": "Pak Thong Chai",
        "province_id": 19,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 301401,
            "zip_code": 30150,
            "name_th": "เมืองปัก",
            "name_en": "Mueang Pak",
            "district_id": 3014,
            "lat": 14.719,
            "long": 102.055,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 301402,
            "zip_code": 30150,
            "name_th": "ตะคุ",
            "name_en": "Takhu",
            "district_id": 3014,
            "lat": 14.754,
            "long": 101.953,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 301403,
            "zip_code": 30150,
            "name_th": "โคกไทย",
            "name_en": "Khok Thai",
            "district_id": 3014,
            "lat": 14.741,
            "long": 102.09,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 301404,
            "zip_code": 30150,
            "name_th": "สำโรง",
            "name_en": "Samrong",
            "district_id": 3014,
            "lat": 14.65,
            "long": 102.063,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 301405,
            "zip_code": 30150,
            "name_th": "ตะขบ",
            "name_en": "Takhop",
            "district_id": 3014,
            "lat": 14.686,
            "long": 101.745,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 301406,
            "zip_code": 30150,
            "name_th": "นกออก",
            "name_en": "Nok Ok",
            "district_id": 3014,
            "lat": 14.686,
            "long": 102.036,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 301407,
            "zip_code": 30150,
            "name_th": "ดอน",
            "name_en": "Don",
            "district_id": 3014,
            "lat": 14.679,
            "long": 102.108,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 301409,
            "zip_code": 30150,
            "name_th": "ตูม",
            "name_en": "Tum",
            "district_id": 3014,
            "lat": 14.701,
            "long": 101.986,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 301410,
            "zip_code": 30150,
            "name_th": "งิ้ว",
            "name_en": "Ngio",
            "district_id": 3014,
            "lat": 14.666,
            "long": 101.997,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 301411,
            "zip_code": 30150,
            "name_th": "สะแกราช",
            "name_en": "Sakae Rat",
            "district_id": 3014,
            "lat": 14.604,
            "long": 102.048,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 301412,
            "zip_code": 30150,
            "name_th": "ลำนางแก้ว",
            "name_en": "Lam Nang Kaeo",
            "district_id": 3014,
            "lat": 14.563,
            "long": 101.87,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 301416,
            "zip_code": 30150,
            "name_th": "ภูหลวง",
            "name_en": "Phu Luang",
            "district_id": 3014,
            "lat": 14.602,
            "long": 101.984,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 301417,
            "zip_code": 30150,
            "name_th": "ธงชัยเหนือ",
            "name_en": "Thong Chai Nuea",
            "district_id": 3014,
            "lat": 14.793,
            "long": 102.034,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 301418,
            "zip_code": 30150,
            "name_th": "สุขเกษม",
            "name_en": "Suk Kasem",
            "district_id": 3014,
            "lat": 14.667,
            "long": 101.939,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 301419,
            "zip_code": 30150,
            "name_th": "เกษมทรัพย์",
            "name_en": "Kasem Sap",
            "district_id": 3014,
            "lat": 14.663,
            "long": 102.046,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 301420,
            "zip_code": 30150,
            "name_th": "บ่อปลาทอง",
            "name_en": "Bo Pla Thong",
            "district_id": 3014,
            "lat": 14.637,
            "long": 101.902,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 3015,
        "name_th": "พิมาย",
        "name_en": "Phimai",
        "province_id": 19,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 301501,
            "zip_code": 30110,
            "name_th": "ในเมือง",
            "name_en": "Nai Mueang",
            "district_id": 3015,
            "lat": 15.206,
            "long": 102.489,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 301502,
            "zip_code": 30110,
            "name_th": "สัมฤทธิ์",
            "name_en": "Samrit",
            "district_id": 3015,
            "lat": 15.216,
            "long": 102.424,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 301503,
            "zip_code": 30110,
            "name_th": "โบสถ์",
            "name_en": "Bot",
            "district_id": 3015,
            "lat": 15.215,
            "long": 102.628,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 301504,
            "zip_code": 30110,
            "name_th": "กระเบื้องใหญ่",
            "name_en": "Krabueang Yai",
            "district_id": 3015,
            "lat": 15.271,
            "long": 102.458,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 301505,
            "zip_code": 30110,
            "name_th": "ท่าหลวง",
            "name_en": "Tha Luang",
            "district_id": 3015,
            "lat": 15.282,
            "long": 102.547,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 301506,
            "zip_code": 30110,
            "name_th": "รังกาใหญ่",
            "name_en": "Rang Ka Yai",
            "district_id": 3015,
            "lat": 15.19,
            "long": 102.555,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 301507,
            "zip_code": 30110,
            "name_th": "ชีวาน",
            "name_en": "Chiwan",
            "district_id": 3015,
            "lat": 15.344,
            "long": 102.54,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 301508,
            "zip_code": 30110,
            "name_th": "นิคมสร้างตนเอง",
            "name_en": "Nikhom Sang Ton-eng",
            "district_id": 3015,
            "lat": 15.128,
            "long": 102.49,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 301509,
            "zip_code": 30110,
            "name_th": "กระชอน",
            "name_en": "Krachon",
            "district_id": 3015,
            "lat": 15.443,
            "long": 102.67,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 301510,
            "zip_code": 30110,
            "name_th": "ดงใหญ่",
            "name_en": "Dong Yai",
            "district_id": 3015,
            "lat": 15.338,
            "long": 102.591,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 301511,
            "zip_code": 30110,
            "name_th": "ธารละหลอด",
            "name_en": "Than Lalot",
            "district_id": 3015,
            "lat": 15.162,
            "long": 102.403,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 301512,
            "zip_code": 30110,
            "name_th": "หนองระเวียง",
            "name_en": "Nong Rawiang",
            "district_id": 3015,
            "lat": 15.113,
            "long": 102.44,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 3016,
        "name_th": "ห้วยแถลง",
        "name_en": "Huai Thalaeng",
        "province_id": 19,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 301601,
            "zip_code": 30240,
            "name_th": "ห้วยแถลง",
            "name_en": "Huai Thalaeng",
            "district_id": 3016,
            "lat": 14.967,
            "long": 102.652,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 301602,
            "zip_code": 30240,
            "name_th": "ทับสวาย",
            "name_en": "Thap Sawai",
            "district_id": 3016,
            "lat": 15.021,
            "long": 102.634,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 301603,
            "zip_code": 30240,
            "name_th": "เมืองพลับพลา",
            "name_en": "Mueang Phlapphla",
            "district_id": 3016,
            "lat": 15.063,
            "long": 102.634,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 301604,
            "zip_code": 30240,
            "name_th": "หลุ่งตะเคียน",
            "name_en": "Lung Takhian",
            "district_id": 3016,
            "lat": 15.12,
            "long": 102.638,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 301605,
            "zip_code": 30240,
            "name_th": "หินดาด",
            "name_en": "Hin Dat",
            "district_id": 3016,
            "lat": 14.995,
            "long": 102.565,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 301606,
            "zip_code": 30240,
            "name_th": "งิ้ว",
            "name_en": "Ngio",
            "district_id": 3016,
            "lat": 15.077,
            "long": 102.689,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 301607,
            "zip_code": 30240,
            "name_th": "กงรถ",
            "name_en": "Kong Rot",
            "district_id": 3016,
            "lat": 15.047,
            "long": 102.752,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 301608,
            "zip_code": 30240,
            "name_th": "หลุ่งประดู่",
            "name_en": "Lung Pradu",
            "district_id": 3016,
            "lat": 15.06,
            "long": 102.582,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 301609,
            "zip_code": 30240,
            "name_th": "ตะโก",
            "name_en": "Tako",
            "district_id": 3016,
            "lat": 15.019,
            "long": 102.718,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 301610,
            "zip_code": 30240,
            "name_th": "ห้วยแคน",
            "name_en": "Huai Khaen",
            "district_id": 3016,
            "lat": 14.985,
            "long": 102.687,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 3017,
        "name_th": "ชุมพวง",
        "name_en": "Chum Phuang",
        "province_id": 19,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 301701,
            "zip_code": 30270,
            "name_th": "ชุมพวง",
            "name_en": "Chum Phuang",
            "district_id": 3017,
            "lat": 15.344,
            "long": 102.75,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 301702,
            "zip_code": 30270,
            "name_th": "ประสุข",
            "name_en": "Prasuk",
            "district_id": 3017,
            "lat": 15.342,
            "long": 102.685,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 301703,
            "zip_code": 30270,
            "name_th": "ท่าลาด",
            "name_en": "Tha Lat",
            "district_id": 3017,
            "lat": 15.243,
            "long": 102.72,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 301704,
            "zip_code": 30270,
            "name_th": "สาหร่าย",
            "name_en": "Sarai",
            "district_id": 3017,
            "lat": 15.184,
            "long": 102.735,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 301705,
            "zip_code": 30270,
            "name_th": "ตลาดไทร",
            "name_en": "Talat Sai",
            "district_id": 3017,
            "lat": 15.109,
            "long": 102.773,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 301706,
            "zip_code": 30270,
            "name_th": "ช่องแมว",
            "name_en": "Chong Maew",
            "district_id": 3017,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 301707,
            "zip_code": 30270,
            "name_th": "ขุย",
            "name_en": "Kui",
            "district_id": 3017,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 301710,
            "zip_code": 30270,
            "name_th": "โนนรัง",
            "name_en": "Non Rang",
            "district_id": 3017,
            "lat": 15.258,
            "long": 102.81,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 301711,
            "zip_code": 30270,
            "name_th": "บ้านยาง",
            "name_en": "Ban Yang",
            "district_id": 3017,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 301714,
            "zip_code": 30270,
            "name_th": "หนองหลัก",
            "name_en": "Nong Lak",
            "district_id": 3017,
            "lat": 15.411,
            "long": 102.732,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 301715,
            "zip_code": 30270,
            "name_th": "ไพล",
            "name_en": "Plai",
            "district_id": 3017,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 301716,
            "zip_code": 30270,
            "name_th": "โนนตูม",
            "name_en": "Non Tum",
            "district_id": 3017,
            "lat": 15.167,
            "long": 102.769,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 301717,
            "zip_code": 30270,
            "name_th": "โนนยอ",
            "name_en": "Non Yo",
            "district_id": 3017,
            "lat": 15.339,
            "long": 102.828,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 3018,
        "name_th": "สูงเนิน",
        "name_en": "Sung Noen",
        "province_id": 19,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 301801,
            "zip_code": 30170,
            "name_th": "สูงเนิน",
            "name_en": "Sung Noen",
            "district_id": 3018,
            "lat": 14.861,
            "long": 101.842,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 301802,
            "zip_code": 30170,
            "name_th": "เสมา",
            "name_en": "Sema",
            "district_id": 3018,
            "lat": 14.982,
            "long": 101.777,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 301803,
            "zip_code": 30170,
            "name_th": "โคราช",
            "name_en": "Khorat",
            "district_id": 3018,
            "lat": 14.909,
            "long": 101.851,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 301804,
            "zip_code": 30170,
            "name_th": "บุ่งขี้เหล็ก",
            "name_en": "Bung Khilek",
            "district_id": 3018,
            "lat": 14.952,
            "long": 101.839,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 301805,
            "zip_code": 30170,
            "name_th": "โนนค่า",
            "name_en": "Non Kha",
            "district_id": 3018,
            "lat": 15.034,
            "long": 101.84,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 301806,
            "zip_code": 30170,
            "name_th": "โค้งยาง",
            "name_en": "Khong Yang",
            "district_id": 3018,
            "lat": 14.922,
            "long": 101.903,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 301807,
            "zip_code": 30170,
            "name_th": "มะเกลือเก่า",
            "name_en": "Makluea Kao",
            "district_id": 3018,
            "lat": 14.779,
            "long": 101.805,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 301808,
            "zip_code": 30170,
            "name_th": "มะเกลือใหม่",
            "name_en": "Makluea Mai",
            "district_id": 3018,
            "lat": 14.798,
            "long": 101.728,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 301809,
            "zip_code": 30380,
            "name_th": "นากลาง",
            "name_en": "Na Klang",
            "district_id": 3018,
            "lat": 14.855,
            "long": 101.942,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 301810,
            "zip_code": 30380,
            "name_th": "หนองตะไก้",
            "name_en": "Nong Takai",
            "district_id": 3018,
            "lat": 14.79,
            "long": 101.895,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 301811,
            "zip_code": 30380,
            "name_th": "กุดจิก",
            "name_en": "Kut Chik",
            "district_id": 3018,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 3019,
        "name_th": "ขามทะเลสอ",
        "name_en": "Kham Thale So",
        "province_id": 19,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 301901,
            "zip_code": 30280,
            "name_th": "ขามทะเลสอ",
            "name_en": "Kham Thale So",
            "district_id": 3019,
            "lat": 14.974,
            "long": 101.959,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 301902,
            "zip_code": 30280,
            "name_th": "โป่งแดง",
            "name_en": "Pong Daeng",
            "district_id": 3019,
            "lat": 14.97,
            "long": 101.916,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 301903,
            "zip_code": 30280,
            "name_th": "พันดุง",
            "name_en": "Phan Dung",
            "district_id": 3019,
            "lat": 15.069,
            "long": 101.952,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 301904,
            "zip_code": 30280,
            "name_th": "หนองสรวง",
            "name_en": "Nong Suang",
            "district_id": 3019,
            "lat": 15.086,
            "long": 101.894,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 301905,
            "zip_code": 30280,
            "name_th": "บึงอ้อ",
            "name_en": "Bueng O",
            "district_id": 3019,
            "lat": 15.028,
            "long": 101.932,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 3020,
        "name_th": "สีคิ้ว",
        "name_en": "Sikhio",
        "province_id": 19,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 302001,
            "zip_code": 30140,
            "name_th": "สีคิ้ว",
            "name_en": "Sikhio",
            "district_id": 3020,
            "lat": 14.905,
            "long": 101.687,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 302002,
            "zip_code": 30140,
            "name_th": "บ้านหัน",
            "name_en": "Ban Han",
            "district_id": 3020,
            "lat": 14.985,
            "long": 101.75,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 302003,
            "zip_code": 30140,
            "name_th": "กฤษณา",
            "name_en": "Kritsana",
            "district_id": 3020,
            "lat": 15.046,
            "long": 101.556,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 302004,
            "zip_code": 30340,
            "name_th": "ลาดบัวขาว",
            "name_en": "Lat Bua Khao",
            "district_id": 3020,
            "lat": 14.823,
            "long": 101.629,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 302005,
            "zip_code": 30140,
            "name_th": "หนองหญ้าขาว",
            "name_en": "Nong Ya Khao",
            "district_id": 3020,
            "lat": 14.959,
            "long": 101.574,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 302006,
            "zip_code": 30140,
            "name_th": "กุดน้อย",
            "name_en": "Kut Noi",
            "district_id": 3020,
            "lat": 14.931,
            "long": 101.753,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 302007,
            "zip_code": 30140,
            "name_th": "หนองน้ำใส",
            "name_en": "Nong Nam Sai",
            "district_id": 3020,
            "lat": 14.932,
            "long": 101.485,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 302008,
            "zip_code": 30140,
            "name_th": "วังโรงใหญ่",
            "name_en": "Wang Rong Yai",
            "district_id": 3020,
            "lat": 15.045,
            "long": 101.659,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 302009,
            "zip_code": 30140,
            "name_th": "มิตรภาพ",
            "name_en": "Mittraphap",
            "district_id": 3020,
            "lat": 14.797,
            "long": 101.685,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 302010,
            "zip_code": 30340,
            "name_th": "คลองไผ่",
            "name_en": "Khlong Phai",
            "district_id": 3020,
            "lat": 14.883,
            "long": 101.515,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 302011,
            "zip_code": 30140,
            "name_th": "ดอนเมือง",
            "name_en": "Don Mueang",
            "district_id": 3020,
            "lat": 15.02,
            "long": 101.456,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 302012,
            "zip_code": 30140,
            "name_th": "หนองบัวน้อย",
            "name_en": "Nong Bua Noi",
            "district_id": 3020,
            "lat": 15.047,
            "long": 101.76,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 3021,
        "name_th": "ปากช่อง",
        "name_en": "Pak Chong",
        "province_id": 19,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 302101,
            "zip_code": 30130,
            "name_th": "ปากช่อง",
            "name_en": "Pak Chong",
            "district_id": 3021,
            "lat": 14.722,
            "long": 101.363,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 302102,
            "zip_code": 30320,
            "name_th": "กลางดง",
            "name_en": "Klang Dong",
            "district_id": 3021,
            "lat": 14.65,
            "long": 101.283,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 302103,
            "zip_code": 30130,
            "name_th": "จันทึก",
            "name_en": "Chanthuek",
            "district_id": 3021,
            "lat": 14.806,
            "long": 101.456,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 302104,
            "zip_code": 30130,
            "name_th": "วังกะทะ",
            "name_en": "Wang Katha",
            "district_id": 3021,
            "lat": 14.536,
            "long": 101.64,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 302105,
            "zip_code": 30130,
            "name_th": "หมูสี",
            "name_en": "Mu Si",
            "district_id": 3021,
            "lat": 14.501,
            "long": 101.402,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 302106,
            "zip_code": 30130,
            "name_th": "หนองสาหร่าย",
            "name_en": "Nong Sarai",
            "district_id": 3021,
            "lat": 14.689,
            "long": 101.488,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 302107,
            "zip_code": 30130,
            "name_th": "ขนงพระ",
            "name_en": "Khanong Phra",
            "district_id": 3021,
            "lat": 14.594,
            "long": 101.53,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 302108,
            "zip_code": 30130,
            "name_th": "โป่งตาลอง",
            "name_en": "Pong Talong",
            "district_id": 3021,
            "lat": 14.472,
            "long": 101.605,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 302109,
            "zip_code": 30130,
            "name_th": "คลองม่วง",
            "name_en": "Khlong Muang",
            "district_id": 3021,
            "lat": 14.647,
            "long": 101.649,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 302110,
            "zip_code": 30130,
            "name_th": "หนองน้ำแดง",
            "name_en": "Nong Nam Daeng",
            "district_id": 3021,
            "lat": 14.613,
            "long": 101.398,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 302111,
            "zip_code": 30130,
            "name_th": "วังไทร",
            "name_en": "Wang Sai",
            "district_id": 3021,
            "lat": 14.706,
            "long": 101.573,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 302112,
            "zip_code": 30320,
            "name_th": "พญาเย็น",
            "name_en": "Phaya Yen",
            "district_id": 3021,
            "lat": 14.548,
            "long": 101.246,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 3022,
        "name_th": "หนองบุญมาก",
        "name_en": "Nong Bunnak",
        "province_id": 19,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 302201,
            "zip_code": 30410,
            "name_th": "หนองบุนนาก",
            "name_en": "Nong Bunnak",
            "district_id": 3022,
            "lat": 14.609,
            "long": 102.4,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 302202,
            "zip_code": 30410,
            "name_th": "สารภี",
            "name_en": "Saraphi",
            "district_id": 3022,
            "lat": 14.814,
            "long": 102.417,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 302203,
            "zip_code": 30410,
            "name_th": "ไทยเจริญ",
            "name_en": "Thai Charoen",
            "district_id": 3022,
            "lat": 14.743,
            "long": 102.45,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 302204,
            "zip_code": 30410,
            "name_th": "หนองหัวแรต",
            "name_en": "Nong Hua Raet",
            "district_id": 3022,
            "lat": 14.715,
            "long": 102.332,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 302205,
            "zip_code": 30410,
            "name_th": "แหลมทอง",
            "name_en": "Laem Thong",
            "district_id": 3022,
            "lat": 14.78,
            "long": 102.304,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 302206,
            "zip_code": 30410,
            "name_th": "หนองตะไก้",
            "name_en": "Nong Takai",
            "district_id": 3022,
            "lat": 14.654,
            "long": 102.397,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 302207,
            "zip_code": 30410,
            "name_th": "ลุงเขว้า",
            "name_en": "Lung Khwao",
            "district_id": 3022,
            "lat": 14.813,
            "long": 102.339,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 302208,
            "zip_code": 30410,
            "name_th": "หนองไม้ไผ่",
            "name_en": "Nong Mai Phai",
            "district_id": 3022,
            "lat": 14.641,
            "long": 102.32,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 302209,
            "zip_code": 30410,
            "name_th": "บ้านใหม่",
            "name_en": "Ban Mai",
            "district_id": 3022,
            "lat": 14.754,
            "long": 102.398,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 3023,
        "name_th": "แก้งสนามนาง",
        "name_en": "Kaeng Sanam Nang",
        "province_id": 19,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 302301,
            "zip_code": 30440,
            "name_th": "แก้งสนามนาง",
            "name_en": "Kaeng Sanam Nang",
            "district_id": 3023,
            "lat": 15.727,
            "long": 102.277,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 302302,
            "zip_code": 30440,
            "name_th": "โนนสำราญ",
            "name_en": "Non Samran",
            "district_id": 3023,
            "lat": 15.75,
            "long": 102.325,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 302303,
            "zip_code": 30440,
            "name_th": "บึงพะไล",
            "name_en": "Bueng Phalai",
            "district_id": 3023,
            "lat": 15.661,
            "long": 102.236,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 302304,
            "zip_code": 30440,
            "name_th": "สีสุก",
            "name_en": "Si Suk",
            "district_id": 3023,
            "lat": 15.64,
            "long": 102.175,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 302305,
            "zip_code": 30440,
            "name_th": "บึงสำโรง",
            "name_en": "Bueng Samrong",
            "district_id": 3023,
            "lat": 15.715,
            "long": 102.198,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 3024,
        "name_th": "โนนแดง",
        "name_en": "Non Daeng",
        "province_id": 19,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 302401,
            "zip_code": 30360,
            "name_th": "โนนแดง",
            "name_en": "Non Daeng",
            "district_id": 3024,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 302402,
            "zip_code": 30360,
            "name_th": "โนนตาเถร",
            "name_en": "Non Ta Then",
            "district_id": 3024,
            "lat": 15.435,
            "long": 102.488,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 302403,
            "zip_code": 30360,
            "name_th": "สำพะเนียง",
            "name_en": "Samphaniang",
            "district_id": 3024,
            "lat": 15.452,
            "long": 102.568,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 302404,
            "zip_code": 30360,
            "name_th": "วังหิน",
            "name_en": "Wang Hin",
            "district_id": 3024,
            "lat": 15.505,
            "long": 102.567,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 302405,
            "zip_code": 30360,
            "name_th": "ดอนยาวใหญ่",
            "name_en": "Don Yao Yai",
            "district_id": 3024,
            "lat": 15.41,
            "long": 102.536,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 3025,
        "name_th": "วังน้ำเขียว",
        "name_en": "Wang Nam Khiao",
        "province_id": 19,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 302501,
            "zip_code": 30370,
            "name_th": "วังน้ำเขียว",
            "name_en": "Wang Nam Khiao",
            "district_id": 3025,
            "lat": 14.399,
            "long": 101.817,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 302502,
            "zip_code": 30370,
            "name_th": "วังหมี",
            "name_en": "Wang Mi",
            "district_id": 3025,
            "lat": 14.474,
            "long": 101.769,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 302503,
            "zip_code": 30150,
            "name_th": "ระเริง",
            "name_en": "Raroeng",
            "district_id": 3025,
            "lat": 14.574,
            "long": 101.731,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 302504,
            "zip_code": 30370,
            "name_th": "อุดมทรัพย์",
            "name_en": "Udom Sap",
            "district_id": 3025,
            "lat": 14.49,
            "long": 101.969,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 302505,
            "zip_code": 30370,
            "name_th": "ไทยสามัคคี",
            "name_en": "Thai Samakkhi",
            "district_id": 3025,
            "lat": 14.353,
            "long": 101.966,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 3026,
        "name_th": "เทพารักษ์",
        "name_en": "Thepharak",
        "province_id": 19,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 302601,
            "zip_code": 30210,
            "name_th": "สำนักตะคร้อ",
            "name_en": "Samnak Takhro",
            "district_id": 3026,
            "lat": 15.297,
            "long": 101.564,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 302602,
            "zip_code": 30210,
            "name_th": "หนองแวง",
            "name_en": "Nong Waeng",
            "district_id": 3026,
            "lat": 15.256,
            "long": 101.436,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 302603,
            "zip_code": 30210,
            "name_th": "บึงปรือ",
            "name_en": "Bueng Prue",
            "district_id": 3026,
            "lat": 15.303,
            "long": 101.411,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 302604,
            "zip_code": 30210,
            "name_th": "วังยายทอง",
            "name_en": "Wang Yai Thong",
            "district_id": 3026,
            "lat": 15.349,
            "long": 101.518,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 3027,
        "name_th": "เมืองยาง",
        "name_en": "Mueang Yang",
        "province_id": 19,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 302701,
            "zip_code": 30270,
            "name_th": "เมืองยาง",
            "name_en": "Mueang Yang",
            "district_id": 3027,
            "lat": 15.418,
            "long": 102.886,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 302702,
            "zip_code": 30270,
            "name_th": "กระเบื้องนอก",
            "name_en": "Krabueang Nok",
            "district_id": 3027,
            "lat": 15.44,
            "long": 102.957,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 302703,
            "zip_code": 30270,
            "name_th": "ละหานปลาค้าว",
            "name_en": "Lahan Pla Khao",
            "district_id": 3027,
            "lat": 15.487,
            "long": 102.889,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 302704,
            "zip_code": 30270,
            "name_th": "โนนอุดม",
            "name_en": "Non Udom",
            "district_id": 3027,
            "lat": 15.426,
            "long": 102.812,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 3028,
        "name_th": "พระทองคำ",
        "name_en": "Phra Thong Kham",
        "province_id": 19,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 302801,
            "zip_code": 30220,
            "name_th": "สระพระ",
            "name_en": "Sa Phra",
            "district_id": 3028,
            "lat": 15.311,
            "long": 101.959,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 302802,
            "zip_code": 30220,
            "name_th": "มาบกราด",
            "name_en": "Map Krat",
            "district_id": 3028,
            "lat": 15.369,
            "long": 101.926,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 302803,
            "zip_code": 30220,
            "name_th": "พังเทียม",
            "name_en": "Phang Thiam",
            "district_id": 3028,
            "lat": 15.275,
            "long": 101.995,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 302804,
            "zip_code": 30220,
            "name_th": "ทัพรั้ง",
            "name_en": "Thap Rang",
            "district_id": 3028,
            "lat": 15.406,
            "long": 101.976,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 302805,
            "zip_code": 30220,
            "name_th": "หนองหอย",
            "name_en": "Nong Hoi",
            "district_id": 3028,
            "lat": 15.334,
            "long": 102.056,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 3029,
        "name_th": "ลำทะเมนชัย",
        "name_en": "Lam Thamenchai",
        "province_id": 19,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 302901,
            "zip_code": 30270,
            "name_th": "ขุย",
            "name_en": "Khui",
            "district_id": 3029,
            "lat": 15.353,
            "long": 102.866,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 302902,
            "zip_code": 30270,
            "name_th": "บ้านยาง",
            "name_en": "Ban Yang",
            "district_id": 3029,
            "lat": 15.25,
            "long": 102.944,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 302903,
            "zip_code": 30270,
            "name_th": "ช่องแมว",
            "name_en": "Chong Maeo",
            "district_id": 3029,
            "lat": 15.276,
            "long": 102.874,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 302904,
            "zip_code": 30270,
            "name_th": "ไพล",
            "name_en": "Phlai",
            "district_id": 3029,
            "lat": 15.36,
            "long": 102.971,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 3030,
        "name_th": "บัวลาย",
        "name_en": "Bua Lai",
        "province_id": 19,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 303001,
            "zip_code": 30120,
            "name_th": "เมืองพะไล",
            "name_en": "Mueang Phalai",
            "district_id": 3030,
            "lat": 15.649,
            "long": 102.532,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 303002,
            "zip_code": 30120,
            "name_th": "โนนจาน",
            "name_en": "Non Chan",
            "district_id": 3030,
            "lat": 15.699,
            "long": 102.472,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 303003,
            "zip_code": 30120,
            "name_th": "บัวลาย",
            "name_en": "Bua Lai",
            "district_id": 3030,
            "lat": 15.661,
            "long": 102.468,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 303004,
            "zip_code": 30120,
            "name_th": "หนองหว้า",
            "name_en": "Nong Wa",
            "district_id": 3030,
            "lat": 15.667,
            "long": 102.573,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 3031,
        "name_th": "สีดา",
        "name_en": "Sida",
        "province_id": 19,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 303101,
            "zip_code": 30430,
            "name_th": "สีดา",
            "name_en": "Sida",
            "district_id": 3031,
            "lat": 15.564,
            "long": 102.588,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 303102,
            "zip_code": 30430,
            "name_th": "โพนทอง",
            "name_en": "Phon Thong",
            "district_id": 3031,
            "lat": 15.54,
            "long": 102.59,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 303103,
            "zip_code": 30430,
            "name_th": "โนนประดู่",
            "name_en": "Non Pradu",
            "district_id": 3031,
            "lat": 15.521,
            "long": 102.479,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 303104,
            "zip_code": 30430,
            "name_th": "สามเมือง",
            "name_en": "Sam Mueang",
            "district_id": 3031,
            "lat": 15.591,
            "long": 102.537,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 303105,
            "zip_code": 30430,
            "name_th": "หนองตาดใหญ่",
            "name_en": "Nong Tat Yai",
            "district_id": 3031,
            "lat": 15.617,
            "long": 102.591,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 3032,
        "name_th": "เฉลิมพระเกียรติ",
        "name_en": "Chaloem Phra Kiat",
        "province_id": 19,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 303201,
            "zip_code": 30230,
            "name_th": "ช้างทอง",
            "name_en": "Chang Thong",
            "district_id": 3032,
            "lat": 15.029,
            "long": 102.31,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 303202,
            "zip_code": 30230,
            "name_th": "ท่าช้าง",
            "name_en": "Tha Chang",
            "district_id": 3032,
            "lat": 14.981,
            "long": 102.323,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 303203,
            "zip_code": 30230,
            "name_th": "พระพุทธ",
            "name_en": "Phra Phut",
            "district_id": 3032,
            "lat": 14.975,
            "long": 102.232,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 303204,
            "zip_code": 30000,
            "name_th": "หนองงูเหลือม",
            "name_en": "Nong Ngu Lueam",
            "district_id": 3032,
            "lat": 15.053,
            "long": 102.234,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 303205,
            "zip_code": 30230,
            "name_th": "หนองยาง",
            "name_en": "Nong Yang",
            "district_id": 3032,
            "lat": 14.93,
            "long": 102.287,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      }
    ]
  },
  {
    "id": 20,
    "name_th": "บุรีรัมย์",
    "name_en": "Buri Ram",
    "geography_id": 3,
    "created_at": "2019-08-09T03:33:09.000+07:00",
    "updated_at": "2025-09-20T06:31:26.000+07:00",
    "deleted_at": null,
    "districts": [
      {
        "id": 3101,
        "name_th": "เมืองบุรีรัมย์",
        "name_en": "Mueang Buri Ram",
        "province_id": 20,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 310101,
            "zip_code": 31000,
            "name_th": "ในเมือง",
            "name_en": "Nai Mueang",
            "district_id": 3101,
            "lat": 14.999,
            "long": 103.104,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 310102,
            "zip_code": 31000,
            "name_th": "อิสาณ",
            "name_en": "Isan",
            "district_id": 3101,
            "lat": 14.979,
            "long": 103.128,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 310103,
            "zip_code": 31000,
            "name_th": "เสม็ด",
            "name_en": "Samet",
            "district_id": 3101,
            "lat": 14.941,
            "long": 103.098,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 310104,
            "zip_code": 31000,
            "name_th": "บ้านบัว",
            "name_en": "Ban Bua",
            "district_id": 3101,
            "lat": 14.949,
            "long": 102.997,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 310105,
            "zip_code": 31000,
            "name_th": "สะแกโพรง",
            "name_en": "Sakae Phrong",
            "district_id": 3101,
            "lat": 14.853,
            "long": 102.942,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 310106,
            "zip_code": 31000,
            "name_th": "สวายจีก",
            "name_en": "Sawai Chik",
            "district_id": 3101,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 310108,
            "zip_code": 31000,
            "name_th": "บ้านยาง",
            "name_en": "Ban Yang",
            "district_id": 3101,
            "lat": 15.018,
            "long": 103.156,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 310112,
            "zip_code": 31000,
            "name_th": "พระครู",
            "name_en": "Phra Khru",
            "district_id": 3101,
            "lat": 15.099,
            "long": 103.018,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 310113,
            "zip_code": 31000,
            "name_th": "ถลุงเหล็ก",
            "name_en": "Thalung Lek",
            "district_id": 3101,
            "lat": 15.116,
            "long": 103.078,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 310114,
            "zip_code": 31000,
            "name_th": "หนองตาด",
            "name_en": "Nong Tat",
            "district_id": 3101,
            "lat": 15.031,
            "long": 103.024,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 310117,
            "zip_code": 31000,
            "name_th": "ลุมปุ๊ก",
            "name_en": "Lumpuk",
            "district_id": 3101,
            "lat": 14.908,
            "long": 102.951,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 310118,
            "zip_code": 31000,
            "name_th": "สองห้อง",
            "name_en": "Song Hong",
            "district_id": 3101,
            "lat": 14.808,
            "long": 102.953,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 310119,
            "zip_code": 31000,
            "name_th": "บัวทอง",
            "name_en": "Bua Thong",
            "district_id": 3101,
            "lat": 15.058,
            "long": 103.136,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 310120,
            "zip_code": 31000,
            "name_th": "ชุมเห็ด",
            "name_en": "Chum Het",
            "district_id": 3101,
            "lat": 15.033,
            "long": 103.093,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 310122,
            "zip_code": 31000,
            "name_th": "หลักเขต",
            "name_en": "Lak Khet",
            "district_id": 3101,
            "lat": 14.824,
            "long": 103.159,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 310125,
            "zip_code": 31000,
            "name_th": "สะแกซำ",
            "name_en": "Sakae Sam",
            "district_id": 3101,
            "lat": 14.871,
            "long": 103.099,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 310126,
            "zip_code": 31000,
            "name_th": "กลันทา",
            "name_en": "Kalantha",
            "district_id": 3101,
            "lat": 15.095,
            "long": 103.109,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 310127,
            "zip_code": 31000,
            "name_th": "กระสัง",
            "name_en": "Krasang",
            "district_id": 3101,
            "lat": 14.974,
            "long": 103.047,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 310128,
            "zip_code": 31000,
            "name_th": "เมืองฝาง",
            "name_en": "Mueang Fang",
            "district_id": 3101,
            "lat": 14.782,
            "long": 102.982,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 3102,
        "name_th": "คูเมือง",
        "name_en": "Khu Mueang",
        "province_id": 20,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 310201,
            "zip_code": 31190,
            "name_th": "คูเมือง",
            "name_en": "Khu Mueang",
            "district_id": 3102,
            "lat": 15.24,
            "long": 103.0,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 310202,
            "zip_code": 31190,
            "name_th": "ปะเคียบ",
            "name_en": "Pakhiap",
            "district_id": 3102,
            "lat": 15.391,
            "long": 103.054,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 310203,
            "zip_code": 31190,
            "name_th": "บ้านแพ",
            "name_en": "Ban Phae",
            "district_id": 3102,
            "lat": 15.388,
            "long": 103.008,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 310204,
            "zip_code": 31190,
            "name_th": "พรสำราญ",
            "name_en": "Phon Samran",
            "district_id": 3102,
            "lat": 15.169,
            "long": 103.027,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 310205,
            "zip_code": 31190,
            "name_th": "หินเหล็กไฟ",
            "name_en": "Hin Lek Fai",
            "district_id": 3102,
            "lat": 15.157,
            "long": 103.064,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 310206,
            "zip_code": 31190,
            "name_th": "ตูมใหญ่",
            "name_en": "Tum Yai",
            "district_id": 3102,
            "lat": 15.165,
            "long": 103.137,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 310207,
            "zip_code": 31190,
            "name_th": "หนองขมาร",
            "name_en": "Nong Khaman",
            "district_id": 3102,
            "lat": 15.314,
            "long": 102.995,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 3103,
        "name_th": "กระสัง",
        "name_en": "Krasang",
        "province_id": 20,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 310301,
            "zip_code": 31160,
            "name_th": "กระสัง",
            "name_en": "Krasang",
            "district_id": 3103,
            "lat": 14.922,
            "long": 103.296,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 310302,
            "zip_code": 31160,
            "name_th": "ลำดวน",
            "name_en": "Lamduan",
            "district_id": 3103,
            "lat": 15.061,
            "long": 103.403,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 310303,
            "zip_code": 31160,
            "name_th": "สองชั้น",
            "name_en": "Song Chan",
            "district_id": 3103,
            "lat": 14.887,
            "long": 103.224,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 310304,
            "zip_code": 31160,
            "name_th": "สูงเนิน",
            "name_en": "Sung Noen",
            "district_id": 3103,
            "lat": 14.82,
            "long": 103.239,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 310305,
            "zip_code": 31160,
            "name_th": "หนองเต็ง",
            "name_en": "Nong Teng",
            "district_id": 3103,
            "lat": 14.905,
            "long": 103.374,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 310306,
            "zip_code": 31160,
            "name_th": "เมืองไผ่",
            "name_en": "Mueang Phai",
            "district_id": 3103,
            "lat": 14.994,
            "long": 103.292,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 310307,
            "zip_code": 31160,
            "name_th": "ชุมแสง",
            "name_en": "Chum Saeng",
            "district_id": 3103,
            "lat": 14.984,
            "long": 103.395,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 310308,
            "zip_code": 31160,
            "name_th": "บ้านปรือ",
            "name_en": "Ban Prue",
            "district_id": 3103,
            "lat": 14.848,
            "long": 103.299,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 310309,
            "zip_code": 31160,
            "name_th": "ห้วยสำราญ",
            "name_en": "Huai Samran",
            "district_id": 3103,
            "lat": 15.072,
            "long": 103.336,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 310310,
            "zip_code": 31160,
            "name_th": "กันทรารมย์",
            "name_en": "Kanthararom",
            "district_id": 3103,
            "lat": 14.966,
            "long": 103.34,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 310311,
            "zip_code": 31160,
            "name_th": "ศรีภูมิ",
            "name_en": "Si Phum",
            "district_id": 3103,
            "lat": 15.027,
            "long": 103.338,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 3104,
        "name_th": "นางรอง",
        "name_en": "Nang Rong",
        "province_id": 20,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 310401,
            "zip_code": 31110,
            "name_th": "นางรอง",
            "name_en": "Nang Rong",
            "district_id": 3104,
            "lat": 14.673,
            "long": 102.806,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 310403,
            "zip_code": 31110,
            "name_th": "สะเดา",
            "name_en": "Sadao",
            "district_id": 3104,
            "lat": 14.577,
            "long": 102.77,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 310405,
            "zip_code": 31110,
            "name_th": "ชุมแสง",
            "name_en": "Chum Saeng",
            "district_id": 3104,
            "lat": 14.561,
            "long": 102.666,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 310406,
            "zip_code": 31110,
            "name_th": "หนองโบสถ์",
            "name_en": "Nong Bot",
            "district_id": 3104,
            "lat": 14.612,
            "long": 102.691,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 310408,
            "zip_code": 31110,
            "name_th": "หนองกง",
            "name_en": "Nong Kong",
            "district_id": 3104,
            "lat": 14.674,
            "long": 102.896,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 310413,
            "zip_code": 31110,
            "name_th": "ถนนหัก",
            "name_en": "Thanon Hak",
            "district_id": 3104,
            "lat": 14.616,
            "long": 102.833,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 310414,
            "zip_code": 31110,
            "name_th": "หนองไทร",
            "name_en": "Nong Sai",
            "district_id": 3104,
            "lat": 14.499,
            "long": 102.757,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 310415,
            "zip_code": 31110,
            "name_th": "ก้านเหลือง",
            "name_en": "Kan Lueang",
            "district_id": 3104,
            "lat": 14.73,
            "long": 102.711,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 310416,
            "zip_code": 31110,
            "name_th": "บ้านสิงห์",
            "name_en": "Ban Sing",
            "district_id": 3104,
            "lat": 14.735,
            "long": 102.789,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 310417,
            "zip_code": 31110,
            "name_th": "ลำไทรโยง",
            "name_en": "Lam Sai Yong",
            "district_id": 3104,
            "lat": 14.665,
            "long": 102.735,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 310418,
            "zip_code": 31110,
            "name_th": "ทรัพย์พระยา",
            "name_en": "Sap Phraya",
            "district_id": 3104,
            "lat": 14.516,
            "long": 102.662,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 310424,
            "zip_code": 31110,
            "name_th": "หนองยายพิมพ์",
            "name_en": "Nong Yai Phim",
            "district_id": 3104,
            "lat": 14.69,
            "long": 102.863,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 310425,
            "zip_code": 31110,
            "name_th": "หัวถนน",
            "name_en": "Hua Thanon",
            "district_id": 3104,
            "lat": 14.661,
            "long": 102.648,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 310426,
            "zip_code": 31110,
            "name_th": "ทุ่งแสงทอง",
            "name_en": "Thung Saeng Thong",
            "district_id": 3104,
            "lat": 14.581,
            "long": 102.705,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 310427,
            "zip_code": 31110,
            "name_th": "หนองโสน",
            "name_en": "Nong Sano",
            "district_id": 3104,
            "lat": 14.737,
            "long": 102.934,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 3105,
        "name_th": "หนองกี่",
        "name_en": "Nong Ki",
        "province_id": 20,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 310501,
            "zip_code": 31210,
            "name_th": "หนองกี่",
            "name_en": "Nong Ki",
            "district_id": 3105,
            "lat": 14.669,
            "long": 102.571,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 310502,
            "zip_code": 31210,
            "name_th": "เย้ยปราสาท",
            "name_en": "Yoei Prasat",
            "district_id": 3105,
            "lat": 14.739,
            "long": 102.564,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 310503,
            "zip_code": 31210,
            "name_th": "เมืองไผ่",
            "name_en": "Mueang Phai",
            "district_id": 3105,
            "lat": 14.774,
            "long": 102.645,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 310504,
            "zip_code": 31210,
            "name_th": "ดอนอะราง",
            "name_en": "Don Arang",
            "district_id": 3105,
            "lat": 14.642,
            "long": 102.571,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 310505,
            "zip_code": 31210,
            "name_th": "โคกสว่าง",
            "name_en": "Khok Sawang",
            "district_id": 3105,
            "lat": 14.782,
            "long": 102.489,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 310506,
            "zip_code": 31210,
            "name_th": "ทุ่งกระตาดพัฒนา",
            "name_en": "Thung Kratat Phatthana",
            "district_id": 3105,
            "lat": 14.674,
            "long": 102.497,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 310507,
            "zip_code": 31210,
            "name_th": "ทุ่งกระเต็น",
            "name_en": "Thung Kraten",
            "district_id": 3105,
            "lat": 14.693,
            "long": 102.564,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 310508,
            "zip_code": 31210,
            "name_th": "ท่าโพธิ์ชัย",
            "name_en": "Tha Pho Chai",
            "district_id": 3105,
            "lat": 14.736,
            "long": 102.635,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 310509,
            "zip_code": 31210,
            "name_th": "โคกสูง",
            "name_en": "Khok Sung",
            "district_id": 3105,
            "lat": 14.806,
            "long": 102.562,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 310510,
            "zip_code": 31210,
            "name_th": "บุกระสัง",
            "name_en": "Bu Krasang",
            "district_id": 3105,
            "lat": 14.724,
            "long": 102.501,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 3106,
        "name_th": "ละหานทราย",
        "name_en": "Lahan Sai",
        "province_id": 20,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 310601,
            "zip_code": 31170,
            "name_th": "ละหานทราย",
            "name_en": "Lahan Sai",
            "district_id": 3106,
            "lat": 14.418,
            "long": 102.854,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 310603,
            "zip_code": 31170,
            "name_th": "ตาจง",
            "name_en": "Ta Chong",
            "district_id": 3106,
            "lat": 14.439,
            "long": 102.92,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 310604,
            "zip_code": 31170,
            "name_th": "สำโรงใหม่",
            "name_en": "Samrong Mai",
            "district_id": 3106,
            "lat": 14.284,
            "long": 102.85,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 310607,
            "zip_code": 31170,
            "name_th": "หนองแวง",
            "name_en": "Nong Waeng",
            "district_id": 3106,
            "lat": 14.268,
            "long": 102.935,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 310610,
            "zip_code": 31170,
            "name_th": "หนองตะครอง",
            "name_en": "Nong Trakhrong",
            "district_id": 3106,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 310611,
            "zip_code": 31170,
            "name_th": "โคกว่าน",
            "name_en": "Khok Wan",
            "district_id": 3106,
            "lat": 14.449,
            "long": 102.784,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 3107,
        "name_th": "ประโคนชัย",
        "name_en": "Prakhon Chai",
        "province_id": 20,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 310701,
            "zip_code": 31140,
            "name_th": "ประโคนชัย",
            "name_en": "Prakhon Chai",
            "district_id": 3107,
            "lat": 14.613,
            "long": 103.081,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 310702,
            "zip_code": 31140,
            "name_th": "แสลงโทน",
            "name_en": "Salaeng Thon",
            "district_id": 3107,
            "lat": 14.787,
            "long": 103.055,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 310703,
            "zip_code": 31140,
            "name_th": "บ้านไทร",
            "name_en": "Ban Sai",
            "district_id": 3107,
            "lat": 14.705,
            "long": 103.065,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 310705,
            "zip_code": 31140,
            "name_th": "ละเวี้ย",
            "name_en": "Lawia",
            "district_id": 3107,
            "lat": 14.599,
            "long": 103.191,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 310706,
            "zip_code": 31140,
            "name_th": "จรเข้มาก",
            "name_en": "Chorakhe Mak",
            "district_id": 3107,
            "lat": 14.5,
            "long": 102.989,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 310707,
            "zip_code": 31140,
            "name_th": "ปังกู",
            "name_en": "Pang Ku",
            "district_id": 3107,
            "lat": 14.537,
            "long": 103.067,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 310708,
            "zip_code": 31140,
            "name_th": "โคกย่าง",
            "name_en": "Khok Yang",
            "district_id": 3107,
            "lat": 14.562,
            "long": 103.005,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 310710,
            "zip_code": 31140,
            "name_th": "โคกม้า",
            "name_en": "Khok Ma",
            "district_id": 3107,
            "lat": 14.641,
            "long": 103.035,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 310713,
            "zip_code": 31140,
            "name_th": "ไพศาล",
            "name_en": "Phaisan",
            "district_id": 3107,
            "lat": 14.662,
            "long": 103.208,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 310714,
            "zip_code": 31140,
            "name_th": "ตะโกตาพิ",
            "name_en": "Tako Taphi",
            "district_id": 3107,
            "lat": 14.638,
            "long": 102.981,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 310715,
            "zip_code": 31140,
            "name_th": "เขาคอก",
            "name_en": "Khao Khok",
            "district_id": 3107,
            "lat": 14.44,
            "long": 103.004,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 310716,
            "zip_code": 31140,
            "name_th": "หนองบอน",
            "name_en": "Nong Bon",
            "district_id": 3107,
            "lat": 14.542,
            "long": 103.143,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 310718,
            "zip_code": 31140,
            "name_th": "โคกมะขาม",
            "name_en": "Khok Makham",
            "district_id": 3107,
            "lat": 14.602,
            "long": 103.129,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 310719,
            "zip_code": 31140,
            "name_th": "โคกตูม",
            "name_en": "Khok Tum",
            "district_id": 3107,
            "lat": 14.702,
            "long": 102.989,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 310720,
            "zip_code": 31140,
            "name_th": "ประทัดบุ",
            "name_en": "Prathat Bu",
            "district_id": 3107,
            "lat": 14.569,
            "long": 102.962,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 310721,
            "zip_code": 31140,
            "name_th": "สี่เหลี่ยม",
            "name_en": "Si Liam",
            "district_id": 3107,
            "lat": 14.75,
            "long": 103.003,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 3108,
        "name_th": "บ้านกรวด",
        "name_en": "Ban Kruat",
        "province_id": 20,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 310801,
            "zip_code": 31180,
            "name_th": "บ้านกรวด",
            "name_en": "Ban Kruat",
            "district_id": 3108,
            "lat": 14.429,
            "long": 103.077,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 310802,
            "zip_code": 31180,
            "name_th": "โนนเจริญ",
            "name_en": "Non Charoen",
            "district_id": 3108,
            "lat": 14.464,
            "long": 103.189,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 310803,
            "zip_code": 31180,
            "name_th": "หนองไม้งาม",
            "name_en": "Nong Mai Ngam",
            "district_id": 3108,
            "lat": 14.344,
            "long": 102.997,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 310804,
            "zip_code": 31180,
            "name_th": "ปราสาท",
            "name_en": "Prasat",
            "district_id": 3108,
            "lat": 14.362,
            "long": 103.109,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 310805,
            "zip_code": 31180,
            "name_th": "สายตะกู",
            "name_en": "Sai Taku",
            "district_id": 3108,
            "lat": 14.397,
            "long": 103.211,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 310806,
            "zip_code": 31180,
            "name_th": "หินลาด",
            "name_en": "Hin Lat",
            "district_id": 3108,
            "lat": 14.473,
            "long": 103.143,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 310807,
            "zip_code": 31180,
            "name_th": "บึงเจริญ",
            "name_en": "Bueng Charoen",
            "district_id": 3108,
            "lat": 14.337,
            "long": 103.037,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 310808,
            "zip_code": 31180,
            "name_th": "จันทบเพชร",
            "name_en": "Chanthop Phet",
            "district_id": 3108,
            "lat": 14.384,
            "long": 103.164,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 310809,
            "zip_code": 31180,
            "name_th": "เขาดินเหนือ",
            "name_en": "Khao Din Nuea",
            "district_id": 3108,
            "lat": 14.524,
            "long": 103.199,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 3109,
        "name_th": "พุทไธสง",
        "name_en": "Phutthaisong",
        "province_id": 20,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 310901,
            "zip_code": 31120,
            "name_th": "พุทไธสง",
            "name_en": "Phutthaisong",
            "district_id": 3109,
            "lat": 15.582,
            "long": 103.014,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 310902,
            "zip_code": 31120,
            "name_th": "มะเฟือง",
            "name_en": "Mafueang",
            "district_id": 3109,
            "lat": 15.497,
            "long": 103.032,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 310903,
            "zip_code": 31120,
            "name_th": "บ้านจาน",
            "name_en": "Ban Chan",
            "district_id": 3109,
            "lat": 15.507,
            "long": 102.983,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 310906,
            "zip_code": 31120,
            "name_th": "บ้านเป้า",
            "name_en": "Ban Pao",
            "district_id": 3109,
            "lat": 15.627,
            "long": 102.892,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 310907,
            "zip_code": 31120,
            "name_th": "บ้านแวง",
            "name_en": "Ban Waeng",
            "district_id": 3109,
            "lat": 15.58,
            "long": 102.959,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 310909,
            "zip_code": 31120,
            "name_th": "บ้านยาง",
            "name_en": "Ban Yang",
            "district_id": 3109,
            "lat": 15.463,
            "long": 103.097,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 310910,
            "zip_code": 31120,
            "name_th": "หายโศก",
            "name_en": "Hai Sok",
            "district_id": 3109,
            "lat": 15.526,
            "long": 102.937,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 3110,
        "name_th": "ลำปลายมาศ",
        "name_en": "Lam Plai Mat",
        "province_id": 20,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 311001,
            "zip_code": 31130,
            "name_th": "ลำปลายมาศ",
            "name_en": "Lam Plai Mat",
            "district_id": 3110,
            "lat": 15.019,
            "long": 102.834,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 311002,
            "zip_code": 31130,
            "name_th": "หนองคู",
            "name_en": "Nong Khu",
            "district_id": 3110,
            "lat": 14.999,
            "long": 102.803,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 311003,
            "zip_code": 31130,
            "name_th": "แสลงพัน",
            "name_en": "Salaeng Phan",
            "district_id": 3110,
            "lat": 14.99,
            "long": 102.957,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 311004,
            "zip_code": 31130,
            "name_th": "ทะเมนชัย",
            "name_en": "Thamen Chai",
            "district_id": 3110,
            "lat": 15.051,
            "long": 102.945,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 311005,
            "zip_code": 31130,
            "name_th": "ตลาดโพธิ์",
            "name_en": "Talat Pho",
            "district_id": 3110,
            "lat": 15.083,
            "long": 102.893,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 311006,
            "zip_code": 31130,
            "name_th": "หนองกะทิง",
            "name_en": "Nong Kathing",
            "district_id": 3110,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 311007,
            "zip_code": 31130,
            "name_th": "โคกกลาง",
            "name_en": "Khok Klang",
            "district_id": 3110,
            "lat": 14.949,
            "long": 102.862,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 311008,
            "zip_code": 31130,
            "name_th": "โคกสะอาด",
            "name_en": "Khok Sa-at",
            "district_id": 3110,
            "lat": 15.154,
            "long": 102.902,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 311009,
            "zip_code": 31130,
            "name_th": "เมืองแฝก",
            "name_en": "Mueang Faek",
            "district_id": 3110,
            "lat": 15.154,
            "long": 102.973,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 311010,
            "zip_code": 31130,
            "name_th": "บ้านยาง",
            "name_en": "Ban Yang",
            "district_id": 3110,
            "lat": 14.873,
            "long": 102.886,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 311011,
            "zip_code": 31130,
            "name_th": "ผไทรินทร์",
            "name_en": "Phathairin",
            "district_id": 3110,
            "lat": 14.917,
            "long": 102.777,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 311012,
            "zip_code": 31130,
            "name_th": "โคกล่าม",
            "name_en": "Khok Lam",
            "district_id": 3110,
            "lat": 15.114,
            "long": 102.839,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 311013,
            "zip_code": 31130,
            "name_th": "หินโคน",
            "name_en": "Hin Khon",
            "district_id": 3110,
            "lat": 15.057,
            "long": 102.82,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 311014,
            "zip_code": 31130,
            "name_th": "หนองบัวโคก",
            "name_en": "Nong Bua Khok",
            "district_id": 3110,
            "lat": 15.006,
            "long": 102.889,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 311015,
            "zip_code": 31130,
            "name_th": "บุโพธิ์",
            "name_en": "Bu Pho",
            "district_id": 3110,
            "lat": 15.109,
            "long": 102.938,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 311016,
            "zip_code": 31130,
            "name_th": "หนองโดน",
            "name_en": "Nong Don",
            "district_id": 3110,
            "lat": 14.882,
            "long": 102.824,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 3111,
        "name_th": "สตึก",
        "name_en": "Satuek",
        "province_id": 20,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 311101,
            "zip_code": 31150,
            "name_th": "สตึก",
            "name_en": "Satuek",
            "district_id": 3111,
            "lat": 15.263,
            "long": 103.301,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 311102,
            "zip_code": 31150,
            "name_th": "นิคม",
            "name_en": "Nikhom",
            "district_id": 3111,
            "lat": 15.274,
            "long": 103.225,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 311103,
            "zip_code": 31150,
            "name_th": "ทุ่งวัง",
            "name_en": "Thung Wang",
            "district_id": 3111,
            "lat": 15.259,
            "long": 103.386,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 311104,
            "zip_code": 31150,
            "name_th": "เมืองแก",
            "name_en": "Mueang Kae",
            "district_id": 3111,
            "lat": 15.19,
            "long": 103.308,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 311105,
            "zip_code": 31150,
            "name_th": "หนองใหญ่",
            "name_en": "Nong Yai",
            "district_id": 3111,
            "lat": 15.131,
            "long": 103.291,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 311106,
            "zip_code": 31150,
            "name_th": "ร่อนทอง",
            "name_en": "Ron Thong",
            "district_id": 3111,
            "lat": 15.2,
            "long": 103.244,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 311109,
            "zip_code": 31150,
            "name_th": "ดอนมนต์",
            "name_en": "Don Mon",
            "district_id": 3111,
            "lat": 15.209,
            "long": 103.183,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 311110,
            "zip_code": 31150,
            "name_th": "ชุมแสง",
            "name_en": "Chum Saeng",
            "district_id": 3111,
            "lat": 15.137,
            "long": 103.377,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 311111,
            "zip_code": 31150,
            "name_th": "ท่าม่วง",
            "name_en": "Tha Muang",
            "district_id": 3111,
            "lat": 15.3,
            "long": 103.442,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 311112,
            "zip_code": 31150,
            "name_th": "สะแก",
            "name_en": "Sakae",
            "district_id": 3111,
            "lat": 15.3,
            "long": 103.354,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 311114,
            "zip_code": 31150,
            "name_th": "สนามชัย",
            "name_en": "Sanam Chai",
            "district_id": 3111,
            "lat": 15.207,
            "long": 103.356,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 311115,
            "zip_code": 31150,
            "name_th": "กระสัง",
            "name_en": "Krasang",
            "district_id": 3111,
            "lat": 15.195,
            "long": 103.405,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 3112,
        "name_th": "ปะคำ",
        "name_en": "Pakham",
        "province_id": 20,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 311201,
            "zip_code": 31220,
            "name_th": "ปะคำ",
            "name_en": "Pakham",
            "district_id": 3112,
            "lat": 14.454,
            "long": 102.721,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 311202,
            "zip_code": 31220,
            "name_th": "ไทยเจริญ",
            "name_en": "Thai Charoen",
            "district_id": 3112,
            "lat": 14.461,
            "long": 102.683,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 311203,
            "zip_code": 31220,
            "name_th": "หนองบัว",
            "name_en": "Nong Bua",
            "district_id": 3112,
            "lat": 14.432,
            "long": 102.657,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 311204,
            "zip_code": 31220,
            "name_th": "โคกมะม่วง",
            "name_en": "Khok Mamuang",
            "district_id": 3112,
            "lat": 14.402,
            "long": 102.612,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 311205,
            "zip_code": 31220,
            "name_th": "หูทำนบ",
            "name_en": "Hu Thamnop",
            "district_id": 3112,
            "lat": 14.364,
            "long": 102.696,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 3113,
        "name_th": "นาโพธิ์",
        "name_en": "Na Pho",
        "province_id": 20,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 311301,
            "zip_code": 31230,
            "name_th": "นาโพธิ์",
            "name_en": "Na Pho",
            "district_id": 3113,
            "lat": 15.635,
            "long": 102.944,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 311302,
            "zip_code": 31230,
            "name_th": "บ้านคู",
            "name_en": "Ban Khu",
            "district_id": 3113,
            "lat": 15.712,
            "long": 102.933,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 311303,
            "zip_code": 31230,
            "name_th": "บ้านดู่",
            "name_en": "Ban Du",
            "district_id": 3113,
            "lat": 15.713,
            "long": 102.977,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 311304,
            "zip_code": 31230,
            "name_th": "ดอนกอก",
            "name_en": "Don Kok",
            "district_id": 3113,
            "lat": 15.763,
            "long": 102.895,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 311305,
            "zip_code": 31230,
            "name_th": "ศรีสว่าง",
            "name_en": "Si Sawang",
            "district_id": 3113,
            "lat": 15.673,
            "long": 102.934,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 3114,
        "name_th": "หนองหงส์",
        "name_en": "Nong Hong",
        "province_id": 20,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 311401,
            "zip_code": 31240,
            "name_th": "สระแก้ว",
            "name_en": "Sa Kaeo",
            "district_id": 3114,
            "lat": 14.828,
            "long": 102.681,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 311402,
            "zip_code": 31240,
            "name_th": "ห้วยหิน",
            "name_en": "Huai Hin",
            "district_id": 3114,
            "lat": 14.871,
            "long": 102.594,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 311403,
            "zip_code": 31240,
            "name_th": "ไทยสามัคคี",
            "name_en": "Thai Samakkhi",
            "district_id": 3114,
            "lat": 14.885,
            "long": 102.763,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 311404,
            "zip_code": 31240,
            "name_th": "หนองชัยศรี",
            "name_en": "Nong Chai Si",
            "district_id": 3114,
            "lat": 14.823,
            "long": 102.645,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 311405,
            "zip_code": 31240,
            "name_th": "เสาเดียว",
            "name_en": "Sao Diao",
            "district_id": 3114,
            "lat": 14.911,
            "long": 102.609,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 311406,
            "zip_code": 31240,
            "name_th": "เมืองฝ้าย",
            "name_en": "Mueang Fai",
            "district_id": 3114,
            "lat": 14.843,
            "long": 102.741,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 311407,
            "zip_code": 31240,
            "name_th": "สระทอง",
            "name_en": "Sa Thong",
            "district_id": 3114,
            "lat": 14.889,
            "long": 102.67,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 3115,
        "name_th": "พลับพลาชัย",
        "name_en": "Phlapphla Chai",
        "province_id": 20,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 311501,
            "zip_code": 31250,
            "name_th": "จันดุม",
            "name_en": "Chan Dum",
            "district_id": 3115,
            "lat": 14.678,
            "long": 103.118,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 311502,
            "zip_code": 31250,
            "name_th": "โคกขมิ้น",
            "name_en": "Khok Khamin",
            "district_id": 3115,
            "lat": 14.769,
            "long": 103.193,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 311503,
            "zip_code": 31250,
            "name_th": "ป่าชัน",
            "name_en": "Pa Chan",
            "district_id": 3115,
            "lat": 14.717,
            "long": 103.241,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 311504,
            "zip_code": 31250,
            "name_th": "สะเดา",
            "name_en": "Sadao",
            "district_id": 3115,
            "lat": 14.722,
            "long": 103.168,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 311505,
            "zip_code": 31250,
            "name_th": "สำโรง",
            "name_en": "Samrong",
            "district_id": 3115,
            "lat": 14.776,
            "long": 103.111,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 3116,
        "name_th": "ห้วยราช",
        "name_en": "Huai Rat",
        "province_id": 20,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 311601,
            "zip_code": 31000,
            "name_th": "ห้วยราช",
            "name_en": "Huai Rat",
            "district_id": 3116,
            "lat": 14.964,
            "long": 103.183,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 311602,
            "zip_code": 31000,
            "name_th": "สามแวง",
            "name_en": "Sam Waeng",
            "district_id": 3116,
            "lat": 15.009,
            "long": 103.192,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 311603,
            "zip_code": 31000,
            "name_th": "ตาเสา",
            "name_en": "Ta Sao",
            "district_id": 3116,
            "lat": 15.088,
            "long": 103.285,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 311604,
            "zip_code": 31000,
            "name_th": "บ้านตะโก",
            "name_en": "Ban Tako",
            "district_id": 3116,
            "lat": 14.969,
            "long": 103.233,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 311605,
            "zip_code": 31000,
            "name_th": "สนวน",
            "name_en": "Sanuan",
            "district_id": 3116,
            "lat": 14.933,
            "long": 103.182,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 311606,
            "zip_code": 31000,
            "name_th": "โคกเหล็ก",
            "name_en": "Khok Lek",
            "district_id": 3116,
            "lat": 15.023,
            "long": 103.23,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 311607,
            "zip_code": 31000,
            "name_th": "เมืองโพธิ์",
            "name_en": "Mueang Pho",
            "district_id": 3116,
            "lat": 15.042,
            "long": 103.268,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 311608,
            "zip_code": 31000,
            "name_th": "ห้วยราชา",
            "name_en": "Huai Racha",
            "district_id": 3116,
            "lat": 14.982,
            "long": 103.203,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 3117,
        "name_th": "โนนสุวรรณ",
        "name_en": "Non Suwan",
        "province_id": 20,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 311701,
            "zip_code": 31110,
            "name_th": "โนนสุวรรณ",
            "name_en": "Non Suwan",
            "district_id": 3117,
            "lat": 14.538,
            "long": 102.604,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 311702,
            "zip_code": 31110,
            "name_th": "ทุ่งจังหัน",
            "name_en": "Thung Changhan",
            "district_id": 3117,
            "lat": 14.566,
            "long": 102.558,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 311703,
            "zip_code": 31110,
            "name_th": "โกรกแก้ว",
            "name_en": "Krok Kaeo",
            "district_id": 3117,
            "lat": 14.621,
            "long": 102.637,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 311704,
            "zip_code": 31110,
            "name_th": "ดงอีจาน",
            "name_en": "Dong I Chan",
            "district_id": 3117,
            "lat": 14.546,
            "long": 102.517,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 3118,
        "name_th": "ชำนิ",
        "name_en": "Chamni",
        "province_id": 20,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 311801,
            "zip_code": 31110,
            "name_th": "ชำนิ",
            "name_en": "Chamni",
            "district_id": 3118,
            "lat": 14.785,
            "long": 102.81,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 311802,
            "zip_code": 31110,
            "name_th": "หนองปล่อง",
            "name_en": "Nong Plong",
            "district_id": 3118,
            "lat": 14.743,
            "long": 102.844,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 311803,
            "zip_code": 31110,
            "name_th": "เมืองยาง",
            "name_en": "Mueang Yang",
            "district_id": 3118,
            "lat": 14.794,
            "long": 102.906,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 311804,
            "zip_code": 31110,
            "name_th": "ช่อผกา",
            "name_en": "Cho Phaka",
            "district_id": 3118,
            "lat": 14.809,
            "long": 102.787,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 311805,
            "zip_code": 31110,
            "name_th": "ละลวด",
            "name_en": "Laluat",
            "district_id": 3118,
            "lat": 14.78,
            "long": 102.745,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 311806,
            "zip_code": 31110,
            "name_th": "โคกสนวน",
            "name_en": "Khok Sanuan",
            "district_id": 3118,
            "lat": 14.755,
            "long": 102.888,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 3119,
        "name_th": "บ้านใหม่ไชยพจน์",
        "name_en": "Ban Mai Chaiyaphot",
        "province_id": 20,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 311901,
            "zip_code": 31120,
            "name_th": "หนองแวง",
            "name_en": "Nong Waeng",
            "district_id": 3119,
            "lat": 15.553,
            "long": 102.907,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 311902,
            "zip_code": 31120,
            "name_th": "ทองหลาง",
            "name_en": "Thonglang",
            "district_id": 3119,
            "lat": 15.608,
            "long": 102.805,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 311903,
            "zip_code": 31120,
            "name_th": "แดงใหญ่",
            "name_en": "Daeng Yai",
            "district_id": 3119,
            "lat": 15.605,
            "long": 102.857,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 311904,
            "zip_code": 31120,
            "name_th": "กู่สวนแตง",
            "name_en": "Ku Suan Taeng",
            "district_id": 3119,
            "lat": 15.534,
            "long": 102.86,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 311905,
            "zip_code": 31120,
            "name_th": "หนองเยือง",
            "name_en": "Nong Yueang",
            "district_id": 3119,
            "lat": 15.555,
            "long": 102.811,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 3120,
        "name_th": "โนนดินแดง",
        "name_en": "Din Daeng",
        "province_id": 20,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 312001,
            "zip_code": 31260,
            "name_th": "โนนดินแดง",
            "name_en": "Non Din Daeng",
            "district_id": 3120,
            "lat": 14.316,
            "long": 102.721,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 312002,
            "zip_code": 31260,
            "name_th": "ส้มป่อย",
            "name_en": "Som Poi",
            "district_id": 3120,
            "lat": 14.346,
            "long": 102.764,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 312003,
            "zip_code": 31260,
            "name_th": "ลำนางรอง",
            "name_en": "Lam Nang Rong",
            "district_id": 3120,
            "lat": 14.213,
            "long": 102.698,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 3121,
        "name_th": "บ้านด่าน",
        "name_en": "Ban Dan",
        "province_id": 20,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 312101,
            "zip_code": 31000,
            "name_th": "บ้านด่าน",
            "name_en": "Ban Dan",
            "district_id": 3121,
            "lat": 15.112,
            "long": 103.162,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 312102,
            "zip_code": 31000,
            "name_th": "ปราสาท",
            "name_en": "Prasat",
            "district_id": 3121,
            "lat": 15.081,
            "long": 103.217,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 312103,
            "zip_code": 31000,
            "name_th": "วังเหนือ",
            "name_en": "Wang Nuea",
            "district_id": 3121,
            "lat": 15.138,
            "long": 103.219,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 312104,
            "zip_code": 31000,
            "name_th": "โนนขวาง",
            "name_en": "Non Khwang",
            "district_id": 3121,
            "lat": 15.191,
            "long": 103.157,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 3122,
        "name_th": "แคนดง",
        "name_en": "Khaen Dong",
        "province_id": 20,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 312201,
            "zip_code": 31150,
            "name_th": "แคนดง",
            "name_en": "Khaen Dong",
            "district_id": 3122,
            "lat": 15.317,
            "long": 103.123,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 312202,
            "zip_code": 31150,
            "name_th": "ดงพลอง",
            "name_en": "Dong Phlong",
            "district_id": 3122,
            "lat": 15.321,
            "long": 103.172,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 312203,
            "zip_code": 31150,
            "name_th": "สระบัว",
            "name_en": "Sa Bua",
            "district_id": 3122,
            "lat": 15.32,
            "long": 103.077,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 312204,
            "zip_code": 31150,
            "name_th": "หัวฝาย",
            "name_en": "Hua Fai",
            "district_id": 3122,
            "lat": 15.267,
            "long": 103.18,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 3123,
        "name_th": "เฉลิมพระเกียรติ",
        "name_en": "Chaloem Phra Kiat",
        "province_id": 20,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 312301,
            "zip_code": 31110,
            "name_th": "เจริญสุข",
            "name_en": "Charoen Suk",
            "district_id": 3123,
            "lat": 14.574,
            "long": 102.865,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 312302,
            "zip_code": 31110,
            "name_th": "ตาเป๊ก",
            "name_en": "Ta Pek",
            "district_id": 3123,
            "lat": 14.568,
            "long": 102.924,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 312303,
            "zip_code": 31110,
            "name_th": "อีสานเขต",
            "name_en": "Isan Khet",
            "district_id": 3123,
            "lat": 14.641,
            "long": 102.931,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 312304,
            "zip_code": 31170,
            "name_th": "ถาวร",
            "name_en": "Thawon",
            "district_id": 3123,
            "lat": 14.518,
            "long": 102.87,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 312305,
            "zip_code": 31170,
            "name_th": "ยายแย้มวัฒนา",
            "name_en": "Yai Yaem Watthana",
            "district_id": 3123,
            "lat": 14.505,
            "long": 102.918,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      }
    ]
  },
  {
    "id": 21,
    "name_th": "สุรินทร์",
    "name_en": "Surin",
    "geography_id": 3,
    "created_at": "2019-08-09T03:33:09.000+07:00",
    "updated_at": "2025-09-20T06:31:26.000+07:00",
    "deleted_at": null,
    "districts": [
      {
        "id": 3201,
        "name_th": "เมืองสุรินทร์",
        "name_en": "Mueang Surin",
        "province_id": 21,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 320101,
            "zip_code": 32000,
            "name_th": "ในเมือง",
            "name_en": "Nai Mueang",
            "district_id": 3201,
            "lat": 14.884,
            "long": 103.49,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 320102,
            "zip_code": 32000,
            "name_th": "ตั้งใจ",
            "name_en": "Tang Chai",
            "district_id": 3201,
            "lat": 15.074,
            "long": 103.55,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 320103,
            "zip_code": 32000,
            "name_th": "เพี้ยราม",
            "name_en": "Phia Ram",
            "district_id": 3201,
            "lat": 15.067,
            "long": 103.471,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 320104,
            "zip_code": 32000,
            "name_th": "นาดี",
            "name_en": "Na Di",
            "district_id": 3201,
            "lat": 15.024,
            "long": 103.528,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 320105,
            "zip_code": 32000,
            "name_th": "ท่าสว่าง",
            "name_en": "Tha Sawang",
            "district_id": 3201,
            "lat": 14.955,
            "long": 103.452,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 320106,
            "zip_code": 32000,
            "name_th": "สลักได",
            "name_en": "Salakdai",
            "district_id": 3201,
            "lat": 14.855,
            "long": 103.562,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 320107,
            "zip_code": 32000,
            "name_th": "ตาอ็อง",
            "name_en": "Ta Ong",
            "district_id": 3201,
            "lat": 14.748,
            "long": 103.617,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 320109,
            "zip_code": 32000,
            "name_th": "สำโรง",
            "name_en": "Samrong",
            "district_id": 3201,
            "lat": 14.802,
            "long": 103.627,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 320110,
            "zip_code": 32000,
            "name_th": "แกใหญ่",
            "name_en": "Kae Yai",
            "district_id": 3201,
            "lat": 14.951,
            "long": 103.513,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 320111,
            "zip_code": 32000,
            "name_th": "นอกเมือง",
            "name_en": "Nok Mueang",
            "district_id": 3201,
            "lat": 14.858,
            "long": 103.491,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 320112,
            "zip_code": 32000,
            "name_th": "คอโค",
            "name_en": "Kho Kho",
            "district_id": 3201,
            "lat": 14.903,
            "long": 103.425,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 320113,
            "zip_code": 32000,
            "name_th": "สวาย",
            "name_en": "Sawai",
            "district_id": 3201,
            "lat": 14.793,
            "long": 103.337,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 320114,
            "zip_code": 32000,
            "name_th": "เฉนียง",
            "name_en": "Chaniang",
            "district_id": 3201,
            "lat": 14.796,
            "long": 103.477,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 320116,
            "zip_code": 32000,
            "name_th": "เทนมีย์",
            "name_en": "Thenmi",
            "district_id": 3201,
            "lat": 14.774,
            "long": 103.542,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 320118,
            "zip_code": 32000,
            "name_th": "นาบัว",
            "name_en": "Na Bua",
            "district_id": 3201,
            "lat": 14.782,
            "long": 103.412,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 320119,
            "zip_code": 32000,
            "name_th": "เมืองที",
            "name_en": "Mueang Thi",
            "district_id": 3201,
            "lat": 14.91,
            "long": 103.652,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 320120,
            "zip_code": 32000,
            "name_th": "ราม",
            "name_en": "Ram",
            "district_id": 3201,
            "lat": 14.848,
            "long": 103.65,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 320121,
            "zip_code": 32000,
            "name_th": "บุฤาษี",
            "name_en": "Bu Ruesi",
            "district_id": 3201,
            "lat": 14.904,
            "long": 103.597,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 320122,
            "zip_code": 32000,
            "name_th": "ตระแสง",
            "name_en": "Trasaeng",
            "district_id": 3201,
            "lat": 14.855,
            "long": 103.403,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 320125,
            "zip_code": 32000,
            "name_th": "แสลงพันธ์",
            "name_en": "Salaeng Phan",
            "district_id": 3201,
            "lat": 14.918,
            "long": 103.545,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 320126,
            "zip_code": 32000,
            "name_th": "กาเกาะ",
            "name_en": "Ka Ko",
            "district_id": 3201,
            "lat": 15.114,
            "long": 103.473,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 3202,
        "name_th": "ชุมพลบุรี",
        "name_en": "Chumphon Buri",
        "province_id": 21,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 320201,
            "zip_code": 32190,
            "name_th": "ชุมพลบุรี",
            "name_en": "Chumphon Buri",
            "district_id": 3202,
            "lat": 15.377,
            "long": 103.411,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 320202,
            "zip_code": 32190,
            "name_th": "นาหนองไผ่",
            "name_en": "Na Nong Phai",
            "district_id": 3202,
            "lat": 15.376,
            "long": 103.487,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 320203,
            "zip_code": 32190,
            "name_th": "ไพรขลา",
            "name_en": "Phrai Khla",
            "district_id": 3202,
            "lat": 15.395,
            "long": 103.556,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 320204,
            "zip_code": 32190,
            "name_th": "ศรีณรงค์",
            "name_en": "Si Narong",
            "district_id": 3202,
            "lat": 15.373,
            "long": 103.338,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 320205,
            "zip_code": 32190,
            "name_th": "ยะวึก",
            "name_en": "Yawuek",
            "district_id": 3202,
            "lat": 15.359,
            "long": 103.23,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 320206,
            "zip_code": 32190,
            "name_th": "เมืองบัว",
            "name_en": "Mueang Bua",
            "district_id": 3202,
            "lat": 15.429,
            "long": 103.205,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 320207,
            "zip_code": 32190,
            "name_th": "สระขุด",
            "name_en": "Sa Khut",
            "district_id": 3202,
            "lat": 15.44,
            "long": 103.15,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 320208,
            "zip_code": 32190,
            "name_th": "กระเบื้อง",
            "name_en": "Krabueang",
            "district_id": 3202,
            "lat": 15.359,
            "long": 103.291,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 320209,
            "zip_code": 32190,
            "name_th": "หนองเรือ",
            "name_en": "Nong Ruea",
            "district_id": 3202,
            "lat": 15.312,
            "long": 103.557,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 3203,
        "name_th": "ท่าตูม",
        "name_en": "Tha Tum",
        "province_id": 21,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 320301,
            "zip_code": 32120,
            "name_th": "ท่าตูม",
            "name_en": "Tha Tum",
            "district_id": 3203,
            "lat": 15.295,
            "long": 103.639,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 320302,
            "zip_code": 32120,
            "name_th": "กระโพ",
            "name_en": "Krapho",
            "district_id": 3203,
            "lat": 15.245,
            "long": 103.492,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 320303,
            "zip_code": 32120,
            "name_th": "พรมเทพ",
            "name_en": "Phrom Thep",
            "district_id": 3203,
            "lat": 15.351,
            "long": 103.622,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 320304,
            "zip_code": 32120,
            "name_th": "โพนครก",
            "name_en": "Phon Khrok",
            "district_id": 3203,
            "lat": 15.401,
            "long": 103.725,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 320305,
            "zip_code": 32120,
            "name_th": "เมืองแก",
            "name_en": "Mueang Kae",
            "district_id": 3203,
            "lat": 15.221,
            "long": 103.67,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 320306,
            "zip_code": 32120,
            "name_th": "บะ",
            "name_en": "Ba",
            "district_id": 3203,
            "lat": 15.242,
            "long": 103.569,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 320307,
            "zip_code": 32120,
            "name_th": "หนองบัว",
            "name_en": "Nong Bua",
            "district_id": 3203,
            "lat": 15.327,
            "long": 103.742,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 320308,
            "zip_code": 32120,
            "name_th": "บัวโคก",
            "name_en": "Bua Khok",
            "district_id": 3203,
            "lat": 15.228,
            "long": 103.71,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 320309,
            "zip_code": 32120,
            "name_th": "หนองเมธี",
            "name_en": "Nong Methi",
            "district_id": 3203,
            "lat": 15.232,
            "long": 103.615,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 320310,
            "zip_code": 32120,
            "name_th": "ทุ่งกุลา",
            "name_en": "Thung Kula",
            "district_id": 3203,
            "lat": 15.429,
            "long": 103.62,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 3204,
        "name_th": "จอมพระ",
        "name_en": "Chom Phra",
        "province_id": 21,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 320401,
            "zip_code": 32180,
            "name_th": "จอมพระ",
            "name_en": "Chom Phra",
            "district_id": 3204,
            "lat": 15.107,
            "long": 103.599,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 320402,
            "zip_code": 32180,
            "name_th": "เมืองลีง",
            "name_en": "Mueang Ling",
            "district_id": 3204,
            "lat": 15.17,
            "long": 103.465,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 320403,
            "zip_code": 32180,
            "name_th": "กระหาด",
            "name_en": "Krahat",
            "district_id": 3204,
            "lat": 15.13,
            "long": 103.529,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 320404,
            "zip_code": 32180,
            "name_th": "บุแกรง",
            "name_en": "Bu Kraeng",
            "district_id": 3204,
            "lat": 15.079,
            "long": 103.683,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 320405,
            "zip_code": 32180,
            "name_th": "หนองสนิท",
            "name_en": "Nong Sanit",
            "district_id": 3204,
            "lat": 15.16,
            "long": 103.655,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 320406,
            "zip_code": 32180,
            "name_th": "บ้านผือ",
            "name_en": "Ban Phue",
            "district_id": 3204,
            "lat": 15.123,
            "long": 103.682,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 320407,
            "zip_code": 32180,
            "name_th": "ลุ่มระวี",
            "name_en": "Lum Rawi",
            "district_id": 3204,
            "lat": 15.162,
            "long": 103.602,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 320408,
            "zip_code": 32180,
            "name_th": "ชุมแสง",
            "name_en": "Chum Saeng",
            "district_id": 3204,
            "lat": 15.178,
            "long": 103.53,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 320409,
            "zip_code": 32180,
            "name_th": "เป็นสุข",
            "name_en": "Pen Suk",
            "district_id": 3204,
            "lat": 15.136,
            "long": 103.565,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 3205,
        "name_th": "ปราสาท",
        "name_en": "Prasat",
        "province_id": 21,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 320501,
            "zip_code": 32140,
            "name_th": "กังแอน",
            "name_en": "Kang-aen",
            "district_id": 3205,
            "lat": 14.656,
            "long": 103.406,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 320502,
            "zip_code": 32140,
            "name_th": "ทมอ",
            "name_en": "Thamo",
            "district_id": 3205,
            "lat": 14.722,
            "long": 103.486,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 320503,
            "zip_code": 32140,
            "name_th": "ไพล",
            "name_en": "Phlai",
            "district_id": 3205,
            "lat": 14.688,
            "long": 103.377,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 320504,
            "zip_code": 32140,
            "name_th": "ปรือ",
            "name_en": "Prue",
            "district_id": 3205,
            "lat": 14.645,
            "long": 103.288,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 320505,
            "zip_code": 32140,
            "name_th": "ทุ่งมน",
            "name_en": "Thung Mon",
            "district_id": 3205,
            "lat": 14.72,
            "long": 103.282,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 320506,
            "zip_code": 32140,
            "name_th": "ตาเบา",
            "name_en": "Ta Bao",
            "district_id": 3205,
            "lat": 14.615,
            "long": 103.493,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 320507,
            "zip_code": 32140,
            "name_th": "หนองใหญ่",
            "name_en": "Nong Yai",
            "district_id": 3205,
            "lat": 14.552,
            "long": 103.462,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 320508,
            "zip_code": 32140,
            "name_th": "โคกยาง",
            "name_en": "Khok Yang",
            "district_id": 3205,
            "lat": 14.673,
            "long": 103.529,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 320509,
            "zip_code": 32140,
            "name_th": "โคกสะอาด",
            "name_en": "Khok Sa-at",
            "district_id": 3205,
            "lat": 14.541,
            "long": 103.373,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 320510,
            "zip_code": 32140,
            "name_th": "บ้านไทร",
            "name_en": "Ban Sai",
            "district_id": 3205,
            "lat": 14.622,
            "long": 103.602,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 320511,
            "zip_code": 32140,
            "name_th": "โชคนาสาม",
            "name_en": "Chok Na Sam",
            "district_id": 3205,
            "lat": 14.544,
            "long": 103.28,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 320512,
            "zip_code": 32140,
            "name_th": "เชื้อเพลิง",
            "name_en": "Chuea Phloeng",
            "district_id": 3205,
            "lat": 14.713,
            "long": 103.418,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 320513,
            "zip_code": 32140,
            "name_th": "ปราสาททนง",
            "name_en": "Prasat Thanong",
            "district_id": 3205,
            "lat": 14.652,
            "long": 103.356,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 320514,
            "zip_code": 32140,
            "name_th": "ตานี",
            "name_en": "Tani",
            "district_id": 3205,
            "lat": 14.617,
            "long": 103.258,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 320515,
            "zip_code": 32140,
            "name_th": "บ้านพลวง",
            "name_en": "Ban Phluang",
            "district_id": 3205,
            "lat": 14.602,
            "long": 103.408,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 320516,
            "zip_code": 32140,
            "name_th": "กันตวจระมวล",
            "name_en": "Kantuat Ramuan",
            "district_id": 3205,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 320517,
            "zip_code": 32140,
            "name_th": "สมุด",
            "name_en": "Samut",
            "district_id": 3205,
            "lat": 14.686,
            "long": 103.339,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 320518,
            "zip_code": 32140,
            "name_th": "ประทัดบุ",
            "name_en": "Prathat Bu",
            "district_id": 3205,
            "lat": 14.727,
            "long": 103.341,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 3206,
        "name_th": "กาบเชิง",
        "name_en": "Kap Choeng",
        "province_id": 21,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 320601,
            "zip_code": 32210,
            "name_th": "กาบเชิง",
            "name_en": "Kap Choeng",
            "district_id": 3206,
            "lat": 14.488,
            "long": 103.585,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 320604,
            "zip_code": 32210,
            "name_th": "คูตัน",
            "name_en": "Khu Tan",
            "district_id": 3206,
            "lat": 14.533,
            "long": 103.667,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 320605,
            "zip_code": 32210,
            "name_th": "ด่าน",
            "name_en": "Dan",
            "district_id": 3206,
            "lat": 14.465,
            "long": 103.709,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 320606,
            "zip_code": 32210,
            "name_th": "แนงมุด",
            "name_en": "Naeng Mut",
            "district_id": 3206,
            "lat": 14.397,
            "long": 103.459,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 320607,
            "zip_code": 32210,
            "name_th": "โคกตะเคียน",
            "name_en": "Khok Takhian",
            "district_id": 3206,
            "lat": 14.48,
            "long": 103.505,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 320610,
            "zip_code": 32210,
            "name_th": "ตะเคียน",
            "name_en": "Takhian",
            "district_id": 3206,
            "lat": 14.464,
            "long": 103.632,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 3207,
        "name_th": "รัตนบุรี",
        "name_en": "Rattanaburi",
        "province_id": 21,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 320701,
            "zip_code": 32130,
            "name_th": "รัตนบุรี",
            "name_en": "Rattanaburi",
            "district_id": 3207,
            "lat": 15.311,
            "long": 103.843,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 320702,
            "zip_code": 32130,
            "name_th": "ธาตุ",
            "name_en": "That",
            "district_id": 3207,
            "lat": 15.317,
            "long": 103.94,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 320703,
            "zip_code": 32130,
            "name_th": "แก",
            "name_en": "Kae",
            "district_id": 3207,
            "lat": 15.355,
            "long": 103.808,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 320704,
            "zip_code": 32130,
            "name_th": "ดอนแรด",
            "name_en": "Don Raet",
            "district_id": 3207,
            "lat": 15.369,
            "long": 104.014,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 320705,
            "zip_code": 32130,
            "name_th": "หนองบัวทอง",
            "name_en": "Nong Bua Thong",
            "district_id": 3207,
            "lat": 15.392,
            "long": 103.933,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 320706,
            "zip_code": 32130,
            "name_th": "หนองบัวบาน",
            "name_en": "Nong Bua Ban",
            "district_id": 3207,
            "lat": 15.239,
            "long": 103.826,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 320709,
            "zip_code": 32130,
            "name_th": "ไผ่",
            "name_en": "Phai",
            "district_id": 3207,
            "lat": 15.324,
            "long": 103.895,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 320711,
            "zip_code": 32130,
            "name_th": "เบิด",
            "name_en": "Boet",
            "district_id": 3207,
            "lat": 15.268,
            "long": 103.921,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 320713,
            "zip_code": 32130,
            "name_th": "น้ำเขียว",
            "name_en": "Nam Khiao",
            "district_id": 3207,
            "lat": 15.316,
            "long": 103.786,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 320714,
            "zip_code": 32130,
            "name_th": "กุดขาคีม",
            "name_en": "Kut Kha Khim",
            "district_id": 3207,
            "lat": 15.407,
            "long": 103.846,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 320715,
            "zip_code": 32130,
            "name_th": "ยางสว่าง",
            "name_en": "Yang Sawang",
            "district_id": 3207,
            "lat": 15.306,
            "long": 103.987,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 320716,
            "zip_code": 32130,
            "name_th": "ทับใหญ่",
            "name_en": "Thap Ya",
            "district_id": 3207,
            "lat": 15.41,
            "long": 103.89,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 3208,
        "name_th": "สนม",
        "name_en": "Sanom",
        "province_id": 21,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 320801,
            "zip_code": 32160,
            "name_th": "สนม",
            "name_en": "Sanom",
            "district_id": 3208,
            "lat": 15.203,
            "long": 103.761,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 320802,
            "zip_code": 32160,
            "name_th": "โพนโก",
            "name_en": "Phon Ko",
            "district_id": 3208,
            "lat": 15.251,
            "long": 103.766,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 320803,
            "zip_code": 32160,
            "name_th": "หนองระฆัง",
            "name_en": "Nong Rakhang",
            "district_id": 3208,
            "lat": 15.152,
            "long": 103.755,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 320804,
            "zip_code": 32160,
            "name_th": "นานวน",
            "name_en": "Na Nuan",
            "district_id": 3208,
            "lat": 15.139,
            "long": 103.793,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 320805,
            "zip_code": 32160,
            "name_th": "แคน",
            "name_en": "Khaen",
            "district_id": 3208,
            "lat": 15.17,
            "long": 103.828,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 320806,
            "zip_code": 32160,
            "name_th": "หัวงัว",
            "name_en": "Hua Ngua",
            "district_id": 3208,
            "lat": 15.124,
            "long": 103.838,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 320807,
            "zip_code": 32160,
            "name_th": "หนองอียอ",
            "name_en": "Nong I Yo",
            "district_id": 3208,
            "lat": 15.157,
            "long": 103.714,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 3209,
        "name_th": "ศีขรภูมิ",
        "name_en": "Sikhoraphum",
        "province_id": 21,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 320901,
            "zip_code": 32110,
            "name_th": "ระแงง",
            "name_en": "Ra-ngaeng",
            "district_id": 3209,
            "lat": 14.898,
            "long": 103.824,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 320902,
            "zip_code": 32110,
            "name_th": "ตรึม",
            "name_en": "Truem",
            "district_id": 3209,
            "lat": 15.035,
            "long": 103.845,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 320903,
            "zip_code": 32110,
            "name_th": "จารพัต",
            "name_en": "Charaphat",
            "district_id": 3209,
            "lat": 14.867,
            "long": 103.735,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 320904,
            "zip_code": 32110,
            "name_th": "ยาง",
            "name_en": "Yang",
            "district_id": 3209,
            "lat": 14.955,
            "long": 103.856,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 320905,
            "zip_code": 32110,
            "name_th": "แตล",
            "name_en": "Taen",
            "district_id": 3209,
            "lat": 15.029,
            "long": 103.71,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 320906,
            "zip_code": 32110,
            "name_th": "หนองบัว",
            "name_en": "Nong Bua",
            "district_id": 3209,
            "lat": 15.083,
            "long": 103.76,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 320907,
            "zip_code": 32110,
            "name_th": "คาละแมะ",
            "name_en": "Khalamae",
            "district_id": 3209,
            "lat": 15.081,
            "long": 103.825,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 320908,
            "zip_code": 32110,
            "name_th": "หนองเหล็ก",
            "name_en": "Nong Lek",
            "district_id": 3209,
            "lat": 14.812,
            "long": 103.722,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 320909,
            "zip_code": 32110,
            "name_th": "หนองขวาว",
            "name_en": "Nong Khwao",
            "district_id": 3209,
            "lat": 14.979,
            "long": 103.794,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 320910,
            "zip_code": 32110,
            "name_th": "ช่างปี่",
            "name_en": "Chang Pi",
            "district_id": 3209,
            "lat": 14.946,
            "long": 103.705,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 320911,
            "zip_code": 32110,
            "name_th": "กุดหวาย",
            "name_en": "Kut Wai",
            "district_id": 3209,
            "lat": 14.92,
            "long": 103.868,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 320912,
            "zip_code": 32110,
            "name_th": "ขวาวใหญ่",
            "name_en": "Khwao Yai",
            "district_id": 3209,
            "lat": 15.018,
            "long": 103.77,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 320913,
            "zip_code": 32110,
            "name_th": "นารุ่ง",
            "name_en": "Na Rung",
            "district_id": 3209,
            "lat": 14.984,
            "long": 103.829,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 320914,
            "zip_code": 32110,
            "name_th": "ตรมไพร",
            "name_en": "Trom Phrai",
            "district_id": 3209,
            "lat": 14.845,
            "long": 103.785,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 320915,
            "zip_code": 32110,
            "name_th": "ผักไหม",
            "name_en": "Phak Mai",
            "district_id": 3209,
            "lat": 14.848,
            "long": 103.83,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 3210,
        "name_th": "สังขะ",
        "name_en": "Sangkha",
        "province_id": 21,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 321001,
            "zip_code": 32150,
            "name_th": "สังขะ",
            "name_en": "Sangkha",
            "district_id": 3210,
            "lat": 14.663,
            "long": 103.839,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 321002,
            "zip_code": 32150,
            "name_th": "ขอนแตก",
            "name_en": "Khon Taek",
            "district_id": 3210,
            "lat": 14.717,
            "long": 103.932,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 321006,
            "zip_code": 32150,
            "name_th": "ดม",
            "name_en": "Dom",
            "district_id": 3210,
            "lat": 14.575,
            "long": 103.856,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 321007,
            "zip_code": 32150,
            "name_th": "พระแก้ว",
            "name_en": "Phra Kaeo",
            "district_id": 3210,
            "lat": 14.653,
            "long": 103.954,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 321008,
            "zip_code": 32150,
            "name_th": "บ้านจารย์",
            "name_en": "Ban Chan",
            "district_id": 3210,
            "lat": 14.561,
            "long": 103.749,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 321009,
            "zip_code": 32150,
            "name_th": "กระเทียม",
            "name_en": "Krathiam",
            "district_id": 3210,
            "lat": 14.604,
            "long": 103.673,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 321010,
            "zip_code": 32150,
            "name_th": "สะกาด",
            "name_en": "Sakat",
            "district_id": 3210,
            "lat": 14.612,
            "long": 103.753,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 321011,
            "zip_code": 32150,
            "name_th": "ตาตุม",
            "name_en": "Ta Tum",
            "district_id": 3210,
            "lat": 14.449,
            "long": 103.779,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 321012,
            "zip_code": 32150,
            "name_th": "ทับทัน",
            "name_en": "Thap Than",
            "district_id": 3210,
            "lat": 14.676,
            "long": 103.786,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 321013,
            "zip_code": 32150,
            "name_th": "ตาคง",
            "name_en": "Ta Khong",
            "district_id": 3210,
            "lat": 14.66,
            "long": 104.034,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 321015,
            "zip_code": 32150,
            "name_th": "บ้านชบ",
            "name_en": "Ban Chop",
            "district_id": 3210,
            "lat": 14.618,
            "long": 103.849,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 321017,
            "zip_code": 32150,
            "name_th": "เทพรักษา",
            "name_en": "Thep Raksa",
            "district_id": 3210,
            "lat": 14.481,
            "long": 103.868,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 3211,
        "name_th": "ลำดวน",
        "name_en": "Lamduan",
        "province_id": 21,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 321101,
            "zip_code": 32220,
            "name_th": "ลำดวน",
            "name_en": "Lamduan",
            "district_id": 3211,
            "lat": 14.702,
            "long": 103.642,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 321102,
            "zip_code": 32220,
            "name_th": "โชคเหนือ",
            "name_en": "Chok Nuea",
            "district_id": 3211,
            "lat": 14.738,
            "long": 103.721,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 321103,
            "zip_code": 32220,
            "name_th": "อู่โลก",
            "name_en": "U Lok",
            "district_id": 3211,
            "lat": 14.684,
            "long": 103.691,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 321104,
            "zip_code": 32220,
            "name_th": "ตรำดม",
            "name_en": "Tram Dom",
            "district_id": 3211,
            "lat": 14.763,
            "long": 103.68,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 321105,
            "zip_code": 32220,
            "name_th": "ตระเปียงเตีย",
            "name_en": "Trapiang Tia",
            "district_id": 3211,
            "lat": 14.751,
            "long": 103.77,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 3212,
        "name_th": "สำโรงทาบ",
        "name_en": "Samrong Thap",
        "province_id": 21,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 321201,
            "zip_code": 32170,
            "name_th": "สำโรงทาบ",
            "name_en": "Samrong Thap",
            "district_id": 3212,
            "lat": 14.989,
            "long": 103.926,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 321202,
            "zip_code": 32170,
            "name_th": "หนองไผ่ล้อม",
            "name_en": "Nong Phai Lom",
            "district_id": 3212,
            "lat": 15.02,
            "long": 103.905,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 321203,
            "zip_code": 32170,
            "name_th": "กระออม",
            "name_en": "Kra-om",
            "district_id": 3212,
            "lat": 15.13,
            "long": 103.968,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 321204,
            "zip_code": 32170,
            "name_th": "หนองฮะ",
            "name_en": "Nong Ha",
            "district_id": 3212,
            "lat": 15.097,
            "long": 103.911,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 321205,
            "zip_code": 32170,
            "name_th": "ศรีสุข",
            "name_en": "Si Suk",
            "district_id": 3212,
            "lat": 15.07,
            "long": 103.949,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 321206,
            "zip_code": 32170,
            "name_th": "เกาะแก้ว",
            "name_en": "Ko Kaeo",
            "district_id": 3212,
            "lat": 14.958,
            "long": 103.952,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 321207,
            "zip_code": 32170,
            "name_th": "หมื่นศรี",
            "name_en": "Muen Si",
            "district_id": 3212,
            "lat": 15.003,
            "long": 103.968,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 321208,
            "zip_code": 32170,
            "name_th": "เสม็จ",
            "name_en": "Samet",
            "district_id": 3212,
            "lat": 15.092,
            "long": 103.875,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 321209,
            "zip_code": 32170,
            "name_th": "สะโน",
            "name_en": "Sano",
            "district_id": 3212,
            "lat": 15.066,
            "long": 103.999,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 321210,
            "zip_code": 32170,
            "name_th": "ประดู่",
            "name_en": "Pradu",
            "district_id": 3212,
            "lat": 15.039,
            "long": 103.952,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 3213,
        "name_th": "บัวเชด",
        "name_en": "Buachet",
        "province_id": 21,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 321301,
            "zip_code": 32230,
            "name_th": "บัวเชด",
            "name_en": "Buachet",
            "district_id": 3213,
            "lat": 14.527,
            "long": 103.942,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 321302,
            "zip_code": 32230,
            "name_th": "สะเดา",
            "name_en": "Sadao",
            "district_id": 3213,
            "lat": 14.532,
            "long": 104.014,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 321303,
            "zip_code": 32230,
            "name_th": "จรัส",
            "name_en": "Charat",
            "district_id": 3213,
            "lat": 14.413,
            "long": 103.976,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 321304,
            "zip_code": 32230,
            "name_th": "ตาวัง",
            "name_en": "Ta Wang",
            "district_id": 3213,
            "lat": 14.609,
            "long": 104.016,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 321305,
            "zip_code": 32230,
            "name_th": "อาโพน",
            "name_en": "A Phon",
            "district_id": 3213,
            "lat": 14.479,
            "long": 103.921,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 321306,
            "zip_code": 32230,
            "name_th": "สำเภาลูน",
            "name_en": "Samphao Lun",
            "district_id": 3213,
            "lat": 14.57,
            "long": 103.953,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 3214,
        "name_th": "พนมดงรัก",
        "name_en": "Phanom Dong Rak",
        "province_id": 21,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 321401,
            "zip_code": 32140,
            "name_th": "บักได",
            "name_en": "Bakdai",
            "district_id": 3214,
            "lat": 14.416,
            "long": 103.35,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 321402,
            "zip_code": 32140,
            "name_th": "โคกกลาง",
            "name_en": "Khok Klang",
            "district_id": 3214,
            "lat": 14.49,
            "long": 103.249,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 321403,
            "zip_code": 32140,
            "name_th": "จีกแดก",
            "name_en": "Chik Daek",
            "district_id": 3214,
            "lat": 14.497,
            "long": 103.354,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 321404,
            "zip_code": 32140,
            "name_th": "ตาเมียง",
            "name_en": "Ta Miang",
            "district_id": 3214,
            "lat": 14.386,
            "long": 103.26,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 3215,
        "name_th": "ศรีณรงค์",
        "name_en": "Si Narong",
        "province_id": 21,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 321501,
            "zip_code": 32150,
            "name_th": "ณรงค์",
            "name_en": "Narong",
            "district_id": 3215,
            "lat": 14.754,
            "long": 103.882,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 321502,
            "zip_code": 32150,
            "name_th": "แจนแวน",
            "name_en": "Chaenwaen",
            "district_id": 3215,
            "lat": 14.797,
            "long": 103.922,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 321503,
            "zip_code": 32150,
            "name_th": "ตรวจ",
            "name_en": "Truat",
            "district_id": 3215,
            "lat": 14.802,
            "long": 103.846,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 321504,
            "zip_code": 32150,
            "name_th": "หนองแวง",
            "name_en": "Nong Waeng",
            "district_id": 3215,
            "lat": 14.757,
            "long": 103.977,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 321505,
            "zip_code": 32150,
            "name_th": "ศรีสุข",
            "name_en": "Si Suk",
            "district_id": 3215,
            "lat": 14.738,
            "long": 103.818,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 3216,
        "name_th": "เขวาสินรินทร์",
        "name_en": "Khwao Sinarin",
        "province_id": 21,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 321601,
            "zip_code": 32000,
            "name_th": "เขวาสินรินทร์",
            "name_en": "Khwao Sinarin",
            "district_id": 3216,
            "lat": 15.009,
            "long": 103.582,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 321602,
            "zip_code": 32000,
            "name_th": "บึง",
            "name_en": "Bueng",
            "district_id": 3216,
            "lat": 15.06,
            "long": 103.61,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 321603,
            "zip_code": 32000,
            "name_th": "ตากูก",
            "name_en": "Ta Kuk",
            "district_id": 3216,
            "lat": 15.026,
            "long": 103.644,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 321604,
            "zip_code": 32000,
            "name_th": "ปราสาททอง",
            "name_en": "Prasat Thong",
            "district_id": 3216,
            "lat": 14.976,
            "long": 103.648,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 321605,
            "zip_code": 32000,
            "name_th": "บ้านแร่",
            "name_en": "Ban Rae",
            "district_id": 3216,
            "lat": 14.966,
            "long": 103.576,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 3217,
        "name_th": "โนนนารายณ์",
        "name_en": "Non Narai",
        "province_id": 21,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 321701,
            "zip_code": 32130,
            "name_th": "หนองหลวง",
            "name_en": "Nong Luang",
            "district_id": 3217,
            "lat": 15.228,
            "long": 103.927,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 321702,
            "zip_code": 32130,
            "name_th": "คำผง",
            "name_en": "Kham Phong",
            "district_id": 3217,
            "lat": 15.186,
            "long": 103.942,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 321703,
            "zip_code": 32130,
            "name_th": "โนน",
            "name_en": "Non",
            "district_id": 3217,
            "lat": 15.173,
            "long": 103.911,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 321704,
            "zip_code": 32130,
            "name_th": "ระเวียง",
            "name_en": "Rawiang",
            "district_id": 3217,
            "lat": 15.251,
            "long": 103.885,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 321705,
            "zip_code": 32130,
            "name_th": "หนองเทพ",
            "name_en": "Nong Thep",
            "district_id": 3217,
            "lat": 15.14,
            "long": 103.88,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      }
    ]
  },
  {
    "id": 22,
    "name_th": "ศรีสะเกษ",
    "name_en": "Si Sa Ket",
    "geography_id": 3,
    "created_at": "2019-08-09T03:33:09.000+07:00",
    "updated_at": "2025-09-20T06:31:26.000+07:00",
    "deleted_at": null,
    "districts": [
      {
        "id": 3301,
        "name_th": "เมืองศรีสะเกษ",
        "name_en": "Mueang Si Sa Ket",
        "province_id": 22,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 330101,
            "zip_code": 33000,
            "name_th": "เมืองเหนือ",
            "name_en": "Mueang Nuea",
            "district_id": 3301,
            "lat": 15.103,
            "long": 104.336,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 330102,
            "zip_code": 33000,
            "name_th": "เมืองใต้",
            "name_en": "Mueang Tai",
            "district_id": 3301,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 330103,
            "zip_code": 33000,
            "name_th": "คูซอด",
            "name_en": "Khu Sot",
            "district_id": 3301,
            "lat": 15.213,
            "long": 104.278,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 330104,
            "zip_code": 33000,
            "name_th": "ซำ",
            "name_en": "Sam",
            "district_id": 3301,
            "lat": 15.04,
            "long": 104.332,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 330105,
            "zip_code": 33000,
            "name_th": "จาน",
            "name_en": "Chan",
            "district_id": 3301,
            "lat": 14.989,
            "long": 104.398,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 330106,
            "zip_code": 33000,
            "name_th": "ตะดอบ",
            "name_en": "Tadop",
            "district_id": 3301,
            "lat": 15.037,
            "long": 104.434,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 330107,
            "zip_code": 33000,
            "name_th": "หนองครก",
            "name_en": "Nong Khrok",
            "district_id": 3301,
            "lat": 15.078,
            "long": 104.295,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 330111,
            "zip_code": 33000,
            "name_th": "โพนข่า",
            "name_en": "Phon Kha",
            "district_id": 3301,
            "lat": 15.055,
            "long": 104.385,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 330112,
            "zip_code": 33000,
            "name_th": "โพนค้อ",
            "name_en": "Phon Kho",
            "district_id": 3301,
            "lat": 15.015,
            "long": 104.369,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 330115,
            "zip_code": 33000,
            "name_th": "โพนเขวา",
            "name_en": "Phon Khwao",
            "district_id": 3301,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 330116,
            "zip_code": 33000,
            "name_th": "หญ้าปล้อง",
            "name_en": "Ya Plong",
            "district_id": 3301,
            "lat": 15.135,
            "long": 104.293,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 330118,
            "zip_code": 33000,
            "name_th": "ทุ่ม",
            "name_en": "Thum",
            "district_id": 3301,
            "lat": 14.98,
            "long": 104.336,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 330119,
            "zip_code": 33000,
            "name_th": "หนองไฮ",
            "name_en": "Nong Hai",
            "district_id": 3301,
            "lat": 15.007,
            "long": 104.427,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 330121,
            "zip_code": 33000,
            "name_th": "หนองแก้ว",
            "name_en": "Nong Kaeo",
            "district_id": 3301,
            "lat": 15.096,
            "long": 104.433,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 330122,
            "zip_code": 33000,
            "name_th": "น้ำคำ",
            "name_en": "Nam Kham",
            "district_id": 3301,
            "lat": 15.167,
            "long": 104.34,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 330123,
            "zip_code": 33000,
            "name_th": "โพธิ์",
            "name_en": "Pho",
            "district_id": 3301,
            "lat": 15.124,
            "long": 104.394,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 330124,
            "zip_code": 33000,
            "name_th": "หมากเขียบ",
            "name_en": "Mak Khiap",
            "district_id": 3301,
            "lat": 15.051,
            "long": 104.258,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 330127,
            "zip_code": 33000,
            "name_th": "หนองไผ่",
            "name_en": "Nong Phai",
            "district_id": 3301,
            "lat": 15.143,
            "long": 104.271,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 3302,
        "name_th": "ยางชุมน้อย",
        "name_en": "Yang Chum Noi",
        "province_id": 22,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 330201,
            "zip_code": 33190,
            "name_th": "ยางชุมน้อย",
            "name_en": "Yang Chum Noi",
            "district_id": 3302,
            "lat": 15.26,
            "long": 104.401,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 330202,
            "zip_code": 33190,
            "name_th": "ลิ้นฟ้า",
            "name_en": "Lin Fa",
            "district_id": 3302,
            "lat": 15.18,
            "long": 104.422,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 330203,
            "zip_code": 33190,
            "name_th": "คอนกาม",
            "name_en": "Khon Kam",
            "district_id": 3302,
            "lat": 15.223,
            "long": 104.36,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 330204,
            "zip_code": 33190,
            "name_th": "โนนคูณ",
            "name_en": "Non Khun",
            "district_id": 3302,
            "lat": 15.302,
            "long": 104.354,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 330205,
            "zip_code": 33190,
            "name_th": "กุดเมืองฮาม",
            "name_en": "Kut Mueang Ham",
            "district_id": 3302,
            "lat": 15.235,
            "long": 104.319,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 330206,
            "zip_code": 33190,
            "name_th": "บึงบอน",
            "name_en": "Bueng Bon",
            "district_id": 3302,
            "lat": 15.251,
            "long": 104.444,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 330207,
            "zip_code": 33190,
            "name_th": "ยางชุมใหญ่",
            "name_en": "Yang Chum Yai",
            "district_id": 3302,
            "lat": 15.212,
            "long": 104.413,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 3303,
        "name_th": "กันทรารมย์",
        "name_en": "Kanthararom",
        "province_id": 22,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 330301,
            "zip_code": 33130,
            "name_th": "ดูน",
            "name_en": "Dun",
            "district_id": 3303,
            "lat": 15.113,
            "long": 104.578,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 330302,
            "zip_code": 33130,
            "name_th": "โนนสัง",
            "name_en": "Non Sang",
            "district_id": 3303,
            "lat": 15.1,
            "long": 104.642,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 330303,
            "zip_code": 33130,
            "name_th": "หนองหัวช้าง",
            "name_en": "Nong Hua Chang",
            "district_id": 3303,
            "lat": 15.049,
            "long": 104.643,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 330304,
            "zip_code": 33130,
            "name_th": "ยาง",
            "name_en": "Yang",
            "district_id": 3303,
            "lat": 15.072,
            "long": 104.526,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 330305,
            "zip_code": 33130,
            "name_th": "หนองแวง",
            "name_en": "Nong Waeng",
            "district_id": 3303,
            "lat": 15.194,
            "long": 104.658,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 330306,
            "zip_code": 33130,
            "name_th": "หนองแก้ว",
            "name_en": "Nong Kaeo",
            "district_id": 3303,
            "lat": 15.143,
            "long": 104.702,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 330307,
            "zip_code": 33130,
            "name_th": "ทาม",
            "name_en": "Tham",
            "district_id": 3303,
            "lat": 15.232,
            "long": 104.616,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 330308,
            "zip_code": 33130,
            "name_th": "ละทาย",
            "name_en": "Lathai",
            "district_id": 3303,
            "lat": 15.182,
            "long": 104.583,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 330309,
            "zip_code": 33130,
            "name_th": "เมืองน้อย",
            "name_en": "Mueang Noi",
            "district_id": 3303,
            "lat": 15.203,
            "long": 104.547,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 330310,
            "zip_code": 33130,
            "name_th": "อีปาด",
            "name_en": "I Pat",
            "district_id": 3303,
            "lat": 15.223,
            "long": 104.5,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 330311,
            "zip_code": 33130,
            "name_th": "บัวน้อย",
            "name_en": "Bua Noi",
            "district_id": 3303,
            "lat": 15.173,
            "long": 104.478,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 330312,
            "zip_code": 33130,
            "name_th": "หนองบัว",
            "name_en": "Nong Bua",
            "district_id": 3303,
            "lat": 15.12,
            "long": 104.525,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 330313,
            "zip_code": 33130,
            "name_th": "ดู่",
            "name_en": "Du",
            "district_id": 3303,
            "lat": 15.08,
            "long": 104.476,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 330314,
            "zip_code": 33130,
            "name_th": "ผักแพว",
            "name_en": "Phak Phaeo",
            "district_id": 3303,
            "lat": 15.034,
            "long": 104.537,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 330315,
            "zip_code": 33130,
            "name_th": "จาน",
            "name_en": "Chan",
            "district_id": 3303,
            "lat": 14.995,
            "long": 104.494,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 330320,
            "zip_code": 33130,
            "name_th": "คำเนียม",
            "name_en": "Kham Niam",
            "district_id": 3303,
            "lat": 15.066,
            "long": 104.583,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 3304,
        "name_th": "กันทรลักษ์",
        "name_en": "Kantharalak",
        "province_id": 22,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 330401,
            "zip_code": 33110,
            "name_th": "บึงมะลู",
            "name_en": "Bueng Malu",
            "district_id": 3304,
            "lat": 14.535,
            "long": 104.714,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 330402,
            "zip_code": 33110,
            "name_th": "กุดเสลา",
            "name_en": "Kut Salao",
            "district_id": 3304,
            "lat": 14.679,
            "long": 104.833,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 330403,
            "zip_code": 33110,
            "name_th": "เมือง",
            "name_en": "Mueang",
            "district_id": 3304,
            "lat": 14.582,
            "long": 104.67,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 330405,
            "zip_code": 33110,
            "name_th": "สังเม็ก",
            "name_en": "Sang Mek",
            "district_id": 3304,
            "lat": 14.643,
            "long": 104.729,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 330406,
            "zip_code": 33110,
            "name_th": "น้ำอ้อม",
            "name_en": "Nam Om",
            "district_id": 3304,
            "lat": 14.66,
            "long": 104.657,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 330407,
            "zip_code": 33110,
            "name_th": "ละลาย",
            "name_en": "Lalai",
            "district_id": 3304,
            "lat": 14.444,
            "long": 104.547,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 330408,
            "zip_code": 33110,
            "name_th": "รุง",
            "name_en": "Rung",
            "district_id": 3304,
            "lat": 14.48,
            "long": 104.63,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 330409,
            "zip_code": 33110,
            "name_th": "ตระกาจ",
            "name_en": "Trakat",
            "district_id": 3304,
            "lat": 14.712,
            "long": 104.596,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 330411,
            "zip_code": 33110,
            "name_th": "จานใหญ่",
            "name_en": "Chan Yai",
            "district_id": 3304,
            "lat": 14.724,
            "long": 104.655,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 330412,
            "zip_code": 33110,
            "name_th": "ภูเงิน",
            "name_en": "Phu Ngoen",
            "district_id": 3304,
            "lat": 14.745,
            "long": 104.571,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 330413,
            "zip_code": 33110,
            "name_th": "ชำ",
            "name_en": "Cham",
            "district_id": 3304,
            "lat": 14.543,
            "long": 104.575,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 330414,
            "zip_code": 33110,
            "name_th": "กระแชง",
            "name_en": "Krachaeng",
            "district_id": 3304,
            "lat": 14.65,
            "long": 104.566,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 330415,
            "zip_code": 33110,
            "name_th": "โนนสำราญ",
            "name_en": "Non Samran",
            "district_id": 3304,
            "lat": 14.534,
            "long": 104.8,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 330416,
            "zip_code": 33110,
            "name_th": "หนองหญ้าลาด",
            "name_en": "Nong Ya Lat",
            "district_id": 3304,
            "lat": 14.654,
            "long": 104.621,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 330419,
            "zip_code": 33110,
            "name_th": "เสาธงชัย",
            "name_en": "Sao Thong Chai",
            "district_id": 3304,
            "lat": 14.447,
            "long": 104.685,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 330420,
            "zip_code": 33110,
            "name_th": "ขนุน",
            "name_en": "Khanun",
            "district_id": 3304,
            "lat": 14.602,
            "long": 104.798,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 330421,
            "zip_code": 33110,
            "name_th": "สวนกล้วย",
            "name_en": "Suan Kluai",
            "district_id": 3304,
            "lat": 14.682,
            "long": 104.777,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 330423,
            "zip_code": 33110,
            "name_th": "เวียงเหนือ",
            "name_en": "Wiang Nuea",
            "district_id": 3304,
            "lat": 14.637,
            "long": 104.686,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 330424,
            "zip_code": 33110,
            "name_th": "ทุ่งใหญ่",
            "name_en": "Thung Yai",
            "district_id": 3304,
            "lat": 14.59,
            "long": 104.591,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 330425,
            "zip_code": 33110,
            "name_th": "ภูผาหมอก",
            "name_en": "Phu Pha Mok",
            "district_id": 3304,
            "lat": 14.466,
            "long": 104.809,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 3305,
        "name_th": "ขุขันธ์",
        "name_en": "Khukhan",
        "province_id": 22,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 330501,
            "zip_code": 33140,
            "name_th": "กันทรารมย์",
            "name_en": "Kanthararom",
            "district_id": 3305,
            "lat": 14.717,
            "long": 104.07,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 330502,
            "zip_code": 33140,
            "name_th": "จะกง",
            "name_en": "Chakong",
            "district_id": 3305,
            "lat": 14.821,
            "long": 104.253,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 330503,
            "zip_code": 33140,
            "name_th": "ใจดี",
            "name_en": "Chai Di",
            "district_id": 3305,
            "lat": 14.753,
            "long": 104.15,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 330504,
            "zip_code": 33140,
            "name_th": "ดองกำเม็ด",
            "name_en": "Dong Kammet",
            "district_id": 3305,
            "lat": 14.775,
            "long": 104.186,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 330505,
            "zip_code": 33140,
            "name_th": "โสน",
            "name_en": "Sano",
            "district_id": 3305,
            "lat": 14.657,
            "long": 104.104,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 330506,
            "zip_code": 33140,
            "name_th": "ปรือใหญ่",
            "name_en": "Prue Yai",
            "district_id": 3305,
            "lat": 14.601,
            "long": 104.246,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 330507,
            "zip_code": 33140,
            "name_th": "สะเดาใหญ่",
            "name_en": "Sadao Yai",
            "district_id": 3305,
            "lat": 14.712,
            "long": 104.268,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 330508,
            "zip_code": 33140,
            "name_th": "ตาอุด",
            "name_en": "Ta Ut",
            "district_id": 3305,
            "lat": 14.669,
            "long": 104.271,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 330509,
            "zip_code": 33140,
            "name_th": "ห้วยเหนือ",
            "name_en": "Huai Nuea",
            "district_id": 3305,
            "lat": 14.72,
            "long": 104.205,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 330510,
            "zip_code": 33140,
            "name_th": "ห้วยใต้",
            "name_en": "Huai Tai",
            "district_id": 3305,
            "lat": 14.662,
            "long": 104.179,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 330511,
            "zip_code": 33140,
            "name_th": "หัวเสือ",
            "name_en": "Hua Suea",
            "district_id": 3305,
            "lat": 14.834,
            "long": 104.186,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 330513,
            "zip_code": 33140,
            "name_th": "ตะเคียน",
            "name_en": "Takhian",
            "district_id": 3305,
            "lat": 14.773,
            "long": 104.248,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 330515,
            "zip_code": 33140,
            "name_th": "นิคมพัฒนา",
            "name_en": "Nikhom Phatthana",
            "district_id": 3305,
            "lat": 14.644,
            "long": 104.234,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 330517,
            "zip_code": 33140,
            "name_th": "โคกเพชร",
            "name_en": "Khok Phet",
            "district_id": 3305,
            "lat": 14.804,
            "long": 104.149,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 330518,
            "zip_code": 33140,
            "name_th": "ปราสาท",
            "name_en": "Prasat",
            "district_id": 3305,
            "lat": 14.727,
            "long": 104.016,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 330521,
            "zip_code": 33140,
            "name_th": "สำโรงตาเจ็น",
            "name_en": "Samrong Ta Chen",
            "district_id": 3305,
            "lat": 14.872,
            "long": 104.17,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 330522,
            "zip_code": 33140,
            "name_th": "ห้วยสำราญ",
            "name_en": "Huai Samran",
            "district_id": 3305,
            "lat": 14.715,
            "long": 104.115,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 330524,
            "zip_code": 33140,
            "name_th": "กฤษณา",
            "name_en": "Kritsana",
            "district_id": 3305,
            "lat": 14.874,
            "long": 104.255,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 330525,
            "zip_code": 33140,
            "name_th": "ลมศักดิ์",
            "name_en": "Lom Sak",
            "district_id": 3305,
            "lat": 14.762,
            "long": 104.283,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 330526,
            "zip_code": 33140,
            "name_th": "หนองฉลอง",
            "name_en": "Nong Chalong",
            "district_id": 3305,
            "lat": 14.684,
            "long": 104.227,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 330527,
            "zip_code": 33140,
            "name_th": "ศรีตระกูล",
            "name_en": "Si Trakun",
            "district_id": 3305,
            "lat": 14.639,
            "long": 104.28,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 330528,
            "zip_code": 33140,
            "name_th": "ศรีสะอาด",
            "name_en": "Si Sa-at",
            "district_id": 3305,
            "lat": 14.754,
            "long": 104.102,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 3306,
        "name_th": "ไพรบึง",
        "name_en": "Phrai Bueng",
        "province_id": 22,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 330601,
            "zip_code": 33180,
            "name_th": "ไพรบึง",
            "name_en": "Phrai Bueng",
            "district_id": 3306,
            "lat": 14.744,
            "long": 104.373,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 330602,
            "zip_code": 33180,
            "name_th": "ดินแดง",
            "name_en": "Din Daeng",
            "district_id": 3306,
            "lat": 14.801,
            "long": 104.308,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 330603,
            "zip_code": 33180,
            "name_th": "ปราสาทเยอ",
            "name_en": "Prasat Yoe",
            "district_id": 3306,
            "lat": 14.811,
            "long": 104.364,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 330604,
            "zip_code": 33180,
            "name_th": "สำโรงพลัน",
            "name_en": "Samrong Phlan",
            "district_id": 3306,
            "lat": 14.7,
            "long": 104.342,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 330605,
            "zip_code": 33180,
            "name_th": "สุขสวัสดิ์",
            "name_en": "Suk Sawat",
            "district_id": 3306,
            "lat": 14.856,
            "long": 104.359,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 330606,
            "zip_code": 33180,
            "name_th": "โนนปูน",
            "name_en": "Non Pun",
            "district_id": 3306,
            "lat": 14.857,
            "long": 104.303,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 3307,
        "name_th": "ปรางค์กู่",
        "name_en": "Prang Ku",
        "province_id": 22,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 330701,
            "zip_code": 33170,
            "name_th": "พิมาย",
            "name_en": "Phimai",
            "district_id": 3307,
            "lat": 14.835,
            "long": 104.032,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 330702,
            "zip_code": 33170,
            "name_th": "กู่",
            "name_en": "Ku",
            "district_id": 3307,
            "lat": 14.853,
            "long": 103.957,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 330703,
            "zip_code": 33170,
            "name_th": "หนองเชียงทูน",
            "name_en": "Nong Chiang Thun",
            "district_id": 3307,
            "lat": 14.875,
            "long": 104.101,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 330704,
            "zip_code": 33170,
            "name_th": "ตูม",
            "name_en": "Tum",
            "district_id": 3307,
            "lat": 14.903,
            "long": 104.009,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 330705,
            "zip_code": 33170,
            "name_th": "สมอ",
            "name_en": "Samo",
            "district_id": 3307,
            "lat": 14.82,
            "long": 104.094,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 330706,
            "zip_code": 33170,
            "name_th": "โพธิ์ศรี",
            "name_en": "Pho Si",
            "district_id": 3307,
            "lat": 14.78,
            "long": 104.082,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 330707,
            "zip_code": 33170,
            "name_th": "สำโรงปราสาท",
            "name_en": "Samrong Prasat",
            "district_id": 3307,
            "lat": 14.917,
            "long": 104.081,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 330708,
            "zip_code": 33170,
            "name_th": "ดู่",
            "name_en": "Du",
            "district_id": 3307,
            "lat": 14.782,
            "long": 104.027,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 330709,
            "zip_code": 33170,
            "name_th": "สวาย",
            "name_en": "Sawai",
            "district_id": 3307,
            "lat": 14.913,
            "long": 103.962,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 330710,
            "zip_code": 33170,
            "name_th": "พิมายเหนือ",
            "name_en": "Phimai Nuea",
            "district_id": 3307,
            "lat": 14.881,
            "long": 104.042,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 3308,
        "name_th": "ขุนหาญ",
        "name_en": "Khun Han",
        "province_id": 22,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 330801,
            "zip_code": 33150,
            "name_th": "สิ",
            "name_en": "Si",
            "district_id": 3308,
            "lat": 14.625,
            "long": 104.436,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 330802,
            "zip_code": 33150,
            "name_th": "บักดอง",
            "name_en": "Bak Dong",
            "district_id": 3308,
            "lat": 14.476,
            "long": 104.444,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 330803,
            "zip_code": 33150,
            "name_th": "พราน",
            "name_en": "Phran",
            "district_id": 3308,
            "lat": 14.592,
            "long": 104.501,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 330804,
            "zip_code": 33150,
            "name_th": "โพธิ์วงศ์",
            "name_en": "Pho Wong",
            "district_id": 3308,
            "lat": 14.666,
            "long": 104.458,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 330805,
            "zip_code": 33150,
            "name_th": "ไพร",
            "name_en": "Phrai",
            "district_id": 3308,
            "lat": 14.706,
            "long": 104.454,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 330806,
            "zip_code": 33150,
            "name_th": "กระหวัน",
            "name_en": "Krawan",
            "district_id": 3308,
            "lat": 14.673,
            "long": 104.414,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 330807,
            "zip_code": 33150,
            "name_th": "ขุนหาญ",
            "name_en": "Khun Han",
            "district_id": 3308,
            "lat": 14.635,
            "long": 104.371,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 330808,
            "zip_code": 33150,
            "name_th": "โนนสูง",
            "name_en": "Non Sung",
            "district_id": 3308,
            "lat": 14.581,
            "long": 104.416,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 330809,
            "zip_code": 33150,
            "name_th": "กันทรอม",
            "name_en": "Kanthrom",
            "district_id": 3308,
            "lat": 14.575,
            "long": 104.353,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 330810,
            "zip_code": 33150,
            "name_th": "ภูฝ้าย",
            "name_en": "Phu Fai",
            "district_id": 3308,
            "lat": 14.683,
            "long": 104.51,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 330811,
            "zip_code": 33150,
            "name_th": "โพธิ์กระสังข์",
            "name_en": "Pho Krasang",
            "district_id": 3308,
            "lat": 14.628,
            "long": 104.327,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 330812,
            "zip_code": 33150,
            "name_th": "ห้วยจันทร์",
            "name_en": "Huai Chan",
            "district_id": 3308,
            "lat": 14.465,
            "long": 104.353,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 3309,
        "name_th": "ราษีไศล",
        "name_en": "Rasi Salai",
        "province_id": 22,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 330901,
            "zip_code": 33160,
            "name_th": "เมืองคง",
            "name_en": "Mueang Khong",
            "district_id": 3309,
            "lat": 15.356,
            "long": 104.159,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 330902,
            "zip_code": 33160,
            "name_th": "เมืองแคน",
            "name_en": "Muang Khaen",
            "district_id": 3309,
            "lat": 15.351,
            "long": 104.214,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 330903,
            "zip_code": 33160,
            "name_th": "หนองแค",
            "name_en": "Nong Khae",
            "district_id": 3309,
            "lat": 15.38,
            "long": 104.106,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 330906,
            "zip_code": 33160,
            "name_th": "จิกสังข์ทอง",
            "name_en": "Chik Sang Thong",
            "district_id": 3309,
            "lat": 15.435,
            "long": 104.125,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 330907,
            "zip_code": 33160,
            "name_th": "ด่าน",
            "name_en": "Dan",
            "district_id": 3309,
            "lat": 15.421,
            "long": 104.026,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 330908,
            "zip_code": 33160,
            "name_th": "ดู่",
            "name_en": "Du",
            "district_id": 3309,
            "lat": 15.416,
            "long": 104.162,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 330909,
            "zip_code": 33160,
            "name_th": "หนองอึ่ง",
            "name_en": "Nong Ueng",
            "district_id": 3309,
            "lat": 15.278,
            "long": 104.176,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 330910,
            "zip_code": 33160,
            "name_th": "บัวหุ่ง",
            "name_en": "Bua Hung",
            "district_id": 3309,
            "lat": 15.321,
            "long": 104.105,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 330911,
            "zip_code": 33160,
            "name_th": "ไผ่",
            "name_en": "Phai",
            "district_id": 3309,
            "lat": 15.332,
            "long": 104.257,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 330912,
            "zip_code": 33160,
            "name_th": "ส้มป่อย",
            "name_en": "Som Poi",
            "district_id": 3309,
            "lat": 15.283,
            "long": 104.232,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 330913,
            "zip_code": 33160,
            "name_th": "หนองหมี",
            "name_en": "Nong Mi",
            "district_id": 3309,
            "lat": 15.271,
            "long": 104.293,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 330914,
            "zip_code": 33160,
            "name_th": "หว้านคำ",
            "name_en": "Wan Kham",
            "district_id": 3309,
            "lat": 15.407,
            "long": 104.2,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 330915,
            "zip_code": 33160,
            "name_th": "สร้างปี่",
            "name_en": "Sang Pi",
            "district_id": 3309,
            "lat": 15.317,
            "long": 104.305,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 3310,
        "name_th": "อุทุมพรพิสัย",
        "name_en": "Uthumphon Phisai",
        "province_id": 22,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 331001,
            "zip_code": 33120,
            "name_th": "กำแพง",
            "name_en": "Kamphaeng",
            "district_id": 3310,
            "lat": 15.1,
            "long": 104.15,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 331002,
            "zip_code": 33120,
            "name_th": "อี่หล่ำ",
            "name_en": "I Lam",
            "district_id": 3310,
            "lat": 15.198,
            "long": 104.188,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 331003,
            "zip_code": 33120,
            "name_th": "ก้านเหลือง",
            "name_en": "Kan Lueang",
            "district_id": 3310,
            "lat": 15.052,
            "long": 104.143,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 331004,
            "zip_code": 33120,
            "name_th": "ทุ่งไชย",
            "name_en": "Thung Chai",
            "district_id": 3310,
            "lat": 15.016,
            "long": 104.109,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 331005,
            "zip_code": 33120,
            "name_th": "สำโรง",
            "name_en": "Samrong",
            "district_id": 3310,
            "lat": 15.146,
            "long": 104.148,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 331006,
            "zip_code": 33120,
            "name_th": "แขม",
            "name_en": "Khaem",
            "district_id": 3310,
            "lat": 15.198,
            "long": 104.14,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 331007,
            "zip_code": 33120,
            "name_th": "หนองไฮ",
            "name_en": "Nong Hai",
            "district_id": 3310,
            "lat": 15.145,
            "long": 104.093,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 331008,
            "zip_code": 33120,
            "name_th": "ขะยูง",
            "name_en": "Khayung",
            "district_id": 3310,
            "lat": 15.126,
            "long": 104.238,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 331010,
            "zip_code": 33120,
            "name_th": "ตาเกษ",
            "name_en": "Ta Ket",
            "district_id": 3310,
            "lat": 15.143,
            "long": 104.21,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 331011,
            "zip_code": 33120,
            "name_th": "หัวช้าง",
            "name_en": "Hua Chang",
            "district_id": 3310,
            "lat": 15.251,
            "long": 104.132,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 331012,
            "zip_code": 33120,
            "name_th": "รังแร้ง",
            "name_en": "Rang Raeng",
            "district_id": 3310,
            "lat": 15.223,
            "long": 104.228,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 331014,
            "zip_code": 33120,
            "name_th": "แต้",
            "name_en": "Tae",
            "district_id": 3310,
            "lat": 15.12,
            "long": 104.178,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 331015,
            "zip_code": 33120,
            "name_th": "แข้",
            "name_en": "Khae",
            "district_id": 3310,
            "lat": 15.067,
            "long": 104.176,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 331016,
            "zip_code": 33120,
            "name_th": "โพธิ์ชัย",
            "name_en": "Pho Chai",
            "district_id": 3310,
            "lat": 15.173,
            "long": 104.227,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 331017,
            "zip_code": 33120,
            "name_th": "ปะอาว",
            "name_en": "Pa Ao",
            "district_id": 3310,
            "lat": 15.101,
            "long": 104.214,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 331018,
            "zip_code": 33120,
            "name_th": "หนองห้าง",
            "name_en": "Nong Hang",
            "district_id": 3310,
            "lat": 15.098,
            "long": 104.088,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 331022,
            "zip_code": 33120,
            "name_th": "สระกำแพงใหญ่",
            "name_en": "Sa Kamphaeng Yai",
            "district_id": 3310,
            "lat": 15.093,
            "long": 104.128,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 331024,
            "zip_code": 33120,
            "name_th": "โคกหล่าม",
            "name_en": "Khok Lam",
            "district_id": 3310,
            "lat": 15.22,
            "long": 104.171,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 331025,
            "zip_code": 33120,
            "name_th": "โคกจาน",
            "name_en": "Khok Chan",
            "district_id": 3310,
            "lat": 14.966,
            "long": 104.104,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 3311,
        "name_th": "บึงบูรพ์",
        "name_en": "Bueng Bun",
        "province_id": 22,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 331101,
            "zip_code": 33220,
            "name_th": "เป๊าะ",
            "name_en": "Po",
            "district_id": 3311,
            "lat": 15.297,
            "long": 104.06,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 331102,
            "zip_code": 33220,
            "name_th": "บึงบูรพ์",
            "name_en": "Bueng Bun",
            "district_id": 3311,
            "lat": 15.328,
            "long": 104.067,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 3312,
        "name_th": "ห้วยทับทัน",
        "name_en": "Huai Thap Than",
        "province_id": 22,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 331201,
            "zip_code": 33210,
            "name_th": "ห้วยทับทัน",
            "name_en": "Huai Thap Than",
            "district_id": 3312,
            "lat": 15.065,
            "long": 104.044,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 331202,
            "zip_code": 33210,
            "name_th": "เมืองหลวง",
            "name_en": "Mueang Luang",
            "district_id": 3312,
            "lat": 15.021,
            "long": 104.047,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 331203,
            "zip_code": 33210,
            "name_th": "กล้วยกว้าง",
            "name_en": "Kluai Kwang",
            "district_id": 3312,
            "lat": 14.966,
            "long": 104.069,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 331204,
            "zip_code": 33210,
            "name_th": "ผักไหม",
            "name_en": "Phak Mai",
            "district_id": 3312,
            "lat": 14.947,
            "long": 104.013,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 331205,
            "zip_code": 33210,
            "name_th": "จานแสนไชย",
            "name_en": "Chan Saen Chai",
            "district_id": 3312,
            "lat": 14.981,
            "long": 104.019,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 331206,
            "zip_code": 33210,
            "name_th": "ปราสาท",
            "name_en": "Prasat",
            "district_id": 3312,
            "lat": 15.11,
            "long": 104.027,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 3313,
        "name_th": "โนนคูณ",
        "name_en": "Non Khun",
        "province_id": 22,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 331301,
            "zip_code": 33250,
            "name_th": "โนนค้อ",
            "name_en": "Non Kho",
            "district_id": 3313,
            "lat": 14.899,
            "long": 104.71,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 331302,
            "zip_code": 33250,
            "name_th": "บก",
            "name_en": "Bok",
            "district_id": 3313,
            "lat": 14.976,
            "long": 104.64,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 331303,
            "zip_code": 33250,
            "name_th": "โพธิ์",
            "name_en": "Pho",
            "district_id": 3313,
            "lat": 14.923,
            "long": 104.614,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 331304,
            "zip_code": 33250,
            "name_th": "หนองกุง",
            "name_en": "Nong Kung",
            "district_id": 3313,
            "lat": 14.861,
            "long": 104.774,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 331305,
            "zip_code": 33250,
            "name_th": "เหล่ากวาง",
            "name_en": "Lao Kwang",
            "district_id": 3313,
            "lat": 14.88,
            "long": 104.638,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 3314,
        "name_th": "ศรีรัตนะ",
        "name_en": "Si Rattana",
        "province_id": 22,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 331401,
            "zip_code": 33240,
            "name_th": "ศรีแก้ว",
            "name_en": "Si Kaeo",
            "district_id": 3314,
            "lat": 14.766,
            "long": 104.476,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 331402,
            "zip_code": 33240,
            "name_th": "พิงพวย",
            "name_en": "Phing Phuai",
            "district_id": 3314,
            "lat": 14.744,
            "long": 104.453,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 331403,
            "zip_code": 33240,
            "name_th": "สระเยาว์",
            "name_en": "Sa Yao",
            "district_id": 3314,
            "lat": 14.785,
            "long": 104.515,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 331404,
            "zip_code": 33240,
            "name_th": "ตูม",
            "name_en": "Tum",
            "district_id": 3314,
            "lat": 14.866,
            "long": 104.488,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 331405,
            "zip_code": 33240,
            "name_th": "เสื่องข้าว",
            "name_en": "Sueang Khao",
            "district_id": 3314,
            "lat": 14.813,
            "long": 104.555,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 331406,
            "zip_code": 33240,
            "name_th": "ศรีโนนงาม",
            "name_en": "Si Non Ngam",
            "district_id": 3314,
            "lat": 14.806,
            "long": 104.419,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 331407,
            "zip_code": 33240,
            "name_th": "สะพุง",
            "name_en": "Saphung",
            "district_id": 3314,
            "lat": 14.828,
            "long": 104.474,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 3315,
        "name_th": "น้ำเกลี้ยง",
        "name_en": "Nam Kliang",
        "province_id": 22,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 331501,
            "zip_code": 33130,
            "name_th": "น้ำเกลี้ยง",
            "name_en": "Nam Kliang",
            "district_id": 3315,
            "lat": 14.917,
            "long": 104.55,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 331502,
            "zip_code": 33130,
            "name_th": "ละเอาะ",
            "name_en": "La-o",
            "district_id": 3315,
            "lat": 14.93,
            "long": 104.451,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 331503,
            "zip_code": 33130,
            "name_th": "ตองปิด",
            "name_en": "Tong Pit",
            "district_id": 3315,
            "lat": 14.964,
            "long": 104.479,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 331504,
            "zip_code": 33130,
            "name_th": "เขิน",
            "name_en": "Khoen",
            "district_id": 3315,
            "lat": 14.852,
            "long": 104.58,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 331505,
            "zip_code": 33130,
            "name_th": "รุ่งระวี",
            "name_en": "Rung Rawi",
            "district_id": 3315,
            "lat": 14.876,
            "long": 104.525,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 331506,
            "zip_code": 33130,
            "name_th": "คูบ",
            "name_en": "Khup",
            "district_id": 3315,
            "lat": 14.971,
            "long": 104.569,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 3316,
        "name_th": "วังหิน",
        "name_en": "Wang Hin",
        "province_id": 22,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 331601,
            "zip_code": 33270,
            "name_th": "บุสูง",
            "name_en": "Bu Sung",
            "district_id": 3316,
            "lat": 14.957,
            "long": 104.209,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 331602,
            "zip_code": 33270,
            "name_th": "ธาตุ",
            "name_en": "That",
            "district_id": 3316,
            "lat": 14.988,
            "long": 104.186,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 331603,
            "zip_code": 33270,
            "name_th": "ดวนใหญ่",
            "name_en": "Duan Yai",
            "district_id": 3316,
            "lat": 14.945,
            "long": 104.271,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 331604,
            "zip_code": 33270,
            "name_th": "บ่อแก้ว",
            "name_en": "Bo Kaeo",
            "district_id": 3316,
            "lat": 14.992,
            "long": 104.27,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 331605,
            "zip_code": 33270,
            "name_th": "ศรีสำราญ",
            "name_en": "Si Samran",
            "district_id": 3316,
            "lat": 14.909,
            "long": 104.155,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 331606,
            "zip_code": 33270,
            "name_th": "ทุ่งสว่าง",
            "name_en": "Thung Sawang",
            "district_id": 3316,
            "lat": 15.018,
            "long": 104.224,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 331607,
            "zip_code": 33270,
            "name_th": "วังหิน",
            "name_en": "Wang Hin",
            "district_id": 3316,
            "lat": 14.92,
            "long": 104.24,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 331608,
            "zip_code": 33270,
            "name_th": "โพนยาง",
            "name_en": "Phon Yang",
            "district_id": 3316,
            "lat": 14.926,
            "long": 104.204,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 3317,
        "name_th": "ภูสิงห์",
        "name_en": "Phu Sing",
        "province_id": 22,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 331701,
            "zip_code": 33140,
            "name_th": "โคกตาล",
            "name_en": "Khok Tan",
            "district_id": 3317,
            "lat": 14.549,
            "long": 104.203,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 331702,
            "zip_code": 33140,
            "name_th": "ห้วยตามอญ",
            "name_en": "Huai Ta Mon",
            "district_id": 3317,
            "lat": 14.525,
            "long": 104.077,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 331703,
            "zip_code": 33140,
            "name_th": "ห้วยตึ๊กชู",
            "name_en": "Huai Tuekchu",
            "district_id": 3317,
            "lat": 14.566,
            "long": 104.12,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 331704,
            "zip_code": 33140,
            "name_th": "ละลม",
            "name_en": "Lalom",
            "district_id": 3317,
            "lat": 14.588,
            "long": 104.079,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 331705,
            "zip_code": 33140,
            "name_th": "ตะเคียนราม",
            "name_en": "Takhian Ram",
            "district_id": 3317,
            "lat": 14.606,
            "long": 104.169,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 331706,
            "zip_code": 33140,
            "name_th": "ดงรัก",
            "name_en": "Dong Rak",
            "district_id": 3317,
            "lat": 14.44,
            "long": 104.189,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 331707,
            "zip_code": 33140,
            "name_th": "ไพรพัฒนา",
            "name_en": "Phrai Phatthana",
            "district_id": 3317,
            "lat": 14.426,
            "long": 104.085,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 3318,
        "name_th": "เมืองจันทร์",
        "name_en": "Mueang Chan",
        "province_id": 22,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 331801,
            "zip_code": 33120,
            "name_th": "เมืองจันทร์",
            "name_en": "Mueang Chan",
            "district_id": 3318,
            "lat": 15.155,
            "long": 104.011,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 331802,
            "zip_code": 33120,
            "name_th": "ตาโกน",
            "name_en": "Takon",
            "district_id": 3318,
            "lat": 15.205,
            "long": 103.996,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 331803,
            "zip_code": 33120,
            "name_th": "หนองใหญ่",
            "name_en": "Nong Yai",
            "district_id": 3318,
            "lat": 15.198,
            "long": 104.035,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 3319,
        "name_th": "เบญจลักษ์",
        "name_en": "Benchalak",
        "province_id": 22,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 331901,
            "zip_code": 33110,
            "name_th": "เสียว",
            "name_en": "Siao",
            "district_id": 3319,
            "lat": 14.799,
            "long": 104.668,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 331902,
            "zip_code": 33110,
            "name_th": "หนองหว้า",
            "name_en": "Nong Wa",
            "district_id": 3319,
            "lat": 14.754,
            "long": 104.722,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 331903,
            "zip_code": 33110,
            "name_th": "หนองงูเหลือม",
            "name_en": "Nong Ngu Lueam",
            "district_id": 3319,
            "lat": 14.836,
            "long": 104.653,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 331904,
            "zip_code": 33110,
            "name_th": "หนองฮาง",
            "name_en": "Nong Hang",
            "district_id": 3319,
            "lat": 14.778,
            "long": 104.594,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 331905,
            "zip_code": 33110,
            "name_th": "ท่าคล้อ",
            "name_en": "Tha Khlo",
            "district_id": 3319,
            "lat": 14.761,
            "long": 104.783,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 3320,
        "name_th": "พยุห์",
        "name_en": "Phayu",
        "province_id": 22,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 332001,
            "zip_code": 33230,
            "name_th": "พยุห์",
            "name_en": "Phayu",
            "district_id": 3320,
            "lat": 14.935,
            "long": 104.387,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 332002,
            "zip_code": 33230,
            "name_th": "พรหมสวัสดิ์",
            "name_en": "Phrom Sawat",
            "district_id": 3320,
            "lat": 14.852,
            "long": 104.427,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 332003,
            "zip_code": 33230,
            "name_th": "ตำแย",
            "name_en": "Tamyae",
            "district_id": 3320,
            "lat": 14.918,
            "long": 104.422,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 332004,
            "zip_code": 33230,
            "name_th": "โนนเพ็ก",
            "name_en": "Non Phek",
            "district_id": 3320,
            "lat": 14.933,
            "long": 104.327,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 332005,
            "zip_code": 33230,
            "name_th": "หนองค้า",
            "name_en": "Nong Kha",
            "district_id": 3320,
            "lat": 14.898,
            "long": 104.334,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 3321,
        "name_th": "โพธิ์ศรีสุวรรณ",
        "name_en": "Pho Si Suwan",
        "province_id": 22,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 332101,
            "zip_code": 33120,
            "name_th": "โดด",
            "name_en": "Dot",
            "district_id": 3321,
            "lat": 15.204,
            "long": 104.078,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 332102,
            "zip_code": 33120,
            "name_th": "เสียว",
            "name_en": "Siao",
            "district_id": 3321,
            "lat": 15.251,
            "long": 104.043,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 332103,
            "zip_code": 33120,
            "name_th": "หนองม้า",
            "name_en": "Nong Ma",
            "district_id": 3321,
            "lat": 15.254,
            "long": 104.083,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 332104,
            "zip_code": 33120,
            "name_th": "ผือใหญ่",
            "name_en": "Phue Yai",
            "district_id": 3321,
            "lat": 15.233,
            "long": 104.111,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 332105,
            "zip_code": 33120,
            "name_th": "อีเซ",
            "name_en": "I Se",
            "district_id": 3321,
            "lat": 15.269,
            "long": 104.009,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 3322,
        "name_th": "ศิลาลาด",
        "name_en": "Sila Lat",
        "province_id": 22,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 332201,
            "zip_code": 33160,
            "name_th": "กุง",
            "name_en": "Kung",
            "district_id": 3322,
            "lat": 15.474,
            "long": 104.084,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 332202,
            "zip_code": 33160,
            "name_th": "คลีกลิ้ง",
            "name_en": "Kleek Ling",
            "district_id": 3322,
            "lat": 15.529,
            "long": 104.109,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 332203,
            "zip_code": 33160,
            "name_th": "หนองบัวดง",
            "name_en": "Nong Bua Dong",
            "district_id": 3322,
            "lat": 15.458,
            "long": 104.046,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 332204,
            "zip_code": 33160,
            "name_th": "โจดม่วง",
            "name_en": "Jod Maung",
            "district_id": 3322,
            "lat": 15.473,
            "long": 104.139,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      }
    ]
  },
  {
    "id": 23,
    "name_th": "อุบลราชธานี",
    "name_en": "Ubon Ratchathani",
    "geography_id": 3,
    "created_at": "2019-08-09T03:33:09.000+07:00",
    "updated_at": "2025-09-20T06:31:26.000+07:00",
    "deleted_at": null,
    "districts": [
      {
        "id": 3401,
        "name_th": "เมืองอุบลราชธานี",
        "name_en": "Mueang Ubon Ratchathani",
        "province_id": 23,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 340101,
            "zip_code": 34000,
            "name_th": "ในเมือง",
            "name_en": "Nai Mueang",
            "district_id": 3401,
            "lat": 15.232,
            "long": 104.859,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 340104,
            "zip_code": 34000,
            "name_th": "หัวเรือ",
            "name_en": "Hua Ruea",
            "district_id": 3401,
            "lat": 15.367,
            "long": 104.845,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 340105,
            "zip_code": 34000,
            "name_th": "หนองขอน",
            "name_en": "Nong Khon",
            "district_id": 3401,
            "lat": 15.32,
            "long": 104.766,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 340107,
            "zip_code": 34000,
            "name_th": "ปทุม",
            "name_en": "Pathum",
            "district_id": 3401,
            "lat": 15.244,
            "long": 104.894,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 340108,
            "zip_code": 34000,
            "name_th": "ขามใหญ่",
            "name_en": "Kham Yai",
            "district_id": 3401,
            "lat": 15.302,
            "long": 104.836,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 340109,
            "zip_code": 34000,
            "name_th": "แจระแม",
            "name_en": "Chaeramae",
            "district_id": 3401,
            "lat": 15.251,
            "long": 104.802,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 340111,
            "zip_code": 34000,
            "name_th": "หนองบ่อ",
            "name_en": "Nong Bo",
            "district_id": 3401,
            "lat": 15.239,
            "long": 104.727,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 340112,
            "zip_code": 34000,
            "name_th": "ไร่น้อย",
            "name_en": "Rai Noi",
            "district_id": 3401,
            "lat": 15.314,
            "long": 104.905,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 340113,
            "zip_code": 34000,
            "name_th": "กระโสบ",
            "name_en": "Krasop",
            "district_id": 3401,
            "lat": 15.309,
            "long": 104.97,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 340116,
            "zip_code": 34000,
            "name_th": "กุดลาด",
            "name_en": "Kut Lat",
            "district_id": 3401,
            "lat": 15.291,
            "long": 105.0,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 340119,
            "zip_code": 34000,
            "name_th": "ขี้เหล็ก",
            "name_en": "Khilek",
            "district_id": 3401,
            "lat": 15.351,
            "long": 104.815,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 340120,
            "zip_code": 34000,
            "name_th": "ปะอาว",
            "name_en": "Pa-ao",
            "district_id": 3401,
            "lat": 15.365,
            "long": 104.716,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 3402,
        "name_th": "ศรีเมืองใหม่",
        "name_en": "Si Mueang Mai",
        "province_id": 23,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 340201,
            "zip_code": 34250,
            "name_th": "นาคำ",
            "name_en": "Na Kham",
            "district_id": 3402,
            "lat": 15.507,
            "long": 105.327,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 340202,
            "zip_code": 34250,
            "name_th": "แก้งกอก",
            "name_en": "Kaeng Kok",
            "district_id": 3402,
            "lat": 15.478,
            "long": 105.237,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 340203,
            "zip_code": 34250,
            "name_th": "เอือดใหญ่",
            "name_en": "Ueat Yai",
            "district_id": 3402,
            "lat": 15.52,
            "long": 105.219,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 340204,
            "zip_code": 34250,
            "name_th": "วาริน",
            "name_en": "Warin",
            "district_id": 3402,
            "lat": 15.415,
            "long": 105.26,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 340205,
            "zip_code": 34250,
            "name_th": "ลาดควาย",
            "name_en": "Lat Khwai",
            "district_id": 3402,
            "lat": 15.564,
            "long": 105.329,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 340206,
            "zip_code": 34250,
            "name_th": "สงยาง",
            "name_en": "Song Yang",
            "district_id": 3402,
            "lat": 15.623,
            "long": 105.286,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 340207,
            "zip_code": 34250,
            "name_th": "ตะบ่าย",
            "name_en": "Ta Bai",
            "district_id": 3402,
            "lat": 15.56,
            "long": 105.227,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 340208,
            "zip_code": 34250,
            "name_th": "คำไหล",
            "name_en": "Kham Lai",
            "district_id": 3402,
            "lat": 15.409,
            "long": 105.346,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 340209,
            "zip_code": 34250,
            "name_th": "หนามแท่ง",
            "name_en": "Nam Thaeng",
            "district_id": 3402,
            "lat": 15.695,
            "long": 105.565,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 340210,
            "zip_code": 34250,
            "name_th": "นาเลิน",
            "name_en": "Na Loen",
            "district_id": 3402,
            "lat": 15.607,
            "long": 105.383,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 340211,
            "zip_code": 34250,
            "name_th": "ดอนใหญ่",
            "name_en": "Don Yai",
            "district_id": 3402,
            "lat": 15.447,
            "long": 105.316,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 3403,
        "name_th": "โขงเจียม",
        "name_en": "Khong Chiam",
        "province_id": 23,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 340301,
            "zip_code": 34220,
            "name_th": "โขงเจียม",
            "name_en": "Khong Chiam",
            "district_id": 3403,
            "lat": 15.296,
            "long": 105.452,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 340302,
            "zip_code": 34220,
            "name_th": "ห้วยยาง",
            "name_en": "Huai Yang",
            "district_id": 3403,
            "lat": 15.467,
            "long": 105.455,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 340303,
            "zip_code": 34220,
            "name_th": "นาโพธิ์กลาง",
            "name_en": "Na Pho Klang",
            "district_id": 3403,
            "lat": 15.553,
            "long": 105.557,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 340304,
            "zip_code": 34220,
            "name_th": "หนองแสงใหญ่",
            "name_en": "Nong Saeng Yai",
            "district_id": 3403,
            "lat": 15.339,
            "long": 105.389,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 340305,
            "zip_code": 34220,
            "name_th": "ห้วยไผ่",
            "name_en": "Huai Phai",
            "district_id": 3403,
            "lat": 15.42,
            "long": 105.551,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 340306,
            "zip_code": 34220,
            "name_th": "คำเขื่อนแก้ว",
            "name_en": "Kham Khuen Kaew",
            "district_id": 3403,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 3404,
        "name_th": "เขื่องใน",
        "name_en": "Khueang Nai",
        "province_id": 23,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 340401,
            "zip_code": 34150,
            "name_th": "เขื่องใน",
            "name_en": "Khueang Nai",
            "district_id": 3404,
            "lat": 15.371,
            "long": 104.556,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 340402,
            "zip_code": 34150,
            "name_th": "สร้างถ่อ",
            "name_en": "Sang Tho",
            "district_id": 3404,
            "lat": 15.367,
            "long": 104.503,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 340403,
            "zip_code": 34150,
            "name_th": "ค้อทอง",
            "name_en": "Kho Thong",
            "district_id": 3404,
            "lat": 15.399,
            "long": 104.429,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 340404,
            "zip_code": 34150,
            "name_th": "ก่อเอ้",
            "name_en": "Ko E",
            "district_id": 3404,
            "lat": 15.392,
            "long": 104.623,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 340405,
            "zip_code": 34150,
            "name_th": "หัวดอน",
            "name_en": "Hua Don",
            "district_id": 3404,
            "lat": 15.307,
            "long": 104.69,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 340406,
            "zip_code": 34150,
            "name_th": "ชีทวน",
            "name_en": "Chi Thuan",
            "district_id": 3404,
            "lat": 15.269,
            "long": 104.653,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 340407,
            "zip_code": 34150,
            "name_th": "ท่าไห",
            "name_en": "Tha Hai",
            "district_id": 3404,
            "lat": 15.319,
            "long": 104.602,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 340408,
            "zip_code": 34150,
            "name_th": "นาคำใหญ่",
            "name_en": "Na Kham Yai",
            "district_id": 3404,
            "lat": 15.283,
            "long": 104.566,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 340409,
            "zip_code": 34150,
            "name_th": "แดงหม้อ",
            "name_en": "Daeng Mo",
            "district_id": 3404,
            "lat": 15.29,
            "long": 104.513,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 340410,
            "zip_code": 34150,
            "name_th": "ธาตุน้อย",
            "name_en": "That Noi",
            "district_id": 3404,
            "lat": 15.281,
            "long": 104.48,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 340411,
            "zip_code": 34320,
            "name_th": "บ้านไทย",
            "name_en": "Ban Thai",
            "district_id": 3404,
            "lat": 15.454,
            "long": 104.424,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 340412,
            "zip_code": 34320,
            "name_th": "บ้านกอก",
            "name_en": "Ban Kok",
            "district_id": 3404,
            "lat": 15.489,
            "long": 104.464,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 340413,
            "zip_code": 34320,
            "name_th": "กลางใหญ่",
            "name_en": "Klang Yai",
            "district_id": 3404,
            "lat": 15.515,
            "long": 104.407,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 340414,
            "zip_code": 34320,
            "name_th": "โนนรัง",
            "name_en": "Non Rang",
            "district_id": 3404,
            "lat": 15.521,
            "long": 104.5,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 340415,
            "zip_code": 34150,
            "name_th": "ยางขี้นก",
            "name_en": "Yang Khi Nok",
            "district_id": 3404,
            "lat": 15.446,
            "long": 104.508,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 340416,
            "zip_code": 34150,
            "name_th": "ศรีสุข",
            "name_en": "Si Suk",
            "district_id": 3404,
            "lat": 15.477,
            "long": 104.515,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 340417,
            "zip_code": 34150,
            "name_th": "สหธาตุ",
            "name_en": "Sahathat",
            "district_id": 3404,
            "lat": 15.338,
            "long": 104.459,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 340418,
            "zip_code": 34150,
            "name_th": "หนองเหล่า",
            "name_en": "Nong Lao",
            "district_id": 3404,
            "lat": 15.453,
            "long": 104.592,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 3405,
        "name_th": "เขมราฐ",
        "name_en": "Khemarat",
        "province_id": 23,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 340501,
            "zip_code": 34170,
            "name_th": "เขมราฐ",
            "name_en": "Khemarat",
            "district_id": 3405,
            "lat": 16.049,
            "long": 105.136,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 340503,
            "zip_code": 34170,
            "name_th": "ขามป้อม",
            "name_en": "Kham Pom",
            "district_id": 3405,
            "lat": 15.977,
            "long": 105.179,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 340504,
            "zip_code": 34170,
            "name_th": "เจียด",
            "name_en": "Chiat",
            "district_id": 3405,
            "lat": 15.872,
            "long": 105.222,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 340507,
            "zip_code": 34170,
            "name_th": "หนองผือ",
            "name_en": "Nong Phue",
            "district_id": 3405,
            "lat": 15.95,
            "long": 105.058,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 340508,
            "zip_code": 34170,
            "name_th": "นาแวง",
            "name_en": "Na Waeng",
            "district_id": 3405,
            "lat": 16.011,
            "long": 105.329,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 340510,
            "zip_code": 34170,
            "name_th": "แก้งเหนือ",
            "name_en": "Kaeng Nuea",
            "district_id": 3405,
            "lat": 15.932,
            "long": 105.128,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 340511,
            "zip_code": 34170,
            "name_th": "หนองนกทา",
            "name_en": "Nong Nok Tha",
            "district_id": 3405,
            "lat": 16.019,
            "long": 105.096,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 340512,
            "zip_code": 34170,
            "name_th": "หนองสิม",
            "name_en": "Nong Sim",
            "district_id": 3405,
            "lat": 16.025,
            "long": 105.037,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 340513,
            "zip_code": 34170,
            "name_th": "หัวนา",
            "name_en": "Hua Na",
            "district_id": 3405,
            "lat": 15.867,
            "long": 105.155,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 3407,
        "name_th": "เดชอุดม",
        "name_en": "Det Udom",
        "province_id": 23,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 340701,
            "zip_code": 34160,
            "name_th": "เมืองเดช",
            "name_en": "Mueang Det",
            "district_id": 3407,
            "lat": 14.92,
            "long": 105.055,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 340702,
            "zip_code": 34160,
            "name_th": "นาส่วง",
            "name_en": "Na Suang",
            "district_id": 3407,
            "lat": 15.012,
            "long": 104.983,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 340704,
            "zip_code": 34160,
            "name_th": "นาเจริญ",
            "name_en": "Na Charoen",
            "district_id": 3407,
            "lat": 14.902,
            "long": 104.955,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 340706,
            "zip_code": 34160,
            "name_th": "ทุ่งเทิง",
            "name_en": "Thung Thoeng",
            "district_id": 3407,
            "lat": 14.819,
            "long": 104.846,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 340708,
            "zip_code": 34160,
            "name_th": "สมสะอาด",
            "name_en": "Som Sa-at",
            "district_id": 3407,
            "lat": 14.824,
            "long": 104.987,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 340709,
            "zip_code": 34160,
            "name_th": "กุดประทาย",
            "name_en": "Kut Prathai",
            "district_id": 3407,
            "lat": 14.966,
            "long": 105.196,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 340710,
            "zip_code": 34160,
            "name_th": "ตบหู",
            "name_en": "Top Hu",
            "district_id": 3407,
            "lat": 14.702,
            "long": 105.09,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 340711,
            "zip_code": 34160,
            "name_th": "กลาง",
            "name_en": "Klang",
            "district_id": 3407,
            "lat": 14.797,
            "long": 105.141,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 340712,
            "zip_code": 34160,
            "name_th": "แก้ง",
            "name_en": "Kaeng",
            "district_id": 3407,
            "lat": 14.695,
            "long": 105.014,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 340713,
            "zip_code": 34160,
            "name_th": "ท่าโพธิ์ศรี",
            "name_en": "Tha Pho Si",
            "district_id": 3407,
            "lat": 14.84,
            "long": 105.049,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 340715,
            "zip_code": 34160,
            "name_th": "บัวงาม",
            "name_en": "Bua Ngam",
            "district_id": 3407,
            "lat": 14.801,
            "long": 105.218,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 340716,
            "zip_code": 34160,
            "name_th": "คำครั่ง",
            "name_en": "Kham Khrang",
            "district_id": 3407,
            "lat": 14.889,
            "long": 105.205,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 340717,
            "zip_code": 34160,
            "name_th": "นากระแซง",
            "name_en": "Na Krasaeng",
            "district_id": 3407,
            "lat": 14.87,
            "long": 104.908,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 340720,
            "zip_code": 34160,
            "name_th": "โพนงาม",
            "name_en": "Phon Ngam",
            "district_id": 3407,
            "lat": 14.904,
            "long": 105.115,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 340721,
            "zip_code": 34160,
            "name_th": "ป่าโมง",
            "name_en": "Pa Mong",
            "district_id": 3407,
            "lat": 14.961,
            "long": 104.976,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 340723,
            "zip_code": 34160,
            "name_th": "โนนสมบูรณ์",
            "name_en": "Non Sombun",
            "district_id": 3407,
            "lat": 14.76,
            "long": 105.03,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 3408,
        "name_th": "นาจะหลวย",
        "name_en": "Na Chaluai",
        "province_id": 23,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 340801,
            "zip_code": 34280,
            "name_th": "นาจะหลวย",
            "name_en": "Na Chaluai",
            "district_id": 3408,
            "lat": 14.487,
            "long": 105.261,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 340802,
            "zip_code": 34280,
            "name_th": "โนนสมบูรณ์",
            "name_en": "Non Sombun",
            "district_id": 3408,
            "lat": 14.688,
            "long": 105.201,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 340803,
            "zip_code": 34280,
            "name_th": "พรสวรรค์",
            "name_en": "Phon Sawan",
            "district_id": 3408,
            "lat": 14.627,
            "long": 105.18,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 340804,
            "zip_code": 34280,
            "name_th": "บ้านตูม",
            "name_en": "Ban Tum",
            "district_id": 3408,
            "lat": 14.608,
            "long": 105.241,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 340805,
            "zip_code": 34280,
            "name_th": "โสกแสง",
            "name_en": "Sok Saeng",
            "district_id": 3408,
            "lat": 14.661,
            "long": 105.258,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 340806,
            "zip_code": 34280,
            "name_th": "โนนสวรรค์",
            "name_en": "Non Sawan",
            "district_id": 3408,
            "lat": 14.659,
            "long": 105.141,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 3409,
        "name_th": "น้ำยืน",
        "name_en": "Nam Yuen",
        "province_id": 23,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 340901,
            "zip_code": 34260,
            "name_th": "โซง",
            "name_en": "Song",
            "district_id": 3409,
            "lat": 14.46,
            "long": 104.947,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 340903,
            "zip_code": 34260,
            "name_th": "ยาง",
            "name_en": "Yang",
            "district_id": 3409,
            "lat": 14.634,
            "long": 105.011,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 340904,
            "zip_code": 34260,
            "name_th": "โดมประดิษฐ์",
            "name_en": "Dom Pradit",
            "district_id": 3409,
            "lat": 14.337,
            "long": 105.059,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 340906,
            "zip_code": 34260,
            "name_th": "บุเปือย",
            "name_en": "Bu Pueai",
            "district_id": 3409,
            "lat": 14.538,
            "long": 105.056,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 340907,
            "zip_code": 34260,
            "name_th": "สีวิเชียร",
            "name_en": "Si Wichian",
            "district_id": 3409,
            "lat": 14.483,
            "long": 105.04,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 340909,
            "zip_code": 34260,
            "name_th": "ยางใหญ่",
            "name_en": "Yang Yai",
            "district_id": 3409,
            "lat": 14.575,
            "long": 105.094,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 340911,
            "zip_code": 34260,
            "name_th": "เก่าขาม",
            "name_en": "Kao Kham",
            "district_id": 3409,
            "lat": 14.577,
            "long": 105.02,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 3410,
        "name_th": "บุณฑริก",
        "name_en": "Buntharik",
        "province_id": 23,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 341001,
            "zip_code": 34230,
            "name_th": "โพนงาม",
            "name_en": "Phon Ngam",
            "district_id": 3410,
            "lat": 14.759,
            "long": 105.464,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 341002,
            "zip_code": 34230,
            "name_th": "ห้วยข่า",
            "name_en": "Huai Kha",
            "district_id": 3410,
            "lat": 14.567,
            "long": 105.424,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 341003,
            "zip_code": 34230,
            "name_th": "คอแลน",
            "name_en": "Kho Laen",
            "district_id": 3410,
            "lat": 14.867,
            "long": 105.461,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 341004,
            "zip_code": 34230,
            "name_th": "นาโพธิ์",
            "name_en": "Na Pho",
            "district_id": 3410,
            "lat": 14.891,
            "long": 105.294,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 341005,
            "zip_code": 34230,
            "name_th": "หนองสะโน",
            "name_en": "Nong Sano",
            "district_id": 3410,
            "lat": 14.771,
            "long": 105.288,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 341006,
            "zip_code": 34230,
            "name_th": "โนนค้อ",
            "name_en": "Non Kho",
            "district_id": 3410,
            "lat": 14.672,
            "long": 105.307,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 341007,
            "zip_code": 34230,
            "name_th": "บัวงาม",
            "name_en": "Bua Ngam",
            "district_id": 3410,
            "lat": 14.741,
            "long": 105.371,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 341008,
            "zip_code": 34230,
            "name_th": "บ้านแมด",
            "name_en": "Ban Maet",
            "district_id": 3410,
            "lat": 14.906,
            "long": 105.348,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 3411,
        "name_th": "ตระการพืชผล",
        "name_en": "Trakan Phuet Phon",
        "province_id": 23,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 341101,
            "zip_code": 34130,
            "name_th": "ขุหลุ",
            "name_en": "Khulu",
            "district_id": 3411,
            "lat": 15.601,
            "long": 105.021,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 341102,
            "zip_code": 34130,
            "name_th": "กระเดียน",
            "name_en": "Kradian",
            "district_id": 3411,
            "lat": 15.618,
            "long": 105.089,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 341103,
            "zip_code": 34130,
            "name_th": "เกษม",
            "name_en": "Kasem",
            "district_id": 3411,
            "lat": 15.691,
            "long": 105.049,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 341104,
            "zip_code": 34130,
            "name_th": "กุศกร",
            "name_en": "Kutsakon",
            "district_id": 3411,
            "lat": 15.57,
            "long": 105.102,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 341105,
            "zip_code": 34130,
            "name_th": "ขามเปี้ย",
            "name_en": "Kham Pia",
            "district_id": 3411,
            "lat": 15.542,
            "long": 104.934,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 341106,
            "zip_code": 34130,
            "name_th": "คอนสาย",
            "name_en": "Khon Sai",
            "district_id": 3411,
            "lat": 15.736,
            "long": 105.128,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 341107,
            "zip_code": 34130,
            "name_th": "โคกจาน",
            "name_en": "Khok Chan",
            "district_id": 3411,
            "lat": 15.507,
            "long": 105.1,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 341108,
            "zip_code": 34130,
            "name_th": "นาพิน",
            "name_en": "Na Phin",
            "district_id": 3411,
            "lat": 15.562,
            "long": 105.034,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 341109,
            "zip_code": 34130,
            "name_th": "นาสะไม",
            "name_en": "Na Samai",
            "district_id": 3411,
            "lat": 15.687,
            "long": 104.913,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 341110,
            "zip_code": 34130,
            "name_th": "โนนกุง",
            "name_en": "Non Kung",
            "district_id": 3411,
            "lat": 15.659,
            "long": 105.168,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 341111,
            "zip_code": 34130,
            "name_th": "ตระการ",
            "name_en": "Trakan",
            "district_id": 3411,
            "lat": 15.466,
            "long": 105.05,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 341112,
            "zip_code": 34130,
            "name_th": "ตากแดด",
            "name_en": "Tak Daet",
            "district_id": 3411,
            "lat": 15.589,
            "long": 105.183,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 341113,
            "zip_code": 34130,
            "name_th": "ไหล่ทุ่ง",
            "name_en": "Lai Thung",
            "district_id": 3411,
            "lat": 15.6,
            "long": 104.968,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 341114,
            "zip_code": 34130,
            "name_th": "เป้า",
            "name_en": "Pao",
            "district_id": 3411,
            "lat": 15.69,
            "long": 104.978,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 341115,
            "zip_code": 34130,
            "name_th": "เซเป็ด",
            "name_en": "Se Pet",
            "district_id": 3411,
            "lat": 15.547,
            "long": 104.988,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 341116,
            "zip_code": 34130,
            "name_th": "สะพือ",
            "name_en": "Saphue",
            "district_id": 3411,
            "lat": 15.51,
            "long": 105.029,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 341117,
            "zip_code": 34130,
            "name_th": "หนองเต่า",
            "name_en": "Nong Tao",
            "district_id": 3411,
            "lat": 15.725,
            "long": 104.933,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 341118,
            "zip_code": 34130,
            "name_th": "ถ้ำแข้",
            "name_en": "Tham Khae",
            "district_id": 3411,
            "lat": 15.672,
            "long": 105.134,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 341119,
            "zip_code": 34130,
            "name_th": "ท่าหลวง",
            "name_en": "Tha Luang",
            "district_id": 3411,
            "lat": 15.673,
            "long": 105.212,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 341120,
            "zip_code": 34130,
            "name_th": "ห้วยฝ้ายพัฒนา",
            "name_en": "Huai Fai Phatthana",
            "district_id": 3411,
            "lat": 15.522,
            "long": 105.168,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 341121,
            "zip_code": 34130,
            "name_th": "กุดยาลวน",
            "name_en": "Kut Ya Luan",
            "district_id": 3411,
            "lat": 15.731,
            "long": 105.029,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 341122,
            "zip_code": 34130,
            "name_th": "บ้านแดง",
            "name_en": "Ban Daeng",
            "district_id": 3411,
            "lat": 15.658,
            "long": 105.081,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 341123,
            "zip_code": 34130,
            "name_th": "คำเจริญ",
            "name_en": "Kham Charoen",
            "district_id": 3411,
            "lat": 15.642,
            "long": 105.032,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 3412,
        "name_th": "กุดข้าวปุ้น",
        "name_en": "Kut Khaopun",
        "province_id": 23,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 341201,
            "zip_code": 34270,
            "name_th": "ข้าวปุ้น",
            "name_en": "Khaopun",
            "district_id": 3412,
            "lat": 15.792,
            "long": 105.006,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 341202,
            "zip_code": 34270,
            "name_th": "โนนสวาง",
            "name_en": "Non Sawang",
            "district_id": 3412,
            "lat": 15.867,
            "long": 105.026,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 341203,
            "zip_code": 34270,
            "name_th": "แก่งเค็ง",
            "name_en": "Kaeng Kheng",
            "district_id": 3412,
            "lat": 15.776,
            "long": 105.101,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 341204,
            "zip_code": 34270,
            "name_th": "กาบิน",
            "name_en": "Ka Bin",
            "district_id": 3412,
            "lat": 15.757,
            "long": 104.964,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 341205,
            "zip_code": 34270,
            "name_th": "หนองทันน้ำ",
            "name_en": "Nong Than Nam",
            "district_id": 3412,
            "lat": 15.828,
            "long": 105.099,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 3414,
        "name_th": "ม่วงสามสิบ",
        "name_en": "Muang Sam Sip",
        "province_id": 23,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 341401,
            "zip_code": 34140,
            "name_th": "ม่วงสามสิบ",
            "name_en": "Muang Sam Sip",
            "district_id": 3414,
            "lat": 15.515,
            "long": 104.73,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 341402,
            "zip_code": 34140,
            "name_th": "เหล่าบก",
            "name_en": "Lao Bok",
            "district_id": 3414,
            "lat": 15.657,
            "long": 104.667,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 341403,
            "zip_code": 34140,
            "name_th": "ดุมใหญ่",
            "name_en": "Dum Yai",
            "district_id": 3414,
            "lat": 15.615,
            "long": 104.739,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 341404,
            "zip_code": 34140,
            "name_th": "หนองช้างใหญ่",
            "name_en": "Non Chang Yai",
            "district_id": 3414,
            "lat": 15.564,
            "long": 104.827,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 341405,
            "zip_code": 34140,
            "name_th": "หนองเมือง",
            "name_en": "Nong Mueang",
            "district_id": 3414,
            "lat": 15.571,
            "long": 104.735,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 341406,
            "zip_code": 34140,
            "name_th": "เตย",
            "name_en": "Toei",
            "district_id": 3414,
            "lat": 15.5,
            "long": 104.828,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 341407,
            "zip_code": 34140,
            "name_th": "ยางสักกระโพหลุ่ม",
            "name_en": "Yang Sak Krapho Lum",
            "district_id": 3414,
            "lat": 15.449,
            "long": 104.811,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 341408,
            "zip_code": 34140,
            "name_th": "หนองไข่นก",
            "name_en": "Nong Khai Nok",
            "district_id": 3414,
            "lat": 15.397,
            "long": 104.765,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 341409,
            "zip_code": 34140,
            "name_th": "หนองเหล่า",
            "name_en": "Nong Lao",
            "district_id": 3414,
            "lat": 15.443,
            "long": 104.679,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 341410,
            "zip_code": 34140,
            "name_th": "หนองฮาง",
            "name_en": "Nong Hang",
            "district_id": 3414,
            "lat": 15.501,
            "long": 104.661,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 341411,
            "zip_code": 34140,
            "name_th": "ยางโยภาพ",
            "name_en": "Yang Yo Phap",
            "district_id": 3414,
            "lat": 15.593,
            "long": 104.667,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 341412,
            "zip_code": 34140,
            "name_th": "ไผ่ใหญ่",
            "name_en": "Phai Yai",
            "district_id": 3414,
            "lat": 15.598,
            "long": 104.617,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 341413,
            "zip_code": 34140,
            "name_th": "นาเลิง",
            "name_en": "Na Loeng",
            "district_id": 3414,
            "lat": 15.541,
            "long": 104.586,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 341414,
            "zip_code": 34140,
            "name_th": "โพนแพง",
            "name_en": "Phon Phaeng",
            "district_id": 3414,
            "lat": 15.444,
            "long": 104.743,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 3415,
        "name_th": "วารินชำราบ",
        "name_en": "Warin Chamrap",
        "province_id": 23,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 341501,
            "zip_code": 34190,
            "name_th": "วารินชำราบ",
            "name_en": "Warin Chamrap",
            "district_id": 3415,
            "lat": 15.2,
            "long": 104.853,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 341502,
            "zip_code": 34190,
            "name_th": "ธาตุ",
            "name_en": "That",
            "district_id": 3415,
            "lat": 15.139,
            "long": 104.887,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 341504,
            "zip_code": 34310,
            "name_th": "ท่าลาด",
            "name_en": "Tha Lat",
            "district_id": 3415,
            "lat": 15.105,
            "long": 104.776,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 341505,
            "zip_code": 34190,
            "name_th": "โนนโหนน",
            "name_en": "Non Non",
            "district_id": 3415,
            "lat": 15.101,
            "long": 104.818,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 341507,
            "zip_code": 34190,
            "name_th": "คูเมือง",
            "name_en": "Khu Mueang",
            "district_id": 3415,
            "lat": 15.08,
            "long": 104.865,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 341508,
            "zip_code": 34190,
            "name_th": "สระสมิง",
            "name_en": "Sa Saming",
            "district_id": 3415,
            "lat": 14.999,
            "long": 104.903,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 341510,
            "zip_code": 34190,
            "name_th": "คำน้ำแซบ",
            "name_en": "Kham Nam Saep",
            "district_id": 3415,
            "lat": 15.198,
            "long": 104.815,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 341511,
            "zip_code": 34310,
            "name_th": "บุ่งหวาย",
            "name_en": "Bung Wai",
            "district_id": 3415,
            "lat": 15.158,
            "long": 104.753,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 341515,
            "zip_code": 34190,
            "name_th": "คำขวาง",
            "name_en": "Kham Khwang",
            "district_id": 3415,
            "lat": 15.165,
            "long": 104.924,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 341516,
            "zip_code": 34190,
            "name_th": "โพธิ์ใหญ่",
            "name_en": "Pho Yai",
            "district_id": 3415,
            "lat": 15.122,
            "long": 104.963,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 341518,
            "zip_code": 34190,
            "name_th": "แสนสุข",
            "name_en": "Saen Suk",
            "district_id": 3415,
            "lat": 15.173,
            "long": 104.872,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 341520,
            "zip_code": 34190,
            "name_th": "หนองกินเพล",
            "name_en": "Nong Kin Phen",
            "district_id": 3415,
            "lat": 15.204,
            "long": 104.782,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 341521,
            "zip_code": 34190,
            "name_th": "โนนผึ้ง",
            "name_en": "Non Phueng",
            "district_id": 3415,
            "lat": 15.162,
            "long": 104.823,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 341522,
            "zip_code": 34190,
            "name_th": "เมืองศรีไค",
            "name_en": "Mueang Si Khai",
            "district_id": 3415,
            "lat": 15.087,
            "long": 104.904,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 341524,
            "zip_code": 34310,
            "name_th": "ห้วยขะยูง",
            "name_en": "Huai Khayung",
            "district_id": 3415,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 341526,
            "zip_code": 34190,
            "name_th": "บุ่งไหม",
            "name_en": "Bung Mai",
            "district_id": 3415,
            "lat": 15.197,
            "long": 104.961,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 3419,
        "name_th": "พิบูลมังสาหาร",
        "name_en": "Phibun Mangsahan",
        "province_id": 23,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 341901,
            "zip_code": 34110,
            "name_th": "พิบูล",
            "name_en": "Phibun",
            "district_id": 3419,
            "lat": 15.248,
            "long": 105.226,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 341902,
            "zip_code": 34110,
            "name_th": "กุดชมภู",
            "name_en": "Kut Chom Phu",
            "district_id": 3419,
            "lat": 15.202,
            "long": 105.249,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 341904,
            "zip_code": 34110,
            "name_th": "ดอนจิก",
            "name_en": "Don Chik",
            "district_id": 3419,
            "lat": 15.132,
            "long": 105.313,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 341905,
            "zip_code": 34110,
            "name_th": "ทรายมูล",
            "name_en": "Sai Mun",
            "district_id": 3419,
            "lat": 15.304,
            "long": 105.344,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 341906,
            "zip_code": 34110,
            "name_th": "นาโพธิ์",
            "name_en": "Na Pho",
            "district_id": 3419,
            "lat": 15.069,
            "long": 105.128,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 341907,
            "zip_code": 34110,
            "name_th": "โนนกลาง",
            "name_en": "Non Klang",
            "district_id": 3419,
            "lat": 15.066,
            "long": 105.344,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 341909,
            "zip_code": 34110,
            "name_th": "โพธิ์ไทร",
            "name_en": "Pho Sai",
            "district_id": 3419,
            "lat": 15.216,
            "long": 105.158,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 341910,
            "zip_code": 34110,
            "name_th": "โพธิ์ศรี",
            "name_en": "Pho Si",
            "district_id": 3419,
            "lat": 15.293,
            "long": 105.237,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 341911,
            "zip_code": 34110,
            "name_th": "ระเว",
            "name_en": "Rawe",
            "district_id": 3419,
            "lat": 15.34,
            "long": 105.297,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 341912,
            "zip_code": 34110,
            "name_th": "ไร่ใต้",
            "name_en": "Rai Tai",
            "district_id": 3419,
            "lat": 15.136,
            "long": 105.122,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 341913,
            "zip_code": 34110,
            "name_th": "หนองบัวฮี",
            "name_en": "Nong Bua Hi",
            "district_id": 3419,
            "lat": 15.065,
            "long": 105.19,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 341914,
            "zip_code": 34110,
            "name_th": "อ่างศิลา",
            "name_en": "Ang Sila",
            "district_id": 3419,
            "lat": 15.031,
            "long": 105.288,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 341918,
            "zip_code": 34110,
            "name_th": "โนนกาหลง",
            "name_en": "Non Kalong",
            "district_id": 3419,
            "lat": 14.993,
            "long": 105.336,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 341919,
            "zip_code": 34110,
            "name_th": "บ้านแขม",
            "name_en": "Ban Khaem",
            "district_id": 3419,
            "lat": 15.022,
            "long": 105.25,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 3420,
        "name_th": "ตาลสุม",
        "name_en": "Tan Sum",
        "province_id": 23,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 342001,
            "zip_code": 34330,
            "name_th": "ตาลสุม",
            "name_en": "Tan Sum",
            "district_id": 3420,
            "lat": 15.326,
            "long": 105.156,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 342002,
            "zip_code": 34330,
            "name_th": "สำโรง",
            "name_en": "Samrong",
            "district_id": 3420,
            "lat": 15.38,
            "long": 105.233,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 342003,
            "zip_code": 34330,
            "name_th": "จิกเทิง",
            "name_en": "Chik Thoeng",
            "district_id": 3420,
            "lat": 15.352,
            "long": 105.086,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 342004,
            "zip_code": 34330,
            "name_th": "หนองกุง",
            "name_en": "Nong Kung",
            "district_id": 3420,
            "lat": 15.444,
            "long": 105.185,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 342005,
            "zip_code": 34330,
            "name_th": "นาคาย",
            "name_en": "Na Khai",
            "district_id": 3420,
            "lat": 15.417,
            "long": 105.108,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 342006,
            "zip_code": 34330,
            "name_th": "คำหว้า",
            "name_en": "Kham Wa",
            "district_id": 3420,
            "lat": 15.385,
            "long": 105.166,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 3421,
        "name_th": "โพธิ์ไทร",
        "name_en": "Pho Sai",
        "province_id": 23,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 342101,
            "zip_code": 34340,
            "name_th": "โพธิ์ไทร",
            "name_en": "Pho Sai",
            "district_id": 3421,
            "lat": 15.816,
            "long": 105.261,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 342102,
            "zip_code": 34340,
            "name_th": "ม่วงใหญ่",
            "name_en": "Muang Yai",
            "district_id": 3421,
            "lat": 15.86,
            "long": 105.273,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 342103,
            "zip_code": 34340,
            "name_th": "สำโรง",
            "name_en": "Sam Rong",
            "district_id": 3421,
            "lat": 15.728,
            "long": 105.494,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 342104,
            "zip_code": 34340,
            "name_th": "สองคอน",
            "name_en": "Song Khon",
            "district_id": 3421,
            "lat": 15.834,
            "long": 105.345,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 342105,
            "zip_code": 34340,
            "name_th": "สารภี",
            "name_en": "Saraphi",
            "district_id": 3421,
            "lat": 15.756,
            "long": 105.254,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 342106,
            "zip_code": 34340,
            "name_th": "เหล่างาม",
            "name_en": "Lao Ngam",
            "district_id": 3421,
            "lat": 15.76,
            "long": 105.374,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 3422,
        "name_th": "สำโรง",
        "name_en": "Samrong",
        "province_id": 23,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 342201,
            "zip_code": 34360,
            "name_th": "สำโรง",
            "name_en": "Samrong",
            "district_id": 3422,
            "lat": 15.01,
            "long": 104.793,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 342202,
            "zip_code": 34360,
            "name_th": "โคกก่อง",
            "name_en": "Khok Kong",
            "district_id": 3422,
            "lat": 15.033,
            "long": 104.839,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 342203,
            "zip_code": 34360,
            "name_th": "หนองไฮ",
            "name_en": "Nong Hai",
            "district_id": 3422,
            "lat": 14.96,
            "long": 104.76,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 342204,
            "zip_code": 34360,
            "name_th": "ค้อน้อย",
            "name_en": "Kho Noi",
            "district_id": 3422,
            "lat": 14.922,
            "long": 104.812,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 342205,
            "zip_code": 34360,
            "name_th": "โนนกาเล็น",
            "name_en": "Non Ka Len",
            "district_id": 3422,
            "lat": 15.02,
            "long": 104.72,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 342206,
            "zip_code": 34360,
            "name_th": "โคกสว่าง",
            "name_en": "Khok Sawang",
            "district_id": 3422,
            "lat": 14.936,
            "long": 104.865,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 342207,
            "zip_code": 34360,
            "name_th": "โนนกลาง",
            "name_en": "Non Klang",
            "district_id": 3422,
            "lat": 14.959,
            "long": 104.713,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 342208,
            "zip_code": 34360,
            "name_th": "บอน",
            "name_en": "Bon",
            "district_id": 3422,
            "lat": 15.055,
            "long": 104.765,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 342209,
            "zip_code": 34360,
            "name_th": "ขามป้อม",
            "name_en": "Kham Pom",
            "district_id": 3422,
            "lat": 14.981,
            "long": 104.821,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 3424,
        "name_th": "ดอนมดแดง",
        "name_en": "Don Mot Daeng",
        "province_id": 23,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 342401,
            "zip_code": 34000,
            "name_th": "ดอนมดแดง",
            "name_en": "Don Mot Daeng",
            "district_id": 3424,
            "lat": 15.315,
            "long": 105.065,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 342402,
            "zip_code": 34000,
            "name_th": "เหล่าแดง",
            "name_en": "Lao Daeng",
            "district_id": 3424,
            "lat": 15.375,
            "long": 105.028,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 342403,
            "zip_code": 34000,
            "name_th": "ท่าเมือง",
            "name_en": "Tha Mueang",
            "district_id": 3424,
            "lat": 15.473,
            "long": 104.968,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 342404,
            "zip_code": 34000,
            "name_th": "คำไฮใหญ่",
            "name_en": "Kham Hai Yai",
            "district_id": 3424,
            "lat": 15.372,
            "long": 104.968,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 3425,
        "name_th": "สิรินธร",
        "name_en": "Sirindhorn",
        "province_id": 23,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 342501,
            "zip_code": 34350,
            "name_th": "คันไร่",
            "name_en": "Khan Rai",
            "district_id": 3425,
            "lat": 15.225,
            "long": 105.33,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 342502,
            "zip_code": 34350,
            "name_th": "ช่องเม็ก",
            "name_en": "Chong Mek",
            "district_id": 3425,
            "lat": 15.126,
            "long": 105.414,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 342503,
            "zip_code": 34350,
            "name_th": "โนนก่อ",
            "name_en": "Non Ko",
            "district_id": 3425,
            "lat": 14.993,
            "long": 105.425,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 342504,
            "zip_code": 34350,
            "name_th": "นิคมสร้างตนเองลำโดมน้อย",
            "name_en": "Nikhom Sang Ton Eng Lam Dom Noi",
            "district_id": 3425,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 342505,
            "zip_code": 34350,
            "name_th": "ฝางคำ",
            "name_en": "Fang Kham",
            "district_id": 3425,
            "lat": 15.134,
            "long": 105.364,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 342506,
            "zip_code": 34350,
            "name_th": "คำเขื่อนแก้ว",
            "name_en": "Kham Khuean Kaeo",
            "district_id": 3425,
            "lat": 15.24,
            "long": 105.507,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 3426,
        "name_th": "ทุ่งศรีอุดม",
        "name_en": "Thung Si Udom",
        "province_id": 23,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 342602,
            "zip_code": 34160,
            "name_th": "หนองอ้ม",
            "name_en": "Nong Om",
            "district_id": 3426,
            "lat": 14.804,
            "long": 104.922,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 342603,
            "zip_code": 34160,
            "name_th": "นาเกษม",
            "name_en": "Na Kasem",
            "district_id": 3426,
            "lat": 14.723,
            "long": 104.931,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 342604,
            "zip_code": 34160,
            "name_th": "กุดเรือ",
            "name_en": "Kut Ruea",
            "district_id": 3426,
            "lat": 14.678,
            "long": 104.955,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 342605,
            "zip_code": 34160,
            "name_th": "โคกชำแระ",
            "name_en": "Khok Chamrae",
            "district_id": 3426,
            "lat": 14.752,
            "long": 104.908,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 342606,
            "zip_code": 34160,
            "name_th": "นาห่อม",
            "name_en": "Na Hom",
            "district_id": 3426,
            "lat": 14.76,
            "long": 104.855,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 3429,
        "name_th": "นาเยีย",
        "name_en": "Na Yia",
        "province_id": 23,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 342901,
            "zip_code": 34160,
            "name_th": "นาเยีย",
            "name_en": "Na Yia",
            "district_id": 3429,
            "lat": 15.006,
            "long": 105.143,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 342902,
            "zip_code": 34160,
            "name_th": "นาดี",
            "name_en": "Na Di",
            "district_id": 3429,
            "lat": 15.116,
            "long": 105.018,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 342903,
            "zip_code": 34160,
            "name_th": "นาเรือง",
            "name_en": "Na Rueang",
            "district_id": 3429,
            "lat": 14.987,
            "long": 105.068,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 3430,
        "name_th": "นาตาล",
        "name_en": "Na Tan",
        "province_id": 23,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 343001,
            "zip_code": 34170,
            "name_th": "นาตาล",
            "name_en": "Na Tan",
            "district_id": 3430,
            "lat": 15.893,
            "long": 105.31,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 343002,
            "zip_code": 34170,
            "name_th": "พะลาน",
            "name_en": "Phalan",
            "district_id": 3430,
            "lat": 15.96,
            "long": 105.332,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 343003,
            "zip_code": 34170,
            "name_th": "กองโพน",
            "name_en": "Kong Phon",
            "district_id": 3430,
            "lat": 15.965,
            "long": 105.27,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 343004,
            "zip_code": 34170,
            "name_th": "พังเคน",
            "name_en": "Phang Khen",
            "district_id": 3430,
            "lat": 15.921,
            "long": 105.212,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 3431,
        "name_th": "เหล่าเสือโก้ก",
        "name_en": "Lao Suea Kok",
        "province_id": 23,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 343101,
            "zip_code": 34000,
            "name_th": "เหล่าเสือโก้ก",
            "name_en": "Lao Suea Kok",
            "district_id": 3431,
            "lat": 15.432,
            "long": 104.918,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 343102,
            "zip_code": 34000,
            "name_th": "โพนเมือง",
            "name_en": "Phon Mueang",
            "district_id": 3431,
            "lat": 15.492,
            "long": 104.891,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 343103,
            "zip_code": 34000,
            "name_th": "แพงใหญ่",
            "name_en": "Phaeng Yai",
            "district_id": 3431,
            "lat": 15.395,
            "long": 104.881,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 343104,
            "zip_code": 34000,
            "name_th": "หนองบก",
            "name_en": "Nong Bok",
            "district_id": 3431,
            "lat": 15.423,
            "long": 104.988,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 3432,
        "name_th": "สว่างวีระวงศ์",
        "name_en": "Sawang Wirawong",
        "province_id": 23,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 343201,
            "zip_code": 34190,
            "name_th": "แก่งโดม",
            "name_en": "Kaeng Dom",
            "district_id": 3432,
            "lat": 15.204,
            "long": 105.087,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 343202,
            "zip_code": 34190,
            "name_th": "ท่าช้าง",
            "name_en": "Tha Chang",
            "district_id": 3432,
            "lat": 15.229,
            "long": 104.99,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 343203,
            "zip_code": 34190,
            "name_th": "บุ่งมะแลง",
            "name_en": "Bung Malaeng",
            "district_id": 3432,
            "lat": 15.238,
            "long": 105.045,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 343204,
            "zip_code": 34190,
            "name_th": "สว่าง",
            "name_en": "Sawang",
            "district_id": 3432,
            "lat": 15.274,
            "long": 105.118,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 3433,
        "name_th": "น้ำขุ่น",
        "name_en": "Nam Khun",
        "province_id": 23,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 343301,
            "zip_code": 34260,
            "name_th": "ตาเกา",
            "name_en": "Ta Kao",
            "district_id": 3433,
            "lat": 14.568,
            "long": 104.919,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 343302,
            "zip_code": 34260,
            "name_th": "ไพบูลย์",
            "name_en": "Phaibun",
            "district_id": 3433,
            "lat": 14.603,
            "long": 104.854,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 343303,
            "zip_code": 34260,
            "name_th": "ขี้เหล็ก",
            "name_en": "Khilek",
            "district_id": 3433,
            "lat": 14.624,
            "long": 104.899,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 343304,
            "zip_code": 34260,
            "name_th": "โคกสะอาด",
            "name_en": "Khok Sa-at",
            "district_id": 3433,
            "lat": 14.443,
            "long": 104.848,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      }
    ]
  },
  {
    "id": 24,
    "name_th": "ยโสธร",
    "name_en": "Yasothon",
    "geography_id": 3,
    "created_at": "2019-08-09T03:33:09.000+07:00",
    "updated_at": "2025-09-20T06:31:26.000+07:00",
    "deleted_at": null,
    "districts": [
      {
        "id": 3501,
        "name_th": "เมืองยโสธร",
        "name_en": "Mueang Yasothon",
        "province_id": 24,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 350101,
            "zip_code": 35000,
            "name_th": "ในเมือง",
            "name_en": "Nai Mueang",
            "district_id": 3501,
            "lat": 15.799,
            "long": 104.148,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 350102,
            "zip_code": 35000,
            "name_th": "น้ำคำใหญ่",
            "name_en": "Nam Kham Yai",
            "district_id": 3501,
            "lat": 15.828,
            "long": 104.167,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 350103,
            "zip_code": 35000,
            "name_th": "ตาดทอง",
            "name_en": "Tat Thong",
            "district_id": 3501,
            "lat": 15.777,
            "long": 104.205,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 350104,
            "zip_code": 35000,
            "name_th": "สำราญ",
            "name_en": "Samran",
            "district_id": 3501,
            "lat": 15.838,
            "long": 104.113,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 350105,
            "zip_code": 35000,
            "name_th": "ค้อเหนือ",
            "name_en": "Kho Nuea",
            "district_id": 3501,
            "lat": 15.835,
            "long": 104.044,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 350106,
            "zip_code": 35000,
            "name_th": "ดู่ทุ่ง",
            "name_en": "Du Thung",
            "district_id": 3501,
            "lat": 15.899,
            "long": 104.041,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 350107,
            "zip_code": 35000,
            "name_th": "เดิด",
            "name_en": "Doet",
            "district_id": 3501,
            "lat": 15.945,
            "long": 104.062,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 350108,
            "zip_code": 35000,
            "name_th": "ขั้นไดใหญ่",
            "name_en": "Khandai Yai",
            "district_id": 3501,
            "lat": 15.915,
            "long": 104.12,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 350109,
            "zip_code": 35000,
            "name_th": "ทุ่งแต้",
            "name_en": "Thung Tae",
            "district_id": 3501,
            "lat": 15.913,
            "long": 104.179,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 350110,
            "zip_code": 35000,
            "name_th": "สิงห์",
            "name_en": "Sing",
            "district_id": 3501,
            "lat": 15.823,
            "long": 104.241,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 350111,
            "zip_code": 35000,
            "name_th": "นาสะไมย์",
            "name_en": "Na Samai",
            "district_id": 3501,
            "lat": 15.895,
            "long": 104.246,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 350112,
            "zip_code": 35000,
            "name_th": "เขื่องคำ",
            "name_en": "Khueang Kham",
            "district_id": 3501,
            "lat": 15.74,
            "long": 104.16,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 350113,
            "zip_code": 35000,
            "name_th": "หนองหิน",
            "name_en": "Nong Hin",
            "district_id": 3501,
            "lat": 15.859,
            "long": 104.282,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 350114,
            "zip_code": 35000,
            "name_th": "หนองคู",
            "name_en": "Nong Khu",
            "district_id": 3501,
            "lat": 15.78,
            "long": 104.252,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 350115,
            "zip_code": 35000,
            "name_th": "ขุมเงิน",
            "name_en": "Khum Ngoen",
            "district_id": 3501,
            "lat": 15.713,
            "long": 104.194,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 350116,
            "zip_code": 35000,
            "name_th": "ทุ่งนางโอก",
            "name_en": "Thung Nang Ok",
            "district_id": 3501,
            "lat": 15.886,
            "long": 104.147,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 350117,
            "zip_code": 35000,
            "name_th": "หนองเรือ",
            "name_en": "Nong Ruea",
            "district_id": 3501,
            "lat": 15.861,
            "long": 104.207,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 350118,
            "zip_code": 35000,
            "name_th": "หนองเป็ด",
            "name_en": "Nong Pet",
            "district_id": 3501,
            "lat": 15.877,
            "long": 104.335,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 3502,
        "name_th": "ทรายมูล",
        "name_en": "Sai Mun",
        "province_id": 24,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 350201,
            "zip_code": 35170,
            "name_th": "ทรายมูล",
            "name_en": "Sai Mun",
            "district_id": 3502,
            "lat": 15.956,
            "long": 104.224,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 350202,
            "zip_code": 35170,
            "name_th": "ดู่ลาด",
            "name_en": "Du Lat",
            "district_id": 3502,
            "lat": 16.012,
            "long": 104.208,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 350203,
            "zip_code": 35170,
            "name_th": "ดงมะไฟ",
            "name_en": "Dong Mafai",
            "district_id": 3502,
            "lat": 15.981,
            "long": 104.135,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 350204,
            "zip_code": 35170,
            "name_th": "นาเวียง",
            "name_en": "Na Wiang",
            "district_id": 3502,
            "lat": 16.07,
            "long": 104.128,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 350205,
            "zip_code": 35170,
            "name_th": "ไผ่",
            "name_en": "Phai",
            "district_id": 3502,
            "lat": 15.927,
            "long": 104.293,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 3503,
        "name_th": "กุดชุม",
        "name_en": "Kut Chum",
        "province_id": 24,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 350301,
            "zip_code": 35140,
            "name_th": "กุดชุม",
            "name_en": "Kut Chum",
            "district_id": 3503,
            "lat": 16.069,
            "long": 104.349,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 350302,
            "zip_code": 35140,
            "name_th": "โนนเปือย",
            "name_en": "Non Pueai",
            "district_id": 3503,
            "lat": 16.011,
            "long": 104.387,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 350303,
            "zip_code": 35140,
            "name_th": "กำแมด",
            "name_en": "Kammaet",
            "district_id": 3503,
            "lat": 15.943,
            "long": 104.379,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 350304,
            "zip_code": 35140,
            "name_th": "นาโส่",
            "name_en": "Na So",
            "district_id": 3503,
            "lat": 15.972,
            "long": 104.317,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 350305,
            "zip_code": 35140,
            "name_th": "ห้วยแก้ง",
            "name_en": "Huai Kaeng",
            "district_id": 3503,
            "lat": 16.007,
            "long": 104.291,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 350306,
            "zip_code": 35140,
            "name_th": "หนองหมี",
            "name_en": "Nong Mi",
            "district_id": 3503,
            "lat": 16.051,
            "long": 104.296,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 350307,
            "zip_code": 35140,
            "name_th": "โพนงาม",
            "name_en": "Phon Ngam",
            "district_id": 3503,
            "lat": 16.045,
            "long": 104.166,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 350308,
            "zip_code": 35140,
            "name_th": "คำน้ำสร้าง",
            "name_en": "Kham Nam Sang",
            "district_id": 3503,
            "lat": 16.099,
            "long": 104.258,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 350309,
            "zip_code": 35140,
            "name_th": "หนองแหน",
            "name_en": "Nong Nae",
            "district_id": 3503,
            "lat": 16.127,
            "long": 104.217,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 3504,
        "name_th": "คำเขื่อนแก้ว",
        "name_en": "Kham Khuean Kaeo",
        "province_id": 24,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 350401,
            "zip_code": 35110,
            "name_th": "ลุมพุก",
            "name_en": "Lumphuk",
            "district_id": 3504,
            "lat": 15.643,
            "long": 104.323,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 350402,
            "zip_code": 35110,
            "name_th": "ย่อ",
            "name_en": "Yo",
            "district_id": 3504,
            "lat": 15.693,
            "long": 104.222,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 350403,
            "zip_code": 35110,
            "name_th": "สงเปือย",
            "name_en": "Song Pueai",
            "district_id": 3504,
            "lat": 15.647,
            "long": 104.221,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 350404,
            "zip_code": 35110,
            "name_th": "โพนทัน",
            "name_en": "Phon Than",
            "district_id": 3504,
            "lat": 15.665,
            "long": 104.282,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 350405,
            "zip_code": 35110,
            "name_th": "ทุ่งมน",
            "name_en": "Thung Mon",
            "district_id": 3504,
            "lat": 15.747,
            "long": 104.286,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 350406,
            "zip_code": 35180,
            "name_th": "นาคำ",
            "name_en": "Na Kham",
            "district_id": 3504,
            "lat": 15.633,
            "long": 104.412,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 350407,
            "zip_code": 35180,
            "name_th": "ดงแคนใหญ่",
            "name_en": "Dong Khaen Yai",
            "district_id": 3504,
            "lat": 15.572,
            "long": 104.395,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 350408,
            "zip_code": 35110,
            "name_th": "กู่จาน",
            "name_en": "Ku Chan",
            "district_id": 3504,
            "lat": 15.682,
            "long": 104.399,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 350409,
            "zip_code": 35180,
            "name_th": "นาแก",
            "name_en": "Na Kae",
            "district_id": 3504,
            "lat": 15.597,
            "long": 104.426,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 350410,
            "zip_code": 35110,
            "name_th": "กุดกุง",
            "name_en": "Kut Kung",
            "district_id": 3504,
            "lat": 15.615,
            "long": 104.246,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 350411,
            "zip_code": 35110,
            "name_th": "เหล่าไฮ",
            "name_en": "Lao Hai",
            "district_id": 3504,
            "lat": 15.724,
            "long": 104.382,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 350412,
            "zip_code": 35180,
            "name_th": "แคนน้อย",
            "name_en": "Khaen Noi",
            "district_id": 3504,
            "lat": 15.594,
            "long": 104.347,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 350413,
            "zip_code": 35110,
            "name_th": "ดงเจริญ",
            "name_en": "Dong Charoen",
            "district_id": 3504,
            "lat": 15.698,
            "long": 104.292,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 3505,
        "name_th": "ป่าติ้ว",
        "name_en": "Pa Tio",
        "province_id": 24,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 350501,
            "zip_code": 35150,
            "name_th": "โพธิ์ไทร",
            "name_en": "Pho Sai",
            "district_id": 3505,
            "lat": 15.832,
            "long": 104.398,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 350502,
            "zip_code": 35150,
            "name_th": "กระจาย",
            "name_en": "Krachai",
            "district_id": 3505,
            "lat": 15.801,
            "long": 104.299,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 350503,
            "zip_code": 35150,
            "name_th": "โคกนาโก",
            "name_en": "Khok Na Ko",
            "district_id": 3505,
            "lat": 15.925,
            "long": 104.43,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 350504,
            "zip_code": 35150,
            "name_th": "เชียงเพ็ง",
            "name_en": "Chiang Pheng",
            "district_id": 3505,
            "lat": 15.772,
            "long": 104.409,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 350505,
            "zip_code": 35150,
            "name_th": "ศรีฐาน",
            "name_en": "Si Than",
            "district_id": 3505,
            "lat": 15.777,
            "long": 104.343,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 3506,
        "name_th": "มหาชนะชัย",
        "name_en": "Maha Chana Chai",
        "province_id": 24,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 350601,
            "zip_code": 35130,
            "name_th": "ฟ้าหยาด",
            "name_en": "Fa Yat",
            "district_id": 3506,
            "lat": 15.514,
            "long": 104.256,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 350602,
            "zip_code": 35130,
            "name_th": "หัวเมือง",
            "name_en": "Hua Mueang",
            "district_id": 3506,
            "lat": 15.566,
            "long": 104.207,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 350603,
            "zip_code": 35130,
            "name_th": "คูเมือง",
            "name_en": "Khu Mueang",
            "district_id": 3506,
            "lat": 15.502,
            "long": 104.184,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 350604,
            "zip_code": 35130,
            "name_th": "ผือฮี",
            "name_en": "Phue Hi",
            "district_id": 3506,
            "lat": 15.45,
            "long": 104.27,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 350605,
            "zip_code": 35130,
            "name_th": "บากเรือ",
            "name_en": "Bak Ruea",
            "district_id": 3506,
            "lat": 15.564,
            "long": 104.278,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 350606,
            "zip_code": 35130,
            "name_th": "ม่วง",
            "name_en": "Muang",
            "district_id": 3506,
            "lat": 15.473,
            "long": 104.324,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 350607,
            "zip_code": 35130,
            "name_th": "โนนทราย",
            "name_en": "Non Sai",
            "district_id": 3506,
            "lat": 15.552,
            "long": 104.329,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 350608,
            "zip_code": 35130,
            "name_th": "บึงแก",
            "name_en": "Bueng Kae",
            "district_id": 3506,
            "lat": 15.511,
            "long": 104.358,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 350609,
            "zip_code": 35130,
            "name_th": "พระเสาร์",
            "name_en": "Phra Sao",
            "district_id": 3506,
            "lat": 15.566,
            "long": 104.153,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 350610,
            "zip_code": 35130,
            "name_th": "สงยาง",
            "name_en": "Song Yang",
            "district_id": 3506,
            "lat": 15.446,
            "long": 104.225,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 3507,
        "name_th": "ค้อวัง",
        "name_en": "Kho Wang",
        "province_id": 24,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 350701,
            "zip_code": 35160,
            "name_th": "ฟ้าห่วน",
            "name_en": "Fa Huan",
            "district_id": 3507,
            "lat": 15.339,
            "long": 104.405,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 350702,
            "zip_code": 35160,
            "name_th": "กุดน้ำใส",
            "name_en": "Kut Nam Sai",
            "district_id": 3507,
            "lat": 15.415,
            "long": 104.353,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 350703,
            "zip_code": 35160,
            "name_th": "น้ำอ้อม",
            "name_en": "Nam Om",
            "district_id": 3507,
            "lat": 15.397,
            "long": 104.28,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 350704,
            "zip_code": 35160,
            "name_th": "ค้อวัง",
            "name_en": "Kho Wang",
            "district_id": 3507,
            "lat": 15.363,
            "long": 104.31,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 3508,
        "name_th": "เลิงนกทา",
        "name_en": "Loeng Nok Tha",
        "province_id": 24,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 350802,
            "zip_code": 35120,
            "name_th": "บุ่งค้า",
            "name_en": "Bung Kha",
            "district_id": 3508,
            "lat": 16.176,
            "long": 104.669,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 350803,
            "zip_code": 35120,
            "name_th": "สวาท",
            "name_en": "Sawat",
            "district_id": 3508,
            "lat": 16.153,
            "long": 104.538,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 350805,
            "zip_code": 35120,
            "name_th": "ห้องแซง",
            "name_en": "Hong Saeng",
            "district_id": 3508,
            "lat": 16.269,
            "long": 104.373,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 350806,
            "zip_code": 35120,
            "name_th": "สามัคคี",
            "name_en": "Samakkhi",
            "district_id": 3508,
            "lat": 16.232,
            "long": 104.453,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 350807,
            "zip_code": 35120,
            "name_th": "กุดเชียงหมี",
            "name_en": "Kut Chiang Mi",
            "district_id": 3508,
            "lat": 16.313,
            "long": 104.446,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 350810,
            "zip_code": 35120,
            "name_th": "สามแยก",
            "name_en": "Sam Yaek",
            "district_id": 3508,
            "lat": 16.217,
            "long": 104.562,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 350811,
            "zip_code": 35120,
            "name_th": "กุดแห่",
            "name_en": "Kut Hae",
            "district_id": 3508,
            "lat": 16.275,
            "long": 104.52,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 350812,
            "zip_code": 35120,
            "name_th": "โคกสำราญ",
            "name_en": "Khok Samran",
            "district_id": 3508,
            "lat": 16.149,
            "long": 104.592,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 350813,
            "zip_code": 35120,
            "name_th": "สร้างมิ่ง",
            "name_en": "Sang Ming",
            "district_id": 3508,
            "lat": 16.095,
            "long": 104.506,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 350814,
            "zip_code": 35120,
            "name_th": "ศรีแก้ว",
            "name_en": "Si Kaeo",
            "district_id": 3508,
            "lat": 16.194,
            "long": 104.332,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 3509,
        "name_th": "ไทยเจริญ",
        "name_en": "Thai Charoen",
        "province_id": 24,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 350901,
            "zip_code": 35120,
            "name_th": "ไทยเจริญ",
            "name_en": "Thai Charoen",
            "district_id": 3509,
            "lat": 16.06,
            "long": 104.432,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 350902,
            "zip_code": 35120,
            "name_th": "น้ำคำ",
            "name_en": "Nam Kham",
            "district_id": 3509,
            "lat": 16.015,
            "long": 104.486,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 350903,
            "zip_code": 35120,
            "name_th": "ส้มผ่อ",
            "name_en": "Som Pho",
            "district_id": 3509,
            "lat": 16.162,
            "long": 104.432,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 350904,
            "zip_code": 35120,
            "name_th": "คำเตย",
            "name_en": "Kham Toei",
            "district_id": 3509,
            "lat": 16.1,
            "long": 104.388,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 350905,
            "zip_code": 35120,
            "name_th": "คำไผ่",
            "name_en": "Kham Phai",
            "district_id": 3509,
            "lat": 16.061,
            "long": 104.521,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      }
    ]
  },
  {
    "id": 25,
    "name_th": "ชัยภูมิ",
    "name_en": "Chaiyaphum",
    "geography_id": 3,
    "created_at": "2019-08-09T03:33:09.000+07:00",
    "updated_at": "2025-09-20T06:31:26.000+07:00",
    "deleted_at": null,
    "districts": [
      {
        "id": 3601,
        "name_th": "เมืองชัยภูมิ",
        "name_en": "Mueang Chaiyaphum",
        "province_id": 25,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 360101,
            "zip_code": 36000,
            "name_th": "ในเมือง",
            "name_en": "Nai Mueang",
            "district_id": 3601,
            "lat": 15.804,
            "long": 102.037,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 360102,
            "zip_code": 36000,
            "name_th": "รอบเมือง",
            "name_en": "Rop Mueang",
            "district_id": 3601,
            "lat": 15.846,
            "long": 102.027,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 360103,
            "zip_code": 36000,
            "name_th": "โพนทอง",
            "name_en": "Phon Thong",
            "district_id": 3601,
            "lat": 15.863,
            "long": 102.114,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 360104,
            "zip_code": 36000,
            "name_th": "นาฝาย",
            "name_en": "Na Fai",
            "district_id": 3601,
            "lat": 15.919,
            "long": 101.982,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 360105,
            "zip_code": 36240,
            "name_th": "บ้านค่าย",
            "name_en": "Ban Khai",
            "district_id": 3601,
            "lat": 15.684,
            "long": 102.028,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 360106,
            "zip_code": 36000,
            "name_th": "กุดตุ้ม",
            "name_en": "Kut Tum",
            "district_id": 3601,
            "lat": 15.771,
            "long": 102.181,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 360107,
            "zip_code": 36000,
            "name_th": "ชีลอง",
            "name_en": "Chi Long",
            "district_id": 3601,
            "lat": 15.73,
            "long": 101.999,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 360108,
            "zip_code": 36000,
            "name_th": "บ้านเล่า",
            "name_en": "Ban Lao",
            "district_id": 3601,
            "lat": 15.872,
            "long": 102.061,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 360109,
            "zip_code": 36000,
            "name_th": "นาเสียว",
            "name_en": "Na Siao",
            "district_id": 3601,
            "lat": 15.941,
            "long": 102.11,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 360110,
            "zip_code": 36000,
            "name_th": "หนองนาแซง",
            "name_en": "Nong Na Saeng",
            "district_id": 3601,
            "lat": 15.742,
            "long": 102.022,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 360111,
            "zip_code": 36000,
            "name_th": "ลาดใหญ่",
            "name_en": "Lat Yai",
            "district_id": 3601,
            "lat": 15.809,
            "long": 102.189,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 360112,
            "zip_code": 36240,
            "name_th": "หนองไผ่",
            "name_en": "Nong Phai",
            "district_id": 3601,
            "lat": 15.707,
            "long": 102.052,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 360113,
            "zip_code": 36000,
            "name_th": "ท่าหินโงม",
            "name_en": "Tha Hin Ngom",
            "district_id": 3601,
            "lat": 16.021,
            "long": 101.993,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 360114,
            "zip_code": 36000,
            "name_th": "ห้วยต้อน",
            "name_en": "Huai Ton",
            "district_id": 3601,
            "lat": 15.93,
            "long": 101.919,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 360115,
            "zip_code": 36000,
            "name_th": "ห้วยบง",
            "name_en": "Huai Bong",
            "district_id": 3601,
            "lat": 15.843,
            "long": 102.167,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 360116,
            "zip_code": 36240,
            "name_th": "โนนสำราญ",
            "name_en": "Non Samran",
            "district_id": 3601,
            "lat": 15.661,
            "long": 102.093,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 360117,
            "zip_code": 36000,
            "name_th": "โคกสูง",
            "name_en": "Khok Sung",
            "district_id": 3601,
            "lat": 15.827,
            "long": 101.958,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 360118,
            "zip_code": 36000,
            "name_th": "บุ่งคล้า",
            "name_en": "Bung Khla",
            "district_id": 3601,
            "lat": 15.759,
            "long": 102.056,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 360119,
            "zip_code": 36000,
            "name_th": "ซับสีทอง",
            "name_en": "Sap Si Thong",
            "district_id": 3601,
            "lat": 16.137,
            "long": 102.017,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 3602,
        "name_th": "บ้านเขว้า",
        "name_en": "Ban Khwao",
        "province_id": 25,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 360201,
            "zip_code": 36170,
            "name_th": "บ้านเขว้า",
            "name_en": "Ban Khwao",
            "district_id": 3602,
            "lat": 15.753,
            "long": 101.911,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 360202,
            "zip_code": 36170,
            "name_th": "ตลาดแร้ง",
            "name_en": "Talat Raeng",
            "district_id": 3602,
            "lat": 15.778,
            "long": 101.861,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 360203,
            "zip_code": 36170,
            "name_th": "ลุ่มลำชี",
            "name_en": "Lum Lam Chi",
            "district_id": 3602,
            "lat": 15.697,
            "long": 101.932,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 360204,
            "zip_code": 36170,
            "name_th": "ชีบน",
            "name_en": "Chi Bon",
            "district_id": 3602,
            "lat": 15.866,
            "long": 101.759,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 360205,
            "zip_code": 36170,
            "name_th": "ภูแลนคา",
            "name_en": "Phu Laen Kha",
            "district_id": 3602,
            "lat": 15.876,
            "long": 101.84,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 360206,
            "zip_code": 36170,
            "name_th": "โนนแดง",
            "name_en": "Non Dang",
            "district_id": 3602,
            "lat": 15.804,
            "long": 101.93,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 3603,
        "name_th": "คอนสวรรค์",
        "name_en": "Khon Sawan",
        "province_id": 25,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 360301,
            "zip_code": 36140,
            "name_th": "คอนสวรรค์",
            "name_en": "Khon Sawan",
            "district_id": 3603,
            "lat": 15.93,
            "long": 102.327,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 360302,
            "zip_code": 36140,
            "name_th": "ยางหวาย",
            "name_en": "Yang Wai",
            "district_id": 3603,
            "lat": 15.887,
            "long": 102.31,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 360303,
            "zip_code": 36140,
            "name_th": "ช่องสามหมอ",
            "name_en": "Chong Sam Mo",
            "district_id": 3603,
            "lat": 16.018,
            "long": 102.292,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 360304,
            "zip_code": 36140,
            "name_th": "โนนสะอาด",
            "name_en": "Non Sa-at",
            "district_id": 3603,
            "lat": 15.816,
            "long": 102.275,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 360305,
            "zip_code": 36140,
            "name_th": "ห้วยไร่",
            "name_en": "Huai Rai",
            "district_id": 3603,
            "lat": 16.021,
            "long": 102.247,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 360306,
            "zip_code": 36140,
            "name_th": "บ้านโสก",
            "name_en": "Ban Sok",
            "district_id": 3603,
            "lat": 15.892,
            "long": 102.263,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 360307,
            "zip_code": 36140,
            "name_th": "โคกมั่งงอย",
            "name_en": "Khok Mang Ngoi",
            "district_id": 3603,
            "lat": 15.955,
            "long": 102.259,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 360308,
            "zip_code": 36140,
            "name_th": "หนองขาม",
            "name_en": "Nong Kham",
            "district_id": 3603,
            "lat": 15.853,
            "long": 102.234,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 360309,
            "zip_code": 36140,
            "name_th": "ศรีสำราญ",
            "name_en": "Si Samran",
            "district_id": 3603,
            "lat": 15.993,
            "long": 102.339,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 3604,
        "name_th": "เกษตรสมบูรณ์",
        "name_en": "Kaset Sombun",
        "province_id": 25,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 360401,
            "zip_code": 36120,
            "name_th": "บ้านยาง",
            "name_en": "Ban Yang",
            "district_id": 3604,
            "lat": 16.286,
            "long": 101.869,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 360402,
            "zip_code": 36120,
            "name_th": "บ้านหัน",
            "name_en": "Ban Han",
            "district_id": 3604,
            "lat": 16.307,
            "long": 102.027,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 360403,
            "zip_code": 36120,
            "name_th": "บ้านเดื่อ",
            "name_en": "Ban Duea",
            "district_id": 3604,
            "lat": 16.089,
            "long": 101.908,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 360404,
            "zip_code": 36120,
            "name_th": "บ้านเป้า",
            "name_en": "Ban Pao",
            "district_id": 3604,
            "lat": 16.372,
            "long": 101.951,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 360405,
            "zip_code": 36120,
            "name_th": "กุดเลาะ",
            "name_en": "Kut Lo",
            "district_id": 3604,
            "lat": 16.309,
            "long": 101.943,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 360406,
            "zip_code": 36120,
            "name_th": "โนนกอก",
            "name_en": "Non Kok",
            "district_id": 3604,
            "lat": 16.171,
            "long": 101.949,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 360407,
            "zip_code": 36120,
            "name_th": "สระโพนทอง",
            "name_en": "Sa Phon Thong",
            "district_id": 3604,
            "lat": 16.246,
            "long": 101.984,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 360408,
            "zip_code": 36120,
            "name_th": "หนองข่า",
            "name_en": "Nong Kha",
            "district_id": 3604,
            "lat": 16.169,
            "long": 101.869,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 360409,
            "zip_code": 36120,
            "name_th": "หนองโพนงาม",
            "name_en": "Nong Phon Ngam",
            "district_id": 3604,
            "lat": 16.434,
            "long": 101.877,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 360410,
            "zip_code": 36120,
            "name_th": "บ้านบัว",
            "name_en": "Ban Bua",
            "district_id": 3604,
            "lat": 16.242,
            "long": 101.874,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 360412,
            "zip_code": 36120,
            "name_th": "โนนทอง",
            "name_en": "Non Thong",
            "district_id": 3604,
            "lat": 16.379,
            "long": 101.797,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 3605,
        "name_th": "หนองบัวแดง",
        "name_en": "Nong Bua Daeng",
        "province_id": 25,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 360501,
            "zip_code": 36210,
            "name_th": "หนองบัวแดง",
            "name_en": "Nong Bua Daeng",
            "district_id": 3605,
            "lat": 16.351,
            "long": 101.721,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 360502,
            "zip_code": 36210,
            "name_th": "กุดชุมแสง",
            "name_en": "Kut Chum Saeng",
            "district_id": 3605,
            "lat": 16.012,
            "long": 101.834,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 360503,
            "zip_code": 36210,
            "name_th": "ถ้ำวัวแดง",
            "name_en": "Tham Wua Daeng",
            "district_id": 3605,
            "lat": 16.161,
            "long": 101.44,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 360504,
            "zip_code": 36210,
            "name_th": "นางแดด",
            "name_en": "Nang Daet",
            "district_id": 3605,
            "lat": 16.28,
            "long": 101.518,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 360507,
            "zip_code": 36210,
            "name_th": "หนองแวง",
            "name_en": "Nong Waeng",
            "district_id": 3605,
            "lat": 16.177,
            "long": 101.722,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 360508,
            "zip_code": 36210,
            "name_th": "คูเมือง",
            "name_en": "Khu Mueang",
            "district_id": 3605,
            "lat": 16.012,
            "long": 101.723,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 360509,
            "zip_code": 36210,
            "name_th": "ท่าใหญ่",
            "name_en": "Tha Yai",
            "district_id": 3605,
            "lat": 16.028,
            "long": 101.624,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 360511,
            "zip_code": 36210,
            "name_th": "วังชมภู",
            "name_en": "Wang Chomphu",
            "district_id": 3605,
            "lat": 16.119,
            "long": 101.578,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 3606,
        "name_th": "จัตุรัส",
        "name_en": "Chatturat",
        "province_id": 25,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 360601,
            "zip_code": 36130,
            "name_th": "บ้านกอก",
            "name_en": "Ban Kok",
            "district_id": 3606,
            "lat": 15.467,
            "long": 101.902,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 360602,
            "zip_code": 36130,
            "name_th": "หนองบัวบาน",
            "name_en": "Nong Bua Ban",
            "district_id": 3606,
            "lat": 15.652,
            "long": 101.802,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 360603,
            "zip_code": 36130,
            "name_th": "บ้านขาม",
            "name_en": "Ban Kham",
            "district_id": 3606,
            "lat": 15.474,
            "long": 101.805,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 360605,
            "zip_code": 36130,
            "name_th": "กุดน้ำใส",
            "name_en": "Kut Nam Sai",
            "district_id": 3606,
            "lat": 15.596,
            "long": 101.794,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 360606,
            "zip_code": 36130,
            "name_th": "หนองโดน",
            "name_en": "Nong Don",
            "district_id": 3606,
            "lat": 15.567,
            "long": 101.736,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 360607,
            "zip_code": 36130,
            "name_th": "ละหาน",
            "name_en": "Lahan",
            "district_id": 3606,
            "lat": 15.629,
            "long": 101.938,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 360610,
            "zip_code": 36130,
            "name_th": "หนองบัวใหญ่",
            "name_en": "Nong Bua Yai",
            "district_id": 3606,
            "lat": 15.561,
            "long": 101.888,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 360611,
            "zip_code": 36220,
            "name_th": "หนองบัวโคก",
            "name_en": "Nong Bua Khok",
            "district_id": 3606,
            "lat": 15.448,
            "long": 101.854,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 360613,
            "zip_code": 36130,
            "name_th": "ส้มป่อย",
            "name_en": "Sompoi",
            "district_id": 3606,
            "lat": 15.711,
            "long": 101.806,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 3607,
        "name_th": "บำเหน็จณรงค์",
        "name_en": "Bamnet Narong",
        "province_id": 25,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 360701,
            "zip_code": 36160,
            "name_th": "บ้านชวน",
            "name_en": "Ban Chuan",
            "district_id": 3607,
            "lat": 15.518,
            "long": 101.653,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 360702,
            "zip_code": 36160,
            "name_th": "บ้านเพชร",
            "name_en": "Ban Phet",
            "district_id": 3607,
            "lat": 15.434,
            "long": 101.697,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 360703,
            "zip_code": 36220,
            "name_th": "บ้านตาล",
            "name_en": "Ban Tan",
            "district_id": 3607,
            "lat": 15.484,
            "long": 101.756,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 360704,
            "zip_code": 36220,
            "name_th": "หัวทะเล",
            "name_en": "Hua Thale",
            "district_id": 3607,
            "lat": 15.424,
            "long": 101.757,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 360705,
            "zip_code": 36160,
            "name_th": "โคกเริงรมย์",
            "name_en": "Khok Roeng Rom",
            "district_id": 3607,
            "lat": 15.391,
            "long": 101.576,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 360706,
            "zip_code": 36160,
            "name_th": "เกาะมะนาว",
            "name_en": "Ko Manao",
            "district_id": 3607,
            "lat": 15.504,
            "long": 101.61,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 360707,
            "zip_code": 36160,
            "name_th": "โคกเพชรพัฒนา",
            "name_en": "Khok Phet Phatthana",
            "district_id": 3607,
            "lat": 15.471,
            "long": 101.578,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 3608,
        "name_th": "หนองบัวระเหว",
        "name_en": "Nong Bua Rawe",
        "province_id": 25,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 360801,
            "zip_code": 36250,
            "name_th": "หนองบัวระเหว",
            "name_en": "Nong Bua Rawe",
            "district_id": 3608,
            "lat": 15.757,
            "long": 101.786,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 360802,
            "zip_code": 36250,
            "name_th": "วังตะเฆ่",
            "name_en": "Wang Takhe",
            "district_id": 3608,
            "lat": 15.83,
            "long": 101.583,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 360803,
            "zip_code": 36250,
            "name_th": "ห้วยแย้",
            "name_en": "Huai Yae",
            "district_id": 3608,
            "lat": 15.921,
            "long": 101.64,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 360804,
            "zip_code": 36250,
            "name_th": "โคกสะอาด",
            "name_en": "Khok Sa-at",
            "district_id": 3608,
            "lat": 15.778,
            "long": 101.699,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 360805,
            "zip_code": 36250,
            "name_th": "โสกปลาดุก",
            "name_en": "Sok Pla Duk",
            "district_id": 3608,
            "lat": 15.718,
            "long": 101.695,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 3609,
        "name_th": "เทพสถิต",
        "name_en": "Thep Sathit",
        "province_id": 25,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 360901,
            "zip_code": 36230,
            "name_th": "วะตะแบก",
            "name_en": "Wa Tabaek",
            "district_id": 3609,
            "lat": 15.426,
            "long": 101.436,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 360902,
            "zip_code": 36230,
            "name_th": "ห้วยยายจิ๋ว",
            "name_en": "Huai Yai Chio",
            "district_id": 3609,
            "lat": 15.432,
            "long": 101.547,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 360903,
            "zip_code": 36230,
            "name_th": "นายางกลัก",
            "name_en": "Na Yang Klak",
            "district_id": 3609,
            "lat": 15.676,
            "long": 101.517,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 360904,
            "zip_code": 36230,
            "name_th": "บ้านไร่",
            "name_en": "Ban Rai",
            "district_id": 3609,
            "lat": 15.595,
            "long": 101.456,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 360905,
            "zip_code": 36230,
            "name_th": "โป่งนก",
            "name_en": "Pong Nok",
            "district_id": 3609,
            "lat": 15.808,
            "long": 101.469,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 3610,
        "name_th": "ภูเขียว",
        "name_en": "Phu Khiao",
        "province_id": 25,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 361001,
            "zip_code": 36110,
            "name_th": "ผักปัง",
            "name_en": "Phak Pang",
            "district_id": 3610,
            "lat": 16.357,
            "long": 102.136,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 361002,
            "zip_code": 36110,
            "name_th": "กวางโจน",
            "name_en": "Kwang Chon",
            "district_id": 3610,
            "lat": 16.282,
            "long": 102.232,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 361003,
            "zip_code": 36110,
            "name_th": "หนองคอนไทย",
            "name_en": "Nong Khon Thai",
            "district_id": 3610,
            "lat": 16.461,
            "long": 102.181,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 361004,
            "zip_code": 36110,
            "name_th": "บ้านแก้ง",
            "name_en": "Ban Kaeng",
            "district_id": 3610,
            "lat": 16.42,
            "long": 102.049,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 361005,
            "zip_code": 36110,
            "name_th": "กุดยม",
            "name_en": "Kut Yom",
            "district_id": 3610,
            "lat": 16.417,
            "long": 102.202,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 361006,
            "zip_code": 36110,
            "name_th": "บ้านเพชร",
            "name_en": "Ban Phet",
            "district_id": 3610,
            "lat": 16.344,
            "long": 102.256,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 361007,
            "zip_code": 36110,
            "name_th": "โคกสะอาด",
            "name_en": "Khok Sa-at",
            "district_id": 3610,
            "lat": 16.475,
            "long": 102.125,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 361008,
            "zip_code": 36110,
            "name_th": "หนองตูม",
            "name_en": "Nong Tum",
            "district_id": 3610,
            "lat": 16.325,
            "long": 102.092,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 361009,
            "zip_code": 36110,
            "name_th": "โอโล",
            "name_en": "Olo",
            "district_id": 3610,
            "lat": 16.346,
            "long": 102.184,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 361010,
            "zip_code": 36110,
            "name_th": "ธาตุทอง",
            "name_en": "That Thong",
            "district_id": 3610,
            "lat": 16.235,
            "long": 102.16,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 361011,
            "zip_code": 36110,
            "name_th": "บ้านดอน",
            "name_en": "Ban Don",
            "district_id": 3610,
            "lat": 16.305,
            "long": 102.304,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 3611,
        "name_th": "บ้านแท่น",
        "name_en": "Ban Thaen",
        "province_id": 25,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 361101,
            "zip_code": 36190,
            "name_th": "บ้านแท่น",
            "name_en": "Ban Thaen",
            "district_id": 3611,
            "lat": 16.405,
            "long": 102.349,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 361102,
            "zip_code": 36190,
            "name_th": "สามสวน",
            "name_en": "Sam Suan",
            "district_id": 3611,
            "lat": 16.419,
            "long": 102.27,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 361103,
            "zip_code": 36190,
            "name_th": "สระพัง",
            "name_en": "Sa Phang",
            "district_id": 3611,
            "lat": 16.401,
            "long": 102.418,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 361104,
            "zip_code": 36190,
            "name_th": "บ้านเต่า",
            "name_en": "Ban Tao",
            "district_id": 3611,
            "lat": 16.35,
            "long": 102.387,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 361105,
            "zip_code": 36190,
            "name_th": "หนองคู",
            "name_en": "Nong Khu",
            "district_id": 3611,
            "lat": 16.293,
            "long": 102.398,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 3612,
        "name_th": "แก้งคร้อ",
        "name_en": "Kaeng Khro",
        "province_id": 25,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 361201,
            "zip_code": 36150,
            "name_th": "ช่องสามหมอ",
            "name_en": "Chong Sam Mo",
            "district_id": 3612,
            "lat": 16.107,
            "long": 102.236,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 361202,
            "zip_code": 36150,
            "name_th": "หนองขาม",
            "name_en": "Nong Kham",
            "district_id": 3612,
            "lat": 16.164,
            "long": 102.194,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 361203,
            "zip_code": 36150,
            "name_th": "นาหนองทุ่ม",
            "name_en": "Na Nong Thum",
            "district_id": 3612,
            "lat": 16.032,
            "long": 102.164,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 361204,
            "zip_code": 36150,
            "name_th": "บ้านแก้ง",
            "name_en": "Ban Kaeng",
            "district_id": 3612,
            "lat": 16.172,
            "long": 102.325,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 361205,
            "zip_code": 36150,
            "name_th": "หนองสังข์",
            "name_en": "Nong Sang",
            "district_id": 3612,
            "lat": 16.242,
            "long": 102.382,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 361206,
            "zip_code": 36150,
            "name_th": "หลุบคา",
            "name_en": "Lup Kha",
            "district_id": 3612,
            "lat": 16.202,
            "long": 102.259,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 361207,
            "zip_code": 36150,
            "name_th": "โคกกุง",
            "name_en": "Khok Kung",
            "district_id": 3612,
            "lat": 16.111,
            "long": 102.154,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 361208,
            "zip_code": 36150,
            "name_th": "เก่าย่าดี",
            "name_en": "Kao Ya Di",
            "district_id": 3612,
            "lat": 16.056,
            "long": 102.074,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 361209,
            "zip_code": 36150,
            "name_th": "ท่ามะไฟหวาน",
            "name_en": "Tha Mafai Wan",
            "district_id": 3612,
            "lat": 16.155,
            "long": 102.097,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 361210,
            "zip_code": 36150,
            "name_th": "หนองไผ่",
            "name_en": "Nong Phai",
            "district_id": 3612,
            "lat": 16.13,
            "long": 102.273,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 3613,
        "name_th": "คอนสาร",
        "name_en": "Khon San",
        "province_id": 25,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 361301,
            "zip_code": 36180,
            "name_th": "คอนสาร",
            "name_en": "Khon San",
            "district_id": 3613,
            "lat": 16.61,
            "long": 101.921,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 361302,
            "zip_code": 36180,
            "name_th": "ทุ่งพระ",
            "name_en": "Thung Phra",
            "district_id": 3613,
            "lat": 16.649,
            "long": 101.642,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 361303,
            "zip_code": 36180,
            "name_th": "โนนคูณ",
            "name_en": "Non Khun",
            "district_id": 3613,
            "lat": 16.485,
            "long": 101.981,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 361304,
            "zip_code": 36180,
            "name_th": "ห้วยยาง",
            "name_en": "Huai Yang",
            "district_id": 3613,
            "lat": 16.536,
            "long": 101.896,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 361305,
            "zip_code": 36180,
            "name_th": "ทุ่งลุยลาย",
            "name_en": "Thung Luilai",
            "district_id": 3613,
            "lat": 16.522,
            "long": 101.634,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 361306,
            "zip_code": 36180,
            "name_th": "ดงบัง",
            "name_en": "Dong Bang",
            "district_id": 3613,
            "lat": 16.587,
            "long": 101.955,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 361307,
            "zip_code": 36180,
            "name_th": "ทุ่งนาเลา",
            "name_en": "Thung Na Lao",
            "district_id": 3613,
            "lat": 16.59,
            "long": 101.864,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 361308,
            "zip_code": 36180,
            "name_th": "ดงกลาง",
            "name_en": "Dong Klang",
            "district_id": 3613,
            "lat": 16.533,
            "long": 101.983,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 3614,
        "name_th": "ภักดีชุมพล",
        "name_en": "Phakdi Chumphon",
        "province_id": 25,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 361401,
            "zip_code": 36260,
            "name_th": "บ้านเจียง",
            "name_en": "Chao Thong",
            "district_id": 3614,
            "lat": 16.131,
            "long": 101.375,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 361402,
            "zip_code": 36260,
            "name_th": "เจาทอง",
            "name_en": "Ban Chiang",
            "district_id": 3614,
            "lat": 15.888,
            "long": 101.397,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 361403,
            "zip_code": 36260,
            "name_th": "วังทอง",
            "name_en": "Wang Thong",
            "district_id": 3614,
            "lat": 15.793,
            "long": 101.372,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 361404,
            "zip_code": 36260,
            "name_th": "แหลมทอง",
            "name_en": "Laem Thong",
            "district_id": 3614,
            "lat": 16.014,
            "long": 101.379,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 3615,
        "name_th": "เนินสง่า",
        "name_en": "Noen Sa-nga",
        "province_id": 25,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 361501,
            "zip_code": 36130,
            "name_th": "หนองฉิม",
            "name_en": "Nong Chim",
            "district_id": 3615,
            "lat": 15.559,
            "long": 101.968,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 361502,
            "zip_code": 36130,
            "name_th": "ตาเนิน",
            "name_en": "Ta Noen",
            "district_id": 3615,
            "lat": 15.527,
            "long": 102.016,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 361503,
            "zip_code": 36130,
            "name_th": "กะฮาด",
            "name_en": "Kahat",
            "district_id": 3615,
            "lat": 15.632,
            "long": 102.026,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 361504,
            "zip_code": 36130,
            "name_th": "รังงาม",
            "name_en": "Rang Ngam",
            "district_id": 3615,
            "lat": 15.487,
            "long": 101.964,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 3616,
        "name_th": "ซับใหญ่",
        "name_en": "Sap Yai",
        "province_id": 25,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 361601,
            "zip_code": 36130,
            "name_th": "ซับใหญ่",
            "name_en": "Sap Yai",
            "district_id": 3616,
            "lat": 15.602,
            "long": 101.573,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 361602,
            "zip_code": 36130,
            "name_th": "ท่ากูบ",
            "name_en": "Tha Kup",
            "district_id": 3616,
            "lat": 15.623,
            "long": 101.708,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 361603,
            "zip_code": 36130,
            "name_th": "ตะโกทอง",
            "name_en": "Tako Thong",
            "district_id": 3616,
            "lat": 15.565,
            "long": 101.67,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      }
    ]
  },
  {
    "id": 26,
    "name_th": "อำนาจเจริญ",
    "name_en": "Amnat Charoen",
    "geography_id": 3,
    "created_at": "2019-08-09T03:33:09.000+07:00",
    "updated_at": "2025-09-20T06:31:26.000+07:00",
    "deleted_at": null,
    "districts": [
      {
        "id": 3701,
        "name_th": "เมืองอำนาจเจริญ",
        "name_en": "Mueang Amnat Charoen",
        "province_id": 26,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 370101,
            "zip_code": 37000,
            "name_th": "บุ่ง",
            "name_en": "Bung",
            "district_id": 3701,
            "lat": 15.872,
            "long": 104.635,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 370102,
            "zip_code": 37000,
            "name_th": "ไก่คำ",
            "name_en": "Kai Kham",
            "district_id": 3701,
            "lat": 15.804,
            "long": 104.64,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 370103,
            "zip_code": 37000,
            "name_th": "นาจิก",
            "name_en": "Na Chik",
            "district_id": 3701,
            "lat": 15.787,
            "long": 104.564,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 370104,
            "zip_code": 37000,
            "name_th": "ปลาค้าว",
            "name_en": "Pla Khao",
            "district_id": 3701,
            "lat": 15.785,
            "long": 104.79,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 370105,
            "zip_code": 37000,
            "name_th": "เหล่าพรวน",
            "name_en": "Lao Pruan",
            "district_id": 3701,
            "lat": 15.867,
            "long": 104.794,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 370106,
            "zip_code": 37000,
            "name_th": "สร้างนกทา",
            "name_en": "Sang Nok Tha",
            "district_id": 3701,
            "lat": 15.841,
            "long": 104.75,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 370107,
            "zip_code": 37000,
            "name_th": "คึมใหญ่",
            "name_en": "Khuem Yai",
            "district_id": 3701,
            "lat": 15.948,
            "long": 104.751,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 370108,
            "zip_code": 37000,
            "name_th": "นาผือ",
            "name_en": "Na Phue",
            "district_id": 3701,
            "lat": 15.982,
            "long": 104.626,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 370109,
            "zip_code": 37000,
            "name_th": "น้ำปลีก",
            "name_en": "Nam Plik",
            "district_id": 3701,
            "lat": 15.811,
            "long": 104.46,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 370110,
            "zip_code": 37000,
            "name_th": "นาวัง",
            "name_en": "Na Wang",
            "district_id": 3701,
            "lat": 15.997,
            "long": 104.579,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 370111,
            "zip_code": 37000,
            "name_th": "นาหมอม้า",
            "name_en": "Na Mo Ma",
            "district_id": 3701,
            "lat": 15.885,
            "long": 104.478,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 370112,
            "zip_code": 37000,
            "name_th": "โนนโพธิ์",
            "name_en": "Non Pho",
            "district_id": 3701,
            "lat": 15.873,
            "long": 104.558,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 370113,
            "zip_code": 37000,
            "name_th": "โนนหนามแท่ง",
            "name_en": "Non Nam Thaeng",
            "district_id": 3701,
            "lat": 15.929,
            "long": 104.631,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 370114,
            "zip_code": 37000,
            "name_th": "ห้วยไร่",
            "name_en": "Huai Rai",
            "district_id": 3701,
            "lat": 15.851,
            "long": 104.689,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 370115,
            "zip_code": 37000,
            "name_th": "หนองมะแซว",
            "name_en": "Nong Masaeo",
            "district_id": 3701,
            "lat": 15.774,
            "long": 104.746,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 370116,
            "zip_code": 37000,
            "name_th": "กุดปลาดุก",
            "name_en": "Kut Pla Duk",
            "district_id": 3701,
            "lat": 15.945,
            "long": 104.525,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 370117,
            "zip_code": 37000,
            "name_th": "ดอนเมย",
            "name_en": "Don Moei",
            "district_id": 3701,
            "lat": 15.823,
            "long": 104.562,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 370118,
            "zip_code": 37000,
            "name_th": "นายม",
            "name_en": "Na Yom",
            "district_id": 3701,
            "lat": 15.878,
            "long": 104.513,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 370119,
            "zip_code": 37000,
            "name_th": "นาแต้",
            "name_en": "Na Tae",
            "district_id": 3701,
            "lat": 15.954,
            "long": 104.692,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 3702,
        "name_th": "ชานุมาน",
        "name_en": "Chanuman",
        "province_id": 26,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 370201,
            "zip_code": 37210,
            "name_th": "ชานุมาน",
            "name_en": "Chanuman",
            "district_id": 3702,
            "lat": 16.232,
            "long": 104.944,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 370202,
            "zip_code": 37210,
            "name_th": "โคกสาร",
            "name_en": "Khok San",
            "district_id": 3702,
            "lat": 16.156,
            "long": 104.996,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 370203,
            "zip_code": 37210,
            "name_th": "คำเขื่อนแก้ว",
            "name_en": "Kham Khuean Kaeo",
            "district_id": 3702,
            "lat": 16.15,
            "long": 104.922,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 370204,
            "zip_code": 37210,
            "name_th": "โคกก่ง",
            "name_en": "Khok Kong",
            "district_id": 3702,
            "lat": 16.066,
            "long": 104.97,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 370205,
            "zip_code": 37210,
            "name_th": "ป่าก่อ",
            "name_en": "Pa Ko",
            "district_id": 3702,
            "lat": 16.046,
            "long": 104.86,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 3703,
        "name_th": "ปทุมราชวงศา",
        "name_en": "Pathum Ratchawongsa",
        "province_id": 26,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 370301,
            "zip_code": 37110,
            "name_th": "หนองข่า",
            "name_en": "Nong Kha",
            "district_id": 3703,
            "lat": 15.973,
            "long": 104.892,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 370302,
            "zip_code": 37110,
            "name_th": "คำโพน",
            "name_en": "Kham Phon",
            "district_id": 3703,
            "lat": 15.968,
            "long": 104.967,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 370303,
            "zip_code": 37110,
            "name_th": "นาหว้า",
            "name_en": "Na Wa",
            "district_id": 3703,
            "lat": 15.897,
            "long": 104.918,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 370304,
            "zip_code": 37110,
            "name_th": "ลือ",
            "name_en": "Lue",
            "district_id": 3703,
            "lat": 15.796,
            "long": 104.868,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 370305,
            "zip_code": 37110,
            "name_th": "ห้วย",
            "name_en": "Huai",
            "district_id": 3703,
            "lat": 15.83,
            "long": 104.948,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 370306,
            "zip_code": 37110,
            "name_th": "โนนงาม",
            "name_en": "Non Ngam",
            "district_id": 3703,
            "lat": 15.862,
            "long": 104.828,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 370307,
            "zip_code": 37110,
            "name_th": "นาป่าแซง",
            "name_en": "Na Pa Saeng",
            "district_id": 3703,
            "lat": 15.872,
            "long": 104.876,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 3704,
        "name_th": "พนา",
        "name_en": "Phana",
        "province_id": 26,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 370401,
            "zip_code": 37180,
            "name_th": "พนา",
            "name_en": "Phana",
            "district_id": 3704,
            "lat": 15.678,
            "long": 104.882,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 370402,
            "zip_code": 37180,
            "name_th": "จานลาน",
            "name_en": "Chan Lan",
            "district_id": 3704,
            "lat": 15.619,
            "long": 104.901,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 370403,
            "zip_code": 37180,
            "name_th": "ไม้กลอน",
            "name_en": "Mai Klon",
            "district_id": 3704,
            "lat": 15.731,
            "long": 104.818,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 370404,
            "zip_code": 37180,
            "name_th": "พระเหลา",
            "name_en": "Phra Lao",
            "district_id": 3704,
            "lat": 15.737,
            "long": 104.882,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 3705,
        "name_th": "เสนางคนิคม",
        "name_en": "Senangkhanikhom",
        "province_id": 26,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 370501,
            "zip_code": 37290,
            "name_th": "เสนางคนิคม",
            "name_en": "Senangkhanikhom",
            "district_id": 3705,
            "lat": 16.056,
            "long": 104.685,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 370502,
            "zip_code": 37290,
            "name_th": "โพนทอง",
            "name_en": "Phon Thong",
            "district_id": 3705,
            "lat": 16.069,
            "long": 104.764,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 370503,
            "zip_code": 37290,
            "name_th": "ไร่สีสุก",
            "name_en": "Rai Si Suk",
            "district_id": 3705,
            "lat": 16.092,
            "long": 104.639,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 370504,
            "zip_code": 37290,
            "name_th": "นาเวียง",
            "name_en": "Na Wiang",
            "district_id": 3705,
            "lat": 16.029,
            "long": 104.592,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 370505,
            "zip_code": 37290,
            "name_th": "หนองไฮ",
            "name_en": "Nong Hai",
            "district_id": 3705,
            "lat": 16.022,
            "long": 104.787,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 370506,
            "zip_code": 37290,
            "name_th": "หนองสามสี",
            "name_en": "Nong Sam Si",
            "district_id": 3705,
            "lat": 16.05,
            "long": 104.616,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 3706,
        "name_th": "หัวตะพาน",
        "name_en": "Hua Taphan",
        "province_id": 26,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 370601,
            "zip_code": 37240,
            "name_th": "หัวตะพาน",
            "name_en": "Hua Taphan",
            "district_id": 3706,
            "lat": 15.718,
            "long": 104.457,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 370602,
            "zip_code": 37240,
            "name_th": "คำพระ",
            "name_en": "Kham Phra",
            "district_id": 3706,
            "lat": 15.761,
            "long": 104.518,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 370603,
            "zip_code": 37240,
            "name_th": "เค็งใหญ่",
            "name_en": "Kheng Yai",
            "district_id": 3706,
            "lat": 15.738,
            "long": 104.564,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 370604,
            "zip_code": 37240,
            "name_th": "หนองแก้ว",
            "name_en": "Nong Kaeo",
            "district_id": 3706,
            "lat": 15.696,
            "long": 104.531,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 370605,
            "zip_code": 37240,
            "name_th": "โพนเมืองน้อย",
            "name_en": "Phon Mueang Noi",
            "district_id": 3706,
            "lat": 15.65,
            "long": 104.58,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 370606,
            "zip_code": 37240,
            "name_th": "สร้างถ่อน้อย",
            "name_en": "Sang Tho Noi",
            "district_id": 3706,
            "lat": 15.641,
            "long": 104.49,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 370607,
            "zip_code": 37240,
            "name_th": "จิกดู่",
            "name_en": "Chik Du",
            "district_id": 3706,
            "lat": 15.583,
            "long": 104.545,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 370608,
            "zip_code": 37240,
            "name_th": "รัตนวารี",
            "name_en": "Rattanawari",
            "district_id": 3706,
            "lat": 15.723,
            "long": 104.513,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 3707,
        "name_th": "ลืออำนาจ",
        "name_en": "Lue Amnat",
        "province_id": 26,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 370701,
            "zip_code": 37000,
            "name_th": "อำนาจ",
            "name_en": "Amnat",
            "district_id": 3707,
            "lat": 15.71,
            "long": 104.668,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 370702,
            "zip_code": 37000,
            "name_th": "ดงมะยาง",
            "name_en": "Dong Mayang",
            "district_id": 3707,
            "lat": 15.716,
            "long": 104.617,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 370703,
            "zip_code": 37000,
            "name_th": "เปือย",
            "name_en": "Pueai",
            "district_id": 3707,
            "lat": 15.687,
            "long": 104.697,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 370704,
            "zip_code": 37000,
            "name_th": "ดงบัง",
            "name_en": "Dong Bang",
            "district_id": 3707,
            "lat": 15.716,
            "long": 104.765,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 370705,
            "zip_code": 37000,
            "name_th": "ไร่ขี",
            "name_en": "Rai Khi",
            "district_id": 3707,
            "lat": 15.663,
            "long": 104.78,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 370706,
            "zip_code": 37000,
            "name_th": "แมด",
            "name_en": "Maet",
            "district_id": 3707,
            "lat": 15.761,
            "long": 104.689,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 370707,
            "zip_code": 37000,
            "name_th": "โคกกลาง",
            "name_en": "Khok Klang",
            "district_id": 3707,
            "lat": 15.751,
            "long": 104.637,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      }
    ]
  },
  {
    "id": 27,
    "name_th": "หนองบัวลำภู",
    "name_en": "Nong Bua Lam Phu",
    "geography_id": 3,
    "created_at": "2019-08-09T03:33:09.000+07:00",
    "updated_at": "2025-09-20T06:31:26.000+07:00",
    "deleted_at": null,
    "districts": [
      {
        "id": 3901,
        "name_th": "เมืองหนองบัวลำภู",
        "name_en": "Mueang Nong Bua Lam Phu",
        "province_id": 27,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 390101,
            "zip_code": 39000,
            "name_th": "หนองบัว",
            "name_en": "Nong Bua",
            "district_id": 3901,
            "lat": 17.168,
            "long": 102.444,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 390102,
            "zip_code": 39000,
            "name_th": "หนองภัยศูนย์",
            "name_en": "Nong Phai Sun",
            "district_id": 3901,
            "lat": 17.263,
            "long": 102.395,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 390103,
            "zip_code": 39000,
            "name_th": "โพธิ์ชัย",
            "name_en": "Pho Chai",
            "district_id": 3901,
            "lat": 17.211,
            "long": 102.381,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 390104,
            "zip_code": 39000,
            "name_th": "หนองสวรรค์",
            "name_en": "Nong Sawan",
            "district_id": 3901,
            "lat": 17.2,
            "long": 102.317,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 390105,
            "zip_code": 39000,
            "name_th": "หัวนา",
            "name_en": "Hua Na",
            "district_id": 3901,
            "lat": 17.032,
            "long": 102.39,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 390106,
            "zip_code": 39000,
            "name_th": "บ้านขาม",
            "name_en": "Ban Kham",
            "district_id": 3901,
            "lat": 17.111,
            "long": 102.477,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 390107,
            "zip_code": 39000,
            "name_th": "นามะเฟือง",
            "name_en": "Na Mafueang",
            "district_id": 3901,
            "lat": 17.046,
            "long": 102.506,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 390108,
            "zip_code": 39000,
            "name_th": "บ้านพร้าว",
            "name_en": "Ban Phrao",
            "district_id": 3901,
            "lat": 17.102,
            "long": 102.392,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 390109,
            "zip_code": 39000,
            "name_th": "โนนขมิ้น",
            "name_en": "Non Khamin",
            "district_id": 3901,
            "lat": 17.164,
            "long": 102.283,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 390110,
            "zip_code": 39000,
            "name_th": "ลำภู",
            "name_en": "Lam Phu",
            "district_id": 3901,
            "lat": 17.243,
            "long": 102.44,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 390111,
            "zip_code": 39000,
            "name_th": "กุดจิก",
            "name_en": "Kut Chik",
            "district_id": 3901,
            "lat": 17.333,
            "long": 102.372,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 390112,
            "zip_code": 39000,
            "name_th": "โนนทัน",
            "name_en": "Non Than",
            "district_id": 3901,
            "lat": 17.245,
            "long": 102.503,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 390113,
            "zip_code": 39000,
            "name_th": "นาคำไฮ",
            "name_en": "Na Kham Hai",
            "district_id": 3901,
            "lat": 17.28,
            "long": 102.304,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 390114,
            "zip_code": 39000,
            "name_th": "ป่าไม้งาม",
            "name_en": "Pa Mai Ngam",
            "district_id": 3901,
            "lat": 16.974,
            "long": 102.366,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 390115,
            "zip_code": 39000,
            "name_th": "หนองหว้า",
            "name_en": "Nong Wa",
            "district_id": 3901,
            "lat": 17.147,
            "long": 102.35,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 3902,
        "name_th": "นากลาง",
        "name_en": "Na Klang",
        "province_id": 27,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 390201,
            "zip_code": 39170,
            "name_th": "นากลาง",
            "name_en": "Na Klang",
            "district_id": 3902,
            "lat": 17.312,
            "long": 102.214,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 390202,
            "zip_code": 39170,
            "name_th": "ด่านช้าง",
            "name_en": "Dan Chang",
            "district_id": 3902,
            "lat": 17.315,
            "long": 102.14,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 390205,
            "zip_code": 39350,
            "name_th": "กุดดินจี่",
            "name_en": "Kut Din Chi",
            "district_id": 3902,
            "lat": 17.349,
            "long": 102.273,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 390206,
            "zip_code": 39170,
            "name_th": "ฝั่งแดง",
            "name_en": "Fang Daeng",
            "district_id": 3902,
            "lat": 17.221,
            "long": 102.223,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 390207,
            "zip_code": 39350,
            "name_th": "เก่ากลอย",
            "name_en": "Kao Kloi",
            "district_id": 3902,
            "lat": 17.397,
            "long": 102.339,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 390209,
            "zip_code": 39170,
            "name_th": "โนนเมือง",
            "name_en": "Non Mueang",
            "district_id": 3902,
            "lat": 17.181,
            "long": 102.154,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 390210,
            "zip_code": 39170,
            "name_th": "อุทัยสวรรค์",
            "name_en": "Uthai Sawan",
            "district_id": 3902,
            "lat": 17.235,
            "long": 102.143,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 390211,
            "zip_code": 39350,
            "name_th": "ดงสวรรค์",
            "name_en": "Dong Sawan",
            "district_id": 3902,
            "lat": 17.443,
            "long": 102.193,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 390213,
            "zip_code": 39170,
            "name_th": "กุดแห่",
            "name_en": "Kut Hae",
            "district_id": 3902,
            "lat": 17.391,
            "long": 102.149,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 3903,
        "name_th": "โนนสัง",
        "name_en": "Non Sang",
        "province_id": 27,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 390301,
            "zip_code": 39140,
            "name_th": "โนนสัง",
            "name_en": "Non Sang",
            "district_id": 3903,
            "lat": 16.872,
            "long": 102.56,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 390302,
            "zip_code": 39140,
            "name_th": "บ้านถิ่น",
            "name_en": "Ban Thin",
            "district_id": 3903,
            "lat": 16.987,
            "long": 102.527,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 390303,
            "zip_code": 39140,
            "name_th": "หนองเรือ",
            "name_en": "Nong Ruea",
            "district_id": 3903,
            "lat": 16.844,
            "long": 102.504,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 390304,
            "zip_code": 39140,
            "name_th": "กุดดู่",
            "name_en": "Kut Du",
            "district_id": 3903,
            "lat": 16.971,
            "long": 102.65,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 390305,
            "zip_code": 39140,
            "name_th": "บ้านค้อ",
            "name_en": "Ban Kho",
            "district_id": 3903,
            "lat": 16.855,
            "long": 102.601,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 390306,
            "zip_code": 39140,
            "name_th": "โนนเมือง",
            "name_en": "Non Mueang",
            "district_id": 3903,
            "lat": 16.84,
            "long": 102.437,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 390307,
            "zip_code": 39140,
            "name_th": "โคกใหญ่",
            "name_en": "Khok Yai",
            "district_id": 3903,
            "lat": 16.809,
            "long": 102.569,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 390308,
            "zip_code": 39140,
            "name_th": "โคกม่วง",
            "name_en": "Khok Muang",
            "district_id": 3903,
            "lat": 16.892,
            "long": 102.4,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 390309,
            "zip_code": 39140,
            "name_th": "นิคมพัฒนา",
            "name_en": "Nikhom Phatthana",
            "district_id": 3903,
            "lat": 16.93,
            "long": 102.524,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 390310,
            "zip_code": 39140,
            "name_th": "ปางกู่",
            "name_en": "Pang Ku",
            "district_id": 3903,
            "lat": 17.003,
            "long": 102.593,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 3904,
        "name_th": "ศรีบุญเรือง",
        "name_en": "Si Bun Rueang",
        "province_id": 27,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 390401,
            "zip_code": 39180,
            "name_th": "เมืองใหม่",
            "name_en": "Mueang Mai",
            "district_id": 3904,
            "lat": 16.992,
            "long": 102.291,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 390402,
            "zip_code": 39180,
            "name_th": "ศรีบุญเรือง",
            "name_en": "Si Bun Rueang",
            "district_id": 3904,
            "lat": 16.922,
            "long": 102.302,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 390403,
            "zip_code": 39180,
            "name_th": "หนองบัวใต้",
            "name_en": "Nong Bua Tai",
            "district_id": 3904,
            "lat": 16.92,
            "long": 102.353,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 390404,
            "zip_code": 39180,
            "name_th": "กุดสะเทียน",
            "name_en": "Kut Sathian",
            "district_id": 3904,
            "lat": 17.056,
            "long": 102.238,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 390405,
            "zip_code": 39180,
            "name_th": "นากอก",
            "name_en": "Na Kok",
            "district_id": 3904,
            "lat": 16.904,
            "long": 102.201,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 390406,
            "zip_code": 39180,
            "name_th": "โนนสะอาด",
            "name_en": "Non Sa-at",
            "district_id": 3904,
            "lat": 16.977,
            "long": 102.176,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 390407,
            "zip_code": 39180,
            "name_th": "ยางหล่อ",
            "name_en": "Yang Lo",
            "district_id": 3904,
            "lat": 17.062,
            "long": 102.159,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 390408,
            "zip_code": 39180,
            "name_th": "โนนม่วง",
            "name_en": "Non Muang",
            "district_id": 3904,
            "lat": 17.128,
            "long": 102.181,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 390409,
            "zip_code": 39180,
            "name_th": "หนองกุงแก้ว",
            "name_en": "Nong Kung Kaeo",
            "district_id": 3904,
            "lat": 17.149,
            "long": 102.073,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 390410,
            "zip_code": 39180,
            "name_th": "หนองแก",
            "name_en": "Nong Kae",
            "district_id": 3904,
            "lat": 17.083,
            "long": 102.294,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 390411,
            "zip_code": 39180,
            "name_th": "ทรายทอง",
            "name_en": "Sai Thong",
            "district_id": 3904,
            "lat": 16.856,
            "long": 102.349,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 390412,
            "zip_code": 39180,
            "name_th": "หันนางาม",
            "name_en": "Han Na Ngam",
            "district_id": 3904,
            "lat": 16.985,
            "long": 102.246,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 3905,
        "name_th": "สุวรรณคูหา",
        "name_en": "Suwannakhuha",
        "province_id": 27,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 390501,
            "zip_code": 39270,
            "name_th": "นาสี",
            "name_en": "Nasi",
            "district_id": 3905,
            "lat": 17.631,
            "long": 102.313,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 390502,
            "zip_code": 39270,
            "name_th": "บ้านโคก",
            "name_en": "Ban Khok",
            "district_id": 3905,
            "lat": 17.528,
            "long": 102.199,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 390503,
            "zip_code": 39270,
            "name_th": "นาดี",
            "name_en": "Na Di",
            "district_id": 3905,
            "lat": 17.473,
            "long": 102.269,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 390504,
            "zip_code": 39270,
            "name_th": "นาด่าน",
            "name_en": "Na Dan",
            "district_id": 3905,
            "lat": 17.47,
            "long": 102.347,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 390505,
            "zip_code": 39270,
            "name_th": "ดงมะไฟ",
            "name_en": "Dong Mafai",
            "district_id": 3905,
            "lat": 17.635,
            "long": 102.245,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 390506,
            "zip_code": 39270,
            "name_th": "สุวรรณคูหา",
            "name_en": "Suwannakhuha",
            "district_id": 3905,
            "lat": 17.551,
            "long": 102.277,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 390507,
            "zip_code": 39270,
            "name_th": "บุญทัน",
            "name_en": "Bun Than",
            "district_id": 3905,
            "lat": 17.582,
            "long": 102.14,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 390508,
            "zip_code": 39270,
            "name_th": "กุดผึ้ง",
            "name_en": "Kut Phueng",
            "district_id": 3905,
            "lat": 17.549,
            "long": 102.315,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 3906,
        "name_th": "นาวัง",
        "name_en": "Na Wang",
        "province_id": 27,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 390601,
            "zip_code": 39170,
            "name_th": "นาเหล่า",
            "name_en": "Na Lao",
            "district_id": 3906,
            "lat": 17.294,
            "long": 102.073,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 390602,
            "zip_code": 39170,
            "name_th": "นาแก",
            "name_en": "Na Kae",
            "district_id": 3906,
            "lat": 17.396,
            "long": 102.078,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 390603,
            "zip_code": 39170,
            "name_th": "วังทอง",
            "name_en": "Wang Thong",
            "district_id": 3906,
            "lat": 17.32,
            "long": 102.03,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 390604,
            "zip_code": 39170,
            "name_th": "วังปลาป้อม",
            "name_en": "Wang Pla Pom",
            "district_id": 3906,
            "lat": 17.426,
            "long": 102.024,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 390605,
            "zip_code": 39170,
            "name_th": "เทพคีรี",
            "name_en": "Thep Khiri",
            "district_id": 3906,
            "lat": 17.308,
            "long": 102.117,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      }
    ]
  },
  {
    "id": 28,
    "name_th": "ขอนแก่น",
    "name_en": "Khon Kaen",
    "geography_id": 3,
    "created_at": "2019-08-09T03:33:09.000+07:00",
    "updated_at": "2025-09-20T06:31:26.000+07:00",
    "deleted_at": null,
    "districts": [
      {
        "id": 4001,
        "name_th": "เมืองขอนแก่น",
        "name_en": "Mueang Khon Kaen",
        "province_id": 28,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 400101,
            "zip_code": 40000,
            "name_th": "ในเมือง",
            "name_en": "Nai Mueang",
            "district_id": 4001,
            "lat": 16.438,
            "long": 102.837,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 400102,
            "zip_code": 40000,
            "name_th": "สำราญ",
            "name_en": "Samran",
            "district_id": 4001,
            "lat": 16.537,
            "long": 102.837,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 400103,
            "zip_code": 40000,
            "name_th": "โคกสี",
            "name_en": "Khok Si",
            "district_id": 4001,
            "lat": 16.481,
            "long": 102.985,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 400104,
            "zip_code": 40260,
            "name_th": "ท่าพระ",
            "name_en": "Tha Phra",
            "district_id": 4001,
            "lat": 16.314,
            "long": 102.813,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 400105,
            "zip_code": 40000,
            "name_th": "บ้านทุ่ม",
            "name_en": "Ban Thum",
            "district_id": 4001,
            "lat": 16.459,
            "long": 102.701,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 400106,
            "zip_code": 40000,
            "name_th": "เมืองเก่า",
            "name_en": "Mueang Kao",
            "district_id": 4001,
            "lat": 16.385,
            "long": 102.809,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 400107,
            "zip_code": 40000,
            "name_th": "พระลับ",
            "name_en": "Phra Lap",
            "district_id": 4001,
            "lat": 16.401,
            "long": 102.885,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 400108,
            "zip_code": 40000,
            "name_th": "สาวะถี",
            "name_en": "Sawathi",
            "district_id": 4001,
            "lat": 16.538,
            "long": 102.684,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 400109,
            "zip_code": 40000,
            "name_th": "บ้านหว้า",
            "name_en": "Ban Wa",
            "district_id": 4001,
            "lat": 16.384,
            "long": 102.713,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 400110,
            "zip_code": 40000,
            "name_th": "บ้านค้อ",
            "name_en": "Ban Kho",
            "district_id": 4001,
            "lat": 16.569,
            "long": 102.753,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 400111,
            "zip_code": 40000,
            "name_th": "แดงใหญ่",
            "name_en": "Daeng Yai",
            "district_id": 4001,
            "lat": 16.485,
            "long": 102.752,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 400112,
            "zip_code": 40000,
            "name_th": "ดอนช้าง",
            "name_en": "Don Chang",
            "district_id": 4001,
            "lat": 16.363,
            "long": 102.759,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 400113,
            "zip_code": 40260,
            "name_th": "ดอนหัน",
            "name_en": "Don Han",
            "district_id": 4001,
            "lat": 16.334,
            "long": 102.869,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 400114,
            "zip_code": 40000,
            "name_th": "ศิลา",
            "name_en": "Sila",
            "district_id": 4001,
            "lat": 16.49,
            "long": 102.857,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 400115,
            "zip_code": 40000,
            "name_th": "บ้านเป็ด",
            "name_en": "Ban Pet",
            "district_id": 4001,
            "lat": 16.435,
            "long": 102.781,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 400116,
            "zip_code": 40000,
            "name_th": "หนองตูม",
            "name_en": "Nong Tum",
            "district_id": 4001,
            "lat": 16.516,
            "long": 102.931,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 400117,
            "zip_code": 40000,
            "name_th": "บึงเนียม",
            "name_en": "Bueng Niam",
            "district_id": 4001,
            "lat": 16.43,
            "long": 102.922,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 400118,
            "zip_code": 40000,
            "name_th": "โนนท่อน",
            "name_en": "Non Thon",
            "district_id": 4001,
            "lat": 16.595,
            "long": 102.837,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 4002,
        "name_th": "บ้านฝาง",
        "name_en": "Ban Fang",
        "province_id": 28,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 400201,
            "zip_code": 40270,
            "name_th": "หนองบัว",
            "name_en": "Nong Bua",
            "district_id": 4002,
            "lat": 16.497,
            "long": 102.596,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 400202,
            "zip_code": 40270,
            "name_th": "ป่าหวายนั่ง",
            "name_en": "Pa Wai Nang",
            "district_id": 4002,
            "lat": 16.609,
            "long": 102.65,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 400203,
            "zip_code": 40270,
            "name_th": "โนนฆ้อง",
            "name_en": "Non Khong",
            "district_id": 4002,
            "lat": 16.416,
            "long": 102.589,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 400204,
            "zip_code": 40270,
            "name_th": "บ้านเหล่า",
            "name_en": "Ban Lao",
            "district_id": 4002,
            "lat": 16.399,
            "long": 102.65,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 400205,
            "zip_code": 40270,
            "name_th": "ป่ามะนาว",
            "name_en": "Pa Manao",
            "district_id": 4002,
            "lat": 16.367,
            "long": 102.573,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 400206,
            "zip_code": 40270,
            "name_th": "บ้านฝาง",
            "name_en": "Ban Fang",
            "district_id": 4002,
            "lat": 16.443,
            "long": 102.654,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 400207,
            "zip_code": 40270,
            "name_th": "โคกงาม",
            "name_en": "Khok Ngam",
            "district_id": 4002,
            "lat": 16.582,
            "long": 102.6,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 4003,
        "name_th": "พระยืน",
        "name_en": "Phra Yuen",
        "province_id": 28,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 400301,
            "zip_code": 40320,
            "name_th": "พระยืน",
            "name_en": "Phra Yuen",
            "district_id": 4003,
            "lat": 16.323,
            "long": 102.612,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 400302,
            "zip_code": 40320,
            "name_th": "พระบุ",
            "name_en": "Phra Bu",
            "district_id": 4003,
            "lat": 16.265,
            "long": 102.697,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 400303,
            "zip_code": 40320,
            "name_th": "บ้านโต้น",
            "name_en": "Ban Ton",
            "district_id": 4003,
            "lat": 16.274,
            "long": 102.751,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 400304,
            "zip_code": 40320,
            "name_th": "หนองแวง",
            "name_en": "Nong Waeng",
            "district_id": 4003,
            "lat": 16.318,
            "long": 102.738,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 400305,
            "zip_code": 40320,
            "name_th": "ขามป้อม",
            "name_en": "Kham Pom",
            "district_id": 4003,
            "lat": 16.301,
            "long": 102.657,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 4004,
        "name_th": "หนองเรือ",
        "name_en": "Nong Ruea",
        "province_id": 28,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 400401,
            "zip_code": 40210,
            "name_th": "หนองเรือ",
            "name_en": "Nong Ruea",
            "district_id": 4004,
            "lat": 16.501,
            "long": 102.464,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 400402,
            "zip_code": 40210,
            "name_th": "บ้านเม็ง",
            "name_en": "Ban Meng",
            "district_id": 4004,
            "lat": 16.435,
            "long": 102.46,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 400403,
            "zip_code": 40240,
            "name_th": "บ้านกง",
            "name_en": "Ban Kong",
            "district_id": 4004,
            "lat": 16.5,
            "long": 102.553,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 400404,
            "zip_code": 40240,
            "name_th": "ยางคำ",
            "name_en": "Yang Kham",
            "district_id": 4004,
            "lat": 16.398,
            "long": 102.515,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 400405,
            "zip_code": 40240,
            "name_th": "จระเข้",
            "name_en": "Chorakhe",
            "district_id": 4004,
            "lat": 16.458,
            "long": 102.536,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 400406,
            "zip_code": 40210,
            "name_th": "โนนทอง",
            "name_en": "Non Thong",
            "district_id": 4004,
            "lat": 16.552,
            "long": 102.384,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 400407,
            "zip_code": 40210,
            "name_th": "กุดกว้าง",
            "name_en": "Kut Kwang",
            "district_id": 4004,
            "lat": 16.475,
            "long": 102.32,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 400408,
            "zip_code": 40210,
            "name_th": "โนนทัน",
            "name_en": "Non Than",
            "district_id": 4004,
            "lat": 16.507,
            "long": 102.377,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 400409,
            "zip_code": 40210,
            "name_th": "โนนสะอาด",
            "name_en": "Non Sa-at",
            "district_id": 4004,
            "lat": 16.538,
            "long": 102.312,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 400410,
            "zip_code": 40240,
            "name_th": "บ้านผือ",
            "name_en": "Ban Phue",
            "district_id": 4004,
            "lat": 16.54,
            "long": 102.556,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 4005,
        "name_th": "ชุมแพ",
        "name_en": "Chum Phae",
        "province_id": 28,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 400501,
            "zip_code": 40130,
            "name_th": "ชุมแพ",
            "name_en": "Chum Phae",
            "district_id": 4005,
            "lat": 16.526,
            "long": 102.074,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 400502,
            "zip_code": 40290,
            "name_th": "โนนหัน",
            "name_en": "Non Han",
            "district_id": 4005,
            "lat": 16.603,
            "long": 102.019,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 400503,
            "zip_code": 40290,
            "name_th": "นาหนองทุ่ม",
            "name_en": "Na Nong Thum",
            "district_id": 4005,
            "lat": 16.767,
            "long": 101.98,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 400504,
            "zip_code": 40130,
            "name_th": "โนนอุดม",
            "name_en": "Non Udom",
            "district_id": 4005,
            "lat": 16.505,
            "long": 102.231,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 400505,
            "zip_code": 40130,
            "name_th": "ขัวเรียง",
            "name_en": "Khua Riang",
            "district_id": 4005,
            "lat": 16.561,
            "long": 102.214,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 400506,
            "zip_code": 40130,
            "name_th": "หนองไผ่",
            "name_en": "Nong Phai",
            "district_id": 4005,
            "lat": 16.565,
            "long": 102.147,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 400507,
            "zip_code": 40130,
            "name_th": "ไชยสอ",
            "name_en": "Chai So",
            "district_id": 4005,
            "lat": 16.514,
            "long": 102.14,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 400508,
            "zip_code": 40130,
            "name_th": "วังหินลาด",
            "name_en": "Wang Hin Lat",
            "district_id": 4005,
            "lat": 16.625,
            "long": 102.093,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 400509,
            "zip_code": 40130,
            "name_th": "นาเพียง",
            "name_en": "Na Phiang",
            "district_id": 4005,
            "lat": 16.49,
            "long": 102.27,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 400510,
            "zip_code": 40290,
            "name_th": "หนองเขียด",
            "name_en": "Nong Khiat",
            "district_id": 4005,
            "lat": 16.658,
            "long": 102.014,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 400511,
            "zip_code": 40130,
            "name_th": "หนองเสาเล้า",
            "name_en": "Nong Sao Lao",
            "district_id": 4005,
            "lat": 16.586,
            "long": 102.298,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 400512,
            "zip_code": 40290,
            "name_th": "โนนสะอาด",
            "name_en": "Non Sa-at",
            "district_id": 4005,
            "lat": 16.576,
            "long": 101.999,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 4006,
        "name_th": "สีชมพู",
        "name_en": "Si Chomphu",
        "province_id": 28,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 400601,
            "zip_code": 40220,
            "name_th": "สีชมพู",
            "name_en": "Si Chomphu",
            "district_id": 4006,
            "lat": 16.841,
            "long": 102.156,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 400602,
            "zip_code": 40220,
            "name_th": "ศรีสุข",
            "name_en": "Si Suk",
            "district_id": 4006,
            "lat": 16.751,
            "long": 102.206,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 400603,
            "zip_code": 40220,
            "name_th": "นาจาน",
            "name_en": "Na Chan",
            "district_id": 4006,
            "lat": 16.657,
            "long": 102.147,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 400604,
            "zip_code": 40220,
            "name_th": "วังเพิ่ม",
            "name_en": "Wang Phoem",
            "district_id": 4006,
            "lat": 16.82,
            "long": 102.204,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 400605,
            "zip_code": 40220,
            "name_th": "ซำยาง",
            "name_en": "Sam Yang",
            "district_id": 4006,
            "lat": 16.688,
            "long": 102.091,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 400606,
            "zip_code": 40220,
            "name_th": "หนองแดง",
            "name_en": "Nong Daeng",
            "district_id": 4006,
            "lat": 16.711,
            "long": 102.113,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 400607,
            "zip_code": 40220,
            "name_th": "ดงลาน",
            "name_en": "Dong Lan",
            "district_id": 4006,
            "lat": 16.805,
            "long": 102.075,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 400608,
            "zip_code": 40220,
            "name_th": "บริบูรณ์",
            "name_en": "Boribun",
            "district_id": 4006,
            "lat": 16.855,
            "long": 102.092,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 400609,
            "zip_code": 40220,
            "name_th": "บ้านใหม่",
            "name_en": "Ban Mai",
            "district_id": 4006,
            "lat": 16.761,
            "long": 102.068,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 400610,
            "zip_code": 40220,
            "name_th": "ภูห่าน",
            "name_en": "Phu Han",
            "district_id": 4006,
            "lat": 16.72,
            "long": 102.046,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 4007,
        "name_th": "น้ำพอง",
        "name_en": "Nam Phong",
        "province_id": 28,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 400701,
            "zip_code": 40140,
            "name_th": "น้ำพอง",
            "name_en": "Nam Phong",
            "district_id": 4007,
            "lat": 16.76,
            "long": 102.825,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 400702,
            "zip_code": 40140,
            "name_th": "วังชัย",
            "name_en": "Wang Chai",
            "district_id": 4007,
            "lat": 16.728,
            "long": 102.862,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 400703,
            "zip_code": 40140,
            "name_th": "หนองกุง",
            "name_en": "Nong Kung",
            "district_id": 4007,
            "lat": 16.73,
            "long": 102.897,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 400704,
            "zip_code": 40140,
            "name_th": "บัวใหญ่",
            "name_en": "Bua Yai",
            "district_id": 4007,
            "lat": 16.632,
            "long": 102.951,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 400705,
            "zip_code": 40310,
            "name_th": "สะอาด",
            "name_en": "Sa-at",
            "district_id": 4007,
            "lat": 16.788,
            "long": 102.768,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 400706,
            "zip_code": 40310,
            "name_th": "ม่วงหวาน",
            "name_en": "Muang Wan",
            "district_id": 4007,
            "lat": 16.646,
            "long": 102.779,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 400707,
            "zip_code": 40140,
            "name_th": "บ้านขาม",
            "name_en": "Ban Kham",
            "district_id": 4007,
            "lat": 16.568,
            "long": 102.952,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 400708,
            "zip_code": 40140,
            "name_th": "บัวเงิน",
            "name_en": "Bua Ngoen",
            "district_id": 4007,
            "lat": 16.793,
            "long": 102.995,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 400709,
            "zip_code": 40140,
            "name_th": "ทรายมูล",
            "name_en": "Sai Mun",
            "district_id": 4007,
            "lat": 16.669,
            "long": 102.913,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 400710,
            "zip_code": 40140,
            "name_th": "ท่ากระเสริม",
            "name_en": "Tha Krasoem",
            "district_id": 4007,
            "lat": 16.613,
            "long": 102.878,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 400711,
            "zip_code": 40140,
            "name_th": "พังทุย",
            "name_en": "Phang Thui",
            "district_id": 4007,
            "lat": 16.774,
            "long": 102.928,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 400712,
            "zip_code": 40140,
            "name_th": "กุดน้ำใส",
            "name_en": "Kut Nam Sai",
            "district_id": 4007,
            "lat": 16.697,
            "long": 102.789,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 4008,
        "name_th": "อุบลรัตน์",
        "name_en": "Ubolratana",
        "province_id": 28,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 400801,
            "zip_code": 40250,
            "name_th": "โคกสูง",
            "name_en": "Khok Sung",
            "district_id": 4008,
            "lat": 16.679,
            "long": 102.676,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 400802,
            "zip_code": 40250,
            "name_th": "บ้านดง",
            "name_en": "Ban Dong",
            "district_id": 4008,
            "lat": 16.801,
            "long": 102.645,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 400803,
            "zip_code": 40250,
            "name_th": "เขื่อนอุบลรัตน์",
            "name_en": "Khuean Ubolratana",
            "district_id": 4008,
            "lat": 16.715,
            "long": 102.636,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 400804,
            "zip_code": 40250,
            "name_th": "นาคำ",
            "name_en": "Na Kham",
            "district_id": 4008,
            "lat": 16.855,
            "long": 102.68,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 400805,
            "zip_code": 40250,
            "name_th": "ศรีสุขสำราญ",
            "name_en": "Si Suk Samran",
            "district_id": 4008,
            "lat": 16.92,
            "long": 102.703,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 400806,
            "zip_code": 40250,
            "name_th": "ทุ่งโป่ง",
            "name_en": "Thung Pong",
            "district_id": 4008,
            "lat": 16.731,
            "long": 102.676,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 4009,
        "name_th": "กระนวน",
        "name_en": "Kranuan",
        "province_id": 28,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 400901,
            "zip_code": 40170,
            "name_th": "หนองโก",
            "name_en": "Nong Ko",
            "district_id": 4009,
            "lat": 16.727,
            "long": 103.11,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 400902,
            "zip_code": 40170,
            "name_th": "หนองกุงใหญ่",
            "name_en": "Nong Kung Yai",
            "district_id": 4009,
            "lat": 16.646,
            "long": 103.086,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 400905,
            "zip_code": 40170,
            "name_th": "ห้วยโจด",
            "name_en": "Huai Chot",
            "district_id": 4009,
            "lat": 16.667,
            "long": 103.022,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 400906,
            "zip_code": 40170,
            "name_th": "ห้วยยาง",
            "name_en": "Huai Yang",
            "district_id": 4009,
            "lat": 16.87,
            "long": 103.085,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 400907,
            "zip_code": 40170,
            "name_th": "บ้านฝาง",
            "name_en": "Ban Fang",
            "district_id": 4009,
            "lat": 16.769,
            "long": 103.05,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 400909,
            "zip_code": 40170,
            "name_th": "ดูนสาด",
            "name_en": "Dun Sat",
            "district_id": 4009,
            "lat": 16.81,
            "long": 103.149,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 400910,
            "zip_code": 40170,
            "name_th": "หนองโน",
            "name_en": "Nong No",
            "district_id": 4009,
            "lat": 16.722,
            "long": 103.03,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 400911,
            "zip_code": 40170,
            "name_th": "น้ำอ้อม",
            "name_en": "Nam Om",
            "district_id": 4009,
            "lat": 16.671,
            "long": 103.127,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 400912,
            "zip_code": 40170,
            "name_th": "หัวนาคำ",
            "name_en": "Hua Na Kham",
            "district_id": 4009,
            "lat": 16.813,
            "long": 103.08,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 4010,
        "name_th": "บ้านไผ่",
        "name_en": "Ban Phai",
        "province_id": 28,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 401001,
            "zip_code": 40110,
            "name_th": "บ้านไผ่",
            "name_en": "Ban Phai",
            "district_id": 4010,
            "lat": 16.063,
            "long": 102.728,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 401002,
            "zip_code": 40110,
            "name_th": "ในเมือง",
            "name_en": "Nai Mueang",
            "district_id": 4010,
            "lat": 16.035,
            "long": 102.723,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 401005,
            "zip_code": 40110,
            "name_th": "เมืองเพีย",
            "name_en": "Mueang Phia",
            "district_id": 4010,
            "lat": 16.102,
            "long": 102.684,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 401009,
            "zip_code": 40110,
            "name_th": "บ้านลาน",
            "name_en": "Ban Lan",
            "district_id": 4010,
            "lat": 15.992,
            "long": 102.838,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 401010,
            "zip_code": 40110,
            "name_th": "แคนเหนือ",
            "name_en": "Khaen Nuea",
            "district_id": 4010,
            "lat": 15.99,
            "long": 102.771,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 401011,
            "zip_code": 40110,
            "name_th": "ภูเหล็ก",
            "name_en": "Phu Lek",
            "district_id": 4010,
            "lat": 16.115,
            "long": 102.828,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 401013,
            "zip_code": 40110,
            "name_th": "ป่าปอ",
            "name_en": "Pa Po",
            "district_id": 4010,
            "lat": 15.919,
            "long": 102.777,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 401014,
            "zip_code": 40110,
            "name_th": "หินตั้ง",
            "name_en": "Hin Tang",
            "district_id": 4010,
            "lat": 16.045,
            "long": 102.831,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 401016,
            "zip_code": 40110,
            "name_th": "หนองน้ำใส",
            "name_en": "Nong Nam Sai",
            "district_id": 4010,
            "lat": 16.042,
            "long": 102.76,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 401017,
            "zip_code": 40110,
            "name_th": "หัวหนอง",
            "name_en": "Hua Nong",
            "district_id": 4010,
            "lat": 16.04,
            "long": 102.697,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 4011,
        "name_th": "เปือยน้อย",
        "name_en": "Pueai Noi",
        "province_id": 28,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 401101,
            "zip_code": 40340,
            "name_th": "เปือยน้อย",
            "name_en": "Pueai Noi",
            "district_id": 4011,
            "lat": 15.879,
            "long": 102.904,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 401102,
            "zip_code": 40340,
            "name_th": "วังม่วง",
            "name_en": "Wang Muang",
            "district_id": 4011,
            "lat": 15.884,
            "long": 102.829,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 401103,
            "zip_code": 40340,
            "name_th": "ขามป้อม",
            "name_en": "Kham Pom",
            "district_id": 4011,
            "lat": 15.938,
            "long": 102.874,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 401104,
            "zip_code": 40340,
            "name_th": "สระแก้ว",
            "name_en": "Sa Kaeo",
            "district_id": 4011,
            "lat": 15.85,
            "long": 102.895,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 4012,
        "name_th": "พล",
        "name_en": "Phon",
        "province_id": 28,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 401201,
            "zip_code": 40120,
            "name_th": "เมืองพล",
            "name_en": "Mueang Phon",
            "district_id": 4012,
            "lat": 15.793,
            "long": 102.64,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 401203,
            "zip_code": 40120,
            "name_th": "โจดหนองแก",
            "name_en": "Chot Nong Kae",
            "district_id": 4012,
            "lat": 15.856,
            "long": 102.65,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 401204,
            "zip_code": 40120,
            "name_th": "เก่างิ้ว",
            "name_en": "Kao Ngio",
            "district_id": 4012,
            "lat": 15.844,
            "long": 102.598,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 401205,
            "zip_code": 40120,
            "name_th": "หนองมะเขือ",
            "name_en": "Nong Makhuea",
            "district_id": 4012,
            "lat": 15.753,
            "long": 102.546,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 401206,
            "zip_code": 40120,
            "name_th": "หนองแวงโสกพระ",
            "name_en": "Nong Waeng Sok Phra",
            "district_id": 4012,
            "lat": 15.746,
            "long": 102.644,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 401207,
            "zip_code": 40120,
            "name_th": "เพ็กใหญ่",
            "name_en": "Phek Yai",
            "district_id": 4012,
            "lat": 15.841,
            "long": 102.538,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 401208,
            "zip_code": 40120,
            "name_th": "โคกสง่า",
            "name_en": "Khok Sa-nga",
            "district_id": 4012,
            "lat": 15.754,
            "long": 102.488,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 401209,
            "zip_code": 40120,
            "name_th": "หนองแวงนางเบ้า",
            "name_en": "Nong Waeng Nang Bao",
            "district_id": 4012,
            "lat": 15.887,
            "long": 102.611,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 401210,
            "zip_code": 40120,
            "name_th": "ลอมคอม",
            "name_en": "Lom Khom",
            "district_id": 4012,
            "lat": 15.794,
            "long": 102.525,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 401211,
            "zip_code": 40120,
            "name_th": "โนนข่า",
            "name_en": "Non Kha",
            "district_id": 4012,
            "lat": 15.764,
            "long": 102.591,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 401212,
            "zip_code": 40120,
            "name_th": "โสกนกเต็น",
            "name_en": "Sok Nok Ten",
            "district_id": 4012,
            "lat": 15.816,
            "long": 102.66,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 401213,
            "zip_code": 40120,
            "name_th": "หัวทุ่ง",
            "name_en": "Hua Thung",
            "district_id": 4012,
            "lat": 15.879,
            "long": 102.556,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 4013,
        "name_th": "แวงใหญ่",
        "name_en": "Waeng Yai",
        "province_id": 28,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 401301,
            "zip_code": 40330,
            "name_th": "คอนฉิม",
            "name_en": "Khon Chim",
            "district_id": 4013,
            "lat": 15.947,
            "long": 102.486,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 401302,
            "zip_code": 40330,
            "name_th": "ใหม่นาเพียง",
            "name_en": "Mai Na Phiang",
            "district_id": 4013,
            "lat": 15.906,
            "long": 102.471,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 401303,
            "zip_code": 40330,
            "name_th": "โนนทอง",
            "name_en": "Non Thong",
            "district_id": 4013,
            "lat": 15.904,
            "long": 102.401,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 401304,
            "zip_code": 40330,
            "name_th": "แวงใหญ่",
            "name_en": "Waeng Yai",
            "district_id": 4013,
            "lat": 15.954,
            "long": 102.533,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 401305,
            "zip_code": 40330,
            "name_th": "โนนสะอาด",
            "name_en": "Non Sa-at",
            "district_id": 4013,
            "lat": 15.954,
            "long": 102.421,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 4014,
        "name_th": "แวงน้อย",
        "name_en": "Waeng Noi",
        "province_id": 28,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 401401,
            "zip_code": 40230,
            "name_th": "แวงน้อย",
            "name_en": "Waeng Noi",
            "district_id": 4014,
            "lat": 15.813,
            "long": 102.423,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 401402,
            "zip_code": 40230,
            "name_th": "ก้านเหลือง",
            "name_en": "Kan Lueang",
            "district_id": 4014,
            "lat": 15.844,
            "long": 102.464,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 401403,
            "zip_code": 40230,
            "name_th": "ท่านางแนว",
            "name_en": "Tha Nang Naeo",
            "district_id": 4014,
            "lat": 15.866,
            "long": 102.372,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 401404,
            "zip_code": 40230,
            "name_th": "ละหานนา",
            "name_en": "Lahan Na",
            "district_id": 4014,
            "lat": 15.813,
            "long": 102.367,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 401405,
            "zip_code": 40230,
            "name_th": "ท่าวัด",
            "name_en": "Tha Wat",
            "district_id": 4014,
            "lat": 15.735,
            "long": 102.397,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 401406,
            "zip_code": 40230,
            "name_th": "ทางขวาง",
            "name_en": "Thang Khwang",
            "district_id": 4014,
            "lat": 15.758,
            "long": 102.429,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 4015,
        "name_th": "หนองสองห้อง",
        "name_en": "Nong Song Hong",
        "province_id": 28,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 401501,
            "zip_code": 40190,
            "name_th": "หนองสองห้อง",
            "name_en": "Nong Song Hong",
            "district_id": 4015,
            "lat": 15.707,
            "long": 102.771,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 401502,
            "zip_code": 40190,
            "name_th": "คึมชาด",
            "name_en": "Khuemchat",
            "district_id": 4015,
            "lat": 15.818,
            "long": 102.802,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 401503,
            "zip_code": 40190,
            "name_th": "โนนธาตุ",
            "name_en": "Non That",
            "district_id": 4015,
            "lat": 15.705,
            "long": 102.72,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 401504,
            "zip_code": 40190,
            "name_th": "ตะกั่วป่า",
            "name_en": "Takua Pa",
            "district_id": 4015,
            "lat": 15.714,
            "long": 102.824,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 401505,
            "zip_code": 40190,
            "name_th": "สำโรง",
            "name_en": "Samrong",
            "district_id": 4015,
            "lat": 15.833,
            "long": 102.744,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 401506,
            "zip_code": 40190,
            "name_th": "หนองเม็ก",
            "name_en": "Nong Mek",
            "district_id": 4015,
            "lat": 15.787,
            "long": 102.724,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 401507,
            "zip_code": 40190,
            "name_th": "ดอนดู่",
            "name_en": "Don Du",
            "district_id": 4015,
            "lat": 15.809,
            "long": 102.874,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 401508,
            "zip_code": 40190,
            "name_th": "ดงเค็ง",
            "name_en": "Dong Kheng",
            "district_id": 4015,
            "lat": 15.67,
            "long": 102.812,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 401509,
            "zip_code": 40190,
            "name_th": "หันโจด",
            "name_en": "Han Chot",
            "district_id": 4015,
            "lat": 15.758,
            "long": 102.695,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 401510,
            "zip_code": 40190,
            "name_th": "ดอนดั่ง",
            "name_en": "Don Dang",
            "district_id": 4015,
            "lat": 15.77,
            "long": 102.788,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 401511,
            "zip_code": 40190,
            "name_th": "วังหิน",
            "name_en": "Wang Hin",
            "district_id": 4015,
            "lat": 15.873,
            "long": 102.742,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 401512,
            "zip_code": 40190,
            "name_th": "หนองไผ่ล้อม",
            "name_en": "Nong Phai Lom",
            "district_id": 4015,
            "lat": 15.752,
            "long": 102.841,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 4016,
        "name_th": "ภูเวียง",
        "name_en": "Phu Wiang",
        "province_id": 28,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 401601,
            "zip_code": 40150,
            "name_th": "บ้านเรือ",
            "name_en": "Ban Ruea",
            "district_id": 4016,
            "lat": 16.676,
            "long": 102.395,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 401604,
            "zip_code": 40150,
            "name_th": "หว้าทอง",
            "name_en": "Wa Thong",
            "district_id": 4016,
            "lat": 16.761,
            "long": 102.469,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 401605,
            "zip_code": 40150,
            "name_th": "กุดขอนแก่น",
            "name_en": "Kut Khon Kaen",
            "district_id": 4016,
            "lat": 16.58,
            "long": 102.502,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 401606,
            "zip_code": 40150,
            "name_th": "นาชุมแสง",
            "name_en": "Na Chum Saeng",
            "district_id": 4016,
            "lat": 16.602,
            "long": 102.331,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 401607,
            "zip_code": 40150,
            "name_th": "นาหว้า",
            "name_en": "Na Wa",
            "district_id": 4016,
            "lat": 16.721,
            "long": 102.572,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 401610,
            "zip_code": 40150,
            "name_th": "หนองกุงธนสาร",
            "name_en": "Nong Kung Thanasan",
            "district_id": 4016,
            "lat": 16.65,
            "long": 102.437,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 401612,
            "zip_code": 40150,
            "name_th": "หนองกุงเซิน",
            "name_en": "Nong Kung Soen",
            "district_id": 4016,
            "lat": 16.633,
            "long": 102.518,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 401613,
            "zip_code": 40150,
            "name_th": "สงเปือย",
            "name_en": "Song Pueai",
            "district_id": 4016,
            "lat": 16.605,
            "long": 102.394,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 401614,
            "zip_code": 40150,
            "name_th": "ทุ่งชมพู",
            "name_en": "Thung Chomphu",
            "district_id": 4016,
            "lat": 16.762,
            "long": 102.524,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 401616,
            "zip_code": 40150,
            "name_th": "ดินดำ",
            "name_en": "Din Dam",
            "district_id": 4016,
            "lat": 16.722,
            "long": 102.398,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 401617,
            "zip_code": 40150,
            "name_th": "ภูเวียง",
            "name_en": "Phu Wiang",
            "district_id": 4016,
            "lat": 16.679,
            "long": 102.364,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 4017,
        "name_th": "มัญจาคีรี",
        "name_en": "Mancha Khiri",
        "province_id": 28,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 401701,
            "zip_code": 40160,
            "name_th": "กุดเค้า",
            "name_en": "Kut Khao",
            "district_id": 4017,
            "lat": 16.114,
            "long": 102.492,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 401702,
            "zip_code": 40160,
            "name_th": "สวนหม่อน",
            "name_en": "Suan Mon",
            "district_id": 4017,
            "lat": 16.165,
            "long": 102.561,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 401703,
            "zip_code": 40160,
            "name_th": "หนองแปน",
            "name_en": "Nong Paen",
            "district_id": 4017,
            "lat": 16.178,
            "long": 102.629,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 401704,
            "zip_code": 40160,
            "name_th": "โพนเพ็ก",
            "name_en": "Phon Phek",
            "district_id": 4017,
            "lat": 16.237,
            "long": 102.534,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 401705,
            "zip_code": 40160,
            "name_th": "คำแคน",
            "name_en": "Kham Khaen",
            "district_id": 4017,
            "lat": 16.323,
            "long": 102.476,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 401706,
            "zip_code": 40160,
            "name_th": "นาข่า",
            "name_en": "Na Kha",
            "district_id": 4017,
            "lat": 16.183,
            "long": 102.5,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 401707,
            "zip_code": 40160,
            "name_th": "นางาม",
            "name_en": "Na Ngam",
            "district_id": 4017,
            "lat": 16.196,
            "long": 102.419,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 401710,
            "zip_code": 40160,
            "name_th": "ท่าศาลา",
            "name_en": "Tha Sala",
            "district_id": 4017,
            "lat": 16.269,
            "long": 102.615,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 4018,
        "name_th": "ชนบท",
        "name_en": "Chonnabot",
        "province_id": 28,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 401801,
            "zip_code": 40180,
            "name_th": "ชนบท",
            "name_en": "Chonnabot",
            "district_id": 4018,
            "lat": 16.067,
            "long": 102.632,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 401802,
            "zip_code": 40180,
            "name_th": "กุดเพียขอม",
            "name_en": "Kut Phia Khom",
            "district_id": 4018,
            "lat": 16.032,
            "long": 102.613,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 401803,
            "zip_code": 40180,
            "name_th": "วังแสง",
            "name_en": "Wang Saeng",
            "district_id": 4018,
            "lat": 16.013,
            "long": 102.482,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 401804,
            "zip_code": 40180,
            "name_th": "ห้วยแก",
            "name_en": "Huai Kae",
            "district_id": 4018,
            "lat": 15.993,
            "long": 102.531,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 401805,
            "zip_code": 40180,
            "name_th": "บ้านแท่น",
            "name_en": "Ban Thaen",
            "district_id": 4018,
            "lat": 15.966,
            "long": 102.603,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 401806,
            "zip_code": 40180,
            "name_th": "ศรีบุญเรือง",
            "name_en": "Si Bun Rueang",
            "district_id": 4018,
            "lat": 16.115,
            "long": 102.623,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 401807,
            "zip_code": 40180,
            "name_th": "โนนพะยอม",
            "name_en": "Non Phayom",
            "district_id": 4018,
            "lat": 16.054,
            "long": 102.547,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 401808,
            "zip_code": 40180,
            "name_th": "ปอแดง",
            "name_en": "Po Daeng",
            "district_id": 4018,
            "lat": 15.95,
            "long": 102.579,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 4019,
        "name_th": "เขาสวนกวาง",
        "name_en": "Khao Suan Kwang",
        "province_id": 28,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 401901,
            "zip_code": 40280,
            "name_th": "เขาสวนกวาง",
            "name_en": "Khao Suan Kwang",
            "district_id": 4019,
            "lat": 16.861,
            "long": 102.84,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 401902,
            "zip_code": 40280,
            "name_th": "ดงเมืองแอม",
            "name_en": "Dong Mueang Aem",
            "district_id": 4019,
            "lat": 16.862,
            "long": 102.767,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 401903,
            "zip_code": 40280,
            "name_th": "นางิ้ว",
            "name_en": "Na Ngio",
            "district_id": 4019,
            "lat": 16.932,
            "long": 102.784,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 401904,
            "zip_code": 40280,
            "name_th": "โนนสมบูรณ์",
            "name_en": "Non Sombun",
            "district_id": 4019,
            "lat": 17.025,
            "long": 102.709,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 401905,
            "zip_code": 40280,
            "name_th": "คำม่วง",
            "name_en": "Kham Muang",
            "district_id": 4019,
            "lat": 16.819,
            "long": 102.867,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 4020,
        "name_th": "ภูผาม่าน",
        "name_en": "Phu Pha Man",
        "province_id": 28,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 402001,
            "zip_code": 40350,
            "name_th": "โนนคอม",
            "name_en": "Non Khom",
            "district_id": 4020,
            "lat": 16.648,
            "long": 101.935,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 402002,
            "zip_code": 40350,
            "name_th": "นาฝาย",
            "name_en": "Na Fai",
            "district_id": 4020,
            "lat": 16.68,
            "long": 101.871,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 402003,
            "zip_code": 40350,
            "name_th": "ภูผาม่าน",
            "name_en": "Phu Pha Man",
            "district_id": 4020,
            "lat": 16.677,
            "long": 101.91,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 402004,
            "zip_code": 40350,
            "name_th": "วังสวาบ",
            "name_en": "Wang Sawap",
            "district_id": 4020,
            "lat": 16.714,
            "long": 101.817,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 402005,
            "zip_code": 40350,
            "name_th": "ห้วยม่วง",
            "name_en": "Huai Muang",
            "district_id": 4020,
            "lat": 16.765,
            "long": 101.909,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 4021,
        "name_th": "ซำสูง",
        "name_en": "Sam Sung",
        "province_id": 28,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 402101,
            "zip_code": 40170,
            "name_th": "กระนวน",
            "name_en": "Kranuan",
            "district_id": 4021,
            "lat": 16.534,
            "long": 103.069,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 402102,
            "zip_code": 40170,
            "name_th": "คำแมด",
            "name_en": "Kham Maet",
            "district_id": 4021,
            "lat": 16.616,
            "long": 103.122,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 402103,
            "zip_code": 40170,
            "name_th": "บ้านโนน",
            "name_en": "Ban Non",
            "district_id": 4021,
            "lat": 16.56,
            "long": 103.027,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 402104,
            "zip_code": 40170,
            "name_th": "คูคำ",
            "name_en": "Khu Kham",
            "district_id": 4021,
            "lat": 16.508,
            "long": 103.014,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 402105,
            "zip_code": 40170,
            "name_th": "ห้วยเตย",
            "name_en": "Huai Toei",
            "district_id": 4021,
            "lat": 16.582,
            "long": 103.089,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 4022,
        "name_th": "โคกโพธิ์ไชย",
        "name_en": "Khok Pho Chai",
        "province_id": 28,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 402201,
            "zip_code": 40160,
            "name_th": "บ้านโคก",
            "name_en": "Ban Khok",
            "district_id": 4022,
            "lat": 16.112,
            "long": 102.378,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 402202,
            "zip_code": 40160,
            "name_th": "โพธิ์ไชย",
            "name_en": "Pho Chai",
            "district_id": 4022,
            "lat": 16.027,
            "long": 102.399,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 402203,
            "zip_code": 40160,
            "name_th": "ซับสมบูรณ์",
            "name_en": "Sap Sombun",
            "district_id": 4022,
            "lat": 16.074,
            "long": 102.329,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 402204,
            "zip_code": 40160,
            "name_th": "นาแพง",
            "name_en": "Na Phaeng",
            "district_id": 4022,
            "lat": 16.078,
            "long": 102.472,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 4023,
        "name_th": "หนองนาคำ",
        "name_en": "Nong Na Kham",
        "province_id": 28,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 402301,
            "zip_code": 40150,
            "name_th": "กุดธาตุ",
            "name_en": "Kut That",
            "district_id": 4023,
            "lat": 16.834,
            "long": 102.308,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 402302,
            "zip_code": 40150,
            "name_th": "บ้านโคก",
            "name_en": "Ban Khok",
            "district_id": 4023,
            "lat": 16.791,
            "long": 102.335,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 402303,
            "zip_code": 40150,
            "name_th": "ขนวน",
            "name_en": "Khanuan",
            "district_id": 4023,
            "lat": 16.774,
            "long": 102.387,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 4024,
        "name_th": "บ้านแฮด",
        "name_en": "Ban Haet",
        "province_id": 28,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 402401,
            "zip_code": 40110,
            "name_th": "บ้านแฮด",
            "name_en": "Ban Haet",
            "district_id": 4024,
            "lat": 16.211,
            "long": 102.778,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 402402,
            "zip_code": 40110,
            "name_th": "โคกสำราญ",
            "name_en": "Khok Samran",
            "district_id": 4024,
            "lat": 16.19,
            "long": 102.71,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 402403,
            "zip_code": 40110,
            "name_th": "โนนสมบูรณ์",
            "name_en": "Non Sombun",
            "district_id": 4024,
            "lat": 16.259,
            "long": 102.788,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 402404,
            "zip_code": 40110,
            "name_th": "หนองแซง",
            "name_en": "Nong Saeng",
            "district_id": 4024,
            "lat": 16.175,
            "long": 102.809,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 4025,
        "name_th": "โนนศิลา",
        "name_en": "Non Sila",
        "province_id": 28,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 402501,
            "zip_code": 40110,
            "name_th": "โนนศิลา",
            "name_en": "Non Sila",
            "district_id": 4025,
            "lat": 15.94,
            "long": 102.664,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 402502,
            "zip_code": 40110,
            "name_th": "หนองปลาหมอ",
            "name_en": "Nong Pla Mo",
            "district_id": 4025,
            "lat": 15.989,
            "long": 102.635,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 402503,
            "zip_code": 40110,
            "name_th": "บ้านหัน",
            "name_en": "Ban Han",
            "district_id": 4025,
            "lat": 15.94,
            "long": 102.72,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 402504,
            "zip_code": 40110,
            "name_th": "เปือยใหญ่",
            "name_en": "Pueai Yai",
            "district_id": 4025,
            "lat": 16.027,
            "long": 102.651,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 402505,
            "zip_code": 40110,
            "name_th": "โนนแดง",
            "name_en": "Non Daeng",
            "district_id": 4025,
            "lat": 16.005,
            "long": 102.687,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 4029,
        "name_th": "เวียงเก่า",
        "name_en": "Wiang Kao",
        "province_id": 28,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 402901,
            "zip_code": 40150,
            "name_th": "ในเมือง",
            "name_en": "Nai Mueang",
            "district_id": 4029,
            "lat": 16.742,
            "long": 102.259,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 402902,
            "zip_code": 40150,
            "name_th": "เมืองเก่าพัฒนา",
            "name_en": "Mueang Kao Phatthana",
            "district_id": 4029,
            "lat": 16.625,
            "long": 102.206,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 402903,
            "zip_code": 40150,
            "name_th": "เขาน้อย",
            "name_en": "Khao Noi",
            "district_id": 4029,
            "lat": 16.723,
            "long": 102.33,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      }
    ]
  },
  {
    "id": 29,
    "name_th": "อุดรธานี",
    "name_en": "Udon Thani",
    "geography_id": 3,
    "created_at": "2019-08-09T03:33:09.000+07:00",
    "updated_at": "2025-09-20T06:31:26.000+07:00",
    "deleted_at": null,
    "districts": [
      {
        "id": 4101,
        "name_th": "เมืองอุดรธานี",
        "name_en": "Mueang Udon Thani",
        "province_id": 29,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 410101,
            "zip_code": 41000,
            "name_th": "หมากแข้ง",
            "name_en": "Mak Khaeng",
            "district_id": 4101,
            "lat": 17.411,
            "long": 102.792,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 410102,
            "zip_code": 41000,
            "name_th": "นิคมสงเคราะห์",
            "name_en": "Nikhom Songkhro",
            "district_id": 4101,
            "lat": 17.365,
            "long": 102.688,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 410103,
            "zip_code": 41000,
            "name_th": "บ้านขาว",
            "name_en": "Ban Khao",
            "district_id": 4101,
            "lat": 17.545,
            "long": 102.775,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 410104,
            "zip_code": 41000,
            "name_th": "หนองบัว",
            "name_en": "Nong Bua",
            "district_id": 4101,
            "lat": 17.406,
            "long": 102.822,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 410105,
            "zip_code": 41000,
            "name_th": "บ้านตาด",
            "name_en": "Ban Tat",
            "district_id": 4101,
            "lat": 17.292,
            "long": 102.762,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 410106,
            "zip_code": 41330,
            "name_th": "โนนสูง",
            "name_en": "Non Sung",
            "district_id": 4101,
            "lat": 17.287,
            "long": 102.846,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 410107,
            "zip_code": 41000,
            "name_th": "หมูม่น",
            "name_en": "Mu Mon",
            "district_id": 4101,
            "lat": 17.469,
            "long": 102.771,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 410108,
            "zip_code": 41000,
            "name_th": "เชียงยืน",
            "name_en": "Chiang Yuen",
            "district_id": 4101,
            "lat": 17.431,
            "long": 102.651,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 410109,
            "zip_code": 41000,
            "name_th": "หนองนาคำ",
            "name_en": "Nong Na Kham",
            "district_id": 4101,
            "lat": 17.367,
            "long": 102.896,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 410110,
            "zip_code": 41000,
            "name_th": "กุดสระ",
            "name_en": "Kut Sa",
            "district_id": 4101,
            "lat": 17.491,
            "long": 102.839,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 410111,
            "zip_code": 41000,
            "name_th": "นาดี",
            "name_en": "Na Di",
            "district_id": 4101,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 410112,
            "zip_code": 41000,
            "name_th": "บ้านเลื่อม",
            "name_en": "Ban Lueam",
            "district_id": 4101,
            "lat": 17.421,
            "long": 102.764,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 410113,
            "zip_code": 41000,
            "name_th": "เชียงพิณ",
            "name_en": "Chiang Phin",
            "district_id": 4101,
            "lat": 17.417,
            "long": 102.699,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 410114,
            "zip_code": 41000,
            "name_th": "สามพร้าว",
            "name_en": "Sam Phrao",
            "district_id": 4101,
            "lat": 17.456,
            "long": 102.886,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 410115,
            "zip_code": 41000,
            "name_th": "หนองไฮ",
            "name_en": "Nong Hai",
            "district_id": 4101,
            "lat": 17.271,
            "long": 102.697,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 410116,
            "zip_code": 41000,
            "name_th": "นาข่า",
            "name_en": "Na Kha",
            "district_id": 4101,
            "lat": 17.54,
            "long": 102.849,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 410117,
            "zip_code": 41000,
            "name_th": "บ้านจั่น",
            "name_en": "Ban Chan",
            "district_id": 4101,
            "lat": 17.343,
            "long": 102.779,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 410118,
            "zip_code": 41000,
            "name_th": "หนองขอนกว้าง",
            "name_en": "Nong Khon Kwang",
            "district_id": 4101,
            "lat": 17.376,
            "long": 102.816,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 410119,
            "zip_code": 41000,
            "name_th": "โคกสะอาด",
            "name_en": "Khok Sa-at",
            "district_id": 4101,
            "lat": 17.356,
            "long": 102.638,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 410120,
            "zip_code": 41000,
            "name_th": "นากว้าง",
            "name_en": "Na Kwang",
            "district_id": 4101,
            "lat": 17.533,
            "long": 102.701,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 410121,
            "zip_code": 41330,
            "name_th": "หนองไผ่",
            "name_en": "Nong Phai",
            "district_id": 4101,
            "lat": 17.256,
            "long": 102.898,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 4102,
        "name_th": "กุดจับ",
        "name_en": "Kut Chap",
        "province_id": 29,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 410201,
            "zip_code": 41250,
            "name_th": "กุดจับ",
            "name_en": "Kut Chap",
            "district_id": 4102,
            "lat": 17.382,
            "long": 102.515,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 410202,
            "zip_code": 41250,
            "name_th": "ปะโค",
            "name_en": "Pakho",
            "district_id": 4102,
            "lat": 17.48,
            "long": 102.596,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 410203,
            "zip_code": 41250,
            "name_th": "ขอนยูง",
            "name_en": "Khon Yung",
            "district_id": 4102,
            "lat": 17.385,
            "long": 102.46,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 410204,
            "zip_code": 41250,
            "name_th": "เชียงเพ็ง",
            "name_en": "Chiang Pheng",
            "district_id": 4102,
            "lat": 17.49,
            "long": 102.652,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 410205,
            "zip_code": 41250,
            "name_th": "สร้างก่อ",
            "name_en": "Sang Ko",
            "district_id": 4102,
            "lat": 17.479,
            "long": 102.506,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 410206,
            "zip_code": 41250,
            "name_th": "เมืองเพีย",
            "name_en": "Mueang Phia",
            "district_id": 4102,
            "lat": 17.411,
            "long": 102.574,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 410207,
            "zip_code": 41250,
            "name_th": "ตาลเลียน",
            "name_en": "Tan Lian",
            "district_id": 4102,
            "lat": 17.44,
            "long": 102.429,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 4103,
        "name_th": "หนองวัวซอ",
        "name_en": "Nong Wua So",
        "province_id": 29,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 410301,
            "zip_code": 41360,
            "name_th": "หมากหญ้า",
            "name_en": "Mak Ya",
            "district_id": 4103,
            "lat": 17.238,
            "long": 102.628,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 410302,
            "zip_code": 41220,
            "name_th": "หนองอ้อ",
            "name_en": "Nong O",
            "district_id": 4103,
            "lat": 17.187,
            "long": 102.541,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 410303,
            "zip_code": 41220,
            "name_th": "อูบมุง",
            "name_en": "Up Mung",
            "district_id": 4103,
            "lat": 17.087,
            "long": 102.564,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 410304,
            "zip_code": 41220,
            "name_th": "กุดหมากไฟ",
            "name_en": "Kut Mak Fai",
            "district_id": 4103,
            "lat": 17.057,
            "long": 102.645,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 410305,
            "zip_code": 41360,
            "name_th": "น้ำพ่น",
            "name_en": "Nam Phon",
            "district_id": 4103,
            "lat": 17.309,
            "long": 102.473,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 410306,
            "zip_code": 41360,
            "name_th": "หนองบัวบาน",
            "name_en": "Nong Bua Ban",
            "district_id": 4103,
            "lat": 17.288,
            "long": 102.645,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 410307,
            "zip_code": 41220,
            "name_th": "โนนหวาย",
            "name_en": "Non Wai",
            "district_id": 4103,
            "lat": 17.142,
            "long": 102.601,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 410308,
            "zip_code": 41360,
            "name_th": "หนองวัวซอ",
            "name_en": "Nong Wua So",
            "district_id": 4103,
            "lat": 17.288,
            "long": 102.576,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 4104,
        "name_th": "กุมภวาปี",
        "name_en": "Kumphawapi",
        "province_id": 29,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 410401,
            "zip_code": 41110,
            "name_th": "ตูมใต้",
            "name_en": "Tum Tai",
            "district_id": 4104,
            "lat": 17.084,
            "long": 102.963,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 410402,
            "zip_code": 41370,
            "name_th": "พันดอน",
            "name_en": "Phan Don",
            "district_id": 4104,
            "lat": 17.137,
            "long": 102.938,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 410403,
            "zip_code": 41110,
            "name_th": "เวียงคำ",
            "name_en": "Wiang Kham",
            "district_id": 4104,
            "lat": 17.097,
            "long": 103.116,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 410404,
            "zip_code": 41110,
            "name_th": "แชแล",
            "name_en": "Chaelae",
            "district_id": 4104,
            "lat": 17.153,
            "long": 103.075,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 410406,
            "zip_code": 41110,
            "name_th": "เชียงแหว",
            "name_en": "Chiang Wae",
            "district_id": 4104,
            "lat": 17.198,
            "long": 103.026,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 410407,
            "zip_code": 41110,
            "name_th": "ห้วยเกิ้ง",
            "name_en": "Huai Koeng",
            "district_id": 4104,
            "lat": 17.044,
            "long": 102.934,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 410409,
            "zip_code": 41370,
            "name_th": "เสอเพลอ",
            "name_en": "Soephloe",
            "district_id": 4104,
            "lat": 17.202,
            "long": 102.874,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 410410,
            "zip_code": 41110,
            "name_th": "สีออ",
            "name_en": "Si O",
            "district_id": 4104,
            "lat": 16.995,
            "long": 103.038,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 410411,
            "zip_code": 41370,
            "name_th": "ปะโค",
            "name_en": "Pa Kho",
            "district_id": 4104,
            "lat": 17.056,
            "long": 102.896,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 410413,
            "zip_code": 41370,
            "name_th": "ผาสุก",
            "name_en": "Phasuk",
            "district_id": 4104,
            "lat": 17.169,
            "long": 102.94,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 410414,
            "zip_code": 41110,
            "name_th": "ท่าลี่",
            "name_en": "Tha Li",
            "district_id": 4104,
            "lat": 16.933,
            "long": 103.064,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 410415,
            "zip_code": 41110,
            "name_th": "กุมภวาปี",
            "name_en": "Kumphawapi",
            "district_id": 4104,
            "lat": 17.112,
            "long": 103.009,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 410416,
            "zip_code": 41110,
            "name_th": "หนองหว้า",
            "name_en": "Nong Wa",
            "district_id": 4104,
            "lat": 17.033,
            "long": 102.981,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 4105,
        "name_th": "โนนสะอาด",
        "name_en": "Non Sa-at",
        "province_id": 29,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 410501,
            "zip_code": 41240,
            "name_th": "โนนสะอาด",
            "name_en": "Non Sa-at",
            "district_id": 4105,
            "lat": 16.977,
            "long": 102.902,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 410502,
            "zip_code": 41240,
            "name_th": "บุ่งแก้ว",
            "name_en": "Bung Kaeo",
            "district_id": 4105,
            "lat": 16.969,
            "long": 102.981,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 410503,
            "zip_code": 41240,
            "name_th": "โพธิ์ศรีสำราญ",
            "name_en": "Pho Si Samran",
            "district_id": 4105,
            "lat": 16.983,
            "long": 102.839,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 410504,
            "zip_code": 41240,
            "name_th": "ทมนางาม",
            "name_en": "Thom Na Ngam",
            "district_id": 4105,
            "lat": 16.888,
            "long": 102.956,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 410505,
            "zip_code": 41240,
            "name_th": "หนองกุงศรี",
            "name_en": "Nong Kung Si",
            "district_id": 4105,
            "lat": 17.048,
            "long": 102.772,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 410506,
            "zip_code": 41240,
            "name_th": "โคกกลาง",
            "name_en": "Khok Klang",
            "district_id": 4105,
            "lat": 16.929,
            "long": 102.911,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 4106,
        "name_th": "หนองหาน",
        "name_en": "Nong Han",
        "province_id": 29,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 410601,
            "zip_code": 41130,
            "name_th": "หนองหาน",
            "name_en": "Nong Han",
            "district_id": 4106,
            "lat": 17.381,
            "long": 103.095,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 410602,
            "zip_code": 41130,
            "name_th": "หนองเม็ก",
            "name_en": "Nong Mek",
            "district_id": 4106,
            "lat": 17.355,
            "long": 103.169,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 410605,
            "zip_code": 41130,
            "name_th": "พังงู",
            "name_en": "Phang Ngu",
            "district_id": 4106,
            "lat": 17.257,
            "long": 103.117,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 410606,
            "zip_code": 41130,
            "name_th": "สะแบง",
            "name_en": "Sabaeng",
            "district_id": 4106,
            "lat": 17.453,
            "long": 103.116,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 410607,
            "zip_code": 41130,
            "name_th": "สร้อยพร้าว",
            "name_en": "Soi Phrao",
            "district_id": 4106,
            "lat": 17.43,
            "long": 103.056,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 410609,
            "zip_code": 41320,
            "name_th": "บ้านเชียง",
            "name_en": "Ban Chiang",
            "district_id": 4106,
            "lat": 17.398,
            "long": 103.228,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 410610,
            "zip_code": 41320,
            "name_th": "บ้านยา",
            "name_en": "Ban Ya",
            "district_id": 4106,
            "lat": 17.395,
            "long": 103.273,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 410611,
            "zip_code": 41130,
            "name_th": "โพนงาม",
            "name_en": "Phon Ngam",
            "district_id": 4106,
            "lat": 17.36,
            "long": 102.968,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 410612,
            "zip_code": 41130,
            "name_th": "ผักตบ",
            "name_en": "Phak Top",
            "district_id": 4106,
            "lat": 17.339,
            "long": 103.021,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 410614,
            "zip_code": 41130,
            "name_th": "หนองไผ่",
            "name_en": "Nong Phai",
            "district_id": 4106,
            "lat": 17.327,
            "long": 103.111,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 410617,
            "zip_code": 41130,
            "name_th": "ดอนหายโศก",
            "name_en": "Don Hai Sok",
            "district_id": 4106,
            "lat": 17.422,
            "long": 102.993,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 410618,
            "zip_code": 41320,
            "name_th": "หนองสระปลา",
            "name_en": "Nong Sa Pla",
            "district_id": 4106,
            "lat": 17.348,
            "long": 103.254,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 4107,
        "name_th": "ทุ่งฝน",
        "name_en": "Thung Fon",
        "province_id": 29,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 410701,
            "zip_code": 41310,
            "name_th": "ทุ่งฝน",
            "name_en": "Thung Fon",
            "district_id": 4107,
            "lat": 17.478,
            "long": 103.263,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 410702,
            "zip_code": 41310,
            "name_th": "ทุ่งใหญ่",
            "name_en": "Thung Yai",
            "district_id": 4107,
            "lat": 17.475,
            "long": 103.174,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 410703,
            "zip_code": 41310,
            "name_th": "นาชุมแสง",
            "name_en": "Na Chum Saeng",
            "district_id": 4107,
            "lat": 17.561,
            "long": 103.193,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 410704,
            "zip_code": 41310,
            "name_th": "นาทม",
            "name_en": "Na Thom",
            "district_id": 4107,
            "lat": 17.542,
            "long": 103.159,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 4108,
        "name_th": "ไชยวาน",
        "name_en": "Chai Wan",
        "province_id": 29,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 410801,
            "zip_code": 41290,
            "name_th": "ไชยวาน",
            "name_en": "Chai Wan",
            "district_id": 4108,
            "lat": 17.303,
            "long": 103.205,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 410802,
            "zip_code": 41290,
            "name_th": "หนองหลัก",
            "name_en": "Nong Lak",
            "district_id": 4108,
            "lat": 17.237,
            "long": 103.204,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 410803,
            "zip_code": 41290,
            "name_th": "คำเลาะ",
            "name_en": "Kham Lo",
            "district_id": 4108,
            "lat": 17.212,
            "long": 103.345,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 410804,
            "zip_code": 41290,
            "name_th": "โพนสูง",
            "name_en": "Phon Sung",
            "district_id": 4108,
            "lat": 17.173,
            "long": 103.24,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 4109,
        "name_th": "ศรีธาตุ",
        "name_en": "Si That",
        "province_id": 29,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 410901,
            "zip_code": 41230,
            "name_th": "ศรีธาตุ",
            "name_en": "Si That",
            "district_id": 4109,
            "lat": 16.987,
            "long": 103.211,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 410902,
            "zip_code": 41230,
            "name_th": "จำปี",
            "name_en": "Champi",
            "district_id": 4109,
            "lat": 16.998,
            "long": 103.171,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 410903,
            "zip_code": 41230,
            "name_th": "บ้านโปร่ง",
            "name_en": "Ban Prong",
            "district_id": 4109,
            "lat": 16.991,
            "long": 103.089,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 410904,
            "zip_code": 41230,
            "name_th": "หัวนาคำ",
            "name_en": "Hua Na Kham",
            "district_id": 4109,
            "lat": 17.083,
            "long": 103.284,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 410905,
            "zip_code": 41230,
            "name_th": "หนองนกเขียน",
            "name_en": "Nong Nok Khian",
            "district_id": 4109,
            "lat": 17.012,
            "long": 103.291,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 410906,
            "zip_code": 41230,
            "name_th": "นายูง",
            "name_en": "Na Yung",
            "district_id": 4109,
            "lat": 16.952,
            "long": 103.308,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 410907,
            "zip_code": 41230,
            "name_th": "ตาดทอง",
            "name_en": "Tat Thong",
            "district_id": 4109,
            "lat": 17.067,
            "long": 103.155,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 4110,
        "name_th": "วังสามหมอ",
        "name_en": "Wang Sam Mo",
        "province_id": 29,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 411001,
            "zip_code": 41280,
            "name_th": "หนองกุงทับม้า",
            "name_en": "Nong Kung Thap Ma",
            "district_id": 4110,
            "lat": 17.019,
            "long": 103.472,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 411002,
            "zip_code": 41280,
            "name_th": "หนองหญ้าไซ",
            "name_en": "Nong Ya Sai",
            "district_id": 4110,
            "lat": 16.952,
            "long": 103.368,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 411003,
            "zip_code": 41280,
            "name_th": "บะยาว",
            "name_en": "Ba Yao",
            "district_id": 4110,
            "lat": 17.084,
            "long": 103.405,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 411004,
            "zip_code": 41280,
            "name_th": "ผาสุก",
            "name_en": "Phasuk",
            "district_id": 4110,
            "lat": 17.134,
            "long": 103.537,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 411005,
            "zip_code": 41280,
            "name_th": "คำโคกสูง",
            "name_en": "Kham Khok Sung",
            "district_id": 4110,
            "lat": 16.882,
            "long": 103.426,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 411006,
            "zip_code": 41280,
            "name_th": "วังสามหมอ",
            "name_en": "Wang Sam Mo",
            "district_id": 4110,
            "lat": 16.941,
            "long": 103.456,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 4111,
        "name_th": "บ้านดุง",
        "name_en": "Ban Dung",
        "province_id": 29,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 411101,
            "zip_code": 41190,
            "name_th": "ศรีสุทโธ",
            "name_en": "Si Suttho",
            "district_id": 4111,
            "lat": 17.684,
            "long": 103.259,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 411102,
            "zip_code": 41190,
            "name_th": "บ้านดุง",
            "name_en": "Ban Dung",
            "district_id": 4111,
            "lat": 17.741,
            "long": 103.25,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 411103,
            "zip_code": 41190,
            "name_th": "ดงเย็น",
            "name_en": "Dong Yen",
            "district_id": 4111,
            "lat": 17.637,
            "long": 103.379,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 411104,
            "zip_code": 41190,
            "name_th": "โพนสูง",
            "name_en": "Phon Sung",
            "district_id": 4111,
            "lat": 17.672,
            "long": 103.296,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 411105,
            "zip_code": 41190,
            "name_th": "อ้อมกอ",
            "name_en": "Om Ko",
            "district_id": 4111,
            "lat": 17.594,
            "long": 103.305,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 411106,
            "zip_code": 41190,
            "name_th": "บ้านจันทน์",
            "name_en": "Ban Chan",
            "district_id": 4111,
            "lat": 17.796,
            "long": 103.296,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 411107,
            "zip_code": 41190,
            "name_th": "บ้านชัย",
            "name_en": "Ban Chai",
            "district_id": 4111,
            "lat": 17.623,
            "long": 103.19,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 411108,
            "zip_code": 41190,
            "name_th": "นาไหม",
            "name_en": "Na Mai",
            "district_id": 4111,
            "lat": 17.768,
            "long": 103.17,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 411109,
            "zip_code": 41190,
            "name_th": "ถ่อนนาลับ",
            "name_en": "Thon Na Lap",
            "district_id": 4111,
            "lat": 17.844,
            "long": 103.199,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 411110,
            "zip_code": 41190,
            "name_th": "วังทอง",
            "name_en": "Wang Thong",
            "district_id": 4111,
            "lat": 17.759,
            "long": 103.32,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 411111,
            "zip_code": 41190,
            "name_th": "บ้านม่วง",
            "name_en": "Ban Muang",
            "district_id": 4111,
            "lat": 17.713,
            "long": 103.362,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 411112,
            "zip_code": 41190,
            "name_th": "บ้านตาด",
            "name_en": "Ban Tat",
            "district_id": 4111,
            "lat": 17.573,
            "long": 103.248,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 411113,
            "zip_code": 41190,
            "name_th": "นาคำ",
            "name_en": "Na Kham",
            "district_id": 4111,
            "lat": 17.691,
            "long": 103.17,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 4117,
        "name_th": "บ้านผือ",
        "name_en": "Ban Phue",
        "province_id": 29,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 411701,
            "zip_code": 41160,
            "name_th": "บ้านผือ",
            "name_en": "Ban Phue",
            "district_id": 4117,
            "lat": 17.697,
            "long": 102.448,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 411702,
            "zip_code": 41160,
            "name_th": "หายโศก",
            "name_en": "Hai Sok",
            "district_id": 4117,
            "lat": 17.692,
            "long": 102.531,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 411703,
            "zip_code": 41160,
            "name_th": "เขือน้ำ",
            "name_en": "Khuea Nam",
            "district_id": 4117,
            "lat": 17.565,
            "long": 102.646,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 411704,
            "zip_code": 41160,
            "name_th": "คำบง",
            "name_en": "Kham Bong",
            "district_id": 4117,
            "lat": 17.54,
            "long": 102.556,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 411705,
            "zip_code": 41160,
            "name_th": "โนนทอง",
            "name_en": "Non Thong",
            "district_id": 4117,
            "lat": 17.56,
            "long": 102.424,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 411706,
            "zip_code": 41160,
            "name_th": "ข้าวสาร",
            "name_en": "Khao San",
            "district_id": 4117,
            "lat": 17.634,
            "long": 102.439,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 411707,
            "zip_code": 41160,
            "name_th": "จำปาโมง",
            "name_en": "Champa Mong",
            "district_id": 4117,
            "lat": 17.613,
            "long": 102.376,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 411708,
            "zip_code": 41160,
            "name_th": "กลางใหญ่",
            "name_en": "Klang Yai",
            "district_id": 4117,
            "lat": 17.785,
            "long": 102.375,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 411709,
            "zip_code": 41160,
            "name_th": "เมืองพาน",
            "name_en": "Mueang Phan",
            "district_id": 4117,
            "lat": 17.684,
            "long": 102.365,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 411710,
            "zip_code": 41160,
            "name_th": "คำด้วง",
            "name_en": "Kham Duang",
            "district_id": 4117,
            "lat": 17.872,
            "long": 102.346,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 411711,
            "zip_code": 41160,
            "name_th": "หนองหัวคู",
            "name_en": "Nong Hua Khu",
            "district_id": 4117,
            "lat": 17.574,
            "long": 102.56,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 411712,
            "zip_code": 41160,
            "name_th": "บ้านค้อ",
            "name_en": "Ban Kho",
            "district_id": 4117,
            "lat": 17.75,
            "long": 102.446,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 411713,
            "zip_code": 41160,
            "name_th": "หนองแวง",
            "name_en": "Nong Waeng",
            "district_id": 4117,
            "lat": 17.509,
            "long": 102.391,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 4118,
        "name_th": "น้ำโสม",
        "name_en": "Nam Som",
        "province_id": 29,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 411801,
            "zip_code": 41210,
            "name_th": "นางัว",
            "name_en": "Na Ngua",
            "district_id": 4118,
            "lat": 17.741,
            "long": 102.215,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 411802,
            "zip_code": 41210,
            "name_th": "น้ำโสม",
            "name_en": "Nam Som",
            "district_id": 4118,
            "lat": 17.715,
            "long": 102.092,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 411805,
            "zip_code": 41210,
            "name_th": "หนองแวง",
            "name_en": "Nong Waeng",
            "district_id": 4118,
            "lat": 17.81,
            "long": 102.3,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 411806,
            "zip_code": 41210,
            "name_th": "บ้านหยวก",
            "name_en": "Ban Yuak",
            "district_id": 4118,
            "lat": 17.697,
            "long": 102.187,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 411807,
            "zip_code": 41210,
            "name_th": "โสมเยี่ยม",
            "name_en": "Som Yiam",
            "district_id": 4118,
            "lat": 17.823,
            "long": 102.207,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 411810,
            "zip_code": 41210,
            "name_th": "ศรีสำราญ",
            "name_en": "Si Samran",
            "district_id": 4118,
            "lat": 17.732,
            "long": 102.162,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 411812,
            "zip_code": 41210,
            "name_th": "สามัคคี",
            "name_en": "Samakkhi",
            "district_id": 4118,
            "lat": 17.73,
            "long": 102.288,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 4119,
        "name_th": "เพ็ญ",
        "name_en": "Phen",
        "province_id": 29,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 411901,
            "zip_code": 41150,
            "name_th": "เพ็ญ",
            "name_en": "Phen",
            "district_id": 4119,
            "lat": 17.673,
            "long": 102.936,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 411902,
            "zip_code": 41150,
            "name_th": "บ้านธาตุ",
            "name_en": "Ban That",
            "district_id": 4119,
            "lat": 17.695,
            "long": 102.85,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 411903,
            "zip_code": 41150,
            "name_th": "นาพู่",
            "name_en": "Na Phu",
            "district_id": 4119,
            "lat": 17.6,
            "long": 102.764,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 411904,
            "zip_code": 41150,
            "name_th": "เชียงหวาง",
            "name_en": "Chiang Wang",
            "district_id": 4119,
            "lat": 17.617,
            "long": 102.849,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 411905,
            "zip_code": 41150,
            "name_th": "สุมเส้า",
            "name_en": "Sum Sao",
            "district_id": 4119,
            "lat": 17.603,
            "long": 102.984,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 411906,
            "zip_code": 41150,
            "name_th": "นาบัว",
            "name_en": "Na Bua",
            "district_id": 4119,
            "lat": 17.551,
            "long": 102.976,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 411907,
            "zip_code": 41150,
            "name_th": "บ้านเหล่า",
            "name_en": "Ban Lao",
            "district_id": 4119,
            "lat": 17.685,
            "long": 103.04,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 411908,
            "zip_code": 41150,
            "name_th": "จอมศรี",
            "name_en": "Chom Si",
            "district_id": 4119,
            "lat": 17.845,
            "long": 102.899,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 411909,
            "zip_code": 41150,
            "name_th": "เตาไห",
            "name_en": "Tao Hai",
            "district_id": 4119,
            "lat": 17.634,
            "long": 103.066,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 411910,
            "zip_code": 41150,
            "name_th": "โคกกลาง",
            "name_en": "Khok Klang",
            "district_id": 4119,
            "lat": 17.729,
            "long": 102.979,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 411911,
            "zip_code": 41150,
            "name_th": "สร้างแป้น",
            "name_en": "Sang Paen",
            "district_id": 4119,
            "lat": 17.513,
            "long": 102.944,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 4120,
        "name_th": "สร้างคอม",
        "name_en": "Sang Khom",
        "province_id": 29,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 412001,
            "zip_code": 41260,
            "name_th": "สร้างคอม",
            "name_en": "Sang Khom",
            "district_id": 4120,
            "lat": 17.814,
            "long": 103.09,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 412002,
            "zip_code": 41260,
            "name_th": "เชียงดา",
            "name_en": "Chiang Da",
            "district_id": 4120,
            "lat": 17.859,
            "long": 103.027,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 412003,
            "zip_code": 41260,
            "name_th": "บ้านยวด",
            "name_en": "Ban Yuat",
            "district_id": 4120,
            "lat": 17.734,
            "long": 103.04,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 412004,
            "zip_code": 41260,
            "name_th": "บ้านโคก",
            "name_en": "Ban Khok",
            "district_id": 4120,
            "lat": 17.786,
            "long": 103.016,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 412005,
            "zip_code": 41260,
            "name_th": "นาสะอาด",
            "name_en": "Na Sa-at",
            "district_id": 4120,
            "lat": 17.843,
            "long": 103.058,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 412006,
            "zip_code": 41260,
            "name_th": "บ้านหินโงม",
            "name_en": "Ban Hin Ngom",
            "district_id": 4120,
            "lat": 17.738,
            "long": 103.099,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 4121,
        "name_th": "หนองแสง",
        "name_en": "Nong Saeng",
        "province_id": 29,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 412101,
            "zip_code": 41340,
            "name_th": "หนองแสง",
            "name_en": "Nong Saeng",
            "district_id": 4121,
            "lat": 17.172,
            "long": 102.842,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 412102,
            "zip_code": 41340,
            "name_th": "แสงสว่าง",
            "name_en": "Saeng Sawang",
            "district_id": 4121,
            "lat": 17.121,
            "long": 102.804,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 412103,
            "zip_code": 41340,
            "name_th": "นาดี",
            "name_en": "Na Di",
            "district_id": 4121,
            "lat": 17.081,
            "long": 102.844,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 412104,
            "zip_code": 41340,
            "name_th": "ทับกุง",
            "name_en": "Thap Kung",
            "district_id": 4121,
            "lat": 17.182,
            "long": 102.737,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 4122,
        "name_th": "นายูง",
        "name_en": "Na Yung",
        "province_id": 29,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 412201,
            "zip_code": 41380,
            "name_th": "นายูง",
            "name_en": "Na Yung",
            "district_id": 4122,
            "lat": 17.916,
            "long": 102.213,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 412202,
            "zip_code": 41380,
            "name_th": "บ้านก้อง",
            "name_en": "Ban Kong",
            "district_id": 4122,
            "lat": 17.821,
            "long": 102.079,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 412203,
            "zip_code": 41380,
            "name_th": "นาแค",
            "name_en": "Na Khae",
            "district_id": 4122,
            "lat": 17.963,
            "long": 102.085,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 412204,
            "zip_code": 41380,
            "name_th": "โนนทอง",
            "name_en": "Non Thong",
            "district_id": 4122,
            "lat": 17.989,
            "long": 102.198,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 4123,
        "name_th": "พิบูลย์รักษ์",
        "name_en": "Phibun Rak",
        "province_id": 29,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 412301,
            "zip_code": 41130,
            "name_th": "บ้านแดง",
            "name_en": "Ban Daeng",
            "district_id": 4123,
            "lat": 17.539,
            "long": 103.072,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 412302,
            "zip_code": 41130,
            "name_th": "นาทราย",
            "name_en": "Na Sai",
            "district_id": 4123,
            "lat": 17.563,
            "long": 103.123,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 412303,
            "zip_code": 41130,
            "name_th": "ดอนกลอย",
            "name_en": "Don Kloi",
            "district_id": 4123,
            "lat": 17.48,
            "long": 103.023,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 4124,
        "name_th": "กู่แก้ว",
        "name_en": "Ku Kaeo",
        "province_id": 29,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 412401,
            "zip_code": 41130,
            "name_th": "บ้านจีต",
            "name_en": "Ban Chit",
            "district_id": 4124,
            "lat": 17.135,
            "long": 103.197,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 412402,
            "zip_code": 41130,
            "name_th": "โนนทองอินทร์",
            "name_en": "Non Thong In",
            "district_id": 4124,
            "lat": 17.197,
            "long": 103.177,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 412403,
            "zip_code": 41130,
            "name_th": "ค้อใหญ่",
            "name_en": "Kho Yai",
            "district_id": 4124,
            "lat": 17.205,
            "long": 103.141,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 412404,
            "zip_code": 41130,
            "name_th": "คอนสาย",
            "name_en": "Khon Sai",
            "district_id": 4124,
            "lat": 17.158,
            "long": 103.134,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 4125,
        "name_th": "ประจักษ์ศิลปาคม",
        "name_en": "rachak-sinlapakhom",
        "province_id": 29,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 412501,
            "zip_code": 41110,
            "name_th": "นาม่วง",
            "name_en": "Na Muang",
            "district_id": 4125,
            "lat": 17.256,
            "long": 102.976,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 412502,
            "zip_code": 41110,
            "name_th": "ห้วยสามพาด",
            "name_en": "Huai Sam Phat",
            "district_id": 4125,
            "lat": 17.237,
            "long": 102.934,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 412503,
            "zip_code": 41110,
            "name_th": "อุ่มจาน",
            "name_en": "Um Chan",
            "district_id": 4125,
            "lat": 17.234,
            "long": 103.062,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      }
    ]
  },
  {
    "id": 30,
    "name_th": "เลย",
    "name_en": "Loei",
    "geography_id": 3,
    "created_at": "2019-08-09T03:33:09.000+07:00",
    "updated_at": "2025-09-20T06:31:26.000+07:00",
    "deleted_at": null,
    "districts": [
      {
        "id": 4201,
        "name_th": "เมืองเลย",
        "name_en": "Mueang Loei",
        "province_id": 30,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 420101,
            "zip_code": 42000,
            "name_th": "กุดป่อง",
            "name_en": "Kut Pong",
            "district_id": 4201,
            "lat": 17.493,
            "long": 101.732,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 420102,
            "zip_code": 42000,
            "name_th": "เมือง",
            "name_en": "Mueang",
            "district_id": 4201,
            "lat": 17.523,
            "long": 101.705,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 420103,
            "zip_code": 42100,
            "name_th": "นาอ้อ",
            "name_en": "Na O",
            "district_id": 4201,
            "lat": 17.582,
            "long": 101.732,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 420104,
            "zip_code": 42000,
            "name_th": "กกดู่",
            "name_en": "Kok Du",
            "district_id": 4201,
            "lat": 17.604,
            "long": 101.635,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 420105,
            "zip_code": 42000,
            "name_th": "น้ำหมาน",
            "name_en": "Nam Man",
            "district_id": 4201,
            "lat": 17.525,
            "long": 101.646,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 420106,
            "zip_code": 42000,
            "name_th": "เสี้ยว",
            "name_en": "Siao",
            "district_id": 4201,
            "lat": 17.458,
            "long": 101.636,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 420107,
            "zip_code": 42000,
            "name_th": "นาอาน",
            "name_en": "Na An",
            "district_id": 4201,
            "lat": 17.46,
            "long": 101.741,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 420108,
            "zip_code": 42000,
            "name_th": "นาโป่ง",
            "name_en": "Na Pong",
            "district_id": 4201,
            "lat": 17.408,
            "long": 101.688,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 420109,
            "zip_code": 42000,
            "name_th": "นาดินดำ",
            "name_en": "Na Din Dam",
            "district_id": 4201,
            "lat": 17.455,
            "long": 101.842,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 420110,
            "zip_code": 42000,
            "name_th": "น้ำสวย",
            "name_en": "Nam Suai",
            "district_id": 4201,
            "lat": 17.613,
            "long": 101.852,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 420111,
            "zip_code": 42000,
            "name_th": "ชัยพฤกษ์",
            "name_en": "Chaiyaphruek",
            "district_id": 4201,
            "lat": 17.523,
            "long": 101.777,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 420112,
            "zip_code": 42000,
            "name_th": "นาแขม",
            "name_en": "Na Khaem",
            "district_id": 4201,
            "lat": 17.687,
            "long": 101.66,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 420113,
            "zip_code": 42100,
            "name_th": "ศรีสองรัก",
            "name_en": "Si Song Rak",
            "district_id": 4201,
            "lat": 17.642,
            "long": 101.769,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 420114,
            "zip_code": 42000,
            "name_th": "กกทอง",
            "name_en": "Kok Thong",
            "district_id": 4201,
            "lat": 17.519,
            "long": 101.562,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 4202,
        "name_th": "นาด้วง",
        "name_en": "Na Duang",
        "province_id": 30,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 420201,
            "zip_code": 42210,
            "name_th": "นาด้วง",
            "name_en": "Na Duang",
            "district_id": 4202,
            "lat": 17.5,
            "long": 102.043,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 420202,
            "zip_code": 42210,
            "name_th": "นาดอกคำ",
            "name_en": "Na Dok Kham",
            "district_id": 4202,
            "lat": 17.591,
            "long": 101.99,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 420203,
            "zip_code": 42210,
            "name_th": "ท่าสะอาด",
            "name_en": "Tha Sa-at",
            "district_id": 4202,
            "lat": 17.497,
            "long": 101.917,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 420204,
            "zip_code": 42210,
            "name_th": "ท่าสวรรค์",
            "name_en": "Tha Sawan",
            "district_id": 4202,
            "lat": 17.432,
            "long": 101.94,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 4203,
        "name_th": "เชียงคาน",
        "name_en": "Chiang Khan",
        "province_id": 30,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 420301,
            "zip_code": 42110,
            "name_th": "เชียงคาน",
            "name_en": "Chiang Khan",
            "district_id": 4203,
            "lat": 17.881,
            "long": 101.665,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 420302,
            "zip_code": 42110,
            "name_th": "ธาตุ",
            "name_en": "That",
            "district_id": 4203,
            "lat": 17.738,
            "long": 101.847,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 420303,
            "zip_code": 42110,
            "name_th": "นาซ่าว",
            "name_en": "Na Sao",
            "district_id": 4203,
            "lat": 17.814,
            "long": 101.663,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 420304,
            "zip_code": 42110,
            "name_th": "เขาแก้ว",
            "name_en": "Khao Kaeo",
            "district_id": 4203,
            "lat": 17.82,
            "long": 101.781,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 420305,
            "zip_code": 42110,
            "name_th": "ปากตม",
            "name_en": "Pak Tom",
            "district_id": 4203,
            "lat": 17.768,
            "long": 101.554,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 420306,
            "zip_code": 42110,
            "name_th": "บุฮม",
            "name_en": "Bu Hom",
            "district_id": 4203,
            "lat": 17.958,
            "long": 101.78,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 420307,
            "zip_code": 42110,
            "name_th": "จอมศรี",
            "name_en": "Chom Si",
            "district_id": 4203,
            "lat": 17.763,
            "long": 101.735,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 420308,
            "zip_code": 42110,
            "name_th": "หาดทรายขาว",
            "name_en": "Hat Sai Khao",
            "district_id": 4203,
            "lat": 17.743,
            "long": 101.658,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 4204,
        "name_th": "ปากชม",
        "name_en": "Pak Chom",
        "province_id": 30,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 420401,
            "zip_code": 42150,
            "name_th": "ปากชม",
            "name_en": "Pak Chom",
            "district_id": 4204,
            "lat": 17.96,
            "long": 101.902,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 420402,
            "zip_code": 42150,
            "name_th": "เชียงกลม",
            "name_en": "Chiang Klom",
            "district_id": 4204,
            "lat": 17.851,
            "long": 101.962,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 420403,
            "zip_code": 42150,
            "name_th": "หาดคัมภีร์",
            "name_en": "Hat Khamphi",
            "district_id": 4204,
            "lat": 18.111,
            "long": 102.01,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 420404,
            "zip_code": 42150,
            "name_th": "ห้วยบ่อซืน",
            "name_en": "Huai Bo Suen",
            "district_id": 4204,
            "lat": 17.73,
            "long": 101.986,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 420405,
            "zip_code": 42150,
            "name_th": "ห้วยพิชัย",
            "name_en": "Huai Phichai",
            "district_id": 4204,
            "lat": 18.017,
            "long": 101.971,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 420406,
            "zip_code": 42150,
            "name_th": "ชมเจริญ",
            "name_en": "Chom Charoen",
            "district_id": 4204,
            "lat": 17.7,
            "long": 101.922,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 4205,
        "name_th": "ด่านซ้าย",
        "name_en": "Dan Sai",
        "province_id": 30,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 420501,
            "zip_code": 42120,
            "name_th": "ด่านซ้าย",
            "name_en": "Dan Sai",
            "district_id": 4205,
            "lat": 17.267,
            "long": 101.155,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 420502,
            "zip_code": 42120,
            "name_th": "ปากหมัน",
            "name_en": "Pak Man",
            "district_id": 4205,
            "lat": 17.483,
            "long": 101.223,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 420503,
            "zip_code": 42120,
            "name_th": "นาดี",
            "name_en": "Na Di",
            "district_id": 4205,
            "lat": 17.42,
            "long": 101.154,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 420504,
            "zip_code": 42120,
            "name_th": "โคกงาม",
            "name_en": "Khok Ngam",
            "district_id": 4205,
            "lat": 17.385,
            "long": 101.233,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 420505,
            "zip_code": 42120,
            "name_th": "โพนสูง",
            "name_en": "Phon Sung",
            "district_id": 4205,
            "lat": 17.277,
            "long": 101.282,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 420506,
            "zip_code": 42120,
            "name_th": "อิปุ่ม",
            "name_en": "Ipum",
            "district_id": 4205,
            "lat": 17.187,
            "long": 101.254,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 420507,
            "zip_code": 42120,
            "name_th": "กกสะทอน",
            "name_en": "Kok Sathon",
            "district_id": 4205,
            "lat": 17.041,
            "long": 101.09,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 420508,
            "zip_code": 42120,
            "name_th": "โป่ง",
            "name_en": "Pong",
            "district_id": 4205,
            "lat": 17.156,
            "long": 101.198,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 420509,
            "zip_code": 42120,
            "name_th": "วังยาว",
            "name_en": "Wang Yao",
            "district_id": 4205,
            "lat": 17.21,
            "long": 101.328,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 420510,
            "zip_code": 42120,
            "name_th": "นาหอ",
            "name_en": "Na Ho",
            "district_id": 4205,
            "lat": 17.331,
            "long": 101.142,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 4206,
        "name_th": "นาแห้ว",
        "name_en": "Na Haeo",
        "province_id": 30,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 420601,
            "zip_code": 42170,
            "name_th": "นาแห้ว",
            "name_en": "Na Haeo",
            "district_id": 4206,
            "lat": 17.484,
            "long": 101.066,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 420602,
            "zip_code": 42170,
            "name_th": "แสงภา",
            "name_en": "Saeng Pha",
            "district_id": 4206,
            "lat": 17.507,
            "long": 100.965,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 420603,
            "zip_code": 42170,
            "name_th": "นาพึง",
            "name_en": "Na Phueng",
            "district_id": 4206,
            "lat": 17.416,
            "long": 101.027,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 420604,
            "zip_code": 42170,
            "name_th": "นามาลา",
            "name_en": "Na Ma La",
            "district_id": 4206,
            "lat": 17.336,
            "long": 101.071,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 420605,
            "zip_code": 42170,
            "name_th": "เหล่ากอหก",
            "name_en": "Lao Ko Hok",
            "district_id": 4206,
            "lat": 17.485,
            "long": 100.864,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 4207,
        "name_th": "ภูเรือ",
        "name_en": "Phu Ruea",
        "province_id": 30,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 420701,
            "zip_code": 42160,
            "name_th": "หนองบัว",
            "name_en": "Nong Bua",
            "district_id": 4207,
            "lat": 17.454,
            "long": 101.371,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 420702,
            "zip_code": 42160,
            "name_th": "ท่าศาลา",
            "name_en": "Tha Sala",
            "district_id": 4207,
            "lat": 17.391,
            "long": 101.463,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 420703,
            "zip_code": 42160,
            "name_th": "ร่องจิก",
            "name_en": "Rong Chik",
            "district_id": 4207,
            "lat": 17.346,
            "long": 101.333,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 420704,
            "zip_code": 42160,
            "name_th": "ปลาบ่า",
            "name_en": "Pla Ba",
            "district_id": 4207,
            "lat": 17.318,
            "long": 101.439,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 420705,
            "zip_code": 42160,
            "name_th": "ลาดค่าง",
            "name_en": "Lat Khang",
            "district_id": 4207,
            "lat": 17.497,
            "long": 101.285,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 420706,
            "zip_code": 42160,
            "name_th": "สานตม",
            "name_en": "San Tom",
            "district_id": 4207,
            "lat": 17.46,
            "long": 101.482,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 4208,
        "name_th": "ท่าลี่",
        "name_en": "Tha Li",
        "province_id": 30,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 420801,
            "zip_code": 42140,
            "name_th": "ท่าลี่",
            "name_en": "Tha Li",
            "district_id": 4208,
            "lat": 17.573,
            "long": 101.412,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 420802,
            "zip_code": 42140,
            "name_th": "หนองผือ",
            "name_en": "Nong Phue",
            "district_id": 4208,
            "lat": 17.678,
            "long": 101.448,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 420803,
            "zip_code": 42140,
            "name_th": "อาฮี",
            "name_en": "A Hi",
            "district_id": 4208,
            "lat": 17.636,
            "long": 101.347,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 420804,
            "zip_code": 42140,
            "name_th": "น้ำแคม",
            "name_en": "Nam Khaem",
            "district_id": 4208,
            "lat": 17.676,
            "long": 101.527,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 420805,
            "zip_code": 42140,
            "name_th": "โคกใหญ่",
            "name_en": "Khok Yai",
            "district_id": 4208,
            "lat": 17.556,
            "long": 101.491,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 420806,
            "zip_code": 42140,
            "name_th": "น้ำทูน",
            "name_en": "Nam Thun",
            "district_id": 4208,
            "lat": 17.592,
            "long": 101.288,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 4209,
        "name_th": "วังสะพุง",
        "name_en": "Wang Saphung",
        "province_id": 30,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 420901,
            "zip_code": 42130,
            "name_th": "วังสะพุง",
            "name_en": "Wang Saphung",
            "district_id": 4209,
            "lat": 17.296,
            "long": 101.746,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 420902,
            "zip_code": 42130,
            "name_th": "ทรายขาว",
            "name_en": "Sai Khao",
            "district_id": 4209,
            "lat": 17.213,
            "long": 101.535,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 420903,
            "zip_code": 42130,
            "name_th": "หนองหญ้าปล้อง",
            "name_en": "Nong Ya Plong",
            "district_id": 4209,
            "lat": 17.234,
            "long": 101.926,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 420904,
            "zip_code": 42130,
            "name_th": "หนองงิ้ว",
            "name_en": "Nong Ngio",
            "district_id": 4209,
            "lat": 17.374,
            "long": 101.571,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 420905,
            "zip_code": 42130,
            "name_th": "ปากปวน",
            "name_en": "Pak Puan",
            "district_id": 4209,
            "lat": 17.357,
            "long": 101.739,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 420906,
            "zip_code": 42130,
            "name_th": "ผาน้อย",
            "name_en": "Pha Noi",
            "district_id": 4209,
            "lat": 17.351,
            "long": 101.831,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 420910,
            "zip_code": 42130,
            "name_th": "ผาบิ้ง",
            "name_en": "Pha Bing",
            "district_id": 4209,
            "lat": 17.193,
            "long": 101.773,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 420911,
            "zip_code": 42130,
            "name_th": "เขาหลวง",
            "name_en": "Khao Luang",
            "district_id": 4209,
            "lat": 17.336,
            "long": 101.674,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 420912,
            "zip_code": 42130,
            "name_th": "โคกขมิ้น",
            "name_en": "Khok Khamin",
            "district_id": 4209,
            "lat": 17.171,
            "long": 101.938,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 420913,
            "zip_code": 42130,
            "name_th": "ศรีสงคราม",
            "name_en": "Si Songkhram",
            "district_id": 4209,
            "lat": 17.254,
            "long": 101.799,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 4210,
        "name_th": "ภูกระดึง",
        "name_en": "Phu Kradueng",
        "province_id": 30,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 421001,
            "zip_code": 42180,
            "name_th": "ศรีฐาน",
            "name_en": "Si Than",
            "district_id": 4210,
            "lat": 16.88,
            "long": 101.771,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 421005,
            "zip_code": 42180,
            "name_th": "ผานกเค้า",
            "name_en": "Pha Nok Khao",
            "district_id": 4210,
            "lat": 16.896,
            "long": 101.986,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 421007,
            "zip_code": 42180,
            "name_th": "ภูกระดึง",
            "name_en": "Phu Kradueng",
            "district_id": 4210,
            "lat": 16.971,
            "long": 101.85,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 421010,
            "zip_code": 42180,
            "name_th": "ห้วยส้ม",
            "name_en": "Huai Som",
            "district_id": 4210,
            "lat": 16.937,
            "long": 101.939,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 4211,
        "name_th": "ภูหลวง",
        "name_en": "Phu Luang",
        "province_id": 30,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 421101,
            "zip_code": 42230,
            "name_th": "ภูหอ",
            "name_en": "Phu Ho",
            "district_id": 4211,
            "lat": 17.135,
            "long": 101.629,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 421102,
            "zip_code": 42230,
            "name_th": "หนองคัน",
            "name_en": "Nong Khan",
            "district_id": 4211,
            "lat": 17.141,
            "long": 101.701,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 421104,
            "zip_code": 42230,
            "name_th": "ห้วยสีเสียด",
            "name_en": "Huai Sisiat",
            "district_id": 4211,
            "lat": 17.138,
            "long": 101.74,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 421105,
            "zip_code": 42230,
            "name_th": "เลยวังไสย์",
            "name_en": "Loei Wang Sai",
            "district_id": 4211,
            "lat": 17.086,
            "long": 101.549,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 421106,
            "zip_code": 42230,
            "name_th": "แก่งศรีภูมิ",
            "name_en": "Kaeng Si Phum",
            "district_id": 4211,
            "lat": 17.049,
            "long": 101.678,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 4212,
        "name_th": "ผาขาว",
        "name_en": "Pha Khao",
        "province_id": 30,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 421201,
            "zip_code": 42240,
            "name_th": "ผาขาว",
            "name_en": "Pha Khao",
            "district_id": 4212,
            "lat": 17.019,
            "long": 101.96,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 421202,
            "zip_code": 42240,
            "name_th": "ท่าช้างคล้อง",
            "name_en": "Tha Chang Khlong",
            "district_id": 4212,
            "lat": 17.019,
            "long": 102.09,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 421203,
            "zip_code": 42240,
            "name_th": "โนนปอแดง",
            "name_en": "Non Po Daeng",
            "district_id": 4212,
            "lat": 16.983,
            "long": 101.985,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 421204,
            "zip_code": 42240,
            "name_th": "โนนป่าซาง",
            "name_en": "Non Pa Sang",
            "district_id": 4212,
            "lat": 17.102,
            "long": 102.052,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 421205,
            "zip_code": 42240,
            "name_th": "บ้านเพิ่ม",
            "name_en": "Ban Phoem",
            "district_id": 4212,
            "lat": 17.1,
            "long": 101.938,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 4213,
        "name_th": "เอราวัณ",
        "name_en": "Erawan",
        "province_id": 30,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 421301,
            "zip_code": 42220,
            "name_th": "เอราวัณ",
            "name_en": "Erawan",
            "district_id": 4213,
            "lat": 17.373,
            "long": 101.892,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 421302,
            "zip_code": 42220,
            "name_th": "ผาอินทร์แปลง",
            "name_en": "Pha In Plaeng",
            "district_id": 4213,
            "lat": 17.303,
            "long": 101.962,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 421303,
            "zip_code": 42220,
            "name_th": "ผาสามยอด",
            "name_en": "Pha Sam Yot",
            "district_id": 4213,
            "lat": 17.228,
            "long": 102.066,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 421304,
            "zip_code": 42220,
            "name_th": "ทรัพย์ไพวัลย์",
            "name_en": "Sap Phaiwan",
            "district_id": 4213,
            "lat": 17.193,
            "long": 101.994,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 4214,
        "name_th": "หนองหิน",
        "name_en": "Nong Hin",
        "province_id": 30,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 421401,
            "zip_code": 42190,
            "name_th": "หนองหิน",
            "name_en": "Nong Hin",
            "district_id": 4214,
            "lat": 17.112,
            "long": 101.86,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 421402,
            "zip_code": 42190,
            "name_th": "ตาดข่า",
            "name_en": "Tat Kha",
            "district_id": 4214,
            "lat": 17.033,
            "long": 101.879,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 421403,
            "zip_code": 42190,
            "name_th": "ปวนพุ",
            "name_en": "Puan Phu",
            "district_id": 4214,
            "lat": 17.031,
            "long": 101.741,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      }
    ]
  },
  {
    "id": 31,
    "name_th": "หนองคาย",
    "name_en": "Nong Khai",
    "geography_id": 3,
    "created_at": "2019-08-09T03:33:09.000+07:00",
    "updated_at": "2025-09-20T06:31:26.000+07:00",
    "deleted_at": null,
    "districts": [
      {
        "id": 4301,
        "name_th": "เมืองหนองคาย",
        "name_en": "Mueang Nong Khai",
        "province_id": 31,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 430101,
            "zip_code": 43000,
            "name_th": "ในเมือง",
            "name_en": "Nai Mueang",
            "district_id": 4301,
            "lat": 17.89,
            "long": 102.761,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 430102,
            "zip_code": 43000,
            "name_th": "มีชัย",
            "name_en": "Mi Chai",
            "district_id": 4301,
            "lat": 17.868,
            "long": 102.729,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 430103,
            "zip_code": 43000,
            "name_th": "โพธิ์ชัย",
            "name_en": "Pho Chai",
            "district_id": 4301,
            "lat": 17.847,
            "long": 102.773,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 430104,
            "zip_code": 43000,
            "name_th": "กวนวัน",
            "name_en": "Kuan Wan",
            "district_id": 4301,
            "lat": 17.858,
            "long": 102.7,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 430105,
            "zip_code": 43000,
            "name_th": "เวียงคุก",
            "name_en": "Wiang Khuk",
            "district_id": 4301,
            "lat": 17.783,
            "long": 102.673,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 430106,
            "zip_code": 43000,
            "name_th": "วัดธาตุ",
            "name_en": "Wat That",
            "district_id": 4301,
            "lat": 17.851,
            "long": 102.826,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 430107,
            "zip_code": 43000,
            "name_th": "หาดคำ",
            "name_en": "Hat Kham",
            "district_id": 4301,
            "lat": 17.9,
            "long": 102.825,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 430108,
            "zip_code": 43000,
            "name_th": "หินโงม",
            "name_en": "Hin Ngom",
            "district_id": 4301,
            "lat": 17.94,
            "long": 102.849,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 430109,
            "zip_code": 43000,
            "name_th": "บ้านเดื่อ",
            "name_en": "Ban Duea",
            "district_id": 4301,
            "lat": 17.985,
            "long": 102.954,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 430110,
            "zip_code": 43100,
            "name_th": "ค่ายบกหวาน",
            "name_en": "Khai Bok Wan",
            "district_id": 4301,
            "lat": 17.781,
            "long": 102.783,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 430111,
            "zip_code": 43100,
            "name_th": "สองห้อง",
            "name_en": "Song Hong",
            "district_id": 4301,
            "lat": 17.715,
            "long": 102.811,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 430113,
            "zip_code": 43100,
            "name_th": "พระธาตุบังพวน",
            "name_en": "Phra That Bang Phuan",
            "district_id": 4301,
            "lat": 17.736,
            "long": 102.693,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 430116,
            "zip_code": 43000,
            "name_th": "หนองกอมเกาะ",
            "name_en": "Nong Kom Ko",
            "district_id": 4301,
            "lat": 17.83,
            "long": 102.742,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 430117,
            "zip_code": 43000,
            "name_th": "ปะโค",
            "name_en": "Pa Kho",
            "district_id": 4301,
            "lat": 17.801,
            "long": 102.716,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 430118,
            "zip_code": 43000,
            "name_th": "เมืองหมี",
            "name_en": "Mueang Mi",
            "district_id": 4301,
            "lat": 17.833,
            "long": 102.702,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 430119,
            "zip_code": 43000,
            "name_th": "สีกาย",
            "name_en": "Si Kai",
            "district_id": 4301,
            "lat": 17.958,
            "long": 102.884,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 4302,
        "name_th": "ท่าบ่อ",
        "name_en": "Tha Bo",
        "province_id": 31,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 430201,
            "zip_code": 43110,
            "name_th": "ท่าบ่อ",
            "name_en": "Tha Bo",
            "district_id": 4302,
            "lat": 17.827,
            "long": 102.568,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 430202,
            "zip_code": 43110,
            "name_th": "น้ำโมง",
            "name_en": "Nam Mong",
            "district_id": 4302,
            "lat": 17.84,
            "long": 102.524,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 430203,
            "zip_code": 43110,
            "name_th": "กองนาง",
            "name_en": "Kong Nang",
            "district_id": 4302,
            "lat": 17.889,
            "long": 102.592,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 430204,
            "zip_code": 43110,
            "name_th": "โคกคอน",
            "name_en": "Khok Khon",
            "district_id": 4302,
            "lat": 17.781,
            "long": 102.496,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 430205,
            "zip_code": 43110,
            "name_th": "บ้านเดื่อ",
            "name_en": "Ban Duea",
            "district_id": 4302,
            "lat": 17.775,
            "long": 102.579,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 430206,
            "zip_code": 43110,
            "name_th": "บ้านถ่อน",
            "name_en": "Ban Thon",
            "district_id": 4302,
            "lat": 17.776,
            "long": 102.632,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 430207,
            "zip_code": 43110,
            "name_th": "บ้านว่าน",
            "name_en": "Ban Wan",
            "district_id": 4302,
            "lat": 17.743,
            "long": 102.558,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 430208,
            "zip_code": 43110,
            "name_th": "นาข่า",
            "name_en": "Na Kha",
            "district_id": 4302,
            "lat": 17.784,
            "long": 102.458,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 430209,
            "zip_code": 43110,
            "name_th": "โพนสา",
            "name_en": "Phon Sa",
            "district_id": 4302,
            "lat": 17.819,
            "long": 102.61,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 430210,
            "zip_code": 43110,
            "name_th": "หนองนาง",
            "name_en": "Nong Nang",
            "district_id": 4302,
            "lat": 17.713,
            "long": 102.621,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 4305,
        "name_th": "โพนพิสัย",
        "name_en": "Phon Phisai",
        "province_id": 31,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 430501,
            "zip_code": 43120,
            "name_th": "จุมพล",
            "name_en": "Chumphon",
            "district_id": 4305,
            "lat": 18.027,
            "long": 103.146,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 430502,
            "zip_code": 43120,
            "name_th": "วัดหลวง",
            "name_en": "Wat Luang",
            "district_id": 4305,
            "lat": 17.949,
            "long": 103.013,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 430503,
            "zip_code": 43120,
            "name_th": "กุดบง",
            "name_en": "Kut Bong",
            "district_id": 4305,
            "lat": 18.105,
            "long": 103.118,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 430504,
            "zip_code": 43120,
            "name_th": "ชุมช้าง",
            "name_en": "Chum Chang",
            "district_id": 4305,
            "lat": 17.974,
            "long": 103.132,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 430506,
            "zip_code": 43120,
            "name_th": "ทุ่งหลวง",
            "name_en": "Thung Luang",
            "district_id": 4305,
            "lat": 17.896,
            "long": 102.976,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 430507,
            "zip_code": 43120,
            "name_th": "เหล่าต่างคำ",
            "name_en": "Lao Tang Kham",
            "district_id": 4305,
            "lat": 17.917,
            "long": 102.911,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 430508,
            "zip_code": 43120,
            "name_th": "นาหนัง",
            "name_en": "Na Nang",
            "district_id": 4305,
            "lat": 17.888,
            "long": 103.136,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 430509,
            "zip_code": 43120,
            "name_th": "เซิม",
            "name_en": "Soem",
            "district_id": 4305,
            "lat": 17.926,
            "long": 103.277,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 430513,
            "zip_code": 43120,
            "name_th": "บ้านโพธิ์",
            "name_en": "Ban Pho",
            "district_id": 4305,
            "lat": 17.86,
            "long": 103.291,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 430521,
            "zip_code": 43120,
            "name_th": "บ้านผือ",
            "name_en": "Ban Phue",
            "district_id": 4305,
            "lat": 17.93,
            "long": 103.213,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 430522,
            "zip_code": 43120,
            "name_th": "สร้างนางขาว",
            "name_en": "Sang Nang Khao",
            "district_id": 4305,
            "lat": 17.899,
            "long": 103.01,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 4307,
        "name_th": "ศรีเชียงใหม่",
        "name_en": "Si Chiang Mai",
        "province_id": 31,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 430701,
            "zip_code": 43130,
            "name_th": "พานพร้าว",
            "name_en": "Phan Phrao",
            "district_id": 4307,
            "lat": 17.942,
            "long": 102.594,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 430703,
            "zip_code": 43130,
            "name_th": "บ้านหม้อ",
            "name_en": "Ban Mo",
            "district_id": 4307,
            "lat": 17.957,
            "long": 102.502,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 430704,
            "zip_code": 43130,
            "name_th": "พระพุทธบาท",
            "name_en": "Phra Phutthabat",
            "district_id": 4307,
            "lat": 17.965,
            "long": 102.424,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 430705,
            "zip_code": 43130,
            "name_th": "หนองปลาปาก",
            "name_en": "Nong Pla Pak",
            "district_id": 4307,
            "lat": 17.913,
            "long": 102.514,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 4308,
        "name_th": "สังคม",
        "name_en": "Sangkhom",
        "province_id": 31,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 430801,
            "zip_code": 43160,
            "name_th": "แก้งไก่",
            "name_en": "Kaeng Kai",
            "district_id": 4308,
            "lat": 18.037,
            "long": 102.235,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 430802,
            "zip_code": 43160,
            "name_th": "ผาตั้ง",
            "name_en": "Pha Tang",
            "district_id": 4308,
            "lat": 17.996,
            "long": 102.328,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 430803,
            "zip_code": 43160,
            "name_th": "บ้านม่วง",
            "name_en": "Ban Muang",
            "district_id": 4308,
            "lat": 18.181,
            "long": 102.128,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 430804,
            "zip_code": 43160,
            "name_th": "นางิ้ว",
            "name_en": "Na Ngio",
            "district_id": 4308,
            "lat": 18.092,
            "long": 102.125,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 430805,
            "zip_code": 43160,
            "name_th": "สังคม",
            "name_en": "Sangkhom",
            "district_id": 4308,
            "lat": 18.091,
            "long": 102.216,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 4314,
        "name_th": "สระใคร",
        "name_en": "Sakhrai",
        "province_id": 31,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 431401,
            "zip_code": 43100,
            "name_th": "สระใคร",
            "name_en": "Sakhrai",
            "district_id": 4314,
            "lat": 17.703,
            "long": 102.75,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 431402,
            "zip_code": 43100,
            "name_th": "คอกช้าง",
            "name_en": "Khok Chang",
            "district_id": 4314,
            "lat": 17.638,
            "long": 102.736,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 431403,
            "zip_code": 43100,
            "name_th": "บ้านฝาง",
            "name_en": "Ban Fang",
            "district_id": 4314,
            "lat": 17.651,
            "long": 102.665,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 4315,
        "name_th": "เฝ้าไร่",
        "name_en": "Fao Rai",
        "province_id": 31,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 431501,
            "zip_code": 43120,
            "name_th": "เฝ้าไร่",
            "name_en": "Fao Rai",
            "district_id": 4315,
            "lat": 17.969,
            "long": 103.27,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 431502,
            "zip_code": 43120,
            "name_th": "นาดี",
            "name_en": "Na Di",
            "district_id": 4315,
            "lat": 17.999,
            "long": 103.366,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 431503,
            "zip_code": 43120,
            "name_th": "หนองหลวง",
            "name_en": "Nong Luang",
            "district_id": 4315,
            "lat": 18.021,
            "long": 103.24,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 431504,
            "zip_code": 43120,
            "name_th": "วังหลวง",
            "name_en": "Wang Luang",
            "district_id": 4315,
            "lat": 18.086,
            "long": 103.256,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 431505,
            "zip_code": 43120,
            "name_th": "อุดมพร",
            "name_en": "Udom Phon",
            "district_id": 4315,
            "lat": 17.891,
            "long": 103.357,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 4316,
        "name_th": "รัตนวาปี",
        "name_en": "Rattanawapi",
        "province_id": 31,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 431601,
            "zip_code": 43120,
            "name_th": "รัตนวาปี",
            "name_en": "Rattanawapi",
            "district_id": 4316,
            "lat": 18.223,
            "long": 103.183,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 431602,
            "zip_code": 43120,
            "name_th": "นาทับไฮ",
            "name_en": "Na Thap Hai",
            "district_id": 4316,
            "lat": 18.177,
            "long": 103.306,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 431603,
            "zip_code": 43120,
            "name_th": "บ้านต้อน",
            "name_en": "Ban Ton",
            "district_id": 4316,
            "lat": 18.258,
            "long": 103.236,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 431604,
            "zip_code": 43120,
            "name_th": "พระบาทนาสิงห์",
            "name_en": "Phra Bat Na Sing",
            "district_id": 4316,
            "lat": 18.163,
            "long": 103.209,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 431605,
            "zip_code": 43120,
            "name_th": "โพนแพง",
            "name_en": "Phon Phaeng",
            "district_id": 4316,
            "lat": 18.252,
            "long": 103.202,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 4317,
        "name_th": "โพธิ์ตาก",
        "name_en": "Pho Tak",
        "province_id": 31,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 431701,
            "zip_code": 43130,
            "name_th": "โพธิ์ตาก",
            "name_en": "Pho Tak",
            "district_id": 4317,
            "lat": 17.846,
            "long": 102.422,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 431702,
            "zip_code": 43130,
            "name_th": "โพนทอง",
            "name_en": "Phon Thong",
            "district_id": 4317,
            "lat": 17.881,
            "long": 102.454,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 431703,
            "zip_code": 43130,
            "name_th": "ด่านศรีสุข",
            "name_en": "Dan Si Suk",
            "district_id": 4317,
            "lat": 17.925,
            "long": 102.398,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      }
    ]
  },
  {
    "id": 32,
    "name_th": "มหาสารคาม",
    "name_en": "Maha Sarakham",
    "geography_id": 3,
    "created_at": "2019-08-09T03:33:09.000+07:00",
    "updated_at": "2025-09-20T06:31:26.000+07:00",
    "deleted_at": null,
    "districts": [
      {
        "id": 4401,
        "name_th": "เมืองมหาสารคาม",
        "name_en": "Mueang Maha Sarakham",
        "province_id": 32,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 440101,
            "zip_code": 44000,
            "name_th": "ตลาด",
            "name_en": "Talat",
            "district_id": 4401,
            "lat": 16.175,
            "long": 103.319,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 440102,
            "zip_code": 44000,
            "name_th": "เขวา",
            "name_en": "Khwao",
            "district_id": 4401,
            "lat": 16.15,
            "long": 103.389,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 440103,
            "zip_code": 44000,
            "name_th": "ท่าตูม",
            "name_en": "Tha Tum",
            "district_id": 4401,
            "lat": 16.162,
            "long": 103.484,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 440104,
            "zip_code": 44000,
            "name_th": "แวงน่าง",
            "name_en": "Waeng Nang",
            "district_id": 4401,
            "lat": 16.128,
            "long": 103.313,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 440105,
            "zip_code": 44000,
            "name_th": "โคกก่อ",
            "name_en": "Khok Ko",
            "district_id": 4401,
            "lat": 16.026,
            "long": 103.239,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 440106,
            "zip_code": 44000,
            "name_th": "ดอนหว่าน",
            "name_en": "Don Wan",
            "district_id": 4401,
            "lat": 15.997,
            "long": 103.318,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 440107,
            "zip_code": 44000,
            "name_th": "เกิ้ง",
            "name_en": "Koeng",
            "district_id": 4401,
            "lat": 16.21,
            "long": 103.33,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 440108,
            "zip_code": 44000,
            "name_th": "แก่งเลิงจาน",
            "name_en": "Kaeng Loeng Chan",
            "district_id": 4401,
            "lat": 16.139,
            "long": 103.226,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 440109,
            "zip_code": 44000,
            "name_th": "ท่าสองคอน",
            "name_en": "Tha Song Khon",
            "district_id": 4401,
            "lat": 16.163,
            "long": 103.15,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 440110,
            "zip_code": 44000,
            "name_th": "ลาดพัฒนา",
            "name_en": "Lat Phatthana",
            "district_id": 4401,
            "lat": 16.207,
            "long": 103.397,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 440111,
            "zip_code": 44000,
            "name_th": "หนองปลิง",
            "name_en": "Nong Pling",
            "district_id": 4401,
            "lat": 16.07,
            "long": 103.313,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 440112,
            "zip_code": 44000,
            "name_th": "ห้วยแอ่ง",
            "name_en": "Huai Aeng",
            "district_id": 4401,
            "lat": 16.117,
            "long": 103.432,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 440113,
            "zip_code": 44000,
            "name_th": "หนองโน",
            "name_en": "Nong No",
            "district_id": 4401,
            "lat": 16.098,
            "long": 103.252,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 440114,
            "zip_code": 44000,
            "name_th": "บัวค้อ",
            "name_en": "Bua Kho",
            "district_id": 4401,
            "lat": 15.986,
            "long": 103.278,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 4402,
        "name_th": "แกดำ",
        "name_en": "Kae Dam",
        "province_id": 32,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 440201,
            "zip_code": 44190,
            "name_th": "แกดำ",
            "name_en": "Kae Dam",
            "district_id": 4402,
            "lat": 16.026,
            "long": 103.401,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 440202,
            "zip_code": 44190,
            "name_th": "วังแสง",
            "name_en": "Wang Saeng",
            "district_id": 4402,
            "lat": 16.047,
            "long": 103.358,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 440203,
            "zip_code": 44190,
            "name_th": "มิตรภาพ",
            "name_en": "Mittraphap",
            "district_id": 4402,
            "lat": 16.09,
            "long": 103.387,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 440204,
            "zip_code": 44190,
            "name_th": "หนองกุง",
            "name_en": "Nong Kung",
            "district_id": 4402,
            "lat": 16.072,
            "long": 103.437,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 440205,
            "zip_code": 44190,
            "name_th": "โนนภิบาล",
            "name_en": "Non Phiban",
            "district_id": 4402,
            "lat": 16.022,
            "long": 103.442,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 4403,
        "name_th": "โกสุมพิสัย",
        "name_en": "Kosum Phisai",
        "province_id": 32,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 440301,
            "zip_code": 44140,
            "name_th": "หัวขวาง",
            "name_en": "Hua Khwang",
            "district_id": 4403,
            "lat": 16.249,
            "long": 103.065,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 440302,
            "zip_code": 44140,
            "name_th": "ยางน้อย",
            "name_en": "Yang Noi",
            "district_id": 4403,
            "lat": 16.301,
            "long": 103.098,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 440303,
            "zip_code": 44140,
            "name_th": "วังยาว",
            "name_en": "Wang Yao",
            "district_id": 4403,
            "lat": 16.223,
            "long": 102.928,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 440304,
            "zip_code": 44140,
            "name_th": "เขวาไร่",
            "name_en": "Khwao Rai",
            "district_id": 4403,
            "lat": 16.249,
            "long": 102.87,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 440305,
            "zip_code": 44140,
            "name_th": "แพง",
            "name_en": "Phaeng",
            "district_id": 4403,
            "lat": 16.26,
            "long": 102.967,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 440306,
            "zip_code": 44140,
            "name_th": "แก้งแก",
            "name_en": "Kaeng Kae",
            "district_id": 4403,
            "lat": 16.197,
            "long": 103.103,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 440307,
            "zip_code": 44140,
            "name_th": "หนองเหล็ก",
            "name_en": "Nong Lek",
            "district_id": 4403,
            "lat": 16.134,
            "long": 102.948,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 440308,
            "zip_code": 44140,
            "name_th": "หนองบัว",
            "name_en": "Nong Bua",
            "district_id": 4403,
            "lat": 16.338,
            "long": 102.995,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 440309,
            "zip_code": 44140,
            "name_th": "เหล่า",
            "name_en": "Lao",
            "district_id": 4403,
            "lat": 16.18,
            "long": 103.068,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 440310,
            "zip_code": 44140,
            "name_th": "เขื่อน",
            "name_en": "Khuean",
            "district_id": 4403,
            "lat": 16.344,
            "long": 103.068,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 440311,
            "zip_code": 44140,
            "name_th": "หนองบอน",
            "name_en": "Nong Bua",
            "district_id": 4403,
            "lat": 16.274,
            "long": 103.018,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 440312,
            "zip_code": 44140,
            "name_th": "โพนงาม",
            "name_en": "Phon Ngam",
            "district_id": 4403,
            "lat": 16.323,
            "long": 102.959,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 440313,
            "zip_code": 44140,
            "name_th": "ยางท่าแจ้ง",
            "name_en": "Yang Tha Chaeng",
            "district_id": 4403,
            "lat": 16.315,
            "long": 103.036,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 440314,
            "zip_code": 44140,
            "name_th": "แห่ใต้",
            "name_en": "Hae Tai",
            "district_id": 4403,
            "lat": 16.281,
            "long": 103.139,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 440315,
            "zip_code": 44140,
            "name_th": "หนองกุงสวรรค์",
            "name_en": "Nong Kung Sawan",
            "district_id": 4403,
            "lat": 16.194,
            "long": 102.975,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 440316,
            "zip_code": 44140,
            "name_th": "เลิงใต้",
            "name_en": "Loeng Tai",
            "district_id": 4403,
            "lat": 16.216,
            "long": 103.142,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 440317,
            "zip_code": 44140,
            "name_th": "ดอนกลาง",
            "name_en": "Don Klang",
            "district_id": 4403,
            "lat": 16.165,
            "long": 102.891,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 4404,
        "name_th": "กันทรวิชัย",
        "name_en": "Kantharawichai",
        "province_id": 32,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 440401,
            "zip_code": 44150,
            "name_th": "โคกพระ",
            "name_en": "Khok Phra",
            "district_id": 4404,
            "lat": 16.337,
            "long": 103.316,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 440402,
            "zip_code": 44150,
            "name_th": "คันธารราษฎร์",
            "name_en": "Khanthararat",
            "district_id": 4404,
            "lat": 16.299,
            "long": 103.283,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 440403,
            "zip_code": 44150,
            "name_th": "มะค่า",
            "name_en": "Makha",
            "district_id": 4404,
            "lat": 16.254,
            "long": 103.351,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 440404,
            "zip_code": 44150,
            "name_th": "ท่าขอนยาง",
            "name_en": "Tha Khon Yang",
            "district_id": 4404,
            "lat": 16.256,
            "long": 103.275,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 440405,
            "zip_code": 44150,
            "name_th": "นาสีนวน",
            "name_en": "Na Si Nuan",
            "district_id": 4404,
            "lat": 16.317,
            "long": 103.202,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 440406,
            "zip_code": 44150,
            "name_th": "ขามเรียง",
            "name_en": "Kham Riang",
            "district_id": 4404,
            "lat": 16.247,
            "long": 103.236,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 440407,
            "zip_code": 44150,
            "name_th": "เขวาใหญ่",
            "name_en": "Khwao Yai",
            "district_id": 4404,
            "lat": 16.228,
            "long": 103.184,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 440408,
            "zip_code": 44150,
            "name_th": "ศรีสุข",
            "name_en": "Si Suk",
            "district_id": 4404,
            "lat": 16.348,
            "long": 103.263,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 440409,
            "zip_code": 44150,
            "name_th": "กุดใส้จ่อ",
            "name_en": "Kut Sai Cho",
            "district_id": 4404,
            "lat": 16.283,
            "long": 103.38,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 440410,
            "zip_code": 44150,
            "name_th": "ขามเฒ่าพัฒนา",
            "name_en": "Kham Thao Phatthana",
            "district_id": 4404,
            "lat": 16.277,
            "long": 103.321,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 4405,
        "name_th": "เชียงยืน",
        "name_en": "Kantharawichai",
        "province_id": 32,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 440501,
            "zip_code": 44160,
            "name_th": "เชียงยืน",
            "name_en": "Chiang Yuen",
            "district_id": 4405,
            "lat": 16.431,
            "long": 103.093,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 440503,
            "zip_code": 44160,
            "name_th": "หนองซอน",
            "name_en": "Nong Son",
            "district_id": 4405,
            "lat": 16.334,
            "long": 103.156,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 440505,
            "zip_code": 44160,
            "name_th": "ดอนเงิน",
            "name_en": "Don Ngoen",
            "district_id": 4405,
            "lat": 16.424,
            "long": 103.151,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 440506,
            "zip_code": 44160,
            "name_th": "กู่ทอง",
            "name_en": "Ku Thong",
            "district_id": 4405,
            "lat": 16.426,
            "long": 103.003,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 440507,
            "zip_code": 44160,
            "name_th": "นาทอง",
            "name_en": "Na Thong",
            "district_id": 4405,
            "lat": 16.389,
            "long": 103.059,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 440508,
            "zip_code": 44160,
            "name_th": "เสือเฒ่า",
            "name_en": "Suea Thao",
            "district_id": 4405,
            "lat": 16.47,
            "long": 103.053,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 440511,
            "zip_code": 44160,
            "name_th": "โพนทอง",
            "name_en": "Phon Thong",
            "district_id": 4405,
            "lat": 16.372,
            "long": 103.144,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 440512,
            "zip_code": 44160,
            "name_th": "เหล่าบัวบาน",
            "name_en": "Lao Bua Ban",
            "district_id": 4405,
            "lat": 16.367,
            "long": 103.012,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 4406,
        "name_th": "บรบือ",
        "name_en": "Borabue",
        "province_id": 32,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 440601,
            "zip_code": 44130,
            "name_th": "บรบือ",
            "name_en": "Borabue",
            "district_id": 4406,
            "lat": 16.061,
            "long": 103.143,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 440602,
            "zip_code": 44130,
            "name_th": "บ่อใหญ่",
            "name_en": "Bo Yai",
            "district_id": 4406,
            "lat": 16.115,
            "long": 103.176,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 440604,
            "zip_code": 44130,
            "name_th": "วังไชย",
            "name_en": "Wang Chai",
            "district_id": 4406,
            "lat": 15.986,
            "long": 103.064,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 440605,
            "zip_code": 44130,
            "name_th": "หนองม่วง",
            "name_en": "Nong Muang",
            "district_id": 4406,
            "lat": 15.961,
            "long": 103.212,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 440606,
            "zip_code": 44130,
            "name_th": "กำพี้",
            "name_en": "Kamphi",
            "district_id": 4406,
            "lat": 15.959,
            "long": 103.144,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 440607,
            "zip_code": 44130,
            "name_th": "โนนราษี",
            "name_en": "Non Rasi",
            "district_id": 4406,
            "lat": 15.888,
            "long": 103.142,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 440608,
            "zip_code": 44130,
            "name_th": "โนนแดง",
            "name_en": "Non Daeng",
            "district_id": 4406,
            "lat": 15.903,
            "long": 103.08,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 440610,
            "zip_code": 44130,
            "name_th": "หนองจิก",
            "name_en": "Nong Chik",
            "district_id": 4406,
            "lat": 16.024,
            "long": 103.17,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 440611,
            "zip_code": 44130,
            "name_th": "บัวมาศ",
            "name_en": "Bua Mat",
            "district_id": 4406,
            "lat": 15.897,
            "long": 103.202,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 440613,
            "zip_code": 44130,
            "name_th": "หนองคูขาด",
            "name_en": "Nong Khu Khat",
            "district_id": 4406,
            "lat": 15.938,
            "long": 102.989,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 440615,
            "zip_code": 44130,
            "name_th": "วังใหม่",
            "name_en": "Wang Mai",
            "district_id": 4406,
            "lat": 16.031,
            "long": 103.039,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 440616,
            "zip_code": 44130,
            "name_th": "ยาง",
            "name_en": "Yang",
            "district_id": 4406,
            "lat": 15.919,
            "long": 103.236,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 440618,
            "zip_code": 44130,
            "name_th": "หนองสิม",
            "name_en": "Nong Sim",
            "district_id": 4406,
            "lat": 16.012,
            "long": 103.114,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 440619,
            "zip_code": 44130,
            "name_th": "หนองโก",
            "name_en": "Nong Ko",
            "district_id": 4406,
            "lat": 16.068,
            "long": 103.201,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 440620,
            "zip_code": 44130,
            "name_th": "ดอนงัว",
            "name_en": "Don Ngua",
            "district_id": 4406,
            "lat": 15.877,
            "long": 103.159,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 4407,
        "name_th": "นาเชือก",
        "name_en": "Na Chueak",
        "province_id": 32,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 440701,
            "zip_code": 44170,
            "name_th": "นาเชือก",
            "name_en": "Na Chueak",
            "district_id": 4407,
            "lat": 15.773,
            "long": 103.047,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 440702,
            "zip_code": 44170,
            "name_th": "สำโรง",
            "name_en": "Samrong",
            "district_id": 4407,
            "lat": 15.87,
            "long": 103.007,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 440703,
            "zip_code": 44170,
            "name_th": "หนองแดง",
            "name_en": "Nong Daeng",
            "district_id": 4407,
            "lat": 15.889,
            "long": 102.948,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 440704,
            "zip_code": 44170,
            "name_th": "เขวาไร่",
            "name_en": "Khwao Rai",
            "district_id": 4407,
            "lat": 15.841,
            "long": 103.065,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 440705,
            "zip_code": 44170,
            "name_th": "หนองโพธิ์",
            "name_en": "Nong Pho",
            "district_id": 4407,
            "lat": 15.755,
            "long": 103.13,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 440706,
            "zip_code": 44170,
            "name_th": "ปอพาน",
            "name_en": "Po Phan",
            "district_id": 4407,
            "lat": 15.816,
            "long": 102.954,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 440707,
            "zip_code": 44170,
            "name_th": "หนองเม็ก",
            "name_en": "Nong Mek",
            "district_id": 4407,
            "lat": 15.786,
            "long": 102.998,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 440708,
            "zip_code": 44170,
            "name_th": "หนองเรือ",
            "name_en": "Nong Ruea",
            "district_id": 4407,
            "lat": 15.828,
            "long": 103.123,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 440709,
            "zip_code": 44170,
            "name_th": "หนองกุง",
            "name_en": "Nong Kung",
            "district_id": 4407,
            "lat": 15.722,
            "long": 103.038,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 440710,
            "zip_code": 44170,
            "name_th": "สันป่าตอง",
            "name_en": "San Pa Ton",
            "district_id": 4407,
            "lat": 15.735,
            "long": 103.076,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 4408,
        "name_th": "พยัคฆภูมิพิสัย",
        "name_en": "Phayakkhaphum Phisai",
        "province_id": 32,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 440801,
            "zip_code": 44110,
            "name_th": "ปะหลาน",
            "name_en": "Palan",
            "district_id": 4408,
            "lat": 15.503,
            "long": 103.163,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 440802,
            "zip_code": 44110,
            "name_th": "ก้ามปู",
            "name_en": "Kam Pu",
            "district_id": 4408,
            "lat": 15.558,
            "long": 103.222,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 440803,
            "zip_code": 44110,
            "name_th": "เวียงสะอาด",
            "name_en": "Wiang Sa-at",
            "district_id": 4408,
            "lat": 15.461,
            "long": 103.262,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 440804,
            "zip_code": 44110,
            "name_th": "เม็กดำ",
            "name_en": "Mek Dam",
            "district_id": 4408,
            "lat": 15.573,
            "long": 103.072,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 440805,
            "zip_code": 44110,
            "name_th": "นาสีนวล",
            "name_en": "Na Si Nuan",
            "district_id": 4408,
            "lat": 15.635,
            "long": 103.223,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 440809,
            "zip_code": 44110,
            "name_th": "ราษฎร์เจริญ",
            "name_en": "Rat Charoen",
            "district_id": 4408,
            "lat": 15.456,
            "long": 103.321,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 440810,
            "zip_code": 44110,
            "name_th": "หนองบัวแก้ว",
            "name_en": "Nong Bua Kaeo",
            "district_id": 4408,
            "lat": 15.543,
            "long": 103.309,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 440812,
            "zip_code": 44110,
            "name_th": "เมืองเตา",
            "name_en": "Mueang Tao",
            "district_id": 4408,
            "lat": 15.479,
            "long": 103.378,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 440815,
            "zip_code": 44110,
            "name_th": "ลานสะแก",
            "name_en": "Lan Sakae",
            "district_id": 4408,
            "lat": 15.568,
            "long": 103.159,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 440816,
            "zip_code": 44110,
            "name_th": "เวียงชัย",
            "name_en": "Wiang Chai",
            "district_id": 4408,
            "lat": 15.517,
            "long": 103.266,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 440817,
            "zip_code": 44110,
            "name_th": "หนองบัว",
            "name_en": "Nong Bua",
            "district_id": 4408,
            "lat": 15.591,
            "long": 103.106,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 440818,
            "zip_code": 44110,
            "name_th": "ราษฎร์พัฒนา",
            "name_en": "Rat Phatthana",
            "district_id": 4408,
            "lat": 15.506,
            "long": 103.31,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 440819,
            "zip_code": 44110,
            "name_th": "เมืองเสือ",
            "name_en": "Mueang Suea",
            "district_id": 4408,
            "lat": 15.484,
            "long": 103.206,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 440820,
            "zip_code": 44110,
            "name_th": "ภารแอ่น",
            "name_en": "Phan Aen",
            "district_id": 4408,
            "lat": 15.593,
            "long": 103.258,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 4409,
        "name_th": "วาปีปทุม",
        "name_en": "Wapi Pathum",
        "province_id": 32,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 440901,
            "zip_code": 44120,
            "name_th": "หนองแสง",
            "name_en": "Nong Saeng",
            "district_id": 4409,
            "lat": 15.829,
            "long": 103.36,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 440902,
            "zip_code": 44120,
            "name_th": "ขามป้อม",
            "name_en": "Kham Pom",
            "district_id": 4409,
            "lat": 15.921,
            "long": 103.377,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 440903,
            "zip_code": 44120,
            "name_th": "เสือโก้ก",
            "name_en": "Suea Kok",
            "district_id": 4409,
            "lat": 15.948,
            "long": 103.442,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 440904,
            "zip_code": 44120,
            "name_th": "ดงใหญ่",
            "name_en": "Dong Yai",
            "district_id": 4409,
            "lat": 15.898,
            "long": 103.308,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 440905,
            "zip_code": 44120,
            "name_th": "โพธิ์ชัย",
            "name_en": "Pho Chai",
            "district_id": 4409,
            "lat": 15.729,
            "long": 103.415,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 440906,
            "zip_code": 44120,
            "name_th": "หัวเรือ",
            "name_en": "Hua Ruea",
            "district_id": 4409,
            "lat": 15.762,
            "long": 103.349,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 440907,
            "zip_code": 44120,
            "name_th": "แคน",
            "name_en": "Khaen",
            "district_id": 4409,
            "lat": 15.875,
            "long": 103.244,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 440908,
            "zip_code": 44120,
            "name_th": "งัวบา",
            "name_en": "Ngua Ba",
            "district_id": 4409,
            "lat": 15.955,
            "long": 103.347,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 440909,
            "zip_code": 44120,
            "name_th": "นาข่า",
            "name_en": "Na Kha",
            "district_id": 4409,
            "lat": 15.836,
            "long": 103.193,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 440910,
            "zip_code": 44120,
            "name_th": "บ้านหวาย",
            "name_en": "Ban Wai",
            "district_id": 4409,
            "lat": 15.812,
            "long": 103.294,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 440911,
            "zip_code": 44120,
            "name_th": "หนองไฮ",
            "name_en": "Nong Hai",
            "district_id": 4409,
            "lat": 15.885,
            "long": 103.432,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 440912,
            "zip_code": 44120,
            "name_th": "ประชาพัฒนา",
            "name_en": "Pracha Phatthana",
            "district_id": 4409,
            "lat": 15.816,
            "long": 103.419,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 440913,
            "zip_code": 44120,
            "name_th": "หนองทุ่ม",
            "name_en": "Nong Thum",
            "district_id": 4409,
            "lat": 15.875,
            "long": 103.399,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 440914,
            "zip_code": 44120,
            "name_th": "หนองแสน",
            "name_en": "Nong Saen",
            "district_id": 4409,
            "lat": 15.983,
            "long": 103.444,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 440915,
            "zip_code": 44120,
            "name_th": "โคกสีทองหลาง",
            "name_en": "Khok Si Thonglang",
            "district_id": 4409,
            "lat": 15.852,
            "long": 103.312,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 4410,
        "name_th": "นาดูน",
        "name_en": "Na Dun",
        "province_id": 32,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 441001,
            "zip_code": 44180,
            "name_th": "นาดูน",
            "name_en": "Na Dun",
            "district_id": 4410,
            "lat": 15.738,
            "long": 103.205,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 441002,
            "zip_code": 44180,
            "name_th": "หนองไผ่",
            "name_en": "Nong Phai",
            "district_id": 4410,
            "lat": 15.726,
            "long": 103.318,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 441003,
            "zip_code": 44180,
            "name_th": "หนองคู",
            "name_en": "Nong Khu",
            "district_id": 4410,
            "lat": 15.782,
            "long": 103.226,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 441004,
            "zip_code": 44180,
            "name_th": "ดงบัง",
            "name_en": "Dong Bang",
            "district_id": 4410,
            "lat": 15.663,
            "long": 103.257,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 441005,
            "zip_code": 44180,
            "name_th": "ดงดวน",
            "name_en": "Dong Duan",
            "district_id": 4410,
            "lat": 15.731,
            "long": 103.162,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 441006,
            "zip_code": 44180,
            "name_th": "หัวดง",
            "name_en": "Hua Dong",
            "district_id": 4410,
            "lat": 15.691,
            "long": 103.194,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 441007,
            "zip_code": 44180,
            "name_th": "ดงยาง",
            "name_en": "Dong Yang",
            "district_id": 4410,
            "lat": 15.757,
            "long": 103.296,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 441008,
            "zip_code": 44180,
            "name_th": "กู่สันตรัตน์",
            "name_en": "Ku Santarat",
            "district_id": 4410,
            "lat": 15.719,
            "long": 103.277,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 441009,
            "zip_code": 44180,
            "name_th": "พระธาตุ",
            "name_en": "Phra That",
            "district_id": 4410,
            "lat": 15.697,
            "long": 103.258,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 4411,
        "name_th": "ยางสีสุราช",
        "name_en": "Yang Sisurat",
        "province_id": 32,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 441101,
            "zip_code": 44210,
            "name_th": "ยางสีสุราช",
            "name_en": "Yang Sisurat",
            "district_id": 4411,
            "lat": 15.677,
            "long": 103.093,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 441102,
            "zip_code": 44210,
            "name_th": "นาภู",
            "name_en": "Na Phu",
            "district_id": 4411,
            "lat": 15.682,
            "long": 103.032,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 441103,
            "zip_code": 44210,
            "name_th": "แวงดง",
            "name_en": "Waeng Dong",
            "district_id": 4411,
            "lat": 15.638,
            "long": 103.035,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 441104,
            "zip_code": 44210,
            "name_th": "บ้านกู่",
            "name_en": "Ban Ku",
            "district_id": 4411,
            "lat": 15.686,
            "long": 103.136,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 441105,
            "zip_code": 44210,
            "name_th": "ดงเมือง",
            "name_en": "Dong Mueang",
            "district_id": 4411,
            "lat": 15.649,
            "long": 103.146,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 441106,
            "zip_code": 44210,
            "name_th": "ขามเรียน",
            "name_en": "Sang Saeng",
            "district_id": 4411,
            "lat": 15.627,
            "long": 103.113,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 441107,
            "zip_code": 44210,
            "name_th": "หนองบัวสันตุ",
            "name_en": "Nong Bua Santu",
            "district_id": 4411,
            "lat": 15.637,
            "long": 103.177,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 4412,
        "name_th": "กุดรัง",
        "name_en": "Kut Rang",
        "province_id": 32,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 441201,
            "zip_code": 44130,
            "name_th": "กุดรัง",
            "name_en": "Kud Rang",
            "district_id": 4412,
            "lat": 16.072,
            "long": 103.0,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 441202,
            "zip_code": 44130,
            "name_th": "นาโพธิ์",
            "name_en": "Na Pho",
            "district_id": 4412,
            "lat": 16.077,
            "long": 102.907,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 441203,
            "zip_code": 44130,
            "name_th": "เลิงแฝก",
            "name_en": "Loeng Faek",
            "district_id": 4412,
            "lat": 15.968,
            "long": 102.96,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 441204,
            "zip_code": 44130,
            "name_th": "หนองแวง",
            "name_en": "Nong Waeng",
            "district_id": 4412,
            "lat": 16.006,
            "long": 102.935,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 441205,
            "zip_code": 44130,
            "name_th": "ห้วยเตย",
            "name_en": "Huai Toei",
            "district_id": 4412,
            "lat": 16.123,
            "long": 103.049,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 4413,
        "name_th": "ชื่นชม",
        "name_en": "Chuen Chom",
        "province_id": 32,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 441301,
            "zip_code": 44160,
            "name_th": "ชื่นชม",
            "name_en": "Chuen Chom",
            "district_id": 4413,
            "lat": 16.551,
            "long": 103.144,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 441302,
            "zip_code": 44160,
            "name_th": "กุดปลาดุก",
            "name_en": "Kut Pla Duk",
            "district_id": 4413,
            "lat": 16.588,
            "long": 103.138,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 441303,
            "zip_code": 44160,
            "name_th": "เหล่าดอกไม้",
            "name_en": "Lao Dok Mai",
            "district_id": 4413,
            "lat": 16.492,
            "long": 103.145,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 441304,
            "zip_code": 44160,
            "name_th": "หนองกุง",
            "name_en": "Nong Kung",
            "district_id": 4413,
            "lat": 16.475,
            "long": 103.124,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      }
    ]
  },
  {
    "id": 33,
    "name_th": "ร้อยเอ็ด",
    "name_en": "Roi Et",
    "geography_id": 3,
    "created_at": "2019-08-09T03:33:09.000+07:00",
    "updated_at": "2025-09-20T06:31:26.000+07:00",
    "deleted_at": null,
    "districts": [
      {
        "id": 4501,
        "name_th": "เมืองร้อยเอ็ด",
        "name_en": "Mueang Roi Et",
        "province_id": 33,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 450101,
            "zip_code": 45000,
            "name_th": "ในเมือง",
            "name_en": "Nai Mueang",
            "district_id": 4501,
            "lat": 16.051,
            "long": 103.653,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 450102,
            "zip_code": 45000,
            "name_th": "รอบเมือง",
            "name_en": "Rop Mueang",
            "district_id": 4501,
            "lat": 16.006,
            "long": 103.632,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 450103,
            "zip_code": 45000,
            "name_th": "เหนือเมือง",
            "name_en": "Nuea Mueang",
            "district_id": 4501,
            "lat": 16.079,
            "long": 103.652,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 450104,
            "zip_code": 45000,
            "name_th": "ขอนแก่น",
            "name_en": "Khon Kaen",
            "district_id": 4501,
            "lat": 16.025,
            "long": 103.591,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 450105,
            "zip_code": 45000,
            "name_th": "นาโพธิ์",
            "name_en": "Na Pho",
            "district_id": 4501,
            "lat": 15.961,
            "long": 103.569,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 450106,
            "zip_code": 45000,
            "name_th": "สะอาดสมบูรณ์",
            "name_en": "Sa-at Sombun",
            "district_id": 4501,
            "lat": 15.932,
            "long": 103.626,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 450108,
            "zip_code": 45000,
            "name_th": "สีแก้ว",
            "name_en": "Si Kaeo",
            "district_id": 4501,
            "lat": 16.126,
            "long": 103.527,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 450109,
            "zip_code": 45000,
            "name_th": "ปอภาร  (ปอพาน)",
            "name_en": "Po Phan",
            "district_id": 4501,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 450110,
            "zip_code": 45000,
            "name_th": "โนนรัง",
            "name_en": "Non Rang",
            "district_id": 4501,
            "lat": 16.002,
            "long": 103.664,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 450117,
            "zip_code": 45000,
            "name_th": "หนองแก้ว",
            "name_en": "Nong Kaeo",
            "district_id": 4501,
            "lat": 15.939,
            "long": 103.66,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 450118,
            "zip_code": 45000,
            "name_th": "หนองแวง",
            "name_en": "Nong Waeng",
            "district_id": 4501,
            "lat": 16.103,
            "long": 103.603,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 450120,
            "zip_code": 45000,
            "name_th": "ดงลาน",
            "name_en": "Dong Lan",
            "district_id": 4501,
            "lat": 16.064,
            "long": 103.578,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 450123,
            "zip_code": 45000,
            "name_th": "แคนใหญ่",
            "name_en": "Khaen Yai",
            "district_id": 4501,
            "lat": 15.897,
            "long": 103.672,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 450124,
            "zip_code": 45000,
            "name_th": "โนนตาล",
            "name_en": "Non Tan",
            "district_id": 4501,
            "lat": 15.969,
            "long": 103.666,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 450125,
            "zip_code": 45000,
            "name_th": "เมืองทอง",
            "name_en": "Mueang Thong",
            "district_id": 4501,
            "lat": 15.932,
            "long": 103.591,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 4502,
        "name_th": "เกษตรวิสัย",
        "name_en": "Kaset Wisai",
        "province_id": 33,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 450201,
            "zip_code": 45150,
            "name_th": "เกษตรวิสัย",
            "name_en": "Kaset Wisai",
            "district_id": 4502,
            "lat": 15.662,
            "long": 103.609,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 450202,
            "zip_code": 45150,
            "name_th": "เมืองบัว",
            "name_en": "Mueang Bua",
            "district_id": 4502,
            "lat": 15.593,
            "long": 103.595,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 450203,
            "zip_code": 45150,
            "name_th": "เหล่าหลวง",
            "name_en": "Lao Luang",
            "district_id": 4502,
            "lat": 15.72,
            "long": 103.552,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 450204,
            "zip_code": 45150,
            "name_th": "สิงห์โคก",
            "name_en": "Sing Khok",
            "district_id": 4502,
            "lat": 15.704,
            "long": 103.668,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 450205,
            "zip_code": 45150,
            "name_th": "ดงครั่งใหญ่",
            "name_en": "Dong Khrang Yai",
            "district_id": 4502,
            "lat": 15.487,
            "long": 103.534,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 450206,
            "zip_code": 45150,
            "name_th": "บ้านฝาง",
            "name_en": "Ban Fang",
            "district_id": 4502,
            "lat": 15.703,
            "long": 103.452,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 450207,
            "zip_code": 45150,
            "name_th": "หนองแวง",
            "name_en": "Nong Waeng",
            "district_id": 4502,
            "lat": 15.741,
            "long": 103.631,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 450208,
            "zip_code": 45150,
            "name_th": "กำแพง",
            "name_en": "Kamphaeng",
            "district_id": 4502,
            "lat": 15.56,
            "long": 103.496,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 450209,
            "zip_code": 45150,
            "name_th": "กู่กาสิงห์",
            "name_en": "Ku Ka Sing",
            "district_id": 4502,
            "lat": 15.591,
            "long": 103.655,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 450210,
            "zip_code": 45150,
            "name_th": "น้ำอ้อม",
            "name_en": "Nam Om",
            "district_id": 4502,
            "lat": 15.639,
            "long": 103.511,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 450211,
            "zip_code": 45150,
            "name_th": "โนนสว่าง",
            "name_en": "Non Sawang",
            "district_id": 4502,
            "lat": 15.704,
            "long": 103.506,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 450212,
            "zip_code": 45150,
            "name_th": "ทุ่งทอง",
            "name_en": "Thung Thong",
            "district_id": 4502,
            "lat": 15.487,
            "long": 103.451,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 450213,
            "zip_code": 45150,
            "name_th": "ดงครั่งน้อย",
            "name_en": "Dong Khrang Noi",
            "district_id": 4502,
            "lat": 15.511,
            "long": 103.617,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 4503,
        "name_th": "ปทุมรัตต์",
        "name_en": "Pathum Rat",
        "province_id": 33,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 450301,
            "zip_code": 45190,
            "name_th": "บัวแดง",
            "name_en": "Bua Daeng",
            "district_id": 4503,
            "lat": 15.65,
            "long": 103.359,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 450302,
            "zip_code": 45190,
            "name_th": "ดอกล้ำ",
            "name_en": "Dok Lam",
            "district_id": 4503,
            "lat": 15.639,
            "long": 103.309,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 450303,
            "zip_code": 45190,
            "name_th": "หนองแคน",
            "name_en": "Nong Khaen",
            "district_id": 4503,
            "lat": 15.688,
            "long": 103.374,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 450304,
            "zip_code": 45190,
            "name_th": "โพนสูง",
            "name_en": "Phon Sung",
            "district_id": 4503,
            "lat": 15.655,
            "long": 103.444,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 450305,
            "zip_code": 45190,
            "name_th": "โนนสวรรค์",
            "name_en": "Non Sawan",
            "district_id": 4503,
            "lat": 15.584,
            "long": 103.435,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 450306,
            "zip_code": 45190,
            "name_th": "สระบัว",
            "name_en": "Sa Bua",
            "district_id": 4503,
            "lat": 15.568,
            "long": 103.371,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 450307,
            "zip_code": 45190,
            "name_th": "โนนสง่า",
            "name_en": "Non Sa-nga",
            "district_id": 4503,
            "lat": 15.608,
            "long": 103.349,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 450308,
            "zip_code": 45190,
            "name_th": "ขี้เหล็ก",
            "name_en": "Khilek",
            "district_id": 4503,
            "lat": 15.635,
            "long": 103.471,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 4504,
        "name_th": "จตุรพักตรพิมาน",
        "name_en": "Chaturaphak Phiman",
        "province_id": 33,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 450401,
            "zip_code": 45180,
            "name_th": "หัวช้าง",
            "name_en": "Hua Chang",
            "district_id": 4504,
            "lat": 15.845,
            "long": 103.569,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 450402,
            "zip_code": 45180,
            "name_th": "หนองผือ",
            "name_en": "Nong Phue",
            "district_id": 4504,
            "lat": 15.836,
            "long": 103.514,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 450403,
            "zip_code": 45180,
            "name_th": "เมืองหงส์",
            "name_en": "Mueang Hong",
            "district_id": 4504,
            "lat": 15.874,
            "long": 103.48,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 450404,
            "zip_code": 45180,
            "name_th": "โคกล่าม",
            "name_en": "Khok Lam",
            "district_id": 4504,
            "lat": 15.908,
            "long": 103.535,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 450405,
            "zip_code": 45180,
            "name_th": "น้ำใส",
            "name_en": "Nam Sai",
            "district_id": 4504,
            "lat": 15.901,
            "long": 103.599,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 450406,
            "zip_code": 45180,
            "name_th": "ดงแดง",
            "name_en": "Dong Daeng",
            "district_id": 4504,
            "lat": 15.854,
            "long": 103.669,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 450407,
            "zip_code": 45180,
            "name_th": "ดงกลาง",
            "name_en": "Dong Klang",
            "district_id": 4504,
            "lat": 15.803,
            "long": 103.604,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 450408,
            "zip_code": 45180,
            "name_th": "ป่าสังข์",
            "name_en": "Pa Sang",
            "district_id": 4504,
            "lat": 15.805,
            "long": 103.665,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 450409,
            "zip_code": 45180,
            "name_th": "อีง่อง",
            "name_en": "I Ngong",
            "district_id": 4504,
            "lat": 15.776,
            "long": 103.515,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 450410,
            "zip_code": 45180,
            "name_th": "ลิ้นฟ้า",
            "name_en": "Lin Fa",
            "district_id": 4504,
            "lat": 15.756,
            "long": 103.434,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 450411,
            "zip_code": 45180,
            "name_th": "ดู่น้อย",
            "name_en": "Du Noi",
            "district_id": 4504,
            "lat": 15.784,
            "long": 103.467,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 450412,
            "zip_code": 45180,
            "name_th": "ศรีโคตร",
            "name_en": "Si Khot",
            "district_id": 4504,
            "lat": 15.773,
            "long": 103.566,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 4505,
        "name_th": "ธวัชบุรี",
        "name_en": "Thawat Buri",
        "province_id": 33,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 450501,
            "zip_code": 45170,
            "name_th": "นิเวศน์",
            "name_en": "Niwet",
            "district_id": 4505,
            "lat": 16.042,
            "long": 103.737,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 450502,
            "zip_code": 45170,
            "name_th": "ธงธานี",
            "name_en": "Thong Thani",
            "district_id": 4505,
            "lat": 16.103,
            "long": 103.853,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 450503,
            "zip_code": 45170,
            "name_th": "หนองไผ่",
            "name_en": "Nong Phai",
            "district_id": 4505,
            "lat": 15.996,
            "long": 103.722,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 450504,
            "zip_code": 45170,
            "name_th": "ธวัชบุรี",
            "name_en": "Thawat Buri",
            "district_id": 4505,
            "lat": 16.116,
            "long": 103.811,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 450506,
            "zip_code": 45170,
            "name_th": "อุ่มเม้า",
            "name_en": "Um Mao",
            "district_id": 4505,
            "lat": 16.025,
            "long": 103.773,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 450507,
            "zip_code": 45170,
            "name_th": "มะอึ",
            "name_en": "Ma-ue",
            "district_id": 4505,
            "lat": 16.081,
            "long": 103.731,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 450510,
            "zip_code": 45170,
            "name_th": "เขวาทุ่ง",
            "name_en": "Khwao Thung",
            "district_id": 4505,
            "lat": 15.945,
            "long": 103.76,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 450515,
            "zip_code": 45170,
            "name_th": "ไพศาล",
            "name_en": "Phaisan",
            "district_id": 4505,
            "lat": 16.026,
            "long": 103.817,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 450517,
            "zip_code": 45170,
            "name_th": "เมืองน้อย",
            "name_en": "Mueang Noi",
            "district_id": 4505,
            "lat": 15.985,
            "long": 103.764,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 450520,
            "zip_code": 45170,
            "name_th": "บึงนคร",
            "name_en": "Bueng Nakhon",
            "district_id": 4505,
            "lat": 16.072,
            "long": 103.852,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 450522,
            "zip_code": 45170,
            "name_th": "ราชธานี",
            "name_en": "Ratchathani",
            "district_id": 4505,
            "lat": 15.883,
            "long": 103.728,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 450524,
            "zip_code": 45170,
            "name_th": "หนองพอก",
            "name_en": "Nong Phok",
            "district_id": 4505,
            "lat": 16.099,
            "long": 103.767,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 4506,
        "name_th": "พนมไพร",
        "name_en": "Phanom Phrai",
        "province_id": 33,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 450601,
            "zip_code": 45140,
            "name_th": "พนมไพร",
            "name_en": "Phanom Phrai",
            "district_id": 4506,
            "lat": 15.688,
            "long": 104.118,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 450602,
            "zip_code": 45140,
            "name_th": "แสนสุข",
            "name_en": "Saen Suk",
            "district_id": 4506,
            "lat": 15.733,
            "long": 104.076,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 450603,
            "zip_code": 45140,
            "name_th": "กุดน้ำใส",
            "name_en": "Kut Nam Sai",
            "district_id": 4506,
            "lat": 15.762,
            "long": 104.065,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 450604,
            "zip_code": 45140,
            "name_th": "หนองทัพไทย",
            "name_en": "Nong Thap Thai",
            "district_id": 4506,
            "lat": 15.689,
            "long": 103.984,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 450605,
            "zip_code": 45140,
            "name_th": "โพธิ์ใหญ่",
            "name_en": "Pho Yai",
            "district_id": 4506,
            "lat": 15.757,
            "long": 104.013,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 450606,
            "zip_code": 45140,
            "name_th": "วารีสวัสดิ์",
            "name_en": "Wari Sawat",
            "district_id": 4506,
            "lat": 15.684,
            "long": 104.044,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 450607,
            "zip_code": 45140,
            "name_th": "โคกสว่าง",
            "name_en": "Khok Sawang",
            "district_id": 4506,
            "lat": 15.637,
            "long": 104.074,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 450611,
            "zip_code": 45140,
            "name_th": "โพธิ์ชัย",
            "name_en": "Pho Chai",
            "district_id": 4506,
            "lat": 15.591,
            "long": 104.08,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 450612,
            "zip_code": 45140,
            "name_th": "นานวล",
            "name_en": "Na Nuan",
            "district_id": 4506,
            "lat": 15.639,
            "long": 104.124,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 450613,
            "zip_code": 45140,
            "name_th": "คำไฮ",
            "name_en": "Kham Hai",
            "district_id": 4506,
            "lat": 15.639,
            "long": 104.159,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 450614,
            "zip_code": 45140,
            "name_th": "สระแก้ว",
            "name_en": "Sa Kaeo",
            "district_id": 4506,
            "lat": 15.704,
            "long": 104.08,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 450615,
            "zip_code": 45140,
            "name_th": "ค้อใหญ่",
            "name_en": "Kho Yai",
            "district_id": 4506,
            "lat": 15.6,
            "long": 104.139,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 450617,
            "zip_code": 45140,
            "name_th": "ชานุวรรณ",
            "name_en": "Chanuwan",
            "district_id": 4506,
            "lat": 15.803,
            "long": 104.088,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 4507,
        "name_th": "โพนทอง",
        "name_en": "Phon Thong",
        "province_id": 33,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 450701,
            "zip_code": 45110,
            "name_th": "แวง",
            "name_en": "Waeng",
            "district_id": 4507,
            "lat": 16.329,
            "long": 103.984,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 450702,
            "zip_code": 45110,
            "name_th": "โคกกกม่วง",
            "name_en": "Khok Kok Muang",
            "district_id": 4507,
            "lat": 16.181,
            "long": 104.028,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 450703,
            "zip_code": 45110,
            "name_th": "นาอุดม",
            "name_en": "Na Udom",
            "district_id": 4507,
            "lat": 16.318,
            "long": 103.856,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 450704,
            "zip_code": 45110,
            "name_th": "สว่าง",
            "name_en": "Sawang",
            "district_id": 4507,
            "lat": 16.218,
            "long": 104.005,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 450705,
            "zip_code": 45110,
            "name_th": "หนองใหญ่",
            "name_en": "Nong Yai",
            "district_id": 4507,
            "lat": 16.401,
            "long": 103.998,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 450706,
            "zip_code": 45110,
            "name_th": "โพธิ์ทอง",
            "name_en": "Pho Thong",
            "district_id": 4507,
            "lat": 16.322,
            "long": 103.92,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 450707,
            "zip_code": 45110,
            "name_th": "โนนชัยศรี",
            "name_en": "Non Chai Si",
            "district_id": 4507,
            "lat": 16.213,
            "long": 103.956,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 450708,
            "zip_code": 45110,
            "name_th": "โพธิ์ศรีสว่าง",
            "name_en": "Pho Si Sawang",
            "district_id": 4507,
            "lat": 16.242,
            "long": 103.888,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 450709,
            "zip_code": 45110,
            "name_th": "อุ่มเม่า",
            "name_en": "Um Mao",
            "district_id": 4507,
            "lat": 16.277,
            "long": 103.862,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 450710,
            "zip_code": 45110,
            "name_th": "คำนาดี",
            "name_en": "Kham Na Di",
            "district_id": 4507,
            "lat": 16.396,
            "long": 103.915,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 450711,
            "zip_code": 45110,
            "name_th": "พรมสวรรค์",
            "name_en": "Phrom Sawan",
            "district_id": 4507,
            "lat": 16.199,
            "long": 104.084,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 450712,
            "zip_code": 45110,
            "name_th": "สระนกแก้ว",
            "name_en": "Sa Nok Kaeo",
            "district_id": 4507,
            "lat": 16.271,
            "long": 103.986,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 450713,
            "zip_code": 45110,
            "name_th": "วังสามัคคี",
            "name_en": "Wang Samakkhi",
            "district_id": 4507,
            "lat": 16.267,
            "long": 104.041,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 450714,
            "zip_code": 45110,
            "name_th": "โคกสูง",
            "name_en": "Khok Sung",
            "district_id": 4507,
            "lat": 16.206,
            "long": 103.873,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 4508,
        "name_th": "โพธิ์ชัย",
        "name_en": "Pho Chai",
        "province_id": 33,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 450801,
            "zip_code": 45230,
            "name_th": "ขามเปี้ย",
            "name_en": "Kham Pia",
            "district_id": 4508,
            "lat": 16.334,
            "long": 103.748,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 450802,
            "zip_code": 45230,
            "name_th": "เชียงใหม่",
            "name_en": "Chiang Mai",
            "district_id": 4508,
            "lat": 16.242,
            "long": 103.804,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 450803,
            "zip_code": 45230,
            "name_th": "บัวคำ",
            "name_en": "Bua Kham",
            "district_id": 4508,
            "lat": 16.281,
            "long": 103.812,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 450804,
            "zip_code": 45230,
            "name_th": "อัคคะคำ",
            "name_en": "Akkha Kham",
            "district_id": 4508,
            "lat": 16.385,
            "long": 103.746,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 450805,
            "zip_code": 45230,
            "name_th": "สะอาด",
            "name_en": "Sa-at",
            "district_id": 4508,
            "lat": 16.209,
            "long": 103.767,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 450806,
            "zip_code": 45230,
            "name_th": "คำพอุง",
            "name_en": "Kham Pha-ung",
            "district_id": 4508,
            "lat": 16.423,
            "long": 103.84,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 450807,
            "zip_code": 45230,
            "name_th": "หนองตาไก้",
            "name_en": "Nong Ta Kai",
            "district_id": 4508,
            "lat": 16.256,
            "long": 103.76,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 450808,
            "zip_code": 45230,
            "name_th": "ดอนโอง",
            "name_en": "Don Ong",
            "district_id": 4508,
            "lat": 16.206,
            "long": 103.826,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 450809,
            "zip_code": 45230,
            "name_th": "โพธิ์ศรี",
            "name_en": "Pho Si",
            "district_id": 4508,
            "lat": 16.344,
            "long": 103.83,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 4509,
        "name_th": "หนองพอก",
        "name_en": "Nong Phok",
        "province_id": 33,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 450901,
            "zip_code": 45210,
            "name_th": "หนองพอก",
            "name_en": "Nong Phok",
            "district_id": 4509,
            "lat": 16.318,
            "long": 104.159,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 450902,
            "zip_code": 45210,
            "name_th": "บึงงาม",
            "name_en": "Bueng Ngam",
            "district_id": 4509,
            "lat": 16.388,
            "long": 104.3,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 450903,
            "zip_code": 45210,
            "name_th": "ภูเขาทอง",
            "name_en": "Phukhao Thong",
            "district_id": 4509,
            "lat": 16.398,
            "long": 104.228,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 450904,
            "zip_code": 45210,
            "name_th": "กกโพธิ์",
            "name_en": "Kok Pho",
            "district_id": 4509,
            "lat": 16.296,
            "long": 104.113,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 450905,
            "zip_code": 45210,
            "name_th": "โคกสว่าง",
            "name_en": "Khok Sawang",
            "district_id": 4509,
            "lat": 16.268,
            "long": 104.275,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 450906,
            "zip_code": 45210,
            "name_th": "หนองขุ่นใหญ่",
            "name_en": "Nong Khun Yai",
            "district_id": 4509,
            "lat": 16.234,
            "long": 104.146,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 450907,
            "zip_code": 45210,
            "name_th": "รอบเมือง",
            "name_en": "Rop Mueang",
            "district_id": 4509,
            "lat": 16.283,
            "long": 104.207,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 450908,
            "zip_code": 45210,
            "name_th": "ผาน้ำย้อย",
            "name_en": "Pha Nam Yoi",
            "district_id": 4509,
            "lat": 16.331,
            "long": 104.289,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 450909,
            "zip_code": 45210,
            "name_th": "ท่าสีดา",
            "name_en": "Ta See Da",
            "district_id": 4509,
            "lat": 16.2,
            "long": 104.215,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 4510,
        "name_th": "เสลภูมิ",
        "name_en": "Selaphum",
        "province_id": 33,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 451001,
            "zip_code": 45120,
            "name_th": "กลาง",
            "name_en": "Klang",
            "district_id": 4510,
            "lat": 16.024,
            "long": 103.921,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 451002,
            "zip_code": 45120,
            "name_th": "นางาม",
            "name_en": "Na Ngam",
            "district_id": 4510,
            "lat": 15.911,
            "long": 103.94,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 451003,
            "zip_code": 45120,
            "name_th": "เมืองไพร",
            "name_en": "Mueang Phrai",
            "district_id": 4510,
            "lat": 16.001,
            "long": 103.993,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 451004,
            "zip_code": 45120,
            "name_th": "นาแซง",
            "name_en": "Na Saeng",
            "district_id": 4510,
            "lat": 16.144,
            "long": 103.968,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 451005,
            "zip_code": 45120,
            "name_th": "นาเมือง",
            "name_en": "Na Mueang",
            "district_id": 4510,
            "lat": 16.074,
            "long": 103.94,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 451006,
            "zip_code": 45120,
            "name_th": "วังหลวง",
            "name_en": "Wang Luang",
            "district_id": 4510,
            "lat": 16.09,
            "long": 103.995,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 451007,
            "zip_code": 45120,
            "name_th": "ท่าม่วง",
            "name_en": "Tha Muang",
            "district_id": 4510,
            "lat": 16.124,
            "long": 103.893,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 451008,
            "zip_code": 45120,
            "name_th": "ขวาว",
            "name_en": "Khwao",
            "district_id": 4510,
            "lat": 15.946,
            "long": 103.99,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 451009,
            "zip_code": 45120,
            "name_th": "โพธิ์ทอง",
            "name_en": "Pho Thong",
            "district_id": 4510,
            "lat": 16.136,
            "long": 104.138,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 451010,
            "zip_code": 45120,
            "name_th": "ภูเงิน",
            "name_en": "Phu Ngoen",
            "district_id": 4510,
            "lat": 16.04,
            "long": 104.078,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 451011,
            "zip_code": 45120,
            "name_th": "เกาะแก้ว",
            "name_en": "Ko Kaeo",
            "district_id": 4510,
            "lat": 16.161,
            "long": 103.868,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 451012,
            "zip_code": 45120,
            "name_th": "นาเลิง",
            "name_en": "Na Loeng",
            "district_id": 4510,
            "lat": 15.933,
            "long": 103.915,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 451013,
            "zip_code": 45120,
            "name_th": "เหล่าน้อย",
            "name_en": "Lao Noi",
            "district_id": 4510,
            "lat": 16.095,
            "long": 104.06,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 451014,
            "zip_code": 45120,
            "name_th": "ศรีวิลัย",
            "name_en": "Si Wilai",
            "district_id": 4510,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 451015,
            "zip_code": 45120,
            "name_th": "หนองหลวง",
            "name_en": "Nong Luang",
            "district_id": 4510,
            "lat": 16.148,
            "long": 103.923,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 451016,
            "zip_code": 45120,
            "name_th": "พรสวรรค์",
            "name_en": "Phon Sawan",
            "district_id": 4510,
            "lat": 16.184,
            "long": 104.148,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 451017,
            "zip_code": 45120,
            "name_th": "ขวัญเมือง",
            "name_en": "Khwan Mueang",
            "district_id": 4510,
            "lat": 16.028,
            "long": 103.958,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 451018,
            "zip_code": 45120,
            "name_th": "บึงเกลือ",
            "name_en": "Bueng Kluea",
            "district_id": 4510,
            "lat": 16.02,
            "long": 104.021,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 4511,
        "name_th": "สุวรรณภูมิ",
        "name_en": "Suwannaphum",
        "province_id": 33,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 451101,
            "zip_code": 45130,
            "name_th": "สระคู",
            "name_en": "Sa Khu",
            "district_id": 4511,
            "lat": 15.552,
            "long": 103.766,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 451102,
            "zip_code": 45130,
            "name_th": "ดอกไม้",
            "name_en": "Dok Mai",
            "district_id": 4511,
            "lat": 15.654,
            "long": 103.774,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 451103,
            "zip_code": 45130,
            "name_th": "นาใหญ่",
            "name_en": "Na Yai",
            "district_id": 4511,
            "lat": 15.704,
            "long": 103.75,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 451104,
            "zip_code": 45130,
            "name_th": "หินกอง",
            "name_en": "Hin Kong",
            "district_id": 4511,
            "lat": 15.599,
            "long": 103.73,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 451105,
            "zip_code": 45130,
            "name_th": "เมืองทุ่ง",
            "name_en": "Mueang Thung",
            "district_id": 4511,
            "lat": 15.627,
            "long": 103.85,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 451106,
            "zip_code": 45130,
            "name_th": "หัวโทน",
            "name_en": "Hua Thon",
            "district_id": 4511,
            "lat": 15.736,
            "long": 103.877,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 451107,
            "zip_code": 45130,
            "name_th": "บ่อพันขัน",
            "name_en": "Bo Phan Khan",
            "district_id": 4511,
            "lat": 15.604,
            "long": 103.898,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 451108,
            "zip_code": 45130,
            "name_th": "ทุ่งหลวง",
            "name_en": "Thung Luang",
            "district_id": 4511,
            "lat": 15.482,
            "long": 103.713,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 451109,
            "zip_code": 45130,
            "name_th": "หัวช้าง",
            "name_en": "Hua Chang",
            "district_id": 4511,
            "lat": 15.645,
            "long": 103.915,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 451110,
            "zip_code": 45130,
            "name_th": "น้ำคำ",
            "name_en": "Nam Kham",
            "district_id": 4511,
            "lat": 15.734,
            "long": 103.824,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 451111,
            "zip_code": 45130,
            "name_th": "ห้วยหินลาด",
            "name_en": "Huai Hin Lat",
            "district_id": 4511,
            "lat": 15.685,
            "long": 103.879,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 451112,
            "zip_code": 45130,
            "name_th": "ช้างเผือก",
            "name_en": "Chang Phueak",
            "district_id": 4511,
            "lat": 15.681,
            "long": 103.938,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 451113,
            "zip_code": 45130,
            "name_th": "ทุ่งกุลา",
            "name_en": "Thung Kula",
            "district_id": 4511,
            "lat": 15.482,
            "long": 103.805,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 451114,
            "zip_code": 45130,
            "name_th": "ทุ่งศรีเมือง",
            "name_en": "Thung Si Mueang",
            "district_id": 4511,
            "lat": 15.575,
            "long": 103.877,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 451115,
            "zip_code": 45130,
            "name_th": "จำปาขัน",
            "name_en": "Champa Khan",
            "district_id": 4511,
            "lat": 15.591,
            "long": 103.928,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 4512,
        "name_th": "เมืองสรวง",
        "name_en": "Mueang Suang",
        "province_id": 33,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 451201,
            "zip_code": 45220,
            "name_th": "หนองผือ",
            "name_en": "Nong Phue",
            "district_id": 4512,
            "lat": 15.817,
            "long": 103.714,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 451202,
            "zip_code": 45220,
            "name_th": "หนองหิน",
            "name_en": "Nong Hin",
            "district_id": 4512,
            "lat": 15.786,
            "long": 103.797,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 451203,
            "zip_code": 45220,
            "name_th": "คูเมือง",
            "name_en": "Khu Mueang",
            "district_id": 4512,
            "lat": 15.749,
            "long": 103.722,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 451204,
            "zip_code": 45220,
            "name_th": "กกกุง",
            "name_en": "Kok Kung",
            "district_id": 4512,
            "lat": 15.77,
            "long": 103.758,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 451205,
            "zip_code": 45220,
            "name_th": "เมืองสรวง",
            "name_en": "Mueang Suang",
            "district_id": 4512,
            "lat": 15.817,
            "long": 103.755,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 4513,
        "name_th": "โพนทราย",
        "name_en": "Phon Sai",
        "province_id": 33,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 451301,
            "zip_code": 45240,
            "name_th": "โพนทราย",
            "name_en": "Phon Sai",
            "district_id": 4513,
            "lat": 15.497,
            "long": 104.005,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 451302,
            "zip_code": 45240,
            "name_th": "สามขา",
            "name_en": "Sam Kha",
            "district_id": 4513,
            "lat": 15.474,
            "long": 103.944,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 451303,
            "zip_code": 45240,
            "name_th": "ศรีสว่าง",
            "name_en": "Si Sawang",
            "district_id": 4513,
            "lat": 15.533,
            "long": 103.868,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 451304,
            "zip_code": 45240,
            "name_th": "ยางคำ",
            "name_en": "Yang Kham",
            "district_id": 4513,
            "lat": 15.443,
            "long": 103.971,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 451305,
            "zip_code": 45240,
            "name_th": "ท่าหาดยาว",
            "name_en": "Tha Hat Yao",
            "district_id": 4513,
            "lat": 15.493,
            "long": 103.91,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 4514,
        "name_th": "อาจสามารถ",
        "name_en": "At Samat",
        "province_id": 33,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 451401,
            "zip_code": 45160,
            "name_th": "อาจสามารถ",
            "name_en": "At Samat",
            "district_id": 4514,
            "lat": 15.864,
            "long": 103.85,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 451402,
            "zip_code": 45160,
            "name_th": "โพนเมือง",
            "name_en": "Phon Mueang",
            "district_id": 4514,
            "lat": 15.913,
            "long": 103.881,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 451403,
            "zip_code": 45160,
            "name_th": "บ้านแจ้ง",
            "name_en": "Ban Chaeng",
            "district_id": 4514,
            "lat": 15.865,
            "long": 103.925,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 451404,
            "zip_code": 45160,
            "name_th": "หน่อม",
            "name_en": "Nom",
            "district_id": 4514,
            "lat": 15.808,
            "long": 103.955,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 451405,
            "zip_code": 45160,
            "name_th": "หนองหมื่นถ่าน",
            "name_en": "Nong Muen Than",
            "district_id": 4514,
            "lat": 15.755,
            "long": 103.937,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 451406,
            "zip_code": 45160,
            "name_th": "หนองขาม",
            "name_en": "Nong Kham",
            "district_id": 4514,
            "lat": 15.8,
            "long": 103.867,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 451407,
            "zip_code": 45160,
            "name_th": "โหรา",
            "name_en": "Hora",
            "district_id": 4514,
            "lat": 15.854,
            "long": 103.802,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 451408,
            "zip_code": 45160,
            "name_th": "หนองบัว",
            "name_en": "Nong Bua",
            "district_id": 4514,
            "lat": 15.861,
            "long": 103.765,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 451409,
            "zip_code": 45160,
            "name_th": "ขี้เหล็ก",
            "name_en": "Khilek",
            "district_id": 4514,
            "lat": 15.903,
            "long": 103.791,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 451410,
            "zip_code": 45160,
            "name_th": "บ้านดู่",
            "name_en": "Ban Du",
            "district_id": 4514,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 4515,
        "name_th": "เมยวดี",
        "name_en": "Moei Wadi",
        "province_id": 33,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 451501,
            "zip_code": 45250,
            "name_th": "เมยวดี",
            "name_en": "Moei Wadi",
            "district_id": 4515,
            "lat": 16.395,
            "long": 104.167,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 451502,
            "zip_code": 45250,
            "name_th": "ชุมพร",
            "name_en": "Chumphon",
            "district_id": 4515,
            "lat": 16.342,
            "long": 104.067,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 451503,
            "zip_code": 45250,
            "name_th": "บุ่งเลิศ",
            "name_en": "Bung Loet",
            "district_id": 4515,
            "lat": 16.416,
            "long": 104.123,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 451504,
            "zip_code": 45250,
            "name_th": "ชมสะอาด",
            "name_en": "Chom Sa-at",
            "district_id": 4515,
            "lat": 16.393,
            "long": 104.098,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 4516,
        "name_th": "ศรีสมเด็จ",
        "name_en": "Si Somdet",
        "province_id": 33,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 451601,
            "zip_code": 45000,
            "name_th": "โพธิ์ทอง",
            "name_en": "Pho Thong",
            "district_id": 4516,
            "lat": 15.973,
            "long": 103.535,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 451602,
            "zip_code": 45000,
            "name_th": "ศรีสมเด็จ",
            "name_en": "Si Somdet",
            "district_id": 4516,
            "lat": 15.98,
            "long": 103.474,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 451603,
            "zip_code": 45000,
            "name_th": "เมืองเปลือย",
            "name_en": "Mueang Plueai",
            "district_id": 4516,
            "lat": 16.011,
            "long": 103.551,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 451604,
            "zip_code": 45000,
            "name_th": "หนองใหญ่",
            "name_en": "Nong Yai",
            "district_id": 4516,
            "lat": 16.044,
            "long": 103.541,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 451605,
            "zip_code": 45280,
            "name_th": "สวนจิก",
            "name_en": "Suan Chik",
            "district_id": 4516,
            "lat": 16.034,
            "long": 103.492,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 451606,
            "zip_code": 45280,
            "name_th": "โพธิ์สัย",
            "name_en": "Pho Sai",
            "district_id": 4516,
            "lat": 16.096,
            "long": 103.475,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 451607,
            "zip_code": 45000,
            "name_th": "หนองแวงควง",
            "name_en": "Nong Waeng Khuang",
            "district_id": 4516,
            "lat": 15.95,
            "long": 103.506,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 451608,
            "zip_code": 45000,
            "name_th": "บ้านบาก",
            "name_en": "Ban Bak",
            "district_id": 4516,
            "lat": 15.987,
            "long": 103.518,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 4517,
        "name_th": "จังหาร",
        "name_en": "Changhan",
        "province_id": 33,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 451701,
            "zip_code": 45000,
            "name_th": "ดินดำ",
            "name_en": "Din Dam",
            "district_id": 4517,
            "lat": 16.183,
            "long": 103.679,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 451702,
            "zip_code": 45000,
            "name_th": "ปาฝา",
            "name_en": "Pa Fa",
            "district_id": 4517,
            "lat": 16.14,
            "long": 103.637,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 451703,
            "zip_code": 45000,
            "name_th": "ม่วงลาด",
            "name_en": "Muang Lat",
            "district_id": 4517,
            "lat": 16.204,
            "long": 103.543,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 451704,
            "zip_code": 45000,
            "name_th": "จังหาร",
            "name_en": "Changhan",
            "district_id": 4517,
            "lat": 16.14,
            "long": 103.594,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 451705,
            "zip_code": 45000,
            "name_th": "ดงสิงห์",
            "name_en": "Dong Sing",
            "district_id": 4517,
            "lat": 16.175,
            "long": 103.58,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 451706,
            "zip_code": 45000,
            "name_th": "ยางใหญ่",
            "name_en": "Yang Yai",
            "district_id": 4517,
            "lat": 16.132,
            "long": 103.679,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 451707,
            "zip_code": 45000,
            "name_th": "ผักแว่น",
            "name_en": "Phak Waen",
            "district_id": 4517,
            "lat": 16.174,
            "long": 103.535,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 451708,
            "zip_code": 45000,
            "name_th": "แสนชาติ",
            "name_en": "Saen Chat",
            "district_id": 4517,
            "lat": 16.176,
            "long": 103.639,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 4518,
        "name_th": "เชียงขวัญ",
        "name_en": "Chiang Khwan",
        "province_id": 33,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 451801,
            "zip_code": 45000,
            "name_th": "เชียงขวัญ",
            "name_en": "Chiang Khwan",
            "district_id": 4518,
            "lat": 16.191,
            "long": 103.724,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 451802,
            "zip_code": 45170,
            "name_th": "พลับพลา",
            "name_en": "Phlapphla",
            "district_id": 4518,
            "lat": 16.135,
            "long": 103.782,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 451803,
            "zip_code": 45000,
            "name_th": "พระธาตุ",
            "name_en": "Phra That",
            "district_id": 4518,
            "lat": 16.16,
            "long": 103.769,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 451804,
            "zip_code": 45000,
            "name_th": "พระเจ้า",
            "name_en": "Phra Chao",
            "district_id": 4518,
            "lat": 16.128,
            "long": 103.741,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 451805,
            "zip_code": 45170,
            "name_th": "หมูม้น",
            "name_en": "Mu Mon",
            "district_id": 4518,
            "lat": 16.101,
            "long": 103.705,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 451806,
            "zip_code": 45000,
            "name_th": "บ้านเขือง",
            "name_en": "Ban Khueang",
            "district_id": 4518,
            "lat": 16.15,
            "long": 103.71,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 4519,
        "name_th": "หนองฮี",
        "name_en": "Nong Hi",
        "province_id": 33,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 451901,
            "zip_code": 45140,
            "name_th": "หนองฮี",
            "name_en": "Nong Hi",
            "district_id": 4519,
            "lat": 15.621,
            "long": 104.0,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 451902,
            "zip_code": 45140,
            "name_th": "สาวแห",
            "name_en": "Sao Hae",
            "district_id": 4519,
            "lat": 15.55,
            "long": 104.062,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 451903,
            "zip_code": 45140,
            "name_th": "ดูกอึ่ง",
            "name_en": "Duk Ueng",
            "district_id": 4519,
            "lat": 15.559,
            "long": 104.016,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 451904,
            "zip_code": 45140,
            "name_th": "เด่นราษฎร์",
            "name_en": "Den Rat",
            "district_id": 4519,
            "lat": 15.582,
            "long": 103.965,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 4520,
        "name_th": "ทุ่งเขาหลวง",
        "name_en": "Thung Khao Luang",
        "province_id": 33,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 452001,
            "zip_code": 45170,
            "name_th": "ทุ่งเขาหลวง",
            "name_en": "Thung Khao Luang",
            "district_id": 4520,
            "lat": 16.032,
            "long": 103.853,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 452002,
            "zip_code": 45170,
            "name_th": "เทอดไทย",
            "name_en": "Thoet Thai",
            "district_id": 4520,
            "lat": 15.963,
            "long": 103.866,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 452003,
            "zip_code": 45170,
            "name_th": "บึงงาม",
            "name_en": "Bueng Ngam",
            "district_id": 4520,
            "lat": 15.986,
            "long": 103.894,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 452004,
            "zip_code": 45170,
            "name_th": "มะบ้า",
            "name_en": "Maba",
            "district_id": 4520,
            "lat": 16.039,
            "long": 103.889,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 452005,
            "zip_code": 45170,
            "name_th": "เหล่า",
            "name_en": "Lao",
            "district_id": 4520,
            "lat": 15.965,
            "long": 103.827,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      }
    ]
  },
  {
    "id": 34,
    "name_th": "กาฬสินธุ์",
    "name_en": "Kalasin",
    "geography_id": 3,
    "created_at": "2019-08-09T03:33:09.000+07:00",
    "updated_at": "2025-09-20T06:31:26.000+07:00",
    "deleted_at": null,
    "districts": [
      {
        "id": 4601,
        "name_th": "เมืองกาฬสินธุ์",
        "name_en": "Mueang Kalasin",
        "province_id": 34,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 460101,
            "zip_code": 46000,
            "name_th": "กาฬสินธุ์",
            "name_en": "Kalasin",
            "district_id": 4601,
            "lat": 16.437,
            "long": 103.522,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 460102,
            "zip_code": 46000,
            "name_th": "เหนือ",
            "name_en": "Nuea",
            "district_id": 4601,
            "lat": 16.442,
            "long": 103.574,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 460103,
            "zip_code": 46000,
            "name_th": "หลุบ",
            "name_en": "Lup",
            "district_id": 4601,
            "lat": 16.393,
            "long": 103.512,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 460104,
            "zip_code": 46000,
            "name_th": "ไผ่",
            "name_en": "Phai",
            "district_id": 4601,
            "lat": 16.522,
            "long": 103.575,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 460105,
            "zip_code": 46000,
            "name_th": "ลำปาว",
            "name_en": "Lam Pao",
            "district_id": 4601,
            "lat": 16.591,
            "long": 103.496,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 460106,
            "zip_code": 46000,
            "name_th": "ลำพาน",
            "name_en": "Lam Phan",
            "district_id": 4601,
            "lat": 16.457,
            "long": 103.484,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 460107,
            "zip_code": 46000,
            "name_th": "เชียงเครือ",
            "name_en": "Chiang Khruea",
            "district_id": 4601,
            "lat": 16.434,
            "long": 103.612,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 460108,
            "zip_code": 46000,
            "name_th": "บึงวิชัย",
            "name_en": "Bueng Wichai",
            "district_id": 4601,
            "lat": 16.5,
            "long": 103.499,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 460109,
            "zip_code": 46000,
            "name_th": "ห้วยโพธิ์",
            "name_en": "Huai Pho",
            "district_id": 4601,
            "lat": 16.392,
            "long": 103.578,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 460111,
            "zip_code": 46000,
            "name_th": "ภูปอ",
            "name_en": "Phu Po",
            "district_id": 4601,
            "lat": 16.59,
            "long": 103.615,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 460113,
            "zip_code": 46000,
            "name_th": "ภูดิน",
            "name_en": "Phu Din",
            "district_id": 4601,
            "lat": 16.636,
            "long": 103.528,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 460115,
            "zip_code": 46000,
            "name_th": "หนองกุง",
            "name_en": "Nong Kung",
            "district_id": 4601,
            "lat": 16.534,
            "long": 103.526,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 460116,
            "zip_code": 46000,
            "name_th": "กลางหมื่น",
            "name_en": "Klang Muen",
            "district_id": 4601,
            "lat": 16.518,
            "long": 103.641,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 460117,
            "zip_code": 46000,
            "name_th": "ขมิ้น",
            "name_en": "Khamin",
            "district_id": 4601,
            "lat": 16.607,
            "long": 103.569,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 460119,
            "zip_code": 46000,
            "name_th": "โพนทอง",
            "name_en": "Phon Thong",
            "district_id": 4601,
            "lat": 16.478,
            "long": 103.548,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 460120,
            "zip_code": 46000,
            "name_th": "นาจารย์",
            "name_en": "Na Chan",
            "district_id": 4601,
            "lat": 16.561,
            "long": 103.643,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 460121,
            "zip_code": 46000,
            "name_th": "ลำคลอง",
            "name_en": "Lam Khlong",
            "district_id": 4601,
            "lat": 16.587,
            "long": 103.45,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 4602,
        "name_th": "นามน",
        "name_en": "Na Mon",
        "province_id": 34,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 460201,
            "zip_code": 46230,
            "name_th": "นามน",
            "name_en": "Na Mon",
            "district_id": 4602,
            "lat": 16.561,
            "long": 103.776,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 460202,
            "zip_code": 46230,
            "name_th": "ยอดแกง",
            "name_en": "Yot Kaeng",
            "district_id": 4602,
            "lat": 16.622,
            "long": 103.735,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 460203,
            "zip_code": 46230,
            "name_th": "สงเปลือย",
            "name_en": "Song Plueai",
            "district_id": 4602,
            "lat": 16.624,
            "long": 103.793,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 460204,
            "zip_code": 46230,
            "name_th": "หลักเหลี่ยม",
            "name_en": "Lak Liam",
            "district_id": 4602,
            "lat": 16.548,
            "long": 103.82,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 460205,
            "zip_code": 46230,
            "name_th": "หนองบัว",
            "name_en": "Nong Bua",
            "district_id": 4602,
            "lat": 16.537,
            "long": 103.855,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 4603,
        "name_th": "กมลาไสย",
        "name_en": "Kamalasai",
        "province_id": 34,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 460301,
            "zip_code": 46130,
            "name_th": "กมลาไสย",
            "name_en": "Kamalasai",
            "district_id": 4603,
            "lat": 16.31,
            "long": 103.551,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 460302,
            "zip_code": 46130,
            "name_th": "หลักเมือง",
            "name_en": "Lak Mueang",
            "district_id": 4603,
            "lat": 16.332,
            "long": 103.595,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 460303,
            "zip_code": 46130,
            "name_th": "โพนงาม",
            "name_en": "Phon Ngam",
            "district_id": 4603,
            "lat": 16.316,
            "long": 103.658,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 460304,
            "zip_code": 46130,
            "name_th": "ดงลิง",
            "name_en": "Dong Ling",
            "district_id": 4603,
            "lat": 16.25,
            "long": 103.661,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 460305,
            "zip_code": 46130,
            "name_th": "ธัญญา",
            "name_en": "Thanya",
            "district_id": 4603,
            "lat": 16.259,
            "long": 103.567,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 460308,
            "zip_code": 46130,
            "name_th": "หนองแปน",
            "name_en": "Nong Paen",
            "district_id": 4603,
            "lat": 16.289,
            "long": 103.511,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 460310,
            "zip_code": 46130,
            "name_th": "เจ้าท่า",
            "name_en": "Chao Tha",
            "district_id": 4603,
            "lat": 16.225,
            "long": 103.591,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 460311,
            "zip_code": 46130,
            "name_th": "โคกสมบูรณ์",
            "name_en": "Khok Sombun",
            "district_id": 4603,
            "lat": 16.36,
            "long": 103.667,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 4604,
        "name_th": "ร่องคำ",
        "name_en": "Rong Kham",
        "province_id": 34,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 460401,
            "zip_code": 46210,
            "name_th": "ร่องคำ",
            "name_en": "Rong Kham",
            "district_id": 4604,
            "lat": 16.266,
            "long": 103.737,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 460402,
            "zip_code": 46210,
            "name_th": "สามัคคี",
            "name_en": "Samakkhi",
            "district_id": 4604,
            "lat": 16.318,
            "long": 103.713,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 460403,
            "zip_code": 46210,
            "name_th": "เหล่าอ้อย",
            "name_en": "Lao Oi",
            "district_id": 4604,
            "lat": 16.254,
            "long": 103.708,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 4605,
        "name_th": "กุฉินารายณ์",
        "name_en": "Kuchinarai",
        "province_id": 34,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 460501,
            "zip_code": 46110,
            "name_th": "บัวขาว",
            "name_en": "Bua Khao",
            "district_id": 4605,
            "lat": 16.521,
            "long": 104.055,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 460502,
            "zip_code": 46110,
            "name_th": "แจนแลน",
            "name_en": "Chaen Laen",
            "district_id": 4605,
            "lat": 16.554,
            "long": 103.998,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 460503,
            "zip_code": 46110,
            "name_th": "เหล่าใหญ่",
            "name_en": "Lao Yai",
            "district_id": 4605,
            "lat": 16.622,
            "long": 103.993,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 460504,
            "zip_code": 46110,
            "name_th": "จุมจัง",
            "name_en": "Chum Chang",
            "district_id": 4605,
            "lat": 16.458,
            "long": 104.107,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 460505,
            "zip_code": 46110,
            "name_th": "เหล่าไฮงาม",
            "name_en": "Lao Hai Ngam",
            "district_id": 4605,
            "lat": 16.471,
            "long": 104.171,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 460506,
            "zip_code": 46110,
            "name_th": "กุดหว้า",
            "name_en": "Kut Wa",
            "district_id": 4605,
            "lat": 16.537,
            "long": 104.167,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 460507,
            "zip_code": 46110,
            "name_th": "สามขา",
            "name_en": "Sam Kha",
            "district_id": 4605,
            "lat": 16.464,
            "long": 103.975,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 460508,
            "zip_code": 46110,
            "name_th": "นาขาม",
            "name_en": "Na Kham",
            "district_id": 4605,
            "lat": 16.508,
            "long": 103.905,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 460509,
            "zip_code": 46110,
            "name_th": "หนองห้าง",
            "name_en": "Nong Hang",
            "district_id": 4605,
            "lat": 16.572,
            "long": 104.124,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 460510,
            "zip_code": 46110,
            "name_th": "นาโก",
            "name_en": "Na Ko",
            "district_id": 4605,
            "lat": 16.606,
            "long": 104.055,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 460511,
            "zip_code": 46110,
            "name_th": "สมสะอาด",
            "name_en": "Som Sa-at",
            "district_id": 4605,
            "lat": 16.451,
            "long": 104.048,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 460512,
            "zip_code": 46110,
            "name_th": "กุดค้าว",
            "name_en": "Kut Khao",
            "district_id": 4605,
            "lat": 16.506,
            "long": 104.001,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 4606,
        "name_th": "เขาวง",
        "name_en": "Khao Wong",
        "province_id": 34,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 460601,
            "zip_code": 46160,
            "name_th": "คุ้มเก่า",
            "name_en": "Khum Kao",
            "district_id": 4606,
            "lat": 16.679,
            "long": 104.132,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 460602,
            "zip_code": 46160,
            "name_th": "สงเปลือย",
            "name_en": "Song Plueai",
            "district_id": 4606,
            "lat": 16.626,
            "long": 104.119,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 460603,
            "zip_code": 46160,
            "name_th": "หนองผือ",
            "name_en": "Nong Phue",
            "district_id": 4606,
            "lat": 16.751,
            "long": 104.094,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 460606,
            "zip_code": 46160,
            "name_th": "กุดสิมคุ้มใหม่",
            "name_en": "Kut Sim Khum Mai",
            "district_id": 4606,
            "lat": 16.676,
            "long": 104.049,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 460608,
            "zip_code": 46160,
            "name_th": "สระพังทอง",
            "name_en": "Saphang Thong",
            "district_id": 4606,
            "lat": 16.719,
            "long": 104.055,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 460611,
            "zip_code": 46160,
            "name_th": "กุดปลาค้าว",
            "name_en": "Kut Pla Khao",
            "district_id": 4606,
            "lat": 16.715,
            "long": 104.115,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 4607,
        "name_th": "ยางตลาด",
        "name_en": "Yang Talat",
        "province_id": 34,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 460701,
            "zip_code": 46120,
            "name_th": "ยางตลาด",
            "name_en": "Yang Talat",
            "district_id": 4607,
            "lat": 16.393,
            "long": 103.352,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 460702,
            "zip_code": 46120,
            "name_th": "หัวงัว",
            "name_en": "Hua Ngua",
            "district_id": 4607,
            "lat": 16.337,
            "long": 103.446,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 460703,
            "zip_code": 46120,
            "name_th": "อุ่มเม่า",
            "name_en": "Um Mao",
            "district_id": 4607,
            "lat": 16.398,
            "long": 103.464,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 460704,
            "zip_code": 46120,
            "name_th": "บัวบาน",
            "name_en": "Bua Ban",
            "district_id": 4607,
            "lat": 16.479,
            "long": 103.416,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 460705,
            "zip_code": 46120,
            "name_th": "เว่อ",
            "name_en": "Woe",
            "district_id": 4607,
            "lat": 16.543,
            "long": 103.351,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 460706,
            "zip_code": 46120,
            "name_th": "อิตื้อ",
            "name_en": "Itue",
            "district_id": 4607,
            "lat": 16.464,
            "long": 103.262,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 460707,
            "zip_code": 46120,
            "name_th": "หัวนาคำ",
            "name_en": "Hua Na Kham",
            "district_id": 4607,
            "lat": 16.392,
            "long": 103.227,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 460708,
            "zip_code": 46120,
            "name_th": "หนองอิเฒ่า",
            "name_en": "Nong I Thao",
            "district_id": 4607,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 460709,
            "zip_code": 46120,
            "name_th": "ดอนสมบูรณ์",
            "name_en": "Don Sombun",
            "district_id": 4607,
            "lat": 16.437,
            "long": 103.406,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 460710,
            "zip_code": 46120,
            "name_th": "นาเชือก",
            "name_en": "Na Chueak",
            "district_id": 4607,
            "lat": 16.557,
            "long": 103.415,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 460711,
            "zip_code": 46120,
            "name_th": "คลองขาม",
            "name_en": "Khlong Kham",
            "district_id": 4607,
            "lat": 16.456,
            "long": 103.338,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 460712,
            "zip_code": 46120,
            "name_th": "เขาพระนอน",
            "name_en": "Khao Phra Non",
            "district_id": 4607,
            "lat": 16.529,
            "long": 103.38,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 460713,
            "zip_code": 46120,
            "name_th": "นาดี",
            "name_en": "Na Di",
            "district_id": 4607,
            "lat": 16.361,
            "long": 103.474,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 460714,
            "zip_code": 46120,
            "name_th": "โนนสูง",
            "name_en": "Non Sung",
            "district_id": 4607,
            "lat": 16.464,
            "long": 103.207,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 460715,
            "zip_code": 46120,
            "name_th": "หนองตอกแป้น",
            "name_en": "Nong Tok Paen",
            "district_id": 4607,
            "lat": 16.319,
            "long": 103.406,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 4608,
        "name_th": "ห้วยเม็ก",
        "name_en": "Huai Mek",
        "province_id": 34,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 460801,
            "zip_code": 46170,
            "name_th": "ห้วยเม็ก",
            "name_en": "Huai Mek",
            "district_id": 4608,
            "lat": 16.596,
            "long": 103.216,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 460802,
            "zip_code": 46170,
            "name_th": "คำใหญ่",
            "name_en": "Kham Yai",
            "district_id": 4608,
            "lat": 16.664,
            "long": 103.177,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 460803,
            "zip_code": 46170,
            "name_th": "กุดโดน",
            "name_en": "Kut Don",
            "district_id": 4608,
            "lat": 16.544,
            "long": 103.268,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 460804,
            "zip_code": 46170,
            "name_th": "บึงนาเรียง",
            "name_en": "Bueng Na Riang",
            "district_id": 4608,
            "lat": 16.6,
            "long": 103.288,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 460805,
            "zip_code": 46170,
            "name_th": "หัวหิน",
            "name_en": "Hua Hin",
            "district_id": 4608,
            "lat": 16.602,
            "long": 103.358,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 460806,
            "zip_code": 46170,
            "name_th": "พิมูล",
            "name_en": "Phimun",
            "district_id": 4608,
            "lat": 16.703,
            "long": 103.181,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 460807,
            "zip_code": 46170,
            "name_th": "คำเหมือดแก้ว",
            "name_en": "Kham Mueat Kaeo",
            "district_id": 4608,
            "lat": 16.523,
            "long": 103.199,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 460808,
            "zip_code": 46170,
            "name_th": "โนนสะอาด",
            "name_en": "Non Sa-at",
            "district_id": 4608,
            "lat": 16.538,
            "long": 103.314,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 460809,
            "zip_code": 46170,
            "name_th": "ทรายทอง",
            "name_en": "Sai Thong",
            "district_id": 4608,
            "lat": 16.74,
            "long": 103.175,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 4609,
        "name_th": "สหัสขันธ์",
        "name_en": "Sahatsakhan",
        "province_id": 34,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 460901,
            "zip_code": 46140,
            "name_th": "ภูสิงห์",
            "name_en": "Phu Sing",
            "district_id": 4609,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 460902,
            "zip_code": 46140,
            "name_th": "สหัสขันธ์",
            "name_en": "Sahatsakhan",
            "district_id": 4609,
            "lat": 16.728,
            "long": 103.55,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 460903,
            "zip_code": 46140,
            "name_th": "นามะเขือ",
            "name_en": "Na Makhuea",
            "district_id": 4609,
            "lat": 16.678,
            "long": 103.638,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 460904,
            "zip_code": 46140,
            "name_th": "โนนศิลา",
            "name_en": "Non Sila",
            "district_id": 4609,
            "lat": 16.8,
            "long": 103.605,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 460905,
            "zip_code": 46140,
            "name_th": "นิคม",
            "name_en": "Nikhom",
            "district_id": 4609,
            "lat": 16.677,
            "long": 103.492,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 460906,
            "zip_code": 46140,
            "name_th": "โนนแหลมทอง",
            "name_en": "Non Laem Thong",
            "district_id": 4609,
            "lat": 16.751,
            "long": 103.619,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 460907,
            "zip_code": 46140,
            "name_th": "โนนบุรี",
            "name_en": "Non Buri",
            "district_id": 4609,
            "lat": 16.706,
            "long": 103.491,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 460908,
            "zip_code": 46140,
            "name_th": "โนนน้ำเกลี้ยง",
            "name_en": "Non Nam Kliang",
            "district_id": 4609,
            "lat": 16.683,
            "long": 103.538,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 4610,
        "name_th": "คำม่วง",
        "name_en": "Kham Muang",
        "province_id": 34,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 461001,
            "zip_code": 46180,
            "name_th": "ทุ่งคลอง",
            "name_en": "Thung Khlong",
            "district_id": 4610,
            "lat": 16.938,
            "long": 103.679,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 461002,
            "zip_code": 46180,
            "name_th": "โพน",
            "name_en": "Phon",
            "district_id": 4610,
            "lat": 16.841,
            "long": 103.637,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 461005,
            "zip_code": 46180,
            "name_th": "ดินจี่",
            "name_en": "Din Chi",
            "district_id": 4610,
            "lat": 16.962,
            "long": 103.719,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 461006,
            "zip_code": 46180,
            "name_th": "นาบอน",
            "name_en": "Na Bon",
            "district_id": 4610,
            "lat": 16.881,
            "long": 103.673,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 461007,
            "zip_code": 46180,
            "name_th": "นาทัน",
            "name_en": "Na Than",
            "district_id": 4610,
            "lat": 17.024,
            "long": 103.613,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 461009,
            "zip_code": 46180,
            "name_th": "เนินยาง",
            "name_en": "Noen Yang",
            "district_id": 4610,
            "lat": 16.803,
            "long": 103.655,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 4611,
        "name_th": "ท่าคันโท",
        "name_en": "Tha Khantho",
        "province_id": 34,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 461101,
            "zip_code": 46190,
            "name_th": "ท่าคันโท",
            "name_en": "Tha Khantho",
            "district_id": 4611,
            "lat": 16.869,
            "long": 103.237,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 461102,
            "zip_code": 46190,
            "name_th": "กุงเก่า",
            "name_en": "Kung Kao",
            "district_id": 4611,
            "lat": 16.87,
            "long": 103.188,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 461103,
            "zip_code": 46190,
            "name_th": "ยางอู้ม",
            "name_en": "Yang Um",
            "district_id": 4611,
            "lat": 16.902,
            "long": 103.286,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 461104,
            "zip_code": 46190,
            "name_th": "กุดจิก",
            "name_en": "Kut Chik",
            "district_id": 4611,
            "lat": 16.843,
            "long": 103.115,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 461105,
            "zip_code": 46190,
            "name_th": "นาตาล",
            "name_en": "Na Tan",
            "district_id": 4611,
            "lat": 16.847,
            "long": 103.28,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 461106,
            "zip_code": 46190,
            "name_th": "ดงสมบูรณ์",
            "name_en": "Dong Sombun",
            "district_id": 4611,
            "lat": 16.869,
            "long": 103.366,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 4612,
        "name_th": "หนองกุงศรี",
        "name_en": "Nong Kung Si",
        "province_id": 34,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 461201,
            "zip_code": 46220,
            "name_th": "หนองกุงศรี",
            "name_en": "Nong Kung Si",
            "district_id": 4612,
            "lat": 16.649,
            "long": 103.274,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 461202,
            "zip_code": 46220,
            "name_th": "หนองบัว",
            "name_en": "Nong Bua",
            "district_id": 4612,
            "lat": 16.728,
            "long": 103.376,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 461203,
            "zip_code": 46220,
            "name_th": "โคกเครือ",
            "name_en": "Khok Khruea",
            "district_id": 4612,
            "lat": 16.781,
            "long": 103.238,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 461204,
            "zip_code": 46220,
            "name_th": "หนองสรวง",
            "name_en": "Nong Suang",
            "district_id": 4612,
            "lat": 16.77,
            "long": 103.422,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 461205,
            "zip_code": 46220,
            "name_th": "เสาเล้า",
            "name_en": "Sao Lao",
            "district_id": 4612,
            "lat": 16.651,
            "long": 103.392,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 461206,
            "zip_code": 46220,
            "name_th": "หนองใหญ่",
            "name_en": "Nong Yai",
            "district_id": 4612,
            "lat": 16.701,
            "long": 103.223,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 461207,
            "zip_code": 46220,
            "name_th": "ดงมูล",
            "name_en": "Dong Mun",
            "district_id": 4612,
            "lat": 16.779,
            "long": 103.313,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 461208,
            "zip_code": 46220,
            "name_th": "ลำหนองแสน",
            "name_en": "Lam Nong Saen",
            "district_id": 4612,
            "lat": 16.678,
            "long": 103.307,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 461209,
            "zip_code": 46220,
            "name_th": "หนองหิน",
            "name_en": "Nong Hin",
            "district_id": 4612,
            "lat": 16.823,
            "long": 103.397,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 4613,
        "name_th": "สมเด็จ",
        "name_en": "Somdet",
        "province_id": 34,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 461301,
            "zip_code": 46150,
            "name_th": "สมเด็จ",
            "name_en": "Somdet",
            "district_id": 4613,
            "lat": 16.705,
            "long": 103.754,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 461302,
            "zip_code": 46150,
            "name_th": "หนองแวง",
            "name_en": "Nong Waeng",
            "district_id": 4613,
            "lat": 16.66,
            "long": 103.69,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 461303,
            "zip_code": 46150,
            "name_th": "แซงบาดาล",
            "name_en": "Saeng Badan",
            "district_id": 4613,
            "lat": 16.819,
            "long": 103.7,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 461304,
            "zip_code": 46150,
            "name_th": "มหาไชย",
            "name_en": "Maha Chai",
            "district_id": 4613,
            "lat": 16.823,
            "long": 103.783,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 461305,
            "zip_code": 46150,
            "name_th": "หมูม่น",
            "name_en": "Mu Mon",
            "district_id": 4613,
            "lat": 16.759,
            "long": 103.679,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 461306,
            "zip_code": 46150,
            "name_th": "ผาเสวย",
            "name_en": "Pha Sawoei",
            "district_id": 4613,
            "lat": 16.797,
            "long": 103.863,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 461307,
            "zip_code": 46150,
            "name_th": "ศรีสมเด็จ",
            "name_en": "Si Somdet",
            "district_id": 4613,
            "lat": 16.738,
            "long": 103.706,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 461308,
            "zip_code": 46150,
            "name_th": "ลำห้วยหลัว",
            "name_en": "Lam Huai Lua",
            "district_id": 4613,
            "lat": 16.732,
            "long": 103.815,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 4614,
        "name_th": "ห้วยผึ้ง",
        "name_en": "Huai Phueng",
        "province_id": 34,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 461401,
            "zip_code": 46240,
            "name_th": "คำบง",
            "name_en": "Kham Bong",
            "district_id": 4614,
            "lat": 16.758,
            "long": 103.912,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 461402,
            "zip_code": 46240,
            "name_th": "ไค้นุ่น",
            "name_en": "Khai Nun",
            "district_id": 4614,
            "lat": 16.612,
            "long": 103.933,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 461403,
            "zip_code": 46240,
            "name_th": "นิคมห้วยผึ้ง",
            "name_en": "Nikhom Huai Phueng",
            "district_id": 4614,
            "lat": 16.675,
            "long": 103.909,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 461404,
            "zip_code": 46240,
            "name_th": "หนองอีบุตร",
            "name_en": "Nong I But",
            "district_id": 4614,
            "lat": 16.597,
            "long": 103.873,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 4615,
        "name_th": "สามชัย",
        "name_en": "Sam Chai",
        "province_id": 34,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 461501,
            "zip_code": 46180,
            "name_th": "สำราญ",
            "name_en": "Samran",
            "district_id": 4615,
            "lat": 16.954,
            "long": 103.522,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 461502,
            "zip_code": 46180,
            "name_th": "สำราญใต้",
            "name_en": "Samran Tai",
            "district_id": 4615,
            "lat": 16.814,
            "long": 103.48,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 461503,
            "zip_code": 46180,
            "name_th": "คำสร้างเที่ยง",
            "name_en": "Kham Sang Thiang",
            "district_id": 4615,
            "lat": 16.814,
            "long": 103.546,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 461504,
            "zip_code": 46180,
            "name_th": "หนองช้าง",
            "name_en": "Nong Chang",
            "district_id": 4615,
            "lat": 16.913,
            "long": 103.571,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 4616,
        "name_th": "นาคู",
        "name_en": "Na Khu",
        "province_id": 34,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 461601,
            "zip_code": 46160,
            "name_th": "นาคู",
            "name_en": "Na Khu",
            "district_id": 4616,
            "lat": 16.808,
            "long": 104.07,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 461602,
            "zip_code": 46160,
            "name_th": "สายนาวัง",
            "name_en": "Sai Na Wang",
            "district_id": 4616,
            "lat": 16.761,
            "long": 104.063,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 461603,
            "zip_code": 46160,
            "name_th": "โนนนาจาน",
            "name_en": "Non Na Chan",
            "district_id": 4616,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 461604,
            "zip_code": 46160,
            "name_th": "บ่อแก้ว",
            "name_en": "Bo Kaeo",
            "district_id": 4616,
            "lat": 16.791,
            "long": 103.994,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 461605,
            "zip_code": 46160,
            "name_th": "ภูแล่นช้าง",
            "name_en": "Phu Laen Chang",
            "district_id": 4616,
            "lat": 16.688,
            "long": 103.97,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 4617,
        "name_th": "ดอนจาน",
        "name_en": "Don Chan",
        "province_id": 34,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 461701,
            "zip_code": 46000,
            "name_th": "ดอนจาน",
            "name_en": "Don Chan",
            "district_id": 4617,
            "lat": 16.425,
            "long": 103.696,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 461702,
            "zip_code": 46000,
            "name_th": "สะอาดไชยศรี",
            "name_en": "Sa-at Chai Si",
            "district_id": 4617,
            "lat": 16.471,
            "long": 103.773,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 461703,
            "zip_code": 46000,
            "name_th": "ดงพยุง",
            "name_en": "Dong Phayung",
            "district_id": 4617,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 461704,
            "zip_code": 46000,
            "name_th": "ม่วงนา",
            "name_en": "Muang Na",
            "district_id": 4617,
            "lat": 16.475,
            "long": 103.639,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 461705,
            "zip_code": 46000,
            "name_th": "นาจำปา",
            "name_en": "Na Champa",
            "district_id": 4617,
            "lat": 16.48,
            "long": 103.696,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 4618,
        "name_th": "ฆ้องชัย",
        "name_en": "Khong Chai",
        "province_id": 34,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 461801,
            "zip_code": 46130,
            "name_th": "ฆ้องชัยพัฒนา",
            "name_en": "Khong Chai Phatthana",
            "district_id": 4618,
            "lat": 16.257,
            "long": 103.463,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 461802,
            "zip_code": 46130,
            "name_th": "เหล่ากลาง",
            "name_en": "Lao Klang",
            "district_id": 4618,
            "lat": 16.245,
            "long": 103.515,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 461803,
            "zip_code": 46130,
            "name_th": "โคกสะอาด",
            "name_en": "Khok Sa-at",
            "district_id": 4618,
            "lat": 16.215,
            "long": 103.468,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 461804,
            "zip_code": 46130,
            "name_th": "โนนศิลาเลิง",
            "name_en": "Non Sila Loeng",
            "district_id": 4618,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 461805,
            "zip_code": 46130,
            "name_th": "ลำชี",
            "name_en": "Lam Chi",
            "district_id": 4618,
            "lat": 16.321,
            "long": 103.493,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      }
    ]
  },
  {
    "id": 35,
    "name_th": "สกลนคร",
    "name_en": "Sakon Nakhon",
    "geography_id": 3,
    "created_at": "2019-08-09T03:33:09.000+07:00",
    "updated_at": "2025-09-20T06:31:26.000+07:00",
    "deleted_at": null,
    "districts": [
      {
        "id": 4701,
        "name_th": "เมืองสกลนคร",
        "name_en": "Mueang Sakon Nakhon",
        "province_id": 35,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 470101,
            "zip_code": 47000,
            "name_th": "ธาตุเชิงชุม",
            "name_en": "That Choeng Chum",
            "district_id": 4701,
            "lat": 17.163,
            "long": 104.162,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 470102,
            "zip_code": 47220,
            "name_th": "ขมิ้น",
            "name_en": "Khamin",
            "district_id": 4701,
            "lat": 17.26,
            "long": 104.014,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 470103,
            "zip_code": 47000,
            "name_th": "งิ้วด่อน",
            "name_en": "Ngio Don",
            "district_id": 4701,
            "lat": 17.114,
            "long": 104.165,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 470104,
            "zip_code": 47000,
            "name_th": "โนนหอม",
            "name_en": "Non Hom",
            "district_id": 4701,
            "lat": 17.053,
            "long": 104.196,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 470106,
            "zip_code": 47000,
            "name_th": "เชียงเครือ",
            "name_en": "Chiang Khruea",
            "district_id": 4701,
            "lat": 17.279,
            "long": 104.123,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 470107,
            "zip_code": 47000,
            "name_th": "ท่าแร่",
            "name_en": "Tha Rae",
            "district_id": 4701,
            "lat": 17.269,
            "long": 104.207,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 470109,
            "zip_code": 47000,
            "name_th": "ม่วงลาย",
            "name_en": "Muang Lai",
            "district_id": 4701,
            "lat": 17.125,
            "long": 104.26,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 470111,
            "zip_code": 47000,
            "name_th": "ดงชน",
            "name_en": "Dong Chon",
            "district_id": 4701,
            "lat": 17.096,
            "long": 104.24,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 470112,
            "zip_code": 47000,
            "name_th": "ห้วยยาง",
            "name_en": "Huai Yang",
            "district_id": 4701,
            "lat": 17.095,
            "long": 104.033,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 470113,
            "zip_code": 47000,
            "name_th": "พังขว้าง",
            "name_en": "Phang Khwang",
            "district_id": 4701,
            "lat": 17.177,
            "long": 104.017,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 470115,
            "zip_code": 47000,
            "name_th": "ดงมะไฟ",
            "name_en": "Dong Mafai",
            "district_id": 4701,
            "lat": 17.059,
            "long": 104.105,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 470116,
            "zip_code": 47000,
            "name_th": "ธาตุนาเวง",
            "name_en": "That Na Weng",
            "district_id": 4701,
            "lat": 17.147,
            "long": 104.095,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 470117,
            "zip_code": 47000,
            "name_th": "เหล่าปอแดง",
            "name_en": "Lao Po Daeng",
            "district_id": 4701,
            "lat": 17.137,
            "long": 104.212,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 470118,
            "zip_code": 47220,
            "name_th": "หนองลาด",
            "name_en": "Nong Lat",
            "district_id": 4701,
            "lat": 17.337,
            "long": 104.072,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 470120,
            "zip_code": 47000,
            "name_th": "ฮางโฮง",
            "name_en": "Hang Hong",
            "district_id": 4701,
            "lat": 17.22,
            "long": 104.122,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 470121,
            "zip_code": 47000,
            "name_th": "โคกก่อง",
            "name_en": "Khok Kong",
            "district_id": 4701,
            "lat": 17.133,
            "long": 104.294,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 4702,
        "name_th": "กุสุมาลย์",
        "name_en": "Kusuman",
        "province_id": 35,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 470201,
            "zip_code": 47210,
            "name_th": "กุสุมาลย์",
            "name_en": "Kusuman",
            "district_id": 4702,
            "lat": 17.302,
            "long": 104.386,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 470202,
            "zip_code": 47210,
            "name_th": "นาโพธิ์",
            "name_en": "Na Pho",
            "district_id": 4702,
            "lat": 17.352,
            "long": 104.287,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 470203,
            "zip_code": 47230,
            "name_th": "นาเพียง",
            "name_en": "Na Phiang",
            "district_id": 4702,
            "lat": 17.367,
            "long": 104.216,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 470204,
            "zip_code": 47210,
            "name_th": "โพธิไพศาล",
            "name_en": "Phothi Phaisan",
            "district_id": 4702,
            "lat": 17.379,
            "long": 104.378,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 470205,
            "zip_code": 47230,
            "name_th": "อุ่มจาน",
            "name_en": "Um Chan",
            "district_id": 4702,
            "lat": 17.35,
            "long": 104.137,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 4703,
        "name_th": "กุดบาก",
        "name_en": "Kut Bak",
        "province_id": 35,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 470301,
            "zip_code": 47180,
            "name_th": "กุดบาก",
            "name_en": "Kut Bak",
            "district_id": 4703,
            "lat": 17.051,
            "long": 103.762,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 470303,
            "zip_code": 47180,
            "name_th": "นาม่อง",
            "name_en": "Na Mong",
            "district_id": 4703,
            "lat": 17.093,
            "long": 103.906,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 470305,
            "zip_code": 47180,
            "name_th": "กุดไห",
            "name_en": "Kut Hai",
            "district_id": 4703,
            "lat": 17.1,
            "long": 103.696,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 4704,
        "name_th": "พรรณานิคม",
        "name_en": "Phanna Nikhom",
        "province_id": 35,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 470401,
            "zip_code": 47130,
            "name_th": "พรรณา",
            "name_en": "Phanna",
            "district_id": 4704,
            "lat": 17.356,
            "long": 103.856,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 470402,
            "zip_code": 47130,
            "name_th": "วังยาง",
            "name_en": "Wang Yang",
            "district_id": 4704,
            "lat": 17.341,
            "long": 103.911,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 470403,
            "zip_code": 47220,
            "name_th": "พอกน้อย",
            "name_en": "Phok Noi",
            "district_id": 4704,
            "lat": 17.315,
            "long": 103.952,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 470404,
            "zip_code": 47220,
            "name_th": "นาหัวบ่อ",
            "name_en": "Na Hua Bo",
            "district_id": 4704,
            "lat": 17.226,
            "long": 103.917,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 470405,
            "zip_code": 47130,
            "name_th": "ไร่",
            "name_en": "Rai",
            "district_id": 4704,
            "lat": 17.274,
            "long": 103.846,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 470406,
            "zip_code": 47130,
            "name_th": "ช้างมิ่ง",
            "name_en": "Chang Ming",
            "district_id": 4704,
            "lat": 17.342,
            "long": 103.796,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 470407,
            "zip_code": 47130,
            "name_th": "นาใน",
            "name_en": "Na Nai",
            "district_id": 4704,
            "lat": 17.207,
            "long": 103.821,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 470408,
            "zip_code": 47130,
            "name_th": "สว่าง",
            "name_en": "Sawang",
            "district_id": 4704,
            "lat": 17.367,
            "long": 103.981,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 470409,
            "zip_code": 47130,
            "name_th": "บะฮี",
            "name_en": "Ba Hi",
            "district_id": 4704,
            "lat": 17.426,
            "long": 103.901,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 470410,
            "zip_code": 47130,
            "name_th": "เชิงชุม",
            "name_en": "Choeng Chum",
            "district_id": 4704,
            "lat": 17.435,
            "long": 104.007,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 4705,
        "name_th": "พังโคน",
        "name_en": "Phang Khon",
        "province_id": 35,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 470501,
            "zip_code": 47160,
            "name_th": "พังโคน",
            "name_en": "Phang Khon",
            "district_id": 4705,
            "lat": 17.39,
            "long": 103.704,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 470502,
            "zip_code": 47160,
            "name_th": "ม่วงไข่",
            "name_en": "Muang Khai",
            "district_id": 4705,
            "lat": 17.405,
            "long": 103.665,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 470503,
            "zip_code": 47160,
            "name_th": "แร่",
            "name_en": "Rae",
            "district_id": 4705,
            "lat": 17.297,
            "long": 103.767,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 470504,
            "zip_code": 47160,
            "name_th": "ไฮหย่อง",
            "name_en": "Hai Yong",
            "district_id": 4705,
            "lat": 17.406,
            "long": 103.765,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 470505,
            "zip_code": 47160,
            "name_th": "ต้นผึ้ง",
            "name_en": "Ton Phueng",
            "district_id": 4705,
            "lat": 17.432,
            "long": 103.827,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 4706,
        "name_th": "วาริชภูมิ",
        "name_en": "Waritchaphum",
        "province_id": 35,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 470601,
            "zip_code": 47150,
            "name_th": "วาริชภูมิ",
            "name_en": "Waritchaphum",
            "district_id": 4706,
            "lat": 17.232,
            "long": 103.642,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 470602,
            "zip_code": 47150,
            "name_th": "ปลาโหล",
            "name_en": "Pla Lo",
            "district_id": 4706,
            "lat": 17.327,
            "long": 103.671,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 470603,
            "zip_code": 47150,
            "name_th": "หนองลาด",
            "name_en": "Nong Lat",
            "district_id": 4706,
            "lat": 17.319,
            "long": 103.543,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 470604,
            "zip_code": 47150,
            "name_th": "คำบ่อ",
            "name_en": "Kham Bo",
            "district_id": 4706,
            "lat": 17.225,
            "long": 103.551,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 470605,
            "zip_code": 47150,
            "name_th": "ค้อเขียว",
            "name_en": "Kho Khiao",
            "district_id": 4706,
            "lat": 17.276,
            "long": 103.527,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 4707,
        "name_th": "นิคมน้ำอูน",
        "name_en": "Nikhom Nam Un",
        "province_id": 35,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 470701,
            "zip_code": 47270,
            "name_th": "นิคมน้ำอูน",
            "name_en": "Nikhom Nam Un",
            "district_id": 4707,
            "lat": 17.142,
            "long": 103.645,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 470702,
            "zip_code": 47270,
            "name_th": "หนองปลิง",
            "name_en": "Nong Pling",
            "district_id": 4707,
            "lat": 17.18,
            "long": 103.749,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 470703,
            "zip_code": 47270,
            "name_th": "หนองบัว",
            "name_en": "Nong Bua",
            "district_id": 4707,
            "lat": 17.148,
            "long": 103.827,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 470704,
            "zip_code": 47270,
            "name_th": "สุวรรณคาม",
            "name_en": "*Suwannakarm",
            "district_id": 4707,
            "lat": 17.155,
            "long": 103.712,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 4708,
        "name_th": "วานรนิวาส",
        "name_en": "Wanon Niwat",
        "province_id": 35,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 470801,
            "zip_code": 47120,
            "name_th": "วานรนิวาส",
            "name_en": "Wanon Niwat",
            "district_id": 4708,
            "lat": 17.645,
            "long": 103.752,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 470802,
            "zip_code": 47120,
            "name_th": "เดื่อศรีคันไชย",
            "name_en": "Duea Si Khan Chai",
            "district_id": 4708,
            "lat": 17.473,
            "long": 103.73,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 470803,
            "zip_code": 47120,
            "name_th": "ขัวก่าย",
            "name_en": "Khua Kai",
            "district_id": 4708,
            "lat": 17.579,
            "long": 103.814,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 470804,
            "zip_code": 47120,
            "name_th": "หนองสนม",
            "name_en": "Nong Sanom",
            "district_id": 4708,
            "lat": 17.526,
            "long": 103.86,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 470805,
            "zip_code": 47120,
            "name_th": "คูสะคาม",
            "name_en": "Khu Sakham",
            "district_id": 4708,
            "lat": 17.727,
            "long": 103.61,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 470806,
            "zip_code": 47120,
            "name_th": "ธาตุ",
            "name_en": "That",
            "district_id": 4708,
            "lat": 17.641,
            "long": 103.651,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 470807,
            "zip_code": 47120,
            "name_th": "หนองแวง",
            "name_en": "Nong Waeng",
            "district_id": 4708,
            "lat": 17.767,
            "long": 103.726,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 470808,
            "zip_code": 47120,
            "name_th": "ศรีวิชัย",
            "name_en": "Si Wichai",
            "district_id": 4708,
            "lat": 17.536,
            "long": 103.68,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 470809,
            "zip_code": 47120,
            "name_th": "นาซอ",
            "name_en": "Na So",
            "district_id": 4708,
            "lat": 17.674,
            "long": 103.848,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 470810,
            "zip_code": 47120,
            "name_th": "อินทร์แปลง",
            "name_en": "In Plaeng",
            "district_id": 4708,
            "lat": 17.787,
            "long": 103.593,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 470811,
            "zip_code": 47120,
            "name_th": "นาคำ",
            "name_en": "Na Kham",
            "district_id": 4708,
            "lat": 17.692,
            "long": 103.792,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 470812,
            "zip_code": 47120,
            "name_th": "คอนสวรรค์",
            "name_en": "Khon Sawan",
            "district_id": 4708,
            "lat": 17.593,
            "long": 103.748,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 470813,
            "zip_code": 47120,
            "name_th": "กุดเรือคำ",
            "name_en": "Kut Ruea Kham",
            "district_id": 4708,
            "lat": 17.76,
            "long": 103.646,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 470814,
            "zip_code": 47120,
            "name_th": "หนองแวงใต้",
            "name_en": "Nong Waeng Tai",
            "district_id": 4708,
            "lat": 17.724,
            "long": 103.76,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 4709,
        "name_th": "คำตากล้า",
        "name_en": "Kham Ta Kla",
        "province_id": 35,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 470901,
            "zip_code": 47250,
            "name_th": "คำตากล้า",
            "name_en": "Kham Ta Kla",
            "district_id": 4709,
            "lat": 17.834,
            "long": 103.754,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 470902,
            "zip_code": 47250,
            "name_th": "หนองบัวสิม",
            "name_en": "Nong Bua Sim",
            "district_id": 4709,
            "lat": 17.841,
            "long": 103.859,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 470903,
            "zip_code": 47250,
            "name_th": "นาแต้",
            "name_en": "Na Tae",
            "district_id": 4709,
            "lat": 17.866,
            "long": 103.699,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 470904,
            "zip_code": 47250,
            "name_th": "แพด",
            "name_en": "Phaet",
            "district_id": 4709,
            "lat": 17.775,
            "long": 103.842,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 4710,
        "name_th": "บ้านม่วง",
        "name_en": "Ban Muang",
        "province_id": 35,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 471001,
            "zip_code": 47140,
            "name_th": "ม่วง",
            "name_en": "Muang",
            "district_id": 4710,
            "lat": 17.858,
            "long": 103.561,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 471002,
            "zip_code": 47140,
            "name_th": "มาย",
            "name_en": "Mai",
            "district_id": 4710,
            "lat": 17.855,
            "long": 103.48,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 471003,
            "zip_code": 47140,
            "name_th": "ดงหม้อทอง",
            "name_en": "Dong Mo Thong",
            "district_id": 4710,
            "lat": 17.995,
            "long": 103.528,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 471004,
            "zip_code": 47140,
            "name_th": "ดงเหนือ",
            "name_en": "Dong Nuea",
            "district_id": 4710,
            "lat": 17.985,
            "long": 103.584,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 471005,
            "zip_code": 47140,
            "name_th": "ดงหม้อทองใต้",
            "name_en": "Dong Mo Thong Tai",
            "district_id": 4710,
            "lat": 17.932,
            "long": 103.441,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 471006,
            "zip_code": 47140,
            "name_th": "ห้วยหลัว",
            "name_en": "Huai Lua",
            "district_id": 4710,
            "lat": 17.795,
            "long": 103.416,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 471007,
            "zip_code": 47140,
            "name_th": "โนนสะอาด",
            "name_en": "Non Sa-at",
            "district_id": 4710,
            "lat": 17.929,
            "long": 103.653,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 471008,
            "zip_code": 47140,
            "name_th": "หนองกวั่ง",
            "name_en": "Nong Kwang",
            "district_id": 4710,
            "lat": 17.796,
            "long": 103.487,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 471009,
            "zip_code": 47140,
            "name_th": "บ่อแก้ว",
            "name_en": "Bo Kaeo",
            "district_id": 4710,
            "lat": 17.863,
            "long": 103.626,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 4711,
        "name_th": "อากาศอำนวย",
        "name_en": "Akat Amnuai",
        "province_id": 35,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 471101,
            "zip_code": 47170,
            "name_th": "อากาศ",
            "name_en": "Akat",
            "district_id": 4711,
            "lat": 17.572,
            "long": 104.013,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 471102,
            "zip_code": 47170,
            "name_th": "โพนแพง",
            "name_en": "Phon Phaeng",
            "district_id": 4711,
            "lat": 17.538,
            "long": 103.956,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 471103,
            "zip_code": 47170,
            "name_th": "วาใหญ่",
            "name_en": "Wa Yai",
            "district_id": 4711,
            "lat": 17.63,
            "long": 103.926,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 471104,
            "zip_code": 47170,
            "name_th": "โพนงาม",
            "name_en": "Phon Ngam",
            "district_id": 4711,
            "lat": 17.757,
            "long": 104.006,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 471105,
            "zip_code": 47170,
            "name_th": "ท่าก้อน",
            "name_en": "Tha Kon",
            "district_id": 4711,
            "lat": 17.759,
            "long": 103.961,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 471106,
            "zip_code": 47170,
            "name_th": "นาฮี",
            "name_en": "Na Hi",
            "district_id": 4711,
            "lat": 17.718,
            "long": 103.92,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 471107,
            "zip_code": 47170,
            "name_th": "บะหว้า",
            "name_en": "Ba Wa",
            "district_id": 4711,
            "lat": 17.495,
            "long": 103.987,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 471108,
            "zip_code": 47170,
            "name_th": "สามัคคีพัฒนา",
            "name_en": "Samakkhi Phatthana",
            "district_id": 4711,
            "lat": 17.669,
            "long": 104.019,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 4712,
        "name_th": "สว่างแดนดิน",
        "name_en": "Sawang Daen Din",
        "province_id": 35,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 471201,
            "zip_code": 47110,
            "name_th": "สว่างแดนดิน",
            "name_en": "Sawang Daen Din",
            "district_id": 4712,
            "lat": 17.448,
            "long": 103.462,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 471203,
            "zip_code": 47110,
            "name_th": "คำสะอาด",
            "name_en": "Kham Sa-at",
            "district_id": 4712,
            "lat": 17.511,
            "long": 103.351,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 471204,
            "zip_code": 47110,
            "name_th": "บ้านต้าย",
            "name_en": "Ban Tai",
            "district_id": 4712,
            "lat": 17.441,
            "long": 103.385,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 471206,
            "zip_code": 47110,
            "name_th": "บงเหนือ",
            "name_en": "Bong Nuea",
            "district_id": 4712,
            "lat": 17.319,
            "long": 103.301,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 471207,
            "zip_code": 47110,
            "name_th": "โพนสูง",
            "name_en": "Phon Sung",
            "district_id": 4712,
            "lat": 17.538,
            "long": 103.4,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 471208,
            "zip_code": 47110,
            "name_th": "โคกสี",
            "name_en": "Khok Si",
            "district_id": 4712,
            "lat": 17.605,
            "long": 103.446,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 471210,
            "zip_code": 47110,
            "name_th": "หนองหลวง",
            "name_en": "Nong Luang",
            "district_id": 4712,
            "lat": 17.377,
            "long": 103.383,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 471211,
            "zip_code": 47110,
            "name_th": "บงใต้",
            "name_en": "Bong Tai",
            "district_id": 4712,
            "lat": 17.422,
            "long": 103.327,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 471212,
            "zip_code": 47110,
            "name_th": "ค้อใต้",
            "name_en": "Kho Tai",
            "district_id": 4712,
            "lat": 17.368,
            "long": 103.33,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 471213,
            "zip_code": 47240,
            "name_th": "พันนา",
            "name_en": "Phan Na",
            "district_id": 4712,
            "lat": 17.416,
            "long": 103.569,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 471214,
            "zip_code": 47240,
            "name_th": "แวง",
            "name_en": "Waeng",
            "district_id": 4712,
            "lat": 17.456,
            "long": 103.63,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 471215,
            "zip_code": 47110,
            "name_th": "ทรายมูล",
            "name_en": "Sai Mun",
            "district_id": 4712,
            "lat": 17.47,
            "long": 103.526,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 471216,
            "zip_code": 47240,
            "name_th": "ตาลโกน",
            "name_en": "Tan Kon",
            "district_id": 4712,
            "lat": 17.345,
            "long": 103.564,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 471217,
            "zip_code": 47240,
            "name_th": "ตาลเนิ้ง",
            "name_en": "Tan Noeng",
            "district_id": 4712,
            "lat": 17.346,
            "long": 103.611,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 471220,
            "zip_code": 47240,
            "name_th": "ธาตุทอง",
            "name_en": "That Thong",
            "district_id": 4712,
            "lat": 17.494,
            "long": 103.579,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 471221,
            "zip_code": 47110,
            "name_th": "บ้านถ่อน",
            "name_en": "Ban Thon",
            "district_id": 4712,
            "lat": 17.532,
            "long": 103.452,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 4713,
        "name_th": "ส่องดาว",
        "name_en": "Song Dao",
        "province_id": 35,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 471301,
            "zip_code": 47190,
            "name_th": "ส่องดาว",
            "name_en": "Song Dao",
            "district_id": 4713,
            "lat": 17.35,
            "long": 103.449,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 471302,
            "zip_code": 47190,
            "name_th": "ท่าศิลา",
            "name_en": "Tha Sila",
            "district_id": 4713,
            "lat": 17.284,
            "long": 103.387,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 471303,
            "zip_code": 47190,
            "name_th": "วัฒนา",
            "name_en": "Watthana",
            "district_id": 4713,
            "lat": 17.362,
            "long": 103.54,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 471304,
            "zip_code": 47190,
            "name_th": "ปทุมวาปี",
            "name_en": "Pathum Wapi",
            "district_id": 4713,
            "lat": 17.298,
            "long": 103.482,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 4714,
        "name_th": "เต่างอย",
        "name_en": "Tao Ngoi",
        "province_id": 35,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 471401,
            "zip_code": 47260,
            "name_th": "เต่างอย",
            "name_en": "Tao Ngoi",
            "district_id": 4714,
            "lat": 16.944,
            "long": 104.242,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 471402,
            "zip_code": 47260,
            "name_th": "บึงทวาย",
            "name_en": "Bueng Thawai",
            "district_id": 4714,
            "lat": 17.034,
            "long": 104.157,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 471403,
            "zip_code": 47260,
            "name_th": "นาตาล",
            "name_en": "Na Tan",
            "district_id": 4714,
            "lat": 16.973,
            "long": 104.116,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 471404,
            "zip_code": 47260,
            "name_th": "จันทร์เพ็ญ",
            "name_en": "Chan Phen",
            "district_id": 4714,
            "lat": 16.925,
            "long": 104.155,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 4715,
        "name_th": "โคกศรีสุพรรณ",
        "name_en": "Khok Si Suphan",
        "province_id": 35,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 471501,
            "zip_code": 47280,
            "name_th": "ตองโขบ",
            "name_en": "Tong Khop",
            "district_id": 4715,
            "lat": 17.01,
            "long": 104.257,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 471502,
            "zip_code": 47280,
            "name_th": "เหล่าโพนค้อ",
            "name_en": "Lao Phon Kho",
            "district_id": 4715,
            "lat": 17.0,
            "long": 104.331,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 471503,
            "zip_code": 47280,
            "name_th": "ด่านม่วงคำ",
            "name_en": "Dan Muang Kham",
            "district_id": 4715,
            "lat": 17.096,
            "long": 104.32,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 471504,
            "zip_code": 47280,
            "name_th": "แมดนาท่ม",
            "name_en": "Maet Na Thom",
            "district_id": 4715,
            "lat": 17.045,
            "long": 104.347,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 4716,
        "name_th": "เจริญศิลป์",
        "name_en": "Charoen Sin",
        "province_id": 35,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 471601,
            "zip_code": 47290,
            "name_th": "บ้านเหล่า",
            "name_en": "Ban Lao",
            "district_id": 4716,
            "lat": 17.699,
            "long": 103.524,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 471602,
            "zip_code": 47290,
            "name_th": "เจริญศิลป์",
            "name_en": "Charoen Sin",
            "district_id": 4716,
            "lat": 17.568,
            "long": 103.561,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 471603,
            "zip_code": 47290,
            "name_th": "ทุ่งแก",
            "name_en": "Thung Kae",
            "district_id": 4716,
            "lat": 17.602,
            "long": 103.528,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 471604,
            "zip_code": 47290,
            "name_th": "โคกศิลา",
            "name_en": "Khok Sila",
            "district_id": 4716,
            "lat": 17.536,
            "long": 103.605,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 471605,
            "zip_code": 47290,
            "name_th": "หนองแปน",
            "name_en": "Nong Paen",
            "district_id": 4716,
            "lat": 17.706,
            "long": 103.443,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 4717,
        "name_th": "โพนนาแก้ว",
        "name_en": "Phon Na Kaeo",
        "province_id": 35,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 471701,
            "zip_code": 47230,
            "name_th": "บ้านโพน",
            "name_en": "Ban Phon",
            "district_id": 4717,
            "lat": 17.219,
            "long": 104.375,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 471702,
            "zip_code": 47230,
            "name_th": "นาแก้ว",
            "name_en": "Na Kaeo",
            "district_id": 4717,
            "lat": 17.268,
            "long": 104.239,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 471703,
            "zip_code": 47230,
            "name_th": "นาตงวัฒนา",
            "name_en": "Na Tong Watthana",
            "district_id": 4717,
            "lat": 17.242,
            "long": 104.341,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 471704,
            "zip_code": 47230,
            "name_th": "บ้านแป้น",
            "name_en": "Ban Paen",
            "district_id": 4717,
            "lat": 17.196,
            "long": 104.234,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 471705,
            "zip_code": 47230,
            "name_th": "เชียงสือ",
            "name_en": "Chiang Sue",
            "district_id": 4717,
            "lat": 17.137,
            "long": 104.361,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 4718,
        "name_th": "ภูพาน",
        "name_en": "Phu Phan",
        "province_id": 35,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 471801,
            "zip_code": 47180,
            "name_th": "สร้างค้อ",
            "name_en": "Sang Kho",
            "district_id": 4718,
            "lat": 16.883,
            "long": 103.918,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 471802,
            "zip_code": 47180,
            "name_th": "หลุบเลา",
            "name_en": "Lup Lao",
            "district_id": 4718,
            "lat": 16.881,
            "long": 104.022,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 471803,
            "zip_code": 47180,
            "name_th": "โคกภู",
            "name_en": "Khok Phu",
            "district_id": 4718,
            "lat": 16.972,
            "long": 103.859,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 471804,
            "zip_code": 47180,
            "name_th": "กกปลาซิว",
            "name_en": "Kok Pla Sio",
            "district_id": 4718,
            "lat": 16.969,
            "long": 104.042,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      }
    ]
  },
  {
    "id": 36,
    "name_th": "นครพนม",
    "name_en": "Nakhon Phanom",
    "geography_id": 3,
    "created_at": "2019-08-09T03:33:09.000+07:00",
    "updated_at": "2025-09-20T06:31:26.000+07:00",
    "deleted_at": null,
    "districts": [
      {
        "id": 4801,
        "name_th": "เมืองนครพนม",
        "name_en": "Mueang Nakhon Phanom",
        "province_id": 36,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 480101,
            "zip_code": 48000,
            "name_th": "ในเมือง",
            "name_en": "Nai Mueang",
            "district_id": 4801,
            "lat": 17.409,
            "long": 104.781,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 480102,
            "zip_code": 48000,
            "name_th": "หนองแสง",
            "name_en": "Nong Saeng",
            "district_id": 4801,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 480103,
            "zip_code": 48000,
            "name_th": "นาทราย",
            "name_en": "Na Sai",
            "district_id": 4801,
            "lat": 17.401,
            "long": 104.65,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 480104,
            "zip_code": 48000,
            "name_th": "นาราชควาย",
            "name_en": "Na Rat Khwai",
            "district_id": 4801,
            "lat": 17.416,
            "long": 104.707,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 480105,
            "zip_code": 48000,
            "name_th": "กุรุคุ",
            "name_en": "Kurukhu",
            "district_id": 4801,
            "lat": 17.338,
            "long": 104.545,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 480106,
            "zip_code": 48000,
            "name_th": "บ้านผึ้ง",
            "name_en": "Ban Phueng",
            "district_id": 4801,
            "lat": 17.336,
            "long": 104.631,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 480107,
            "zip_code": 48000,
            "name_th": "อาจสามารถ",
            "name_en": "At Samat",
            "district_id": 4801,
            "lat": 17.461,
            "long": 104.725,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 480108,
            "zip_code": 48000,
            "name_th": "ขามเฒ่า",
            "name_en": "Kham Thao",
            "district_id": 4801,
            "lat": 17.263,
            "long": 104.764,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 480109,
            "zip_code": 48000,
            "name_th": "บ้านกลาง",
            "name_en": "Ban Klang",
            "district_id": 4801,
            "lat": 17.157,
            "long": 104.784,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 480110,
            "zip_code": 48000,
            "name_th": "ท่าค้อ",
            "name_en": "Tha Kho",
            "district_id": 4801,
            "lat": 17.316,
            "long": 104.746,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 480111,
            "zip_code": 48000,
            "name_th": "คำเตย",
            "name_en": "Kham Toei",
            "district_id": 4801,
            "lat": 17.21,
            "long": 104.709,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 480112,
            "zip_code": 48000,
            "name_th": "หนองญาติ",
            "name_en": "Nong Yat",
            "district_id": 4801,
            "lat": 17.342,
            "long": 104.732,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 480113,
            "zip_code": 48000,
            "name_th": "ดงขวาง",
            "name_en": "Dong Khwang",
            "district_id": 4801,
            "lat": 17.207,
            "long": 104.782,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 480114,
            "zip_code": 48000,
            "name_th": "วังตามัว",
            "name_en": "Wang Ta Mua",
            "district_id": 4801,
            "lat": 17.312,
            "long": 104.492,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 480115,
            "zip_code": 48000,
            "name_th": "โพธิ์ตาก",
            "name_en": "Pho Tak",
            "district_id": 4801,
            "lat": 17.344,
            "long": 104.69,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 4802,
        "name_th": "ปลาปาก",
        "name_en": "Pla Pak",
        "province_id": 36,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 480201,
            "zip_code": 48160,
            "name_th": "ปลาปาก",
            "name_en": "Pla Pak",
            "district_id": 4802,
            "lat": 17.197,
            "long": 104.515,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 480202,
            "zip_code": 48160,
            "name_th": "หนองฮี",
            "name_en": "Nong Hi",
            "district_id": 4802,
            "lat": 17.128,
            "long": 104.587,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 480203,
            "zip_code": 48160,
            "name_th": "กุตาไก้",
            "name_en": "Kutakai",
            "district_id": 4802,
            "lat": 17.217,
            "long": 104.608,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 480204,
            "zip_code": 48160,
            "name_th": "โคกสว่าง",
            "name_en": "Khok Sawan",
            "district_id": 4802,
            "lat": 17.145,
            "long": 104.465,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 480205,
            "zip_code": 48160,
            "name_th": "โคกสูง",
            "name_en": "Khok Sung",
            "district_id": 4802,
            "lat": 17.178,
            "long": 104.413,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 480206,
            "zip_code": 48160,
            "name_th": "มหาชัย",
            "name_en": "Maha Chai",
            "district_id": 4802,
            "lat": 17.247,
            "long": 104.492,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 480207,
            "zip_code": 48160,
            "name_th": "นามะเขือ",
            "name_en": "Na Makhuea",
            "district_id": 4802,
            "lat": 17.273,
            "long": 104.654,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 480208,
            "zip_code": 48160,
            "name_th": "หนองเทาใหญ่",
            "name_en": "Nong Thao Yai",
            "district_id": 4802,
            "lat": 17.121,
            "long": 104.523,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 4803,
        "name_th": "ท่าอุเทน",
        "name_en": "Tha Uthen",
        "province_id": 36,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 480301,
            "zip_code": 48120,
            "name_th": "ท่าอุเทน",
            "name_en": "Tha Uthen",
            "district_id": 4803,
            "lat": 17.576,
            "long": 104.591,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 480302,
            "zip_code": 48120,
            "name_th": "โนนตาล",
            "name_en": "Non Tan",
            "district_id": 4803,
            "lat": 17.534,
            "long": 104.598,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 480303,
            "zip_code": 48120,
            "name_th": "ท่าจำปา",
            "name_en": "Tha Champa",
            "district_id": 4803,
            "lat": 17.592,
            "long": 104.494,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 480304,
            "zip_code": 48120,
            "name_th": "ไชยบุรี",
            "name_en": "Chai Buri",
            "district_id": 4803,
            "lat": 17.636,
            "long": 104.433,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 480305,
            "zip_code": 48120,
            "name_th": "พนอม",
            "name_en": "Phanom",
            "district_id": 4803,
            "lat": 17.697,
            "long": 104.393,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 480306,
            "zip_code": 48120,
            "name_th": "พะทาย",
            "name_en": "Phathai",
            "district_id": 4803,
            "lat": 17.756,
            "long": 104.316,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 480311,
            "zip_code": 48120,
            "name_th": "เวินพระบาท",
            "name_en": "Woen Phra Bat",
            "district_id": 4803,
            "lat": 17.509,
            "long": 104.676,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 480312,
            "zip_code": 48120,
            "name_th": "รามราช",
            "name_en": "Ram Rat",
            "district_id": 4803,
            "lat": 17.468,
            "long": 104.635,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 480314,
            "zip_code": 48120,
            "name_th": "หนองเทา",
            "name_en": "Nong Thao",
            "district_id": 4803,
            "lat": 17.783,
            "long": 104.352,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 4804,
        "name_th": "บ้านแพง",
        "name_en": "Ban Phaeng",
        "province_id": 36,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 480401,
            "zip_code": 48140,
            "name_th": "บ้านแพง",
            "name_en": "Ban Phaeng",
            "district_id": 4804,
            "lat": 17.967,
            "long": 104.215,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 480402,
            "zip_code": 48140,
            "name_th": "ไผ่ล้อม",
            "name_en": "Phai Lom",
            "district_id": 4804,
            "lat": 17.989,
            "long": 104.154,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 480403,
            "zip_code": 48140,
            "name_th": "โพนทอง",
            "name_en": "Phon Thong",
            "district_id": 4804,
            "lat": 17.876,
            "long": 104.217,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 480404,
            "zip_code": 48140,
            "name_th": "หนองแวง",
            "name_en": "Nong Waeng",
            "district_id": 4804,
            "lat": 17.785,
            "long": 104.233,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 480408,
            "zip_code": 48140,
            "name_th": "นางัว",
            "name_en": "Na Ngua",
            "district_id": 4804,
            "lat": 17.943,
            "long": 104.182,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 480409,
            "zip_code": 48140,
            "name_th": "นาเข",
            "name_en": "Na Khe",
            "district_id": 4804,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 4805,
        "name_th": "ธาตุพนม",
        "name_en": "That Phanom",
        "province_id": 36,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 480501,
            "zip_code": 48110,
            "name_th": "ธาตุพนม",
            "name_en": "That Phanom",
            "district_id": 4805,
            "lat": 16.939,
            "long": 104.72,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 480502,
            "zip_code": 48110,
            "name_th": "ฝั่งแดง",
            "name_en": "Fang Daeng",
            "district_id": 4805,
            "lat": 16.914,
            "long": 104.675,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 480503,
            "zip_code": 48110,
            "name_th": "โพนแพง",
            "name_en": "Phon Phaeng",
            "district_id": 4805,
            "lat": 17.148,
            "long": 104.695,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 480504,
            "zip_code": 48110,
            "name_th": "พระกลางทุ่ง",
            "name_en": "Phra Klang Thung",
            "district_id": 4805,
            "lat": 16.986,
            "long": 104.699,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 480505,
            "zip_code": 48110,
            "name_th": "นาถ่อน",
            "name_en": "Na Thon",
            "district_id": 4805,
            "lat": 17.137,
            "long": 104.744,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 480506,
            "zip_code": 48110,
            "name_th": "แสนพัน",
            "name_en": "Saen Phan",
            "district_id": 4805,
            "lat": 17.066,
            "long": 104.749,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 480507,
            "zip_code": 48110,
            "name_th": "ดอนนางหงส์",
            "name_en": "Don Nang Hong",
            "district_id": 4805,
            "lat": 17.097,
            "long": 104.743,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 480508,
            "zip_code": 48110,
            "name_th": "น้ำก่ำ",
            "name_en": "Nam Kam",
            "district_id": 4805,
            "lat": 16.872,
            "long": 104.723,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 480509,
            "zip_code": 48110,
            "name_th": "อุ่มเหม้า",
            "name_en": "Um Mao",
            "district_id": 4805,
            "lat": 16.839,
            "long": 104.67,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 480510,
            "zip_code": 48110,
            "name_th": "นาหนาด",
            "name_en": "Na Nat",
            "district_id": 4805,
            "lat": 16.915,
            "long": 104.654,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 480511,
            "zip_code": 48110,
            "name_th": "กุดฉิม",
            "name_en": "Kut Chim",
            "district_id": 4805,
            "lat": 17.059,
            "long": 104.726,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 480512,
            "zip_code": 48110,
            "name_th": "ธาตุพนมเหนือ",
            "name_en": "That Phanom Nuea",
            "district_id": 4805,
            "lat": 16.975,
            "long": 104.667,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 4806,
        "name_th": "เรณูนคร",
        "name_en": "Renu Nakhon",
        "province_id": 36,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 480601,
            "zip_code": 48170,
            "name_th": "เรณู",
            "name_en": "Renu",
            "district_id": 4806,
            "lat": 17.081,
            "long": 104.644,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 480602,
            "zip_code": 48170,
            "name_th": "โพนทอง",
            "name_en": "Phon Thong",
            "district_id": 4806,
            "lat": 17.068,
            "long": 104.697,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 480603,
            "zip_code": 48170,
            "name_th": "ท่าลาด",
            "name_en": "Tha Lat",
            "district_id": 4806,
            "lat": 17.007,
            "long": 104.589,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 480604,
            "zip_code": 48170,
            "name_th": "นางาม",
            "name_en": "Na Ngam",
            "district_id": 4806,
            "lat": 17.106,
            "long": 104.672,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 480605,
            "zip_code": 48170,
            "name_th": "โคกหินแฮ่",
            "name_en": "Khok Hin Hae",
            "district_id": 4806,
            "lat": 17.046,
            "long": 104.628,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 480607,
            "zip_code": 48170,
            "name_th": "หนองย่างชิ้น",
            "name_en": "Nong Yang Chin",
            "district_id": 4806,
            "lat": 17.019,
            "long": 104.698,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 480608,
            "zip_code": 48170,
            "name_th": "เรณูใต้",
            "name_en": "Renu Tai",
            "district_id": 4806,
            "lat": 17.019,
            "long": 104.66,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 480609,
            "zip_code": 48170,
            "name_th": "นาขาม",
            "name_en": "Na Kham",
            "district_id": 4806,
            "lat": 16.984,
            "long": 104.63,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 4807,
        "name_th": "นาแก",
        "name_en": "Na Kae",
        "province_id": 36,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 480701,
            "zip_code": 48130,
            "name_th": "นาแก",
            "name_en": "Na Kae",
            "district_id": 4807,
            "lat": 16.897,
            "long": 104.495,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 480702,
            "zip_code": 48130,
            "name_th": "พระซอง",
            "name_en": "Phra Song",
            "district_id": 4807,
            "lat": 17.021,
            "long": 104.551,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 480703,
            "zip_code": 48130,
            "name_th": "หนองสังข์",
            "name_en": "Nong Sang",
            "district_id": 4807,
            "lat": 16.989,
            "long": 104.468,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 480704,
            "zip_code": 48130,
            "name_th": "นาคู่",
            "name_en": "Na Khu",
            "district_id": 4807,
            "lat": 16.978,
            "long": 104.539,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 480705,
            "zip_code": 48130,
            "name_th": "พิมาน",
            "name_en": "Phiman",
            "district_id": 4807,
            "lat": 16.909,
            "long": 104.54,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 480706,
            "zip_code": 48130,
            "name_th": "พุ่มแก",
            "name_en": "Phum Kae",
            "district_id": 4807,
            "lat": 16.911,
            "long": 104.621,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 480707,
            "zip_code": 48130,
            "name_th": "ก้านเหลือง",
            "name_en": "Kan Lueang",
            "district_id": 4807,
            "lat": 16.897,
            "long": 104.383,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 480708,
            "zip_code": 48130,
            "name_th": "หนองบ่อ",
            "name_en": "Nong Bo",
            "district_id": 4807,
            "lat": 16.932,
            "long": 104.322,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 480709,
            "zip_code": 48130,
            "name_th": "นาเลียง",
            "name_en": "Na Liang",
            "district_id": 4807,
            "lat": 17.063,
            "long": 104.551,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 480712,
            "zip_code": 48130,
            "name_th": "บ้านแก้ง",
            "name_en": "Ban Kaeng",
            "district_id": 4807,
            "lat": 16.918,
            "long": 104.446,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 480713,
            "zip_code": 48130,
            "name_th": "คำพี้",
            "name_en": "Kham Phi",
            "district_id": 4807,
            "lat": 16.937,
            "long": 104.369,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 480715,
            "zip_code": 48130,
            "name_th": "สีชมพู",
            "name_en": "Si Chomphu",
            "district_id": 4807,
            "lat": 16.918,
            "long": 104.575,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 4808,
        "name_th": "ศรีสงคราม",
        "name_en": "Si Songkhram",
        "province_id": 36,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 480801,
            "zip_code": 48150,
            "name_th": "ศรีสงคราม",
            "name_en": "Si Songkhram",
            "district_id": 4808,
            "lat": 17.641,
            "long": 104.289,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 480802,
            "zip_code": 48150,
            "name_th": "นาเดื่อ",
            "name_en": "Na Duea",
            "district_id": 4808,
            "lat": 17.555,
            "long": 104.333,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 480803,
            "zip_code": 48150,
            "name_th": "บ้านเอื้อง",
            "name_en": "Ban Ueang",
            "district_id": 4808,
            "lat": 17.548,
            "long": 104.232,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 480804,
            "zip_code": 48150,
            "name_th": "สามผง",
            "name_en": "Sam Phong",
            "district_id": 4808,
            "lat": 17.73,
            "long": 104.164,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 480805,
            "zip_code": 48150,
            "name_th": "ท่าบ่อสงคราม",
            "name_en": "Tha Bo Songkhram",
            "district_id": 4808,
            "lat": 17.633,
            "long": 104.196,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 480806,
            "zip_code": 48150,
            "name_th": "บ้านข่า",
            "name_en": "Ban Kha",
            "district_id": 4808,
            "lat": 17.666,
            "long": 104.121,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 480807,
            "zip_code": 48150,
            "name_th": "นาคำ",
            "name_en": "Na Kham",
            "district_id": 4808,
            "lat": 17.619,
            "long": 104.354,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 480808,
            "zip_code": 48150,
            "name_th": "โพนสว่าง",
            "name_en": "Phon Sawang",
            "district_id": 4808,
            "lat": 17.542,
            "long": 104.167,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 480809,
            "zip_code": 48150,
            "name_th": "หาดแพง",
            "name_en": "Hat Phaeng",
            "district_id": 4808,
            "lat": 17.712,
            "long": 104.3,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 4809,
        "name_th": "นาหว้า",
        "name_en": "Na Wa",
        "province_id": 36,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 480901,
            "zip_code": 48180,
            "name_th": "นาหว้า",
            "name_en": "Na Wa",
            "district_id": 4809,
            "lat": 17.471,
            "long": 104.06,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 480902,
            "zip_code": 48180,
            "name_th": "นางัว",
            "name_en": "Na Ngua",
            "district_id": 4809,
            "lat": 17.424,
            "long": 104.071,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 480903,
            "zip_code": 48180,
            "name_th": "บ้านเสียว",
            "name_en": "Ban Siao",
            "district_id": 4809,
            "lat": 17.554,
            "long": 104.082,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 480904,
            "zip_code": 48180,
            "name_th": "นาคูณใหญ่",
            "name_en": "Na Khun Yai",
            "district_id": 4809,
            "lat": 17.507,
            "long": 104.145,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 480905,
            "zip_code": 48180,
            "name_th": "เหล่าพัฒนา",
            "name_en": "Lao Phatthana",
            "district_id": 4809,
            "lat": 17.617,
            "long": 104.07,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 480906,
            "zip_code": 48180,
            "name_th": "ท่าเรือ",
            "name_en": "Tha Ruea",
            "district_id": 4809,
            "lat": 17.503,
            "long": 104.052,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 4810,
        "name_th": "โพนสวรรค์",
        "name_en": "Phon Sawan",
        "province_id": 36,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 481001,
            "zip_code": 48190,
            "name_th": "โพนสวรรค์",
            "name_en": "Phon Sawan",
            "district_id": 4810,
            "lat": 17.444,
            "long": 104.504,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 481002,
            "zip_code": 48190,
            "name_th": "นาหัวบ่อ",
            "name_en": "Na Hua Bo",
            "district_id": 4810,
            "lat": 17.482,
            "long": 104.368,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 481003,
            "zip_code": 48190,
            "name_th": "นาขมิ้น",
            "name_en": "Na Khamin",
            "district_id": 4810,
            "lat": 17.523,
            "long": 104.513,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 481004,
            "zip_code": 48190,
            "name_th": "โพนบก",
            "name_en": "Phon Bok",
            "district_id": 4810,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 481005,
            "zip_code": 48190,
            "name_th": "บ้านค้อ",
            "name_en": "Ban Kho",
            "district_id": 4810,
            "lat": 17.473,
            "long": 104.264,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 481006,
            "zip_code": 48190,
            "name_th": "โพนจาน",
            "name_en": "Phon Chan",
            "district_id": 4810,
            "lat": 17.409,
            "long": 104.424,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 481007,
            "zip_code": 48190,
            "name_th": "นาใน",
            "name_en": "Na Nai",
            "district_id": 4810,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 4811,
        "name_th": "นาทม",
        "name_en": "Na Thom",
        "province_id": 36,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 481101,
            "zip_code": 48140,
            "name_th": "นาทม",
            "name_en": "Na Thom",
            "district_id": 4811,
            "lat": 17.845,
            "long": 104.037,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 481102,
            "zip_code": 48140,
            "name_th": "หนองซน",
            "name_en": "Nong Son",
            "district_id": 4811,
            "lat": 17.866,
            "long": 104.147,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 481103,
            "zip_code": 48140,
            "name_th": "ดอนเตย",
            "name_en": "Don Toei",
            "district_id": 4811,
            "lat": 17.798,
            "long": 104.108,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 4812,
        "name_th": "วังยาง",
        "name_en": "Wang Yang",
        "province_id": 36,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 481201,
            "zip_code": 48130,
            "name_th": "วังยาง",
            "name_en": "Wang Yang",
            "district_id": 4812,
            "lat": 17.063,
            "long": 104.442,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 481202,
            "zip_code": 48130,
            "name_th": "โคกสี",
            "name_en": "Khok Si",
            "district_id": 4812,
            "lat": 17.081,
            "long": 104.387,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 481203,
            "zip_code": 48130,
            "name_th": "ยอดชาด",
            "name_en": "Yot Chat",
            "district_id": 4812,
            "lat": 17.065,
            "long": 104.482,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 481204,
            "zip_code": 48130,
            "name_th": "หนองโพธิ์",
            "name_en": "Nong Pho",
            "district_id": 4812,
            "lat": 17.091,
            "long": 104.491,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      }
    ]
  },
  {
    "id": 37,
    "name_th": "มุกดาหาร",
    "name_en": "Mukdahan",
    "geography_id": 3,
    "created_at": "2019-08-09T03:33:09.000+07:00",
    "updated_at": "2025-09-20T06:31:26.000+07:00",
    "deleted_at": null,
    "districts": [
      {
        "id": 4901,
        "name_th": "เมืองมุกดาหาร",
        "name_en": "Mueang Mukdahan",
        "province_id": 37,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 490101,
            "zip_code": 49000,
            "name_th": "มุกดาหาร",
            "name_en": "Mukdahan",
            "district_id": 4901,
            "lat": 16.558,
            "long": 104.646,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 490102,
            "zip_code": 49000,
            "name_th": "ศรีบุญเรือง",
            "name_en": "Si Bun Rueang",
            "district_id": 4901,
            "lat": 16.53,
            "long": 104.724,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 490103,
            "zip_code": 49000,
            "name_th": "บ้านโคก",
            "name_en": "Ban Khok",
            "district_id": 4901,
            "lat": 16.64,
            "long": 104.565,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 490104,
            "zip_code": 49000,
            "name_th": "บางทรายใหญ่",
            "name_en": "Bang Sai Yai",
            "district_id": 4901,
            "lat": 16.619,
            "long": 104.693,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 490105,
            "zip_code": 49000,
            "name_th": "โพนทราย",
            "name_en": "Phon Sai",
            "district_id": 4901,
            "lat": 16.541,
            "long": 104.584,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 490106,
            "zip_code": 49000,
            "name_th": "ผึ่งแดด",
            "name_en": "Phueng Daet",
            "district_id": 4901,
            "lat": 16.631,
            "long": 104.476,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 490107,
            "zip_code": 49000,
            "name_th": "นาโสก",
            "name_en": "Na Sok",
            "district_id": 4901,
            "lat": 16.487,
            "long": 104.522,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 490108,
            "zip_code": 49000,
            "name_th": "นาสีนวน",
            "name_en": "Na Si Nuan",
            "district_id": 4901,
            "lat": 16.455,
            "long": 104.785,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 490109,
            "zip_code": 49000,
            "name_th": "คำป่าหลาย",
            "name_en": "Kham Pa Lai",
            "district_id": 4901,
            "lat": 16.711,
            "long": 104.621,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 490110,
            "zip_code": 49000,
            "name_th": "คำอาฮวน",
            "name_en": "Kham Ahuan",
            "district_id": 4901,
            "lat": 16.494,
            "long": 104.667,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 490111,
            "zip_code": 49000,
            "name_th": "ดงเย็น",
            "name_en": "Dong Yen",
            "district_id": 4901,
            "lat": 16.371,
            "long": 104.697,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 490112,
            "zip_code": 49000,
            "name_th": "ดงมอน",
            "name_en": "Dong Mon",
            "district_id": 4901,
            "lat": 16.687,
            "long": 104.5,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 490113,
            "zip_code": 49000,
            "name_th": "กุดแข้",
            "name_en": "Kut Khae",
            "district_id": 4901,
            "lat": 16.574,
            "long": 104.565,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 4902,
        "name_th": "นิคมคำสร้อย",
        "name_en": "Nikhom Kham Soi",
        "province_id": 37,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 490201,
            "zip_code": 49130,
            "name_th": "นิคมคำสร้อย",
            "name_en": "Nikhom Kham Soi",
            "district_id": 4902,
            "lat": 16.306,
            "long": 104.582,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 490202,
            "zip_code": 49130,
            "name_th": "นากอก",
            "name_en": "Na Kok",
            "district_id": 4902,
            "lat": 16.346,
            "long": 104.614,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 490203,
            "zip_code": 49130,
            "name_th": "หนองแวง",
            "name_en": "Nong Waeng",
            "district_id": 4902,
            "lat": 16.412,
            "long": 104.605,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 490204,
            "zip_code": 49130,
            "name_th": "กกแดง",
            "name_en": "Kok Daeng",
            "district_id": 4902,
            "lat": 16.41,
            "long": 104.505,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 490205,
            "zip_code": 49130,
            "name_th": "นาอุดม",
            "name_en": "Na Udom",
            "district_id": 4902,
            "lat": 16.274,
            "long": 104.615,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 490206,
            "zip_code": 49130,
            "name_th": "โชคชัย",
            "name_en": "Chok Chai",
            "district_id": 4902,
            "lat": 16.358,
            "long": 104.499,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 490207,
            "zip_code": 49130,
            "name_th": "ร่มเกล้า",
            "name_en": "Rom Klao",
            "district_id": 4902,
            "lat": 16.381,
            "long": 104.437,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 4903,
        "name_th": "ดอนตาล",
        "name_en": "Don Tan",
        "province_id": 37,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 490301,
            "zip_code": 49120,
            "name_th": "ดอนตาล",
            "name_en": "Don Tan",
            "district_id": 4903,
            "lat": 16.299,
            "long": 104.905,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 490302,
            "zip_code": 49120,
            "name_th": "โพธิ์ไทร",
            "name_en": "Pho Sai",
            "district_id": 4903,
            "lat": 16.376,
            "long": 104.862,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 490303,
            "zip_code": 49120,
            "name_th": "ป่าไร่",
            "name_en": "Pa Rai",
            "district_id": 4903,
            "lat": 16.254,
            "long": 104.701,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 490304,
            "zip_code": 49120,
            "name_th": "เหล่าหมี",
            "name_en": "Lao Mi",
            "district_id": 4903,
            "lat": 16.346,
            "long": 104.781,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 490305,
            "zip_code": 49120,
            "name_th": "บ้านบาก",
            "name_en": "Ban Bak",
            "district_id": 4903,
            "lat": 16.232,
            "long": 104.852,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 490306,
            "zip_code": 49120,
            "name_th": "นาสะเม็ง",
            "name_en": "Na Sameng",
            "district_id": 4903,
            "lat": 16.287,
            "long": 104.837,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 490307,
            "zip_code": 49120,
            "name_th": "บ้านแก้ง",
            "name_en": "Ban Kaeng",
            "district_id": 4903,
            "lat": 16.41,
            "long": 104.814,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 4904,
        "name_th": "ดงหลวง",
        "name_en": "Dong Luang",
        "province_id": 37,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 490401,
            "zip_code": 49140,
            "name_th": "ดงหลวง",
            "name_en": "Dong Luang",
            "district_id": 4904,
            "lat": 16.818,
            "long": 104.523,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 490402,
            "zip_code": 49140,
            "name_th": "หนองบัว",
            "name_en": "Nong Bua",
            "district_id": 4904,
            "lat": 16.811,
            "long": 104.568,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 490403,
            "zip_code": 49140,
            "name_th": "กกตูม",
            "name_en": "Kok Tum",
            "district_id": 4904,
            "lat": 16.792,
            "long": 104.196,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 490404,
            "zip_code": 49140,
            "name_th": "หนองแคน",
            "name_en": "Nong Khaen",
            "district_id": 4904,
            "lat": 16.76,
            "long": 104.492,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 490405,
            "zip_code": 49140,
            "name_th": "ชะโนดน้อย",
            "name_en": "Chanot Noi",
            "district_id": 4904,
            "lat": 16.805,
            "long": 104.618,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 490406,
            "zip_code": 49140,
            "name_th": "พังแดง",
            "name_en": "Phang Daeng",
            "district_id": 4904,
            "lat": 16.797,
            "long": 104.373,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 4905,
        "name_th": "คำชะอี",
        "name_en": "Khamcha-i",
        "province_id": 37,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 490503,
            "zip_code": 49110,
            "name_th": "บ้านซ่ง",
            "name_en": "Ban Song",
            "district_id": 4905,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 490504,
            "zip_code": 49110,
            "name_th": "คำชะอี",
            "name_en": "Khamcha-i",
            "district_id": 4905,
            "lat": 16.589,
            "long": 104.279,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 490505,
            "zip_code": 49110,
            "name_th": "หนองเอี่ยน",
            "name_en": "(Nong Ian",
            "district_id": 4905,
            "lat": 16.616,
            "long": 104.453,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 490506,
            "zip_code": 49110,
            "name_th": "บ้านค้อ",
            "name_en": "Ban Kho",
            "district_id": 4905,
            "lat": 16.701,
            "long": 104.352,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 490507,
            "zip_code": 49110,
            "name_th": "บ้านเหล่า",
            "name_en": "Ban Lao",
            "district_id": 4905,
            "lat": 16.686,
            "long": 104.282,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 490508,
            "zip_code": 49110,
            "name_th": "โพนงาม",
            "name_en": "Phon Ngam",
            "district_id": 4905,
            "lat": 16.675,
            "long": 104.435,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 490511,
            "zip_code": 49110,
            "name_th": "เหล่าสร้างถ่อ",
            "name_en": "Lao Sang Tho",
            "district_id": 4905,
            "lat": 16.561,
            "long": 104.492,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 490512,
            "zip_code": 49110,
            "name_th": "คำบก",
            "name_en": "Kham Bok",
            "district_id": 4905,
            "lat": 16.499,
            "long": 104.411,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 490514,
            "zip_code": 49110,
            "name_th": "น้ำเที่ยง",
            "name_en": "Nam Thiang",
            "district_id": 4905,
            "lat": 16.569,
            "long": 104.398,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 4906,
        "name_th": "หว้านใหญ่",
        "name_en": "Wan Yai",
        "province_id": 37,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 490601,
            "zip_code": 49150,
            "name_th": "หว้านใหญ่",
            "name_en": "Wan Yai",
            "district_id": 4906,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 490602,
            "zip_code": 49150,
            "name_th": "ป่งขาม",
            "name_en": "Pong Kham",
            "district_id": 4906,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 490603,
            "zip_code": 49150,
            "name_th": "บางทรายน้อย",
            "name_en": "Bang Sai Noi",
            "district_id": 4906,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 490604,
            "zip_code": 49150,
            "name_th": "ชะโนด",
            "name_en": "Chanot",
            "district_id": 4906,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 490605,
            "zip_code": 49150,
            "name_th": "ดงหมู",
            "name_en": "Dong Mu",
            "district_id": 4906,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 4907,
        "name_th": "หนองสูง",
        "name_en": "Nong Sung",
        "province_id": 37,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 490701,
            "zip_code": 49160,
            "name_th": "หนองสูง",
            "name_en": "Nong Sung",
            "district_id": 4907,
            "lat": 16.459,
            "long": 104.361,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 490702,
            "zip_code": 49160,
            "name_th": "โนนยาง",
            "name_en": "Non Yang",
            "district_id": 4907,
            "lat": 16.49,
            "long": 104.278,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 490703,
            "zip_code": 49160,
            "name_th": "ภูวง",
            "name_en": "Phu Wong",
            "district_id": 4907,
            "lat": 16.455,
            "long": 104.447,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 490704,
            "zip_code": 49160,
            "name_th": "บ้านเป้า",
            "name_en": "Ban Pao",
            "district_id": 4907,
            "lat": 16.41,
            "long": 104.337,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 490705,
            "zip_code": 49160,
            "name_th": "หนองสูงใต้",
            "name_en": "Nong Sung Tai",
            "district_id": 4907,
            "lat": 16.388,
            "long": 104.382,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 490706,
            "zip_code": 49160,
            "name_th": "หนองสูงเหนือ",
            "name_en": "Nong Sung Nuea",
            "district_id": 4907,
            "lat": 16.491,
            "long": 104.36,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      }
    ]
  },
  {
    "id": 38,
    "name_th": "เชียงใหม่",
    "name_en": "Chiang Mai",
    "geography_id": 1,
    "created_at": "2019-08-09T03:33:09.000+07:00",
    "updated_at": "2025-09-20T06:31:26.000+07:00",
    "deleted_at": null,
    "districts": [
      {
        "id": 5001,
        "name_th": "เมืองเชียงใหม่",
        "name_en": "Mueang Chiang Mai",
        "province_id": 38,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 500101,
            "zip_code": 50200,
            "name_th": "ศรีภูมิ",
            "name_en": "Si Phum",
            "district_id": 5001,
            "lat": 18.796,
            "long": 98.985,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 500102,
            "zip_code": 50200,
            "name_th": "พระสิงห์",
            "name_en": "Phra Sing",
            "district_id": 5001,
            "lat": 18.785,
            "long": 98.985,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 500103,
            "zip_code": 50100,
            "name_th": "หายยา",
            "name_en": "Haiya",
            "district_id": 5001,
            "lat": 18.777,
            "long": 98.984,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 500104,
            "zip_code": 50300,
            "name_th": "ช้างม่อย",
            "name_en": "Chang Moi",
            "district_id": 5001,
            "lat": 18.796,
            "long": 98.996,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 500105,
            "zip_code": 50100,
            "name_th": "ช้างคลาน",
            "name_en": "Chang Khlan",
            "district_id": 5001,
            "lat": 18.774,
            "long": 98.996,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 500106,
            "zip_code": 50000,
            "name_th": "วัดเกต",
            "name_en": "Wat Ket",
            "district_id": 5001,
            "lat": 18.785,
            "long": 99.011,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 500107,
            "zip_code": 50300,
            "name_th": "ช้างเผือก",
            "name_en": "Chang Phueak",
            "district_id": 5001,
            "lat": 18.821,
            "long": 98.969,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 500108,
            "zip_code": 50200,
            "name_th": "สุเทพ",
            "name_en": "Suthep",
            "district_id": 5001,
            "lat": 18.768,
            "long": 98.921,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 500109,
            "zip_code": 50100,
            "name_th": "แม่เหียะ",
            "name_en": "Mae Hia",
            "district_id": 5001,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 500110,
            "zip_code": 50100,
            "name_th": "ป่าแดด",
            "name_en": "Pa Daet",
            "district_id": 5001,
            "lat": 18.742,
            "long": 98.978,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 500111,
            "zip_code": 50000,
            "name_th": "หนองหอย",
            "name_en": "Nong Hoi",
            "district_id": 5001,
            "lat": 18.758,
            "long": 99.015,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 500112,
            "zip_code": 50000,
            "name_th": "ท่าศาลา",
            "name_en": "Tha Sala",
            "district_id": 5001,
            "lat": 18.77,
            "long": 99.034,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 500113,
            "zip_code": 50000,
            "name_th": "หนองป่าครั่ง",
            "name_en": "Nong Pa Khrang",
            "district_id": 5001,
            "lat": 18.788,
            "long": 99.034,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 500114,
            "zip_code": 50000,
            "name_th": "ฟ้าฮ่าม",
            "name_en": "Fa Ham",
            "district_id": 5001,
            "lat": 18.816,
            "long": 99.008,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 500115,
            "zip_code": 50300,
            "name_th": "ป่าตัน",
            "name_en": "Pa Tan",
            "district_id": 5001,
            "lat": 18.811,
            "long": 98.999,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 500116,
            "zip_code": 50300,
            "name_th": "สันผีเสื้อ",
            "name_en": "San Phi Suea",
            "district_id": 5001,
            "lat": 18.841,
            "long": 98.998,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 5002,
        "name_th": "จอมทอง",
        "name_en": "Chom Thong",
        "province_id": 38,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 500203,
            "zip_code": 50160,
            "name_th": "บ้านหลวง",
            "name_en": "Ban Luang",
            "district_id": 5002,
            "lat": 18.502,
            "long": 98.6,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 500204,
            "zip_code": 50160,
            "name_th": "ข่วงเปา",
            "name_en": "Khuang Pao",
            "district_id": 5002,
            "lat": 18.472,
            "long": 98.726,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 500205,
            "zip_code": 50160,
            "name_th": "สบเตี๊ยะ",
            "name_en": "Sop Tia",
            "district_id": 5002,
            "lat": 18.352,
            "long": 98.668,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 500206,
            "zip_code": 50240,
            "name_th": "บ้านแปะ",
            "name_en": "Ban Pae",
            "district_id": 5002,
            "lat": 18.256,
            "long": 98.565,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 500207,
            "zip_code": 50160,
            "name_th": "ดอยแก้ว",
            "name_en": "Doi Kaeo",
            "district_id": 5002,
            "lat": 18.39,
            "long": 98.576,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 500209,
            "zip_code": 50240,
            "name_th": "แม่สอย",
            "name_en": "Mae Soi",
            "district_id": 5002,
            "lat": 18.222,
            "long": 98.721,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 5003,
        "name_th": "แม่แจ่ม",
        "name_en": "Mae Chaem",
        "province_id": 38,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 500301,
            "zip_code": 50270,
            "name_th": "ช่างเคิ่ง",
            "name_en": "Chang Khoeng",
            "district_id": 5003,
            "lat": 18.552,
            "long": 98.401,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 500302,
            "zip_code": 50270,
            "name_th": "ท่าผา",
            "name_en": "Tha Pha",
            "district_id": 5003,
            "lat": 18.485,
            "long": 98.416,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 500303,
            "zip_code": 50270,
            "name_th": "บ้านทับ",
            "name_en": "Ban Thap",
            "district_id": 5003,
            "lat": 18.342,
            "long": 98.234,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 500304,
            "zip_code": 50270,
            "name_th": "แม่ศึก",
            "name_en": "Mae Suek",
            "district_id": 5003,
            "lat": 18.738,
            "long": 98.224,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 500305,
            "zip_code": 50270,
            "name_th": "แม่นาจร",
            "name_en": "Mae Na Chon",
            "district_id": 5003,
            "lat": 18.802,
            "long": 98.373,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 500307,
            "zip_code": 50270,
            "name_th": "ปางหินฝน",
            "name_en": "Pang Hin Fon",
            "district_id": 5003,
            "lat": 18.451,
            "long": 98.136,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 500308,
            "zip_code": 50270,
            "name_th": "กองแขก",
            "name_en": "Kong Khaek",
            "district_id": 5003,
            "lat": 18.358,
            "long": 98.376,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 5004,
        "name_th": "เชียงดาว",
        "name_en": "Chiang Dao",
        "province_id": 38,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 500401,
            "zip_code": 50170,
            "name_th": "เชียงดาว",
            "name_en": "Chiang Dao",
            "district_id": 5004,
            "lat": 19.389,
            "long": 98.947,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 500402,
            "zip_code": 50170,
            "name_th": "เมืองนะ",
            "name_en": "Mueang Na",
            "district_id": 5004,
            "lat": 19.312,
            "long": 98.939,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 500403,
            "zip_code": 50170,
            "name_th": "เมืองงาย",
            "name_en": "Mueang Ngai",
            "district_id": 5004,
            "lat": 19.477,
            "long": 98.833,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 500404,
            "zip_code": 50170,
            "name_th": "แม่นะ",
            "name_en": "Mae Na",
            "district_id": 5004,
            "lat": 19.687,
            "long": 98.9,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 500405,
            "zip_code": 50170,
            "name_th": "เมืองคอง",
            "name_en": "Mueang Khong",
            "district_id": 5004,
            "lat": 19.388,
            "long": 98.753,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 500406,
            "zip_code": 50170,
            "name_th": "ปิงโค้ง",
            "name_en": "Ping Khong",
            "district_id": 5004,
            "lat": 19.507,
            "long": 99.066,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 500407,
            "zip_code": 50170,
            "name_th": "ทุ่งข้าวพวง",
            "name_en": "Thung Khao Phuang",
            "district_id": 5004,
            "lat": 19.552,
            "long": 98.906,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 5005,
        "name_th": "ดอยสะเก็ด",
        "name_en": "Doi Saket",
        "province_id": 38,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 500501,
            "zip_code": 50220,
            "name_th": "เชิงดอย",
            "name_en": "Choeng Doi",
            "district_id": 5005,
            "lat": 18.899,
            "long": 99.17,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 500502,
            "zip_code": 50220,
            "name_th": "สันปูเลย",
            "name_en": "San Pu Loei",
            "district_id": 5005,
            "lat": 18.808,
            "long": 99.072,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 500503,
            "zip_code": 50220,
            "name_th": "ลวงเหนือ",
            "name_en": "Luang Nuea",
            "district_id": 5005,
            "lat": 18.965,
            "long": 99.141,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 500504,
            "zip_code": 50220,
            "name_th": "ป่าป้อง",
            "name_en": "Pa Pong",
            "district_id": 5005,
            "lat": 18.85,
            "long": 99.16,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 500505,
            "zip_code": 50220,
            "name_th": "สง่าบ้าน",
            "name_en": "Sa-nga Ban",
            "district_id": 5005,
            "lat": 18.832,
            "long": 99.12,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 500506,
            "zip_code": 50220,
            "name_th": "ป่าลาน",
            "name_en": "Pa Lan",
            "district_id": 5005,
            "lat": 18.836,
            "long": 99.106,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 500507,
            "zip_code": 50220,
            "name_th": "ตลาดขวัญ",
            "name_en": "Talat Khwan",
            "district_id": 5005,
            "lat": 18.841,
            "long": 99.088,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 500508,
            "zip_code": 50220,
            "name_th": "สำราญราษฎร์",
            "name_en": "Samran Rat",
            "district_id": 5005,
            "lat": 18.807,
            "long": 99.095,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 500509,
            "zip_code": 50220,
            "name_th": "แม่คือ",
            "name_en": "Mae Khue",
            "district_id": 5005,
            "lat": 18.782,
            "long": 99.101,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 500510,
            "zip_code": 50220,
            "name_th": "ตลาดใหญ่",
            "name_en": "Talat Yai",
            "district_id": 5005,
            "lat": 18.81,
            "long": 99.127,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 500511,
            "zip_code": 50220,
            "name_th": "แม่ฮ้อยเงิน",
            "name_en": "Mae Hoi Ngoen",
            "district_id": 5005,
            "lat": 18.805,
            "long": 99.149,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 500512,
            "zip_code": 50220,
            "name_th": "แม่โป่ง",
            "name_en": "Mae Pong",
            "district_id": 5005,
            "lat": 18.847,
            "long": 99.196,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 500513,
            "zip_code": 50220,
            "name_th": "ป่าเมี่ยง",
            "name_en": "Pa Miang",
            "district_id": 5005,
            "lat": 18.935,
            "long": 99.243,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 500514,
            "zip_code": 50220,
            "name_th": "เทพเสด็จ",
            "name_en": "Thep Sadet",
            "district_id": 5005,
            "lat": 18.956,
            "long": 99.326,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 5006,
        "name_th": "แม่แตง",
        "name_en": "Mae Taeng",
        "province_id": 38,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 500601,
            "zip_code": 50150,
            "name_th": "สันมหาพน",
            "name_en": "San Maha Phon",
            "district_id": 5006,
            "lat": 19.118,
            "long": 98.946,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 500602,
            "zip_code": 50150,
            "name_th": "แม่แตง",
            "name_en": "Mae Taeng",
            "district_id": 5006,
            "lat": 19.155,
            "long": 98.91,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 500603,
            "zip_code": 50150,
            "name_th": "ขี้เหล็ก",
            "name_en": "Khilek",
            "district_id": 5006,
            "lat": 19.071,
            "long": 98.916,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 500604,
            "zip_code": 50150,
            "name_th": "ช่อแล",
            "name_en": "Cho Lae",
            "district_id": 5006,
            "lat": 19.144,
            "long": 99.024,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 500605,
            "zip_code": 50150,
            "name_th": "แม่หอพระ",
            "name_en": "Mae Ho Phra",
            "district_id": 5006,
            "lat": 19.117,
            "long": 99.072,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 500606,
            "zip_code": 50150,
            "name_th": "สบเปิง",
            "name_en": "Sop Poeng",
            "district_id": 5006,
            "lat": 19.104,
            "long": 98.81,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 500607,
            "zip_code": 50150,
            "name_th": "บ้านเป้า",
            "name_en": "Ban Pao",
            "district_id": 5006,
            "lat": 19.218,
            "long": 99.047,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 500608,
            "zip_code": 50330,
            "name_th": "สันป่ายาง",
            "name_en": "San Pa Yang",
            "district_id": 5006,
            "lat": 19.049,
            "long": 98.83,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 500609,
            "zip_code": 50150,
            "name_th": "ป่าแป๋",
            "name_en": "Pa Pae",
            "district_id": 5006,
            "lat": 19.179,
            "long": 98.671,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 500610,
            "zip_code": 50150,
            "name_th": "เมืองก๋าย",
            "name_en": "Mueang Kai",
            "district_id": 5006,
            "lat": 19.186,
            "long": 98.79,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 500611,
            "zip_code": 50150,
            "name_th": "บ้านช้าง",
            "name_en": "Ban Chang",
            "district_id": 5006,
            "lat": 19.147,
            "long": 98.861,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 500612,
            "zip_code": 50150,
            "name_th": "กื้ดช้าง",
            "name_en": "Kuet Chang",
            "district_id": 5006,
            "lat": 19.269,
            "long": 98.768,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 500613,
            "zip_code": 50150,
            "name_th": "อินทขิล",
            "name_en": "Inthakhin",
            "district_id": 5006,
            "lat": 19.2,
            "long": 98.953,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 500614,
            "zip_code": 50150,
            "name_th": "สมก๋าย",
            "name_en": "Som Kai",
            "district_id": 5006,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 5007,
        "name_th": "แม่ริม",
        "name_en": "Mae Rim",
        "province_id": 38,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 500701,
            "zip_code": 50180,
            "name_th": "ริมใต้",
            "name_en": "Rim Tai",
            "district_id": 5007,
            "lat": 18.914,
            "long": 98.964,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 500702,
            "zip_code": 50180,
            "name_th": "ริมเหนือ",
            "name_en": "Rim Nuea",
            "district_id": 5007,
            "lat": 18.929,
            "long": 98.948,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 500703,
            "zip_code": 50180,
            "name_th": "สันโป่ง",
            "name_en": "San Pong",
            "district_id": 5007,
            "lat": 18.954,
            "long": 98.954,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 500704,
            "zip_code": 50180,
            "name_th": "ขี้เหล็ก",
            "name_en": "Khilek",
            "district_id": 5007,
            "lat": 19.011,
            "long": 98.942,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 500705,
            "zip_code": 50330,
            "name_th": "สะลวง",
            "name_en": "Saluang",
            "district_id": 5007,
            "lat": 19.005,
            "long": 98.837,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 500706,
            "zip_code": 50180,
            "name_th": "ห้วยทราย",
            "name_en": "Huai Sai",
            "district_id": 5007,
            "lat": 18.967,
            "long": 98.915,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 500707,
            "zip_code": 50180,
            "name_th": "แม่แรม",
            "name_en": "Mae Raem",
            "district_id": 5007,
            "lat": 18.911,
            "long": 98.893,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 500708,
            "zip_code": 50180,
            "name_th": "โป่งแยง",
            "name_en": "Pong Yaeng",
            "district_id": 5007,
            "lat": 18.885,
            "long": 98.82,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 500709,
            "zip_code": 50180,
            "name_th": "แม่สา",
            "name_en": "Mae Sa",
            "district_id": 5007,
            "lat": 18.894,
            "long": 98.945,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 500710,
            "zip_code": 50180,
            "name_th": "ดอนแก้ว",
            "name_en": "Don Kaeo",
            "district_id": 5007,
            "lat": 18.86,
            "long": 98.939,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 500711,
            "zip_code": 50180,
            "name_th": "เหมืองแก้ว",
            "name_en": "Mueang Kaeo",
            "district_id": 5007,
            "lat": 18.898,
            "long": 98.983,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 5008,
        "name_th": "สะเมิง",
        "name_en": "Samoeng",
        "province_id": 38,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 500801,
            "zip_code": 50250,
            "name_th": "สะเมิงใต้",
            "name_en": "Samoeng Tai",
            "district_id": 5008,
            "lat": 18.823,
            "long": 98.714,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 500802,
            "zip_code": 50250,
            "name_th": "สะเมิงเหนือ",
            "name_en": "Samoeng Nuea",
            "district_id": 5008,
            "lat": 18.977,
            "long": 98.739,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 500803,
            "zip_code": 50250,
            "name_th": "แม่สาบ",
            "name_en": "Mae Sap",
            "district_id": 5008,
            "lat": 18.945,
            "long": 98.641,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 500804,
            "zip_code": 50250,
            "name_th": "บ่อแก้ว",
            "name_en": "Bo Kaeo",
            "district_id": 5008,
            "lat": 18.791,
            "long": 98.604,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 500805,
            "zip_code": 50250,
            "name_th": "ยั้งเมิน",
            "name_en": "Yang Moen",
            "district_id": 5008,
            "lat": 19.001,
            "long": 98.464,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 5009,
        "name_th": "ฝาง",
        "name_en": "Fang",
        "province_id": 38,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 500901,
            "zip_code": 50110,
            "name_th": "เวียง",
            "name_en": "Wiang",
            "district_id": 5009,
            "lat": 19.944,
            "long": 99.214,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 500903,
            "zip_code": 50110,
            "name_th": "ม่อนปิ่น",
            "name_en": "Mon Pin",
            "district_id": 5009,
            "lat": 19.955,
            "long": 99.112,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 500904,
            "zip_code": 50320,
            "name_th": "แม่งอน",
            "name_en": "Mae Ngon",
            "district_id": 5009,
            "lat": 19.793,
            "long": 99.124,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 500905,
            "zip_code": 50110,
            "name_th": "แม่สูน",
            "name_en": "Mae Sun",
            "district_id": 5009,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 500906,
            "zip_code": 50110,
            "name_th": "สันทราย",
            "name_en": "San Sai",
            "district_id": 5009,
            "lat": 19.879,
            "long": 99.209,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 500910,
            "zip_code": 50110,
            "name_th": "แม่คะ",
            "name_en": "Mae Kha",
            "district_id": 5009,
            "lat": 19.821,
            "long": 99.213,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 500911,
            "zip_code": 50320,
            "name_th": "แม่ข่า",
            "name_en": "Mae Kha",
            "district_id": 5009,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 500912,
            "zip_code": 50110,
            "name_th": "โป่งน้ำร้อน",
            "name_en": "Pong Nam Ron",
            "district_id": 5009,
            "lat": 20.061,
            "long": 99.121,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 5010,
        "name_th": "แม่อาย",
        "name_en": "Mae Ai",
        "province_id": 38,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 501001,
            "zip_code": 50280,
            "name_th": "แม่อาย",
            "name_en": "Mae Ai",
            "district_id": 5010,
            "lat": 20.065,
            "long": 99.262,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 501002,
            "zip_code": 50280,
            "name_th": "แม่สาว",
            "name_en": "Mae Sao",
            "district_id": 5010,
            "lat": 20.06,
            "long": 99.168,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 501003,
            "zip_code": 50280,
            "name_th": "สันต้นหมื้อ",
            "name_en": "San Ton Mue",
            "district_id": 5010,
            "lat": 19.948,
            "long": 99.28,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 501004,
            "zip_code": 50280,
            "name_th": "แม่นาวาง",
            "name_en": "Mae Na Wang",
            "district_id": 5010,
            "lat": 19.98,
            "long": 99.382,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 501005,
            "zip_code": 50280,
            "name_th": "ท่าตอน",
            "name_en": "Tha Ton",
            "district_id": 5010,
            "lat": 20.066,
            "long": 99.387,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 501006,
            "zip_code": 50280,
            "name_th": "บ้านหลวง",
            "name_en": "Ban Luang",
            "district_id": 5010,
            "lat": 19.871,
            "long": 99.343,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 501007,
            "zip_code": 50280,
            "name_th": "มะลิกา",
            "name_en": "Malika",
            "district_id": 5010,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 5011,
        "name_th": "พร้าว",
        "name_en": "Phrao",
        "province_id": 38,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 501101,
            "zip_code": 50190,
            "name_th": "เวียง",
            "name_en": "Wiang",
            "district_id": 5011,
            "lat": 19.378,
            "long": 99.203,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 501102,
            "zip_code": 50190,
            "name_th": "ทุ่งหลวง",
            "name_en": "Thung Luang",
            "district_id": 5011,
            "lat": 19.359,
            "long": 99.202,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 501103,
            "zip_code": 50190,
            "name_th": "ป่าตุ้ม",
            "name_en": "Pa Tum",
            "district_id": 5011,
            "lat": 19.37,
            "long": 99.266,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 501104,
            "zip_code": 50190,
            "name_th": "ป่าไหน่",
            "name_en": "Pa Nai",
            "district_id": 5011,
            "lat": 19.44,
            "long": 99.261,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 501105,
            "zip_code": 50190,
            "name_th": "สันทราย",
            "name_en": "San Sai",
            "district_id": 5011,
            "lat": 19.504,
            "long": 99.204,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 501106,
            "zip_code": 50190,
            "name_th": "บ้านโป่ง",
            "name_en": "Ban Pong",
            "district_id": 5011,
            "lat": 19.392,
            "long": 99.121,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 501107,
            "zip_code": 50190,
            "name_th": "น้ำแพร่",
            "name_en": "Nam Phrae",
            "district_id": 5011,
            "lat": 19.33,
            "long": 99.109,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 501108,
            "zip_code": 50190,
            "name_th": "เขื่อนผาก",
            "name_en": "Khuean Phak",
            "district_id": 5011,
            "lat": 19.308,
            "long": 99.164,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 501109,
            "zip_code": 50190,
            "name_th": "แม่แวน",
            "name_en": "Mae Waen",
            "district_id": 5011,
            "lat": 19.303,
            "long": 99.261,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 501110,
            "zip_code": 50190,
            "name_th": "แม่ปั๋ง",
            "name_en": "Mae Pang",
            "district_id": 5011,
            "lat": 19.213,
            "long": 99.212,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 501111,
            "zip_code": 50190,
            "name_th": "โหล่งขอด",
            "name_en": "Long Khot",
            "district_id": 5011,
            "lat": 19.074,
            "long": 99.225,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 5012,
        "name_th": "สันป่าตอง",
        "name_en": "San Pa Tong",
        "province_id": 38,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 501201,
            "zip_code": 50120,
            "name_th": "ยุหว่า",
            "name_en": "Yu Wa",
            "district_id": 5012,
            "lat": 18.62,
            "long": 98.875,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 501202,
            "zip_code": 50120,
            "name_th": "สันกลาง",
            "name_en": "San Klang",
            "district_id": 5012,
            "lat": 18.665,
            "long": 98.871,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 501203,
            "zip_code": 50120,
            "name_th": "ท่าวังพร้าว",
            "name_en": "Tha Wang Phrao",
            "district_id": 5012,
            "lat": 18.531,
            "long": 98.864,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 501204,
            "zip_code": 50120,
            "name_th": "มะขามหลวง",
            "name_en": "Makham Luang",
            "district_id": 5012,
            "lat": 18.601,
            "long": 98.907,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 501205,
            "zip_code": 50120,
            "name_th": "แม่ก๊า",
            "name_en": "Mae Ka",
            "district_id": 5012,
            "lat": 18.574,
            "long": 98.939,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 501206,
            "zip_code": 50120,
            "name_th": "บ้านแม",
            "name_en": "Ban Mae",
            "district_id": 5012,
            "lat": 18.626,
            "long": 98.854,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 501207,
            "zip_code": 50120,
            "name_th": "บ้านกลาง",
            "name_en": "Ban Klang",
            "district_id": 5012,
            "lat": 18.557,
            "long": 98.887,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 501208,
            "zip_code": 50120,
            "name_th": "ทุ่งสะโตก",
            "name_en": "Thung Satok",
            "district_id": 5012,
            "lat": 18.586,
            "long": 98.849,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 501210,
            "zip_code": 50120,
            "name_th": "ทุ่งต้อม",
            "name_en": "Thung Tom",
            "district_id": 5012,
            "lat": 18.613,
            "long": 98.92,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 501214,
            "zip_code": 50120,
            "name_th": "น้ำบ่อหลวง",
            "name_en": "Nam Bo Luang",
            "district_id": 5012,
            "lat": 18.674,
            "long": 98.841,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 501215,
            "zip_code": 50120,
            "name_th": "มะขุนหวาน",
            "name_en": "Makhun Wan",
            "district_id": 5012,
            "lat": 18.574,
            "long": 98.907,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 5013,
        "name_th": "สันกำแพง",
        "name_en": "San Kamphaeng",
        "province_id": 38,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 501301,
            "zip_code": 50130,
            "name_th": "สันกำแพง",
            "name_en": "San Kamphaeng",
            "district_id": 5013,
            "lat": 18.756,
            "long": 99.133,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 501302,
            "zip_code": 50130,
            "name_th": "ทรายมูล",
            "name_en": "Sai Mun",
            "district_id": 5013,
            "lat": 18.735,
            "long": 99.136,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 501303,
            "zip_code": 50130,
            "name_th": "ร้องวัวแดง",
            "name_en": "Rong Wua Daeng",
            "district_id": 5013,
            "lat": 18.746,
            "long": 99.206,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 501304,
            "zip_code": 50130,
            "name_th": "บวกค้าง",
            "name_en": "Buak Khang",
            "district_id": 5013,
            "lat": 18.704,
            "long": 99.107,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 501305,
            "zip_code": 50130,
            "name_th": "แช่ช้าง",
            "name_en": "Chae Chang",
            "district_id": 5013,
            "lat": 18.722,
            "long": 99.154,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 501306,
            "zip_code": 50130,
            "name_th": "ออนใต้",
            "name_en": "On Tai",
            "district_id": 5013,
            "lat": 18.7,
            "long": 99.229,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 501310,
            "zip_code": 50130,
            "name_th": "แม่ปูคา",
            "name_en": "Mae Pu Kha",
            "district_id": 5013,
            "lat": 18.785,
            "long": 99.126,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 501311,
            "zip_code": 50130,
            "name_th": "ห้วยทราย",
            "name_en": "Huai Sai",
            "district_id": 5013,
            "lat": 18.781,
            "long": 99.189,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 501312,
            "zip_code": 50130,
            "name_th": "ต้นเปา",
            "name_en": "Ton Pao",
            "district_id": 5013,
            "lat": 18.76,
            "long": 99.082,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 501313,
            "zip_code": 50130,
            "name_th": "สันกลาง",
            "name_en": "San Klang",
            "district_id": 5013,
            "lat": 18.775,
            "long": 99.056,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 5014,
        "name_th": "สันทราย",
        "name_en": "San Sai",
        "province_id": 38,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 501401,
            "zip_code": 50210,
            "name_th": "สันทรายหลวง",
            "name_en": "San Sai Luang",
            "district_id": 5014,
            "lat": 18.857,
            "long": 99.046,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 501402,
            "zip_code": 50210,
            "name_th": "สันทรายน้อย",
            "name_en": "San Sai Noi",
            "district_id": 5014,
            "lat": 18.819,
            "long": 99.024,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 501403,
            "zip_code": 50210,
            "name_th": "สันพระเนตร",
            "name_en": "San Phranet",
            "district_id": 5014,
            "lat": 18.808,
            "long": 99.038,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 501404,
            "zip_code": 50210,
            "name_th": "สันนาเม็ง",
            "name_en": "San Na Meng",
            "district_id": 5014,
            "lat": 18.842,
            "long": 99.062,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 501405,
            "zip_code": 50210,
            "name_th": "สันป่าเปา",
            "name_en": "San Pa Pao",
            "district_id": 5014,
            "lat": 18.861,
            "long": 99.084,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 501406,
            "zip_code": 50210,
            "name_th": "หนองแหย่ง",
            "name_en": "Nong Yaeng",
            "district_id": 5014,
            "lat": 18.911,
            "long": 99.101,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 501407,
            "zip_code": 50210,
            "name_th": "หนองจ๊อม",
            "name_en": "Nong Chom",
            "district_id": 5014,
            "lat": 18.852,
            "long": 99.023,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 501408,
            "zip_code": 50290,
            "name_th": "หนองหาร",
            "name_en": "Nong Han",
            "district_id": 5014,
            "lat": 18.93,
            "long": 99.014,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 501409,
            "zip_code": 50290,
            "name_th": "แม่แฝก",
            "name_en": "Mae Faek",
            "district_id": 5014,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 501410,
            "zip_code": 50290,
            "name_th": "แม่แฝกใหม่",
            "name_en": "Mae Faek Mai",
            "district_id": 5014,
            "lat": 19.026,
            "long": 99.007,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 501411,
            "zip_code": 50210,
            "name_th": "เมืองเล็น",
            "name_en": "Mueang Len",
            "district_id": 5014,
            "lat": 18.896,
            "long": 99.08,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 501412,
            "zip_code": 50210,
            "name_th": "ป่าไผ่",
            "name_en": "Pa Phai",
            "district_id": 5014,
            "lat": 18.907,
            "long": 99.051,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 5015,
        "name_th": "หางดง",
        "name_en": "Hang Dong",
        "province_id": 38,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 501501,
            "zip_code": 50230,
            "name_th": "หางดง",
            "name_en": "Hang Dong",
            "district_id": 5015,
            "lat": 18.692,
            "long": 98.915,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 501502,
            "zip_code": 50230,
            "name_th": "หนองแก๋ว",
            "name_en": "Nong Kaeo",
            "district_id": 5015,
            "lat": 18.674,
            "long": 98.933,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 501503,
            "zip_code": 50230,
            "name_th": "หารแก้ว",
            "name_en": "Han Kaeo",
            "district_id": 5015,
            "lat": 18.65,
            "long": 98.922,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 501504,
            "zip_code": 50340,
            "name_th": "หนองตอง",
            "name_en": "Nong Tong",
            "district_id": 5015,
            "lat": 18.613,
            "long": 98.945,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 501505,
            "zip_code": 50230,
            "name_th": "ขุนคง",
            "name_en": "Khun Khong",
            "district_id": 5015,
            "lat": 18.673,
            "long": 98.956,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 501506,
            "zip_code": 50230,
            "name_th": "สบแม่ข่า",
            "name_en": "Sop Mae Kha",
            "district_id": 5015,
            "lat": 18.689,
            "long": 98.98,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 501507,
            "zip_code": 50230,
            "name_th": "บ้านแหวน",
            "name_en": "Ban Waen",
            "district_id": 5015,
            "lat": 18.701,
            "long": 98.944,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 501508,
            "zip_code": 50230,
            "name_th": "สันผักหวาน",
            "name_en": "San Phak Wan",
            "district_id": 5015,
            "lat": 18.719,
            "long": 98.97,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 501509,
            "zip_code": 50230,
            "name_th": "หนองควาย",
            "name_en": "Nong Khwai",
            "district_id": 5015,
            "lat": 18.731,
            "long": 98.923,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 501510,
            "zip_code": 50230,
            "name_th": "บ้านปง",
            "name_en": "Ban Pong",
            "district_id": 5015,
            "lat": 18.769,
            "long": 98.868,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 501511,
            "zip_code": 50230,
            "name_th": "น้ำแพร่",
            "name_en": "Nam Phrae",
            "district_id": 5015,
            "lat": 18.709,
            "long": 98.881,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 5016,
        "name_th": "ฮอด",
        "name_en": "Hot",
        "province_id": 38,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 501601,
            "zip_code": 50240,
            "name_th": "หางดง",
            "name_en": "Hang Dong",
            "district_id": 5016,
            "lat": 18.16,
            "long": 98.483,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 501602,
            "zip_code": 50240,
            "name_th": "ฮอด",
            "name_en": "Hot",
            "district_id": 5016,
            "lat": 18.103,
            "long": 98.583,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 501603,
            "zip_code": 50240,
            "name_th": "บ้านตาล",
            "name_en": "Ban Tan",
            "district_id": 5016,
            "lat": 18.088,
            "long": 98.709,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 501604,
            "zip_code": 50240,
            "name_th": "บ่อหลวง",
            "name_en": "Bo Luang",
            "district_id": 5016,
            "lat": 18.158,
            "long": 98.379,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 501605,
            "zip_code": 50240,
            "name_th": "บ่อสลี",
            "name_en": "Bo Sali",
            "district_id": 5016,
            "lat": 18.155,
            "long": 98.244,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 501606,
            "zip_code": 50240,
            "name_th": "นาคอเรือ",
            "name_en": "Na Kho Ruea",
            "district_id": 5016,
            "lat": 18.009,
            "long": 98.52,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 5017,
        "name_th": "ดอยเต่า",
        "name_en": "Doi Tao",
        "province_id": 38,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 501701,
            "zip_code": 50260,
            "name_th": "ดอยเต่า",
            "name_en": "Doi Tao",
            "district_id": 5017,
            "lat": 17.897,
            "long": 98.731,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 501702,
            "zip_code": 50260,
            "name_th": "ท่าเดื่อ",
            "name_en": "Tha Duea",
            "district_id": 5017,
            "lat": 17.959,
            "long": 98.676,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 501703,
            "zip_code": 50260,
            "name_th": "มืดกา",
            "name_en": "Muet Ka",
            "district_id": 5017,
            "lat": 17.873,
            "long": 98.593,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 501704,
            "zip_code": 50260,
            "name_th": "บ้านแอ่น",
            "name_en": "Ban Aen",
            "district_id": 5017,
            "lat": 18.053,
            "long": 98.626,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 501705,
            "zip_code": 50260,
            "name_th": "บงตัน",
            "name_en": "Bong Tan",
            "district_id": 5017,
            "lat": 18.017,
            "long": 98.661,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 501706,
            "zip_code": 50260,
            "name_th": "โปงทุ่ง",
            "name_en": "Pong Thung",
            "district_id": 5017,
            "lat": 17.836,
            "long": 98.736,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 5018,
        "name_th": "อมก๋อย",
        "name_en": "Omkoi",
        "province_id": 38,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 501801,
            "zip_code": 50310,
            "name_th": "อมก๋อย",
            "name_en": "Omkoi",
            "district_id": 5018,
            "lat": 17.915,
            "long": 98.335,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 501802,
            "zip_code": 50310,
            "name_th": "ยางเปียง",
            "name_en": "Yang Piang",
            "district_id": 5018,
            "lat": 17.682,
            "long": 98.392,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 501803,
            "zip_code": 50310,
            "name_th": "แม่ตื่น",
            "name_en": "Mae Tuen",
            "district_id": 5018,
            "lat": 17.398,
            "long": 98.395,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 501804,
            "zip_code": 50310,
            "name_th": "ม่อนจอง",
            "name_en": "Mon Chong",
            "district_id": 5018,
            "lat": 17.43,
            "long": 98.5,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 501805,
            "zip_code": 50310,
            "name_th": "สบโขง",
            "name_en": "Sop Khong",
            "district_id": 5018,
            "lat": 17.654,
            "long": 98.217,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 501806,
            "zip_code": 50310,
            "name_th": "นาเกียน",
            "name_en": "Na Kian",
            "district_id": 5018,
            "lat": 17.864,
            "long": 98.156,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 5019,
        "name_th": "สารภี",
        "name_en": "Saraphi",
        "province_id": 38,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 501901,
            "zip_code": 50140,
            "name_th": "ยางเนิ้ง",
            "name_en": "Yang Noeng",
            "district_id": 5019,
            "lat": 18.707,
            "long": 99.036,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 501902,
            "zip_code": 50140,
            "name_th": "สารภี",
            "name_en": "Saraphi",
            "district_id": 5019,
            "lat": 18.681,
            "long": 99.047,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 501903,
            "zip_code": 50140,
            "name_th": "ชมภู",
            "name_en": "Chom Phu",
            "district_id": 5019,
            "lat": 18.694,
            "long": 99.071,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 501904,
            "zip_code": 50140,
            "name_th": "ไชยสถาน",
            "name_en": "Chai Sathan",
            "district_id": 5019,
            "lat": 18.745,
            "long": 99.043,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 501905,
            "zip_code": 50140,
            "name_th": "ขัวมุง",
            "name_en": "Khua Mung",
            "district_id": 5019,
            "lat": 18.678,
            "long": 98.991,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 501906,
            "zip_code": 50140,
            "name_th": "หนองแฝก",
            "name_en": "Nong Faek",
            "district_id": 5019,
            "lat": 18.691,
            "long": 99.019,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 501907,
            "zip_code": 50140,
            "name_th": "หนองผึ้ง",
            "name_en": "Nong Phueng",
            "district_id": 5019,
            "lat": 18.735,
            "long": 99.021,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 501908,
            "zip_code": 50140,
            "name_th": "ท่ากว้าง",
            "name_en": "Tha Kwang",
            "district_id": 5019,
            "lat": 18.659,
            "long": 98.998,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 501909,
            "zip_code": 50140,
            "name_th": "ดอนแก้ว",
            "name_en": "Don Kaeo",
            "district_id": 5019,
            "lat": 18.697,
            "long": 98.997,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 501910,
            "zip_code": 50140,
            "name_th": "ท่าวังตาล",
            "name_en": "Tha Wang Tan",
            "district_id": 5019,
            "lat": 18.718,
            "long": 99.007,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 501911,
            "zip_code": 50140,
            "name_th": "สันทราย",
            "name_en": "San Sai",
            "district_id": 5019,
            "lat": 18.64,
            "long": 98.972,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 501912,
            "zip_code": 50140,
            "name_th": "ป่าบง",
            "name_en": "Pa Bong",
            "district_id": 5019,
            "lat": 18.736,
            "long": 99.059,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 5020,
        "name_th": "เวียงแหง",
        "name_en": "Wiang Haeng",
        "province_id": 38,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 502001,
            "zip_code": 50350,
            "name_th": "เมืองแหง",
            "name_en": "Mueang Haeng",
            "district_id": 5020,
            "lat": 19.515,
            "long": 98.639,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 502002,
            "zip_code": 50350,
            "name_th": "เปียงหลวง",
            "name_en": "Piang Luang",
            "district_id": 5020,
            "lat": 19.692,
            "long": 98.693,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 502003,
            "zip_code": 50350,
            "name_th": "แสนไห",
            "name_en": "Saen Hai",
            "district_id": 5020,
            "lat": 19.615,
            "long": 98.632,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 5021,
        "name_th": "ไชยปราการ",
        "name_en": "Chai Prakan",
        "province_id": 38,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 502101,
            "zip_code": 50320,
            "name_th": "ปงตำ",
            "name_en": "Pong Tam",
            "district_id": 5021,
            "lat": 19.748,
            "long": 99.145,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 502102,
            "zip_code": 50320,
            "name_th": "ศรีดงเย็น",
            "name_en": "Si Dong Yen",
            "district_id": 5021,
            "lat": 19.646,
            "long": 99.178,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 502103,
            "zip_code": 50320,
            "name_th": "แม่ทะลบ",
            "name_en": "Mae Thalop",
            "district_id": 5021,
            "lat": 19.73,
            "long": 99.247,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 502104,
            "zip_code": 50320,
            "name_th": "หนองบัว",
            "name_en": "Nong Bua",
            "district_id": 5021,
            "lat": 19.736,
            "long": 99.073,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 5022,
        "name_th": "แม่วาง",
        "name_en": "Mae Wang",
        "province_id": 38,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 502201,
            "zip_code": 50360,
            "name_th": "บ้านกาด",
            "name_en": "Ban Kat",
            "district_id": 5022,
            "lat": 18.637,
            "long": 98.752,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 502202,
            "zip_code": 50360,
            "name_th": "ทุ่งปี้",
            "name_en": "Thung Pi",
            "district_id": 5022,
            "lat": 18.587,
            "long": 98.741,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 502203,
            "zip_code": 50360,
            "name_th": "ทุ่งรวงทอง",
            "name_en": "Thung Ruang Thong",
            "district_id": 5022,
            "lat": 18.554,
            "long": 98.849,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 502204,
            "zip_code": 50360,
            "name_th": "แม่วิน",
            "name_en": "Mae Win",
            "district_id": 5022,
            "lat": 18.683,
            "long": 98.674,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 502205,
            "zip_code": 50360,
            "name_th": "ดอนเปา",
            "name_en": "Don Pao",
            "district_id": 5022,
            "lat": 18.679,
            "long": 98.783,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 5023,
        "name_th": "แม่ออน",
        "name_en": "Mae On",
        "province_id": 38,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 502301,
            "zip_code": 50130,
            "name_th": "ออนเหนือ",
            "name_en": "On Nuea",
            "district_id": 5023,
            "lat": 18.793,
            "long": 99.308,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 502302,
            "zip_code": 50130,
            "name_th": "ออนกลาง",
            "name_en": "On Klang",
            "district_id": 5023,
            "lat": 18.758,
            "long": 99.263,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 502303,
            "zip_code": 50130,
            "name_th": "บ้านสหกรณ์",
            "name_en": "Ban Sahakon",
            "district_id": 5023,
            "lat": 18.825,
            "long": 99.242,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 502304,
            "zip_code": 50130,
            "name_th": "ห้วยแก้ว",
            "name_en": "Huai Kaeo",
            "district_id": 5023,
            "lat": 18.884,
            "long": 99.327,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 502305,
            "zip_code": 50130,
            "name_th": "แม่ทา",
            "name_en": "Mae Tha",
            "district_id": 5023,
            "lat": 18.591,
            "long": 99.289,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 502306,
            "zip_code": 50130,
            "name_th": "ทาเหนือ",
            "name_en": "Tha Nuea",
            "district_id": 5023,
            "lat": 18.702,
            "long": 99.308,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 5024,
        "name_th": "ดอยหล่อ",
        "name_en": "Doi Lo",
        "province_id": 38,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 502401,
            "zip_code": 50160,
            "name_th": "ดอยหล่อ",
            "name_en": "Doi Lo",
            "district_id": 5024,
            "lat": 18.488,
            "long": 98.798,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 502402,
            "zip_code": 50160,
            "name_th": "สองแคว",
            "name_en": "Song Khwae",
            "district_id": 5024,
            "lat": 18.504,
            "long": 98.841,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 502403,
            "zip_code": 50160,
            "name_th": "ยางคราม",
            "name_en": "Yang Khram",
            "district_id": 5024,
            "lat": 18.56,
            "long": 98.782,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 502404,
            "zip_code": 50160,
            "name_th": "สันติสุข",
            "name_en": "Santi Suk",
            "district_id": 5024,
            "lat": 18.581,
            "long": 98.682,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 5025,
        "name_th": "กัลยาณิวัฒนา",
        "name_en": "Galyani Vadhana",
        "province_id": 38,
        "created_at": "2025-11-15T14:48:00.000+07:00",
        "updated_at": "2025-11-15T14:48:00.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 502501,
            "zip_code": 58130,
            "name_th": "บ้านจันทร์",
            "name_en": "Ban Chan",
            "district_id": 5025,
            "lat": 19.0825,
            "long": 98.3196,
            "created_at": "2025-11-15T14:48:00.000+07:00",
            "updated_at": "2025-11-15T14:48:00.000+07:00",
            "deleted_at": null
          },
          {
            "id": 502502,
            "zip_code": 50250,
            "name_th": "แม่แดด",
            "name_en": "Mae Daet",
            "district_id": 5025,
            "lat": 18.9382,
            "long": 98.3922,
            "created_at": "2025-11-15T14:48:00.000+07:00",
            "updated_at": "2025-11-15T14:48:00.000+07:00",
            "deleted_at": null
          },
          {
            "id": 502503,
            "zip_code": 58130,
            "name_th": "แจ่มหลวง",
            "name_en": "Chaem Luang",
            "district_id": 5025,
            "lat": 18.991,
            "long": 98.2174,
            "created_at": "2025-11-15T14:48:00.000+07:00",
            "updated_at": "2025-11-15T14:48:00.000+07:00",
            "deleted_at": null
          }
        ]
      }
    ]
  },
  {
    "id": 39,
    "name_th": "ลำพูน",
    "name_en": "Lamphun",
    "geography_id": 1,
    "created_at": "2019-08-09T03:33:09.000+07:00",
    "updated_at": "2025-09-20T06:31:26.000+07:00",
    "deleted_at": null,
    "districts": [
      {
        "id": 5101,
        "name_th": "เมืองลำพูน",
        "name_en": "Mueang Lamphun",
        "province_id": 39,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 510101,
            "zip_code": 51000,
            "name_th": "ในเมือง",
            "name_en": "Nai Mueang",
            "district_id": 5101,
            "lat": 18.573,
            "long": 99.002,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 510102,
            "zip_code": 51000,
            "name_th": "เหมืองง่า",
            "name_en": "Mueang Nga",
            "district_id": 5101,
            "lat": 18.613,
            "long": 99.032,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 510103,
            "zip_code": 51150,
            "name_th": "อุโมงค์",
            "name_en": "Umong",
            "district_id": 5101,
            "lat": 18.648,
            "long": 99.042,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 510104,
            "zip_code": 51150,
            "name_th": "หนองช้างคืน",
            "name_en": "Nong Chang Khuen",
            "district_id": 5101,
            "lat": 18.656,
            "long": 99.013,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 510105,
            "zip_code": 51000,
            "name_th": "ประตูป่า",
            "name_en": "Pratu Pa",
            "district_id": 5101,
            "lat": 18.623,
            "long": 98.986,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 510106,
            "zip_code": 51000,
            "name_th": "ริมปิง",
            "name_en": "Rim Ping",
            "district_id": 5101,
            "lat": 18.598,
            "long": 98.984,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 510107,
            "zip_code": 51000,
            "name_th": "ต้นธง",
            "name_en": "Ton Thong",
            "district_id": 5101,
            "lat": 18.572,
            "long": 98.985,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 510108,
            "zip_code": 51000,
            "name_th": "บ้านแป้น",
            "name_en": "Ban Paen",
            "district_id": 5101,
            "lat": 18.523,
            "long": 98.951,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 510109,
            "zip_code": 51000,
            "name_th": "เหมืองจี้",
            "name_en": "Mueang Chi",
            "district_id": 5101,
            "lat": 18.468,
            "long": 98.971,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 510110,
            "zip_code": 51000,
            "name_th": "ป่าสัก",
            "name_en": "Pa Sak",
            "district_id": 5101,
            "lat": 18.519,
            "long": 99.03,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 510111,
            "zip_code": 51000,
            "name_th": "เวียงยอง",
            "name_en": "Wiang Yong",
            "district_id": 5101,
            "lat": 18.558,
            "long": 99.009,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 510112,
            "zip_code": 51000,
            "name_th": "บ้านกลาง",
            "name_en": "Ban Klang",
            "district_id": 5101,
            "lat": 18.575,
            "long": 99.063,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 510113,
            "zip_code": 51000,
            "name_th": "มะเขือแจ้",
            "name_en": "Makhuea Chae",
            "district_id": 5101,
            "lat": 18.592,
            "long": 99.128,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 510116,
            "zip_code": 51000,
            "name_th": "ศรีบัวบาน",
            "name_en": "Si Bua Ban",
            "district_id": 5101,
            "lat": 18.517,
            "long": 99.109,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 510117,
            "zip_code": 51000,
            "name_th": "หนองหนาม",
            "name_en": "Nong Nam",
            "district_id": 5101,
            "lat": 18.502,
            "long": 98.989,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 5102,
        "name_th": "แม่ทา",
        "name_en": "Mae Tha",
        "province_id": 39,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 510201,
            "zip_code": 51140,
            "name_th": "ทาปลาดุก",
            "name_en": "Tha Pla Duk",
            "district_id": 5102,
            "lat": 18.532,
            "long": 99.245,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 510202,
            "zip_code": 51140,
            "name_th": "ทาสบเส้า",
            "name_en": "Tha Sop Sao",
            "district_id": 5102,
            "lat": 18.417,
            "long": 99.135,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 510203,
            "zip_code": 51170,
            "name_th": "ทากาศ",
            "name_en": "Tha Kat",
            "district_id": 5102,
            "lat": 18.342,
            "long": 99.052,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 510204,
            "zip_code": 51170,
            "name_th": "ทาขุมเงิน",
            "name_en": "Tha Khum Ngoen",
            "district_id": 5102,
            "lat": 18.363,
            "long": 98.962,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 510205,
            "zip_code": 51170,
            "name_th": "ทาทุ่งหลวง",
            "name_en": "Tha Thung Luang",
            "district_id": 5102,
            "lat": 18.438,
            "long": 99.03,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 510206,
            "zip_code": 51170,
            "name_th": "ทาแม่ลอบ",
            "name_en": "Tha Mae Lop",
            "district_id": 5102,
            "lat": 18.241,
            "long": 98.97,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 5103,
        "name_th": "บ้านโฮ่ง",
        "name_en": "Ban Hong",
        "province_id": 39,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 510301,
            "zip_code": 51130,
            "name_th": "บ้านโฮ่ง",
            "name_en": "Ban Hong",
            "district_id": 5103,
            "lat": 18.308,
            "long": 98.815,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 510302,
            "zip_code": 51130,
            "name_th": "ป่าพลู",
            "name_en": "Pa Phlu",
            "district_id": 5103,
            "lat": 18.211,
            "long": 98.867,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 510303,
            "zip_code": 51130,
            "name_th": "เหล่ายาว",
            "name_en": "Lao Yao",
            "district_id": 5103,
            "lat": 18.36,
            "long": 98.794,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 510304,
            "zip_code": 51130,
            "name_th": "ศรีเตี้ย",
            "name_en": "Si Tia",
            "district_id": 5103,
            "lat": 18.383,
            "long": 98.75,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 510305,
            "zip_code": 51130,
            "name_th": "หนองปลาสะวาย",
            "name_en": "Nong Pla Sawai",
            "district_id": 5103,
            "lat": 18.314,
            "long": 98.697,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 5104,
        "name_th": "ลี้",
        "name_en": "Li",
        "province_id": 39,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 510401,
            "zip_code": 51110,
            "name_th": "ลี้",
            "name_en": "Li",
            "district_id": 5104,
            "lat": 17.79,
            "long": 98.986,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 510402,
            "zip_code": 51110,
            "name_th": "แม่ตืน",
            "name_en": "Mae Tuen",
            "district_id": 5104,
            "lat": 17.956,
            "long": 98.956,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 510403,
            "zip_code": 51110,
            "name_th": "นาทราย",
            "name_en": "Na Sai",
            "district_id": 5104,
            "lat": 17.687,
            "long": 98.97,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 510404,
            "zip_code": 51110,
            "name_th": "ดงดำ",
            "name_en": "Dong Dam",
            "district_id": 5104,
            "lat": 17.742,
            "long": 99.062,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 510405,
            "zip_code": 51110,
            "name_th": "ก้อ",
            "name_en": "Ko",
            "district_id": 5104,
            "lat": 17.604,
            "long": 98.783,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 510406,
            "zip_code": 51110,
            "name_th": "แม่ลาน",
            "name_en": "Mae Lan",
            "district_id": 5104,
            "lat": 17.761,
            "long": 98.809,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 510408,
            "zip_code": 51110,
            "name_th": "ป่าไผ่",
            "name_en": "Pa Phai",
            "district_id": 5104,
            "lat": 17.855,
            "long": 98.936,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 510409,
            "zip_code": 51110,
            "name_th": "ศรีวิชัย",
            "name_en": "Si Wichai",
            "district_id": 5104,
            "lat": 18.079,
            "long": 98.898,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 5105,
        "name_th": "ทุ่งหัวช้าง",
        "name_en": "Thung Hua Chang",
        "province_id": 39,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 510501,
            "zip_code": 51160,
            "name_th": "ทุ่งหัวช้าง",
            "name_en": "Thung Hua Chang",
            "district_id": 5105,
            "lat": 17.983,
            "long": 99.048,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 510502,
            "zip_code": 51160,
            "name_th": "บ้านปวง",
            "name_en": "Ban Puang",
            "district_id": 5105,
            "lat": 17.87,
            "long": 99.089,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 510503,
            "zip_code": 51160,
            "name_th": "ตะเคียนปม",
            "name_en": "Takhian Pom",
            "district_id": 5105,
            "lat": 18.106,
            "long": 99.025,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 5106,
        "name_th": "ป่าซาง",
        "name_en": "Pa Sang",
        "province_id": 39,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 510601,
            "zip_code": 51120,
            "name_th": "ปากบ่อง",
            "name_en": "Pak Bong",
            "district_id": 5106,
            "lat": 18.537,
            "long": 98.933,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 510602,
            "zip_code": 51120,
            "name_th": "ป่าซาง",
            "name_en": "Pa Sang",
            "district_id": 5106,
            "lat": 18.512,
            "long": 98.937,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 510603,
            "zip_code": 51120,
            "name_th": "แม่แรง",
            "name_en": "Mae Raeng",
            "district_id": 5106,
            "lat": 18.498,
            "long": 98.91,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 510604,
            "zip_code": 51120,
            "name_th": "ม่วงน้อย",
            "name_en": "Muang Noi",
            "district_id": 5106,
            "lat": 18.479,
            "long": 98.941,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 510605,
            "zip_code": 51120,
            "name_th": "บ้านเรือน",
            "name_en": "Ban Ruean",
            "district_id": 5106,
            "lat": 18.509,
            "long": 98.871,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 510606,
            "zip_code": 51120,
            "name_th": "มะกอก",
            "name_en": "Makok",
            "district_id": 5106,
            "lat": 18.449,
            "long": 98.923,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 510607,
            "zip_code": 51120,
            "name_th": "ท่าตุ้ม",
            "name_en": "Tha Tum",
            "district_id": 5106,
            "lat": 18.478,
            "long": 98.873,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 510608,
            "zip_code": 51120,
            "name_th": "น้ำดิบ",
            "name_en": "Nam Dip",
            "district_id": 5106,
            "lat": 18.424,
            "long": 98.833,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 510611,
            "zip_code": 51120,
            "name_th": "นครเจดีย์",
            "name_en": "Nakhon Chedi",
            "district_id": 5106,
            "lat": 18.371,
            "long": 98.898,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 5107,
        "name_th": "บ้านธิ",
        "name_en": "Ban Thi",
        "province_id": 39,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 510701,
            "zip_code": 51180,
            "name_th": "บ้านธิ",
            "name_en": "Ban Thi",
            "district_id": 5107,
            "lat": 18.614,
            "long": 99.19,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 510702,
            "zip_code": 51180,
            "name_th": "ห้วยยาบ",
            "name_en": "Huai Yap",
            "district_id": 5107,
            "lat": 18.679,
            "long": 99.163,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 5108,
        "name_th": "เวียงหนองล่อง",
        "name_en": "Wiang Nong Long",
        "province_id": 39,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 510801,
            "zip_code": 51120,
            "name_th": "หนองล่อง",
            "name_en": "Nong Long",
            "district_id": 5108,
            "lat": 18.404,
            "long": 98.732,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 510802,
            "zip_code": 51120,
            "name_th": "หนองยวง",
            "name_en": "Nong Yuang",
            "district_id": 5108,
            "lat": 18.415,
            "long": 98.78,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 510803,
            "zip_code": 51120,
            "name_th": "วังผาง",
            "name_en": "Wang Phang",
            "district_id": 5108,
            "lat": 18.422,
            "long": 98.744,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      }
    ]
  },
  {
    "id": 40,
    "name_th": "ลำปาง",
    "name_en": "Lampang",
    "geography_id": 1,
    "created_at": "2019-08-09T03:33:09.000+07:00",
    "updated_at": "2025-09-20T06:31:26.000+07:00",
    "deleted_at": null,
    "districts": [
      {
        "id": 5201,
        "name_th": "เมืองลำปาง",
        "name_en": "Mueang Lampang",
        "province_id": 40,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 520101,
            "zip_code": 52000,
            "name_th": "เวียงเหนือ",
            "name_en": "Wiang Nuea",
            "district_id": 5201,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 520102,
            "zip_code": 52000,
            "name_th": "หัวเวียง",
            "name_en": "Hua Wiang",
            "district_id": 5201,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 520103,
            "zip_code": 52100,
            "name_th": "สวนดอก",
            "name_en": "Suan Dok",
            "district_id": 5201,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 520104,
            "zip_code": 52100,
            "name_th": "สบตุ๋ย",
            "name_en": "Sop Tui",
            "district_id": 5201,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 520105,
            "zip_code": 52000,
            "name_th": "พระบาท",
            "name_en": "Phra Bat",
            "district_id": 5201,
            "lat": 18.255,
            "long": 99.518,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 520106,
            "zip_code": 52100,
            "name_th": "ชมพู",
            "name_en": "Chomphu",
            "district_id": 5201,
            "lat": 18.254,
            "long": 99.479,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 520107,
            "zip_code": 52000,
            "name_th": "กล้วยแพะ",
            "name_en": "Kluai Phae",
            "district_id": 5201,
            "lat": 18.211,
            "long": 99.502,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 520108,
            "zip_code": 52100,
            "name_th": "ปงแสนทอง",
            "name_en": "Pong Saen Thong",
            "district_id": 5201,
            "lat": 18.268,
            "long": 99.432,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 520109,
            "zip_code": 52000,
            "name_th": "บ้านแลง",
            "name_en": "Ban Laeng",
            "district_id": 5201,
            "lat": 18.526,
            "long": 99.691,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 520110,
            "zip_code": 52000,
            "name_th": "บ้านเสด็จ",
            "name_en": "Ban Sadet",
            "district_id": 5201,
            "lat": 18.392,
            "long": 99.645,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 520111,
            "zip_code": 52000,
            "name_th": "พิชัย",
            "name_en": "Phichai",
            "district_id": 5201,
            "lat": 18.316,
            "long": 99.571,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 520112,
            "zip_code": 52000,
            "name_th": "ทุ่งฝาย",
            "name_en": "Thung Fai",
            "district_id": 5201,
            "lat": 18.374,
            "long": 99.55,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 520113,
            "zip_code": 52100,
            "name_th": "บ้านเอื้อม",
            "name_en": "Ban Ueam",
            "district_id": 5201,
            "lat": 18.478,
            "long": 99.357,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 520114,
            "zip_code": 52100,
            "name_th": "บ้านเป้า",
            "name_en": "Ban Pao",
            "district_id": 5201,
            "lat": 18.357,
            "long": 99.455,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 520115,
            "zip_code": 52100,
            "name_th": "บ้านค่า",
            "name_en": "Ban Kha",
            "district_id": 5201,
            "lat": 18.52,
            "long": 99.414,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 520116,
            "zip_code": 52100,
            "name_th": "บ่อแฮ้ว",
            "name_en": "Bo Haeo",
            "district_id": 5201,
            "lat": 18.31,
            "long": 99.433,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 520117,
            "zip_code": 52000,
            "name_th": "ต้นธงชัย",
            "name_en": "Ton Thong Chai",
            "district_id": 5201,
            "lat": 18.39,
            "long": 99.485,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 520118,
            "zip_code": 52000,
            "name_th": "นิคมพัฒนา",
            "name_en": "Nikhom Phatthana",
            "district_id": 5201,
            "lat": 18.445,
            "long": 99.545,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 520119,
            "zip_code": 52000,
            "name_th": "บุญนาคพัฒนา",
            "name_en": "Bunnak Phatthana",
            "district_id": 5201,
            "lat": 18.46,
            "long": 99.598,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 5202,
        "name_th": "แม่เมาะ",
        "name_en": "Mae Mo",
        "province_id": 40,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 520201,
            "zip_code": 52220,
            "name_th": "บ้านดง",
            "name_en": "Ban Dong",
            "district_id": 5202,
            "lat": 18.374,
            "long": 99.701,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 520202,
            "zip_code": 52220,
            "name_th": "นาสัก",
            "name_en": "Na Sak",
            "district_id": 5202,
            "lat": 18.343,
            "long": 99.836,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 520203,
            "zip_code": 52220,
            "name_th": "จางเหนือ",
            "name_en": "Chang Nuea",
            "district_id": 5202,
            "lat": 18.456,
            "long": 99.941,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 520204,
            "zip_code": 52220,
            "name_th": "แม่เมาะ",
            "name_en": "Mae Mo",
            "district_id": 5202,
            "lat": 18.297,
            "long": 99.668,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 520205,
            "zip_code": 52220,
            "name_th": "สบป้าด",
            "name_en": "Sop Pat",
            "district_id": 5202,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 5203,
        "name_th": "เกาะคา",
        "name_en": "Ko Kha",
        "province_id": 40,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 520301,
            "zip_code": 52130,
            "name_th": "ลำปางหลวง",
            "name_en": "Lampang Luang",
            "district_id": 5203,
            "lat": 18.238,
            "long": 99.387,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 520302,
            "zip_code": 52130,
            "name_th": "นาแก้ว",
            "name_en": "Na Kaeo",
            "district_id": 5203,
            "lat": 18.031,
            "long": 99.301,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 520303,
            "zip_code": 52130,
            "name_th": "ไหล่หิน",
            "name_en": "Lai Hin",
            "district_id": 5203,
            "lat": 18.186,
            "long": 99.255,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 520304,
            "zip_code": 52130,
            "name_th": "วังพร้าว",
            "name_en": "Wang Phrao",
            "district_id": 5203,
            "lat": 18.147,
            "long": 99.407,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 520305,
            "zip_code": 52130,
            "name_th": "ศาลา",
            "name_en": "Sala",
            "district_id": 5203,
            "lat": 18.196,
            "long": 99.413,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 520306,
            "zip_code": 52130,
            "name_th": "เกาะคา",
            "name_en": "Ko Kha",
            "district_id": 5203,
            "lat": 18.202,
            "long": 99.372,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 520307,
            "zip_code": 52130,
            "name_th": "นาแส่ง",
            "name_en": "Na Saeng",
            "district_id": 5203,
            "lat": 18.074,
            "long": 99.381,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 520308,
            "zip_code": 52130,
            "name_th": "ท่าผา",
            "name_en": "Tha Pha",
            "district_id": 5203,
            "lat": 18.173,
            "long": 99.365,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 520309,
            "zip_code": 52130,
            "name_th": "ใหม่พัฒนา",
            "name_en": "Mai Phatthana",
            "district_id": 5203,
            "lat": 18.254,
            "long": 99.318,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 5204,
        "name_th": "เสริมงาม",
        "name_en": "Soem Ngam",
        "province_id": 40,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 520401,
            "zip_code": 52210,
            "name_th": "ทุ่งงาม",
            "name_en": "Thung Ngam",
            "district_id": 5204,
            "lat": 18.071,
            "long": 99.244,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 520402,
            "zip_code": 52210,
            "name_th": "เสริมขวา",
            "name_en": "Soem Khwa",
            "district_id": 5204,
            "lat": 18.138,
            "long": 99.196,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 520403,
            "zip_code": 52210,
            "name_th": "เสริมซ้าย",
            "name_en": "Soem Sai",
            "district_id": 5204,
            "lat": 17.975,
            "long": 99.165,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 520404,
            "zip_code": 52210,
            "name_th": "เสริมกลาง",
            "name_en": "Soem Klang",
            "district_id": 5204,
            "lat": 18.132,
            "long": 99.087,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 5205,
        "name_th": "งาว",
        "name_en": "Ngao",
        "province_id": 40,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 520501,
            "zip_code": 52110,
            "name_th": "หลวงเหนือ",
            "name_en": "Luang Nuea",
            "district_id": 5205,
            "lat": 18.752,
            "long": 99.996,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 520502,
            "zip_code": 52110,
            "name_th": "หลวงใต้",
            "name_en": "Luang Tai",
            "district_id": 5205,
            "lat": 18.743,
            "long": 99.958,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 520503,
            "zip_code": 52110,
            "name_th": "บ้านโป่ง",
            "name_en": "Ban Pong",
            "district_id": 5205,
            "lat": 18.726,
            "long": 99.886,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 520504,
            "zip_code": 52110,
            "name_th": "บ้านร้อง",
            "name_en": "Ban Rong",
            "district_id": 5205,
            "lat": 18.972,
            "long": 99.824,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 520505,
            "zip_code": 52110,
            "name_th": "ปงเตา",
            "name_en": "Pong Tao",
            "district_id": 5205,
            "lat": 18.839,
            "long": 99.927,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 520506,
            "zip_code": 52110,
            "name_th": "นาแก",
            "name_en": "Na Kae",
            "district_id": 5205,
            "lat": 18.817,
            "long": 99.885,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 520507,
            "zip_code": 52110,
            "name_th": "บ้านอ้อน",
            "name_en": "Ban On",
            "district_id": 5205,
            "lat": 18.788,
            "long": 99.852,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 520508,
            "zip_code": 52110,
            "name_th": "บ้านแหง",
            "name_en": "Ban Haeng",
            "district_id": 5205,
            "lat": 18.782,
            "long": 100.054,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 520509,
            "zip_code": 52110,
            "name_th": "บ้านหวด",
            "name_en": "Ban Huat",
            "district_id": 5205,
            "lat": 18.609,
            "long": 99.888,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 520510,
            "zip_code": 52110,
            "name_th": "แม่ตีบ",
            "name_en": "Mae Tip",
            "district_id": 5205,
            "lat": 18.634,
            "long": 100.038,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 5206,
        "name_th": "แจ้ห่ม",
        "name_en": "Chae Hom",
        "province_id": 40,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 520601,
            "zip_code": 52120,
            "name_th": "แจ้ห่ม",
            "name_en": "Chae Hom",
            "district_id": 5206,
            "lat": 18.7,
            "long": 99.616,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 520602,
            "zip_code": 52120,
            "name_th": "บ้านสา",
            "name_en": "Ban Sa",
            "district_id": 5206,
            "lat": 18.592,
            "long": 99.561,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 520603,
            "zip_code": 52120,
            "name_th": "ปงดอน",
            "name_en": "Pong Don",
            "district_id": 5206,
            "lat": 18.783,
            "long": 99.695,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 520604,
            "zip_code": 52120,
            "name_th": "แม่สุก",
            "name_en": "Mae Suk",
            "district_id": 5206,
            "lat": 18.836,
            "long": 99.578,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 520605,
            "zip_code": 52120,
            "name_th": "เมืองมาย",
            "name_en": "Mueang Mai",
            "district_id": 5206,
            "lat": 18.645,
            "long": 99.725,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 520606,
            "zip_code": 52120,
            "name_th": "ทุ่งผึ้ง",
            "name_en": "Thung Phueng",
            "district_id": 5206,
            "lat": 18.914,
            "long": 99.703,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 520607,
            "zip_code": 52120,
            "name_th": "วิเชตนคร",
            "name_en": "Wichet Nakhon",
            "district_id": 5206,
            "lat": 18.726,
            "long": 99.557,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 5207,
        "name_th": "วังเหนือ",
        "name_en": "Wang Nuea",
        "province_id": 40,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 520701,
            "zip_code": 52140,
            "name_th": "ทุ่งฮั้ว",
            "name_en": "Thung Hua",
            "district_id": 5207,
            "lat": 19.229,
            "long": 99.631,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 520702,
            "zip_code": 52140,
            "name_th": "วังเหนือ",
            "name_en": "Wang Nuea",
            "district_id": 5207,
            "lat": 19.16,
            "long": 99.585,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 520703,
            "zip_code": 52140,
            "name_th": "วังใต้",
            "name_en": "Wang Tai",
            "district_id": 5207,
            "lat": 19.084,
            "long": 99.577,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 520704,
            "zip_code": 52140,
            "name_th": "ร่องเคาะ",
            "name_en": "Rong Kho",
            "district_id": 5207,
            "lat": 18.992,
            "long": 99.601,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 520705,
            "zip_code": 52140,
            "name_th": "วังทอง",
            "name_en": "Wang Thong",
            "district_id": 5207,
            "lat": 19.07,
            "long": 99.713,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 520706,
            "zip_code": 52140,
            "name_th": "วังซ้าย",
            "name_en": "Wang Sai",
            "district_id": 5207,
            "lat": 19.157,
            "long": 99.645,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 520707,
            "zip_code": 52140,
            "name_th": "วังแก้ว",
            "name_en": "Wang Kaeo",
            "district_id": 5207,
            "lat": 19.329,
            "long": 99.636,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 520708,
            "zip_code": 52140,
            "name_th": "วังทรายคำ",
            "name_en": "Wang Sai Kham",
            "district_id": 5207,
            "lat": 19.08,
            "long": 99.649,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 5208,
        "name_th": "เถิน",
        "name_en": "Thoen",
        "province_id": 40,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 520801,
            "zip_code": 52160,
            "name_th": "ล้อมแรด",
            "name_en": "Lom Raet",
            "district_id": 5208,
            "lat": 17.634,
            "long": 99.212,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 520802,
            "zip_code": 52230,
            "name_th": "แม่วะ",
            "name_en": "Mae Wa",
            "district_id": 5208,
            "lat": 17.468,
            "long": 99.216,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 520803,
            "zip_code": 52160,
            "name_th": "แม่ปะ",
            "name_en": "Mae Pa",
            "district_id": 5208,
            "lat": 17.684,
            "long": 99.299,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 520804,
            "zip_code": 52160,
            "name_th": "แม่มอก",
            "name_en": "Mae Mok",
            "district_id": 5208,
            "lat": 17.609,
            "long": 99.381,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 520805,
            "zip_code": 52160,
            "name_th": "เวียงมอก",
            "name_en": "Wiang Mok",
            "district_id": 5208,
            "lat": 17.396,
            "long": 99.353,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 520806,
            "zip_code": 52160,
            "name_th": "นาโป่ง",
            "name_en": "Na Pong",
            "district_id": 5208,
            "lat": 17.651,
            "long": 99.116,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 520807,
            "zip_code": 52160,
            "name_th": "แม่ถอด",
            "name_en": "Mae Thot",
            "district_id": 5208,
            "lat": 17.766,
            "long": 99.201,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 520808,
            "zip_code": 52160,
            "name_th": "เถินบุรี",
            "name_en": "Thoen Buri",
            "district_id": 5208,
            "lat": 17.558,
            "long": 99.207,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 5209,
        "name_th": "แม่พริก",
        "name_en": "Mae Phrik",
        "province_id": 40,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 520901,
            "zip_code": 52180,
            "name_th": "แม่พริก",
            "name_en": "Mae Phrik",
            "district_id": 5209,
            "lat": 17.513,
            "long": 99.009,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 520902,
            "zip_code": 52180,
            "name_th": "ผาปัง",
            "name_en": "Pha Pang",
            "district_id": 5209,
            "lat": 17.564,
            "long": 99.069,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 520903,
            "zip_code": 52180,
            "name_th": "แม่ปุ",
            "name_en": "Mae Pu",
            "district_id": 5209,
            "lat": 17.539,
            "long": 99.152,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 520904,
            "zip_code": 52180,
            "name_th": "พระบาทวังตวง",
            "name_en": "Phra Bat Wang Tuang",
            "district_id": 5209,
            "lat": 17.412,
            "long": 99.162,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 5210,
        "name_th": "แม่ทะ",
        "name_en": "Mae Tha",
        "province_id": 40,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 521001,
            "zip_code": 52150,
            "name_th": "แม่ทะ",
            "name_en": "Mae Tha",
            "district_id": 5210,
            "lat": 18.162,
            "long": 99.563,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 521002,
            "zip_code": 52150,
            "name_th": "นาครัว",
            "name_en": "Na Khrua",
            "district_id": 5210,
            "lat": 18.109,
            "long": 99.545,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 521003,
            "zip_code": 52150,
            "name_th": "ป่าตัน",
            "name_en": "Pa Tan",
            "district_id": 5210,
            "lat": 18.122,
            "long": 99.477,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 521004,
            "zip_code": 52150,
            "name_th": "บ้านกิ่ว",
            "name_en": "Ban Kio",
            "district_id": 5210,
            "lat": 18.089,
            "long": 99.491,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 521005,
            "zip_code": 52150,
            "name_th": "บ้านบอม",
            "name_en": "Ban Bom",
            "district_id": 5210,
            "lat": 18.054,
            "long": 99.489,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 521006,
            "zip_code": 52150,
            "name_th": "น้ำโจ้",
            "name_en": "Nam Cho",
            "district_id": 5210,
            "lat": 18.17,
            "long": 99.46,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 521007,
            "zip_code": 52150,
            "name_th": "ดอนไฟ",
            "name_en": "Don Fai",
            "district_id": 5210,
            "lat": 18.104,
            "long": 99.671,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 521008,
            "zip_code": 52150,
            "name_th": "หัวเสือ",
            "name_en": "Hua Suea",
            "district_id": 5210,
            "lat": 18.173,
            "long": 99.696,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 521010,
            "zip_code": 52150,
            "name_th": "วังเงิน",
            "name_en": "Wang Ngoen",
            "district_id": 5210,
            "lat": 18.09,
            "long": 99.614,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 521011,
            "zip_code": 52150,
            "name_th": "สันดอนแก้ว",
            "name_en": "San Don Kaeo",
            "district_id": 5210,
            "lat": 17.984,
            "long": 99.484,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 5211,
        "name_th": "สบปราบ",
        "name_en": "Sop Prap",
        "province_id": 40,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 521101,
            "zip_code": 52170,
            "name_th": "สบปราบ",
            "name_en": "Sop Prap",
            "district_id": 5211,
            "lat": 17.835,
            "long": 99.344,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 521102,
            "zip_code": 52170,
            "name_th": "สมัย",
            "name_en": "Samai",
            "district_id": 5211,
            "lat": 17.9,
            "long": 99.421,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 521103,
            "zip_code": 52170,
            "name_th": "แม่กัวะ",
            "name_en": "Mae Kua",
            "district_id": 5211,
            "lat": 17.956,
            "long": 99.353,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 521104,
            "zip_code": 52170,
            "name_th": "นายาง",
            "name_en": "Na Yang",
            "district_id": 5211,
            "lat": 17.904,
            "long": 99.266,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 5212,
        "name_th": "ห้างฉัตร",
        "name_en": "Hang Chat",
        "province_id": 40,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 521201,
            "zip_code": 52190,
            "name_th": "ห้างฉัตร",
            "name_en": "Hang Chat",
            "district_id": 5212,
            "lat": 18.337,
            "long": 99.353,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 521202,
            "zip_code": 52190,
            "name_th": "หนองหล่ม",
            "name_en": "Nong Lom",
            "district_id": 5212,
            "lat": 18.349,
            "long": 99.387,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 521203,
            "zip_code": 52190,
            "name_th": "เมืองยาว",
            "name_en": "Mueang Yao",
            "district_id": 5212,
            "lat": 18.269,
            "long": 99.2,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 521204,
            "zip_code": 52190,
            "name_th": "ปงยางคก",
            "name_en": "Pong Yang Khok",
            "district_id": 5212,
            "lat": 18.284,
            "long": 99.365,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 521205,
            "zip_code": 52190,
            "name_th": "เวียงตาล",
            "name_en": "Wiang Tan",
            "district_id": 5212,
            "lat": 18.408,
            "long": 99.277,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 521206,
            "zip_code": 52190,
            "name_th": "แม่สัน",
            "name_en": "Mae San",
            "district_id": 5212,
            "lat": 18.291,
            "long": 99.273,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 521207,
            "zip_code": 52190,
            "name_th": "วอแก้ว",
            "name_en": "Wo Kaeo",
            "district_id": 5212,
            "lat": 18.421,
            "long": 99.339,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 5213,
        "name_th": "เมืองปาน",
        "name_en": "Mueang Pan",
        "province_id": 40,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 521301,
            "zip_code": 52240,
            "name_th": "เมืองปาน",
            "name_en": "Mueang Pan",
            "district_id": 5213,
            "lat": 18.797,
            "long": 99.446,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 521302,
            "zip_code": 52240,
            "name_th": "บ้านขอ",
            "name_en": "Ban Kho",
            "district_id": 5213,
            "lat": 18.685,
            "long": 99.481,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 521303,
            "zip_code": 52240,
            "name_th": "ทุ่งกว๋าว",
            "name_en": "Thung Kwao",
            "district_id": 5213,
            "lat": 18.57,
            "long": 99.47,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 521304,
            "zip_code": 52240,
            "name_th": "แจ้ซ้อน",
            "name_en": "Chae Son",
            "district_id": 5213,
            "lat": 18.838,
            "long": 99.501,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 521305,
            "zip_code": 52240,
            "name_th": "หัวเมือง",
            "name_en": "Hua Mueang",
            "district_id": 5213,
            "lat": 18.946,
            "long": 99.531,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      }
    ]
  },
  {
    "id": 41,
    "name_th": "อุตรดิตถ์",
    "name_en": "Uttaradit",
    "geography_id": 1,
    "created_at": "2019-08-09T03:33:09.000+07:00",
    "updated_at": "2025-09-20T06:31:26.000+07:00",
    "deleted_at": null,
    "districts": [
      {
        "id": 5301,
        "name_th": "เมืองอุตรดิตถ์",
        "name_en": "Mueang Uttaradit",
        "province_id": 41,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 530101,
            "zip_code": 53000,
            "name_th": "ท่าอิฐ",
            "name_en": "Tha It",
            "district_id": 5301,
            "lat": 17.613,
            "long": 100.079,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 530102,
            "zip_code": 53000,
            "name_th": "ท่าเสา",
            "name_en": "Tha Sao",
            "district_id": 5301,
            "lat": 17.652,
            "long": 100.086,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 530103,
            "zip_code": 53000,
            "name_th": "บ้านเกาะ",
            "name_en": "Ban Ko",
            "district_id": 5301,
            "lat": 17.579,
            "long": 100.117,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 530104,
            "zip_code": 53000,
            "name_th": "ป่าเซ่า",
            "name_en": "Pa Sao",
            "district_id": 5301,
            "lat": 17.6,
            "long": 100.16,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 530105,
            "zip_code": 53000,
            "name_th": "คุ้งตะเภา",
            "name_en": "Khung Taphao",
            "district_id": 5301,
            "lat": 17.641,
            "long": 100.166,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 530106,
            "zip_code": 53170,
            "name_th": "วังกะพี้",
            "name_en": "Wang Kaphi",
            "district_id": 5301,
            "lat": 17.545,
            "long": 100.079,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 530107,
            "zip_code": 53000,
            "name_th": "หาดกรวด",
            "name_en": "Hat Kruat",
            "district_id": 5301,
            "lat": 17.562,
            "long": 100.199,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 530108,
            "zip_code": 53000,
            "name_th": "น้ำริด",
            "name_en": "Nam Rit",
            "district_id": 5301,
            "lat": 17.684,
            "long": 100.132,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 530109,
            "zip_code": 53000,
            "name_th": "งิ้วงาม",
            "name_en": "Ngio Ngam",
            "district_id": 5301,
            "lat": 17.702,
            "long": 100.174,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 530110,
            "zip_code": 53000,
            "name_th": "บ้านด่านนาขาม",
            "name_en": "Ban Dan Na Kham",
            "district_id": 5301,
            "lat": 17.784,
            "long": 100.161,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 530111,
            "zip_code": 53000,
            "name_th": "บ้านด่าน",
            "name_en": "Ban Dan",
            "district_id": 5301,
            "lat": 17.663,
            "long": 100.28,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 530112,
            "zip_code": 53000,
            "name_th": "ผาจุก",
            "name_en": "Pha Chuk",
            "district_id": 5301,
            "lat": 17.639,
            "long": 100.243,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 530113,
            "zip_code": 53000,
            "name_th": "วังดิน",
            "name_en": "Wang Din",
            "district_id": 5301,
            "lat": 17.737,
            "long": 100.266,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 530114,
            "zip_code": 53000,
            "name_th": "แสนตอ",
            "name_en": "Saen To",
            "district_id": 5301,
            "lat": 17.651,
            "long": 100.365,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 530115,
            "zip_code": 53000,
            "name_th": "หาดงิ้ว",
            "name_en": "Hat Ngio",
            "district_id": 5301,
            "lat": 17.681,
            "long": 100.337,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 530116,
            "zip_code": 53000,
            "name_th": "ขุนฝาง",
            "name_en": "Khun Fang",
            "district_id": 5301,
            "lat": 17.76,
            "long": 100.223,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 530117,
            "zip_code": 53000,
            "name_th": "ถ้ำฉลอง",
            "name_en": "Tham Chalong",
            "district_id": 5301,
            "lat": 17.606,
            "long": 100.36,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 5302,
        "name_th": "ตรอน",
        "name_en": "Tron",
        "province_id": 41,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 530201,
            "zip_code": 53140,
            "name_th": "วังแดง",
            "name_en": "Wang Daeng",
            "district_id": 5302,
            "lat": 17.488,
            "long": 100.113,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 530202,
            "zip_code": 53140,
            "name_th": "บ้านแก่ง",
            "name_en": "Ban Kaeng",
            "district_id": 5302,
            "lat": 17.441,
            "long": 100.158,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 530203,
            "zip_code": 53140,
            "name_th": "หาดสองแคว",
            "name_en": "Hat Song Khwae",
            "district_id": 5302,
            "lat": 17.426,
            "long": 100.115,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 530204,
            "zip_code": 53140,
            "name_th": "น้ำอ่าง",
            "name_en": "Nam Ang",
            "district_id": 5302,
            "lat": 17.456,
            "long": 100.215,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 530205,
            "zip_code": 53140,
            "name_th": "ข่อยสูง",
            "name_en": "Khoi Sung",
            "district_id": 5302,
            "lat": 17.502,
            "long": 99.976,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 5303,
        "name_th": "ท่าปลา",
        "name_en": "Tha Pla",
        "province_id": 41,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 530301,
            "zip_code": 53150,
            "name_th": "ท่าปลา",
            "name_en": "Tha Pla",
            "district_id": 5303,
            "lat": 17.845,
            "long": 100.448,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 530302,
            "zip_code": 53150,
            "name_th": "หาดล้า",
            "name_en": "Hat La",
            "district_id": 5303,
            "lat": 17.76,
            "long": 100.333,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 530303,
            "zip_code": 53190,
            "name_th": "ผาเลือด",
            "name_en": "Pha Lueat",
            "district_id": 5303,
            "lat": 17.749,
            "long": 100.491,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 530304,
            "zip_code": 53150,
            "name_th": "จริม",
            "name_en": "Charim",
            "district_id": 5303,
            "lat": 17.834,
            "long": 100.353,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 530305,
            "zip_code": 53150,
            "name_th": "น้ำหมัน",
            "name_en": "Nam Man",
            "district_id": 5303,
            "lat": 17.862,
            "long": 100.25,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 530306,
            "zip_code": 53110,
            "name_th": "ท่าแฝก",
            "name_en": "Tha Faek",
            "district_id": 5303,
            "lat": 17.92,
            "long": 100.615,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 530307,
            "zip_code": 53150,
            "name_th": "นางพญา",
            "name_en": "Nang Phaya",
            "district_id": 5303,
            "lat": 17.97,
            "long": 100.441,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 530308,
            "zip_code": 53190,
            "name_th": "ร่วมจิต",
            "name_en": "Ruam Chit",
            "district_id": 5303,
            "lat": 17.718,
            "long": 100.329,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 5304,
        "name_th": "น้ำปาด",
        "name_en": "Nam Pat",
        "province_id": 41,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 530401,
            "zip_code": 53110,
            "name_th": "แสนตอ",
            "name_en": "Saen To",
            "district_id": 5304,
            "lat": 17.72,
            "long": 100.646,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 530402,
            "zip_code": 53110,
            "name_th": "บ้านฝาย",
            "name_en": "Ban Fai",
            "district_id": 5304,
            "lat": 17.74,
            "long": 100.758,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 530403,
            "zip_code": 53110,
            "name_th": "เด่นเหล็ก",
            "name_en": "Den Lek",
            "district_id": 5304,
            "lat": 17.82,
            "long": 100.788,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 530404,
            "zip_code": 53110,
            "name_th": "น้ำไคร้",
            "name_en": "Nam Khrai",
            "district_id": 5304,
            "lat": 17.608,
            "long": 100.542,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 530405,
            "zip_code": 53110,
            "name_th": "น้ำไผ่",
            "name_en": "Nam Phai",
            "district_id": 5304,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 530406,
            "zip_code": 53110,
            "name_th": "ห้วยมุ่น",
            "name_en": "Huai Mun",
            "district_id": 5304,
            "lat": 17.794,
            "long": 100.935,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 5305,
        "name_th": "ฟากท่า",
        "name_en": "Fak Tha",
        "province_id": 41,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 530501,
            "zip_code": 53160,
            "name_th": "ฟากท่า",
            "name_en": "Fak Tha",
            "district_id": 5305,
            "lat": 18.068,
            "long": 100.937,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 530502,
            "zip_code": 53160,
            "name_th": "สองคอน",
            "name_en": "Song Khon",
            "district_id": 5305,
            "lat": 17.955,
            "long": 100.906,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 530503,
            "zip_code": 53160,
            "name_th": "บ้านเสี้ยว",
            "name_en": "Ban Siao",
            "district_id": 5305,
            "lat": 17.914,
            "long": 100.848,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 530504,
            "zip_code": 53160,
            "name_th": "สองห้อง",
            "name_en": "Song Hong",
            "district_id": 5305,
            "lat": 17.93,
            "long": 100.757,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 5306,
        "name_th": "บ้านโคก",
        "name_en": "Ban Khok",
        "province_id": 41,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 530601,
            "zip_code": 53180,
            "name_th": "ม่วงเจ็ดต้น",
            "name_en": "Muang Chet Ton",
            "district_id": 5306,
            "lat": 18.115,
            "long": 101.062,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 530602,
            "zip_code": 53180,
            "name_th": "บ้านโคก",
            "name_en": "Ban Khok",
            "district_id": 5306,
            "lat": 18.008,
            "long": 101.084,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 530603,
            "zip_code": 53180,
            "name_th": "นาขุม",
            "name_en": "Na Khum",
            "district_id": 5306,
            "lat": 17.951,
            "long": 100.998,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 530604,
            "zip_code": 53180,
            "name_th": "บ่อเบี้ย",
            "name_en": "Bo Bia",
            "district_id": 5306,
            "lat": 18.253,
            "long": 101.044,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 5307,
        "name_th": "พิชัย",
        "name_en": "Phichai",
        "province_id": 41,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 530701,
            "zip_code": 53120,
            "name_th": "ในเมือง",
            "name_en": "Nai Mueang",
            "district_id": 5307,
            "lat": 17.301,
            "long": 100.107,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 530702,
            "zip_code": 53220,
            "name_th": "บ้านดารา",
            "name_en": "Ban Dara",
            "district_id": 5307,
            "lat": 17.37,
            "long": 100.13,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 530703,
            "zip_code": 53120,
            "name_th": "ไร่อ้อย",
            "name_en": "Rai Oi",
            "district_id": 5307,
            "lat": 17.358,
            "long": 100.027,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 530704,
            "zip_code": 53220,
            "name_th": "ท่าสัก",
            "name_en": "Tha Sak",
            "district_id": 5307,
            "lat": 17.379,
            "long": 100.178,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 530705,
            "zip_code": 53120,
            "name_th": "คอรุม",
            "name_en": "Kho Rum",
            "district_id": 5307,
            "lat": 17.292,
            "long": 100.031,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 530706,
            "zip_code": 53120,
            "name_th": "บ้านหม้อ",
            "name_en": "Ban Mo",
            "district_id": 5307,
            "lat": 17.256,
            "long": 100.123,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 530707,
            "zip_code": 53120,
            "name_th": "ท่ามะเฟือง",
            "name_en": "Tha Mafueang",
            "district_id": 5307,
            "lat": 17.238,
            "long": 100.021,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 530708,
            "zip_code": 53120,
            "name_th": "บ้านโคน",
            "name_en": "Ban Khon",
            "district_id": 5307,
            "lat": 17.208,
            "long": 100.138,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 530709,
            "zip_code": 53120,
            "name_th": "พญาแมน",
            "name_en": "Phaya Maen",
            "district_id": 5307,
            "lat": 17.187,
            "long": 100.016,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 530710,
            "zip_code": 53120,
            "name_th": "นาอิน",
            "name_en": "Na In",
            "district_id": 5307,
            "lat": 17.245,
            "long": 100.193,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 530711,
            "zip_code": 53120,
            "name_th": "นายาง",
            "name_en": "Na Yang",
            "district_id": 5307,
            "lat": 17.318,
            "long": 100.21,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 5308,
        "name_th": "ลับแล",
        "name_en": "Laplae",
        "province_id": 41,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 530801,
            "zip_code": 53130,
            "name_th": "ศรีพนมมาศ",
            "name_en": "Si Phanom Mat",
            "district_id": 5308,
            "lat": 17.652,
            "long": 100.039,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 530802,
            "zip_code": 53130,
            "name_th": "แม่พูล",
            "name_en": "Mae Phun",
            "district_id": 5308,
            "lat": 17.746,
            "long": 99.968,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 530803,
            "zip_code": 53130,
            "name_th": "นานกกก",
            "name_en": "Na Nok Kok",
            "district_id": 5308,
            "lat": 17.754,
            "long": 100.072,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 530804,
            "zip_code": 53130,
            "name_th": "ฝายหลวง",
            "name_en": "Fai Luang",
            "district_id": 5308,
            "lat": 17.651,
            "long": 99.997,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 530805,
            "zip_code": 53130,
            "name_th": "ชัยจุมพล",
            "name_en": "Chai Chumphon",
            "district_id": 5308,
            "lat": 17.631,
            "long": 100.037,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 530806,
            "zip_code": 53210,
            "name_th": "ไผ่ล้อม",
            "name_en": "Phai Lom",
            "district_id": 5308,
            "lat": 17.529,
            "long": 100.035,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 530807,
            "zip_code": 53210,
            "name_th": "ทุ่งยั้ง",
            "name_en": "Thung Yang",
            "district_id": 5308,
            "lat": 17.58,
            "long": 100.015,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 530808,
            "zip_code": 53210,
            "name_th": "ด่านแม่คำมัน",
            "name_en": "Dan Mae Kham Man",
            "district_id": 5308,
            "lat": 17.547,
            "long": 99.963,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 5309,
        "name_th": "ทองแสนขัน",
        "name_en": "Thong Saen Khan",
        "province_id": 41,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 530901,
            "zip_code": 53230,
            "name_th": "ผักขวง",
            "name_en": "Phak Khuang",
            "district_id": 5309,
            "lat": 17.535,
            "long": 100.415,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 530902,
            "zip_code": 53230,
            "name_th": "บ่อทอง",
            "name_en": "Bo Thong",
            "district_id": 5309,
            "lat": 17.444,
            "long": 100.356,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 530903,
            "zip_code": 53230,
            "name_th": "ป่าคาย",
            "name_en": "Pa Khai",
            "district_id": 5309,
            "lat": 17.495,
            "long": 100.267,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 530904,
            "zip_code": 53230,
            "name_th": "น้ำพี้",
            "name_en": "Nam Phi",
            "district_id": 5309,
            "lat": 17.581,
            "long": 100.299,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      }
    ]
  },
  {
    "id": 42,
    "name_th": "แพร่",
    "name_en": "Phrae",
    "geography_id": 1,
    "created_at": "2019-08-09T03:33:09.000+07:00",
    "updated_at": "2025-09-20T06:31:26.000+07:00",
    "deleted_at": null,
    "districts": [
      {
        "id": 5401,
        "name_th": "เมืองแพร่",
        "name_en": "Mueang Phrae",
        "province_id": 42,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 540101,
            "zip_code": 54000,
            "name_th": "ในเวียง",
            "name_en": "Nai Wiang",
            "district_id": 5401,
            "lat": 18.14,
            "long": 100.142,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 540102,
            "zip_code": 54000,
            "name_th": "นาจักร",
            "name_en": "Na Chak",
            "district_id": 5401,
            "lat": 18.113,
            "long": 100.164,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 540103,
            "zip_code": 54000,
            "name_th": "น้ำชำ",
            "name_en": "Nam Cham",
            "district_id": 5401,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 540104,
            "zip_code": 54000,
            "name_th": "ป่าแดง",
            "name_en": "Pa Daeng",
            "district_id": 5401,
            "lat": 18.063,
            "long": 100.316,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 540105,
            "zip_code": 54000,
            "name_th": "ทุ่งโฮ้ง",
            "name_en": "Thung Hong",
            "district_id": 5401,
            "lat": 18.188,
            "long": 100.196,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 540106,
            "zip_code": 54000,
            "name_th": "เหมืองหม้อ",
            "name_en": "Mueang Mo",
            "district_id": 5401,
            "lat": 18.163,
            "long": 100.21,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 540107,
            "zip_code": 54000,
            "name_th": "วังธง",
            "name_en": "Wang Thong",
            "district_id": 5401,
            "lat": 18.209,
            "long": 100.11,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 540108,
            "zip_code": 54000,
            "name_th": "แม่หล่าย",
            "name_en": "Mae Lai",
            "district_id": 5401,
            "lat": 18.215,
            "long": 100.204,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 540109,
            "zip_code": 54000,
            "name_th": "ห้วยม้า",
            "name_en": "Huai Ma",
            "district_id": 5401,
            "lat": 18.228,
            "long": 100.237,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 540110,
            "zip_code": 54000,
            "name_th": "ป่าแมต",
            "name_en": "Pa Maet",
            "district_id": 5401,
            "lat": 18.158,
            "long": 100.092,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 540111,
            "zip_code": 54000,
            "name_th": "บ้านถิ่น",
            "name_en": "Ban Thin",
            "district_id": 5401,
            "lat": 18.154,
            "long": 100.224,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 540112,
            "zip_code": 54000,
            "name_th": "สวนเขื่อน",
            "name_en": "Suan Khuean",
            "district_id": 5401,
            "lat": 18.128,
            "long": 100.306,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 540113,
            "zip_code": 54000,
            "name_th": "วังหงส์",
            "name_en": "Wang Hong",
            "district_id": 5401,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 540114,
            "zip_code": 54000,
            "name_th": "แม่คำมี",
            "name_en": "Mae Kham Mi",
            "district_id": 5401,
            "lat": 18.247,
            "long": 100.217,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 540115,
            "zip_code": 54000,
            "name_th": "ทุ่งกวาว",
            "name_en": "Thung Kwao",
            "district_id": 5401,
            "lat": 18.165,
            "long": 100.154,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 540116,
            "zip_code": 54000,
            "name_th": "ท่าข้าม",
            "name_en": "Tha Kham",
            "district_id": 5401,
            "lat": 18.229,
            "long": 100.126,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 540117,
            "zip_code": 54000,
            "name_th": "แม่ยม",
            "name_en": "Mae Yom",
            "district_id": 5401,
            "lat": 18.187,
            "long": 100.157,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 540118,
            "zip_code": 54000,
            "name_th": "ช่อแฮ",
            "name_en": "Cho Hae",
            "district_id": 5401,
            "lat": 17.954,
            "long": 100.323,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 540119,
            "zip_code": 54000,
            "name_th": "ร่องฟอง",
            "name_en": "Rong Fong",
            "district_id": 5401,
            "lat": 18.167,
            "long": 100.193,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 540120,
            "zip_code": 54000,
            "name_th": "กาญจนา",
            "name_en": "Kanchana",
            "district_id": 5401,
            "lat": 18.123,
            "long": 100.184,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 5402,
        "name_th": "ร้องกวาง",
        "name_en": "Rong Kwang",
        "province_id": 42,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 540201,
            "zip_code": 54140,
            "name_th": "ร้องกวาง",
            "name_en": "Rong Kwang",
            "district_id": 5402,
            "lat": 18.351,
            "long": 100.336,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 540204,
            "zip_code": 54140,
            "name_th": "ร้องเข็ม",
            "name_en": "Rong Khem",
            "district_id": 5402,
            "lat": 18.293,
            "long": 100.313,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 540205,
            "zip_code": 54140,
            "name_th": "น้ำเลา",
            "name_en": "Nam Lao",
            "district_id": 5402,
            "lat": 18.254,
            "long": 100.309,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 540206,
            "zip_code": 54140,
            "name_th": "บ้านเวียง",
            "name_en": "Ban Wiang",
            "district_id": 5402,
            "lat": 18.208,
            "long": 100.381,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 540207,
            "zip_code": 54140,
            "name_th": "ทุ่งศรี",
            "name_en": "Thung Si",
            "district_id": 5402,
            "lat": 18.316,
            "long": 100.34,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 540208,
            "zip_code": 54140,
            "name_th": "แม่ยางตาล",
            "name_en": "Mae Yang Tan",
            "district_id": 5402,
            "lat": 18.304,
            "long": 100.257,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 540209,
            "zip_code": 54140,
            "name_th": "แม่ยางฮ่อ",
            "name_en": "Mae Yang Ho",
            "district_id": 5402,
            "lat": 18.35,
            "long": 100.26,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 540210,
            "zip_code": 54140,
            "name_th": "ไผ่โทน",
            "name_en": "Phai Thon",
            "district_id": 5402,
            "lat": 18.32,
            "long": 100.464,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 540213,
            "zip_code": 54140,
            "name_th": "ห้วยโรง",
            "name_en": "Huai Rong",
            "district_id": 5402,
            "lat": 18.432,
            "long": 100.513,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 540214,
            "zip_code": 54140,
            "name_th": "แม่ทราย",
            "name_en": "Mae Sai",
            "district_id": 5402,
            "lat": 18.411,
            "long": 100.314,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 540215,
            "zip_code": 54140,
            "name_th": "แม่ยางร้อง",
            "name_en": "Mae Yang Rong",
            "district_id": 5402,
            "lat": 18.396,
            "long": 100.248,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 5403,
        "name_th": "ลอง",
        "name_en": "Long",
        "province_id": 42,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 540301,
            "zip_code": 54150,
            "name_th": "ห้วยอ้อ",
            "name_en": "Huai O",
            "district_id": 5403,
            "lat": 18.131,
            "long": 99.825,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 540302,
            "zip_code": 54150,
            "name_th": "บ้านปิน",
            "name_en": "Ban Pin",
            "district_id": 5403,
            "lat": 18.065,
            "long": 99.937,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 540303,
            "zip_code": 54150,
            "name_th": "ต้าผามอก",
            "name_en": "Ta Pha Mok",
            "district_id": 5403,
            "lat": 18.151,
            "long": 99.983,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 540304,
            "zip_code": 54150,
            "name_th": "เวียงต้า",
            "name_en": "Wiang Ta",
            "district_id": 5403,
            "lat": 18.303,
            "long": 99.999,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 540305,
            "zip_code": 54150,
            "name_th": "ปากกาง",
            "name_en": "Pak Kang",
            "district_id": 5403,
            "lat": 18.042,
            "long": 99.811,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 540306,
            "zip_code": 54150,
            "name_th": "หัวทุ่ง",
            "name_en": "Hua Thung",
            "district_id": 5403,
            "lat": 18.093,
            "long": 99.776,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 540307,
            "zip_code": 54150,
            "name_th": "ทุ่งแล้ง",
            "name_en": "Thung Laeng",
            "district_id": 5403,
            "lat": 17.959,
            "long": 99.752,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 540308,
            "zip_code": 54150,
            "name_th": "บ่อเหล็กลอง",
            "name_en": "Bo Lek Long",
            "district_id": 5403,
            "lat": 18.013,
            "long": 99.719,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 540309,
            "zip_code": 54150,
            "name_th": "แม่ปาน",
            "name_en": "Mae Pan",
            "district_id": 5403,
            "lat": 17.986,
            "long": 99.871,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 5404,
        "name_th": "สูงเม่น",
        "name_en": "Sung Men",
        "province_id": 42,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 540401,
            "zip_code": 54130,
            "name_th": "สูงเม่น",
            "name_en": "Sung Men",
            "district_id": 5404,
            "lat": 18.059,
            "long": 100.087,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 540402,
            "zip_code": 54130,
            "name_th": "น้ำชำ",
            "name_en": "Nam Cham",
            "district_id": 5404,
            "lat": 18.034,
            "long": 100.091,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 540403,
            "zip_code": 54130,
            "name_th": "หัวฝาย",
            "name_en": "Hua Fai",
            "district_id": 5404,
            "lat": 17.961,
            "long": 100.188,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 540404,
            "zip_code": 54130,
            "name_th": "ดอนมูล",
            "name_en": "Don Mun",
            "district_id": 5404,
            "lat": 18.067,
            "long": 100.126,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 540405,
            "zip_code": 54130,
            "name_th": "บ้านเหล่า",
            "name_en": "Ban Lao",
            "district_id": 5404,
            "lat": 18.015,
            "long": 100.206,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 540406,
            "zip_code": 54130,
            "name_th": "บ้านกวาง",
            "name_en": "Ban Kwang",
            "district_id": 5404,
            "lat": 18.033,
            "long": 100.222,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 540407,
            "zip_code": 54130,
            "name_th": "บ้านปง",
            "name_en": "Ban Pong",
            "district_id": 5404,
            "lat": 18.06,
            "long": 100.026,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 540408,
            "zip_code": 54130,
            "name_th": "บ้านกาศ",
            "name_en": "Ban Kat",
            "district_id": 5404,
            "lat": 18.09,
            "long": 100.168,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 540409,
            "zip_code": 54130,
            "name_th": "ร่องกาศ",
            "name_en": "Rong Kat",
            "district_id": 5404,
            "lat": 18.096,
            "long": 100.126,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 540410,
            "zip_code": 54130,
            "name_th": "สบสาย",
            "name_en": "Sop Sai",
            "district_id": 5404,
            "lat": 18.102,
            "long": 100.023,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 540411,
            "zip_code": 54000,
            "name_th": "เวียงทอง",
            "name_en": "Wiang Thong",
            "district_id": 5404,
            "lat": 18.124,
            "long": 100.046,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 540412,
            "zip_code": 54130,
            "name_th": "พระหลวง",
            "name_en": "Phra Luang",
            "district_id": 5404,
            "lat": 18.069,
            "long": 100.111,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 5405,
        "name_th": "เด่นชัย",
        "name_en": "Den Chai",
        "province_id": 42,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 540501,
            "zip_code": 54110,
            "name_th": "เด่นชัย",
            "name_en": "Den Chai",
            "district_id": 5405,
            "lat": 17.973,
            "long": 100.04,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 540502,
            "zip_code": 54110,
            "name_th": "แม่จั๊วะ",
            "name_en": "Mae Chua",
            "district_id": 5405,
            "lat": 17.975,
            "long": 100.104,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 540503,
            "zip_code": 54110,
            "name_th": "ไทรย้อย",
            "name_en": "Sai Yoi",
            "district_id": 5405,
            "lat": 17.892,
            "long": 99.956,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 540504,
            "zip_code": 54110,
            "name_th": "ห้วยไร่",
            "name_en": "Huai Rai",
            "district_id": 5405,
            "lat": 17.898,
            "long": 100.09,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 540505,
            "zip_code": 54110,
            "name_th": "ปงป่าหวาย",
            "name_en": "Pong Pa Wai",
            "district_id": 5405,
            "lat": 18.024,
            "long": 99.991,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 5406,
        "name_th": "สอง",
        "name_en": "Song",
        "province_id": 42,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 540601,
            "zip_code": 54120,
            "name_th": "บ้านหนุน",
            "name_en": "Ban Nun",
            "district_id": 5406,
            "lat": 18.437,
            "long": 100.234,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 540602,
            "zip_code": 54120,
            "name_th": "บ้านกลาง",
            "name_en": "Ban Klang",
            "district_id": 5406,
            "lat": 18.485,
            "long": 100.183,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 540603,
            "zip_code": 54120,
            "name_th": "ห้วยหม้าย",
            "name_en": "Huai Mai",
            "district_id": 5406,
            "lat": 18.418,
            "long": 100.089,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 540604,
            "zip_code": 54120,
            "name_th": "เตาปูน",
            "name_en": "Tao Pun",
            "district_id": 5406,
            "lat": 18.531,
            "long": 100.271,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 540605,
            "zip_code": 54120,
            "name_th": "หัวเมือง",
            "name_en": "Hua Mueang",
            "district_id": 5406,
            "lat": 18.333,
            "long": 100.181,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 540606,
            "zip_code": 54120,
            "name_th": "สะเอียบ",
            "name_en": "Sa-iap",
            "district_id": 5406,
            "lat": 18.709,
            "long": 100.247,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 540607,
            "zip_code": 54120,
            "name_th": "แดนชุมพล",
            "name_en": "Daen Chumphon",
            "district_id": 5406,
            "lat": 18.365,
            "long": 100.198,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 540608,
            "zip_code": 54120,
            "name_th": "ทุ่งน้าว",
            "name_en": "Thung Nao",
            "district_id": 5406,
            "lat": 18.402,
            "long": 100.2,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 5407,
        "name_th": "วังชิ้น",
        "name_en": "Wang Chin",
        "province_id": 42,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 540701,
            "zip_code": 54160,
            "name_th": "วังชิ้น",
            "name_en": "Wang Chin",
            "district_id": 5407,
            "lat": 17.861,
            "long": 99.647,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 540702,
            "zip_code": 54160,
            "name_th": "สรอย",
            "name_en": "Saroi",
            "district_id": 5407,
            "lat": 17.759,
            "long": 99.425,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 540703,
            "zip_code": 54160,
            "name_th": "แม่ป้าก",
            "name_en": "Mae Pak",
            "district_id": 5407,
            "lat": 18.005,
            "long": 99.638,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 540704,
            "zip_code": 54160,
            "name_th": "นาพูน",
            "name_en": "Na Phun",
            "district_id": 5407,
            "lat": 17.85,
            "long": 99.79,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 540705,
            "zip_code": 54160,
            "name_th": "แม่พุง",
            "name_en": "Mae Phung",
            "district_id": 5407,
            "lat": 17.866,
            "long": 99.539,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 540706,
            "zip_code": 54160,
            "name_th": "ป่าสัก",
            "name_en": "Pa Sak",
            "district_id": 5407,
            "lat": 17.826,
            "long": 99.472,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 540707,
            "zip_code": 54160,
            "name_th": "แม่เกิ๋ง",
            "name_en": "Mae Koeng",
            "district_id": 5407,
            "lat": 17.945,
            "long": 99.556,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 5408,
        "name_th": "หนองม่วงไข่",
        "name_en": "Nong Muang Khai",
        "province_id": 42,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 540801,
            "zip_code": 54170,
            "name_th": "แม่คำมี",
            "name_en": "Mae Kham Mi",
            "district_id": 5408,
            "lat": 18.271,
            "long": 100.218,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 540802,
            "zip_code": 54170,
            "name_th": "หนองม่วงไข่",
            "name_en": "Nong Muang Khai",
            "district_id": 5408,
            "lat": 18.295,
            "long": 100.208,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 540803,
            "zip_code": 54170,
            "name_th": "น้ำรัด",
            "name_en": "Nam Rat",
            "district_id": 5408,
            "lat": 18.268,
            "long": 100.138,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 540804,
            "zip_code": 54170,
            "name_th": "วังหลวง",
            "name_en": "Wang Luang",
            "district_id": 5408,
            "lat": 18.294,
            "long": 100.115,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 540805,
            "zip_code": 54170,
            "name_th": "ตำหนักธรรม",
            "name_en": "Tamnak Tham",
            "district_id": 5408,
            "lat": 18.271,
            "long": 100.266,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 540806,
            "zip_code": 54170,
            "name_th": "ทุ่งแค้ว",
            "name_en": "Thung Khaeo",
            "district_id": 5408,
            "lat": 18.32,
            "long": 100.12,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      }
    ]
  },
  {
    "id": 43,
    "name_th": "น่าน",
    "name_en": "Nan",
    "geography_id": 1,
    "created_at": "2019-08-09T03:33:09.000+07:00",
    "updated_at": "2025-09-20T06:31:26.000+07:00",
    "deleted_at": null,
    "districts": [
      {
        "id": 5501,
        "name_th": "เมืองน่าน",
        "name_en": "Mueang Nan",
        "province_id": 43,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 550101,
            "zip_code": 55000,
            "name_th": "ในเวียง",
            "name_en": "Nai Wiang",
            "district_id": 5501,
            "lat": 18.793,
            "long": 100.786,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 550102,
            "zip_code": 55000,
            "name_th": "บ่อ",
            "name_en": "Bo",
            "district_id": 5501,
            "lat": 18.97,
            "long": 100.721,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 550103,
            "zip_code": 55000,
            "name_th": "ผาสิงห์",
            "name_en": "Pha Sing",
            "district_id": 5501,
            "lat": 18.85,
            "long": 100.749,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 550104,
            "zip_code": 55000,
            "name_th": "ไชยสถาน",
            "name_en": "Chai Sathan",
            "district_id": 5501,
            "lat": 18.783,
            "long": 100.731,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 550105,
            "zip_code": 55000,
            "name_th": "ถืมตอง",
            "name_en": "Thuem Tong",
            "district_id": 5501,
            "lat": 18.797,
            "long": 100.712,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 550106,
            "zip_code": 55000,
            "name_th": "เรือง",
            "name_en": "Rueang",
            "district_id": 5501,
            "lat": 18.783,
            "long": 100.615,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 550107,
            "zip_code": 55000,
            "name_th": "นาซาว",
            "name_en": "Na Sao",
            "district_id": 5501,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 550108,
            "zip_code": 55000,
            "name_th": "ดู่ใต้",
            "name_en": "Du Tai",
            "district_id": 5501,
            "lat": 18.724,
            "long": 100.739,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 550109,
            "zip_code": 55000,
            "name_th": "กองควาย",
            "name_en": "Kong Khwai",
            "district_id": 5501,
            "lat": 18.686,
            "long": 100.732,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 550116,
            "zip_code": 55000,
            "name_th": "สวก",
            "name_en": "Suak",
            "district_id": 5501,
            "lat": 18.742,
            "long": 100.624,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 550117,
            "zip_code": 55000,
            "name_th": "สะเนียน",
            "name_en": "Sanian",
            "district_id": 5501,
            "lat": 18.912,
            "long": 100.592,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 5502,
        "name_th": "แม่จริม",
        "name_en": "Mae Charim",
        "province_id": 43,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 550202,
            "zip_code": 55170,
            "name_th": "หนองแดง",
            "name_en": "Nong Daeng",
            "district_id": 5502,
            "lat": 18.736,
            "long": 101.025,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 550203,
            "zip_code": 55170,
            "name_th": "หมอเมือง",
            "name_en": "Mo Mueang",
            "district_id": 5502,
            "lat": 18.687,
            "long": 100.975,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 550204,
            "zip_code": 55170,
            "name_th": "น้ำพาง",
            "name_en": "Nam Phang",
            "district_id": 5502,
            "lat": 18.611,
            "long": 101.057,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 550205,
            "zip_code": 55170,
            "name_th": "น้ำปาย",
            "name_en": "Nam Pai",
            "district_id": 5502,
            "lat": 18.641,
            "long": 100.961,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 550206,
            "zip_code": 55170,
            "name_th": "แม่จริม",
            "name_en": "Mae Charim",
            "district_id": 5502,
            "lat": 18.824,
            "long": 101.045,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 5503,
        "name_th": "บ้านหลวง",
        "name_en": "Ban Luang",
        "province_id": 43,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 550301,
            "zip_code": 55190,
            "name_th": "บ้านฟ้า",
            "name_en": "Ban Fa",
            "district_id": 5503,
            "lat": 18.782,
            "long": 100.429,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 550302,
            "zip_code": 55190,
            "name_th": "ป่าคาหลวง",
            "name_en": "Pa Kha Luang",
            "district_id": 5503,
            "lat": 18.858,
            "long": 100.405,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 550303,
            "zip_code": 55190,
            "name_th": "สวด",
            "name_en": "Suat",
            "district_id": 5503,
            "lat": 18.849,
            "long": 100.484,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 550304,
            "zip_code": 55190,
            "name_th": "บ้านพี้",
            "name_en": "Ban Phi",
            "district_id": 5503,
            "lat": 18.907,
            "long": 100.425,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 5504,
        "name_th": "นาน้อย",
        "name_en": "Na Noi",
        "province_id": 43,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 550401,
            "zip_code": 55150,
            "name_th": "นาน้อย",
            "name_en": "Na Noi",
            "district_id": 5504,
            "lat": 18.313,
            "long": 100.681,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 550402,
            "zip_code": 55150,
            "name_th": "เชียงของ",
            "name_en": "Chiang Khong",
            "district_id": 5504,
            "lat": 18.273,
            "long": 100.884,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 550403,
            "zip_code": 55150,
            "name_th": "ศรีษะเกษ",
            "name_en": "Sisaket",
            "district_id": 5504,
            "lat": 18.369,
            "long": 100.771,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 550404,
            "zip_code": 55150,
            "name_th": "สถาน",
            "name_en": "Sathan",
            "district_id": 5504,
            "lat": 18.236,
            "long": 100.745,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 550405,
            "zip_code": 55150,
            "name_th": "สันทะ",
            "name_en": "Santha",
            "district_id": 5504,
            "lat": 18.276,
            "long": 100.567,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 550406,
            "zip_code": 55150,
            "name_th": "บัวใหญ่",
            "name_en": "Bua Yai",
            "district_id": 5504,
            "lat": 18.35,
            "long": 100.57,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 550407,
            "zip_code": 55150,
            "name_th": "น้ำตก",
            "name_en": "Nam Tok",
            "district_id": 5504,
            "lat": 18.394,
            "long": 100.629,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 5505,
        "name_th": "ปัว",
        "name_en": "Pua",
        "province_id": 43,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 550501,
            "zip_code": 55120,
            "name_th": "ปัว",
            "name_en": "Pua",
            "district_id": 5505,
            "lat": 19.168,
            "long": 100.903,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 550502,
            "zip_code": 55120,
            "name_th": "แงง",
            "name_en": "Ngaeng",
            "district_id": 5505,
            "lat": 19.197,
            "long": 100.849,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 550503,
            "zip_code": 55120,
            "name_th": "สถาน",
            "name_en": "Sathan",
            "district_id": 5505,
            "lat": 19.224,
            "long": 100.951,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 550504,
            "zip_code": 55120,
            "name_th": "ศิลาแลง",
            "name_en": "Sila Laeng",
            "district_id": 5505,
            "lat": 19.148,
            "long": 100.967,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 550505,
            "zip_code": 55120,
            "name_th": "ศิลาเพชร",
            "name_en": "Sila Phet",
            "district_id": 5505,
            "lat": 19.097,
            "long": 100.957,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 550506,
            "zip_code": 55120,
            "name_th": "อวน",
            "name_en": "Uan",
            "district_id": 5505,
            "lat": 19.029,
            "long": 100.998,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 550509,
            "zip_code": 55120,
            "name_th": "ไชยวัฒนา",
            "name_en": "Chai Watthana",
            "district_id": 5505,
            "lat": 19.222,
            "long": 100.895,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 550510,
            "zip_code": 55120,
            "name_th": "เจดีย์ชัย",
            "name_en": "Chedi Chai",
            "district_id": 5505,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 550511,
            "zip_code": 55120,
            "name_th": "ภูคา",
            "name_en": "Phu Kha",
            "district_id": 5505,
            "lat": 19.254,
            "long": 101.091,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 550512,
            "zip_code": 55120,
            "name_th": "สกาด",
            "name_en": "Sakat",
            "district_id": 5505,
            "lat": 19.27,
            "long": 101.031,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 550513,
            "zip_code": 55120,
            "name_th": "ป่ากลาง",
            "name_en": "Pa Klang",
            "district_id": 5505,
            "lat": 19.13,
            "long": 100.9,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 550514,
            "zip_code": 55120,
            "name_th": "วรนคร",
            "name_en": "Woranakhon",
            "district_id": 5505,
            "lat": 19.176,
            "long": 100.947,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 5506,
        "name_th": "ท่าวังผา",
        "name_en": "Tha Wang Pha",
        "province_id": 43,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 550601,
            "zip_code": 55140,
            "name_th": "ริม",
            "name_en": "Rim",
            "district_id": 5506,
            "lat": 19.119,
            "long": 100.798,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 550602,
            "zip_code": 55140,
            "name_th": "ป่าคา",
            "name_en": "Pa Kha",
            "district_id": 5506,
            "lat": 19.107,
            "long": 100.665,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 550603,
            "zip_code": 55140,
            "name_th": "ผาตอ",
            "name_en": "Pha To",
            "district_id": 5506,
            "lat": 19.214,
            "long": 100.774,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 550604,
            "zip_code": 55140,
            "name_th": "ยม",
            "name_en": "Yom",
            "district_id": 5506,
            "lat": 19.061,
            "long": 100.926,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 550605,
            "zip_code": 55140,
            "name_th": "ตาลชุม",
            "name_en": "Tan Chum",
            "district_id": 5506,
            "lat": 19.022,
            "long": 100.829,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 550606,
            "zip_code": 55140,
            "name_th": "ศรีภูมิ",
            "name_en": "Si Phum",
            "district_id": 5506,
            "lat": 19.069,
            "long": 100.726,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 550607,
            "zip_code": 55140,
            "name_th": "จอมพระ",
            "name_en": "Chom Phra",
            "district_id": 5506,
            "lat": 19.103,
            "long": 100.865,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 550608,
            "zip_code": 55140,
            "name_th": "แสนทอง",
            "name_en": "Saen Thong",
            "district_id": 5506,
            "lat": 19.14,
            "long": 100.751,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 550609,
            "zip_code": 55140,
            "name_th": "ท่าวังผา",
            "name_en": "Tha Wang Pha",
            "district_id": 5506,
            "lat": 19.128,
            "long": 100.831,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 550610,
            "zip_code": 55140,
            "name_th": "ผาทอง",
            "name_en": "Pha Thong",
            "district_id": 5506,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 5507,
        "name_th": "เวียงสา",
        "name_en": "Wiang Sa",
        "province_id": 43,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 550701,
            "zip_code": 55110,
            "name_th": "กลางเวียง",
            "name_en": "Klang Wiang",
            "district_id": 5507,
            "lat": 18.577,
            "long": 100.74,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 550702,
            "zip_code": 55110,
            "name_th": "ขึ่ง",
            "name_en": "Khueng",
            "district_id": 5507,
            "lat": 18.53,
            "long": 100.834,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 550703,
            "zip_code": 55110,
            "name_th": "ไหล่น่าน",
            "name_en": "Lai Nan",
            "district_id": 5507,
            "lat": 18.59,
            "long": 100.93,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 550704,
            "zip_code": 55110,
            "name_th": "ตาลชุม",
            "name_en": "Tan Chum",
            "district_id": 5507,
            "lat": 18.637,
            "long": 100.783,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 550705,
            "zip_code": 55110,
            "name_th": "นาเหลือง",
            "name_en": "Na Lueang",
            "district_id": 5507,
            "lat": 18.679,
            "long": 100.837,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 550706,
            "zip_code": 55110,
            "name_th": "ส้าน",
            "name_en": "San",
            "district_id": 5507,
            "lat": 18.464,
            "long": 100.729,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 550707,
            "zip_code": 55110,
            "name_th": "น้ำมวบ",
            "name_en": "Nam Muap",
            "district_id": 5507,
            "lat": 18.444,
            "long": 100.94,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 550708,
            "zip_code": 55110,
            "name_th": "น้ำปั้ว",
            "name_en": "Nam Pua",
            "district_id": 5507,
            "lat": 18.639,
            "long": 100.725,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 550709,
            "zip_code": 55110,
            "name_th": "ยาบหัวนา",
            "name_en": "Yap Hua Na",
            "district_id": 5507,
            "lat": 18.611,
            "long": 100.471,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 550710,
            "zip_code": 55110,
            "name_th": "ปงสนุก",
            "name_en": "Pong Sanuk",
            "district_id": 5507,
            "lat": 18.6,
            "long": 100.648,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 550711,
            "zip_code": 55110,
            "name_th": "อ่ายนาไลย",
            "name_en": "Ai Na Lai",
            "district_id": 5507,
            "lat": 18.514,
            "long": 100.541,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 550712,
            "zip_code": 55110,
            "name_th": "ส้านนาหนองใหม่",
            "name_en": "San Na Nong Mai",
            "district_id": 5507,
            "lat": 18.531,
            "long": 100.996,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 550713,
            "zip_code": 55110,
            "name_th": "แม่ขะนิง",
            "name_en": "Mae Khaning",
            "district_id": 5507,
            "lat": 18.718,
            "long": 100.552,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 550714,
            "zip_code": 55110,
            "name_th": "แม่สาคร",
            "name_en": "Mae Sakhon",
            "district_id": 5507,
            "lat": 18.474,
            "long": 100.637,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 550715,
            "zip_code": 55110,
            "name_th": "จอมจันทร์",
            "name_en": "Chom Chan",
            "district_id": 5507,
            "lat": 18.637,
            "long": 100.896,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 550716,
            "zip_code": 55110,
            "name_th": "แม่สา",
            "name_en": "Mae Sa",
            "district_id": 5507,
            "lat": 18.564,
            "long": 100.66,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 550717,
            "zip_code": 55110,
            "name_th": "ทุ่งศรีทอง",
            "name_en": "Thung Si Thong",
            "district_id": 5507,
            "lat": 18.661,
            "long": 100.694,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 5508,
        "name_th": "ทุ่งช้าง",
        "name_en": "Thung Chang",
        "province_id": 43,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 550801,
            "zip_code": 55130,
            "name_th": "ปอน",
            "name_en": "Pon",
            "district_id": 5508,
            "lat": 19.535,
            "long": 100.975,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 550802,
            "zip_code": 55130,
            "name_th": "งอบ",
            "name_en": "Ngop",
            "district_id": 5508,
            "lat": 19.514,
            "long": 100.849,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 550803,
            "zip_code": 55130,
            "name_th": "และ",
            "name_en": "Lae",
            "district_id": 5508,
            "lat": 19.447,
            "long": 100.811,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 550804,
            "zip_code": 55130,
            "name_th": "ทุ่งช้าง",
            "name_en": "Thung Chang",
            "district_id": 5508,
            "lat": 19.39,
            "long": 100.834,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 5509,
        "name_th": "เชียงกลาง",
        "name_en": "Chiang Klang",
        "province_id": 43,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 550901,
            "zip_code": 55160,
            "name_th": "เชียงกลาง",
            "name_en": "Chiang Klang",
            "district_id": 5509,
            "lat": 19.32,
            "long": 100.97,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 550902,
            "zip_code": 55160,
            "name_th": "เปือ",
            "name_en": "Puea",
            "district_id": 5509,
            "lat": 19.324,
            "long": 100.843,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 550903,
            "zip_code": 55160,
            "name_th": "เชียงคาน",
            "name_en": "Chiang Khan",
            "district_id": 5509,
            "lat": 19.246,
            "long": 100.855,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 550904,
            "zip_code": 55160,
            "name_th": "พระธาตุ",
            "name_en": "Phra That",
            "district_id": 5509,
            "lat": 19.338,
            "long": 100.925,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 550908,
            "zip_code": 55160,
            "name_th": "พญาแก้ว",
            "name_en": "Phaya Kaeo",
            "district_id": 5509,
            "lat": 19.27,
            "long": 100.909,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 550909,
            "zip_code": 55160,
            "name_th": "พระพุทธบาท",
            "name_en": "Phra Phutthabat",
            "district_id": 5509,
            "lat": 19.258,
            "long": 100.814,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 5510,
        "name_th": "นาหมื่น",
        "name_en": "Na Muen",
        "province_id": 43,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 551001,
            "zip_code": 55180,
            "name_th": "นาทะนุง",
            "name_en": "Na Thanung",
            "district_id": 5510,
            "lat": 18.117,
            "long": 100.615,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 551002,
            "zip_code": 55180,
            "name_th": "บ่อแก้ว",
            "name_en": "Bo Kaeo",
            "district_id": 5510,
            "lat": 18.139,
            "long": 100.832,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 551003,
            "zip_code": 55180,
            "name_th": "เมืองลี",
            "name_en": "Mueang Li",
            "district_id": 5510,
            "lat": 18.226,
            "long": 100.505,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 551004,
            "zip_code": 55180,
            "name_th": "ปิงหลวง",
            "name_en": "Ping Luang",
            "district_id": 5510,
            "lat": 18.115,
            "long": 100.486,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 5511,
        "name_th": "สันติสุข",
        "name_en": "Santi Suk",
        "province_id": 43,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 551101,
            "zip_code": 55210,
            "name_th": "ดู่พงษ์",
            "name_en": "Du Phong",
            "district_id": 5511,
            "lat": 18.898,
            "long": 100.902,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 551102,
            "zip_code": 55210,
            "name_th": "ป่าแลวหลวง",
            "name_en": "Pa Laeo Luang",
            "district_id": 5511,
            "lat": 18.957,
            "long": 100.95,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 551103,
            "zip_code": 55210,
            "name_th": "พงษ์",
            "name_en": "Phong",
            "district_id": 5511,
            "lat": 18.899,
            "long": 100.983,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 5512,
        "name_th": "บ่อเกลือ",
        "name_en": "Bo Kluea",
        "province_id": 43,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 551201,
            "zip_code": 55220,
            "name_th": "บ่อเกลือเหนือ",
            "name_en": "Bo Kluea Nuea",
            "district_id": 5512,
            "lat": 19.297,
            "long": 101.176,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 551202,
            "zip_code": 55220,
            "name_th": "บ่อเกลือใต้",
            "name_en": "Bo Kluea Tai",
            "district_id": 5512,
            "lat": 19.127,
            "long": 101.13,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 551204,
            "zip_code": 55220,
            "name_th": "ภูฟ้า",
            "name_en": "Phu Fa",
            "district_id": 5512,
            "lat": 18.973,
            "long": 101.201,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 551205,
            "zip_code": 55220,
            "name_th": "ดงพญา",
            "name_en": "Dong Phaya",
            "district_id": 5512,
            "lat": 19.22,
            "long": 101.198,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 5513,
        "name_th": "สองแคว",
        "name_en": "Song Khwae",
        "province_id": 43,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 551301,
            "zip_code": 55160,
            "name_th": "นาไร่หลวง",
            "name_en": "Na Rai Luang",
            "district_id": 5513,
            "lat": 19.339,
            "long": 100.704,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 551302,
            "zip_code": 55160,
            "name_th": "ชนแดน",
            "name_en": "Chon Daen",
            "district_id": 5513,
            "lat": 19.462,
            "long": 100.691,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 551303,
            "zip_code": 55160,
            "name_th": "ยอด",
            "name_en": "Yot",
            "district_id": 5513,
            "lat": 19.384,
            "long": 100.567,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 5514,
        "name_th": "ภูเพียง",
        "name_en": "Phu Phiang",
        "province_id": 43,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 551401,
            "zip_code": 55000,
            "name_th": "ม่วงตึ๊ด",
            "name_en": "Muang Tuet",
            "district_id": 5514,
            "lat": 18.756,
            "long": 100.816,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 551402,
            "zip_code": 55000,
            "name_th": "นาปัง",
            "name_en": "Na Pang",
            "district_id": 5514,
            "lat": 18.696,
            "long": 100.801,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 551403,
            "zip_code": 55000,
            "name_th": "น้ำแก่น",
            "name_en": "Nam Kaen",
            "district_id": 5514,
            "lat": 18.698,
            "long": 100.88,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 551404,
            "zip_code": 55000,
            "name_th": "น้ำเกี๋ยน",
            "name_en": "Nam Kian",
            "district_id": 5514,
            "lat": 18.737,
            "long": 100.841,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 551405,
            "zip_code": 55000,
            "name_th": "เมืองจัง",
            "name_en": "Mueang Chang",
            "district_id": 5514,
            "lat": 18.878,
            "long": 100.83,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 551406,
            "zip_code": 55000,
            "name_th": "ท่าน้าว",
            "name_en": "Tha Nao",
            "district_id": 5514,
            "lat": 18.731,
            "long": 100.791,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 551407,
            "zip_code": 55000,
            "name_th": "ฝายแก้ว",
            "name_en": "Fai Kaeo",
            "district_id": 5514,
            "lat": 18.803,
            "long": 100.933,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 5515,
        "name_th": "เฉลิมพระเกียรติ",
        "name_en": "Chaloem Phra Kiat",
        "province_id": 43,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 551501,
            "zip_code": 55130,
            "name_th": "ห้วยโก๋น",
            "name_en": "Huai Kon",
            "district_id": 5515,
            "lat": 19.559,
            "long": 101.046,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 551502,
            "zip_code": 55130,
            "name_th": "ขุนน่าน",
            "name_en": "Khun Nan",
            "district_id": 5515,
            "lat": 19.45,
            "long": 101.128,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      }
    ]
  },
  {
    "id": 44,
    "name_th": "พะเยา",
    "name_en": "Phayao",
    "geography_id": 1,
    "created_at": "2019-08-09T03:33:09.000+07:00",
    "updated_at": "2025-09-20T06:31:26.000+07:00",
    "deleted_at": null,
    "districts": [
      {
        "id": 5601,
        "name_th": "เมืองพะเยา",
        "name_en": "Mueang Phayao",
        "province_id": 44,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 560101,
            "zip_code": 56000,
            "name_th": "เวียง",
            "name_en": "Wiang",
            "district_id": 5601,
            "lat": 19.172,
            "long": 99.894,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 560102,
            "zip_code": 56000,
            "name_th": "แม่ต๋ำ",
            "name_en": "Mae Tam",
            "district_id": 5601,
            "lat": 19.142,
            "long": 99.912,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 560104,
            "zip_code": 56000,
            "name_th": "แม่นาเรือ",
            "name_en": "Mae Na Ruea",
            "district_id": 5601,
            "lat": 19.088,
            "long": 99.797,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 560105,
            "zip_code": 56000,
            "name_th": "บ้านตุ่น",
            "name_en": "Ban Tun",
            "district_id": 5601,
            "lat": 19.141,
            "long": 99.823,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 560106,
            "zip_code": 56000,
            "name_th": "บ้านต๊ำ",
            "name_en": "Ban Tam",
            "district_id": 5601,
            "lat": 19.216,
            "long": 99.756,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 560107,
            "zip_code": 56000,
            "name_th": "บ้านต๋อม",
            "name_en": "Ban Tom",
            "district_id": 5601,
            "lat": 19.198,
            "long": 99.8,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 560108,
            "zip_code": 56000,
            "name_th": "แม่ปืม",
            "name_en": "Mae Puem",
            "district_id": 5601,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 560110,
            "zip_code": 56000,
            "name_th": "แม่กา",
            "name_en": "Mae Ka",
            "district_id": 5601,
            "lat": 19.049,
            "long": 99.917,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 560111,
            "zip_code": 56000,
            "name_th": "บ้านใหม่",
            "name_en": "Ban Mai",
            "district_id": 5601,
            "lat": 19.295,
            "long": 99.733,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 560112,
            "zip_code": 56000,
            "name_th": "จำป่าหวาย",
            "name_en": "Cham Pa Wai",
            "district_id": 5601,
            "lat": 19.105,
            "long": 99.945,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 560113,
            "zip_code": 56000,
            "name_th": "ท่าวังทอง",
            "name_en": "Tha Wang Thong",
            "district_id": 5601,
            "lat": 19.202,
            "long": 99.927,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 560114,
            "zip_code": 56000,
            "name_th": "แม่ใส",
            "name_en": "Mae Sai",
            "district_id": 5601,
            "lat": 19.127,
            "long": 99.886,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 560115,
            "zip_code": 56000,
            "name_th": "บ้านสาง",
            "name_en": "Ban Sang",
            "district_id": 5601,
            "lat": 19.156,
            "long": 99.811,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 560116,
            "zip_code": 56000,
            "name_th": "ท่าจำปี",
            "name_en": "Tha Champi",
            "district_id": 5601,
            "lat": 19.245,
            "long": 99.815,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 560118,
            "zip_code": 56000,
            "name_th": "สันป่าม่วง",
            "name_en": "San Pa Muang",
            "district_id": 5601,
            "lat": 19.166,
            "long": 99.759,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 5602,
        "name_th": "จุน",
        "name_en": "Chun",
        "province_id": 44,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 560201,
            "zip_code": 56150,
            "name_th": "ห้วยข้าวก่ำ",
            "name_en": "Huai Khao Kam",
            "district_id": 5602,
            "lat": 19.352,
            "long": 100.12,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 560202,
            "zip_code": 56150,
            "name_th": "จุน",
            "name_en": "Chun",
            "district_id": 5602,
            "lat": 19.282,
            "long": 100.152,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 560203,
            "zip_code": 56150,
            "name_th": "ลอ",
            "name_en": "Lo",
            "district_id": 5602,
            "lat": 19.414,
            "long": 100.073,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 560204,
            "zip_code": 56150,
            "name_th": "หงส์หิน",
            "name_en": "Hong Hin",
            "district_id": 5602,
            "lat": 19.507,
            "long": 100.103,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 560205,
            "zip_code": 56150,
            "name_th": "ทุ่งรวงทอง",
            "name_en": "Thung Ruang Thong",
            "district_id": 5602,
            "lat": 19.436,
            "long": 100.166,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 560206,
            "zip_code": 56150,
            "name_th": "ห้วยยางขาม",
            "name_en": "Huai Yang Kham",
            "district_id": 5602,
            "lat": 19.378,
            "long": 100.163,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 560207,
            "zip_code": 56150,
            "name_th": "พระธาตุขิงแกง",
            "name_en": "Phra That Khing Kaeng",
            "district_id": 5602,
            "lat": 19.273,
            "long": 100.186,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 5603,
        "name_th": "เชียงคำ",
        "name_en": "Chiang Kham",
        "province_id": 44,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 560301,
            "zip_code": 56110,
            "name_th": "หย่วน",
            "name_en": "Yuan",
            "district_id": 5603,
            "lat": 19.536,
            "long": 100.293,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 560306,
            "zip_code": 56110,
            "name_th": "น้ำแวน",
            "name_en": "Nam Waen",
            "district_id": 5603,
            "lat": 19.477,
            "long": 100.244,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 560307,
            "zip_code": 56110,
            "name_th": "เวียง",
            "name_en": "Wiang",
            "district_id": 5603,
            "lat": 19.495,
            "long": 100.327,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 560308,
            "zip_code": 56110,
            "name_th": "ฝายกวาง",
            "name_en": "Fai Kwang",
            "district_id": 5603,
            "lat": 19.394,
            "long": 100.244,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 560309,
            "zip_code": 56110,
            "name_th": "เจดีย์คำ",
            "name_en": "Chedi Kham",
            "district_id": 5603,
            "lat": 19.537,
            "long": 100.337,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 560310,
            "zip_code": 56110,
            "name_th": "ร่มเย็น",
            "name_en": "Rom Yen",
            "district_id": 5603,
            "lat": 19.511,
            "long": 100.504,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 560311,
            "zip_code": 56110,
            "name_th": "เชียงบาน",
            "name_en": "Chiang Ban",
            "district_id": 5603,
            "lat": 19.586,
            "long": 100.234,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 560312,
            "zip_code": 56110,
            "name_th": "แม่ลาว",
            "name_en": "Mae Lao",
            "district_id": 5603,
            "lat": 19.432,
            "long": 100.451,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 560313,
            "zip_code": 56110,
            "name_th": "อ่างทอง",
            "name_en": "Ang Thong",
            "district_id": 5603,
            "lat": 19.552,
            "long": 100.201,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 560314,
            "zip_code": 56110,
            "name_th": "ทุ่งผาสุข",
            "name_en": "Thung Pha Suk",
            "district_id": 5603,
            "lat": 19.473,
            "long": 100.291,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 5604,
        "name_th": "เชียงม่วน",
        "name_en": "Chiang Muan",
        "province_id": 44,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 560401,
            "zip_code": 56160,
            "name_th": "เชียงม่วน",
            "name_en": "Chiang Muan",
            "district_id": 5604,
            "lat": 18.888,
            "long": 100.334,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 560402,
            "zip_code": 56160,
            "name_th": "บ้านมาง",
            "name_en": "Ban Mang",
            "district_id": 5604,
            "lat": 18.869,
            "long": 100.22,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 560403,
            "zip_code": 56160,
            "name_th": "สระ",
            "name_en": "Sa",
            "district_id": 5604,
            "lat": 18.992,
            "long": 100.404,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 5605,
        "name_th": "ดอกคำใต้",
        "name_en": "Dok Khamtai",
        "province_id": 44,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 560501,
            "zip_code": 56120,
            "name_th": "ดอกคำใต้",
            "name_en": "Dok Khamtai",
            "district_id": 5605,
            "lat": 19.152,
            "long": 99.955,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 560502,
            "zip_code": 56120,
            "name_th": "ดอนศรีชุม",
            "name_en": "Don Si Chum",
            "district_id": 5605,
            "lat": 19.157,
            "long": 100.026,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 560503,
            "zip_code": 56120,
            "name_th": "บ้านถ้ำ",
            "name_en": "Ban Tham",
            "district_id": 5605,
            "lat": 19.105,
            "long": 100.074,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 560504,
            "zip_code": 56120,
            "name_th": "บ้านปิน",
            "name_en": "Ban Pin",
            "district_id": 5605,
            "lat": 18.988,
            "long": 100.034,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 560505,
            "zip_code": 56120,
            "name_th": "ห้วยลาน",
            "name_en": "Huai Lan",
            "district_id": 5605,
            "lat": 19.37,
            "long": 100.04,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 560506,
            "zip_code": 56120,
            "name_th": "สันโค้ง",
            "name_en": "San Khong",
            "district_id": 5605,
            "lat": 19.195,
            "long": 100.034,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 560507,
            "zip_code": 56120,
            "name_th": "ป่าซาง",
            "name_en": "Pa Sang",
            "district_id": 5605,
            "lat": 19.284,
            "long": 100.084,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 560508,
            "zip_code": 56120,
            "name_th": "หนองหล่ม",
            "name_en": "Nong Lom",
            "district_id": 5605,
            "lat": 18.925,
            "long": 100.096,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 560509,
            "zip_code": 56120,
            "name_th": "ดงสุวรรณ",
            "name_en": "Dong Suwan",
            "district_id": 5605,
            "lat": 19.242,
            "long": 100.053,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 560510,
            "zip_code": 56120,
            "name_th": "บุญเกิด",
            "name_en": "Bun Koet",
            "district_id": 5605,
            "lat": 19.134,
            "long": 99.998,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 560511,
            "zip_code": 56120,
            "name_th": "สว่างอารมณ์",
            "name_en": "Sawang Arom",
            "district_id": 5605,
            "lat": 19.194,
            "long": 99.982,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 560512,
            "zip_code": 56120,
            "name_th": "คือเวียง",
            "name_en": "Khue Wiang",
            "district_id": 5605,
            "lat": 19.085,
            "long": 100.014,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 5606,
        "name_th": "ปง",
        "name_en": "Pong",
        "province_id": 44,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 560601,
            "zip_code": 56140,
            "name_th": "ปง",
            "name_en": "Pong",
            "district_id": 5606,
            "lat": 19.102,
            "long": 100.205,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 560602,
            "zip_code": 56140,
            "name_th": "ควร",
            "name_en": "Khuan",
            "district_id": 5606,
            "lat": 19.182,
            "long": 100.374,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 560603,
            "zip_code": 56140,
            "name_th": "ออย",
            "name_en": "Oi",
            "district_id": 5606,
            "lat": 19.211,
            "long": 100.329,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 560604,
            "zip_code": 56140,
            "name_th": "งิม",
            "name_en": "Ngim",
            "district_id": 5606,
            "lat": 19.284,
            "long": 100.403,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 560605,
            "zip_code": 56140,
            "name_th": "ผาช้างน้อย",
            "name_en": "Pha Chang Noi",
            "district_id": 5606,
            "lat": 19.282,
            "long": 100.502,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 560606,
            "zip_code": 56140,
            "name_th": "นาปรัง",
            "name_en": "Na Prang",
            "district_id": 5606,
            "lat": 19.219,
            "long": 100.242,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 560607,
            "zip_code": 56140,
            "name_th": "ขุนควร",
            "name_en": "Khun Khuan",
            "district_id": 5606,
            "lat": 19.111,
            "long": 100.457,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 5607,
        "name_th": "แม่ใจ",
        "name_en": "Mae Chai",
        "province_id": 44,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 560701,
            "zip_code": 56130,
            "name_th": "แม่ใจ",
            "name_en": "Mae Chai",
            "district_id": 5607,
            "lat": 19.33,
            "long": 99.846,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 560702,
            "zip_code": 56130,
            "name_th": "ศรีถ้อย",
            "name_en": "Si Thoi",
            "district_id": 5607,
            "lat": 19.357,
            "long": 99.725,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 560703,
            "zip_code": 56130,
            "name_th": "แม่สุก",
            "name_en": "Mae Suk",
            "district_id": 5607,
            "lat": 19.313,
            "long": 99.796,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 560704,
            "zip_code": 56130,
            "name_th": "ป่าแฝก",
            "name_en": "Pa Faek",
            "district_id": 5607,
            "lat": 19.426,
            "long": 99.763,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 560705,
            "zip_code": 56130,
            "name_th": "บ้านเหล่า",
            "name_en": "Ban Lao",
            "district_id": 5607,
            "lat": 19.399,
            "long": 99.859,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 560706,
            "zip_code": 56130,
            "name_th": "เจริญราษฎร์",
            "name_en": "Charoen Rat",
            "district_id": 5607,
            "lat": 19.396,
            "long": 99.756,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 5608,
        "name_th": "ภูซาง",
        "name_en": "Phu Sang",
        "province_id": 44,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 560801,
            "zip_code": 56110,
            "name_th": "ภูซาง",
            "name_en": "Phu Sang",
            "district_id": 5608,
            "lat": 19.671,
            "long": 100.378,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 560802,
            "zip_code": 56110,
            "name_th": "ป่าสัก",
            "name_en": "Pa Sak",
            "district_id": 5608,
            "lat": 19.622,
            "long": 100.37,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 560803,
            "zip_code": 56110,
            "name_th": "ทุ่งกล้วย",
            "name_en": "Thung Kluai",
            "district_id": 5608,
            "lat": 19.606,
            "long": 100.417,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 560804,
            "zip_code": 56110,
            "name_th": "เชียงแรง",
            "name_en": "Chiang Raeng",
            "district_id": 5608,
            "lat": 19.616,
            "long": 100.289,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 560805,
            "zip_code": 56110,
            "name_th": "สบบง",
            "name_en": "Sop Bong",
            "district_id": 5608,
            "lat": 19.57,
            "long": 100.317,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 5609,
        "name_th": "ภูกามยาว",
        "name_en": "Phu Kamyao",
        "province_id": 44,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 560901,
            "zip_code": 56000,
            "name_th": "ห้วยแก้ว",
            "name_en": "Huai Kaeo",
            "district_id": 5609,
            "lat": 19.311,
            "long": 99.999,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 560902,
            "zip_code": 56000,
            "name_th": "ดงเจน",
            "name_en": "Dong Chen",
            "district_id": 5609,
            "lat": 19.24,
            "long": 99.952,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 560903,
            "zip_code": 56000,
            "name_th": "แม่อิง",
            "name_en": "Mae Ing",
            "district_id": 5609,
            "lat": 19.241,
            "long": 99.989,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      }
    ]
  },
  {
    "id": 45,
    "name_th": "เชียงราย",
    "name_en": "Chiang Rai",
    "geography_id": 1,
    "created_at": "2019-08-09T03:33:09.000+07:00",
    "updated_at": "2025-09-20T06:31:26.000+07:00",
    "deleted_at": null,
    "districts": [
      {
        "id": 5701,
        "name_th": "เมืองเชียงราย",
        "name_en": "Mueang Chiang Rai",
        "province_id": 45,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 570101,
            "zip_code": 57000,
            "name_th": "เวียง",
            "name_en": "Wiang",
            "district_id": 5701,
            "lat": 19.907,
            "long": 99.832,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 570102,
            "zip_code": 57000,
            "name_th": "รอบเวียง",
            "name_en": "Rop Wiang",
            "district_id": 5701,
            "lat": 19.898,
            "long": 99.803,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 570103,
            "zip_code": 57100,
            "name_th": "บ้านดู่",
            "name_en": "Ban Du",
            "district_id": 5701,
            "lat": 19.971,
            "long": 99.847,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 570104,
            "zip_code": 57100,
            "name_th": "นางแล",
            "name_en": "Nang Lae",
            "district_id": 5701,
            "lat": 20.048,
            "long": 99.876,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 570105,
            "zip_code": 57100,
            "name_th": "แม่ข้าวต้ม",
            "name_en": "Mae Khao Tom",
            "district_id": 5701,
            "lat": 20.021,
            "long": 99.922,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 570106,
            "zip_code": 57100,
            "name_th": "แม่ยาว",
            "name_en": "Mae Yao",
            "district_id": 5701,
            "lat": 19.991,
            "long": 99.729,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 570107,
            "zip_code": 57000,
            "name_th": "สันทราย",
            "name_en": "San Sai",
            "district_id": 5701,
            "lat": 19.855,
            "long": 99.805,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 570111,
            "zip_code": 57000,
            "name_th": "แม่กรณ์",
            "name_en": "Mae Kon",
            "district_id": 5701,
            "lat": 19.862,
            "long": 99.698,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 570112,
            "zip_code": 57000,
            "name_th": "ห้วยชมภู",
            "name_en": "Huai Chomphu",
            "district_id": 5701,
            "lat": 20.015,
            "long": 99.506,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 570113,
            "zip_code": 57000,
            "name_th": "ห้วยสัก",
            "name_en": "Huai Sak",
            "district_id": 5701,
            "lat": 19.756,
            "long": 99.872,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 570114,
            "zip_code": 57100,
            "name_th": "ริมกก",
            "name_en": "Rim Kok",
            "district_id": 5701,
            "lat": 19.937,
            "long": 99.887,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 570115,
            "zip_code": 57000,
            "name_th": "ดอยลาน",
            "name_en": "Doi Lan",
            "district_id": 5701,
            "lat": 19.682,
            "long": 99.945,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 570116,
            "zip_code": 57000,
            "name_th": "ป่าอ้อดอนชัย",
            "name_en": "Pa O Don Chai",
            "district_id": 5701,
            "lat": 19.768,
            "long": 99.819,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 570118,
            "zip_code": 57000,
            "name_th": "ท่าสาย",
            "name_en": "Tha Sai",
            "district_id": 5701,
            "lat": 19.837,
            "long": 99.851,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 570120,
            "zip_code": 57000,
            "name_th": "ดอยฮาง",
            "name_en": "Doi Hang",
            "district_id": 5701,
            "lat": 19.931,
            "long": 99.713,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 570121,
            "zip_code": 57100,
            "name_th": "ท่าสุด",
            "name_en": "Tha Sut",
            "district_id": 5701,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 5702,
        "name_th": "เวียงชัย",
        "name_en": "Wiang Chai",
        "province_id": 45,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 570202,
            "zip_code": 57210,
            "name_th": "เวียงชัย",
            "name_en": "Wiang Chai",
            "district_id": 5702,
            "lat": 19.866,
            "long": 99.912,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 570203,
            "zip_code": 57210,
            "name_th": "ผางาม",
            "name_en": "Pha Ngam",
            "district_id": 5702,
            "lat": 19.882,
            "long": 100.046,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 570204,
            "zip_code": 57210,
            "name_th": "เวียงเหนือ",
            "name_en": "Wiang Nuea",
            "district_id": 5702,
            "lat": 19.932,
            "long": 99.94,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 570206,
            "zip_code": 57210,
            "name_th": "ดอนศิลา",
            "name_en": "Don Sila",
            "district_id": 5702,
            "lat": 19.805,
            "long": 100.005,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 570208,
            "zip_code": 57210,
            "name_th": "เมืองชุม",
            "name_en": "Mueang Chum",
            "district_id": 5702,
            "lat": 19.904,
            "long": 99.974,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 5703,
        "name_th": "เชียงของ",
        "name_en": "Chiang Khong",
        "province_id": 45,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 570301,
            "zip_code": 57140,
            "name_th": "เวียง",
            "name_en": "Wiang",
            "district_id": 5703,
            "lat": 20.266,
            "long": 100.369,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 570302,
            "zip_code": 57140,
            "name_th": "สถาน",
            "name_en": "Sathan",
            "district_id": 5703,
            "lat": 20.202,
            "long": 100.364,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 570303,
            "zip_code": 57140,
            "name_th": "ครึ่ง",
            "name_en": "Khrueng",
            "district_id": 5703,
            "lat": 20.058,
            "long": 100.402,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 570304,
            "zip_code": 57140,
            "name_th": "บุญเรือง",
            "name_en": "Bun Rueang",
            "district_id": 5703,
            "lat": 19.989,
            "long": 100.347,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 570305,
            "zip_code": 57140,
            "name_th": "ห้วยซ้อ",
            "name_en": "Huai So",
            "district_id": 5703,
            "lat": 20.061,
            "long": 100.284,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 570308,
            "zip_code": 57230,
            "name_th": "ศรีดอนชัย",
            "name_en": "Si Don Chai",
            "district_id": 5703,
            "lat": 20.15,
            "long": 100.324,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 570310,
            "zip_code": 57140,
            "name_th": "ริมโขง",
            "name_en": "Rim Khong",
            "district_id": 5703,
            "lat": 20.361,
            "long": 100.313,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 5704,
        "name_th": "เทิง",
        "name_en": "Thoeng",
        "province_id": 45,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 570401,
            "zip_code": 57160,
            "name_th": "เวียง",
            "name_en": "Wiang",
            "district_id": 5704,
            "lat": 19.692,
            "long": 100.213,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 570402,
            "zip_code": 57160,
            "name_th": "งิ้ว",
            "name_en": "Ngio",
            "district_id": 5704,
            "lat": 19.697,
            "long": 100.096,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 570403,
            "zip_code": 57230,
            "name_th": "ปล้อง",
            "name_en": "Plong",
            "district_id": 5704,
            "lat": 19.658,
            "long": 100.062,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 570404,
            "zip_code": 57230,
            "name_th": "แม่ลอย",
            "name_en": "Mae Loi",
            "district_id": 5704,
            "lat": 19.573,
            "long": 100.063,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 570405,
            "zip_code": 57230,
            "name_th": "เชียงเคี่ยน",
            "name_en": "Chiang Khian",
            "district_id": 5704,
            "lat": 19.625,
            "long": 99.99,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 570409,
            "zip_code": 57160,
            "name_th": "ตับเต่า",
            "name_en": "Tap Tao",
            "district_id": 5704,
            "lat": 19.787,
            "long": 100.355,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 570410,
            "zip_code": 57160,
            "name_th": "หงาว",
            "name_en": "Ngao",
            "district_id": 5704,
            "lat": 19.678,
            "long": 100.283,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 570411,
            "zip_code": 57160,
            "name_th": "สันทรายงาม",
            "name_en": "San Sai Ngam",
            "district_id": 5704,
            "lat": 19.717,
            "long": 100.18,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 570412,
            "zip_code": 57160,
            "name_th": "ศรีดอนไชย",
            "name_en": "Si Don Chai",
            "district_id": 5704,
            "lat": 19.609,
            "long": 100.092,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 570413,
            "zip_code": 57160,
            "name_th": "หนองแรด",
            "name_en": "Nong Raet",
            "district_id": 5704,
            "lat": 19.607,
            "long": 100.143,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 5705,
        "name_th": "พาน",
        "name_en": "Phan",
        "province_id": 45,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 570501,
            "zip_code": 57120,
            "name_th": "สันมะเค็ด",
            "name_en": "San Makhet",
            "district_id": 5705,
            "lat": 19.609,
            "long": 99.864,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 570502,
            "zip_code": 57120,
            "name_th": "แม่อ้อ",
            "name_en": "Mae O",
            "district_id": 5705,
            "lat": 19.672,
            "long": 99.821,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 570503,
            "zip_code": 57250,
            "name_th": "ธารทอง",
            "name_en": "Than Thong",
            "district_id": 5705,
            "lat": 19.71,
            "long": 99.723,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 570504,
            "zip_code": 57120,
            "name_th": "สันติสุข",
            "name_en": "Santi Suk",
            "district_id": 5705,
            "lat": 19.575,
            "long": 99.765,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 570505,
            "zip_code": 57120,
            "name_th": "ดอยงาม",
            "name_en": "Doi Ngam",
            "district_id": 5705,
            "lat": 19.548,
            "long": 99.808,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 570506,
            "zip_code": 57120,
            "name_th": "หัวง้ม",
            "name_en": "Hua Ngom",
            "district_id": 5705,
            "lat": 19.538,
            "long": 99.771,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 570507,
            "zip_code": 57120,
            "name_th": "เจริญเมือง",
            "name_en": "Charoen Mueang",
            "district_id": 5705,
            "lat": 19.616,
            "long": 99.746,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 570508,
            "zip_code": 57120,
            "name_th": "ป่าหุ่ง",
            "name_en": "Pa Hung",
            "district_id": 5705,
            "lat": 19.495,
            "long": 99.648,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 570509,
            "zip_code": 57120,
            "name_th": "ม่วงคำ",
            "name_en": "Muang Kham",
            "district_id": 5705,
            "lat": 19.49,
            "long": 99.711,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 570510,
            "zip_code": 57120,
            "name_th": "ทรายขาว",
            "name_en": "Sai Khao",
            "district_id": 5705,
            "lat": 19.663,
            "long": 99.733,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 570511,
            "zip_code": 57120,
            "name_th": "สันกลาง",
            "name_en": "San Klang",
            "district_id": 5705,
            "lat": 19.607,
            "long": 99.684,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 570512,
            "zip_code": 57280,
            "name_th": "แม่เย็น",
            "name_en": "Mae Yen",
            "district_id": 5705,
            "lat": 19.454,
            "long": 99.732,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 570513,
            "zip_code": 57120,
            "name_th": "เมืองพาน",
            "name_en": "Mueang Phan",
            "district_id": 5705,
            "lat": 19.554,
            "long": 99.746,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 570514,
            "zip_code": 57280,
            "name_th": "ทานตะวัน",
            "name_en": "Than Tawan",
            "district_id": 5705,
            "lat": 19.47,
            "long": 99.832,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 570515,
            "zip_code": 57120,
            "name_th": "เวียงห้าว",
            "name_en": "Wiang Hao",
            "district_id": 5705,
            "lat": 19.524,
            "long": 99.88,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 5706,
        "name_th": "ป่าแดด",
        "name_en": "Pa Daet",
        "province_id": 45,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 570601,
            "zip_code": 57190,
            "name_th": "ป่าแดด",
            "name_en": "Pa Daet",
            "district_id": 5706,
            "lat": 19.507,
            "long": 100.015,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 570602,
            "zip_code": 57190,
            "name_th": "ป่าแงะ",
            "name_en": "Pa Ngae",
            "district_id": 5706,
            "lat": 19.579,
            "long": 99.933,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 570603,
            "zip_code": 57190,
            "name_th": "สันมะค่า",
            "name_en": "San Makha",
            "district_id": 5706,
            "lat": 19.466,
            "long": 100.048,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 570605,
            "zip_code": 57190,
            "name_th": "โรงช้าง",
            "name_en": "Rong Chang",
            "district_id": 5706,
            "lat": 19.494,
            "long": 99.947,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 570606,
            "zip_code": 57190,
            "name_th": "ศรีโพธิ์เงิน",
            "name_en": "Si Pho Ngoen",
            "district_id": 5706,
            "lat": 19.435,
            "long": 99.934,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 5707,
        "name_th": "แม่จัน",
        "name_en": "Mae Chan",
        "province_id": 45,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 570701,
            "zip_code": 57110,
            "name_th": "แม่จัน",
            "name_en": "Mae Chan",
            "district_id": 5707,
            "lat": 20.138,
            "long": 99.87,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 570702,
            "zip_code": 57270,
            "name_th": "จันจว้า",
            "name_en": "Chan Chwa",
            "district_id": 5707,
            "lat": 20.239,
            "long": 99.982,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 570703,
            "zip_code": 57240,
            "name_th": "แม่คำ",
            "name_en": "Mae Kham",
            "district_id": 5707,
            "lat": 20.251,
            "long": 99.902,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 570704,
            "zip_code": 57110,
            "name_th": "ป่าซาง",
            "name_en": "Pa Sang",
            "district_id": 5707,
            "lat": 20.181,
            "long": 99.846,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 570705,
            "zip_code": 57110,
            "name_th": "สันทราย",
            "name_en": "San Sai",
            "district_id": 5707,
            "lat": 20.171,
            "long": 99.891,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 570706,
            "zip_code": 57110,
            "name_th": "ท่าข้าวเปลือก",
            "name_en": "Tha Khao Plueak",
            "district_id": 5707,
            "lat": 20.163,
            "long": 100.018,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 570708,
            "zip_code": 57110,
            "name_th": "ป่าตึง",
            "name_en": "Pa Tueng",
            "district_id": 5707,
            "lat": 20.134,
            "long": 99.77,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 570710,
            "zip_code": 57240,
            "name_th": "แม่ไร่",
            "name_en": "Mae Rai",
            "district_id": 5707,
            "lat": 20.256,
            "long": 99.864,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 570711,
            "zip_code": 57110,
            "name_th": "ศรีค้ำ",
            "name_en": "Si Kham",
            "district_id": 5707,
            "lat": 20.221,
            "long": 99.797,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 570712,
            "zip_code": 57270,
            "name_th": "จันจว้าใต้",
            "name_en": "Chan Chwa Tai",
            "district_id": 5707,
            "lat": 20.239,
            "long": 99.936,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 570713,
            "zip_code": 57110,
            "name_th": "จอมสวรรค์",
            "name_en": "Chom Sawan",
            "district_id": 5707,
            "lat": 20.17,
            "long": 99.95,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 5708,
        "name_th": "เชียงแสน",
        "name_en": "Chiang Saen",
        "province_id": 45,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 570801,
            "zip_code": 57150,
            "name_th": "เวียง",
            "name_en": "Wiang",
            "district_id": 5708,
            "lat": 20.305,
            "long": 100.081,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 570802,
            "zip_code": 57150,
            "name_th": "ป่าสัก",
            "name_en": "Pa Sak",
            "district_id": 5708,
            "lat": 20.28,
            "long": 100.003,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 570803,
            "zip_code": 57150,
            "name_th": "บ้านแซว",
            "name_en": "Ban Saeo",
            "district_id": 5708,
            "lat": 20.212,
            "long": 100.265,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 570804,
            "zip_code": 57150,
            "name_th": "ศรีดอนมูล",
            "name_en": "Si Don Mun",
            "district_id": 5708,
            "lat": 20.336,
            "long": 100.002,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 570805,
            "zip_code": 57150,
            "name_th": "แม่เงิน",
            "name_en": "Mae Ngoen",
            "district_id": 5708,
            "lat": 20.298,
            "long": 100.262,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 570806,
            "zip_code": 57150,
            "name_th": "โยนก",
            "name_en": "Yonok",
            "district_id": 5708,
            "lat": 20.238,
            "long": 100.062,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 5709,
        "name_th": "แม่สาย",
        "name_en": "Mae Sai",
        "province_id": 45,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 570901,
            "zip_code": 57130,
            "name_th": "แม่สาย",
            "name_en": "Mae Sai",
            "district_id": 5709,
            "lat": 20.431,
            "long": 99.913,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 570902,
            "zip_code": 57220,
            "name_th": "ห้วยไคร้",
            "name_en": "Huai Khrai",
            "district_id": 5709,
            "lat": 20.286,
            "long": 99.87,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 570903,
            "zip_code": 57130,
            "name_th": "เกาะช้าง",
            "name_en": "Ko Chang",
            "district_id": 5709,
            "lat": 20.398,
            "long": 100.01,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 570904,
            "zip_code": 57130,
            "name_th": "โป่งผา",
            "name_en": "Pong Pha",
            "district_id": 5709,
            "lat": 20.37,
            "long": 99.894,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 570905,
            "zip_code": 57130,
            "name_th": "ศรีเมืองชุม",
            "name_en": "Si Mueang Chum",
            "district_id": 5709,
            "lat": 20.378,
            "long": 99.957,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 570906,
            "zip_code": 57130,
            "name_th": "เวียงพางคำ",
            "name_en": "Wiang Phang Kham",
            "district_id": 5709,
            "lat": 20.409,
            "long": 99.9,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 570908,
            "zip_code": 57220,
            "name_th": "บ้านด้าย",
            "name_en": "Ban Dai",
            "district_id": 5709,
            "lat": 20.31,
            "long": 99.929,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 570909,
            "zip_code": 57130,
            "name_th": "โป่งงาม",
            "name_en": "Pong Ngam",
            "district_id": 5709,
            "lat": 20.325,
            "long": 99.869,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 5710,
        "name_th": "แม่สรวย",
        "name_en": "Mae Suai",
        "province_id": 45,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 571001,
            "zip_code": 57180,
            "name_th": "แม่สรวย",
            "name_en": "Mae Suai",
            "district_id": 5710,
            "lat": 19.676,
            "long": 99.56,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 571002,
            "zip_code": 57180,
            "name_th": "ป่าแดด",
            "name_en": "Pa Daet",
            "district_id": 5710,
            "lat": 19.715,
            "long": 99.427,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 571003,
            "zip_code": 57180,
            "name_th": "แม่พริก",
            "name_en": "Mae Phrik",
            "district_id": 5710,
            "lat": 19.63,
            "long": 99.524,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 571004,
            "zip_code": 57180,
            "name_th": "ศรีถ้อย",
            "name_en": "Si Thoi",
            "district_id": 5710,
            "lat": 19.677,
            "long": 99.317,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 571005,
            "zip_code": 57180,
            "name_th": "ท่าก๊อ",
            "name_en": "Tha Ko",
            "district_id": 5710,
            "lat": 19.504,
            "long": 99.528,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 571006,
            "zip_code": 57180,
            "name_th": "วาวี",
            "name_en": "Wawi",
            "district_id": 5710,
            "lat": 19.848,
            "long": 99.497,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 571007,
            "zip_code": 57180,
            "name_th": "เจดีย์หลวง",
            "name_en": "Chedi Luang",
            "district_id": 5710,
            "lat": 19.569,
            "long": 99.546,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 5711,
        "name_th": "เวียงป่าเป้า",
        "name_en": "Wiang Pa Pao",
        "province_id": 45,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 571101,
            "zip_code": 57170,
            "name_th": "สันสลี",
            "name_en": "San Sali",
            "district_id": 5711,
            "lat": 19.419,
            "long": 99.514,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 571102,
            "zip_code": 57170,
            "name_th": "เวียง",
            "name_en": "Wiang",
            "district_id": 5711,
            "lat": 19.358,
            "long": 99.422,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 571103,
            "zip_code": 57170,
            "name_th": "บ้านโป่ง",
            "name_en": "Ban Pong",
            "district_id": 5711,
            "lat": 19.302,
            "long": 99.459,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 571104,
            "zip_code": 57170,
            "name_th": "ป่างิ้ว",
            "name_en": "Pa Ngio",
            "district_id": 5711,
            "lat": 19.252,
            "long": 99.441,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 571105,
            "zip_code": 57260,
            "name_th": "เวียงกาหลง",
            "name_en": "Wiang Kalong",
            "district_id": 5711,
            "lat": 19.241,
            "long": 99.525,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 571106,
            "zip_code": 57260,
            "name_th": "แม่เจดีย์",
            "name_en": "Mae Chedi",
            "district_id": 5711,
            "lat": 19.164,
            "long": 99.367,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 571107,
            "zip_code": 57260,
            "name_th": "แม่เจดีย์ใหม่",
            "name_en": "Mae Chedi Mai",
            "district_id": 5711,
            "lat": 19.098,
            "long": 99.451,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 5712,
        "name_th": "พญาเม็งราย",
        "name_en": "Phaya Mengrai",
        "province_id": 45,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 571201,
            "zip_code": 57290,
            "name_th": "แม่เปา",
            "name_en": "Mae Pao",
            "district_id": 5712,
            "lat": 19.902,
            "long": 100.118,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 571202,
            "zip_code": 57290,
            "name_th": "แม่ต๋ำ",
            "name_en": "Mae Tam",
            "district_id": 5712,
            "lat": 19.926,
            "long": 100.239,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 571203,
            "zip_code": 57290,
            "name_th": "ไม้ยา",
            "name_en": "Mai Ya",
            "district_id": 5712,
            "lat": 19.769,
            "long": 100.107,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 571204,
            "zip_code": 57290,
            "name_th": "เม็งราย",
            "name_en": "Mengrai",
            "district_id": 5712,
            "lat": 19.861,
            "long": 100.182,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 571205,
            "zip_code": 57290,
            "name_th": "ตาดควัน",
            "name_en": "Tat Khwan",
            "district_id": 5712,
            "lat": 19.991,
            "long": 100.184,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 5713,
        "name_th": "เวียงแก่น",
        "name_en": "Wiang Kaen",
        "province_id": 45,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 571301,
            "zip_code": 57310,
            "name_th": "ม่วงยาย",
            "name_en": "Muang Yai",
            "district_id": 5713,
            "lat": 20.108,
            "long": 100.539,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 571302,
            "zip_code": 57310,
            "name_th": "ปอ",
            "name_en": "Por",
            "district_id": 5713,
            "lat": 19.94,
            "long": 100.449,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 571303,
            "zip_code": 57310,
            "name_th": "หล่ายงาว",
            "name_en": "Lai Ngao",
            "district_id": 5713,
            "lat": 20.117,
            "long": 100.48,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 571304,
            "zip_code": 57310,
            "name_th": "ท่าข้าม",
            "name_en": "Tha Kham",
            "district_id": 5713,
            "lat": 20.042,
            "long": 100.52,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 5714,
        "name_th": "ขุนตาล",
        "name_en": "Khun Tan",
        "province_id": 45,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 571401,
            "zip_code": 57340,
            "name_th": "ต้า",
            "name_en": "Ta",
            "district_id": 5714,
            "lat": 19.804,
            "long": 100.233,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 571402,
            "zip_code": 57340,
            "name_th": "ป่าตาล",
            "name_en": "Pa Tan",
            "district_id": 5714,
            "lat": 19.847,
            "long": 100.272,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 571403,
            "zip_code": 57340,
            "name_th": "ยางฮอม",
            "name_en": "Yang Hom",
            "district_id": 5714,
            "lat": 19.924,
            "long": 100.306,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 5715,
        "name_th": "แม่ฟ้าหลวง",
        "name_en": "Mae Fa Luang",
        "province_id": 45,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 571501,
            "zip_code": 57240,
            "name_th": "เทอดไทย",
            "name_en": "Thoet Thai",
            "district_id": 5715,
            "lat": 20.306,
            "long": 99.603,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 571502,
            "zip_code": 57110,
            "name_th": "แม่สลองใน",
            "name_en": "Mae Salong Nai",
            "district_id": 5715,
            "lat": 20.194,
            "long": 99.706,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 571503,
            "zip_code": 57110,
            "name_th": "แม่สลองนอก",
            "name_en": "Mae Salong Nok",
            "district_id": 5715,
            "lat": 20.141,
            "long": 99.654,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 571504,
            "zip_code": 57240,
            "name_th": "แม่ฟ้าหลวง",
            "name_en": "Mae Fa Luang",
            "district_id": 5715,
            "lat": 20.288,
            "long": 99.783,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 5716,
        "name_th": "แม่ลาว",
        "name_en": "Mae Lao",
        "province_id": 45,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 571601,
            "zip_code": 57250,
            "name_th": "ดงมะดะ",
            "name_en": "Dong Mada",
            "district_id": 5716,
            "lat": 19.734,
            "long": 99.67,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 571602,
            "zip_code": 57250,
            "name_th": "จอมหมอกแก้ว",
            "name_en": "Chom Mok Kaeo",
            "district_id": 5716,
            "lat": 19.757,
            "long": 99.747,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 571603,
            "zip_code": 57250,
            "name_th": "บัวสลี",
            "name_en": "Bua Sali",
            "district_id": 5716,
            "lat": 19.804,
            "long": 99.768,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 571604,
            "zip_code": 57250,
            "name_th": "ป่าก่อดำ",
            "name_en": "Pa Ko Dam",
            "district_id": 5716,
            "lat": 19.794,
            "long": 99.715,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 571605,
            "zip_code": 57000,
            "name_th": "โป่งแพร่",
            "name_en": "Pong Phrae",
            "district_id": 5716,
            "lat": 19.812,
            "long": 99.653,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 5717,
        "name_th": "เวียงเชียงรุ้ง",
        "name_en": "Wiang Chiang Rung",
        "province_id": 45,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 571701,
            "zip_code": 57210,
            "name_th": "ทุ่งก่อ",
            "name_en": "Thung Ko",
            "district_id": 5717,
            "lat": 19.984,
            "long": 100.049,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 571702,
            "zip_code": 57210,
            "name_th": "ดงมหาวัน",
            "name_en": "Dong Maha Wan",
            "district_id": 5717,
            "lat": 20.041,
            "long": 100.006,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 571703,
            "zip_code": 57210,
            "name_th": "ป่าซาง",
            "name_en": "Pa Sang",
            "district_id": 5717,
            "lat": 20.048,
            "long": 100.12,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 5718,
        "name_th": "ดอยหลวง",
        "name_en": "Doi Luang",
        "province_id": 45,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 571801,
            "zip_code": 57110,
            "name_th": "ปงน้อย",
            "name_en": "Pong Noi",
            "district_id": 5718,
            "lat": 20.104,
            "long": 100.068,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 571802,
            "zip_code": 57110,
            "name_th": "โชคชัย",
            "name_en": "Chok Chai",
            "district_id": 5718,
            "lat": 20.134,
            "long": 100.193,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 571803,
            "zip_code": 57110,
            "name_th": "หนองป่าก่อ",
            "name_en": "Nong Pa Ko",
            "district_id": 5718,
            "lat": 20.181,
            "long": 100.124,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      }
    ]
  },
  {
    "id": 46,
    "name_th": "แม่ฮ่องสอน",
    "name_en": "Mae Hong Son",
    "geography_id": 1,
    "created_at": "2019-08-09T03:33:09.000+07:00",
    "updated_at": "2025-09-20T06:31:26.000+07:00",
    "deleted_at": null,
    "districts": [
      {
        "id": 5801,
        "name_th": "เมืองแม่ฮ่องสอน",
        "name_en": "Mueang Mae Hong Son",
        "province_id": 46,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 580101,
            "zip_code": 58000,
            "name_th": "จองคำ",
            "name_en": "Chong Kham",
            "district_id": 5801,
            "lat": 19.302,
            "long": 97.97,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 580102,
            "zip_code": 58000,
            "name_th": "ห้วยโป่ง",
            "name_en": "Huai Pong",
            "district_id": 5801,
            "lat": 19.038,
            "long": 98.006,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 580103,
            "zip_code": 58000,
            "name_th": "ผาบ่อง",
            "name_en": "Pha Bong",
            "district_id": 5801,
            "lat": 19.215,
            "long": 97.91,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 580104,
            "zip_code": 58000,
            "name_th": "ปางหมู",
            "name_en": "Pang Mu",
            "district_id": 5801,
            "lat": 19.344,
            "long": 97.915,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 580105,
            "zip_code": 58000,
            "name_th": "หมอกจำแป่",
            "name_en": "Mok Champae",
            "district_id": 5801,
            "lat": 19.497,
            "long": 97.995,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 580106,
            "zip_code": 58000,
            "name_th": "ห้วยผา",
            "name_en": "Huai Pha",
            "district_id": 5801,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 580109,
            "zip_code": 58000,
            "name_th": "ห้วยปูลิง",
            "name_en": "Huai Pu Ling",
            "district_id": 5801,
            "lat": 19.188,
            "long": 98.112,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 5802,
        "name_th": "ขุนยวม",
        "name_en": "Khun Yuam",
        "province_id": 46,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 580201,
            "zip_code": 58140,
            "name_th": "ขุนยวม",
            "name_en": "Khun Yuam",
            "district_id": 5802,
            "lat": 18.992,
            "long": 97.801,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 580202,
            "zip_code": 58140,
            "name_th": "แม่เงา",
            "name_en": "Mae Ngao",
            "district_id": 5802,
            "lat": 18.836,
            "long": 97.796,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 580203,
            "zip_code": 58140,
            "name_th": "เมืองปอน",
            "name_en": "Mueang Pon",
            "district_id": 5802,
            "lat": 18.702,
            "long": 97.945,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 580204,
            "zip_code": 58140,
            "name_th": "แม่ยวมน้อย",
            "name_en": "Mae Yuam Noi",
            "district_id": 5802,
            "lat": 18.742,
            "long": 98.051,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 580205,
            "zip_code": 58140,
            "name_th": "แม่กิ๊",
            "name_en": "Mae Ki",
            "district_id": 5802,
            "lat": 18.673,
            "long": 97.827,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 580206,
            "zip_code": 58140,
            "name_th": "แม่อูคอ",
            "name_en": "Mae Uo Kor",
            "district_id": 5802,
            "lat": 18.884,
            "long": 98.046,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 5803,
        "name_th": "ปาย",
        "name_en": "Pai",
        "province_id": 46,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 580301,
            "zip_code": 58130,
            "name_th": "เวียงใต้",
            "name_en": "Wiang Tai",
            "district_id": 5803,
            "lat": 19.362,
            "long": 98.419,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 580302,
            "zip_code": 58130,
            "name_th": "เวียงเหนือ",
            "name_en": "Wiang Nuea",
            "district_id": 5803,
            "lat": 19.512,
            "long": 98.497,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 580303,
            "zip_code": 58130,
            "name_th": "แม่นาเติง",
            "name_en": "Mae Na Toeng",
            "district_id": 5803,
            "lat": 19.456,
            "long": 98.363,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 580304,
            "zip_code": 58130,
            "name_th": "แม่ฮี้",
            "name_en": "Mae Hi",
            "district_id": 5803,
            "lat": 19.3,
            "long": 98.525,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 580305,
            "zip_code": 58130,
            "name_th": "ทุ่งยาว",
            "name_en": "Thung Yao",
            "district_id": 5803,
            "lat": 19.336,
            "long": 98.233,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 580306,
            "zip_code": 58130,
            "name_th": "เมืองแปง",
            "name_en": "Mueang Paeng",
            "district_id": 5803,
            "lat": 19.216,
            "long": 98.313,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 580307,
            "zip_code": 58130,
            "name_th": "โป่งสา",
            "name_en": "Pong Sa",
            "district_id": 5803,
            "lat": 19.12,
            "long": 98.581,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 5804,
        "name_th": "แม่สะเรียง",
        "name_en": "Mae Sariang",
        "province_id": 46,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 580401,
            "zip_code": 58110,
            "name_th": "บ้านกาศ",
            "name_en": "Ban Kat",
            "district_id": 5804,
            "lat": 18.259,
            "long": 97.88,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 580402,
            "zip_code": 58110,
            "name_th": "แม่สะเรียง",
            "name_en": "Mae Sariang",
            "district_id": 5804,
            "lat": 18.148,
            "long": 97.972,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 580403,
            "zip_code": 58110,
            "name_th": "แม่คง",
            "name_en": "Mae Khong",
            "district_id": 5804,
            "lat": 18.237,
            "long": 97.638,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 580404,
            "zip_code": 58110,
            "name_th": "แม่เหาะ",
            "name_en": "Mae Ho",
            "district_id": 5804,
            "lat": 18.12,
            "long": 98.074,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 580405,
            "zip_code": 58110,
            "name_th": "แม่ยวม",
            "name_en": "Mae Yuam",
            "district_id": 5804,
            "lat": 18.063,
            "long": 97.808,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 580406,
            "zip_code": 58110,
            "name_th": "เสาหิน",
            "name_en": "Sao Hin",
            "district_id": 5804,
            "lat": 18.432,
            "long": 97.719,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 580408,
            "zip_code": 58110,
            "name_th": "ป่าแป๋",
            "name_en": "Pa Pae",
            "district_id": 5804,
            "lat": 18.268,
            "long": 98.072,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 5805,
        "name_th": "แม่ลาน้อย",
        "name_en": "Mae La Noi",
        "province_id": 46,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 580501,
            "zip_code": 58120,
            "name_th": "แม่ลาน้อย",
            "name_en": "Mae La Noi",
            "district_id": 5805,
            "lat": 18.435,
            "long": 97.852,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 580502,
            "zip_code": 58120,
            "name_th": "แม่ลาหลวง",
            "name_en": "Mae La Luang",
            "district_id": 5805,
            "lat": 18.548,
            "long": 97.872,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 580503,
            "zip_code": 58120,
            "name_th": "ท่าผาปุ้ม",
            "name_en": "Tha Pha Pum",
            "district_id": 5805,
            "lat": 18.315,
            "long": 97.991,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 580504,
            "zip_code": 58120,
            "name_th": "แม่โถ",
            "name_en": "Mae Tho",
            "district_id": 5805,
            "lat": 18.609,
            "long": 98.032,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 580505,
            "zip_code": 58120,
            "name_th": "ห้วยห้อม",
            "name_en": "Huai Hom",
            "district_id": 5805,
            "lat": 18.37,
            "long": 98.102,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 580506,
            "zip_code": 58120,
            "name_th": "แม่นาจาง",
            "name_en": "Mae Na Chang",
            "district_id": 5805,
            "lat": 18.529,
            "long": 98.093,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 580507,
            "zip_code": 58120,
            "name_th": "สันติคีรี",
            "name_en": "Santi Khiri",
            "district_id": 5805,
            "lat": 18.508,
            "long": 97.992,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 580508,
            "zip_code": 58120,
            "name_th": "ขุนแม่ลาน้อย",
            "name_en": "Khun Mae La Noi",
            "district_id": 5805,
            "lat": 18.586,
            "long": 98.161,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 5806,
        "name_th": "สบเมย",
        "name_en": "Sop Moei",
        "province_id": 46,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 580601,
            "zip_code": 58110,
            "name_th": "สบเมย",
            "name_en": "Sop Moei",
            "district_id": 5806,
            "lat": 17.898,
            "long": 97.872,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 580602,
            "zip_code": 58110,
            "name_th": "แม่คะตวน",
            "name_en": "Mae Khatuan",
            "district_id": 5806,
            "lat": 18.003,
            "long": 97.981,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 580603,
            "zip_code": 58110,
            "name_th": "กองก๋อย",
            "name_en": "Kong Koi",
            "district_id": 5806,
            "lat": 18.015,
            "long": 98.16,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 580604,
            "zip_code": 58110,
            "name_th": "แม่สวด",
            "name_en": "Mae Suat",
            "district_id": 5806,
            "lat": 17.796,
            "long": 98.049,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 580605,
            "zip_code": 58110,
            "name_th": "ป่าโปง",
            "name_en": "Pa Pong",
            "district_id": 5806,
            "lat": 18.113,
            "long": 98.166,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 580606,
            "zip_code": 58110,
            "name_th": "แม่สามแลบ",
            "name_en": "Mae Sam Laep",
            "district_id": 5806,
            "lat": 17.899,
            "long": 97.759,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 5807,
        "name_th": "ปางมะผ้า",
        "name_en": "Pang Mapha",
        "province_id": 46,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 580701,
            "zip_code": 58150,
            "name_th": "สบป่อง",
            "name_en": "Sop Pong",
            "district_id": 5807,
            "lat": 19.453,
            "long": 98.169,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 580702,
            "zip_code": 58150,
            "name_th": "ปางมะผ้า",
            "name_en": "Pang Mapha",
            "district_id": 5807,
            "lat": 19.615,
            "long": 98.204,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 580703,
            "zip_code": 58150,
            "name_th": "ถ้ำลอด",
            "name_en": "Tham Lot",
            "district_id": 5807,
            "lat": 19.582,
            "long": 98.309,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 580704,
            "zip_code": 58150,
            "name_th": "นาปู่ป้อม",
            "name_en": "Na Pu Pom",
            "district_id": 5807,
            "lat": 19.659,
            "long": 98.114,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      }
    ]
  },
  {
    "id": 47,
    "name_th": "นครสวรรค์",
    "name_en": "Nakhon Sawan",
    "geography_id": 2,
    "created_at": "2019-08-09T03:33:09.000+07:00",
    "updated_at": "2025-09-20T06:31:26.000+07:00",
    "deleted_at": null,
    "districts": [
      {
        "id": 6001,
        "name_th": "เมืองนครสวรรค์",
        "name_en": "Mueang Nakhon Sawan",
        "province_id": 47,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 600101,
            "zip_code": 60000,
            "name_th": "ปากน้ำโพ",
            "name_en": "Paknam Pho",
            "district_id": 6001,
            "lat": 15.703,
            "long": 100.128,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 600102,
            "zip_code": 60000,
            "name_th": "กลางแดด",
            "name_en": "Klang Daet",
            "district_id": 6001,
            "lat": 15.663,
            "long": 100.118,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 600103,
            "zip_code": 60000,
            "name_th": "เกรียงไกร",
            "name_en": "Kriangkrai",
            "district_id": 6001,
            "lat": 15.719,
            "long": 100.218,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 600104,
            "zip_code": 60000,
            "name_th": "แควใหญ่",
            "name_en": "Khwae Yai",
            "district_id": 6001,
            "lat": 15.712,
            "long": 100.174,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 600105,
            "zip_code": 60000,
            "name_th": "ตะเคียนเลื่อน",
            "name_en": "Takhian Luean",
            "district_id": 6001,
            "lat": 15.63,
            "long": 100.086,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 600106,
            "zip_code": 60000,
            "name_th": "นครสวรรค์ตก",
            "name_en": "Nakhon Sawan Tok",
            "district_id": 6001,
            "lat": 15.681,
            "long": 100.073,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 600107,
            "zip_code": 60000,
            "name_th": "นครสวรรค์ออก",
            "name_en": "Nakhon Sawan Ok",
            "district_id": 6001,
            "lat": 15.633,
            "long": 100.132,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 600108,
            "zip_code": 60000,
            "name_th": "บางพระหลวง",
            "name_en": "Bang Phra Luang",
            "district_id": 6001,
            "lat": 15.771,
            "long": 100.188,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 600109,
            "zip_code": 60000,
            "name_th": "บางม่วง",
            "name_en": "Bang Muang",
            "district_id": 6001,
            "lat": 15.755,
            "long": 100.11,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 600110,
            "zip_code": 60000,
            "name_th": "บ้านมะเกลือ",
            "name_en": "Ban Makluea",
            "district_id": 6001,
            "lat": 15.801,
            "long": 100.143,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 600111,
            "zip_code": 60000,
            "name_th": "บ้านแก่ง",
            "name_en": "Ban Kaeng",
            "district_id": 6001,
            "lat": 15.788,
            "long": 100.057,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 600112,
            "zip_code": 60000,
            "name_th": "พระนอน",
            "name_en": "Phra Non",
            "district_id": 6001,
            "lat": 15.663,
            "long": 100.216,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 600113,
            "zip_code": 60000,
            "name_th": "วัดไทร",
            "name_en": "Wat Sai",
            "district_id": 6001,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 600114,
            "zip_code": 60240,
            "name_th": "หนองกรด",
            "name_en": "Nong Krot",
            "district_id": 6001,
            "lat": 15.724,
            "long": 99.997,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 600115,
            "zip_code": 60240,
            "name_th": "หนองกระโดน",
            "name_en": "Nong Kradon",
            "district_id": 6001,
            "lat": 15.804,
            "long": 99.965,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 600116,
            "zip_code": 60000,
            "name_th": "หนองปลิง",
            "name_en": "Nong Pling",
            "district_id": 6001,
            "lat": 15.645,
            "long": 100.169,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 600117,
            "zip_code": 60000,
            "name_th": "บึงเสนาท",
            "name_en": "Bueng Senat",
            "district_id": 6001,
            "lat": 15.734,
            "long": 100.14,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 6002,
        "name_th": "โกรกพระ",
        "name_en": "Krok Phra",
        "province_id": 47,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 600201,
            "zip_code": 60170,
            "name_th": "โกรกพระ",
            "name_en": "Krok Phra",
            "district_id": 6002,
            "lat": 15.559,
            "long": 100.056,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 600202,
            "zip_code": 60170,
            "name_th": "ยางตาล",
            "name_en": "Yang Tan",
            "district_id": 6002,
            "lat": 15.585,
            "long": 100.114,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 600203,
            "zip_code": 60170,
            "name_th": "บางมะฝ่อ",
            "name_en": "Bang Mafo",
            "district_id": 6002,
            "lat": 15.594,
            "long": 100.081,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 600204,
            "zip_code": 60170,
            "name_th": "บางประมุง",
            "name_en": "Bang Pramung",
            "district_id": 6002,
            "lat": 15.662,
            "long": 99.997,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 600205,
            "zip_code": 60170,
            "name_th": "นากลาง",
            "name_en": "Na Klang",
            "district_id": 6002,
            "lat": 15.62,
            "long": 99.981,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 600206,
            "zip_code": 60170,
            "name_th": "ศาลาแดง",
            "name_en": "Sala Daeng",
            "district_id": 6002,
            "lat": 15.581,
            "long": 99.996,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 600207,
            "zip_code": 60170,
            "name_th": "เนินกว้าว",
            "name_en": "Noen Kwao",
            "district_id": 6002,
            "lat": 15.54,
            "long": 100.015,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 600208,
            "zip_code": 60170,
            "name_th": "เนินศาลา",
            "name_en": "Noen Sala",
            "district_id": 6002,
            "lat": 15.54,
            "long": 99.96,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 600209,
            "zip_code": 60170,
            "name_th": "หาดสูง",
            "name_en": "Hat Sung",
            "district_id": 6002,
            "lat": 15.503,
            "long": 99.989,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 6003,
        "name_th": "ชุมแสง",
        "name_en": "Chum Saeng",
        "province_id": 47,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 600301,
            "zip_code": 60120,
            "name_th": "ชุมแสง",
            "name_en": "Chum Saeng",
            "district_id": 6003,
            "lat": 15.896,
            "long": 100.315,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 600302,
            "zip_code": 60250,
            "name_th": "ทับกฤช",
            "name_en": "Thap Krit",
            "district_id": 6003,
            "lat": 15.77,
            "long": 100.233,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 600303,
            "zip_code": 60120,
            "name_th": "พิกุล",
            "name_en": "Phikun",
            "district_id": 6003,
            "lat": 15.889,
            "long": 100.346,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 600304,
            "zip_code": 60120,
            "name_th": "เกยไชย",
            "name_en": "Koei Chai",
            "district_id": 6003,
            "lat": 15.869,
            "long": 100.286,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 600305,
            "zip_code": 60120,
            "name_th": "ท่าไม้",
            "name_en": "Tha Mai",
            "district_id": 6003,
            "lat": 15.915,
            "long": 100.253,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 600306,
            "zip_code": 60120,
            "name_th": "บางเคียน",
            "name_en": "Bang Khian",
            "district_id": 6003,
            "lat": 15.806,
            "long": 100.176,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 600307,
            "zip_code": 60120,
            "name_th": "หนองกระเจา",
            "name_en": "Nong Krachao",
            "district_id": 6003,
            "lat": 15.901,
            "long": 100.395,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 600308,
            "zip_code": 60250,
            "name_th": "พันลาน",
            "name_en": "Phan Lan",
            "district_id": 6003,
            "lat": 15.833,
            "long": 100.28,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 600309,
            "zip_code": 60120,
            "name_th": "โคกหม้อ",
            "name_en": "Khok Mo",
            "district_id": 6003,
            "lat": 15.83,
            "long": 100.235,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 600310,
            "zip_code": 60120,
            "name_th": "ไผ่สิงห์",
            "name_en": "Phai Sing",
            "district_id": 6003,
            "lat": 15.829,
            "long": 100.36,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 600311,
            "zip_code": 60120,
            "name_th": "ฆะมัง",
            "name_en": "Khamang",
            "district_id": 6003,
            "lat": 15.948,
            "long": 100.312,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 600312,
            "zip_code": 60250,
            "name_th": "ทับกฤชใต้",
            "name_en": "Thap Krit Tai",
            "district_id": 6003,
            "lat": 15.757,
            "long": 100.286,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 6004,
        "name_th": "หนองบัว",
        "name_en": "Nong Bua",
        "province_id": 47,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 600401,
            "zip_code": 60110,
            "name_th": "หนองบัว",
            "name_en": "Nong Bua",
            "district_id": 6004,
            "lat": 15.85,
            "long": 100.654,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 600402,
            "zip_code": 60110,
            "name_th": "หนองกลับ",
            "name_en": "Nong Klap",
            "district_id": 6004,
            "lat": 15.924,
            "long": 100.614,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 600403,
            "zip_code": 60110,
            "name_th": "ธารทหาร",
            "name_en": "Than Thahan",
            "district_id": 6004,
            "lat": 15.787,
            "long": 100.549,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 600404,
            "zip_code": 60110,
            "name_th": "ห้วยร่วม",
            "name_en": "Huai Ruam",
            "district_id": 6004,
            "lat": 15.908,
            "long": 100.494,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 600405,
            "zip_code": 60110,
            "name_th": "ห้วยถั่วใต้",
            "name_en": "Huai Thua Tai",
            "district_id": 6004,
            "lat": 15.837,
            "long": 100.464,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 600406,
            "zip_code": 60110,
            "name_th": "ห้วยถั่วเหนือ",
            "name_en": "Huai Thua Nuea",
            "district_id": 6004,
            "lat": 15.855,
            "long": 100.504,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 600407,
            "zip_code": 60110,
            "name_th": "ห้วยใหญ่",
            "name_en": "Huai Yai",
            "district_id": 6004,
            "lat": 15.864,
            "long": 100.429,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 600408,
            "zip_code": 60110,
            "name_th": "ทุ่งทอง",
            "name_en": "Thung Thong",
            "district_id": 6004,
            "lat": 15.937,
            "long": 100.713,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 600409,
            "zip_code": 60110,
            "name_th": "วังบ่อ",
            "name_en": "Wang Bo",
            "district_id": 6004,
            "lat": 15.783,
            "long": 100.649,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 6005,
        "name_th": "บรรพตพิสัย",
        "name_en": "Banphot Phisai",
        "province_id": 47,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 600501,
            "zip_code": 60180,
            "name_th": "ท่างิ้ว",
            "name_en": "Tha Ngio",
            "district_id": 6005,
            "lat": 15.918,
            "long": 99.976,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 600502,
            "zip_code": 60180,
            "name_th": "บางตาหงาย",
            "name_en": "Bang Ta Ngai",
            "district_id": 6005,
            "lat": 15.943,
            "long": 100.022,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 600503,
            "zip_code": 60180,
            "name_th": "หูกวาง",
            "name_en": "Hukwang",
            "district_id": 6005,
            "lat": 15.879,
            "long": 100.014,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 600504,
            "zip_code": 60180,
            "name_th": "อ่างทอง",
            "name_en": "Ang Thong",
            "district_id": 6005,
            "lat": 15.871,
            "long": 99.942,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 600505,
            "zip_code": 60180,
            "name_th": "บ้านแดน",
            "name_en": "Ban Daen",
            "district_id": 6005,
            "lat": 15.937,
            "long": 99.89,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 600506,
            "zip_code": 60180,
            "name_th": "บางแก้ว",
            "name_en": "Bang Kaeo",
            "district_id": 6005,
            "lat": 15.982,
            "long": 99.872,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 600507,
            "zip_code": 60180,
            "name_th": "ตาขีด",
            "name_en": "Ta Khit",
            "district_id": 6005,
            "lat": 16.017,
            "long": 99.917,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 600508,
            "zip_code": 60180,
            "name_th": "ตาสัง",
            "name_en": "Ta Sang",
            "district_id": 6005,
            "lat": 15.993,
            "long": 99.967,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 600509,
            "zip_code": 60180,
            "name_th": "ด่านช้าง",
            "name_en": "Dan Chang",
            "district_id": 6005,
            "lat": 16.08,
            "long": 99.999,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 600510,
            "zip_code": 60180,
            "name_th": "หนองกรด",
            "name_en": "Nong Krot",
            "district_id": 6005,
            "lat": 15.997,
            "long": 100.095,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 600511,
            "zip_code": 60180,
            "name_th": "หนองตางู",
            "name_en": "Nong Ta Ngu",
            "district_id": 6005,
            "lat": 16.13,
            "long": 100.054,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 600512,
            "zip_code": 60180,
            "name_th": "บึงปลาทู",
            "name_en": "Bueng Pla Thu",
            "district_id": 6005,
            "lat": 16.073,
            "long": 100.065,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 600513,
            "zip_code": 60180,
            "name_th": "เจริญผล",
            "name_en": "Charoen Phon",
            "district_id": 6005,
            "lat": 15.956,
            "long": 99.988,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 6006,
        "name_th": "เก้าเลี้ยว",
        "name_en": "Kao Liao",
        "province_id": 47,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 600601,
            "zip_code": 60230,
            "name_th": "มหาโพธิ",
            "name_en": "Maha Phot",
            "district_id": 6006,
            "lat": 15.828,
            "long": 100.104,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 600602,
            "zip_code": 60230,
            "name_th": "เก้าเลี้ยว",
            "name_en": "Kao Liao",
            "district_id": 6006,
            "lat": 15.849,
            "long": 100.085,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 600603,
            "zip_code": 60230,
            "name_th": "หนองเต่า",
            "name_en": "Nong Tao",
            "district_id": 6006,
            "lat": 15.884,
            "long": 100.146,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 600604,
            "zip_code": 60230,
            "name_th": "เขาดิน",
            "name_en": "Khao Din",
            "district_id": 6006,
            "lat": 15.839,
            "long": 100.039,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 600605,
            "zip_code": 60230,
            "name_th": "หัวดง",
            "name_en": "Hua Dong",
            "district_id": 6006,
            "lat": 15.908,
            "long": 100.072,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 6007,
        "name_th": "ตาคลี",
        "name_en": "Takhli",
        "province_id": 47,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 600701,
            "zip_code": 60140,
            "name_th": "ตาคลี",
            "name_en": "Takhli",
            "district_id": 6007,
            "lat": 15.271,
            "long": 100.339,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 600702,
            "zip_code": 60210,
            "name_th": "ช่องแค",
            "name_en": "Chong Khae",
            "district_id": 6007,
            "lat": 15.197,
            "long": 100.422,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 600703,
            "zip_code": 60260,
            "name_th": "จันเสน",
            "name_en": "Chan Sen",
            "district_id": 6007,
            "lat": 15.103,
            "long": 100.439,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 600704,
            "zip_code": 60210,
            "name_th": "ห้วยหอม",
            "name_en": "Huai Hom",
            "district_id": 6007,
            "lat": 15.225,
            "long": 100.483,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 600705,
            "zip_code": 60140,
            "name_th": "หัวหวาย",
            "name_en": "Hua Wai",
            "district_id": 6007,
            "lat": 15.384,
            "long": 100.383,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 600706,
            "zip_code": 60140,
            "name_th": "หนองโพ",
            "name_en": "Nong Pho",
            "district_id": 6007,
            "lat": 15.403,
            "long": 100.278,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 600707,
            "zip_code": 60140,
            "name_th": "หนองหม้อ",
            "name_en": "Nong Mo",
            "district_id": 6007,
            "lat": 15.194,
            "long": 100.325,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 600708,
            "zip_code": 60210,
            "name_th": "สร้อยทอง",
            "name_en": "Soi Thong",
            "district_id": 6007,
            "lat": 15.12,
            "long": 100.387,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 600709,
            "zip_code": 60260,
            "name_th": "ลาดทิพรส",
            "name_en": "Lat Thippharot",
            "district_id": 6007,
            "lat": 15.235,
            "long": 100.549,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 600710,
            "zip_code": 60210,
            "name_th": "พรหมนิมิต",
            "name_en": "Phrom Nimit",
            "district_id": 6007,
            "lat": 15.175,
            "long": 100.393,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 6008,
        "name_th": "ท่าตะโก",
        "name_en": "Takhli",
        "province_id": 47,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 600801,
            "zip_code": 60160,
            "name_th": "ท่าตะโก",
            "name_en": "Tha Tako",
            "district_id": 6008,
            "lat": 15.631,
            "long": 100.48,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 600802,
            "zip_code": 60160,
            "name_th": "พนมรอก",
            "name_en": "Phanom Rok",
            "district_id": 6008,
            "lat": 15.704,
            "long": 100.442,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 600803,
            "zip_code": 60160,
            "name_th": "หัวถนน",
            "name_en": "Hua Thanon",
            "district_id": 6008,
            "lat": 15.583,
            "long": 100.432,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 600804,
            "zip_code": 60160,
            "name_th": "สายลำโพง",
            "name_en": "Sai Lamphong",
            "district_id": 6008,
            "lat": 15.768,
            "long": 100.487,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 600805,
            "zip_code": 60160,
            "name_th": "วังมหากร",
            "name_en": "Wang Mahakon",
            "district_id": 6008,
            "lat": 15.649,
            "long": 100.355,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 600806,
            "zip_code": 60160,
            "name_th": "ดอนคา",
            "name_en": "Don Kha",
            "district_id": 6008,
            "lat": 15.685,
            "long": 100.538,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 600807,
            "zip_code": 60160,
            "name_th": "ทำนบ",
            "name_en": "Thamnop",
            "district_id": 6008,
            "lat": 15.603,
            "long": 100.518,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 600808,
            "zip_code": 60160,
            "name_th": "วังใหญ่",
            "name_en": "Wang Yai",
            "district_id": 6008,
            "lat": 15.781,
            "long": 100.413,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 600809,
            "zip_code": 60160,
            "name_th": "พนมเศษ",
            "name_en": "Phanom Set",
            "district_id": 6008,
            "lat": 15.731,
            "long": 100.34,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 600810,
            "zip_code": 60160,
            "name_th": "หนองหลวง",
            "name_en": "Nong Luang",
            "district_id": 6008,
            "lat": 15.486,
            "long": 100.533,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 6009,
        "name_th": "ไพศาลี",
        "name_en": "Phaisali",
        "province_id": 47,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 600901,
            "zip_code": 60220,
            "name_th": "โคกเดื่อ",
            "name_en": "Khok Duea",
            "district_id": 6009,
            "lat": 15.622,
            "long": 100.604,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 600902,
            "zip_code": 60220,
            "name_th": "สำโรงชัย",
            "name_en": "Samrong Chai",
            "district_id": 6009,
            "lat": 15.524,
            "long": 100.633,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 600903,
            "zip_code": 60220,
            "name_th": "วังน้ำลัด",
            "name_en": "Wang Nam Lat",
            "district_id": 6009,
            "lat": 15.709,
            "long": 100.666,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 600904,
            "zip_code": 60220,
            "name_th": "ตะคร้อ",
            "name_en": "Takhro",
            "district_id": 6009,
            "lat": 15.476,
            "long": 100.71,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 600905,
            "zip_code": 60220,
            "name_th": "โพธิ์ประสาท",
            "name_en": "Pho Prasat",
            "district_id": 6009,
            "lat": 15.44,
            "long": 100.587,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 600906,
            "zip_code": 60220,
            "name_th": "วังข่อย",
            "name_en": "Wang Khoi",
            "district_id": 6009,
            "lat": 15.598,
            "long": 100.761,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 600907,
            "zip_code": 60220,
            "name_th": "นาขอม",
            "name_en": "Na Khom",
            "district_id": 6009,
            "lat": 15.721,
            "long": 100.784,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 600908,
            "zip_code": 60220,
            "name_th": "ไพศาลี",
            "name_en": "Phaisali",
            "district_id": 6009,
            "lat": 15.637,
            "long": 100.7,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 6010,
        "name_th": "พยุหะคีรี",
        "name_en": "Phayuha Khiri",
        "province_id": 47,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 601001,
            "zip_code": 60130,
            "name_th": "พยุหะ",
            "name_en": "Phayuha",
            "district_id": 6010,
            "lat": 15.455,
            "long": 100.145,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 601002,
            "zip_code": 60130,
            "name_th": "เนินมะกอก",
            "name_en": "Noen Makok",
            "district_id": 6010,
            "lat": 15.449,
            "long": 100.2,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 601003,
            "zip_code": 60130,
            "name_th": "นิคมเขาบ่อแก้ว",
            "name_en": "Nikhom Khao Bo Kaeo",
            "district_id": 6010,
            "lat": 15.471,
            "long": 100.245,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 601004,
            "zip_code": 60130,
            "name_th": "ม่วงหัก",
            "name_en": "Muang Hak",
            "district_id": 6010,
            "lat": 15.389,
            "long": 100.2,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 601005,
            "zip_code": 60130,
            "name_th": "ยางขาว",
            "name_en": "Yang Khao",
            "district_id": 6010,
            "lat": 15.514,
            "long": 100.069,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 601006,
            "zip_code": 60130,
            "name_th": "ย่านมัทรี",
            "name_en": "Yan Matsi",
            "district_id": 6010,
            "lat": 15.524,
            "long": 100.106,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 601007,
            "zip_code": 60130,
            "name_th": "เขาทอง",
            "name_en": "Khao Thong",
            "district_id": 6010,
            "lat": 15.567,
            "long": 100.161,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 601008,
            "zip_code": 60130,
            "name_th": "ท่าน้ำอ้อย",
            "name_en": "Tha Nam Oi",
            "district_id": 6010,
            "lat": 15.423,
            "long": 100.149,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 601009,
            "zip_code": 60130,
            "name_th": "น้ำทรง",
            "name_en": "Nam Song",
            "district_id": 6010,
            "lat": 15.46,
            "long": 100.074,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 601010,
            "zip_code": 60130,
            "name_th": "เขากะลา",
            "name_en": "Khao Kala",
            "district_id": 6010,
            "lat": 15.542,
            "long": 100.316,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 601011,
            "zip_code": 60130,
            "name_th": "สระทะเล",
            "name_en": "Sa Thale",
            "district_id": 6010,
            "lat": 15.51,
            "long": 100.156,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 6011,
        "name_th": "ลาดยาว",
        "name_en": "Phayuha Khiri",
        "province_id": 47,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 601101,
            "zip_code": 60150,
            "name_th": "ลาดยาว",
            "name_en": "Lat Yao",
            "district_id": 6011,
            "lat": 15.756,
            "long": 99.759,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 601102,
            "zip_code": 60150,
            "name_th": "ห้วยน้ำหอม",
            "name_en": "Huai Nam Hom",
            "district_id": 6011,
            "lat": 15.729,
            "long": 99.696,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 601103,
            "zip_code": 60150,
            "name_th": "วังม้า",
            "name_en": "Wang Ma",
            "district_id": 6011,
            "lat": 15.686,
            "long": 99.871,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 601104,
            "zip_code": 60150,
            "name_th": "วังเมือง",
            "name_en": "Wang Mueang",
            "district_id": 6011,
            "lat": 15.64,
            "long": 99.846,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 601105,
            "zip_code": 60150,
            "name_th": "สร้อยละคร",
            "name_en": "Soi Lakhon",
            "district_id": 6011,
            "lat": 15.726,
            "long": 99.824,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 601106,
            "zip_code": 60150,
            "name_th": "มาบแก",
            "name_en": "Map Kae",
            "district_id": 6011,
            "lat": 15.677,
            "long": 99.781,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 601107,
            "zip_code": 60150,
            "name_th": "หนองยาว",
            "name_en": "Nong Yao",
            "district_id": 6011,
            "lat": 15.737,
            "long": 99.887,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 601108,
            "zip_code": 60150,
            "name_th": "หนองนมวัว",
            "name_en": "Nong Nom Wua",
            "district_id": 6011,
            "lat": 15.777,
            "long": 99.866,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 601109,
            "zip_code": 60150,
            "name_th": "บ้านไร่",
            "name_en": "Ban Rai",
            "district_id": 6011,
            "lat": 15.873,
            "long": 99.791,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 601110,
            "zip_code": 60150,
            "name_th": "เนินขี้เหล็ก",
            "name_en": "Noen Khilek",
            "district_id": 6011,
            "lat": 15.839,
            "long": 99.858,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 601116,
            "zip_code": 60150,
            "name_th": "ศาลเจ้าไก่ต่อ",
            "name_en": "San Chao Kai To",
            "district_id": 6011,
            "lat": 15.788,
            "long": 99.669,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 601117,
            "zip_code": 60150,
            "name_th": "สระแก้ว",
            "name_en": "Sa Kaeo",
            "district_id": 6011,
            "lat": 15.784,
            "long": 99.803,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 6012,
        "name_th": "ตากฟ้า",
        "name_en": "Tak Fa",
        "province_id": 47,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 601201,
            "zip_code": 60190,
            "name_th": "ตากฟ้า",
            "name_en": "Tak Fa",
            "district_id": 6012,
            "lat": 15.313,
            "long": 100.488,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 601202,
            "zip_code": 60190,
            "name_th": "ลำพยนต์",
            "name_en": "Lam Phayon",
            "district_id": 6012,
            "lat": 15.32,
            "long": 100.573,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 601203,
            "zip_code": 60190,
            "name_th": "สุขสำราญ",
            "name_en": "Suk Samran",
            "district_id": 6012,
            "lat": 15.353,
            "long": 100.523,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 601204,
            "zip_code": 60190,
            "name_th": "หนองพิกุล",
            "name_en": "Nong Phikun",
            "district_id": 6012,
            "lat": 15.331,
            "long": 100.428,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 601205,
            "zip_code": 60190,
            "name_th": "พุนกยูง",
            "name_en": "Phu Nok Yung",
            "district_id": 6012,
            "lat": 15.402,
            "long": 100.467,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 601206,
            "zip_code": 60190,
            "name_th": "อุดมธัญญา",
            "name_en": "Udom Thanya",
            "district_id": 6012,
            "lat": 15.479,
            "long": 100.407,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 601207,
            "zip_code": 60190,
            "name_th": "เขาชายธง",
            "name_en": "Khao Chai Thong",
            "district_id": 6012,
            "lat": 15.278,
            "long": 100.448,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 6013,
        "name_th": "แม่วงก์",
        "name_en": "Mae Wong",
        "province_id": 47,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 601301,
            "zip_code": 60150,
            "name_th": "แม่วงก์",
            "name_en": "Mae Wong",
            "district_id": 6013,
            "lat": 15.781,
            "long": 99.57,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 601303,
            "zip_code": 60150,
            "name_th": "แม่เล่ย์",
            "name_en": "Mae Le",
            "district_id": 6013,
            "lat": 15.842,
            "long": 99.298,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 601304,
            "zip_code": 60150,
            "name_th": "วังซ่าน",
            "name_en": "Wang San",
            "district_id": 6013,
            "lat": 15.859,
            "long": 99.644,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 601305,
            "zip_code": 60150,
            "name_th": "เขาชนกัน",
            "name_en": "Khao Chon Kan",
            "district_id": 6013,
            "lat": 15.883,
            "long": 99.516,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 6014,
        "name_th": "แม่เปิน",
        "name_en": "Mae Poen",
        "province_id": 47,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 601401,
            "zip_code": 60150,
            "name_th": "แม่เปิน",
            "name_en": "Mae Poen",
            "district_id": 6014,
            "lat": 15.738,
            "long": 99.294,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 6015,
        "name_th": "ชุมตาบง",
        "name_en": "Chum Ta Bong",
        "province_id": 47,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 601501,
            "zip_code": 60150,
            "name_th": "ชุมตาบง",
            "name_en": "Chum Ta Bong",
            "district_id": 6015,
            "lat": 15.627,
            "long": 99.572,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 601502,
            "zip_code": 60150,
            "name_th": "ปางสวรรค์",
            "name_en": "Pang Sawan",
            "district_id": 6015,
            "lat": 15.688,
            "long": 99.56,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      }
    ]
  },
  {
    "id": 48,
    "name_th": "อุทัยธานี",
    "name_en": "Uthai Thani",
    "geography_id": 2,
    "created_at": "2019-08-09T03:33:09.000+07:00",
    "updated_at": "2025-09-20T06:31:26.000+07:00",
    "deleted_at": null,
    "districts": [
      {
        "id": 6101,
        "name_th": "เมืองอุทัยธานี",
        "name_en": "Mueang Uthai Thani",
        "province_id": 48,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 610101,
            "zip_code": 61000,
            "name_th": "อุทัยใหม่",
            "name_en": "Uthai Mai",
            "district_id": 6101,
            "lat": 15.375,
            "long": 100.031,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 610102,
            "zip_code": 61000,
            "name_th": "น้ำซึม",
            "name_en": "Nam Suem",
            "district_id": 6101,
            "lat": 15.353,
            "long": 100.033,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 610103,
            "zip_code": 61000,
            "name_th": "สะแกกรัง",
            "name_en": "Sakae Krang",
            "district_id": 6101,
            "lat": 15.354,
            "long": 100.068,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 610104,
            "zip_code": 61000,
            "name_th": "ดอนขวาง",
            "name_en": "Don Khwang",
            "district_id": 6101,
            "lat": 15.415,
            "long": 100.032,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 610105,
            "zip_code": 61000,
            "name_th": "หาดทนง",
            "name_en": "Hat Thanong",
            "district_id": 6101,
            "lat": 15.382,
            "long": 100.096,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 610106,
            "zip_code": 61000,
            "name_th": "เกาะเทโพ",
            "name_en": "Ko Thepho",
            "district_id": 6101,
            "lat": 15.35,
            "long": 100.088,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 610107,
            "zip_code": 61000,
            "name_th": "ท่าซุง",
            "name_en": "Tha Sung",
            "district_id": 6101,
            "lat": 15.31,
            "long": 100.058,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 610108,
            "zip_code": 61000,
            "name_th": "หนองแก",
            "name_en": "Nong Kae",
            "district_id": 6101,
            "lat": 15.417,
            "long": 99.974,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 610109,
            "zip_code": 61000,
            "name_th": "โนนเหล็ก",
            "name_en": "Non Lek",
            "district_id": 6101,
            "lat": 15.462,
            "long": 99.985,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 610110,
            "zip_code": 61000,
            "name_th": "หนองเต่า",
            "name_en": "Nong Tao",
            "district_id": 6101,
            "lat": 15.455,
            "long": 99.963,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 610111,
            "zip_code": 61000,
            "name_th": "หนองไผ่แบน",
            "name_en": "Nong Phai Baen",
            "district_id": 6101,
            "lat": 15.444,
            "long": 100.018,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 610112,
            "zip_code": 61000,
            "name_th": "หนองพังค่า",
            "name_en": "Nong Phang Kha",
            "district_id": 6101,
            "lat": 15.398,
            "long": 99.959,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 610113,
            "zip_code": 61000,
            "name_th": "ทุ่งใหญ่",
            "name_en": "Thung Yai",
            "district_id": 6101,
            "lat": 15.483,
            "long": 99.974,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 610114,
            "zip_code": 61000,
            "name_th": "เนินแจง",
            "name_en": "Noen Chaeng",
            "district_id": 6101,
            "lat": 15.46,
            "long": 100.031,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 6102,
        "name_th": "ทัพทัน",
        "name_en": "Thap Than",
        "province_id": 48,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 610201,
            "zip_code": 61120,
            "name_th": "ทัพทัน",
            "name_en": "Thap Than",
            "district_id": 6102,
            "lat": 15.467,
            "long": 99.888,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 610202,
            "zip_code": 61120,
            "name_th": "ทุ่งนาไทย",
            "name_en": "Thung Na Thai",
            "district_id": 6102,
            "lat": 15.45,
            "long": 99.926,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 610203,
            "zip_code": 61120,
            "name_th": "เขาขี้ฝอย",
            "name_en": "Khao Khi Foi",
            "district_id": 6102,
            "lat": 15.469,
            "long": 99.939,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 610204,
            "zip_code": 61120,
            "name_th": "หนองหญ้าปล้อง",
            "name_en": "Nong Ya Plong",
            "district_id": 6102,
            "lat": 15.495,
            "long": 99.909,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 610205,
            "zip_code": 61120,
            "name_th": "โคกหม้อ",
            "name_en": "Khok Mo",
            "district_id": 6102,
            "lat": 15.55,
            "long": 99.915,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 610206,
            "zip_code": 61120,
            "name_th": "หนองยายดา",
            "name_en": "Nong Yai Da",
            "district_id": 6102,
            "lat": 15.519,
            "long": 99.87,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 610207,
            "zip_code": 61120,
            "name_th": "หนองกลางดง",
            "name_en": "Nong Klang Dong",
            "district_id": 6102,
            "lat": 15.465,
            "long": 99.844,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 610208,
            "zip_code": 61120,
            "name_th": "หนองกระทุ่ม",
            "name_en": "Nong Krathum",
            "district_id": 6102,
            "lat": 15.508,
            "long": 99.71,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 610209,
            "zip_code": 61120,
            "name_th": "หนองสระ",
            "name_en": "Nong Sa",
            "district_id": 6102,
            "lat": 15.445,
            "long": 99.82,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 610210,
            "zip_code": 61120,
            "name_th": "ตลุกดู่",
            "name_en": "Taluk Du",
            "district_id": 6102,
            "lat": 15.452,
            "long": 99.74,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 6103,
        "name_th": "สว่างอารมณ์",
        "name_en": "Sawang Arom",
        "province_id": 48,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 610301,
            "zip_code": 61150,
            "name_th": "สว่างอารมณ์",
            "name_en": "Sawang Arom",
            "district_id": 6103,
            "lat": 15.548,
            "long": 99.844,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 610302,
            "zip_code": 61150,
            "name_th": "หนองหลวง",
            "name_en": "Nong Luang",
            "district_id": 6103,
            "lat": 15.622,
            "long": 99.9,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 610303,
            "zip_code": 61150,
            "name_th": "พลวงสองนาง",
            "name_en": "Phluang Song Nang",
            "district_id": 6103,
            "lat": 15.55,
            "long": 99.779,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 610304,
            "zip_code": 61150,
            "name_th": "ไผ่เขียว",
            "name_en": "Phai Khiao",
            "district_id": 6103,
            "lat": 15.623,
            "long": 99.762,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 610305,
            "zip_code": 61150,
            "name_th": "บ่อยาง",
            "name_en": "Bor Yang",
            "district_id": 6103,
            "lat": 15.592,
            "long": 99.715,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 6104,
        "name_th": "หนองฉาง",
        "name_en": "Nong Chang",
        "province_id": 48,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 610401,
            "zip_code": 61110,
            "name_th": "หนองฉาง",
            "name_en": "Nong Chang",
            "district_id": 6104,
            "lat": 15.397,
            "long": 99.854,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 610402,
            "zip_code": 61110,
            "name_th": "หนองยาง",
            "name_en": "Nong Yang",
            "district_id": 6104,
            "lat": 15.343,
            "long": 99.815,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 610403,
            "zip_code": 61110,
            "name_th": "หนองนางนวล",
            "name_en": "Nong Nang Nuan",
            "district_id": 6104,
            "lat": 15.34,
            "long": 99.864,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 610404,
            "zip_code": 61110,
            "name_th": "หนองสรวง",
            "name_en": "Nong Suang",
            "district_id": 6104,
            "lat": 15.372,
            "long": 99.81,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 610405,
            "zip_code": 61110,
            "name_th": "บ้านเก่า",
            "name_en": "Ban Kao",
            "district_id": 6104,
            "lat": 15.427,
            "long": 99.874,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 610406,
            "zip_code": 61110,
            "name_th": "อุทัยเก่า",
            "name_en": "Uthai Kao",
            "district_id": 6104,
            "lat": 15.408,
            "long": 99.8,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 610407,
            "zip_code": 61110,
            "name_th": "ทุ่งโพ",
            "name_en": "Thung Pho",
            "district_id": 6104,
            "lat": 15.344,
            "long": 99.712,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 610408,
            "zip_code": 61110,
            "name_th": "ทุ่งพง",
            "name_en": "Thung Phong",
            "district_id": 6104,
            "lat": 15.425,
            "long": 99.843,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 610409,
            "zip_code": 61170,
            "name_th": "เขาบางแกรก",
            "name_en": "Khao Bang Kraek",
            "district_id": 6104,
            "lat": 15.328,
            "long": 99.657,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 610410,
            "zip_code": 61110,
            "name_th": "เขากวางทอง",
            "name_en": "Khao Kwang Thong",
            "district_id": 6104,
            "lat": 15.394,
            "long": 99.694,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 6105,
        "name_th": "หนองขาหย่าง",
        "name_en": "Nong Khayang",
        "province_id": 48,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 610501,
            "zip_code": 61130,
            "name_th": "หนองขาหย่าง",
            "name_en": "Nong Khayang",
            "district_id": 6105,
            "lat": 15.349,
            "long": 99.95,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 610502,
            "zip_code": 61130,
            "name_th": "หนองไผ่",
            "name_en": "Nong Phai",
            "district_id": 6105,
            "lat": 15.341,
            "long": 99.902,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 610503,
            "zip_code": 61130,
            "name_th": "ดอนกลอย",
            "name_en": "Don Kloi",
            "district_id": 6105,
            "lat": 15.389,
            "long": 99.903,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 610504,
            "zip_code": 61130,
            "name_th": "ห้วยรอบ",
            "name_en": "Huai Rop",
            "district_id": 6105,
            "lat": 15.371,
            "long": 99.9,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 610505,
            "zip_code": 61130,
            "name_th": "ทุ่งพึ่ง",
            "name_en": "Thung Phueng",
            "district_id": 6105,
            "lat": 15.422,
            "long": 99.934,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 610506,
            "zip_code": 61130,
            "name_th": "ท่าโพ",
            "name_en": "Tha Pho",
            "district_id": 6105,
            "lat": 15.369,
            "long": 99.984,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 610507,
            "zip_code": 61130,
            "name_th": "หมกแถว",
            "name_en": "Mok Thaeo",
            "district_id": 6105,
            "lat": 15.338,
            "long": 99.991,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 610508,
            "zip_code": 61130,
            "name_th": "หลุมเข้า",
            "name_en": "Lum Khao",
            "district_id": 6105,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 610509,
            "zip_code": 61130,
            "name_th": "ดงขวาง",
            "name_en": "Dong Kwang",
            "district_id": 6105,
            "lat": 15.315,
            "long": 99.999,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 6106,
        "name_th": "บ้านไร่",
        "name_en": "Ban Rai",
        "province_id": 48,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 610601,
            "zip_code": 61140,
            "name_th": "บ้านไร่",
            "name_en": "Ban Rai",
            "district_id": 6106,
            "lat": 15.05,
            "long": 99.464,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 610602,
            "zip_code": 61140,
            "name_th": "ทัพหลวง",
            "name_en": "Thap Luang",
            "district_id": 6106,
            "lat": 15.054,
            "long": 99.603,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 610603,
            "zip_code": 61140,
            "name_th": "ห้วยแห้ง",
            "name_en": "Huai Haeng",
            "district_id": 6106,
            "lat": 15.175,
            "long": 99.556,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 610604,
            "zip_code": 61140,
            "name_th": "คอกควาย",
            "name_en": "Khok Khwai",
            "district_id": 6106,
            "lat": 15.226,
            "long": 99.412,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 610605,
            "zip_code": 61180,
            "name_th": "วังหิน",
            "name_en": "Wang Hin",
            "district_id": 6106,
            "lat": 15.27,
            "long": 99.7,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 610606,
            "zip_code": 61180,
            "name_th": "เมืองการุ้ง",
            "name_en": "Mueang Ka Rung",
            "district_id": 6106,
            "lat": 15.177,
            "long": 99.724,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 610607,
            "zip_code": 61140,
            "name_th": "แก่นมะกรูด",
            "name_en": "Kaen Makrut",
            "district_id": 6106,
            "lat": 15.292,
            "long": 99.168,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 610609,
            "zip_code": 61180,
            "name_th": "หนองจอก",
            "name_en": "Nong Chok",
            "district_id": 6106,
            "lat": 15.047,
            "long": 99.685,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 610610,
            "zip_code": 61180,
            "name_th": "หูช้าง",
            "name_en": "Hu Chang",
            "district_id": 6106,
            "lat": 15.142,
            "long": 99.681,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 610611,
            "zip_code": 61140,
            "name_th": "บ้านบึง",
            "name_en": "Ban Bueng",
            "district_id": 6106,
            "lat": 15.028,
            "long": 99.553,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 610612,
            "zip_code": 61180,
            "name_th": "บ้านใหม่คลองเคียน",
            "name_en": "Ban Mai Khlong Khian",
            "district_id": 6106,
            "lat": 15.238,
            "long": 99.674,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 610613,
            "zip_code": 61180,
            "name_th": "หนองบ่มกล้วย",
            "name_en": "Nong Bom Kluai",
            "district_id": 6106,
            "lat": 15.021,
            "long": 99.73,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 610614,
            "zip_code": 61140,
            "name_th": "เจ้าวัด",
            "name_en": "Chao Wat",
            "district_id": 6106,
            "lat": 15.132,
            "long": 99.431,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 6107,
        "name_th": "ลานสัก",
        "name_en": "Lan Sak",
        "province_id": 48,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 610701,
            "zip_code": 61160,
            "name_th": "ลานสัก",
            "name_en": "Lan Sak",
            "district_id": 6107,
            "lat": 15.486,
            "long": 99.544,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 610702,
            "zip_code": 61160,
            "name_th": "ประดู่ยืน",
            "name_en": "Pradu Yuen",
            "district_id": 6107,
            "lat": 15.452,
            "long": 99.643,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 610703,
            "zip_code": 61160,
            "name_th": "ป่าอ้อ",
            "name_en": "Pa O",
            "district_id": 6107,
            "lat": 15.408,
            "long": 99.519,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 610704,
            "zip_code": 61160,
            "name_th": "ระบำ",
            "name_en": "Rabam",
            "district_id": 6107,
            "lat": 15.538,
            "long": 99.336,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 610705,
            "zip_code": 61160,
            "name_th": "น้ำรอบ",
            "name_en": "Nam Rop",
            "district_id": 6107,
            "lat": 15.534,
            "long": 99.605,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 610706,
            "zip_code": 61160,
            "name_th": "ทุ่งนางาม",
            "name_en": "Thung Na Ngam",
            "district_id": 6107,
            "lat": 15.385,
            "long": 99.61,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 6108,
        "name_th": "ห้วยคต",
        "name_en": "Huai Khot",
        "province_id": 48,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 610801,
            "zip_code": 61170,
            "name_th": "สุขฤทัย",
            "name_en": "Suk Ruethai",
            "district_id": 6108,
            "lat": 15.274,
            "long": 99.646,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 610802,
            "zip_code": 61170,
            "name_th": "ทองหลาง",
            "name_en": "Thonglang",
            "district_id": 6108,
            "lat": 15.316,
            "long": 99.481,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 610803,
            "zip_code": 61170,
            "name_th": "ห้วยคต",
            "name_en": "Huai Khot",
            "district_id": 6108,
            "lat": 15.272,
            "long": 99.568,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      }
    ]
  },
  {
    "id": 49,
    "name_th": "กำแพงเพชร",
    "name_en": "Kamphaeng Phet",
    "geography_id": 2,
    "created_at": "2019-08-09T03:33:09.000+07:00",
    "updated_at": "2025-09-20T06:31:26.000+07:00",
    "deleted_at": null,
    "districts": [
      {
        "id": 6201,
        "name_th": "เมืองกำแพงเพชร",
        "name_en": "Mueang Kamphaeng Phet",
        "province_id": 49,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 620101,
            "zip_code": 62000,
            "name_th": "ในเมือง",
            "name_en": "Nai Mueang",
            "district_id": 6201,
            "lat": 16.473,
            "long": 99.528,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 620102,
            "zip_code": 62160,
            "name_th": "ไตรตรึงษ์",
            "name_en": "Trai Trueng",
            "district_id": 6201,
            "lat": 16.328,
            "long": 99.553,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 620103,
            "zip_code": 62000,
            "name_th": "อ่างทอง",
            "name_en": "Ang Thong",
            "district_id": 6201,
            "lat": 16.267,
            "long": 99.465,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 620104,
            "zip_code": 62000,
            "name_th": "นาบ่อคำ",
            "name_en": "Na Bo Kham",
            "district_id": 6201,
            "lat": 16.458,
            "long": 99.321,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 620105,
            "zip_code": 62000,
            "name_th": "นครชุม",
            "name_en": "Nakhon Chum",
            "district_id": 6201,
            "lat": 16.49,
            "long": 99.457,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 620106,
            "zip_code": 62000,
            "name_th": "ทรงธรรม",
            "name_en": "Song Tham",
            "district_id": 6201,
            "lat": 16.53,
            "long": 99.454,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 620107,
            "zip_code": 62000,
            "name_th": "ลานดอกไม้",
            "name_en": "Lan Dokmai",
            "district_id": 6201,
            "lat": 16.634,
            "long": 99.44,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 620110,
            "zip_code": 62000,
            "name_th": "หนองปลิง",
            "name_en": "Nong Pling",
            "district_id": 6201,
            "lat": 16.566,
            "long": 99.521,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 620111,
            "zip_code": 62000,
            "name_th": "คณฑี",
            "name_en": "Khonthi",
            "district_id": 6201,
            "lat": 16.367,
            "long": 99.695,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 620112,
            "zip_code": 62000,
            "name_th": "นิคมทุ่งโพธิ์ทะเล",
            "name_en": "Nikhom Thung Pho Thale",
            "district_id": 6201,
            "lat": 16.485,
            "long": 99.703,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 620113,
            "zip_code": 62000,
            "name_th": "เทพนคร",
            "name_en": "Thep Nakhon",
            "district_id": 6201,
            "lat": 16.427,
            "long": 99.611,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 620114,
            "zip_code": 62000,
            "name_th": "วังทอง",
            "name_en": "Wang Thong",
            "district_id": 6201,
            "lat": 16.27,
            "long": 99.376,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 620115,
            "zip_code": 62000,
            "name_th": "ท่าขุนราม",
            "name_en": "Tha Khun Ram",
            "district_id": 6201,
            "lat": 16.451,
            "long": 99.452,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 620117,
            "zip_code": 62000,
            "name_th": "คลองแม่ลาย",
            "name_en": "Khlong Mae Lai",
            "district_id": 6201,
            "lat": 16.375,
            "long": 99.41,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 620118,
            "zip_code": 62160,
            "name_th": "ธำมรงค์",
            "name_en": "Thammarong",
            "district_id": 6201,
            "lat": 16.33,
            "long": 99.628,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 620119,
            "zip_code": 62000,
            "name_th": "สระแก้ว",
            "name_en": "Sa Kaeo",
            "district_id": 6201,
            "lat": 16.521,
            "long": 99.59,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 6202,
        "name_th": "ไทรงาม",
        "name_en": "Sai Ngam",
        "province_id": 49,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 620201,
            "zip_code": 62150,
            "name_th": "ไทรงาม",
            "name_en": "Sai Ngam",
            "district_id": 6202,
            "lat": 16.487,
            "long": 99.897,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 620202,
            "zip_code": 62150,
            "name_th": "หนองคล้า",
            "name_en": "Nong Khla",
            "district_id": 6202,
            "lat": 16.452,
            "long": 99.827,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 620203,
            "zip_code": 62150,
            "name_th": "หนองทอง",
            "name_en": "Nong Thong",
            "district_id": 6202,
            "lat": 16.417,
            "long": 99.756,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 620204,
            "zip_code": 62150,
            "name_th": "หนองไม้กอง",
            "name_en": "Nong Mai Kong",
            "district_id": 6202,
            "lat": 16.464,
            "long": 99.973,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 620205,
            "zip_code": 62150,
            "name_th": "มหาชัย",
            "name_en": "Maha Chai",
            "district_id": 6202,
            "lat": 16.507,
            "long": 99.798,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 620206,
            "zip_code": 62150,
            "name_th": "พานทอง",
            "name_en": "Phan Thong",
            "district_id": 6202,
            "lat": 16.384,
            "long": 99.833,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 620207,
            "zip_code": 62150,
            "name_th": "หนองแม่แตง",
            "name_en": "Nong Mae Taeng",
            "district_id": 6202,
            "lat": 16.399,
            "long": 99.909,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 6203,
        "name_th": "คลองลาน",
        "name_en": "Khlong Lan",
        "province_id": 49,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 620301,
            "zip_code": 62180,
            "name_th": "คลองน้ำไหล",
            "name_en": "Khlong Nam Lai",
            "district_id": 6203,
            "lat": 16.157,
            "long": 99.144,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 620302,
            "zip_code": 62180,
            "name_th": "โป่งน้ำร้อน",
            "name_en": "Pong Nam Ron",
            "district_id": 6203,
            "lat": 16.389,
            "long": 99.258,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 620303,
            "zip_code": 62180,
            "name_th": "คลองลานพัฒนา",
            "name_en": "Khlong Lan Phatthana",
            "district_id": 6203,
            "lat": 16.096,
            "long": 99.252,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 620304,
            "zip_code": 62180,
            "name_th": "สักงาม",
            "name_en": "Sak Ngam",
            "district_id": 6203,
            "lat": 16.324,
            "long": 99.348,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 6204,
        "name_th": "ขาณุวรลักษบุรี",
        "name_en": "Khanu Woralaksaburi",
        "province_id": 49,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 620403,
            "zip_code": 62130,
            "name_th": "ยางสูง",
            "name_en": "Yang Sung",
            "district_id": 6204,
            "lat": 16.124,
            "long": 99.857,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 620404,
            "zip_code": 62130,
            "name_th": "ป่าพุทรา",
            "name_en": "Pa Phutsa",
            "district_id": 6204,
            "lat": 16.094,
            "long": 99.918,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 620405,
            "zip_code": 62130,
            "name_th": "แสนตอ",
            "name_en": "Saen To",
            "district_id": 6204,
            "lat": 16.051,
            "long": 99.831,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 620406,
            "zip_code": 62140,
            "name_th": "สลกบาตร",
            "name_en": "Salok Bat",
            "district_id": 6204,
            "lat": 16.0,
            "long": 99.801,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 620407,
            "zip_code": 62140,
            "name_th": "บ่อถ้ำ",
            "name_en": "Bo Tham",
            "district_id": 6204,
            "lat": 15.912,
            "long": 99.738,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 620408,
            "zip_code": 62140,
            "name_th": "ดอนแตง",
            "name_en": "Don Taeng",
            "district_id": 6204,
            "lat": 16.053,
            "long": 99.752,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 620409,
            "zip_code": 62140,
            "name_th": "วังชะพลู",
            "name_en": "Wang Chaphlu",
            "district_id": 6204,
            "lat": 16.011,
            "long": 99.639,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 620410,
            "zip_code": 62140,
            "name_th": "โค้งไผ่",
            "name_en": "Khong Phai",
            "district_id": 6204,
            "lat": 16.108,
            "long": 99.657,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 620411,
            "zip_code": 62140,
            "name_th": "ปางมะค่า",
            "name_en": "Pang Makha",
            "district_id": 6204,
            "lat": 15.967,
            "long": 99.461,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 620412,
            "zip_code": 62140,
            "name_th": "วังหามแห",
            "name_en": "Wang Ham Hae",
            "district_id": 6204,
            "lat": 16.066,
            "long": 99.603,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 620413,
            "zip_code": 62130,
            "name_th": "เกาะตาล",
            "name_en": "Ko Tan",
            "district_id": 6204,
            "lat": 16.103,
            "long": 99.788,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 6205,
        "name_th": "คลองขลุง",
        "name_en": "Khlong Khlung",
        "province_id": 49,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 620501,
            "zip_code": 62120,
            "name_th": "คลองขลุง",
            "name_en": "Khlong Khlung",
            "district_id": 6205,
            "lat": 16.176,
            "long": 99.698,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 620502,
            "zip_code": 62120,
            "name_th": "ท่ามะเขือ",
            "name_en": "Tha Makhuea",
            "district_id": 6205,
            "lat": 16.261,
            "long": 99.752,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 620504,
            "zip_code": 62120,
            "name_th": "ท่าพุทรา",
            "name_en": "Tha Phutsa",
            "district_id": 6205,
            "lat": 16.269,
            "long": 99.679,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 620505,
            "zip_code": 62120,
            "name_th": "แม่ลาด",
            "name_en": "Mae Lat",
            "district_id": 6205,
            "lat": 16.153,
            "long": 99.785,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 620506,
            "zip_code": 62120,
            "name_th": "วังยาง",
            "name_en": "Wang Yang",
            "district_id": 6205,
            "lat": 16.204,
            "long": 99.774,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 620507,
            "zip_code": 62120,
            "name_th": "วังแขม",
            "name_en": "Wang Khaem",
            "district_id": 6205,
            "lat": 16.208,
            "long": 99.837,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 620508,
            "zip_code": 62120,
            "name_th": "หัวถนน",
            "name_en": "Hua Thanon",
            "district_id": 6205,
            "lat": 16.267,
            "long": 99.631,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 620509,
            "zip_code": 62120,
            "name_th": "วังไทร",
            "name_en": "Wang Sai",
            "district_id": 6205,
            "lat": 16.2,
            "long": 99.631,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 620513,
            "zip_code": 62120,
            "name_th": "วังบัว",
            "name_en": "Wang Bua",
            "district_id": 6205,
            "lat": 16.308,
            "long": 99.729,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 620516,
            "zip_code": 62120,
            "name_th": "คลองสมบูรณ์",
            "name_en": "Khlong Sombun",
            "district_id": 6205,
            "lat": 16.25,
            "long": 99.543,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 6206,
        "name_th": "พรานกระต่าย",
        "name_en": "Phran Kratai",
        "province_id": 49,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 620601,
            "zip_code": 62110,
            "name_th": "พรานกระต่าย",
            "name_en": "Phran Kratai",
            "district_id": 6206,
            "lat": 16.657,
            "long": 99.538,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 620602,
            "zip_code": 62110,
            "name_th": "หนองหัววัว",
            "name_en": "Nong Hua Wua",
            "district_id": 6206,
            "lat": 16.748,
            "long": 99.579,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 620603,
            "zip_code": 62110,
            "name_th": "ท่าไม้",
            "name_en": "Tha Mai",
            "district_id": 6206,
            "lat": 16.679,
            "long": 99.434,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 620604,
            "zip_code": 62110,
            "name_th": "วังควง",
            "name_en": "Wang Khuang",
            "district_id": 6206,
            "lat": 16.779,
            "long": 99.398,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 620605,
            "zip_code": 62110,
            "name_th": "วังตะแบก",
            "name_en": "Wang Tabaek",
            "district_id": 6206,
            "lat": 16.712,
            "long": 99.666,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 620606,
            "zip_code": 62110,
            "name_th": "เขาคีริส",
            "name_en": "Khao Khirit",
            "district_id": 6206,
            "lat": 16.588,
            "long": 99.683,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 620607,
            "zip_code": 62110,
            "name_th": "คุยบ้านโอง",
            "name_en": "Khui Ban Ong",
            "district_id": 6206,
            "lat": 16.659,
            "long": 99.667,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 620608,
            "zip_code": 62110,
            "name_th": "คลองพิไกร",
            "name_en": "Khlong Phikrai",
            "district_id": 6206,
            "lat": 16.666,
            "long": 99.742,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 620609,
            "zip_code": 62110,
            "name_th": "ถ้ำกระต่ายทอง",
            "name_en": "Tham Kratai Thong",
            "district_id": 6206,
            "lat": 16.729,
            "long": 99.541,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 620610,
            "zip_code": 62110,
            "name_th": "ห้วยยั้ง",
            "name_en": "Huai Yang",
            "district_id": 6206,
            "lat": 16.824,
            "long": 99.559,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 6207,
        "name_th": "ลานกระบือ",
        "name_en": "Lan Krabue",
        "province_id": 49,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 620701,
            "zip_code": 62170,
            "name_th": "ลานกระบือ",
            "name_en": "Lan Krabue",
            "district_id": 6207,
            "lat": 16.625,
            "long": 99.861,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 620702,
            "zip_code": 62170,
            "name_th": "ช่องลม",
            "name_en": "Chong Lom",
            "district_id": 6207,
            "lat": 16.568,
            "long": 99.913,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 620703,
            "zip_code": 62170,
            "name_th": "หนองหลวง",
            "name_en": "Nong Luang",
            "district_id": 6207,
            "lat": 16.64,
            "long": 99.78,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 620704,
            "zip_code": 62170,
            "name_th": "โนนพลวง",
            "name_en": "Non Phluang",
            "district_id": 6207,
            "lat": 16.56,
            "long": 99.857,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 620705,
            "zip_code": 62170,
            "name_th": "ประชาสุขสันต์",
            "name_en": "Pracha Suk San",
            "district_id": 6207,
            "lat": 16.521,
            "long": 99.974,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 620706,
            "zip_code": 62170,
            "name_th": "บึงทับแรต",
            "name_en": "Bueng Thap Raet",
            "district_id": 6207,
            "lat": 16.689,
            "long": 99.855,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 620707,
            "zip_code": 62170,
            "name_th": "จันทิมา",
            "name_en": "Chanthima",
            "district_id": 6207,
            "lat": 16.57,
            "long": 99.791,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 6208,
        "name_th": "ทรายทองวัฒนา",
        "name_en": "Sai Thong Watthana",
        "province_id": 49,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 620801,
            "zip_code": 62190,
            "name_th": "ทุ่งทราย",
            "name_en": "Thung Sai",
            "district_id": 6208,
            "lat": 16.305,
            "long": 99.862,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 620802,
            "zip_code": 62190,
            "name_th": "ทุ่งทอง",
            "name_en": "Thung Thong",
            "district_id": 6208,
            "lat": 16.341,
            "long": 99.899,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 620803,
            "zip_code": 62190,
            "name_th": "ถาวรวัฒนา",
            "name_en": "Thawon Watthana",
            "district_id": 6208,
            "lat": 16.287,
            "long": 99.915,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 6209,
        "name_th": "ปางศิลาทอง",
        "name_en": "Pang Sila Thong",
        "province_id": 49,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 620901,
            "zip_code": 62120,
            "name_th": "โพธิ์ทอง",
            "name_en": "Pho Thong",
            "district_id": 6209,
            "lat": 16.11,
            "long": 99.527,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 620902,
            "zip_code": 62120,
            "name_th": "หินดาต",
            "name_en": "Hin Dat",
            "district_id": 6209,
            "lat": 16.052,
            "long": 99.426,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 620903,
            "zip_code": 62120,
            "name_th": "ปางตาไว",
            "name_en": "Pang Ta Wai",
            "district_id": 6209,
            "lat": 16.017,
            "long": 99.164,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 6210,
        "name_th": "บึงสามัคคี",
        "name_en": "Bueng Samakkhi",
        "province_id": 49,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 621001,
            "zip_code": 62210,
            "name_th": "บึงสามัคคี",
            "name_en": "Bueng Samakkhi",
            "district_id": 6210,
            "lat": 16.285,
            "long": 99.985,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 621002,
            "zip_code": 62210,
            "name_th": "วังชะโอน",
            "name_en": "Wang Cha-on",
            "district_id": 6210,
            "lat": 16.233,
            "long": 99.926,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 621003,
            "zip_code": 62210,
            "name_th": "ระหาน",
            "name_en": "Rahan",
            "district_id": 6210,
            "lat": 16.158,
            "long": 99.941,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 621004,
            "zip_code": 62210,
            "name_th": "เทพนิมิต",
            "name_en": "Thep Nimit",
            "district_id": 6210,
            "lat": 16.182,
            "long": 99.914,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 6211,
        "name_th": "โกสัมพีนคร",
        "name_en": "Kosamphi Nakhon",
        "province_id": 49,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 621101,
            "zip_code": 62000,
            "name_th": "โกสัมพี",
            "name_en": "Kosamphi",
            "district_id": 6211,
            "lat": 16.501,
            "long": 99.215,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 621102,
            "zip_code": 62000,
            "name_th": "เพชรชมภู",
            "name_en": "Phet Chomphu",
            "district_id": 6211,
            "lat": 16.58,
            "long": 99.361,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 621103,
            "zip_code": 62000,
            "name_th": "ลานดอกไม้ตก",
            "name_en": "Lan Dokmai Tok",
            "district_id": 6211,
            "lat": 16.581,
            "long": 99.429,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      }
    ]
  },
  {
    "id": 50,
    "name_th": "ตาก",
    "name_en": "Tak",
    "geography_id": 4,
    "created_at": "2019-08-09T03:33:09.000+07:00",
    "updated_at": "2025-09-20T06:31:26.000+07:00",
    "deleted_at": null,
    "districts": [
      {
        "id": 6301,
        "name_th": "เมืองตาก",
        "name_en": "Mueang Tak",
        "province_id": 50,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 630101,
            "zip_code": 63000,
            "name_th": "ระแหง",
            "name_en": "Rahaeng",
            "district_id": 6301,
            "lat": 16.862,
            "long": 99.129,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 630102,
            "zip_code": 63000,
            "name_th": "หนองหลวง",
            "name_en": "Nong Luang",
            "district_id": 6301,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 630103,
            "zip_code": 63000,
            "name_th": "เชียงเงิน",
            "name_en": "Chiang Ngoen",
            "district_id": 6301,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 630104,
            "zip_code": 63000,
            "name_th": "หัวเดียด",
            "name_en": "Hua Diat",
            "district_id": 6301,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 630105,
            "zip_code": 63000,
            "name_th": "หนองบัวเหนือ",
            "name_en": "Nong Bua Nuea",
            "district_id": 6301,
            "lat": 16.923,
            "long": 99.049,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 630106,
            "zip_code": 63000,
            "name_th": "ไม้งาม",
            "name_en": "Mai Ngam",
            "district_id": 6301,
            "lat": 16.972,
            "long": 99.186,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 630107,
            "zip_code": 63000,
            "name_th": "โป่งแดง",
            "name_en": "Pong Daeng",
            "district_id": 6301,
            "lat": 17.059,
            "long": 99.291,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 630108,
            "zip_code": 63000,
            "name_th": "น้ำรึม",
            "name_en": "Nam Ruem",
            "district_id": 6301,
            "lat": 16.897,
            "long": 99.168,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 630109,
            "zip_code": 63000,
            "name_th": "วังหิน",
            "name_en": "Wang Hin",
            "district_id": 6301,
            "lat": 16.786,
            "long": 99.231,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 630111,
            "zip_code": 63000,
            "name_th": "แม่ท้อ",
            "name_en": "Mae Tho",
            "district_id": 6301,
            "lat": 16.789,
            "long": 98.967,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 630112,
            "zip_code": 63000,
            "name_th": "ป่ามะม่วง",
            "name_en": "Pa Mamuang",
            "district_id": 6301,
            "lat": 16.866,
            "long": 99.075,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 630113,
            "zip_code": 63000,
            "name_th": "หนองบัวใต้",
            "name_en": "Nong Bua Tai",
            "district_id": 6301,
            "lat": 16.795,
            "long": 99.103,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 630114,
            "zip_code": 63000,
            "name_th": "วังประจบ",
            "name_en": "Wang Prachop",
            "district_id": 6301,
            "lat": 16.888,
            "long": 99.373,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 630115,
            "zip_code": 63000,
            "name_th": "ตลุกกลางทุ่ง",
            "name_en": "Taluk Klang Thung",
            "district_id": 6301,
            "lat": 16.861,
            "long": 99.249,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 6302,
        "name_th": "บ้านตาก",
        "name_en": "Ban Tak",
        "province_id": 50,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 630201,
            "zip_code": 63120,
            "name_th": "ตากออก",
            "name_en": "Tak Ok",
            "district_id": 6302,
            "lat": 17.066,
            "long": 99.107,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 630202,
            "zip_code": 63120,
            "name_th": "สมอโคน",
            "name_en": "Samo Khon",
            "district_id": 6302,
            "lat": 17.046,
            "long": 99.183,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 630203,
            "zip_code": 63120,
            "name_th": "แม่สลิด",
            "name_en": "Mae Salit",
            "district_id": 6302,
            "lat": 17.295,
            "long": 99.255,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 630204,
            "zip_code": 63120,
            "name_th": "ตากตก",
            "name_en": "Tak Tok",
            "district_id": 6302,
            "lat": 17.001,
            "long": 99.068,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 630205,
            "zip_code": 63120,
            "name_th": "เกาะตะเภา",
            "name_en": "Ko Taphao",
            "district_id": 6302,
            "lat": 17.11,
            "long": 99.011,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 630206,
            "zip_code": 63120,
            "name_th": "ทุ่งกระเชาะ",
            "name_en": "Thung Kracho",
            "district_id": 6302,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 630207,
            "zip_code": 63120,
            "name_th": "ท้องฟ้า",
            "name_en": "Thong Fa",
            "district_id": 6302,
            "lat": 17.086,
            "long": 98.918,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 6303,
        "name_th": "สามเงา",
        "name_en": "Sam Ngao",
        "province_id": 50,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 630301,
            "zip_code": 63130,
            "name_th": "สามเงา",
            "name_en": "Sam Ngao",
            "district_id": 6303,
            "lat": 17.25,
            "long": 99.034,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 630302,
            "zip_code": 63130,
            "name_th": "วังหมัน",
            "name_en": "Wang Man",
            "district_id": 6303,
            "lat": 17.201,
            "long": 99.117,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 630303,
            "zip_code": 63130,
            "name_th": "ยกกระบัตร",
            "name_en": "Yokkrabat",
            "district_id": 6303,
            "lat": 17.335,
            "long": 99.034,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 630304,
            "zip_code": 63130,
            "name_th": "ย่านรี",
            "name_en": "Yan Ri",
            "district_id": 6303,
            "lat": 17.188,
            "long": 99.022,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 630305,
            "zip_code": 63130,
            "name_th": "บ้านนา",
            "name_en": "Ban Na",
            "district_id": 6303,
            "lat": 17.333,
            "long": 98.864,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 630306,
            "zip_code": 63130,
            "name_th": "วังจันทร์",
            "name_en": "Wang Chan",
            "district_id": 6303,
            "lat": 17.275,
            "long": 99.147,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 6304,
        "name_th": "แม่ระมาด",
        "name_en": "Mae Ramat",
        "province_id": 50,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 630401,
            "zip_code": 63140,
            "name_th": "แม่ระมาด",
            "name_en": "Mae Ramat",
            "district_id": 6304,
            "lat": 16.971,
            "long": 98.525,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 630402,
            "zip_code": 63140,
            "name_th": "แม่จะเรา",
            "name_en": "Mae Charao",
            "district_id": 6304,
            "lat": 16.947,
            "long": 98.591,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 630403,
            "zip_code": 63140,
            "name_th": "ขะเนจื้อ",
            "name_en": "Khane Chue",
            "district_id": 6304,
            "lat": 17.055,
            "long": 98.541,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 630404,
            "zip_code": 63140,
            "name_th": "แม่ตื่น",
            "name_en": "Mae Tuen",
            "district_id": 6304,
            "lat": 17.194,
            "long": 98.566,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 630405,
            "zip_code": 63140,
            "name_th": "สามหมื่น",
            "name_en": "Sam Muen",
            "district_id": 6304,
            "lat": 17.092,
            "long": 98.698,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 630406,
            "zip_code": 63140,
            "name_th": "พระธาตุ",
            "name_en": "Phra That",
            "district_id": 6304,
            "lat": 17.004,
            "long": 98.668,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 6305,
        "name_th": "ท่าสองยาง",
        "name_en": "Tha Song Yang",
        "province_id": 50,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 630501,
            "zip_code": 63150,
            "name_th": "ท่าสองยาง",
            "name_en": "Tha Song Yang",
            "district_id": 6305,
            "lat": 17.724,
            "long": 97.817,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 630502,
            "zip_code": 63150,
            "name_th": "แม่ต้าน",
            "name_en": "Mae Tan",
            "district_id": 6305,
            "lat": 17.268,
            "long": 98.275,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 630503,
            "zip_code": 63150,
            "name_th": "แม่สอง",
            "name_en": "Mae Song",
            "district_id": 6305,
            "lat": 17.494,
            "long": 98.151,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 630504,
            "zip_code": 63150,
            "name_th": "แม่หละ",
            "name_en": "Mae La",
            "district_id": 6305,
            "lat": 17.17,
            "long": 98.359,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 630505,
            "zip_code": 63150,
            "name_th": "แม่วะหลวง",
            "name_en": "Mae Wa Luang",
            "district_id": 6305,
            "lat": 17.763,
            "long": 97.923,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 630506,
            "zip_code": 63150,
            "name_th": "แม่อุสุ",
            "name_en": "Mae Usu",
            "district_id": 6305,
            "lat": 17.361,
            "long": 98.214,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 6306,
        "name_th": "แม่สอด",
        "name_en": "Mae Sot",
        "province_id": 50,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 630601,
            "zip_code": 63110,
            "name_th": "แม่สอด",
            "name_en": "Mae Sot",
            "district_id": 6306,
            "lat": 16.716,
            "long": 98.573,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 630602,
            "zip_code": 63110,
            "name_th": "แม่กุ",
            "name_en": "Mae Ku",
            "district_id": 6306,
            "lat": 16.62,
            "long": 98.651,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 630603,
            "zip_code": 63110,
            "name_th": "พะวอ",
            "name_en": "Phawo",
            "district_id": 6306,
            "lat": 16.671,
            "long": 98.784,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 630604,
            "zip_code": 63110,
            "name_th": "แม่ตาว",
            "name_en": "Mae Tao",
            "district_id": 6306,
            "lat": 16.681,
            "long": 98.577,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 630605,
            "zip_code": 63110,
            "name_th": "แม่กาษา",
            "name_en": "Mae Kasa",
            "district_id": 6306,
            "lat": 16.897,
            "long": 98.654,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 630606,
            "zip_code": 63110,
            "name_th": "ท่าสายลวด",
            "name_en": "Tha Sai Luat",
            "district_id": 6306,
            "lat": 16.696,
            "long": 98.533,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 630607,
            "zip_code": 63110,
            "name_th": "แม่ปะ",
            "name_en": "Mae Pa",
            "district_id": 6306,
            "lat": 16.757,
            "long": 98.586,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 630608,
            "zip_code": 63110,
            "name_th": "มหาวัน",
            "name_en": "Mahawan",
            "district_id": 6306,
            "lat": 16.565,
            "long": 98.676,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 630609,
            "zip_code": 63110,
            "name_th": "ด่านแม่ละเมา",
            "name_en": "Dan Mae Lamao",
            "district_id": 6306,
            "lat": 16.748,
            "long": 98.862,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 630610,
            "zip_code": 63110,
            "name_th": "พระธาตุผาแดง",
            "name_en": "Phra That Pha Daeng",
            "district_id": 6306,
            "lat": 16.692,
            "long": 98.639,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 6307,
        "name_th": "พบพระ",
        "name_en": "Phop Phra",
        "province_id": 50,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 630701,
            "zip_code": 63160,
            "name_th": "พบพระ",
            "name_en": "Phop Phra",
            "district_id": 6307,
            "lat": 16.402,
            "long": 98.697,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 630702,
            "zip_code": 63160,
            "name_th": "ช่องแคบ",
            "name_en": "Chong Khaep",
            "district_id": 6307,
            "lat": 16.512,
            "long": 98.749,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 630703,
            "zip_code": 63160,
            "name_th": "คีรีราษฎร์",
            "name_en": "Khiri Rat",
            "district_id": 6307,
            "lat": 16.537,
            "long": 98.845,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 630704,
            "zip_code": 63160,
            "name_th": "วาเล่ย์",
            "name_en": "Wale",
            "district_id": 6307,
            "lat": 16.368,
            "long": 98.768,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 630705,
            "zip_code": 63160,
            "name_th": "รวมไทยพัฒนา",
            "name_en": "Ruam Thai Phatthana",
            "district_id": 6307,
            "lat": 16.44,
            "long": 98.786,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 6308,
        "name_th": "อุ้มผาง",
        "name_en": "Umphang",
        "province_id": 50,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 630801,
            "zip_code": 63170,
            "name_th": "อุ้มผาง",
            "name_en": "Umphang",
            "district_id": 6308,
            "lat": 16.019,
            "long": 98.955,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 630802,
            "zip_code": 63170,
            "name_th": "หนองหลวง",
            "name_en": "Nong Luang",
            "district_id": 6308,
            "lat": 16.033,
            "long": 98.739,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 630803,
            "zip_code": 63170,
            "name_th": "โมโกร",
            "name_en": "Mokro",
            "district_id": 6308,
            "lat": 16.22,
            "long": 98.964,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 630804,
            "zip_code": 63170,
            "name_th": "แม่จัน",
            "name_en": "Mae Chan",
            "district_id": 6308,
            "lat": 15.727,
            "long": 98.716,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 630805,
            "zip_code": 63170,
            "name_th": "แม่ละมุ้ง",
            "name_en": "Mae Lamung",
            "district_id": 6308,
            "lat": 15.641,
            "long": 98.966,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 630806,
            "zip_code": 63170,
            "name_th": "แม่กลอง",
            "name_en": "Mae Klong",
            "district_id": 6308,
            "lat": 16.066,
            "long": 98.834,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 6309,
        "name_th": "วังเจ้า",
        "name_en": "Wang Chao",
        "province_id": 50,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 630901,
            "zip_code": 63000,
            "name_th": "เชียงทอง",
            "name_en": "Chiang Thong",
            "district_id": 6309,
            "lat": 16.571,
            "long": 99.122,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 630902,
            "zip_code": 63000,
            "name_th": "นาโบสถ์",
            "name_en": "Na Bot",
            "district_id": 6309,
            "lat": 16.705,
            "long": 99.156,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 630903,
            "zip_code": 63000,
            "name_th": "ประดาง",
            "name_en": "Pradang",
            "district_id": 6309,
            "lat": 16.748,
            "long": 99.184,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      }
    ]
  },
  {
    "id": 51,
    "name_th": "สุโขทัย",
    "name_en": "Sukhothai",
    "geography_id": 2,
    "created_at": "2019-08-09T03:33:09.000+07:00",
    "updated_at": "2025-09-20T06:31:26.000+07:00",
    "deleted_at": null,
    "districts": [
      {
        "id": 6401,
        "name_th": "เมืองสุโขทัย",
        "name_en": "Mueang Sukhothai",
        "province_id": 51,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 640101,
            "zip_code": 64000,
            "name_th": "ธานี",
            "name_en": "Thani",
            "district_id": 6401,
            "lat": 17.012,
            "long": 99.822,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 640102,
            "zip_code": 64220,
            "name_th": "บ้านสวน",
            "name_en": "Ban Suan",
            "district_id": 6401,
            "lat": 17.045,
            "long": 99.903,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 640103,
            "zip_code": 64210,
            "name_th": "เมืองเก่า",
            "name_en": "Mueang Kao",
            "district_id": 6401,
            "lat": 17.021,
            "long": 99.682,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 640104,
            "zip_code": 64000,
            "name_th": "ปากแคว",
            "name_en": "Pak Khwae",
            "district_id": 6401,
            "lat": 17.043,
            "long": 99.824,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 640105,
            "zip_code": 64000,
            "name_th": "ยางซ้าย",
            "name_en": "Yang Sai",
            "district_id": 6401,
            "lat": 16.974,
            "long": 99.821,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 640106,
            "zip_code": 64000,
            "name_th": "บ้านกล้วย",
            "name_en": "Ban Kluai",
            "district_id": 6401,
            "lat": 17.029,
            "long": 99.776,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 640107,
            "zip_code": 64000,
            "name_th": "บ้านหลุม",
            "name_en": "Ban Lum",
            "district_id": 6401,
            "lat": 16.983,
            "long": 99.87,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 640108,
            "zip_code": 64220,
            "name_th": "ตาลเตี้ย",
            "name_en": "Tan Tia",
            "district_id": 6401,
            "lat": 17.063,
            "long": 99.87,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 640109,
            "zip_code": 64000,
            "name_th": "ปากพระ",
            "name_en": "Pak Phra",
            "district_id": 6401,
            "lat": 16.915,
            "long": 99.836,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 640110,
            "zip_code": 64210,
            "name_th": "วังทองแดง",
            "name_en": "Wang Thongdaeng",
            "district_id": 6401,
            "lat": 17.107,
            "long": 99.687,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 6402,
        "name_th": "บ้านด่านลานหอย",
        "name_en": "Ban Dan Lan Hoi",
        "province_id": 51,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 640201,
            "zip_code": 64140,
            "name_th": "ลานหอย",
            "name_en": "Lan Hoi",
            "district_id": 6402,
            "lat": 16.887,
            "long": 99.609,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 640202,
            "zip_code": 64140,
            "name_th": "บ้านด่าน",
            "name_en": "Ban Dan",
            "district_id": 6402,
            "lat": 17.048,
            "long": 99.549,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 640203,
            "zip_code": 64140,
            "name_th": "วังตะคร้อ",
            "name_en": "Wang Takhro",
            "district_id": 6402,
            "lat": 16.948,
            "long": 99.5,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 640204,
            "zip_code": 64140,
            "name_th": "วังน้ำขาว",
            "name_en": "Wang Nam Khao",
            "district_id": 6402,
            "lat": 17.096,
            "long": 99.608,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 640205,
            "zip_code": 64140,
            "name_th": "ตลิ่งชัน",
            "name_en": "Taling Chan",
            "district_id": 6402,
            "lat": 17.156,
            "long": 99.414,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 640206,
            "zip_code": 64140,
            "name_th": "หนองหญ้าปล้อง",
            "name_en": "Nong Ya Plong",
            "district_id": 6402,
            "lat": 16.995,
            "long": 99.481,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 640207,
            "zip_code": 64140,
            "name_th": "วังลึก",
            "name_en": "Wang Luek",
            "district_id": 6402,
            "lat": 17.04,
            "long": 99.461,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 6403,
        "name_th": "คีรีมาศ",
        "name_en": "Khiri Mat",
        "province_id": 51,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 640301,
            "zip_code": 64160,
            "name_th": "โตนด",
            "name_en": "Tanot",
            "district_id": 6403,
            "lat": 16.839,
            "long": 99.824,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 640302,
            "zip_code": 64160,
            "name_th": "ทุ่งหลวง",
            "name_en": "Thung Luang",
            "district_id": 6403,
            "lat": 16.877,
            "long": 99.774,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 640303,
            "zip_code": 64160,
            "name_th": "บ้านป้อม",
            "name_en": "Ban Pom",
            "district_id": 6403,
            "lat": 16.931,
            "long": 99.776,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 640304,
            "zip_code": 64160,
            "name_th": "สามพวง",
            "name_en": "Sam Phuang",
            "district_id": 6403,
            "lat": 16.79,
            "long": 99.785,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 640305,
            "zip_code": 64160,
            "name_th": "ศรีคีรีมาศ",
            "name_en": "Si Khiri Mat",
            "district_id": 6403,
            "lat": 16.827,
            "long": 99.706,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 640306,
            "zip_code": 64160,
            "name_th": "หนองจิก",
            "name_en": "Nong Chik",
            "district_id": 6403,
            "lat": 16.764,
            "long": 99.749,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 640307,
            "zip_code": 64160,
            "name_th": "นาเชิงคีรี",
            "name_en": "Na Choeng Khiri",
            "district_id": 6403,
            "lat": 16.929,
            "long": 99.688,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 640308,
            "zip_code": 64160,
            "name_th": "หนองกระดิ่ง",
            "name_en": "Nong Krading",
            "district_id": 6403,
            "lat": 16.798,
            "long": 99.851,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 640309,
            "zip_code": 64160,
            "name_th": "บ้านน้ำพุ",
            "name_en": "Ban Nam Phu",
            "district_id": 6403,
            "lat": 16.815,
            "long": 99.632,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 640310,
            "zip_code": 64160,
            "name_th": "ทุ่งยางเมือง",
            "name_en": "Thung Yang Mueang",
            "district_id": 6403,
            "lat": 16.748,
            "long": 99.834,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 6404,
        "name_th": "กงไกรลาศ",
        "name_en": "Kong Krailat",
        "province_id": 51,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 640401,
            "zip_code": 64170,
            "name_th": "กง",
            "name_en": "Kong",
            "district_id": 6404,
            "lat": 16.893,
            "long": 99.984,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 640402,
            "zip_code": 64170,
            "name_th": "บ้านกร่าง",
            "name_en": "Ban Krang",
            "district_id": 6404,
            "lat": 16.947,
            "long": 99.939,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 640403,
            "zip_code": 64170,
            "name_th": "ไกรนอก",
            "name_en": "Krai Nok",
            "district_id": 6404,
            "lat": 16.907,
            "long": 100.083,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 640404,
            "zip_code": 64170,
            "name_th": "ไกรกลาง",
            "name_en": "Krai Klang",
            "district_id": 6404,
            "lat": 16.996,
            "long": 99.997,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 640405,
            "zip_code": 64170,
            "name_th": "ไกรใน",
            "name_en": "Krai Nai",
            "district_id": 6404,
            "lat": 17.022,
            "long": 99.947,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 640406,
            "zip_code": 64170,
            "name_th": "ดงเดือย",
            "name_en": "Dong Dueai",
            "district_id": 6404,
            "lat": 16.92,
            "long": 100.011,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 640407,
            "zip_code": 64170,
            "name_th": "ป่าแฝก",
            "name_en": "Pa Faek",
            "district_id": 6404,
            "lat": 16.969,
            "long": 99.927,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 640408,
            "zip_code": 64170,
            "name_th": "กกแรต",
            "name_en": "Kok Raet",
            "district_id": 6404,
            "lat": 17.005,
            "long": 100.027,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 640409,
            "zip_code": 64170,
            "name_th": "ท่าฉนวน",
            "name_en": "Tha Chanuan",
            "district_id": 6404,
            "lat": 16.891,
            "long": 99.878,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 640410,
            "zip_code": 64170,
            "name_th": "หนองตูม",
            "name_en": "Nong Tum",
            "district_id": 6404,
            "lat": 16.88,
            "long": 99.949,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 640411,
            "zip_code": 64170,
            "name_th": "บ้านใหม่สุขเกษม",
            "name_en": "Ban Mai Suk Kasem",
            "district_id": 6404,
            "lat": 16.954,
            "long": 100.078,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 6405,
        "name_th": "ศรีสัชนาลัย",
        "name_en": "Si Satchanalai",
        "province_id": 51,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 640501,
            "zip_code": 64130,
            "name_th": "หาดเสี้ยว",
            "name_en": "Hat Siao",
            "district_id": 6405,
            "lat": 17.52,
            "long": 99.784,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 640502,
            "zip_code": 64130,
            "name_th": "ป่างิ้ว",
            "name_en": "Pa Ngio",
            "district_id": 6405,
            "lat": 17.55,
            "long": 99.825,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 640503,
            "zip_code": 64130,
            "name_th": "แม่สำ",
            "name_en": "Mae Sam",
            "district_id": 6405,
            "lat": 17.608,
            "long": 99.713,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 640504,
            "zip_code": 64130,
            "name_th": "แม่สิน",
            "name_en": "Mae Sin",
            "district_id": 6405,
            "lat": 17.736,
            "long": 99.585,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 640505,
            "zip_code": 64130,
            "name_th": "บ้านตึก",
            "name_en": "Ban Tuek",
            "district_id": 6405,
            "lat": 17.649,
            "long": 99.881,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 640506,
            "zip_code": 64130,
            "name_th": "หนองอ้อ",
            "name_en": "Nong O",
            "district_id": 6405,
            "lat": 17.484,
            "long": 99.751,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 640507,
            "zip_code": 64190,
            "name_th": "ท่าชัย",
            "name_en": "Tha Chai",
            "district_id": 6405,
            "lat": 17.444,
            "long": 99.846,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 640508,
            "zip_code": 64190,
            "name_th": "ศรีสัชนาลัย",
            "name_en": "Si Satchanalai",
            "district_id": 6405,
            "lat": 17.409,
            "long": 99.778,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 640509,
            "zip_code": 64130,
            "name_th": "ดงคู่",
            "name_en": "Dong Khu",
            "district_id": 6405,
            "lat": 17.547,
            "long": 99.899,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 640510,
            "zip_code": 64130,
            "name_th": "บ้านแก่ง",
            "name_en": "Ban Kaeng",
            "district_id": 6405,
            "lat": 17.449,
            "long": 99.643,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 640511,
            "zip_code": 64130,
            "name_th": "สารจิตร",
            "name_en": "San Chit",
            "district_id": 6405,
            "lat": 17.42,
            "long": 99.728,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 6406,
        "name_th": "ศรีสำโรง",
        "name_en": "Si Samrong",
        "province_id": 51,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 640601,
            "zip_code": 64120,
            "name_th": "คลองตาล",
            "name_en": "Khlong Tan",
            "district_id": 6406,
            "lat": 17.158,
            "long": 99.858,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 640602,
            "zip_code": 64120,
            "name_th": "วังลึก",
            "name_en": "Wang Luek",
            "district_id": 6406,
            "lat": 17.147,
            "long": 99.883,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 640603,
            "zip_code": 64120,
            "name_th": "สามเรือน",
            "name_en": "Sam Ruean",
            "district_id": 6406,
            "lat": 17.183,
            "long": 99.872,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 640604,
            "zip_code": 64120,
            "name_th": "บ้านนา",
            "name_en": "Ban Na",
            "district_id": 6406,
            "lat": 17.171,
            "long": 99.835,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 640605,
            "zip_code": 64120,
            "name_th": "วังทอง",
            "name_en": "Wang Thong",
            "district_id": 6406,
            "lat": 17.139,
            "long": 99.811,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 640606,
            "zip_code": 64120,
            "name_th": "นาขุนไกร",
            "name_en": "Na Khun Krai",
            "district_id": 6406,
            "lat": 17.196,
            "long": 99.582,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 640607,
            "zip_code": 64120,
            "name_th": "เกาะตาเลี้ยง",
            "name_en": "Ko Ta Liang",
            "district_id": 6406,
            "lat": 17.111,
            "long": 99.908,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 640608,
            "zip_code": 64120,
            "name_th": "วัดเกาะ",
            "name_en": "Wat Ko",
            "district_id": 6406,
            "lat": 17.188,
            "long": 99.827,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 640609,
            "zip_code": 64120,
            "name_th": "บ้านไร่",
            "name_en": "Ban Rai",
            "district_id": 6406,
            "lat": 17.164,
            "long": 99.764,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 640610,
            "zip_code": 64120,
            "name_th": "ทับผึ้ง",
            "name_en": "Thap Phueng",
            "district_id": 6406,
            "lat": 17.084,
            "long": 99.83,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 640611,
            "zip_code": 64120,
            "name_th": "บ้านซ่าน",
            "name_en": "Ban San",
            "district_id": 6406,
            "lat": 17.203,
            "long": 99.77,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 640612,
            "zip_code": 64120,
            "name_th": "วังใหญ่",
            "name_en": "Wang Yai",
            "district_id": 6406,
            "lat": 17.118,
            "long": 99.765,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 640613,
            "zip_code": 64120,
            "name_th": "ราวต้นจันทร์",
            "name_en": "Rao Ton Chan",
            "district_id": 6406,
            "lat": 17.174,
            "long": 99.723,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 6407,
        "name_th": "สวรรคโลก",
        "name_en": "Sawankhalok",
        "province_id": 51,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 640701,
            "zip_code": 64110,
            "name_th": "เมืองสวรรคโลก",
            "name_en": "Mueang Sawankhalok",
            "district_id": 6407,
            "lat": 17.315,
            "long": 99.834,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 640702,
            "zip_code": 64110,
            "name_th": "ในเมือง",
            "name_en": "Nai Mueang",
            "district_id": 6407,
            "lat": 17.326,
            "long": 99.878,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 640703,
            "zip_code": 64110,
            "name_th": "คลองกระจง",
            "name_en": "Khlong Krachong",
            "district_id": 6407,
            "lat": 17.239,
            "long": 99.828,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 640704,
            "zip_code": 64110,
            "name_th": "วังพิณพาทย์",
            "name_en": "Wang Phinphat",
            "district_id": 6407,
            "lat": 17.335,
            "long": 99.815,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 640705,
            "zip_code": 64110,
            "name_th": "วังไม้ขอน",
            "name_en": "Wang Mai Khon",
            "district_id": 6407,
            "lat": 17.31,
            "long": 99.807,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 640706,
            "zip_code": 64110,
            "name_th": "ย่านยาว",
            "name_en": "Yan Yao",
            "district_id": 6407,
            "lat": 17.273,
            "long": 99.816,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 640707,
            "zip_code": 64110,
            "name_th": "นาทุ่ง",
            "name_en": "Na Thung",
            "district_id": 6407,
            "lat": 17.311,
            "long": 99.74,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 640708,
            "zip_code": 64110,
            "name_th": "คลองยาง",
            "name_en": "Khlong Yao",
            "district_id": 6407,
            "lat": 17.414,
            "long": 99.915,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 640709,
            "zip_code": 64110,
            "name_th": "เมืองบางยม",
            "name_en": "Mueang Bang Yom",
            "district_id": 6407,
            "lat": 17.214,
            "long": 99.876,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 640710,
            "zip_code": 64110,
            "name_th": "ท่าทอง",
            "name_en": "Tha Thong",
            "district_id": 6407,
            "lat": 17.212,
            "long": 99.85,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 640711,
            "zip_code": 64110,
            "name_th": "ปากน้ำ",
            "name_en": "Pak Nam",
            "district_id": 6407,
            "lat": 17.233,
            "long": 99.925,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 640712,
            "zip_code": 64110,
            "name_th": "ป่ากุมเกาะ",
            "name_en": "Pa Kum Ko",
            "district_id": 6407,
            "lat": 17.365,
            "long": 99.794,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 640713,
            "zip_code": 64110,
            "name_th": "เมืองบางขลัง",
            "name_en": "Mueang Bang Khlang",
            "district_id": 6407,
            "lat": 17.242,
            "long": 99.71,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 640714,
            "zip_code": 64110,
            "name_th": "หนองกลับ",
            "name_en": "Nong Klap",
            "district_id": 6407,
            "lat": 17.245,
            "long": 99.782,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 6408,
        "name_th": "ศรีนคร",
        "name_en": "Si Nakhon",
        "province_id": 51,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 640801,
            "zip_code": 64180,
            "name_th": "ศรีนคร",
            "name_en": "Si Nakhon",
            "district_id": 6408,
            "lat": 17.373,
            "long": 99.98,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 640802,
            "zip_code": 64180,
            "name_th": "นครเดิฐ",
            "name_en": "Nakhon Doet",
            "district_id": 6408,
            "lat": 17.471,
            "long": 99.955,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 640803,
            "zip_code": 64180,
            "name_th": "น้ำขุม",
            "name_en": "Nam Khum",
            "district_id": 6408,
            "lat": 17.412,
            "long": 99.982,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 640804,
            "zip_code": 64180,
            "name_th": "คลองมะพลับ",
            "name_en": "Khlong Maphlap",
            "district_id": 6408,
            "lat": 17.319,
            "long": 99.962,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 640805,
            "zip_code": 64180,
            "name_th": "หนองบัว",
            "name_en": "Nong Bua",
            "district_id": 6408,
            "lat": 17.285,
            "long": 99.958,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 6409,
        "name_th": "ทุ่งเสลี่ยม",
        "name_en": "Thung Saliam",
        "province_id": 51,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 640901,
            "zip_code": 64230,
            "name_th": "บ้านใหม่ไชยมงคล",
            "name_en": "Ban Mai Chai Mongkhon",
            "district_id": 6409,
            "lat": 17.251,
            "long": 99.652,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 640902,
            "zip_code": 64150,
            "name_th": "ไทยชนะศึก",
            "name_en": "Thai Chana Suek",
            "district_id": 6409,
            "lat": 17.376,
            "long": 99.589,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 640903,
            "zip_code": 64150,
            "name_th": "ทุ่งเสลี่ยม",
            "name_en": "Thung Saliam",
            "district_id": 6409,
            "lat": 17.301,
            "long": 99.548,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 640904,
            "zip_code": 64150,
            "name_th": "กลางดง",
            "name_en": "Klang Dong",
            "district_id": 6409,
            "lat": 17.394,
            "long": 99.491,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 640905,
            "zip_code": 64230,
            "name_th": "เขาแก้วศรีสมบูรณ์",
            "name_en": "Khaokaw Si Somboon",
            "district_id": 6409,
            "lat": 17.32,
            "long": 99.643,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      }
    ]
  },
  {
    "id": 52,
    "name_th": "พิษณุโลก",
    "name_en": "Phitsanulok",
    "geography_id": 2,
    "created_at": "2019-08-09T03:33:09.000+07:00",
    "updated_at": "2025-09-20T06:31:26.000+07:00",
    "deleted_at": null,
    "districts": [
      {
        "id": 6501,
        "name_th": "เมืองพิษณุโลก",
        "name_en": "Mueang Phitsanulok",
        "province_id": 52,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 650101,
            "zip_code": 65000,
            "name_th": "ในเมือง",
            "name_en": "Nai Mueang",
            "district_id": 6501,
            "lat": 16.815,
            "long": 100.26,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 650102,
            "zip_code": 65230,
            "name_th": "วังน้ำคู้",
            "name_en": "Wang Nam Khu",
            "district_id": 6501,
            "lat": 16.652,
            "long": 100.269,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 650103,
            "zip_code": 65000,
            "name_th": "วัดจันทร์",
            "name_en": "Wat Chan",
            "district_id": 6501,
            "lat": 16.789,
            "long": 100.25,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 650104,
            "zip_code": 65230,
            "name_th": "วัดพริก",
            "name_en": "Wat Phrik",
            "district_id": 6501,
            "lat": 16.715,
            "long": 100.243,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 650105,
            "zip_code": 65000,
            "name_th": "ท่าทอง",
            "name_en": "Tha Thong",
            "district_id": 6501,
            "lat": 16.798,
            "long": 100.197,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 650106,
            "zip_code": 65000,
            "name_th": "ท่าโพธิ์",
            "name_en": "Tha Pho",
            "district_id": 6501,
            "lat": 16.758,
            "long": 100.195,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 650107,
            "zip_code": 65000,
            "name_th": "สมอแข",
            "name_en": "Samo Khae",
            "district_id": 6501,
            "lat": 16.823,
            "long": 100.325,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 650108,
            "zip_code": 65000,
            "name_th": "ดอนทอง",
            "name_en": "Don Thong",
            "district_id": 6501,
            "lat": 16.884,
            "long": 100.392,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 650109,
            "zip_code": 65000,
            "name_th": "บ้านป่า",
            "name_en": "Ban Pa",
            "district_id": 6501,
            "lat": 16.926,
            "long": 100.368,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 650110,
            "zip_code": 65000,
            "name_th": "ปากโทก",
            "name_en": "Pak Thok",
            "district_id": 6501,
            "lat": 16.905,
            "long": 100.259,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 650111,
            "zip_code": 65000,
            "name_th": "หัวรอ",
            "name_en": "Hua Ro",
            "district_id": 6501,
            "lat": 16.875,
            "long": 100.274,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 650112,
            "zip_code": 65000,
            "name_th": "จอมทอง",
            "name_en": "Chom Thong",
            "district_id": 6501,
            "lat": 16.902,
            "long": 100.215,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 650113,
            "zip_code": 65000,
            "name_th": "บ้านกร่าง",
            "name_en": "Ban Krang",
            "district_id": 6501,
            "lat": 16.855,
            "long": 100.184,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 650114,
            "zip_code": 65000,
            "name_th": "บ้านคลอง",
            "name_en": "Ban Khlong",
            "district_id": 6501,
            "lat": 16.83,
            "long": 100.239,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 650115,
            "zip_code": 65000,
            "name_th": "พลายชุมพล",
            "name_en": "Phlai Chumphon",
            "district_id": 6501,
            "lat": 16.854,
            "long": 100.226,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 650116,
            "zip_code": 65000,
            "name_th": "มะขามสูง",
            "name_en": "Makham Sung",
            "district_id": 6501,
            "lat": 16.929,
            "long": 100.256,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 650117,
            "zip_code": 65000,
            "name_th": "อรัญญิก",
            "name_en": "Aranyik",
            "district_id": 6501,
            "lat": 16.8,
            "long": 100.288,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 650118,
            "zip_code": 65000,
            "name_th": "บึงพระ",
            "name_en": "Bueng Phra",
            "district_id": 6501,
            "lat": 16.749,
            "long": 100.273,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 650119,
            "zip_code": 65000,
            "name_th": "ไผ่ขอดอน",
            "name_en": "Phai Kho Don",
            "district_id": 6501,
            "lat": 16.911,
            "long": 100.158,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 650120,
            "zip_code": 65230,
            "name_th": "งิ้วงาม",
            "name_en": "Ngio Ngam",
            "district_id": 6501,
            "lat": 16.671,
            "long": 100.237,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 6502,
        "name_th": "นครไทย",
        "name_en": "Nakhon Thai",
        "province_id": 52,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 650201,
            "zip_code": 65120,
            "name_th": "นครไทย",
            "name_en": "Nakhon Thai",
            "district_id": 6502,
            "lat": 17.126,
            "long": 100.839,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 650202,
            "zip_code": 65120,
            "name_th": "หนองกะท้าว",
            "name_en": "Nong Kathao",
            "district_id": 6502,
            "lat": 17.096,
            "long": 100.674,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 650203,
            "zip_code": 65120,
            "name_th": "บ้านแยง",
            "name_en": "Ban Yaeng",
            "district_id": 6502,
            "lat": 16.942,
            "long": 100.71,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 650204,
            "zip_code": 65120,
            "name_th": "เนินเพิ่ม",
            "name_en": "Noen Phoem",
            "district_id": 6502,
            "lat": 17.033,
            "long": 100.946,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 650205,
            "zip_code": 65120,
            "name_th": "นาบัว",
            "name_en": "Na Bua",
            "district_id": 6502,
            "lat": 17.203,
            "long": 100.851,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 650206,
            "zip_code": 65120,
            "name_th": "นครชุม",
            "name_en": "Nakhon Chum",
            "district_id": 6502,
            "lat": 17.26,
            "long": 100.806,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 650207,
            "zip_code": 65120,
            "name_th": "น้ำกุ่ม",
            "name_en": "Nam Kum",
            "district_id": 6502,
            "lat": 17.398,
            "long": 100.866,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 650208,
            "zip_code": 65120,
            "name_th": "ยางโกลน",
            "name_en": "Yang Klon",
            "district_id": 6502,
            "lat": 17.207,
            "long": 100.95,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 650209,
            "zip_code": 65120,
            "name_th": "บ่อโพธิ์",
            "name_en": "Bo Pho",
            "district_id": 6502,
            "lat": 17.161,
            "long": 101.017,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 650210,
            "zip_code": 65120,
            "name_th": "บ้านพร้าว",
            "name_en": "Ban Phrao",
            "district_id": 6502,
            "lat": 17.146,
            "long": 100.76,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 650211,
            "zip_code": 65120,
            "name_th": "ห้วยเฮี้ย",
            "name_en": "Huai Hia",
            "district_id": 6502,
            "lat": 16.899,
            "long": 100.923,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 6503,
        "name_th": "ชาติตระการ",
        "name_en": "Chat Trakan",
        "province_id": 52,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 650301,
            "zip_code": 65170,
            "name_th": "ป่าแดง",
            "name_en": "Pa Daeng",
            "district_id": 6503,
            "lat": 17.285,
            "long": 100.561,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 650302,
            "zip_code": 65170,
            "name_th": "ชาติตระการ",
            "name_en": "Chat Trakan",
            "district_id": 6503,
            "lat": 17.32,
            "long": 100.704,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 650303,
            "zip_code": 65170,
            "name_th": "สวนเมี่ยง",
            "name_en": "Suan Miang",
            "district_id": 6503,
            "lat": 17.194,
            "long": 100.529,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 650304,
            "zip_code": 65170,
            "name_th": "บ้านดง",
            "name_en": "Ban Dong",
            "district_id": 6503,
            "lat": 17.361,
            "long": 100.505,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 650305,
            "zip_code": 65170,
            "name_th": "บ่อภาค",
            "name_en": "Bo Phak",
            "district_id": 6503,
            "lat": 17.54,
            "long": 100.817,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 650306,
            "zip_code": 65170,
            "name_th": "ท่าสะแก",
            "name_en": "Tha Sakae",
            "district_id": 6503,
            "lat": 17.241,
            "long": 100.711,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 6504,
        "name_th": "บางระกำ",
        "name_en": "Bang Rakam",
        "province_id": 52,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 650401,
            "zip_code": 65140,
            "name_th": "บางระกำ",
            "name_en": "Bang Rakam",
            "district_id": 6504,
            "lat": 16.738,
            "long": 100.145,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 650402,
            "zip_code": 65140,
            "name_th": "ปลักแรด",
            "name_en": "Plak Raet",
            "district_id": 6504,
            "lat": 16.693,
            "long": 100.094,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 650403,
            "zip_code": 65140,
            "name_th": "พันเสา",
            "name_en": "Phan Sao",
            "district_id": 6504,
            "lat": 16.622,
            "long": 100.064,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 650404,
            "zip_code": 65140,
            "name_th": "วังอิทก",
            "name_en": "Wang Ithok",
            "district_id": 6504,
            "lat": 16.665,
            "long": 100.164,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 650405,
            "zip_code": 65140,
            "name_th": "บึงกอก",
            "name_en": "Bueng Kok",
            "district_id": 6504,
            "lat": 16.7,
            "long": 100.011,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 650406,
            "zip_code": 65140,
            "name_th": "หนองกุลา",
            "name_en": "Nong Kula",
            "district_id": 6504,
            "lat": 16.636,
            "long": 99.96,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 650407,
            "zip_code": 65240,
            "name_th": "ชุมแสงสงคราม",
            "name_en": "Chum Saeng Songkhram",
            "district_id": 6504,
            "lat": 16.76,
            "long": 99.977,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 650408,
            "zip_code": 65140,
            "name_th": "นิคมพัฒนา",
            "name_en": "Nikhom Phatthana",
            "district_id": 6504,
            "lat": 16.741,
            "long": 99.885,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 650409,
            "zip_code": 65140,
            "name_th": "บ่อทอง",
            "name_en": "Bo Thong",
            "district_id": 6504,
            "lat": 16.631,
            "long": 100.134,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 650410,
            "zip_code": 65140,
            "name_th": "ท่านางงาม",
            "name_en": "Tha Nang Ngam",
            "district_id": 6504,
            "lat": 16.81,
            "long": 100.114,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 650411,
            "zip_code": 65240,
            "name_th": "คุยม่วง",
            "name_en": "Khui Muang",
            "district_id": 6504,
            "lat": 16.82,
            "long": 99.962,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 6505,
        "name_th": "บางกระทุ่ม",
        "name_en": "Bang Krathum",
        "province_id": 52,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 650501,
            "zip_code": 65110,
            "name_th": "บางกระทุ่ม",
            "name_en": "Bang Krathum",
            "district_id": 6505,
            "lat": 16.591,
            "long": 100.297,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 650502,
            "zip_code": 65110,
            "name_th": "บ้านไร่",
            "name_en": "Ban Rai",
            "district_id": 6505,
            "lat": 16.62,
            "long": 100.253,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 650503,
            "zip_code": 65110,
            "name_th": "โคกสลุด",
            "name_en": "Khok Salut",
            "district_id": 6505,
            "lat": 16.577,
            "long": 100.245,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 650504,
            "zip_code": 65110,
            "name_th": "สนามคลี",
            "name_en": "Sanam Khli",
            "district_id": 6505,
            "lat": 16.547,
            "long": 100.256,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 650505,
            "zip_code": 65110,
            "name_th": "ท่าตาล",
            "name_en": "Tha Tan",
            "district_id": 6505,
            "lat": 16.658,
            "long": 100.331,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 650506,
            "zip_code": 65110,
            "name_th": "ไผ่ล้อม",
            "name_en": "Phai Lom",
            "district_id": 6505,
            "lat": 16.56,
            "long": 100.347,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 650507,
            "zip_code": 65110,
            "name_th": "นครป่าหมาก",
            "name_en": "Nakhon Pa Mak",
            "district_id": 6505,
            "lat": 16.609,
            "long": 100.351,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 650508,
            "zip_code": 65210,
            "name_th": "เนินกุ่ม",
            "name_en": "Noen Kum",
            "district_id": 6505,
            "lat": 16.541,
            "long": 100.458,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 650509,
            "zip_code": 65210,
            "name_th": "วัดตายม",
            "name_en": "Wat Ta Yom",
            "district_id": 6505,
            "lat": 16.595,
            "long": 100.444,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 6506,
        "name_th": "พรหมพิราม",
        "name_en": "Phrom Phiram",
        "province_id": 52,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 650601,
            "zip_code": 65150,
            "name_th": "พรหมพิราม",
            "name_en": "Phrom Phiram",
            "district_id": 6506,
            "lat": 17.004,
            "long": 100.135,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 650602,
            "zip_code": 65150,
            "name_th": "ท่าช้าง",
            "name_en": "Tha Chang",
            "district_id": 6506,
            "lat": 16.976,
            "long": 100.168,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 650603,
            "zip_code": 65180,
            "name_th": "วงฆ้อง",
            "name_en": "Wong Khong",
            "district_id": 6506,
            "lat": 17.113,
            "long": 100.107,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 650604,
            "zip_code": 65150,
            "name_th": "มะตูม",
            "name_en": "Matum",
            "district_id": 6506,
            "lat": 16.936,
            "long": 100.205,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 650605,
            "zip_code": 65150,
            "name_th": "หอกลอง",
            "name_en": "Ho Klong",
            "district_id": 6506,
            "lat": 16.985,
            "long": 100.251,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 650606,
            "zip_code": 65180,
            "name_th": "ศรีภิรมย์",
            "name_en": "Si Phirom",
            "district_id": 6506,
            "lat": 17.094,
            "long": 100.029,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 650607,
            "zip_code": 65180,
            "name_th": "ตลุกเทียม",
            "name_en": "Taluk Thiam",
            "district_id": 6506,
            "lat": 17.149,
            "long": 100.039,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 650608,
            "zip_code": 65150,
            "name_th": "วังวน",
            "name_en": "Wang Won",
            "district_id": 6506,
            "lat": 17.05,
            "long": 100.029,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 650609,
            "zip_code": 65150,
            "name_th": "หนองแขม",
            "name_en": "Nong Khaem",
            "district_id": 6506,
            "lat": 17.046,
            "long": 100.131,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 650610,
            "zip_code": 65180,
            "name_th": "มะต้อง",
            "name_en": "Matong",
            "district_id": 6506,
            "lat": 17.086,
            "long": 100.166,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 650611,
            "zip_code": 65150,
            "name_th": "ทับยายเชียง",
            "name_en": "Thap Yai Chiang",
            "district_id": 6506,
            "lat": 17.095,
            "long": 100.294,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 650612,
            "zip_code": 65180,
            "name_th": "ดงประคำ",
            "name_en": "Dong Prakham",
            "district_id": 6506,
            "lat": 17.189,
            "long": 100.26,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 6507,
        "name_th": "วัดโบสถ์",
        "name_en": "Wat Bot",
        "province_id": 52,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 650701,
            "zip_code": 65160,
            "name_th": "วัดโบสถ์",
            "name_en": "Wat Bot",
            "district_id": 6507,
            "lat": 17.021,
            "long": 100.306,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 650702,
            "zip_code": 65160,
            "name_th": "ท่างาม",
            "name_en": "Tha Ngam",
            "district_id": 6507,
            "lat": 16.97,
            "long": 100.377,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 650703,
            "zip_code": 65160,
            "name_th": "ท้อแท้",
            "name_en": "Thothae",
            "district_id": 6507,
            "lat": 16.968,
            "long": 100.296,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 650704,
            "zip_code": 65160,
            "name_th": "บ้านยาง",
            "name_en": "Ban Yang",
            "district_id": 6507,
            "lat": 17.089,
            "long": 100.413,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 650705,
            "zip_code": 65160,
            "name_th": "หินลาด",
            "name_en": "Hin Lat",
            "district_id": 6507,
            "lat": 17.168,
            "long": 100.333,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 650706,
            "zip_code": 65160,
            "name_th": "คันโช้ง",
            "name_en": "Khan Chong",
            "district_id": 6507,
            "lat": 17.307,
            "long": 100.298,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 6508,
        "name_th": "วังทอง",
        "name_en": "Wang Thong",
        "province_id": 52,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 650801,
            "zip_code": 65130,
            "name_th": "วังทอง",
            "name_en": "Wang Thong",
            "district_id": 6508,
            "lat": 16.822,
            "long": 100.403,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 650802,
            "zip_code": 65130,
            "name_th": "พันชาลี",
            "name_en": "Phan Chali",
            "district_id": 6508,
            "lat": 16.608,
            "long": 100.523,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 650803,
            "zip_code": 65130,
            "name_th": "แม่ระกา",
            "name_en": "Mae Raka",
            "district_id": 6508,
            "lat": 16.707,
            "long": 100.362,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 650804,
            "zip_code": 65220,
            "name_th": "บ้านกลาง",
            "name_en": "Ban Klang",
            "district_id": 6508,
            "lat": 17.017,
            "long": 100.549,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 650805,
            "zip_code": 65130,
            "name_th": "วังพิกุล",
            "name_en": "Wang Phikun",
            "district_id": 6508,
            "lat": 16.775,
            "long": 100.358,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 650806,
            "zip_code": 65220,
            "name_th": "แก่งโสภา",
            "name_en": "Kaeng Sopha",
            "district_id": 6508,
            "lat": 16.907,
            "long": 100.625,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 650807,
            "zip_code": 65130,
            "name_th": "ท่าหมื่นราม",
            "name_en": "Tha Muen Ram",
            "district_id": 6508,
            "lat": 16.691,
            "long": 100.514,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 650808,
            "zip_code": 65130,
            "name_th": "วังนกแอ่น",
            "name_en": "Wang Nok Aen",
            "district_id": 6508,
            "lat": 16.819,
            "long": 100.582,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 650809,
            "zip_code": 65130,
            "name_th": "หนองพระ",
            "name_en": "Nong Phra",
            "district_id": 6508,
            "lat": 16.681,
            "long": 100.441,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 650810,
            "zip_code": 65130,
            "name_th": "ชัยนาม",
            "name_en": "Chaiyanam",
            "district_id": 6508,
            "lat": 16.839,
            "long": 100.467,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 650811,
            "zip_code": 65130,
            "name_th": "ดินทอง",
            "name_en": "Din Thong",
            "district_id": 6508,
            "lat": 16.767,
            "long": 100.445,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 6509,
        "name_th": "เนินมะปราง",
        "name_en": "Noen Maprang",
        "province_id": 52,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 650901,
            "zip_code": 65190,
            "name_th": "ชมพู",
            "name_en": "Chomphu",
            "district_id": 6509,
            "lat": 16.717,
            "long": 100.641,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 650902,
            "zip_code": 65190,
            "name_th": "บ้านมุง",
            "name_en": "Ban Mung",
            "district_id": 6509,
            "lat": 16.543,
            "long": 100.752,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 650903,
            "zip_code": 65190,
            "name_th": "ไทรย้อย",
            "name_en": "Sai Yoi",
            "district_id": 6509,
            "lat": 16.452,
            "long": 100.634,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 650904,
            "zip_code": 65190,
            "name_th": "วังโพรง",
            "name_en": "Wang Phrong",
            "district_id": 6509,
            "lat": 16.383,
            "long": 100.664,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 650905,
            "zip_code": 65190,
            "name_th": "บ้านน้อยซุ้มขี้เหล็ก",
            "name_en": "Ban Noi Sum Khilek",
            "district_id": 6509,
            "lat": 16.542,
            "long": 100.596,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 650906,
            "zip_code": 65190,
            "name_th": "เนินมะปราง",
            "name_en": "Noen Maprang",
            "district_id": 6509,
            "lat": 16.595,
            "long": 100.626,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 650907,
            "zip_code": 65190,
            "name_th": "วังยาง",
            "name_en": "Wang Yang",
            "district_id": 6509,
            "lat": 16.457,
            "long": 100.741,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 650908,
            "zip_code": 65190,
            "name_th": "โคกแหลม",
            "name_en": "Khok Laem",
            "district_id": 6509,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      }
    ]
  },
  {
    "id": 53,
    "name_th": "พิจิตร",
    "name_en": "Phichit",
    "geography_id": 2,
    "created_at": "2019-08-09T03:33:09.000+07:00",
    "updated_at": "2025-09-20T06:31:26.000+07:00",
    "deleted_at": null,
    "districts": [
      {
        "id": 6601,
        "name_th": "เมืองพิจิตร",
        "name_en": "Mueang Phichit",
        "province_id": 53,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 660101,
            "zip_code": 66000,
            "name_th": "ในเมือง",
            "name_en": "Nai Mueang",
            "district_id": 6601,
            "lat": 16.443,
            "long": 100.343,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 660102,
            "zip_code": 66000,
            "name_th": "ไผ่ขวาง",
            "name_en": "Phai Khwang",
            "district_id": 6601,
            "lat": 16.504,
            "long": 100.303,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 660103,
            "zip_code": 66000,
            "name_th": "ย่านยาว",
            "name_en": "Yan Yao",
            "district_id": 6601,
            "lat": 16.507,
            "long": 100.268,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 660104,
            "zip_code": 66000,
            "name_th": "ท่าฬ่อ",
            "name_en": "Tha Lo",
            "district_id": 6601,
            "lat": 16.51,
            "long": 100.352,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 660105,
            "zip_code": 66000,
            "name_th": "ปากทาง",
            "name_en": "Pak Thang",
            "district_id": 6601,
            "lat": 16.453,
            "long": 100.366,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 660106,
            "zip_code": 66000,
            "name_th": "คลองคะเชนทร์",
            "name_en": "Khlong Khachen",
            "district_id": 6601,
            "lat": 16.458,
            "long": 100.293,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 660107,
            "zip_code": 66000,
            "name_th": "โรงช้าง",
            "name_en": "Rong Chang",
            "district_id": 6601,
            "lat": 16.422,
            "long": 100.259,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 660108,
            "zip_code": 66000,
            "name_th": "เมืองเก่า",
            "name_en": "Mueang Kao",
            "district_id": 6601,
            "lat": 16.393,
            "long": 100.303,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 660109,
            "zip_code": 66000,
            "name_th": "ท่าหลวง",
            "name_en": "Tha Luang",
            "district_id": 6601,
            "lat": 16.419,
            "long": 100.363,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 660110,
            "zip_code": 66000,
            "name_th": "บ้านบุ่ง",
            "name_en": "Ban Bung",
            "district_id": 6601,
            "lat": 16.394,
            "long": 100.427,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 660111,
            "zip_code": 66000,
            "name_th": "ฆะมัง",
            "name_en": "Khamang",
            "district_id": 6601,
            "lat": 16.369,
            "long": 100.373,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 660112,
            "zip_code": 66170,
            "name_th": "ดงป่าคำ",
            "name_en": "Dong Pa Kham",
            "district_id": 6601,
            "lat": 16.295,
            "long": 100.367,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 660113,
            "zip_code": 66170,
            "name_th": "หัวดง",
            "name_en": "Hua Dong",
            "district_id": 6601,
            "lat": 16.332,
            "long": 100.441,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 660115,
            "zip_code": 66000,
            "name_th": "ป่ามะคาบ",
            "name_en": "Pa Makhap",
            "district_id": 6601,
            "lat": 16.501,
            "long": 100.392,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 660119,
            "zip_code": 66000,
            "name_th": "สายคำโห้",
            "name_en": "Sai Kham Ho",
            "district_id": 6601,
            "lat": 16.407,
            "long": 100.486,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 660120,
            "zip_code": 66170,
            "name_th": "ดงกลาง",
            "name_en": "Dong Klang",
            "district_id": 6601,
            "lat": 16.335,
            "long": 100.363,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 6602,
        "name_th": "วังทรายพูน",
        "name_en": "Wang Sai Phun",
        "province_id": 53,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 660201,
            "zip_code": 66180,
            "name_th": "วังทรายพูน",
            "name_en": "Wang Sai Phun",
            "district_id": 6602,
            "lat": 16.383,
            "long": 100.605,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 660202,
            "zip_code": 66180,
            "name_th": "หนองปลาไหล",
            "name_en": "Nong Pla Lai",
            "district_id": 6602,
            "lat": 16.443,
            "long": 100.535,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 660203,
            "zip_code": 66180,
            "name_th": "หนองพระ",
            "name_en": "Nong Phra",
            "district_id": 6602,
            "lat": 16.342,
            "long": 100.566,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 660204,
            "zip_code": 66180,
            "name_th": "หนองปล้อง",
            "name_en": "Nong Plong",
            "district_id": 6602,
            "lat": 16.339,
            "long": 100.504,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 6603,
        "name_th": "โพธิ์ประทับช้าง",
        "name_en": "Pho Prathap Chang",
        "province_id": 53,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 660301,
            "zip_code": 66190,
            "name_th": "โพธิ์ประทับช้าง",
            "name_en": "Pho Prathap Chang",
            "district_id": 6603,
            "lat": 16.323,
            "long": 100.3,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 660302,
            "zip_code": 66190,
            "name_th": "ไผ่ท่าโพ",
            "name_en": "Phai Tha Pho",
            "district_id": 6603,
            "lat": 16.278,
            "long": 100.235,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 660303,
            "zip_code": 66190,
            "name_th": "วังจิก",
            "name_en": "Wang Chik",
            "district_id": 6603,
            "lat": 16.351,
            "long": 100.264,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 660304,
            "zip_code": 66190,
            "name_th": "ไผ่รอบ",
            "name_en": "Phai Rop",
            "district_id": 6603,
            "lat": 16.354,
            "long": 100.152,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 660305,
            "zip_code": 66190,
            "name_th": "ดงเสือเหลือง",
            "name_en": "Dong Suea Lueang",
            "district_id": 6603,
            "lat": 16.27,
            "long": 100.182,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 660306,
            "zip_code": 66190,
            "name_th": "เนินสว่าง",
            "name_en": "Noen Sawang",
            "district_id": 6603,
            "lat": 16.318,
            "long": 100.138,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 660307,
            "zip_code": 66190,
            "name_th": "ทุ่งใหญ่",
            "name_en": "Thung Yai",
            "district_id": 6603,
            "lat": 16.292,
            "long": 100.071,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 6604,
        "name_th": "ตะพานหิน",
        "name_en": "Taphan Hin",
        "province_id": 53,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 660401,
            "zip_code": 66110,
            "name_th": "ตะพานหิน",
            "name_en": "Taphan Hin",
            "district_id": 6604,
            "lat": 16.222,
            "long": 100.427,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 660402,
            "zip_code": 66110,
            "name_th": "งิ้วราย",
            "name_en": "Ngio Rai",
            "district_id": 6604,
            "lat": 16.267,
            "long": 100.427,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 660403,
            "zip_code": 66110,
            "name_th": "ห้วยเกตุ",
            "name_en": "Huai Ket",
            "district_id": 6604,
            "lat": 16.238,
            "long": 100.399,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 660404,
            "zip_code": 66110,
            "name_th": "ไทรโรงโขน",
            "name_en": "Sai Rong Khon",
            "district_id": 6604,
            "lat": 16.168,
            "long": 100.421,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 660405,
            "zip_code": 66110,
            "name_th": "หนองพยอม",
            "name_en": "Nong Phayom",
            "district_id": 6604,
            "lat": 16.235,
            "long": 100.46,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 660406,
            "zip_code": 66150,
            "name_th": "ทุ่งโพธิ์",
            "name_en": "Tung Pho",
            "district_id": 6604,
            "lat": 16.129,
            "long": 100.501,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 660407,
            "zip_code": 66110,
            "name_th": "ดงตะขบ",
            "name_en": "Dong Takhop",
            "district_id": 6604,
            "lat": 16.144,
            "long": 100.467,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 660408,
            "zip_code": 66110,
            "name_th": "คลองคูณ",
            "name_en": "Khlong Khun",
            "district_id": 6604,
            "lat": 16.176,
            "long": 100.395,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 660409,
            "zip_code": 66110,
            "name_th": "วังสำโรง",
            "name_en": "Wang Samrong",
            "district_id": 6604,
            "lat": 16.252,
            "long": 100.308,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 660410,
            "zip_code": 66110,
            "name_th": "วังหว้า",
            "name_en": "Wang Wa",
            "district_id": 6604,
            "lat": 16.207,
            "long": 100.354,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 660411,
            "zip_code": 66150,
            "name_th": "วังหลุม",
            "name_en": "Wang Lum",
            "district_id": 6604,
            "lat": 16.19,
            "long": 100.484,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 660412,
            "zip_code": 66110,
            "name_th": "ทับหมัน",
            "name_en": "Thap Man",
            "district_id": 6604,
            "lat": 16.207,
            "long": 100.277,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 660413,
            "zip_code": 66110,
            "name_th": "ไผ่หลวง",
            "name_en": "Phai Luang",
            "district_id": 6604,
            "lat": 16.193,
            "long": 100.428,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 6605,
        "name_th": "บางมูลนาก",
        "name_en": "Bang Mun Nak",
        "province_id": 53,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 660501,
            "zip_code": 66120,
            "name_th": "บางมูลนาก",
            "name_en": "Bang Mun Nak",
            "district_id": 6605,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 660502,
            "zip_code": 66120,
            "name_th": "บางไผ่",
            "name_en": "Bang Phai",
            "district_id": 6605,
            "lat": 16.123,
            "long": 100.403,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 660503,
            "zip_code": 66120,
            "name_th": "หอไกร",
            "name_en": "Ho Krai",
            "district_id": 6605,
            "lat": 16.068,
            "long": 100.381,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 660504,
            "zip_code": 66120,
            "name_th": "เนินมะกอก",
            "name_en": "Noen Makok",
            "district_id": 6605,
            "lat": 15.991,
            "long": 100.362,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 660505,
            "zip_code": 66120,
            "name_th": "วังสำโรง",
            "name_en": "Wang Samrong",
            "district_id": 6605,
            "lat": 15.968,
            "long": 100.433,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 660506,
            "zip_code": 66120,
            "name_th": "ภูมิ",
            "name_en": "Phum",
            "district_id": 6605,
            "lat": 16.037,
            "long": 100.445,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 660507,
            "zip_code": 66120,
            "name_th": "วังกรด",
            "name_en": "Wang Krot",
            "district_id": 6605,
            "lat": 15.997,
            "long": 100.465,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 660508,
            "zip_code": 66120,
            "name_th": "ห้วยเขน",
            "name_en": "Huai Khen",
            "district_id": 6605,
            "lat": 16.033,
            "long": 100.479,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 660509,
            "zip_code": 66210,
            "name_th": "วังตะกู",
            "name_en": "Wang Taku",
            "district_id": 6605,
            "lat": 16.049,
            "long": 100.514,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 660514,
            "zip_code": 66120,
            "name_th": "ลำประดา",
            "name_en": "Lam Prad",
            "district_id": 6605,
            "lat": 16.082,
            "long": 100.464,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 6606,
        "name_th": "โพทะเล",
        "name_en": "Pho Thale",
        "province_id": 53,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 660601,
            "zip_code": 66130,
            "name_th": "โพทะเล",
            "name_en": "Pho Thale",
            "district_id": 6606,
            "lat": 16.103,
            "long": 100.236,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 660602,
            "zip_code": 66130,
            "name_th": "ท้ายน้ำ",
            "name_en": "Thai Nam",
            "district_id": 6606,
            "lat": 16.147,
            "long": 100.207,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 660603,
            "zip_code": 66130,
            "name_th": "ทะนง",
            "name_en": "Thanong",
            "district_id": 6606,
            "lat": 16.078,
            "long": 100.18,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 660604,
            "zip_code": 66130,
            "name_th": "ท่าบัว",
            "name_en": "Tha Bua",
            "district_id": 6606,
            "lat": 16.059,
            "long": 100.326,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 660605,
            "zip_code": 66130,
            "name_th": "ทุ่งน้อย",
            "name_en": "Thung Noi",
            "district_id": 6606,
            "lat": 16.117,
            "long": 100.315,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 660606,
            "zip_code": 66130,
            "name_th": "ท่าขมิ้น",
            "name_en": "Tha Khamin",
            "district_id": 6606,
            "lat": 16.025,
            "long": 100.2,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 660607,
            "zip_code": 66130,
            "name_th": "ท่าเสา",
            "name_en": "Tha Sao",
            "district_id": 6606,
            "lat": 15.966,
            "long": 100.212,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 660608,
            "zip_code": 66130,
            "name_th": "บางคลาน",
            "name_en": "Bang Khlan",
            "district_id": 6606,
            "lat": 16.001,
            "long": 100.286,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 660611,
            "zip_code": 66130,
            "name_th": "ท่านั่ง",
            "name_en": "Tha Nang",
            "district_id": 6606,
            "lat": 15.963,
            "long": 100.276,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 660612,
            "zip_code": 66130,
            "name_th": "บ้านน้อย",
            "name_en": "Ban Noi",
            "district_id": 6606,
            "lat": 16.043,
            "long": 100.288,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 660613,
            "zip_code": 66130,
            "name_th": "วัดขวาง",
            "name_en": "Wat Khwang",
            "district_id": 6606,
            "lat": 16.16,
            "long": 100.298,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 6607,
        "name_th": "สามง่าม",
        "name_en": "Sam Ngam",
        "province_id": 53,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 660701,
            "zip_code": 66140,
            "name_th": "สามง่าม",
            "name_en": "Sam Ngam",
            "district_id": 6607,
            "lat": 16.498,
            "long": 100.213,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 660702,
            "zip_code": 66140,
            "name_th": "กำแพงดิน",
            "name_en": "Kamphaeng Din",
            "district_id": 6607,
            "lat": 16.585,
            "long": 100.219,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 660703,
            "zip_code": 66140,
            "name_th": "รังนก",
            "name_en": "Rang Nok",
            "district_id": 6607,
            "lat": 16.432,
            "long": 100.212,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 660706,
            "zip_code": 66140,
            "name_th": "เนินปอ",
            "name_en": "Noen Po",
            "district_id": 6607,
            "lat": 16.408,
            "long": 100.136,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 660707,
            "zip_code": 66140,
            "name_th": "หนองโสน",
            "name_en": "Nong Sano",
            "district_id": 6607,
            "lat": 16.389,
            "long": 100.044,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 6608,
        "name_th": "ทับคล้อ",
        "name_en": "Tap Khlo",
        "province_id": 53,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 660801,
            "zip_code": 66150,
            "name_th": "ทับคล้อ",
            "name_en": "Thap Khlo",
            "district_id": 6608,
            "lat": 16.189,
            "long": 100.568,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 660802,
            "zip_code": 66230,
            "name_th": "เขาทราย",
            "name_en": "Khao Sai",
            "district_id": 6608,
            "lat": 16.193,
            "long": 100.637,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 660803,
            "zip_code": 66230,
            "name_th": "เขาเจ็ดลูก",
            "name_en": "Khao Chet Luk",
            "district_id": 6608,
            "lat": 16.274,
            "long": 100.569,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 660804,
            "zip_code": 66150,
            "name_th": "ท้ายทุ่ง",
            "name_en": "Tai Toong",
            "district_id": 6608,
            "lat": 16.086,
            "long": 100.618,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 6609,
        "name_th": "สากเหล็ก",
        "name_en": "Sak Lek",
        "province_id": 53,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 660901,
            "zip_code": 66160,
            "name_th": "สากเหล็ก",
            "name_en": "Sak Lek",
            "district_id": 6609,
            "lat": 16.486,
            "long": 100.461,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 660902,
            "zip_code": 66160,
            "name_th": "ท่าเยี่ยม",
            "name_en": "Tha Yiam",
            "district_id": 6609,
            "lat": 16.522,
            "long": 100.556,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 660903,
            "zip_code": 66160,
            "name_th": "คลองทราย",
            "name_en": "Khlong Sai",
            "district_id": 6609,
            "lat": 16.552,
            "long": 100.559,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 660904,
            "zip_code": 66160,
            "name_th": "หนองหญ้าไทร",
            "name_en": "Nong Ya Sai",
            "district_id": 6609,
            "lat": 16.544,
            "long": 100.527,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 660905,
            "zip_code": 66160,
            "name_th": "วังทับไทร",
            "name_en": "Wang Thap Sai",
            "district_id": 6609,
            "lat": 16.489,
            "long": 100.555,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 6610,
        "name_th": "บึงนาราง",
        "name_en": "Bueng Na Rang",
        "province_id": 53,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 661001,
            "zip_code": 66130,
            "name_th": "ห้วยแก้ว",
            "name_en": "Huai Kaeo",
            "district_id": 6610,
            "lat": 16.162,
            "long": 100.111,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 661002,
            "zip_code": 66130,
            "name_th": "โพธิ์ไทรงาม",
            "name_en": "Pho Sai Ngam",
            "district_id": 6610,
            "lat": 16.121,
            "long": 100.147,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 661003,
            "zip_code": 66130,
            "name_th": "แหลมรัง",
            "name_en": "Laem Rang",
            "district_id": 6610,
            "lat": 16.225,
            "long": 100.073,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 661004,
            "zip_code": 66130,
            "name_th": "บางลาย",
            "name_en": "Bang Lai",
            "district_id": 6610,
            "lat": 16.208,
            "long": 100.231,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 661005,
            "zip_code": 66130,
            "name_th": "บึงนาราง",
            "name_en": "Bueng Na Rang",
            "district_id": 6610,
            "lat": 16.205,
            "long": 100.163,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 6611,
        "name_th": "ดงเจริญ",
        "name_en": "Dong Charoen",
        "province_id": 53,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 661101,
            "zip_code": 66210,
            "name_th": "วังงิ้วใต้",
            "name_en": "Wang Ngio Tai",
            "district_id": 6611,
            "lat": 16.028,
            "long": 100.648,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 661102,
            "zip_code": 66210,
            "name_th": "วังงิ้ว",
            "name_en": "Wang Ngio",
            "district_id": 6611,
            "lat": 16.0,
            "long": 100.741,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 661103,
            "zip_code": 66210,
            "name_th": "ห้วยร่วม",
            "name_en": "Huai Ruam",
            "district_id": 6611,
            "lat": 15.972,
            "long": 100.536,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 661104,
            "zip_code": 66210,
            "name_th": "ห้วยพุก",
            "name_en": "Huai Phuk",
            "district_id": 6611,
            "lat": 16.004,
            "long": 100.609,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 661105,
            "zip_code": 66210,
            "name_th": "สำนักขุนเณร",
            "name_en": "Samnak Khun Nen",
            "district_id": 6611,
            "lat": 16.042,
            "long": 100.568,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 6612,
        "name_th": "วชิรบารมี",
        "name_en": "Wachirabarami",
        "province_id": 53,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 661201,
            "zip_code": 66140,
            "name_th": "บ้านนา",
            "name_en": "Ban Na",
            "district_id": 6612,
            "lat": 16.495,
            "long": 100.128,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 661202,
            "zip_code": 66140,
            "name_th": "บึงบัว",
            "name_en": "Bueng Bua",
            "district_id": 6612,
            "lat": 16.484,
            "long": 100.053,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 661203,
            "zip_code": 66140,
            "name_th": "วังโมกข์",
            "name_en": "Wang Mok",
            "district_id": 6612,
            "lat": 16.563,
            "long": 100.091,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 661204,
            "zip_code": 66220,
            "name_th": "หนองหลุม",
            "name_en": "Nong Lum",
            "district_id": 6612,
            "lat": 16.597,
            "long": 100.114,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      }
    ]
  },
  {
    "id": 54,
    "name_th": "เพชรบูรณ์",
    "name_en": "Phetchabun",
    "geography_id": 2,
    "created_at": "2019-08-09T03:33:09.000+07:00",
    "updated_at": "2025-09-20T06:31:26.000+07:00",
    "deleted_at": null,
    "districts": [
      {
        "id": 6701,
        "name_th": "เมืองเพชรบูรณ์",
        "name_en": "Mueang Phetchabun",
        "province_id": 54,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 670101,
            "zip_code": 67000,
            "name_th": "ในเมือง",
            "name_en": "Nai Mueang",
            "district_id": 6701,
            "lat": 16.42,
            "long": 101.156,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 670102,
            "zip_code": 67000,
            "name_th": "ตะเบาะ",
            "name_en": "Tabo",
            "district_id": 6701,
            "lat": 16.322,
            "long": 101.299,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 670103,
            "zip_code": 67000,
            "name_th": "บ้านโตก",
            "name_en": "Ban Tok",
            "district_id": 6701,
            "lat": 16.347,
            "long": 101.056,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 670104,
            "zip_code": 67000,
            "name_th": "สะเดียง",
            "name_en": "Sadiang",
            "district_id": 6701,
            "lat": 16.396,
            "long": 101.164,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 670105,
            "zip_code": 67000,
            "name_th": "ป่าเลา",
            "name_en": "Pa Lao",
            "district_id": 6701,
            "lat": 16.449,
            "long": 100.972,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 670106,
            "zip_code": 67000,
            "name_th": "นางั่ว",
            "name_en": "Na Ngua",
            "district_id": 6701,
            "lat": 16.507,
            "long": 101.146,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 670107,
            "zip_code": 67250,
            "name_th": "ท่าพล",
            "name_en": "Tha Phon",
            "district_id": 6701,
            "lat": 16.59,
            "long": 101.134,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 670108,
            "zip_code": 67000,
            "name_th": "ดงมูลเหล็ก",
            "name_en": "Dong Mun Lek",
            "district_id": 6701,
            "lat": 16.478,
            "long": 101.203,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 670109,
            "zip_code": 67000,
            "name_th": "บ้านโคก",
            "name_en": "Ban Khok",
            "district_id": 6701,
            "lat": 16.471,
            "long": 101.25,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 670110,
            "zip_code": 67000,
            "name_th": "ชอนไพร",
            "name_en": "Chon Phrai",
            "district_id": 6701,
            "lat": 16.341,
            "long": 101.153,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 670111,
            "zip_code": 67000,
            "name_th": "นาป่า",
            "name_en": "Na Pa",
            "district_id": 6701,
            "lat": 16.39,
            "long": 101.218,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 670112,
            "zip_code": 67210,
            "name_th": "นายม",
            "name_en": "Na Yom",
            "district_id": 6701,
            "lat": 16.229,
            "long": 101.23,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 670113,
            "zip_code": 67210,
            "name_th": "วังชมภู",
            "name_en": "Wang Chomphu",
            "district_id": 6701,
            "lat": 16.266,
            "long": 101.027,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 670114,
            "zip_code": 67000,
            "name_th": "น้ำร้อน",
            "name_en": "Nam Ron",
            "district_id": 6701,
            "lat": 16.322,
            "long": 101.187,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 670115,
            "zip_code": 67210,
            "name_th": "ห้วยสะแก",
            "name_en": "Huai Sakae",
            "district_id": 6701,
            "lat": 16.191,
            "long": 101.067,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 670116,
            "zip_code": 67000,
            "name_th": "ห้วยใหญ่",
            "name_en": "Huai Yai",
            "district_id": 6701,
            "lat": 16.505,
            "long": 101.383,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 670117,
            "zip_code": 67210,
            "name_th": "ระวิง",
            "name_en": "Rawing",
            "district_id": 6701,
            "lat": 16.146,
            "long": 101.138,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 6702,
        "name_th": "ชนแดน",
        "name_en": "Chon Daen",
        "province_id": 54,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 670201,
            "zip_code": 67150,
            "name_th": "ชนแดน",
            "name_en": "Chon Daen",
            "district_id": 6702,
            "lat": 16.158,
            "long": 100.895,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 670202,
            "zip_code": 67190,
            "name_th": "ดงขุย",
            "name_en": "Dong Khui",
            "district_id": 6702,
            "lat": 16.131,
            "long": 100.677,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 670203,
            "zip_code": 67150,
            "name_th": "ท่าข้าม",
            "name_en": "Tha Kham",
            "district_id": 6702,
            "lat": 16.204,
            "long": 100.792,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 670204,
            "zip_code": 67150,
            "name_th": "พุทธบาท",
            "name_en": "Phutthabat",
            "district_id": 6702,
            "lat": 16.271,
            "long": 100.892,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 670205,
            "zip_code": 67150,
            "name_th": "ลาดแค",
            "name_en": "Lat Khae",
            "district_id": 6702,
            "lat": 15.983,
            "long": 100.839,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 670206,
            "zip_code": 67190,
            "name_th": "บ้านกล้วย",
            "name_en": "Ban Kluai",
            "district_id": 6702,
            "lat": 16.05,
            "long": 100.744,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 670208,
            "zip_code": 67150,
            "name_th": "ซับพุทรา",
            "name_en": "Sap Phutsa",
            "district_id": 6702,
            "lat": 16.035,
            "long": 100.928,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 670209,
            "zip_code": 67190,
            "name_th": "ตะกุดไร",
            "name_en": "Takut Rai",
            "district_id": 6702,
            "lat": 16.18,
            "long": 100.726,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 670210,
            "zip_code": 67150,
            "name_th": "ศาลาลาย",
            "name_en": "Sala Lai",
            "district_id": 6702,
            "lat": 16.092,
            "long": 100.832,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 6703,
        "name_th": "หล่มสัก",
        "name_en": "Lom Sak",
        "province_id": 54,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 670301,
            "zip_code": 67110,
            "name_th": "หล่มสัก",
            "name_en": "Lom Sak",
            "district_id": 6703,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 670302,
            "zip_code": 67110,
            "name_th": "วัดป่า",
            "name_en": "Wat Pa",
            "district_id": 6703,
            "lat": 16.795,
            "long": 101.234,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 670303,
            "zip_code": 67110,
            "name_th": "ตาลเดี่ยว",
            "name_en": "Tan Diao",
            "district_id": 6703,
            "lat": 16.785,
            "long": 101.248,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 670304,
            "zip_code": 67110,
            "name_th": "ฝายนาแซง",
            "name_en": "Fai Na Saeng",
            "district_id": 6703,
            "lat": 16.811,
            "long": 101.206,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 670305,
            "zip_code": 67110,
            "name_th": "หนองสว่าง",
            "name_en": "Nong Sawang",
            "district_id": 6703,
            "lat": 16.839,
            "long": 101.239,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 670306,
            "zip_code": 67110,
            "name_th": "น้ำเฮี้ย",
            "name_en": "Nam Hia",
            "district_id": 6703,
            "lat": 16.83,
            "long": 101.206,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 670307,
            "zip_code": 67110,
            "name_th": "สักหลง",
            "name_en": "Sak Long",
            "district_id": 6703,
            "lat": 16.844,
            "long": 101.275,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 670308,
            "zip_code": 67110,
            "name_th": "ท่าอิบุญ",
            "name_en": "Tha Ibun",
            "district_id": 6703,
            "lat": 16.889,
            "long": 101.346,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 670309,
            "zip_code": 67110,
            "name_th": "บ้านโสก",
            "name_en": "Ban Sok",
            "district_id": 6703,
            "lat": 16.803,
            "long": 101.284,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 670310,
            "zip_code": 67110,
            "name_th": "บ้านติ้ว",
            "name_en": "Ban Tio",
            "district_id": 6703,
            "lat": 16.782,
            "long": 101.357,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 670311,
            "zip_code": 67110,
            "name_th": "ห้วยไร่",
            "name_en": "Huai Rai",
            "district_id": 6703,
            "lat": 16.825,
            "long": 101.319,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 670312,
            "zip_code": 67110,
            "name_th": "น้ำก้อ",
            "name_en": "Nam Ko",
            "district_id": 6703,
            "lat": 16.794,
            "long": 101.158,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 670313,
            "zip_code": 67110,
            "name_th": "ปากช่อง",
            "name_en": "Pak Chong",
            "district_id": 6703,
            "lat": 16.708,
            "long": 101.304,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 670314,
            "zip_code": 67110,
            "name_th": "น้ำชุน",
            "name_en": "Nam Chun",
            "district_id": 6703,
            "lat": 16.739,
            "long": 101.143,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 670315,
            "zip_code": 67110,
            "name_th": "หนองไขว่",
            "name_en": "Nong Khwai",
            "district_id": 6703,
            "lat": 16.757,
            "long": 101.22,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 670316,
            "zip_code": 67110,
            "name_th": "ลานบ่า",
            "name_en": "Lan Ba",
            "district_id": 6703,
            "lat": 16.68,
            "long": 101.208,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 670317,
            "zip_code": 67110,
            "name_th": "บุ่งคล้า",
            "name_en": "Bung Khla",
            "district_id": 6703,
            "lat": 16.629,
            "long": 101.178,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 670318,
            "zip_code": 67110,
            "name_th": "บุ่งน้ำเต้า",
            "name_en": "Bung Namtao",
            "district_id": 6703,
            "lat": 16.677,
            "long": 101.146,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 670319,
            "zip_code": 67110,
            "name_th": "บ้านกลาง",
            "name_en": "Ban Klang",
            "district_id": 6703,
            "lat": 16.642,
            "long": 101.298,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 670320,
            "zip_code": 67110,
            "name_th": "ช้างตะลูด",
            "name_en": "Chang Talut",
            "district_id": 6703,
            "lat": 16.581,
            "long": 101.324,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 670321,
            "zip_code": 67110,
            "name_th": "บ้านไร่",
            "name_en": "Ban Rai",
            "district_id": 6703,
            "lat": 16.608,
            "long": 101.212,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 670322,
            "zip_code": 67110,
            "name_th": "ปากดุก",
            "name_en": "Pak Duk",
            "district_id": 6703,
            "lat": 16.72,
            "long": 101.249,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 670323,
            "zip_code": 67110,
            "name_th": "บ้านหวาย",
            "name_en": "Ban Wai",
            "district_id": 6703,
            "lat": 16.759,
            "long": 101.293,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 6704,
        "name_th": "หล่มเก่า",
        "name_en": "Lom Kao",
        "province_id": 54,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 670401,
            "zip_code": 67120,
            "name_th": "หล่มเก่า",
            "name_en": "Lom Kao",
            "district_id": 6704,
            "lat": 16.893,
            "long": 101.242,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 670402,
            "zip_code": 67120,
            "name_th": "นาซำ",
            "name_en": "Na Sam",
            "district_id": 6704,
            "lat": 17.026,
            "long": 101.217,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 670403,
            "zip_code": 67120,
            "name_th": "หินฮาว",
            "name_en": "Hin Hao",
            "district_id": 6704,
            "lat": 16.951,
            "long": 101.215,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 670404,
            "zip_code": 67120,
            "name_th": "บ้านเนิน",
            "name_en": "Ban Noen",
            "district_id": 6704,
            "lat": 16.857,
            "long": 101.095,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 670405,
            "zip_code": 67120,
            "name_th": "ศิลา",
            "name_en": "Sila",
            "district_id": 6704,
            "lat": 17.108,
            "long": 101.407,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 670406,
            "zip_code": 67120,
            "name_th": "นาแซง",
            "name_en": "Na Saeng",
            "district_id": 6704,
            "lat": 16.857,
            "long": 101.229,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 670407,
            "zip_code": 67120,
            "name_th": "วังบาล",
            "name_en": "Wang Ban",
            "district_id": 6704,
            "lat": 16.929,
            "long": 101.156,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 670408,
            "zip_code": 67120,
            "name_th": "นาเกาะ",
            "name_en": "Na Ko",
            "district_id": 6704,
            "lat": 16.832,
            "long": 101.176,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 670409,
            "zip_code": 67120,
            "name_th": "ตาดกลอย",
            "name_en": "Tat Kloi",
            "district_id": 6704,
            "lat": 16.998,
            "long": 101.402,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 6705,
        "name_th": "วิเชียรบุรี",
        "name_en": "Wichian Buri",
        "province_id": 54,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 670501,
            "zip_code": 67130,
            "name_th": "ท่าโรง",
            "name_en": "Tha Rong",
            "district_id": 6705,
            "lat": 15.66,
            "long": 101.141,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 670502,
            "zip_code": 67130,
            "name_th": "สระประดู่",
            "name_en": "Sa Pradu",
            "district_id": 6705,
            "lat": 15.628,
            "long": 101.061,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 670503,
            "zip_code": 67130,
            "name_th": "สามแยก",
            "name_en": "Sam Yaek",
            "district_id": 6705,
            "lat": 15.709,
            "long": 101.029,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 670504,
            "zip_code": 67130,
            "name_th": "โคกปรง",
            "name_en": "Khok Prong",
            "district_id": 6705,
            "lat": 15.814,
            "long": 101.227,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 670505,
            "zip_code": 67130,
            "name_th": "น้ำร้อน",
            "name_en": "Nam Ron",
            "district_id": 6705,
            "lat": 15.687,
            "long": 101.306,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 670506,
            "zip_code": 67130,
            "name_th": "บ่อรัง",
            "name_en": "Bo Rang",
            "district_id": 6705,
            "lat": 15.608,
            "long": 101.217,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 670507,
            "zip_code": 67180,
            "name_th": "พุเตย",
            "name_en": "Phu Toei",
            "district_id": 6705,
            "lat": 15.586,
            "long": 101.018,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 670508,
            "zip_code": 67180,
            "name_th": "พุขาม",
            "name_en": "Phu Kham",
            "district_id": 6705,
            "lat": 15.529,
            "long": 101.044,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 670509,
            "zip_code": 67180,
            "name_th": "ภูน้ำหยด",
            "name_en": "Phu Nam Yot",
            "district_id": 6705,
            "lat": 15.53,
            "long": 100.92,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 670510,
            "zip_code": 67180,
            "name_th": "ซับสมบูรณ์",
            "name_en": "Sap Sombun",
            "district_id": 6705,
            "lat": 15.669,
            "long": 100.983,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 670511,
            "zip_code": 67130,
            "name_th": "บึงกระจับ",
            "name_en": "Bueng Krachap",
            "district_id": 6705,
            "lat": 15.744,
            "long": 101.095,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 670512,
            "zip_code": 67180,
            "name_th": "วังใหญ่",
            "name_en": "Wang Yai",
            "district_id": 6705,
            "lat": 15.607,
            "long": 100.949,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 670513,
            "zip_code": 67130,
            "name_th": "ยางสาว",
            "name_en": "Yang Sao",
            "district_id": 6705,
            "lat": 15.755,
            "long": 101.216,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 670514,
            "zip_code": 67180,
            "name_th": "ซับน้อย",
            "name_en": "Sap Noi",
            "district_id": 6705,
            "lat": 15.657,
            "long": 100.858,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 6706,
        "name_th": "ศรีเทพ",
        "name_en": "Si Thep",
        "province_id": 54,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 670601,
            "zip_code": 67170,
            "name_th": "ศรีเทพ",
            "name_en": "Si Thep",
            "district_id": 6706,
            "lat": 15.439,
            "long": 101.14,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 670602,
            "zip_code": 67170,
            "name_th": "สระกรวด",
            "name_en": "Sa Kruat",
            "district_id": 6706,
            "lat": 15.42,
            "long": 101.07,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 670603,
            "zip_code": 67170,
            "name_th": "คลองกระจัง",
            "name_en": "Khlong Krachang",
            "district_id": 6706,
            "lat": 15.37,
            "long": 101.164,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 670604,
            "zip_code": 67170,
            "name_th": "นาสนุ่น",
            "name_en": "Na Sanun",
            "district_id": 6706,
            "lat": 15.527,
            "long": 101.136,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 670605,
            "zip_code": 67170,
            "name_th": "โคกสะอาด",
            "name_en": "Khok Sa-at",
            "district_id": 6706,
            "lat": 15.477,
            "long": 100.971,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 670606,
            "zip_code": 67170,
            "name_th": "หนองย่างทอย",
            "name_en": "Nong Yang Thoi",
            "district_id": 6706,
            "lat": 15.402,
            "long": 101.252,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 670607,
            "zip_code": 67170,
            "name_th": "ประดู่งาม",
            "name_en": "Pradu Ngam",
            "district_id": 6706,
            "lat": 15.436,
            "long": 100.971,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 6707,
        "name_th": "หนองไผ่",
        "name_en": "Nong Phai",
        "province_id": 54,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 670701,
            "zip_code": 67140,
            "name_th": "กองทูล",
            "name_en": "Kong Thun",
            "district_id": 6707,
            "lat": 15.956,
            "long": 101.103,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 670702,
            "zip_code": 67220,
            "name_th": "นาเฉลียง",
            "name_en": "Na Chaliang",
            "district_id": 6707,
            "lat": 16.075,
            "long": 101.084,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 670703,
            "zip_code": 67140,
            "name_th": "บ้านโภชน์",
            "name_en": "Ban Phot",
            "district_id": 6707,
            "lat": 15.933,
            "long": 100.928,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 670704,
            "zip_code": 67140,
            "name_th": "ท่าแดง",
            "name_en": "Tha Daeng",
            "district_id": 6707,
            "lat": 15.957,
            "long": 101.183,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 670705,
            "zip_code": 67140,
            "name_th": "เพชรละคร",
            "name_en": "Phet Lakhon",
            "district_id": 6707,
            "lat": 15.897,
            "long": 101.154,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 670706,
            "zip_code": 67140,
            "name_th": "บ่อไทย",
            "name_en": "Bo Thai",
            "district_id": 6707,
            "lat": 16.129,
            "long": 101.276,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 670707,
            "zip_code": 67220,
            "name_th": "ห้วยโป่ง",
            "name_en": "Huai Pong",
            "district_id": 6707,
            "lat": 16.141,
            "long": 101.034,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 670708,
            "zip_code": 67140,
            "name_th": "วังท่าดี",
            "name_en": "Wang Tha Di",
            "district_id": 6707,
            "lat": 15.995,
            "long": 101.223,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 670709,
            "zip_code": 67140,
            "name_th": "บัววัฒนา",
            "name_en": "Bua Watthana",
            "district_id": 6707,
            "lat": 15.953,
            "long": 101.034,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 670710,
            "zip_code": 67140,
            "name_th": "หนองไผ่",
            "name_en": "Nong Phai",
            "district_id": 6707,
            "lat": 16.004,
            "long": 101.037,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 670711,
            "zip_code": 67140,
            "name_th": "วังโบสถ์",
            "name_en": "Wang Bot",
            "district_id": 6707,
            "lat": 16.057,
            "long": 101.147,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 670712,
            "zip_code": 67220,
            "name_th": "ยางงาม",
            "name_en": "Yang Ngam",
            "district_id": 6707,
            "lat": 16.101,
            "long": 100.951,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 670713,
            "zip_code": 67140,
            "name_th": "ท่าด้วง",
            "name_en": "Tha Duang",
            "district_id": 6707,
            "lat": 16.001,
            "long": 101.301,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 6708,
        "name_th": "บึงสามพัน",
        "name_en": "Bueng Sam Phan",
        "province_id": 54,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 670801,
            "zip_code": 67160,
            "name_th": "ซับสมอทอด",
            "name_en": "Sap Samo Thot",
            "district_id": 6708,
            "lat": 15.846,
            "long": 100.939,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 670802,
            "zip_code": 67160,
            "name_th": "ซับไม้แดง",
            "name_en": "Sap Mai Daeng",
            "district_id": 6708,
            "lat": 15.788,
            "long": 100.922,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 670803,
            "zip_code": 67160,
            "name_th": "หนองแจง",
            "name_en": "Nong Chaeng",
            "district_id": 6708,
            "lat": 15.877,
            "long": 100.985,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 670804,
            "zip_code": 67160,
            "name_th": "กันจุ",
            "name_en": "Kan Chu",
            "district_id": 6708,
            "lat": 15.817,
            "long": 101.075,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 670805,
            "zip_code": 67230,
            "name_th": "วังพิกุล",
            "name_en": "Wang Phikun",
            "district_id": 6708,
            "lat": 15.747,
            "long": 100.861,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 670806,
            "zip_code": 67160,
            "name_th": "พญาวัง",
            "name_en": "Phaya Wang",
            "district_id": 6708,
            "lat": 15.88,
            "long": 100.847,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 670807,
            "zip_code": 67160,
            "name_th": "ศรีมงคล",
            "name_en": "Si Mongkhon",
            "district_id": 6708,
            "lat": 15.82,
            "long": 100.835,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 670808,
            "zip_code": 67160,
            "name_th": "สระแก้ว",
            "name_en": "Sa Kaeo",
            "district_id": 6708,
            "lat": 15.894,
            "long": 101.324,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 670809,
            "zip_code": 67160,
            "name_th": "บึงสามพัน",
            "name_en": "Bueng Sam Phan",
            "district_id": 6708,
            "lat": 15.791,
            "long": 101.022,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 6709,
        "name_th": "น้ำหนาว",
        "name_en": "Nam Nao",
        "province_id": 54,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 670901,
            "zip_code": 67260,
            "name_th": "น้ำหนาว",
            "name_en": "Nam Nao",
            "district_id": 6709,
            "lat": 16.764,
            "long": 101.681,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 670902,
            "zip_code": 67260,
            "name_th": "หลักด่าน",
            "name_en": "Lak Dan",
            "district_id": 6709,
            "lat": 16.937,
            "long": 101.477,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 670903,
            "zip_code": 67260,
            "name_th": "วังกวาง",
            "name_en": "Wang Kwang",
            "district_id": 6709,
            "lat": 16.936,
            "long": 101.595,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 670904,
            "zip_code": 67260,
            "name_th": "โคกมน",
            "name_en": "Khok Mon",
            "district_id": 6709,
            "lat": 16.709,
            "long": 101.71,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 6710,
        "name_th": "วังโป่ง",
        "name_en": "Wang Pong",
        "province_id": 54,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 671001,
            "zip_code": 67240,
            "name_th": "วังโป่ง",
            "name_en": "Wang Pong",
            "district_id": 6710,
            "lat": 16.347,
            "long": 100.809,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 671002,
            "zip_code": 67240,
            "name_th": "ท้ายดง",
            "name_en": "Thai Dong",
            "district_id": 6710,
            "lat": 16.297,
            "long": 100.678,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 671003,
            "zip_code": 67240,
            "name_th": "ซับเปิบ",
            "name_en": "Sap Poep",
            "district_id": 6710,
            "lat": 16.362,
            "long": 100.918,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 671004,
            "zip_code": 67240,
            "name_th": "วังหิน",
            "name_en": "Wang Hin",
            "district_id": 6710,
            "lat": 16.387,
            "long": 100.754,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 671005,
            "zip_code": 67240,
            "name_th": "วังศาล",
            "name_en": "Wang San",
            "district_id": 6710,
            "lat": 16.283,
            "long": 100.758,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 6711,
        "name_th": "เขาค้อ",
        "name_en": "Khao Kho",
        "province_id": 54,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 671101,
            "zip_code": 67270,
            "name_th": "ทุ่งสมอ",
            "name_en": "Khao Kho",
            "district_id": 6711,
            "lat": 16.717,
            "long": 100.962,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 671102,
            "zip_code": 67280,
            "name_th": "แคมป์สน",
            "name_en": "Khaem Son",
            "district_id": 6711,
            "lat": 16.78,
            "long": 101.055,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 671103,
            "zip_code": 67270,
            "name_th": "เขาค้อ",
            "name_en": "Thung Samo",
            "district_id": 6711,
            "lat": 16.631,
            "long": 100.999,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 671104,
            "zip_code": 67270,
            "name_th": "ริมสีม่วง",
            "name_en": "Rim Si Muang",
            "district_id": 6711,
            "lat": 16.52,
            "long": 101.042,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 671105,
            "zip_code": 67270,
            "name_th": "สะเดาะพง",
            "name_en": "Sado Phong",
            "district_id": 6711,
            "lat": 16.545,
            "long": 100.968,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 671106,
            "zip_code": 67270,
            "name_th": "หนองแม่นา",
            "name_en": "Nong Mae Na",
            "district_id": 6711,
            "lat": 16.578,
            "long": 100.898,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 671107,
            "zip_code": 67280,
            "name_th": "เข็กน้อย",
            "name_en": "Khek Noi",
            "district_id": 6711,
            "lat": 16.832,
            "long": 101.015,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      }
    ]
  },
  {
    "id": 55,
    "name_th": "ราชบุรี",
    "name_en": "Ratchaburi",
    "geography_id": 4,
    "created_at": "2019-08-09T03:33:09.000+07:00",
    "updated_at": "2025-09-20T06:31:26.000+07:00",
    "deleted_at": null,
    "districts": [
      {
        "id": 7001,
        "name_th": "เมืองราชบุรี",
        "name_en": "Mueang Ratchaburi",
        "province_id": 55,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 700101,
            "zip_code": 70000,
            "name_th": "หน้าเมือง",
            "name_en": "Na Mueang",
            "district_id": 7001,
            "lat": 13.535,
            "long": 99.82,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 700102,
            "zip_code": 70000,
            "name_th": "เจดีย์หัก",
            "name_en": "Chedi Hak",
            "district_id": 7001,
            "lat": 13.539,
            "long": 99.781,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 700103,
            "zip_code": 70000,
            "name_th": "ดอนตะโก",
            "name_en": "Don Tako",
            "district_id": 7001,
            "lat": 13.509,
            "long": 99.792,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 700104,
            "zip_code": 70000,
            "name_th": "หนองกลางนา",
            "name_en": "Nong Klang Na",
            "district_id": 7001,
            "lat": 13.593,
            "long": 99.796,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 700105,
            "zip_code": 70000,
            "name_th": "ห้วยไผ่",
            "name_en": "Huai Phai",
            "district_id": 7001,
            "lat": 13.51,
            "long": 99.745,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 700106,
            "zip_code": 70000,
            "name_th": "คุ้งน้ำวน",
            "name_en": "Khung Nam Won",
            "district_id": 7001,
            "lat": 13.508,
            "long": 99.898,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 700107,
            "zip_code": 70000,
            "name_th": "คุ้งกระถิน",
            "name_en": "Khung Krathin",
            "district_id": 7001,
            "lat": 13.504,
            "long": 99.876,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 700108,
            "zip_code": 70000,
            "name_th": "อ่างทอง",
            "name_en": "Ang Thong",
            "district_id": 7001,
            "lat": 13.465,
            "long": 99.787,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 700109,
            "zip_code": 70000,
            "name_th": "โคกหม้อ",
            "name_en": "Khok Mo",
            "district_id": 7001,
            "lat": 13.571,
            "long": 99.834,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 700110,
            "zip_code": 70000,
            "name_th": "สามเรือน",
            "name_en": "Sam Ruean",
            "district_id": 7001,
            "lat": 13.603,
            "long": 99.86,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 700111,
            "zip_code": 70000,
            "name_th": "พิกุลทอง",
            "name_en": "Phikun Thong",
            "district_id": 7001,
            "lat": 13.575,
            "long": 99.866,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 700112,
            "zip_code": 70000,
            "name_th": "น้ำพุ",
            "name_en": "Nam Phu",
            "district_id": 7001,
            "lat": 13.547,
            "long": 99.631,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 700113,
            "zip_code": 70000,
            "name_th": "ดอนแร่",
            "name_en": "Don Rae",
            "district_id": 7001,
            "lat": 13.471,
            "long": 99.758,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 700114,
            "zip_code": 70000,
            "name_th": "หินกอง",
            "name_en": "Hin Kong",
            "district_id": 7001,
            "lat": 13.565,
            "long": 99.705,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 700115,
            "zip_code": 70000,
            "name_th": "เขาแร้ง",
            "name_en": "Khao Raeng",
            "district_id": 7001,
            "lat": 13.622,
            "long": 99.773,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 700116,
            "zip_code": 70000,
            "name_th": "เกาะพลับพลา",
            "name_en": "Ko Phlapphla",
            "district_id": 7001,
            "lat": 13.585,
            "long": 99.75,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 700117,
            "zip_code": 70000,
            "name_th": "หลุมดิน",
            "name_en": "Lum Din",
            "district_id": 7001,
            "lat": 13.571,
            "long": 99.808,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 700118,
            "zip_code": 70000,
            "name_th": "บางป่า",
            "name_en": "Bang Pa",
            "district_id": 7001,
            "lat": 13.553,
            "long": 99.886,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 700119,
            "zip_code": 70000,
            "name_th": "พงสวาย",
            "name_en": "Phong Sawai",
            "district_id": 7001,
            "lat": 13.545,
            "long": 99.848,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 700120,
            "zip_code": 70000,
            "name_th": "คูบัว",
            "name_en": "Khu Bua",
            "district_id": 7001,
            "lat": 13.48,
            "long": 99.822,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 700121,
            "zip_code": 70000,
            "name_th": "ท่าราบ",
            "name_en": "Tha Rap",
            "district_id": 7001,
            "lat": 13.602,
            "long": 99.819,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 700122,
            "zip_code": 70000,
            "name_th": "บ้านไร่",
            "name_en": "Ban Rai",
            "district_id": 7001,
            "lat": 13.511,
            "long": 99.845,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 7002,
        "name_th": "จอมบึง",
        "name_en": "Chom Bueng",
        "province_id": 55,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 700201,
            "zip_code": 70150,
            "name_th": "จอมบึง",
            "name_en": "Chom Bueng",
            "district_id": 7002,
            "lat": 13.622,
            "long": 99.606,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 700202,
            "zip_code": 70150,
            "name_th": "ปากช่อง",
            "name_en": "Pak Chong",
            "district_id": 7002,
            "lat": 13.667,
            "long": 99.649,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 700203,
            "zip_code": 70150,
            "name_th": "เบิกไพร",
            "name_en": "Boek Phrai",
            "district_id": 7002,
            "lat": 13.685,
            "long": 99.521,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 700204,
            "zip_code": 70150,
            "name_th": "ด่านทับตะโก",
            "name_en": "Dan Thap Tako",
            "district_id": 7002,
            "lat": 13.663,
            "long": 99.426,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 700205,
            "zip_code": 70150,
            "name_th": "แก้มอ้น",
            "name_en": "Kaem On",
            "district_id": 7002,
            "lat": 13.74,
            "long": 99.428,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 700206,
            "zip_code": 70150,
            "name_th": "รางบัว",
            "name_en": "Rang Bua",
            "district_id": 7002,
            "lat": 13.533,
            "long": 99.533,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 7003,
        "name_th": "สวนผึ้ง",
        "name_en": "Suan Phueng",
        "province_id": 55,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 700301,
            "zip_code": 70180,
            "name_th": "สวนผึ้ง",
            "name_en": "Suan Phueng",
            "district_id": 7003,
            "lat": 13.612,
            "long": 99.249,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 700302,
            "zip_code": 70180,
            "name_th": "ป่าหวาย",
            "name_en": "Pa Wai",
            "district_id": 7003,
            "lat": 13.578,
            "long": 99.423,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 700304,
            "zip_code": 70180,
            "name_th": "ท่าเคย",
            "name_en": "Tha Khoei",
            "district_id": 7003,
            "lat": 13.522,
            "long": 99.42,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 700307,
            "zip_code": 70180,
            "name_th": "ตะนาวศรี",
            "name_en": "Tanao Si",
            "district_id": 7003,
            "lat": 13.418,
            "long": 99.273,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 7004,
        "name_th": "ดำเนินสะดวก",
        "name_en": "Damnoen Saduak",
        "province_id": 55,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 700401,
            "zip_code": 70130,
            "name_th": "ดำเนินสะดวก",
            "name_en": "Damnoen Saduak",
            "district_id": 7004,
            "lat": 13.517,
            "long": 99.949,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 700402,
            "zip_code": 70210,
            "name_th": "ประสาทสิทธิ์",
            "name_en": "Prasat Sit",
            "district_id": 7004,
            "lat": 13.555,
            "long": 100.036,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 700403,
            "zip_code": 70130,
            "name_th": "ศรีสุราษฎร์",
            "name_en": "Si Surat",
            "district_id": 7004,
            "lat": 13.533,
            "long": 99.984,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 700404,
            "zip_code": 70130,
            "name_th": "ตาหลวง",
            "name_en": "Ta Luang",
            "district_id": 7004,
            "lat": 13.504,
            "long": 99.953,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 700405,
            "zip_code": 70130,
            "name_th": "ดอนกรวย",
            "name_en": "Don Kruai",
            "district_id": 7004,
            "lat": 13.58,
            "long": 99.971,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 700406,
            "zip_code": 70130,
            "name_th": "ดอนคลัง",
            "name_en": "Don Khlang",
            "district_id": 7004,
            "lat": 13.619,
            "long": 99.974,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 700407,
            "zip_code": 70210,
            "name_th": "บัวงาม",
            "name_en": "Bua Ngam",
            "district_id": 7004,
            "lat": 13.608,
            "long": 100.016,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 700408,
            "zip_code": 70130,
            "name_th": "บ้านไร่",
            "name_en": "Ban Rai",
            "district_id": 7004,
            "lat": 13.606,
            "long": 99.909,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 700409,
            "zip_code": 70130,
            "name_th": "แพงพวย",
            "name_en": "Phaengphuai",
            "district_id": 7004,
            "lat": 13.571,
            "long": 99.925,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 700410,
            "zip_code": 70130,
            "name_th": "สี่หมื่น",
            "name_en": "Si Muen",
            "district_id": 7004,
            "lat": 13.522,
            "long": 99.929,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 700411,
            "zip_code": 70130,
            "name_th": "ท่านัด",
            "name_en": "Tha Nat",
            "district_id": 7004,
            "lat": 13.544,
            "long": 99.96,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 700412,
            "zip_code": 70130,
            "name_th": "ขุนพิทักษ์",
            "name_en": "Khun Phithak",
            "district_id": 7004,
            "lat": 13.509,
            "long": 99.982,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 700413,
            "zip_code": 70130,
            "name_th": "ดอนไผ่",
            "name_en": "Don Phai",
            "district_id": 7004,
            "lat": 13.551,
            "long": 100.009,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 7005,
        "name_th": "บ้านโป่ง",
        "name_en": "Ban Pong",
        "province_id": 55,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 700501,
            "zip_code": 70110,
            "name_th": "บ้านโป่ง",
            "name_en": "Ban Pong",
            "district_id": 7005,
            "lat": 13.816,
            "long": 99.873,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 700502,
            "zip_code": 70110,
            "name_th": "ท่าผา",
            "name_en": "Tha Pha",
            "district_id": 7005,
            "lat": 13.865,
            "long": 99.865,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 700503,
            "zip_code": 70190,
            "name_th": "กรับใหญ่",
            "name_en": "Krap Yai",
            "district_id": 7005,
            "lat": 13.908,
            "long": 99.868,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 700504,
            "zip_code": 70110,
            "name_th": "ปากแรต",
            "name_en": "Pak Raet",
            "district_id": 7005,
            "lat": 13.833,
            "long": 99.89,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 700505,
            "zip_code": 70110,
            "name_th": "หนองกบ",
            "name_en": "Nong Kop",
            "district_id": 7005,
            "lat": 13.821,
            "long": 99.934,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 700506,
            "zip_code": 70110,
            "name_th": "หนองอ้อ",
            "name_en": "Nong O",
            "district_id": 7005,
            "lat": 13.793,
            "long": 99.906,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 700507,
            "zip_code": 70110,
            "name_th": "ดอนกระเบื้อง",
            "name_en": "Don Krabueang",
            "district_id": 7005,
            "lat": 13.769,
            "long": 99.891,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 700508,
            "zip_code": 70110,
            "name_th": "สวนกล้วย",
            "name_en": "Suan Kluai",
            "district_id": 7005,
            "lat": 13.798,
            "long": 99.882,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 700509,
            "zip_code": 70110,
            "name_th": "นครชุมน์",
            "name_en": "Nakhon Chum",
            "district_id": 7005,
            "lat": 13.773,
            "long": 99.863,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 700510,
            "zip_code": 70110,
            "name_th": "บ้านม่วง",
            "name_en": "Ban Muang",
            "district_id": 7005,
            "lat": 13.771,
            "long": 99.815,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 700511,
            "zip_code": 70110,
            "name_th": "คุ้งพยอม",
            "name_en": "Khung Phayom",
            "district_id": 7005,
            "lat": 13.797,
            "long": 99.83,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 700512,
            "zip_code": 70110,
            "name_th": "หนองปลาหมอ",
            "name_en": "Nong Pla Mo",
            "district_id": 7005,
            "lat": 13.794,
            "long": 99.776,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 700513,
            "zip_code": 70110,
            "name_th": "เขาขลุง",
            "name_en": "Khao Khlung",
            "district_id": 7005,
            "lat": 13.798,
            "long": 99.728,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 700514,
            "zip_code": 70110,
            "name_th": "เบิกไพร",
            "name_en": "Boek Phrai",
            "district_id": 7005,
            "lat": 13.819,
            "long": 99.851,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 700515,
            "zip_code": 70110,
            "name_th": "ลาดบัวขาว",
            "name_en": "Lat Bua Khao",
            "district_id": 7005,
            "lat": 13.841,
            "long": 99.831,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 7006,
        "name_th": "บางแพ",
        "name_en": "Bang Phae",
        "province_id": 55,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 700601,
            "zip_code": 70160,
            "name_th": "บางแพ",
            "name_en": "Bang Phae",
            "district_id": 7006,
            "lat": 13.691,
            "long": 99.951,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 700602,
            "zip_code": 70160,
            "name_th": "วังเย็น",
            "name_en": "Wang Yen",
            "district_id": 7006,
            "lat": 13.705,
            "long": 99.909,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 700603,
            "zip_code": 70160,
            "name_th": "หัวโพ",
            "name_en": "Hua Pho",
            "district_id": 7006,
            "lat": 13.654,
            "long": 99.978,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 700604,
            "zip_code": 70160,
            "name_th": "วัดแก้ว",
            "name_en": "Wat Kaeo",
            "district_id": 7006,
            "lat": 13.657,
            "long": 99.918,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 700605,
            "zip_code": 70160,
            "name_th": "ดอนใหญ่",
            "name_en": "Don Yai",
            "district_id": 7006,
            "lat": 13.709,
            "long": 100.002,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 700606,
            "zip_code": 70160,
            "name_th": "ดอนคา",
            "name_en": "Don Kha",
            "district_id": 7006,
            "lat": 13.668,
            "long": 100.006,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 700607,
            "zip_code": 70160,
            "name_th": "โพหัก",
            "name_en": "Pho Hak",
            "district_id": 7006,
            "lat": 13.64,
            "long": 100.043,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 7007,
        "name_th": "โพธาราม",
        "name_en": "Photharam",
        "province_id": 55,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 700701,
            "zip_code": 70120,
            "name_th": "โพธาราม",
            "name_en": "Photharam",
            "district_id": 7007,
            "lat": 13.695,
            "long": 99.853,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 700702,
            "zip_code": 70120,
            "name_th": "ดอนกระเบื้อง",
            "name_en": "Don Krabueang",
            "district_id": 7007,
            "lat": 13.752,
            "long": 99.899,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 700703,
            "zip_code": 70120,
            "name_th": "หนองโพ",
            "name_en": "Nong Pho",
            "district_id": 7007,
            "lat": 13.741,
            "long": 99.924,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 700704,
            "zip_code": 70120,
            "name_th": "บ้านเลือก",
            "name_en": "Ban Lueak",
            "district_id": 7007,
            "lat": 13.725,
            "long": 99.886,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 700705,
            "zip_code": 70120,
            "name_th": "คลองตาคต",
            "name_en": "Khlong Ta Khot",
            "district_id": 7007,
            "lat": 13.672,
            "long": 99.854,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 700706,
            "zip_code": 70120,
            "name_th": "บ้านฆ้อง",
            "name_en": "Ban Khong",
            "district_id": 7007,
            "lat": 13.681,
            "long": 99.888,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 700707,
            "zip_code": 70120,
            "name_th": "บ้านสิงห์",
            "name_en": "Ban Sing",
            "district_id": 7007,
            "lat": 13.636,
            "long": 99.895,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 700708,
            "zip_code": 70120,
            "name_th": "ดอนทราย",
            "name_en": "Don Sai",
            "district_id": 7007,
            "lat": 13.632,
            "long": 99.858,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 700709,
            "zip_code": 70120,
            "name_th": "เจ็ดเสมียน",
            "name_en": "Chet Samian",
            "district_id": 7007,
            "lat": 13.638,
            "long": 99.828,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 700710,
            "zip_code": 70120,
            "name_th": "คลองข่อย",
            "name_en": "Khlong Khoi",
            "district_id": 7007,
            "lat": 13.675,
            "long": 99.827,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 700711,
            "zip_code": 70120,
            "name_th": "ชำแระ",
            "name_en": "Chamrae",
            "district_id": 7007,
            "lat": 13.738,
            "long": 99.809,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 700712,
            "zip_code": 70120,
            "name_th": "สร้อยฟ้า",
            "name_en": "Soi Fa",
            "district_id": 7007,
            "lat": 13.721,
            "long": 99.835,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 700713,
            "zip_code": 70120,
            "name_th": "ท่าชุมพล",
            "name_en": "Tha Chumphon",
            "district_id": 7007,
            "lat": 13.691,
            "long": 99.802,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 700714,
            "zip_code": 70120,
            "name_th": "บางโตนด",
            "name_en": "Bang Tanot",
            "district_id": 7007,
            "lat": 13.653,
            "long": 99.796,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 700715,
            "zip_code": 70120,
            "name_th": "เตาปูน",
            "name_en": "Tao Pun",
            "district_id": 7007,
            "lat": 13.749,
            "long": 99.742,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 700716,
            "zip_code": 70120,
            "name_th": "นางแก้ว",
            "name_en": "Nang Kaeo",
            "district_id": 7007,
            "lat": 13.697,
            "long": 99.768,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 700717,
            "zip_code": 70120,
            "name_th": "ธรรมเสน",
            "name_en": "Thammasen",
            "district_id": 7007,
            "lat": 13.669,
            "long": 99.726,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 700718,
            "zip_code": 70120,
            "name_th": "เขาชะงุ้ม",
            "name_en": "Khao Cha-ngum",
            "district_id": 7007,
            "lat": 13.726,
            "long": 99.7,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 700719,
            "zip_code": 70120,
            "name_th": "หนองกวาง",
            "name_en": "Nong Kwang",
            "district_id": 7007,
            "lat": 13.747,
            "long": 99.597,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 7008,
        "name_th": "ปากท่อ",
        "name_en": "Pak Tho",
        "province_id": 55,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 700801,
            "zip_code": 70140,
            "name_th": "ทุ่งหลวง",
            "name_en": "Thung Luang",
            "district_id": 7008,
            "lat": 13.411,
            "long": 99.683,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 700802,
            "zip_code": 70140,
            "name_th": "วังมะนาว",
            "name_en": "Wang Manao",
            "district_id": 7008,
            "lat": 13.341,
            "long": 99.802,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 700803,
            "zip_code": 70140,
            "name_th": "ดอนทราย",
            "name_en": "Don Sai",
            "district_id": 7008,
            "lat": 13.368,
            "long": 99.776,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 700804,
            "zip_code": 70140,
            "name_th": "หนองกระทุ่ม",
            "name_en": "Nong Krathum",
            "district_id": 7008,
            "lat": 13.404,
            "long": 99.779,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 700805,
            "zip_code": 70140,
            "name_th": "ปากท่อ",
            "name_en": "Pak Tho",
            "district_id": 7008,
            "lat": 13.382,
            "long": 99.841,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 700806,
            "zip_code": 70140,
            "name_th": "ป่าไก่",
            "name_en": "Pa Kai",
            "district_id": 7008,
            "lat": 13.412,
            "long": 99.827,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 700807,
            "zip_code": 70140,
            "name_th": "วัดยางงาม",
            "name_en": "Wat Yang Ngam",
            "district_id": 7008,
            "lat": 13.399,
            "long": 99.864,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 700808,
            "zip_code": 70140,
            "name_th": "อ่างหิน",
            "name_en": "Ang Hin",
            "district_id": 7008,
            "lat": 13.46,
            "long": 99.626,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 700809,
            "zip_code": 70140,
            "name_th": "บ่อกระดาน",
            "name_en": "Bo Kradan",
            "district_id": 7008,
            "lat": 13.438,
            "long": 99.801,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 700810,
            "zip_code": 70140,
            "name_th": "ยางหัก",
            "name_en": "Yang Hak",
            "district_id": 7008,
            "lat": 13.283,
            "long": 99.596,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 700811,
            "zip_code": 70140,
            "name_th": "วันดาว",
            "name_en": "Wan Dao",
            "district_id": 7008,
            "lat": 13.354,
            "long": 99.856,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 700812,
            "zip_code": 70140,
            "name_th": "ห้วยยางโทน",
            "name_en": "Huai Yang Thon",
            "district_id": 7008,
            "lat": 13.345,
            "long": 99.693,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 7009,
        "name_th": "วัดเพลง",
        "name_en": "Wat Phleng",
        "province_id": 55,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 700901,
            "zip_code": 70170,
            "name_th": "เกาะศาลพระ",
            "name_en": "Ko San Phra",
            "district_id": 7009,
            "lat": 13.473,
            "long": 99.86,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 700902,
            "zip_code": 70170,
            "name_th": "จอมประทัด",
            "name_en": "Chom Prathat",
            "district_id": 7009,
            "lat": 13.424,
            "long": 99.863,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 700903,
            "zip_code": 70170,
            "name_th": "วัดเพลง",
            "name_en": "Wat Pleng",
            "district_id": 7009,
            "lat": 13.449,
            "long": 99.872,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 7010,
        "name_th": "บ้านคา",
        "name_en": "Ban Kha",
        "province_id": 55,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 701001,
            "zip_code": 70180,
            "name_th": "บ้านคา",
            "name_en": "Ban Kha",
            "district_id": 7010,
            "lat": 13.418,
            "long": 99.386,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 701002,
            "zip_code": 70180,
            "name_th": "บ้านบึง",
            "name_en": "Ban Bueng",
            "district_id": 7010,
            "lat": 13.283,
            "long": 99.444,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 701003,
            "zip_code": 70180,
            "name_th": "หนองพันจันทร์",
            "name_en": "Nong Phan Chan",
            "district_id": 7010,
            "lat": 13.448,
            "long": 99.462,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 7074,
        "name_th": "ท้องถิ่นเทศบาลตำบลบ้านฆ้อง",
        "name_en": "Tet Saban Ban Kong",
        "province_id": 55,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": []
      }
    ]
  },
  {
    "id": 56,
    "name_th": "กาญจนบุรี",
    "name_en": "Kanchanaburi",
    "geography_id": 4,
    "created_at": "2019-08-09T03:33:09.000+07:00",
    "updated_at": "2025-09-20T06:31:26.000+07:00",
    "deleted_at": null,
    "districts": [
      {
        "id": 7101,
        "name_th": "เมืองกาญจนบุรี",
        "name_en": "Mueang Kanchanaburi",
        "province_id": 56,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 710101,
            "zip_code": 71000,
            "name_th": "บ้านเหนือ",
            "name_en": "Ban Nuea",
            "district_id": 7101,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 710102,
            "zip_code": 71000,
            "name_th": "บ้านใต้",
            "name_en": "Ban Tai",
            "district_id": 7101,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 710103,
            "zip_code": 71000,
            "name_th": "ปากแพรก",
            "name_en": "Pak Phraek",
            "district_id": 7101,
            "lat": 14.039,
            "long": 99.551,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 710104,
            "zip_code": 71000,
            "name_th": "ท่ามะขาม",
            "name_en": "Tha Makham",
            "district_id": 7101,
            "lat": 14.035,
            "long": 99.503,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 710105,
            "zip_code": 71000,
            "name_th": "แก่งเสี้ยน",
            "name_en": "Kaeng Sian",
            "district_id": 7101,
            "lat": 14.103,
            "long": 99.501,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 710106,
            "zip_code": 71190,
            "name_th": "หนองบัว",
            "name_en": "Nong Bua",
            "district_id": 7101,
            "lat": 14.05,
            "long": 99.417,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 710107,
            "zip_code": 71190,
            "name_th": "ลาดหญ้า",
            "name_en": "Lat Ya",
            "district_id": 7101,
            "lat": 14.138,
            "long": 99.419,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 710108,
            "zip_code": 71190,
            "name_th": "วังด้ง",
            "name_en": "Wang Dong",
            "district_id": 7101,
            "lat": 14.151,
            "long": 99.306,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 710109,
            "zip_code": 71190,
            "name_th": "ช่องสะเดา",
            "name_en": "Chong Sadao",
            "district_id": 7101,
            "lat": 14.228,
            "long": 99.187,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 710110,
            "zip_code": 71000,
            "name_th": "หนองหญ้า",
            "name_en": "Nong Ya",
            "district_id": 7101,
            "lat": 13.981,
            "long": 99.451,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 710111,
            "zip_code": 71000,
            "name_th": "เกาะสำโรง",
            "name_en": "Ko Samrong",
            "district_id": 7101,
            "lat": 13.951,
            "long": 99.52,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 710113,
            "zip_code": 71000,
            "name_th": "บ้านเก่า",
            "name_en": "Ban Kao",
            "district_id": 7101,
            "lat": 13.981,
            "long": 99.305,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 710116,
            "zip_code": 71000,
            "name_th": "วังเย็น",
            "name_en": "Wang Yen",
            "district_id": 7101,
            "lat": 13.954,
            "long": 99.4,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 7102,
        "name_th": "ไทรโยค",
        "name_en": "Sai Yok",
        "province_id": 56,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 710201,
            "zip_code": 71150,
            "name_th": "ลุ่มสุ่ม",
            "name_en": "Lum Sum",
            "district_id": 7102,
            "lat": 14.104,
            "long": 99.133,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 710202,
            "zip_code": 71150,
            "name_th": "ท่าเสา",
            "name_en": "Tha Sao",
            "district_id": 7102,
            "lat": 14.303,
            "long": 99.037,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 710203,
            "zip_code": 71150,
            "name_th": "สิงห์",
            "name_en": "Sing",
            "district_id": 7102,
            "lat": 14.035,
            "long": 99.287,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 710204,
            "zip_code": 71150,
            "name_th": "ไทรโยค",
            "name_en": "Sai Yok",
            "district_id": 7102,
            "lat": 14.421,
            "long": 98.741,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 710205,
            "zip_code": 71150,
            "name_th": "วังกระแจะ",
            "name_en": "Wang Krachae",
            "district_id": 7102,
            "lat": 14.26,
            "long": 98.911,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 710206,
            "zip_code": 71150,
            "name_th": "ศรีมงคล",
            "name_en": "Si Mongkhon",
            "district_id": 7102,
            "lat": 13.992,
            "long": 99.139,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 710207,
            "zip_code": 71150,
            "name_th": "บ้องตี้",
            "name_en": "Bongti",
            "district_id": 7102,
            "lat": 14.134,
            "long": 98.916,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 7103,
        "name_th": "บ่อพลอย",
        "name_en": "Bo Phloi",
        "province_id": 56,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 710301,
            "zip_code": 71160,
            "name_th": "บ่อพลอย",
            "name_en": "Bo Phloi",
            "district_id": 7103,
            "lat": 14.305,
            "long": 99.466,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 710302,
            "zip_code": 71160,
            "name_th": "หนองกุ่ม",
            "name_en": "Nong Kum",
            "district_id": 7103,
            "lat": 14.205,
            "long": 99.462,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 710303,
            "zip_code": 71220,
            "name_th": "หนองรี",
            "name_en": "Nong Ri",
            "district_id": 7103,
            "lat": 14.54,
            "long": 99.356,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 710305,
            "zip_code": 71160,
            "name_th": "หลุมรัง",
            "name_en": "Lum Rang",
            "district_id": 7103,
            "lat": 14.485,
            "long": 99.481,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 710308,
            "zip_code": 71160,
            "name_th": "ช่องด่าน",
            "name_en": "Chong Dan",
            "district_id": 7103,
            "lat": 14.412,
            "long": 99.437,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 710309,
            "zip_code": 71220,
            "name_th": "หนองกร่าง",
            "name_en": "Nong Krang",
            "district_id": 7103,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 7104,
        "name_th": "ศรีสวัสดิ์",
        "name_en": "Si Sawat",
        "province_id": 56,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 710401,
            "zip_code": 71250,
            "name_th": "นาสวน",
            "name_en": "Na Suan",
            "district_id": 7104,
            "lat": 14.895,
            "long": 99.029,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 710402,
            "zip_code": 71250,
            "name_th": "ด่านแม่แฉลบ",
            "name_en": "Dan Mae Chalaep",
            "district_id": 7104,
            "lat": 14.691,
            "long": 98.98,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 710403,
            "zip_code": 71250,
            "name_th": "หนองเป็ด",
            "name_en": "Nong Pet",
            "district_id": 7104,
            "lat": 14.464,
            "long": 99.232,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 710404,
            "zip_code": 71250,
            "name_th": "ท่ากระดาน",
            "name_en": "Tha Kradan",
            "district_id": 7104,
            "lat": 14.366,
            "long": 99.174,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 710405,
            "zip_code": 71220,
            "name_th": "เขาโจด",
            "name_en": "Khao Chot",
            "district_id": 7104,
            "lat": 14.885,
            "long": 99.183,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 710406,
            "zip_code": 71250,
            "name_th": "แม่กระบุง",
            "name_en": "Mae Krabung",
            "district_id": 7104,
            "lat": 14.527,
            "long": 98.996,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 7105,
        "name_th": "ท่ามะกา",
        "name_en": "Tha Maka",
        "province_id": 56,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 710501,
            "zip_code": 71120,
            "name_th": "พงตึก",
            "name_en": "Phong Tuek",
            "district_id": 7105,
            "lat": 13.869,
            "long": 99.776,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 710502,
            "zip_code": 71120,
            "name_th": "ยางม่วง",
            "name_en": "Yang Muang",
            "district_id": 7105,
            "lat": 13.921,
            "long": 99.834,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 710503,
            "zip_code": 71130,
            "name_th": "ดอนชะเอม",
            "name_en": "Don Cha-em",
            "district_id": 7105,
            "lat": 13.971,
            "long": 99.807,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 710504,
            "zip_code": 71120,
            "name_th": "ท่าไม้",
            "name_en": "Tha Mai",
            "district_id": 7105,
            "lat": 13.906,
            "long": 99.801,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 710505,
            "zip_code": 71130,
            "name_th": "ตะคร้ำเอน",
            "name_en": "Takhram En",
            "district_id": 7105,
            "lat": 13.992,
            "long": 99.744,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 710506,
            "zip_code": 71120,
            "name_th": "ท่ามะกา",
            "name_en": "Tha Maka",
            "district_id": 7105,
            "lat": 13.93,
            "long": 99.779,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 710507,
            "zip_code": 71130,
            "name_th": "ท่าเรือ",
            "name_en": "Tha Ruea",
            "district_id": 7105,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 710508,
            "zip_code": 71120,
            "name_th": "โคกตะบอง",
            "name_en": "Khok Tabong",
            "district_id": 7105,
            "lat": 13.839,
            "long": 99.746,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 710509,
            "zip_code": 71120,
            "name_th": "ดอนขมิ้น",
            "name_en": "Don Khamin",
            "district_id": 7105,
            "lat": 13.884,
            "long": 99.826,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 710510,
            "zip_code": 71130,
            "name_th": "อุโลกสี่หมื่น",
            "name_en": "Ulok Si Muen",
            "district_id": 7105,
            "lat": 14.06,
            "long": 99.773,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 710511,
            "zip_code": 71120,
            "name_th": "เขาสามสิบหาบ",
            "name_en": "Khao Samsip Hap",
            "district_id": 7105,
            "lat": 13.865,
            "long": 99.719,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 710512,
            "zip_code": 71130,
            "name_th": "พระแท่น",
            "name_en": "Phra Thaen",
            "district_id": 7105,
            "lat": 14.018,
            "long": 99.792,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 710513,
            "zip_code": 71120,
            "name_th": "หวายเหนียว",
            "name_en": "Wai Niao",
            "district_id": 7105,
            "lat": 13.902,
            "long": 99.759,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 710514,
            "zip_code": 71130,
            "name_th": "แสนตอ",
            "name_en": "Saen To",
            "district_id": 7105,
            "lat": 13.922,
            "long": 99.732,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 710515,
            "zip_code": 70190,
            "name_th": "สนามแย้",
            "name_en": "Sanam Yae",
            "district_id": 7105,
            "lat": 13.954,
            "long": 99.851,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 710516,
            "zip_code": 71120,
            "name_th": "ท่าเสา",
            "name_en": "Tha Sao",
            "district_id": 7105,
            "lat": 13.843,
            "long": 99.805,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 710517,
            "zip_code": 71130,
            "name_th": "หนองลาน",
            "name_en": "Nong Lan",
            "district_id": 7105,
            "lat": 14.037,
            "long": 99.827,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 7106,
        "name_th": "ท่าม่วง",
        "name_en": "Tha Muang",
        "province_id": 56,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 710601,
            "zip_code": 71110,
            "name_th": "ท่าม่วง",
            "name_en": "Tha Muang",
            "district_id": 7106,
            "lat": 13.974,
            "long": 99.625,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 710602,
            "zip_code": 71110,
            "name_th": "วังขนาย",
            "name_en": "Wang Khanai",
            "district_id": 7106,
            "lat": 13.96,
            "long": 99.663,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 710603,
            "zip_code": 71110,
            "name_th": "วังศาลา",
            "name_en": "Wang Sala",
            "district_id": 7106,
            "lat": 13.971,
            "long": 99.697,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 710604,
            "zip_code": 71110,
            "name_th": "ท่าล้อ",
            "name_en": "Tha Lo",
            "district_id": 7106,
            "lat": 13.987,
            "long": 99.589,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 710605,
            "zip_code": 71110,
            "name_th": "หนองขาว",
            "name_en": "Nong Khao",
            "district_id": 7106,
            "lat": 14.055,
            "long": 99.613,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 710606,
            "zip_code": 71110,
            "name_th": "ทุ่งทอง",
            "name_en": "Thung Thong",
            "district_id": 7106,
            "lat": 14.008,
            "long": 99.666,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 710607,
            "zip_code": 71110,
            "name_th": "เขาน้อย",
            "name_en": "Khao Noi",
            "district_id": 7106,
            "lat": 13.919,
            "long": 99.588,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 710608,
            "zip_code": 71110,
            "name_th": "ม่วงชุม",
            "name_en": "Muang Chum",
            "district_id": 7106,
            "lat": 13.937,
            "long": 99.617,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 710609,
            "zip_code": 71110,
            "name_th": "บ้านใหม่",
            "name_en": "Ban Mai",
            "district_id": 7106,
            "lat": 13.868,
            "long": 99.604,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 710610,
            "zip_code": 71110,
            "name_th": "พังตรุ",
            "name_en": "Phang Tru",
            "district_id": 7106,
            "lat": 13.863,
            "long": 99.645,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 710611,
            "zip_code": 71130,
            "name_th": "ท่าตะคร้อ",
            "name_en": "Tha Takhro",
            "district_id": 7106,
            "lat": 13.917,
            "long": 99.699,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 710612,
            "zip_code": 71110,
            "name_th": "รางสาลี่",
            "name_en": "Rang Sali",
            "district_id": 7106,
            "lat": 13.866,
            "long": 99.543,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 710613,
            "zip_code": 71110,
            "name_th": "หนองตากยา",
            "name_en": "Nong Tak Ya",
            "district_id": 7106,
            "lat": 13.795,
            "long": 99.546,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 7107,
        "name_th": "ทองผาภูมิ",
        "name_en": "Pha Phum",
        "province_id": 56,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 710701,
            "zip_code": 71180,
            "name_th": "ท่าขนุน",
            "name_en": "Tha Khanun",
            "district_id": 7107,
            "lat": 14.762,
            "long": 98.641,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 710702,
            "zip_code": 71180,
            "name_th": "ปิล๊อก",
            "name_en": "Pilok",
            "district_id": 7107,
            "lat": 14.779,
            "long": 98.403,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 710703,
            "zip_code": 71180,
            "name_th": "หินดาด",
            "name_en": "Hin Dat",
            "district_id": 7107,
            "lat": 14.608,
            "long": 98.723,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 710704,
            "zip_code": 71180,
            "name_th": "ลิ่นถิ่น",
            "name_en": "Linthin",
            "district_id": 7107,
            "lat": 14.584,
            "long": 98.833,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 710705,
            "zip_code": 71180,
            "name_th": "ชะแล",
            "name_en": "Chalae",
            "district_id": 7107,
            "lat": 14.996,
            "long": 98.833,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 710706,
            "zip_code": 71180,
            "name_th": "ห้วยเขย่ง",
            "name_en": "Huai Khayeng",
            "district_id": 7107,
            "lat": 14.635,
            "long": 98.583,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 710707,
            "zip_code": 71180,
            "name_th": "สหกรณ์นิคม",
            "name_en": "Sahakon Nikhom",
            "district_id": 7107,
            "lat": 14.735,
            "long": 98.763,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 7108,
        "name_th": "สังขละบุรี",
        "name_en": "Sangkhla Buri",
        "province_id": 56,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 710801,
            "zip_code": 71240,
            "name_th": "หนองลู",
            "name_en": "Nong Lu",
            "district_id": 7108,
            "lat": 15.112,
            "long": 98.341,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 710802,
            "zip_code": 71240,
            "name_th": "ปรังเผล",
            "name_en": "Prangphle",
            "district_id": 7108,
            "lat": 14.999,
            "long": 98.545,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 710803,
            "zip_code": 71240,
            "name_th": "ไล่โว่",
            "name_en": "Lai Wo",
            "district_id": 7108,
            "lat": 15.345,
            "long": 98.664,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 7109,
        "name_th": "พนมทวน",
        "name_en": "Phanom Thuan",
        "province_id": 56,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 710901,
            "zip_code": 71140,
            "name_th": "พนมทวน",
            "name_en": "Phanom Thuan",
            "district_id": 7109,
            "lat": 14.129,
            "long": 99.705,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 710902,
            "zip_code": 71140,
            "name_th": "หนองโรง",
            "name_en": "Nong Rong",
            "district_id": 7109,
            "lat": 14.162,
            "long": 99.622,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 710903,
            "zip_code": 71140,
            "name_th": "ทุ่งสมอ",
            "name_en": "Thung Samo",
            "district_id": 7109,
            "lat": 14.076,
            "long": 99.667,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 710904,
            "zip_code": 71140,
            "name_th": "ดอนเจดีย์",
            "name_en": "Don Chedi",
            "district_id": 7109,
            "lat": 14.036,
            "long": 99.674,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 710905,
            "zip_code": 71140,
            "name_th": "พังตรุ",
            "name_en": "Phang Tru",
            "district_id": 7109,
            "lat": 14.134,
            "long": 99.746,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 710906,
            "zip_code": 71170,
            "name_th": "รางหวาย",
            "name_en": "Rang Wai",
            "district_id": 7109,
            "lat": 14.232,
            "long": 99.767,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 710911,
            "zip_code": 71140,
            "name_th": "หนองสาหร่าย",
            "name_en": "Nong Sarai",
            "district_id": 7109,
            "lat": 14.067,
            "long": 99.728,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 710912,
            "zip_code": 71140,
            "name_th": "ดอนตาเพชร",
            "name_en": "Don Ta Phet",
            "district_id": 7109,
            "lat": 14.192,
            "long": 99.678,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 7110,
        "name_th": "เลาขวัญ",
        "name_en": "Lao Khwan",
        "province_id": 56,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 711001,
            "zip_code": 71210,
            "name_th": "เลาขวัญ",
            "name_en": "Lao Khwan",
            "district_id": 7110,
            "lat": 14.58,
            "long": 99.753,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 711002,
            "zip_code": 71210,
            "name_th": "หนองโสน",
            "name_en": "Nong Sano",
            "district_id": 7110,
            "lat": 14.648,
            "long": 99.758,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 711003,
            "zip_code": 71210,
            "name_th": "หนองประดู่",
            "name_en": "Nong Pradu",
            "district_id": 7110,
            "lat": 14.456,
            "long": 99.738,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 711004,
            "zip_code": 71210,
            "name_th": "หนองปลิง",
            "name_en": "Nong Pling",
            "district_id": 7110,
            "lat": 14.715,
            "long": 99.743,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 711005,
            "zip_code": 71210,
            "name_th": "หนองนกแก้ว",
            "name_en": "Nong Nok Kaeo",
            "district_id": 7110,
            "lat": 14.516,
            "long": 99.655,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 711006,
            "zip_code": 71210,
            "name_th": "ทุ่งกระบ่ำ",
            "name_en": "Thung Krabam",
            "district_id": 7110,
            "lat": 14.616,
            "long": 99.586,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 711007,
            "zip_code": 71210,
            "name_th": "หนองฝ้าย",
            "name_en": "Nong Fai",
            "district_id": 7110,
            "lat": 14.682,
            "long": 99.642,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 7111,
        "name_th": "ด่านมะขามเตี้ย",
        "name_en": "Dan Makham Tia",
        "province_id": 56,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 711101,
            "zip_code": 71260,
            "name_th": "ด่านมะขามเตี้ย",
            "name_en": "Dan Makham Tia",
            "district_id": 7111,
            "lat": 13.836,
            "long": 99.388,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 711102,
            "zip_code": 71260,
            "name_th": "กลอนโด",
            "name_en": "Klondo",
            "district_id": 7111,
            "lat": 13.88,
            "long": 99.44,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 711103,
            "zip_code": 71260,
            "name_th": "จรเข้เผือก",
            "name_en": "Chorakhe Phueak",
            "district_id": 7111,
            "lat": 13.811,
            "long": 99.21,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 711104,
            "zip_code": 71260,
            "name_th": "หนองไผ่",
            "name_en": "Nong Phai",
            "district_id": 7111,
            "lat": 13.808,
            "long": 99.44,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 7112,
        "name_th": "หนองปรือ",
        "name_en": "Nong Prue",
        "province_id": 56,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 711201,
            "zip_code": 71220,
            "name_th": "หนองปรือ",
            "name_en": "Nong Prue",
            "district_id": 7112,
            "lat": 14.63,
            "long": 99.454,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 711202,
            "zip_code": 71220,
            "name_th": "หนองปลาไหล",
            "name_en": "Nong Pla Lai",
            "district_id": 7112,
            "lat": 14.626,
            "long": 99.527,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 711203,
            "zip_code": 71220,
            "name_th": "สมเด็จเจริญ",
            "name_en": "Somdet Charoen",
            "district_id": 7112,
            "lat": 14.746,
            "long": 99.338,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 7113,
        "name_th": "ห้วยกระเจา",
        "name_en": "Huai Krachao",
        "province_id": 56,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 711301,
            "zip_code": 71170,
            "name_th": "ห้วยกระเจา",
            "name_en": "Huai Krachao",
            "district_id": 7113,
            "lat": 14.312,
            "long": 99.618,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 711302,
            "zip_code": 71170,
            "name_th": "วังไผ่",
            "name_en": "Wang Phai",
            "district_id": 7113,
            "lat": 14.434,
            "long": 99.597,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 711303,
            "zip_code": 71170,
            "name_th": "ดอนแสลบ",
            "name_en": "Don Salaep",
            "district_id": 7113,
            "lat": 14.292,
            "long": 99.701,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 711304,
            "zip_code": 71170,
            "name_th": "สระลงเรือ",
            "name_en": "Sa Long Ruea",
            "district_id": 7113,
            "lat": 14.357,
            "long": 99.764,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      }
    ]
  },
  {
    "id": 57,
    "name_th": "สุพรรณบุรี",
    "name_en": "Suphan Buri",
    "geography_id": 2,
    "created_at": "2019-08-09T03:33:09.000+07:00",
    "updated_at": "2025-09-20T06:31:26.000+07:00",
    "deleted_at": null,
    "districts": [
      {
        "id": 7201,
        "name_th": "เมืองสุพรรณบุรี",
        "name_en": "Mueang Suphan Buri",
        "province_id": 57,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 720101,
            "zip_code": 72000,
            "name_th": "ท่าพี่เลี้ยง",
            "name_en": "Tha Phi Liang",
            "district_id": 7201,
            "lat": 14.471,
            "long": 100.116,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 720102,
            "zip_code": 72000,
            "name_th": "รั้วใหญ่",
            "name_en": "Rua Yai",
            "district_id": 7201,
            "lat": 14.451,
            "long": 100.113,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 720103,
            "zip_code": 72000,
            "name_th": "ทับตีเหล็ก",
            "name_en": "Thap Ti Lek",
            "district_id": 7201,
            "lat": 14.434,
            "long": 100.108,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 720104,
            "zip_code": 72000,
            "name_th": "ท่าระหัด",
            "name_en": "Tha Rahat",
            "district_id": 7201,
            "lat": 14.445,
            "long": 100.164,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 720105,
            "zip_code": 72000,
            "name_th": "ไผ่ขวาง",
            "name_en": "Phai Kwang",
            "district_id": 7201,
            "lat": 14.47,
            "long": 100.165,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 720106,
            "zip_code": 72000,
            "name_th": "โคกโคเฒ่า",
            "name_en": "Khok Kho Thao",
            "district_id": 7201,
            "lat": 14.464,
            "long": 100.233,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 720107,
            "zip_code": 72000,
            "name_th": "ดอนตาล",
            "name_en": "Don Tan",
            "district_id": 7201,
            "lat": 14.49,
            "long": 100.208,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 720108,
            "zip_code": 72000,
            "name_th": "ดอนมะสังข์",
            "name_en": "Don Masang",
            "district_id": 7201,
            "lat": 14.524,
            "long": 100.181,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 720109,
            "zip_code": 72000,
            "name_th": "พิหารแดง",
            "name_en": "Phihan Daeng",
            "district_id": 7201,
            "lat": 14.506,
            "long": 100.107,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 720110,
            "zip_code": 72000,
            "name_th": "ดอนกำยาน",
            "name_en": "Don Kamyan",
            "district_id": 7201,
            "lat": 14.454,
            "long": 100.064,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 720111,
            "zip_code": 72000,
            "name_th": "ดอนโพธิ์ทอง",
            "name_en": "Don Pho Thong",
            "district_id": 7201,
            "lat": 14.426,
            "long": 100.032,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 720112,
            "zip_code": 72000,
            "name_th": "บ้านโพธิ์",
            "name_en": "Ban Pho",
            "district_id": 7201,
            "lat": 14.524,
            "long": 100.071,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 720113,
            "zip_code": 72230,
            "name_th": "สระแก้ว",
            "name_en": "Sa Kaeo",
            "district_id": 7201,
            "lat": 14.502,
            "long": 100.014,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 720114,
            "zip_code": 72230,
            "name_th": "ตลิ่งชัน",
            "name_en": "Taling Chan",
            "district_id": 7201,
            "lat": 14.559,
            "long": 100.029,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 720115,
            "zip_code": 72210,
            "name_th": "บางกุ้ง",
            "name_en": "Bang Kung",
            "district_id": 7201,
            "lat": 14.457,
            "long": 100.003,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 720116,
            "zip_code": 72210,
            "name_th": "ศาลาขาว",
            "name_en": "Sala Khao",
            "district_id": 7201,
            "lat": 14.433,
            "long": 99.973,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 720117,
            "zip_code": 72210,
            "name_th": "สวนแตง",
            "name_en": "Suan Taeng",
            "district_id": 7201,
            "lat": 14.436,
            "long": 100.018,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 720118,
            "zip_code": 72000,
            "name_th": "สนามชัย",
            "name_en": "Sanam Chai",
            "district_id": 7201,
            "lat": 14.492,
            "long": 100.169,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 720119,
            "zip_code": 72000,
            "name_th": "โพธิ์พระยา",
            "name_en": "Pho Phraya",
            "district_id": 7201,
            "lat": 14.531,
            "long": 100.116,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 720120,
            "zip_code": 72230,
            "name_th": "สนามคลี",
            "name_en": "Sanam Klee",
            "district_id": 7201,
            "lat": 14.539,
            "long": 99.982,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 7202,
        "name_th": "เดิมบางนางบวช",
        "name_en": "Doem Bang Nang Buat",
        "province_id": 57,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 720201,
            "zip_code": 72120,
            "name_th": "เขาพระ",
            "name_en": "Khao Phra",
            "district_id": 7202,
            "lat": 14.853,
            "long": 100.095,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 720202,
            "zip_code": 72120,
            "name_th": "เดิมบาง",
            "name_en": "Doem Bang",
            "district_id": 7202,
            "lat": 14.893,
            "long": 100.109,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 720203,
            "zip_code": 72120,
            "name_th": "นางบวช",
            "name_en": "Nang Buat",
            "district_id": 7202,
            "lat": 14.811,
            "long": 100.12,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 720204,
            "zip_code": 72120,
            "name_th": "เขาดิน",
            "name_en": "Khao Din",
            "district_id": 7202,
            "lat": 14.803,
            "long": 100.189,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 720205,
            "zip_code": 72120,
            "name_th": "ปากน้ำ",
            "name_en": "Pak Nam",
            "district_id": 7202,
            "lat": 14.931,
            "long": 100.087,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 720206,
            "zip_code": 72120,
            "name_th": "ทุ่งคลี",
            "name_en": "Thung Khli",
            "district_id": 7202,
            "lat": 14.863,
            "long": 100.189,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 720207,
            "zip_code": 72120,
            "name_th": "โคกช้าง",
            "name_en": "Khok Chang",
            "district_id": 7202,
            "lat": 14.91,
            "long": 100.169,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 720208,
            "zip_code": 72120,
            "name_th": "หัวเขา",
            "name_en": "Hua Khao",
            "district_id": 7202,
            "lat": 14.869,
            "long": 100.038,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 720209,
            "zip_code": 72120,
            "name_th": "หัวนา",
            "name_en": "Hua Na",
            "district_id": 7202,
            "lat": 14.883,
            "long": 99.97,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 720210,
            "zip_code": 72120,
            "name_th": "บ่อกรุ",
            "name_en": "Bo Kru",
            "district_id": 7202,
            "lat": 14.893,
            "long": 99.905,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 720211,
            "zip_code": 72120,
            "name_th": "วังศรีราช",
            "name_en": "Wang Si Rat",
            "district_id": 7202,
            "lat": 14.85,
            "long": 99.988,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 720212,
            "zip_code": 72120,
            "name_th": "ป่าสะแก",
            "name_en": "Pa Sakae",
            "district_id": 7202,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 720213,
            "zip_code": 72120,
            "name_th": "ยางนอน",
            "name_en": "Yang Non",
            "district_id": 7202,
            "lat": 14.857,
            "long": 100.132,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 720214,
            "zip_code": 72120,
            "name_th": "หนองกระทุ่ม",
            "name_en": "Nong Krathum",
            "district_id": 7202,
            "lat": 14.907,
            "long": 99.804,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 7203,
        "name_th": "ด่านช้าง",
        "name_en": "Dan Chang",
        "province_id": 57,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 720301,
            "zip_code": 72180,
            "name_th": "หนองมะค่าโมง",
            "name_en": "Nong Makha Mong",
            "district_id": 7203,
            "lat": 14.882,
            "long": 99.737,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 720302,
            "zip_code": 72180,
            "name_th": "ด่านช้าง",
            "name_en": "Dan Chang",
            "district_id": 7203,
            "lat": 14.744,
            "long": 99.527,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 720303,
            "zip_code": 72180,
            "name_th": "ห้วยขมิ้น",
            "name_en": "Huai Khamin",
            "district_id": 7203,
            "lat": 14.922,
            "long": 99.534,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 720304,
            "zip_code": 72180,
            "name_th": "องค์พระ",
            "name_en": "Ong Phra",
            "district_id": 7203,
            "lat": 14.8,
            "long": 99.386,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 720305,
            "zip_code": 72180,
            "name_th": "วังคัน",
            "name_en": "Wang Khan",
            "district_id": 7203,
            "lat": 14.937,
            "long": 99.666,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 720306,
            "zip_code": 72180,
            "name_th": "นิคมกระเสียว",
            "name_en": "Nikhom Krasiao",
            "district_id": 7203,
            "lat": 14.844,
            "long": 99.548,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 720307,
            "zip_code": 72180,
            "name_th": "วังยาว",
            "name_en": "Wang Yao",
            "district_id": 7203,
            "lat": 14.954,
            "long": 99.381,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 7204,
        "name_th": "บางปลาม้า",
        "name_en": "Bang Pla Ma",
        "province_id": 57,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 720401,
            "zip_code": 72150,
            "name_th": "โคกคราม",
            "name_en": "Khok Khram",
            "district_id": 7204,
            "lat": 14.414,
            "long": 100.151,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 720402,
            "zip_code": 72150,
            "name_th": "บางปลาม้า",
            "name_en": "Bang Pla Ma",
            "district_id": 7204,
            "lat": 14.402,
            "long": 100.102,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 720403,
            "zip_code": 72150,
            "name_th": "ตะค่า",
            "name_en": "Takha",
            "district_id": 7204,
            "lat": 14.348,
            "long": 100.171,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 720404,
            "zip_code": 72150,
            "name_th": "บางใหญ่",
            "name_en": "Bang Yai",
            "district_id": 7204,
            "lat": 14.3,
            "long": 100.102,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 720405,
            "zip_code": 72150,
            "name_th": "กฤษณา",
            "name_en": "Kritsana",
            "district_id": 7204,
            "lat": 14.29,
            "long": 100.178,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 720406,
            "zip_code": 72150,
            "name_th": "สาลี",
            "name_en": "Sali",
            "district_id": 7204,
            "lat": 14.286,
            "long": 100.221,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 720407,
            "zip_code": 72150,
            "name_th": "ไผ่กองดิน",
            "name_en": "Phai Kong Din",
            "district_id": 7204,
            "lat": 14.34,
            "long": 100.264,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 720408,
            "zip_code": 72150,
            "name_th": "องครักษ์",
            "name_en": "Ongkharak",
            "district_id": 7204,
            "lat": 14.374,
            "long": 100.236,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 720409,
            "zip_code": 72150,
            "name_th": "จรเข้ใหญ่",
            "name_en": "Chorakhe Yai",
            "district_id": 7204,
            "lat": 14.421,
            "long": 100.236,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 720410,
            "zip_code": 72150,
            "name_th": "บ้านแหลม",
            "name_en": "Ban Laem",
            "district_id": 7204,
            "lat": 14.346,
            "long": 100.14,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 720411,
            "zip_code": 72150,
            "name_th": "มะขามล้ม",
            "name_en": "Makham Lom",
            "district_id": 7204,
            "lat": 14.37,
            "long": 100.043,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 720412,
            "zip_code": 72150,
            "name_th": "วังน้ำเย็น",
            "name_en": "Wang Nam Yen",
            "district_id": 7204,
            "lat": 14.377,
            "long": 100.015,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 720413,
            "zip_code": 72150,
            "name_th": "วัดโบสถ์",
            "name_en": "Wat Bot",
            "district_id": 7204,
            "lat": 14.33,
            "long": 100.037,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 720414,
            "zip_code": 72150,
            "name_th": "วัดดาว",
            "name_en": "Wad Daw",
            "district_id": 7204,
            "lat": 14.35,
            "long": 100.106,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 7205,
        "name_th": "ศรีประจันต์",
        "name_en": "Si Prachan",
        "province_id": 57,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 720501,
            "zip_code": 72140,
            "name_th": "ศรีประจันต์",
            "name_en": "Si Prachan",
            "district_id": 7205,
            "lat": 14.609,
            "long": 100.179,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 720502,
            "zip_code": 72140,
            "name_th": "บ้านกร่าง",
            "name_en": "Ban Krang",
            "district_id": 7205,
            "lat": 14.638,
            "long": 100.104,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 720503,
            "zip_code": 72140,
            "name_th": "มดแดง",
            "name_en": "Mot Daeng",
            "district_id": 7205,
            "lat": 14.57,
            "long": 100.119,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 720504,
            "zip_code": 72140,
            "name_th": "บางงาม",
            "name_en": "Bang Ngam",
            "district_id": 7205,
            "lat": 14.601,
            "long": 100.097,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 720505,
            "zip_code": 72140,
            "name_th": "ดอนปรู",
            "name_en": "Don Pru",
            "district_id": 7205,
            "lat": 14.722,
            "long": 100.19,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 720506,
            "zip_code": 72140,
            "name_th": "ปลายนา",
            "name_en": "Plai Na",
            "district_id": 7205,
            "lat": 14.66,
            "long": 100.2,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 720507,
            "zip_code": 72140,
            "name_th": "วังหว้า",
            "name_en": "Wang Wa",
            "district_id": 7205,
            "lat": 14.661,
            "long": 100.095,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 720508,
            "zip_code": 72140,
            "name_th": "วังน้ำซับ",
            "name_en": "Wang Nam Sap",
            "district_id": 7205,
            "lat": 14.65,
            "long": 100.154,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 720509,
            "zip_code": 72140,
            "name_th": "วังยาง",
            "name_en": "Wang Yang",
            "district_id": 7205,
            "lat": 14.559,
            "long": 100.167,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 7206,
        "name_th": "ดอนเจดีย์",
        "name_en": "Don Chedi",
        "province_id": 57,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 720601,
            "zip_code": 72170,
            "name_th": "ดอนเจดีย์",
            "name_en": "Don Chedi",
            "district_id": 7206,
            "lat": 14.633,
            "long": 99.959,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 720602,
            "zip_code": 72170,
            "name_th": "หนองสาหร่าย",
            "name_en": "Nong Sarai",
            "district_id": 7206,
            "lat": 14.671,
            "long": 100.011,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 720603,
            "zip_code": 72170,
            "name_th": "ไร่รถ",
            "name_en": "Rai Rot",
            "district_id": 7206,
            "lat": 14.603,
            "long": 99.955,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 720604,
            "zip_code": 72250,
            "name_th": "สระกระโจม",
            "name_en": "Sa Krachom",
            "district_id": 7206,
            "lat": 14.643,
            "long": 99.865,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 720605,
            "zip_code": 72250,
            "name_th": "ทะเลบก",
            "name_en": "Talae Bok",
            "district_id": 7206,
            "lat": 14.708,
            "long": 99.838,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 7207,
        "name_th": "สองพี่น้อง",
        "name_en": "Song Phi Nong",
        "province_id": 57,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 720701,
            "zip_code": 72110,
            "name_th": "สองพี่น้อง",
            "name_en": "Song Phi Nong",
            "district_id": 7207,
            "lat": 14.225,
            "long": 100.023,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 720702,
            "zip_code": 72110,
            "name_th": "บางเลน",
            "name_en": "Bang Len",
            "district_id": 7207,
            "lat": 14.169,
            "long": 100.085,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 720703,
            "zip_code": 72110,
            "name_th": "บางตาเถร",
            "name_en": "Bang Ta Then",
            "district_id": 7207,
            "lat": 14.199,
            "long": 100.174,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 720704,
            "zip_code": 72110,
            "name_th": "บางตะเคียน",
            "name_en": "Bang Takhian",
            "district_id": 7207,
            "lat": 14.213,
            "long": 100.103,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 720705,
            "zip_code": 72110,
            "name_th": "บ้านกุ่ม",
            "name_en": "Ban Kum",
            "district_id": 7207,
            "lat": 14.26,
            "long": 100.114,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 720706,
            "zip_code": 72110,
            "name_th": "หัวโพธิ์",
            "name_en": "Hua Pho",
            "district_id": 7207,
            "lat": 14.302,
            "long": 99.981,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 720707,
            "zip_code": 72110,
            "name_th": "บางพลับ",
            "name_en": "Bang Phlap",
            "district_id": 7207,
            "lat": 14.252,
            "long": 100.046,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 720708,
            "zip_code": 72110,
            "name_th": "เนินพระปรางค์",
            "name_en": "Noen Phra Prang",
            "district_id": 7207,
            "lat": 14.194,
            "long": 100.048,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 720709,
            "zip_code": 72110,
            "name_th": "บ้านช้าง",
            "name_en": "Ban Chang",
            "district_id": 7207,
            "lat": 14.234,
            "long": 100.206,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 720710,
            "zip_code": 72110,
            "name_th": "ต้นตาล",
            "name_en": "Ton Tan",
            "district_id": 7207,
            "lat": 14.22,
            "long": 100.061,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 720711,
            "zip_code": 72110,
            "name_th": "ศรีสำราญ",
            "name_en": "Si Samran",
            "district_id": 7207,
            "lat": 14.217,
            "long": 99.948,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 720712,
            "zip_code": 72190,
            "name_th": "ทุ่งคอก",
            "name_en": "Thung Khok",
            "district_id": 7207,
            "lat": 14.166,
            "long": 99.959,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 720713,
            "zip_code": 72110,
            "name_th": "หนองบ่อ",
            "name_en": "Nong Bo",
            "district_id": 7207,
            "lat": 14.204,
            "long": 99.86,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 720714,
            "zip_code": 72190,
            "name_th": "บ่อสุพรรณ",
            "name_en": "Bo Suphan",
            "district_id": 7207,
            "lat": 14.13,
            "long": 99.849,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 720715,
            "zip_code": 72110,
            "name_th": "ดอนมะนาว",
            "name_en": "Don Manao",
            "district_id": 7207,
            "lat": 14.166,
            "long": 100.011,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 7208,
        "name_th": "สามชุก",
        "name_en": "Sam Chuk",
        "province_id": 57,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 720801,
            "zip_code": 72130,
            "name_th": "ย่านยาว",
            "name_en": "Yan Yao",
            "district_id": 7208,
            "lat": 14.71,
            "long": 100.112,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 720802,
            "zip_code": 72130,
            "name_th": "วังลึก",
            "name_en": "Wang Luek",
            "district_id": 7208,
            "lat": 14.758,
            "long": 100.158,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 720803,
            "zip_code": 72130,
            "name_th": "สามชุก",
            "name_en": "Sam Chuk",
            "district_id": 7208,
            "lat": 14.763,
            "long": 100.095,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 720804,
            "zip_code": 72130,
            "name_th": "หนองผักนาก",
            "name_en": "Nong Phak Nak",
            "district_id": 7208,
            "lat": 14.757,
            "long": 100.032,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 720805,
            "zip_code": 72130,
            "name_th": "บ้านสระ",
            "name_en": "Ban Sa",
            "district_id": 7208,
            "lat": 14.708,
            "long": 100.041,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 720806,
            "zip_code": 72130,
            "name_th": "หนองสะเดา",
            "name_en": "Nong Sadao",
            "district_id": 7208,
            "lat": 14.803,
            "long": 99.991,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 720807,
            "zip_code": 72130,
            "name_th": "กระเสียว",
            "name_en": "Krasiao",
            "district_id": 7208,
            "lat": 14.801,
            "long": 100.056,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 7209,
        "name_th": "อู่ทอง",
        "name_en": "U Thong",
        "province_id": 57,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 720901,
            "zip_code": 72160,
            "name_th": "อู่ทอง",
            "name_en": "U Thong",
            "district_id": 7209,
            "lat": 14.377,
            "long": 99.88,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 720902,
            "zip_code": 72220,
            "name_th": "สระยายโสม",
            "name_en": "Sa Yai Som",
            "district_id": 7209,
            "lat": 14.273,
            "long": 99.874,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 720903,
            "zip_code": 72160,
            "name_th": "จรเข้สามพัน",
            "name_en": "Chorakhe Sam Phan",
            "district_id": 7209,
            "lat": 14.317,
            "long": 99.85,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 720904,
            "zip_code": 72160,
            "name_th": "บ้านดอน",
            "name_en": "Ban Don",
            "district_id": 7209,
            "lat": 14.303,
            "long": 99.923,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 720905,
            "zip_code": 72160,
            "name_th": "ยุ้งทะลาย",
            "name_en": "Yung Thalai",
            "district_id": 7209,
            "lat": 14.322,
            "long": 99.898,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 720906,
            "zip_code": 72220,
            "name_th": "ดอนมะเกลือ",
            "name_en": "Don Makluea",
            "district_id": 7209,
            "lat": 14.263,
            "long": 99.95,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 720907,
            "zip_code": 72160,
            "name_th": "หนองโอ่ง",
            "name_en": "Nong Ong",
            "district_id": 7209,
            "lat": 14.418,
            "long": 99.886,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 720908,
            "zip_code": 72160,
            "name_th": "ดอนคา",
            "name_en": "Don Kha",
            "district_id": 7209,
            "lat": 14.452,
            "long": 99.854,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 720909,
            "zip_code": 72160,
            "name_th": "พลับพลาไชย",
            "name_en": "Phlapphla Chai",
            "district_id": 7209,
            "lat": 14.517,
            "long": 99.887,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 720910,
            "zip_code": 72160,
            "name_th": "บ้านโข้ง",
            "name_en": "Ban Khong",
            "district_id": 7209,
            "lat": 14.578,
            "long": 99.864,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 720911,
            "zip_code": 72160,
            "name_th": "เจดีย์",
            "name_en": "Chedi",
            "district_id": 7209,
            "lat": 14.353,
            "long": 99.966,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 720912,
            "zip_code": 72220,
            "name_th": "สระพังลาน",
            "name_en": "Sa Phang Lan",
            "district_id": 7209,
            "lat": 14.253,
            "long": 99.906,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 720913,
            "zip_code": 72160,
            "name_th": "กระจัน",
            "name_en": "Krachan",
            "district_id": 7209,
            "lat": 14.367,
            "long": 99.928,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 7210,
        "name_th": "หนองหญ้าไซ",
        "name_en": "Nong Ya Sai",
        "province_id": 57,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 721001,
            "zip_code": 72240,
            "name_th": "หนองหญ้าไซ",
            "name_en": "Nong Ya Sai",
            "district_id": 7210,
            "lat": 14.776,
            "long": 99.885,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 721002,
            "zip_code": 72240,
            "name_th": "หนองราชวัตร",
            "name_en": "Nong Ratchawat",
            "district_id": 7210,
            "lat": 14.72,
            "long": 99.931,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 721003,
            "zip_code": 72240,
            "name_th": "หนองโพธิ์",
            "name_en": "Nong Pho",
            "district_id": 7210,
            "lat": 14.831,
            "long": 99.919,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 721004,
            "zip_code": 72240,
            "name_th": "แจงงาม",
            "name_en": "Chaeng Ngam",
            "district_id": 7210,
            "lat": 14.82,
            "long": 99.804,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 721005,
            "zip_code": 72240,
            "name_th": "หนองขาม",
            "name_en": "Nong Kham",
            "district_id": 7210,
            "lat": 14.796,
            "long": 99.693,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 721006,
            "zip_code": 72240,
            "name_th": "ทัพหลวง",
            "name_en": "Thap Luang",
            "district_id": 7210,
            "lat": 14.749,
            "long": 99.806,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      }
    ]
  },
  {
    "id": 58,
    "name_th": "นครปฐม",
    "name_en": "Nakhon Pathom",
    "geography_id": 2,
    "created_at": "2019-08-09T03:33:09.000+07:00",
    "updated_at": "2025-09-20T06:31:26.000+07:00",
    "deleted_at": null,
    "districts": [
      {
        "id": 7301,
        "name_th": "เมืองนครปฐม",
        "name_en": "Mueang Nakhon Pathom",
        "province_id": 58,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 730101,
            "zip_code": 73000,
            "name_th": "พระปฐมเจดีย์",
            "name_en": "Phra Pathom Chedi",
            "district_id": 7301,
            "lat": 13.819,
            "long": 100.05,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 730102,
            "zip_code": 73000,
            "name_th": "บางแขม",
            "name_en": "Bang Khaem",
            "district_id": 7301,
            "lat": 13.754,
            "long": 100.034,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 730103,
            "zip_code": 73000,
            "name_th": "พระประโทน",
            "name_en": "Phra Prathon",
            "district_id": 7301,
            "lat": 13.811,
            "long": 100.088,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 730104,
            "zip_code": 73000,
            "name_th": "ธรรมศาลา",
            "name_en": "Thammasala",
            "district_id": 7301,
            "lat": 13.807,
            "long": 100.105,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 730105,
            "zip_code": 73000,
            "name_th": "ตาก้อง",
            "name_en": "Ta Kong",
            "district_id": 7301,
            "lat": 13.892,
            "long": 100.054,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 730106,
            "zip_code": 73000,
            "name_th": "มาบแค",
            "name_en": "Map Khae",
            "district_id": 7301,
            "lat": 13.864,
            "long": 100.073,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 730107,
            "zip_code": 73000,
            "name_th": "สนามจันทร์",
            "name_en": "Sanam Chan",
            "district_id": 7301,
            "lat": 13.804,
            "long": 100.041,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 730108,
            "zip_code": 73000,
            "name_th": "ดอนยายหอม",
            "name_en": "Don Yai Hom",
            "district_id": 7301,
            "lat": 13.725,
            "long": 100.07,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 730109,
            "zip_code": 73000,
            "name_th": "ถนนขาด",
            "name_en": "Thanon Khat",
            "district_id": 7301,
            "lat": 13.782,
            "long": 100.077,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 730110,
            "zip_code": 73000,
            "name_th": "บ่อพลับ",
            "name_en": "Bo Phlap",
            "district_id": 7301,
            "lat": 13.837,
            "long": 100.065,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 730111,
            "zip_code": 73000,
            "name_th": "นครปฐม",
            "name_en": "Nakhon Pathom",
            "district_id": 7301,
            "lat": 13.848,
            "long": 100.044,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 730112,
            "zip_code": 73000,
            "name_th": "วังตะกู",
            "name_en": "Wang Taku",
            "district_id": 7301,
            "lat": 13.857,
            "long": 100.014,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 730113,
            "zip_code": 73000,
            "name_th": "หนองปากโลง",
            "name_en": "Nong Pak Long",
            "district_id": 7301,
            "lat": 13.866,
            "long": 99.989,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 730114,
            "zip_code": 73000,
            "name_th": "สามควายเผือก",
            "name_en": "Sam Khwai Phueak",
            "district_id": 7301,
            "lat": 13.841,
            "long": 100.113,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 730115,
            "zip_code": 73000,
            "name_th": "ทุ่งน้อย",
            "name_en": "Thung Noi",
            "district_id": 7301,
            "lat": 13.867,
            "long": 100.108,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 730116,
            "zip_code": 73000,
            "name_th": "หนองดินแดง",
            "name_en": "Nong Din Daeng",
            "district_id": 7301,
            "lat": 13.786,
            "long": 99.991,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 730117,
            "zip_code": 73000,
            "name_th": "วังเย็น",
            "name_en": "Wang Yen",
            "district_id": 7301,
            "lat": 13.766,
            "long": 100.008,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 730118,
            "zip_code": 73000,
            "name_th": "โพรงมะเดื่อ",
            "name_en": "Phrong Maduea",
            "district_id": 7301,
            "lat": 13.84,
            "long": 99.978,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 730119,
            "zip_code": 73000,
            "name_th": "ลำพยา",
            "name_en": "Lam Phaya",
            "district_id": 7301,
            "lat": 13.811,
            "long": 100.019,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 730120,
            "zip_code": 73000,
            "name_th": "สระกะเทียม",
            "name_en": "Sa Kathiam",
            "district_id": 7301,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 730121,
            "zip_code": 73000,
            "name_th": "สวนป่าน",
            "name_en": "Suan Pan",
            "district_id": 7301,
            "lat": 13.757,
            "long": 99.947,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 730122,
            "zip_code": 73000,
            "name_th": "ห้วยจรเข้",
            "name_en": "Huai Chorakhe",
            "district_id": 7301,
            "lat": 13.804,
            "long": 100.067,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 730123,
            "zip_code": 73000,
            "name_th": "ทัพหลวง",
            "name_en": "Thap Luang",
            "district_id": 7301,
            "lat": 13.878,
            "long": 100.021,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 730124,
            "zip_code": 73000,
            "name_th": "หนองงูเหลือม",
            "name_en": "Nong Ngulueam",
            "district_id": 7301,
            "lat": 13.914,
            "long": 99.952,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 730125,
            "zip_code": 73000,
            "name_th": "บ้านยาง",
            "name_en": "Ban Yang",
            "district_id": 7301,
            "lat": 13.868,
            "long": 99.929,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 7302,
        "name_th": "กำแพงแสน",
        "name_en": "Kamphaeng Saen",
        "province_id": 58,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 730201,
            "zip_code": 73140,
            "name_th": "ทุ่งกระพังโหม",
            "name_en": "Thung Kraphanghom",
            "district_id": 7302,
            "lat": 13.991,
            "long": 99.983,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 730202,
            "zip_code": 73180,
            "name_th": "กระตีบ",
            "name_en": "Kratip",
            "district_id": 7302,
            "lat": 14.111,
            "long": 99.964,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 730203,
            "zip_code": 73140,
            "name_th": "ทุ่งลูกนก",
            "name_en": "Thung Luk Nok",
            "district_id": 7302,
            "lat": 14.055,
            "long": 99.905,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 730204,
            "zip_code": 73140,
            "name_th": "ห้วยขวาง",
            "name_en": "Huai Khwang",
            "district_id": 7302,
            "lat": 13.923,
            "long": 100.015,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 730205,
            "zip_code": 73140,
            "name_th": "ทุ่งขวาง",
            "name_en": "Thung Khwang",
            "district_id": 7302,
            "lat": 13.965,
            "long": 99.963,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 730206,
            "zip_code": 73140,
            "name_th": "สระสี่มุม",
            "name_en": "Sa Si Mum",
            "district_id": 7302,
            "lat": 14.065,
            "long": 100.003,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 730207,
            "zip_code": 73140,
            "name_th": "ทุ่งบัว",
            "name_en": "Thung Bua",
            "district_id": 7302,
            "lat": 14.041,
            "long": 99.935,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 730208,
            "zip_code": 73140,
            "name_th": "ดอนข่อย",
            "name_en": "Don Khoi",
            "district_id": 7302,
            "lat": 14.022,
            "long": 100.035,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 730209,
            "zip_code": 73180,
            "name_th": "สระพัฒนา",
            "name_en": "Sa Phatthana",
            "district_id": 7302,
            "lat": 14.096,
            "long": 100.043,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 730210,
            "zip_code": 73140,
            "name_th": "ห้วยหมอนทอง",
            "name_en": "Huai Mon Thong",
            "district_id": 7302,
            "lat": 13.969,
            "long": 99.921,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 730211,
            "zip_code": 73180,
            "name_th": "ห้วยม่วง",
            "name_en": "Huai Muang",
            "district_id": 7302,
            "lat": 14.13,
            "long": 100.025,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 730212,
            "zip_code": 73140,
            "name_th": "กำแพงแสน",
            "name_en": "Kamphaeng Saen",
            "district_id": 7302,
            "lat": 14.024,
            "long": 99.981,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 730213,
            "zip_code": 73140,
            "name_th": "รางพิกุล",
            "name_en": "Rang Phikun",
            "district_id": 7302,
            "lat": 14.003,
            "long": 99.917,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 730214,
            "zip_code": 73140,
            "name_th": "หนองกระทุ่ม",
            "name_en": "Nong Krathum",
            "district_id": 7302,
            "lat": 14.004,
            "long": 99.865,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 730215,
            "zip_code": 73140,
            "name_th": "วังน้ำเขียว",
            "name_en": "Wang Nam Khiao",
            "district_id": 7302,
            "lat": 13.99,
            "long": 100.027,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 7303,
        "name_th": "นครชัยศรี",
        "name_en": "Nakhon Chai Si",
        "province_id": 58,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 730301,
            "zip_code": 73120,
            "name_th": "นครชัยศรี",
            "name_en": "Nakhon Chai Si",
            "district_id": 7303,
            "lat": 13.787,
            "long": 100.192,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 730302,
            "zip_code": 73120,
            "name_th": "บางกระเบา",
            "name_en": "Bang Krabao",
            "district_id": 7303,
            "lat": 13.793,
            "long": 100.183,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 730303,
            "zip_code": 73120,
            "name_th": "วัดแค",
            "name_en": "Wat Khae",
            "district_id": 7303,
            "lat": 13.814,
            "long": 100.175,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 730304,
            "zip_code": 73120,
            "name_th": "ท่าตำหนัก",
            "name_en": "Tha Tamnak",
            "district_id": 7303,
            "lat": 13.766,
            "long": 100.18,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 730305,
            "zip_code": 73120,
            "name_th": "บางแก้ว",
            "name_en": "Bang Kaeo",
            "district_id": 7303,
            "lat": 13.775,
            "long": 100.168,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 730306,
            "zip_code": 73120,
            "name_th": "ท่ากระชับ",
            "name_en": "Tha Krachap",
            "district_id": 7303,
            "lat": 13.76,
            "long": 100.155,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 730307,
            "zip_code": 73120,
            "name_th": "ขุนแก้ว",
            "name_en": "Khun Kaeo",
            "district_id": 7303,
            "lat": 13.774,
            "long": 100.209,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 730308,
            "zip_code": 73120,
            "name_th": "ท่าพระยา",
            "name_en": "Tha Phraya",
            "district_id": 7303,
            "lat": 13.785,
            "long": 100.144,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 730309,
            "zip_code": 73120,
            "name_th": "พะเนียด",
            "name_en": "Phaniat",
            "district_id": 7303,
            "lat": 13.795,
            "long": 100.123,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 730310,
            "zip_code": 73120,
            "name_th": "บางระกำ",
            "name_en": "Bang Rakam",
            "district_id": 7303,
            "lat": 13.756,
            "long": 100.134,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 730311,
            "zip_code": 73120,
            "name_th": "โคกพระเจดีย์",
            "name_en": "Khok Phra Chedi",
            "district_id": 7303,
            "lat": 13.726,
            "long": 100.126,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 730312,
            "zip_code": 73120,
            "name_th": "ศรีษะทอง",
            "name_en": "Sisa Thong",
            "district_id": 7303,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 730313,
            "zip_code": 73120,
            "name_th": "แหลมบัว",
            "name_en": "Laem Bua",
            "district_id": 7303,
            "lat": 13.857,
            "long": 100.147,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 730314,
            "zip_code": 73120,
            "name_th": "ศรีมหาโพธิ์",
            "name_en": "Si Maha Pho",
            "district_id": 7303,
            "lat": 13.889,
            "long": 100.155,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 730315,
            "zip_code": 73120,
            "name_th": "สัมปทวน",
            "name_en": "Sampathuan",
            "district_id": 7303,
            "lat": 13.83,
            "long": 100.195,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 730316,
            "zip_code": 73120,
            "name_th": "วัดสำโรง",
            "name_en": "Wat Samrong",
            "district_id": 7303,
            "lat": 13.827,
            "long": 100.218,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 730317,
            "zip_code": 73120,
            "name_th": "ดอนแฝก",
            "name_en": "Don Faek",
            "district_id": 7303,
            "lat": 13.859,
            "long": 100.244,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 730318,
            "zip_code": 73120,
            "name_th": "ห้วยพลู",
            "name_en": "Huai Phlu",
            "district_id": 7303,
            "lat": 13.878,
            "long": 100.233,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 730319,
            "zip_code": 73120,
            "name_th": "วัดละมุด",
            "name_en": "Wat Lamut",
            "district_id": 7303,
            "lat": 13.886,
            "long": 100.182,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 730320,
            "zip_code": 73120,
            "name_th": "บางพระ",
            "name_en": "Bang Phra",
            "district_id": 7303,
            "lat": 13.891,
            "long": 100.206,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 730321,
            "zip_code": 73120,
            "name_th": "บางแก้วฟ้า",
            "name_en": "Bang Kaeo Fa",
            "district_id": 7303,
            "lat": 13.896,
            "long": 100.247,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 730322,
            "zip_code": 73120,
            "name_th": "ลานตากฟ้า",
            "name_en": "Lan Tak Fa",
            "district_id": 7303,
            "lat": 13.828,
            "long": 100.233,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 730323,
            "zip_code": 73120,
            "name_th": "งิ้วราย",
            "name_en": "Ngio Rai",
            "district_id": 7303,
            "lat": 13.807,
            "long": 100.212,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 730324,
            "zip_code": 73120,
            "name_th": "ไทยาวาส",
            "name_en": "Thaiyawat",
            "district_id": 7303,
            "lat": 13.793,
            "long": 100.215,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 7304,
        "name_th": "ดอนตูม",
        "name_en": "Don Tum",
        "province_id": 58,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 730401,
            "zip_code": 73150,
            "name_th": "สามง่าม",
            "name_en": "Sam Ngam",
            "district_id": 7304,
            "lat": 13.978,
            "long": 100.083,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 730402,
            "zip_code": 73150,
            "name_th": "ห้วยพระ",
            "name_en": "Huai Phra",
            "district_id": 7304,
            "lat": 13.93,
            "long": 100.084,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 730403,
            "zip_code": 73150,
            "name_th": "ลำเหย",
            "name_en": "Lam Hoei",
            "district_id": 7304,
            "lat": 13.957,
            "long": 100.044,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 730404,
            "zip_code": 73150,
            "name_th": "ดอนพุทรา",
            "name_en": "Don Phutsa",
            "district_id": 7304,
            "lat": 13.936,
            "long": 100.124,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 730405,
            "zip_code": 73150,
            "name_th": "บ้านหลวง",
            "name_en": "Ban Luang",
            "district_id": 7304,
            "lat": 13.911,
            "long": 100.15,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 730406,
            "zip_code": 73150,
            "name_th": "ดอนรวก",
            "name_en": "Don Ruak",
            "district_id": 7304,
            "lat": 13.89,
            "long": 100.117,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 730407,
            "zip_code": 73150,
            "name_th": "ห้วยด้วน",
            "name_en": "Huai Duan",
            "district_id": 7304,
            "lat": 13.902,
            "long": 100.1,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 730408,
            "zip_code": 73150,
            "name_th": "ลำลูกบัว",
            "name_en": "Lam Luk Bua",
            "district_id": 7304,
            "lat": 14.024,
            "long": 100.074,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 7305,
        "name_th": "บางเลน",
        "name_en": "Bang Len",
        "province_id": 58,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 730501,
            "zip_code": 73130,
            "name_th": "บางเลน",
            "name_en": "Bang Len",
            "district_id": 7305,
            "lat": 14.014,
            "long": 100.151,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 730502,
            "zip_code": 73130,
            "name_th": "บางปลา",
            "name_en": "Bang Pla",
            "district_id": 7305,
            "lat": 13.97,
            "long": 100.158,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 730503,
            "zip_code": 73190,
            "name_th": "บางหลวง",
            "name_en": "Bang Luang",
            "district_id": 7305,
            "lat": 14.108,
            "long": 100.093,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 730504,
            "zip_code": 73130,
            "name_th": "บางภาษี",
            "name_en": "Bang Phasi",
            "district_id": 7305,
            "lat": 14.038,
            "long": 100.243,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 730505,
            "zip_code": 73130,
            "name_th": "บางระกำ",
            "name_en": "Bang Rakam",
            "district_id": 7305,
            "lat": 13.914,
            "long": 100.254,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 730506,
            "zip_code": 73130,
            "name_th": "บางไทรป่า",
            "name_en": "Bang Sai Pa",
            "district_id": 7305,
            "lat": 14.047,
            "long": 100.15,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 730507,
            "zip_code": 73190,
            "name_th": "หินมูล",
            "name_en": "Hin Mun",
            "district_id": 7305,
            "lat": 14.104,
            "long": 100.147,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 730508,
            "zip_code": 73130,
            "name_th": "ไทรงาม",
            "name_en": "Sai Ngam",
            "district_id": 7305,
            "lat": 14.093,
            "long": 100.177,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 730509,
            "zip_code": 73130,
            "name_th": "ดอนตูม",
            "name_en": "Don Tum",
            "district_id": 7305,
            "lat": 13.999,
            "long": 100.123,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 730510,
            "zip_code": 73130,
            "name_th": "นิลเพชร",
            "name_en": "Ninlaphet",
            "district_id": 7305,
            "lat": 14.121,
            "long": 100.235,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 730511,
            "zip_code": 73130,
            "name_th": "บัวปากท่า",
            "name_en": "Bua Pak Tha",
            "district_id": 7305,
            "lat": 14.159,
            "long": 100.228,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 730512,
            "zip_code": 73130,
            "name_th": "คลองนกกระทุง",
            "name_en": "Khlong Nok Krathung",
            "district_id": 7305,
            "lat": 13.991,
            "long": 100.222,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 730513,
            "zip_code": 73130,
            "name_th": "นราภิรมย์",
            "name_en": "Naraphirom",
            "district_id": 7305,
            "lat": 13.953,
            "long": 100.262,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 730514,
            "zip_code": 73130,
            "name_th": "ลำพญา",
            "name_en": "Lam Phaya",
            "district_id": 7305,
            "lat": 13.954,
            "long": 100.199,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 730515,
            "zip_code": 73130,
            "name_th": "ไผ่หูช้าง",
            "name_en": "Phai Hu Chang",
            "district_id": 7305,
            "lat": 14.064,
            "long": 100.116,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 7306,
        "name_th": "สามพราน",
        "name_en": "Sam Phran",
        "province_id": 58,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 730601,
            "zip_code": 73110,
            "name_th": "ท่าข้าม",
            "name_en": "Tha Kham",
            "district_id": 7306,
            "lat": 13.714,
            "long": 100.247,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 730602,
            "zip_code": 73210,
            "name_th": "ทรงคนอง",
            "name_en": "Song Khanong",
            "district_id": 7306,
            "lat": 13.78,
            "long": 100.262,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 730603,
            "zip_code": 73110,
            "name_th": "หอมเกร็ด",
            "name_en": "Hom Kret",
            "district_id": 7306,
            "lat": 13.779,
            "long": 100.24,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 730604,
            "zip_code": 73210,
            "name_th": "บางกระทึก",
            "name_en": "Bang Krathuek",
            "district_id": 7306,
            "lat": 13.772,
            "long": 100.305,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 730605,
            "zip_code": 73210,
            "name_th": "บางเตย",
            "name_en": "Bang Toei",
            "district_id": 7306,
            "lat": 13.787,
            "long": 100.289,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 730606,
            "zip_code": 73110,
            "name_th": "สามพราน",
            "name_en": "Sam Phran",
            "district_id": 7306,
            "lat": 13.716,
            "long": 100.219,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 730607,
            "zip_code": 73110,
            "name_th": "บางช้าง",
            "name_en": "Bang Chang",
            "district_id": 7306,
            "lat": 13.702,
            "long": 100.2,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 730608,
            "zip_code": 73210,
            "name_th": "ไร่ขิง",
            "name_en": "Rai Khing",
            "district_id": 7306,
            "lat": 13.737,
            "long": 100.283,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 730609,
            "zip_code": 73110,
            "name_th": "ท่าตลาด",
            "name_en": "Tha Talat",
            "district_id": 7306,
            "lat": 13.751,
            "long": 100.234,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 730610,
            "zip_code": 73220,
            "name_th": "กระทุ่มล้ม",
            "name_en": "Krathum Lom",
            "district_id": 7306,
            "lat": 13.737,
            "long": 100.322,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 730611,
            "zip_code": 73110,
            "name_th": "คลองใหม่",
            "name_en": "Khlong Mai",
            "district_id": 7306,
            "lat": 13.734,
            "long": 100.174,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 730612,
            "zip_code": 73110,
            "name_th": "ตลาดจินดา",
            "name_en": "Talat Chinda",
            "district_id": 7306,
            "lat": 13.698,
            "long": 100.15,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 730613,
            "zip_code": 73110,
            "name_th": "คลองจินดา",
            "name_en": "Khlong Chinda",
            "district_id": 7306,
            "lat": 13.677,
            "long": 100.092,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 730614,
            "zip_code": 73110,
            "name_th": "ยายชา",
            "name_en": "Yai Cha",
            "district_id": 7306,
            "lat": 13.733,
            "long": 100.235,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 730615,
            "zip_code": 73110,
            "name_th": "บ้านใหม่",
            "name_en": "Ban Mai",
            "district_id": 7306,
            "lat": 13.69,
            "long": 100.242,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 730616,
            "zip_code": 73160,
            "name_th": "อ้อมใหญ่",
            "name_en": "Om Yai",
            "district_id": 7306,
            "lat": 13.7,
            "long": 100.268,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 7307,
        "name_th": "พุทธมณฑล",
        "name_en": "Phutthamonthon",
        "province_id": 58,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 730701,
            "zip_code": 73170,
            "name_th": "ศาลายา",
            "name_en": "Sala Ya",
            "district_id": 7307,
            "lat": 13.813,
            "long": 100.305,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 730702,
            "zip_code": 73170,
            "name_th": "คลองโยง",
            "name_en": "Khlong Yong",
            "district_id": 7307,
            "lat": 13.862,
            "long": 100.281,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 730703,
            "zip_code": 73170,
            "name_th": "มหาสวัสดิ์",
            "name_en": "Maha Sawat",
            "district_id": 7307,
            "lat": 13.815,
            "long": 100.262,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      }
    ]
  },
  {
    "id": 59,
    "name_th": "สมุทรสาคร",
    "name_en": "Samut Sakhon",
    "geography_id": 2,
    "created_at": "2019-08-09T03:33:09.000+07:00",
    "updated_at": "2025-09-20T06:31:26.000+07:00",
    "deleted_at": null,
    "districts": [
      {
        "id": 7401,
        "name_th": "เมืองสมุทรสาคร",
        "name_en": "Mueang Samut Sakhon",
        "province_id": 59,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 740101,
            "zip_code": 74000,
            "name_th": "มหาชัย",
            "name_en": "Maha Chai",
            "district_id": 7401,
            "lat": 13.552,
            "long": 100.28,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 740102,
            "zip_code": 74000,
            "name_th": "ท่าฉลอม",
            "name_en": "Tha Chalom",
            "district_id": 7401,
            "lat": 13.538,
            "long": 100.269,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 740103,
            "zip_code": 74000,
            "name_th": "โกรกกราก",
            "name_en": "Krok Krak",
            "district_id": 7401,
            "lat": 13.533,
            "long": 100.276,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 740104,
            "zip_code": 74000,
            "name_th": "บ้านบ่อ",
            "name_en": "Ban Bo",
            "district_id": 7401,
            "lat": 13.487,
            "long": 100.192,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 740105,
            "zip_code": 74000,
            "name_th": "บางโทรัด",
            "name_en": "Bang Tho Rat",
            "district_id": 7401,
            "lat": 13.492,
            "long": 100.158,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 740106,
            "zip_code": 74000,
            "name_th": "กาหลง",
            "name_en": "Ka Long",
            "district_id": 7401,
            "lat": 13.483,
            "long": 100.13,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 740107,
            "zip_code": 74000,
            "name_th": "นาโคก",
            "name_en": "Na Khok",
            "district_id": 7401,
            "lat": 13.464,
            "long": 100.096,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 740108,
            "zip_code": 74000,
            "name_th": "ท่าจีน",
            "name_en": "Tha Chin",
            "district_id": 7401,
            "lat": 13.539,
            "long": 100.252,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 740109,
            "zip_code": 74000,
            "name_th": "นาดี",
            "name_en": "Na Di",
            "district_id": 7401,
            "lat": 13.595,
            "long": 100.295,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 740110,
            "zip_code": 74000,
            "name_th": "ท่าทราย",
            "name_en": "Tha Sai",
            "district_id": 7401,
            "lat": 13.571,
            "long": 100.266,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 740111,
            "zip_code": 74000,
            "name_th": "คอกกระบือ",
            "name_en": "Khok Krabue",
            "district_id": 7401,
            "lat": 13.599,
            "long": 100.333,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 740112,
            "zip_code": 74000,
            "name_th": "บางน้ำจืด",
            "name_en": "Bang Nam Chuet",
            "district_id": 7401,
            "lat": 13.614,
            "long": 100.363,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 740113,
            "zip_code": 74000,
            "name_th": "พันท้ายนรสิงห์",
            "name_en": "Phan Thai Norasing",
            "district_id": 7401,
            "lat": 13.539,
            "long": 100.377,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 740114,
            "zip_code": 74000,
            "name_th": "โคกขาม",
            "name_en": "Khok Kham",
            "district_id": 7401,
            "lat": 13.531,
            "long": 100.326,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 740115,
            "zip_code": 74000,
            "name_th": "บ้านเกาะ",
            "name_en": "Ban Ko",
            "district_id": 7401,
            "lat": 13.591,
            "long": 100.247,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 740116,
            "zip_code": 74000,
            "name_th": "บางกระเจ้า",
            "name_en": "Bang Krachao",
            "district_id": 7401,
            "lat": 13.512,
            "long": 100.215,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 740117,
            "zip_code": 74000,
            "name_th": "บางหญ้าแพรก",
            "name_en": "Bang Ya Phraek",
            "district_id": 7401,
            "lat": 13.501,
            "long": 100.25,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 740118,
            "zip_code": 74000,
            "name_th": "ชัยมงคล",
            "name_en": "Chai Mongkon",
            "district_id": 7401,
            "lat": 13.54,
            "long": 100.185,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 7402,
        "name_th": "กระทุ่มแบน",
        "name_en": "Krathum Baen",
        "province_id": 59,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 740201,
            "zip_code": 74110,
            "name_th": "ตลาดกระทุ่มแบน",
            "name_en": "Talat Krathum Baen",
            "district_id": 7402,
            "lat": 13.654,
            "long": 100.25,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 740202,
            "zip_code": 74130,
            "name_th": "อ้อมน้อย",
            "name_en": "Om Noi",
            "district_id": 7402,
            "lat": 13.702,
            "long": 100.308,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 740203,
            "zip_code": 74110,
            "name_th": "ท่าไม้",
            "name_en": "Tha Mai",
            "district_id": 7402,
            "lat": 13.671,
            "long": 100.261,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 740204,
            "zip_code": 74110,
            "name_th": "สวนหลวง",
            "name_en": "Suan Luang",
            "district_id": 7402,
            "lat": 13.671,
            "long": 100.323,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 740205,
            "zip_code": 74110,
            "name_th": "บางยาง",
            "name_en": "Bang Yang",
            "district_id": 7402,
            "lat": 13.652,
            "long": 100.226,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 740206,
            "zip_code": 74110,
            "name_th": "คลองมะเดื่อ",
            "name_en": "Khlong Maduea",
            "district_id": 7402,
            "lat": 13.637,
            "long": 100.292,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 740207,
            "zip_code": 74110,
            "name_th": "หนองนกไข่",
            "name_en": "Nong Nok Khai",
            "district_id": 7402,
            "lat": 13.668,
            "long": 100.192,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 740208,
            "zip_code": 74110,
            "name_th": "ดอนไก่ดี",
            "name_en": "Don Kai Di",
            "district_id": 7402,
            "lat": 13.633,
            "long": 100.266,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 740209,
            "zip_code": 74110,
            "name_th": "แคราย",
            "name_en": "Khae Rai",
            "district_id": 7402,
            "lat": 13.643,
            "long": 100.324,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 740210,
            "zip_code": 74110,
            "name_th": "ท่าเสา",
            "name_en": "Tha Sao",
            "district_id": 7402,
            "lat": 13.623,
            "long": 100.24,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 7403,
        "name_th": "บ้านแพ้ว",
        "name_en": "Ban Phaeo",
        "province_id": 59,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 740301,
            "zip_code": 74120,
            "name_th": "บ้านแพ้ว",
            "name_en": "Ban Phaeo",
            "district_id": 7403,
            "lat": 13.618,
            "long": 100.104,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 740302,
            "zip_code": 74120,
            "name_th": "หลักสาม",
            "name_en": "Lak Sam",
            "district_id": 7403,
            "lat": 13.571,
            "long": 100.139,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 740303,
            "zip_code": 74120,
            "name_th": "ยกกระบัตร",
            "name_en": "Yokkrabat",
            "district_id": 7403,
            "lat": 13.559,
            "long": 100.082,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 740304,
            "zip_code": 74120,
            "name_th": "โรงเข้",
            "name_en": "Rong Khe",
            "district_id": 7403,
            "lat": 13.521,
            "long": 100.069,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 740305,
            "zip_code": 74120,
            "name_th": "หนองสองห้อง",
            "name_en": "Nong Song Hong",
            "district_id": 7403,
            "lat": 13.581,
            "long": 100.065,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 740306,
            "zip_code": 74120,
            "name_th": "หนองบัว",
            "name_en": "Nong Bua",
            "district_id": 7403,
            "lat": 13.598,
            "long": 100.075,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 740307,
            "zip_code": 74120,
            "name_th": "หลักสอง",
            "name_en": "Lak Song",
            "district_id": 7403,
            "lat": 13.614,
            "long": 100.134,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 740308,
            "zip_code": 74120,
            "name_th": "เจ็ดริ้ว",
            "name_en": "Chet Rio",
            "district_id": 7403,
            "lat": 13.639,
            "long": 100.141,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 740309,
            "zip_code": 74120,
            "name_th": "คลองตัน",
            "name_en": "Khlong Tan",
            "district_id": 7403,
            "lat": 13.641,
            "long": 100.171,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 740310,
            "zip_code": 74120,
            "name_th": "อำแพง",
            "name_en": "Amphaeng",
            "district_id": 7403,
            "lat": 13.6,
            "long": 100.189,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 740311,
            "zip_code": 74120,
            "name_th": "สวนส้ม",
            "name_en": "Suan Som",
            "district_id": 7403,
            "lat": 13.624,
            "long": 100.186,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 740312,
            "zip_code": 74120,
            "name_th": "เกษตรพัฒนา",
            "name_en": "Kaset Phatthana",
            "district_id": 7403,
            "lat": 13.666,
            "long": 100.153,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      }
    ]
  },
  {
    "id": 60,
    "name_th": "สมุทรสงคราม",
    "name_en": "Samut Songkhram",
    "geography_id": 2,
    "created_at": "2019-08-09T03:33:09.000+07:00",
    "updated_at": "2025-09-20T06:31:26.000+07:00",
    "deleted_at": null,
    "districts": [
      {
        "id": 7501,
        "name_th": "เมืองสมุทรสงคราม",
        "name_en": "Mueang Samut Songkhram",
        "province_id": 60,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 750101,
            "zip_code": 75000,
            "name_th": "แม่กลอง",
            "name_en": "Mae Klong",
            "district_id": 7501,
            "lat": 13.4,
            "long": 99.994,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 750102,
            "zip_code": 75000,
            "name_th": "บางขันแตก",
            "name_en": "Bang Khan Taek",
            "district_id": 7501,
            "lat": 13.384,
            "long": 99.955,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 750103,
            "zip_code": 75000,
            "name_th": "ลาดใหญ่",
            "name_en": "Lat Yai",
            "district_id": 7501,
            "lat": 13.451,
            "long": 100.037,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 750104,
            "zip_code": 75000,
            "name_th": "บ้านปรก",
            "name_en": "Ban Prok",
            "district_id": 7501,
            "lat": 13.43,
            "long": 99.992,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 750105,
            "zip_code": 75000,
            "name_th": "บางแก้ว",
            "name_en": "Bang Kaeo",
            "district_id": 7501,
            "lat": 13.431,
            "long": 100.06,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 750106,
            "zip_code": 75000,
            "name_th": "ท้ายหาด",
            "name_en": "Thai Hat",
            "district_id": 7501,
            "lat": 13.399,
            "long": 99.976,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 750107,
            "zip_code": 75000,
            "name_th": "แหลมใหญ่",
            "name_en": "Laem Yai",
            "district_id": 7501,
            "lat": 13.354,
            "long": 99.99,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 750108,
            "zip_code": 75000,
            "name_th": "คลองเขิน",
            "name_en": "Khlong Khoen",
            "district_id": 7501,
            "lat": 13.445,
            "long": 99.988,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 750109,
            "zip_code": 75000,
            "name_th": "คลองโคน",
            "name_en": "Khlong Khon",
            "district_id": 7501,
            "lat": 13.329,
            "long": 99.95,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 750110,
            "zip_code": 75000,
            "name_th": "นางตะเคียน",
            "name_en": "Nang Takhian",
            "district_id": 7501,
            "lat": 13.48,
            "long": 100.027,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 750111,
            "zip_code": 75000,
            "name_th": "บางจะเกร็ง",
            "name_en": "Bang Chakreng",
            "district_id": 7501,
            "lat": 13.376,
            "long": 100.01,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 7502,
        "name_th": "บางคนที",
        "name_en": "Bang Khonthi",
        "province_id": 60,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 750201,
            "zip_code": 75120,
            "name_th": "กระดังงา",
            "name_en": "Kradangnga",
            "district_id": 7502,
            "lat": 13.472,
            "long": 99.951,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 750202,
            "zip_code": 75120,
            "name_th": "บางสะแก",
            "name_en": "Bang Sakae",
            "district_id": 7502,
            "lat": 13.45,
            "long": 99.928,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 750203,
            "zip_code": 75120,
            "name_th": "บางยี่รงค์",
            "name_en": "Bang Yi Rong",
            "district_id": 7502,
            "lat": 13.481,
            "long": 99.912,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 750204,
            "zip_code": 75120,
            "name_th": "โรงหีบ",
            "name_en": "Rong Hip",
            "district_id": 7502,
            "lat": 13.47,
            "long": 99.931,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 750205,
            "zip_code": 75120,
            "name_th": "บางคนที",
            "name_en": "Bang Khonthi",
            "district_id": 7502,
            "lat": 13.493,
            "long": 99.945,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 750206,
            "zip_code": 75120,
            "name_th": "ดอนมะโนรา",
            "name_en": "Don Manora",
            "district_id": 7502,
            "lat": 13.499,
            "long": 100.018,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 750207,
            "zip_code": 75120,
            "name_th": "บางพรม",
            "name_en": "Bang Phrom",
            "district_id": 7502,
            "lat": 13.452,
            "long": 99.955,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 750208,
            "zip_code": 75120,
            "name_th": "บางกุ้ง",
            "name_en": "Bang Kung",
            "district_id": 7502,
            "lat": 13.459,
            "long": 99.931,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 750209,
            "zip_code": 75120,
            "name_th": "จอมปลวก",
            "name_en": "Chom Pluak",
            "district_id": 7502,
            "lat": 13.483,
            "long": 99.976,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 750210,
            "zip_code": 75120,
            "name_th": "บางนกแขวก",
            "name_en": "Bang Nok Khwaek",
            "district_id": 7502,
            "lat": 13.504,
            "long": 99.923,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 750211,
            "zip_code": 75120,
            "name_th": "ยายแพง",
            "name_en": "Yai Phaeng",
            "district_id": 7502,
            "lat": 13.487,
            "long": 99.958,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 750212,
            "zip_code": 75120,
            "name_th": "บางกระบือ",
            "name_en": "Bang Krabue",
            "district_id": 7502,
            "lat": 13.463,
            "long": 99.968,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 750213,
            "zip_code": 75120,
            "name_th": "บ้านปราโมทย์",
            "name_en": "Ban Pramot",
            "district_id": 7502,
            "lat": 13.46,
            "long": 99.898,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 7503,
        "name_th": "อัมพวา",
        "name_en": "Amphawa",
        "province_id": 60,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 750301,
            "zip_code": 75110,
            "name_th": "อัมพวา",
            "name_en": "Amphawa",
            "district_id": 7503,
            "lat": 13.427,
            "long": 99.954,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 750302,
            "zip_code": 75110,
            "name_th": "สวนหลวง",
            "name_en": "Suan Luang",
            "district_id": 7503,
            "lat": 13.414,
            "long": 99.953,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 750303,
            "zip_code": 75110,
            "name_th": "ท่าคา",
            "name_en": "Tha Kha",
            "district_id": 7503,
            "lat": 13.466,
            "long": 99.993,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 750304,
            "zip_code": 75110,
            "name_th": "วัดประดู่",
            "name_en": "Wat Pradu",
            "district_id": 7503,
            "lat": 13.38,
            "long": 99.875,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 750305,
            "zip_code": 75110,
            "name_th": "เหมืองใหม่",
            "name_en": "Mueang Mai",
            "district_id": 7503,
            "lat": 13.433,
            "long": 99.91,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 750306,
            "zip_code": 75110,
            "name_th": "บางช้าง",
            "name_en": "Bang Chang",
            "district_id": 7503,
            "lat": 13.437,
            "long": 99.953,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 750307,
            "zip_code": 75110,
            "name_th": "แควอ้อม",
            "name_en": "Khwae Om",
            "district_id": 7503,
            "lat": 13.436,
            "long": 99.937,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 750308,
            "zip_code": 75110,
            "name_th": "ปลายโพงพาง",
            "name_en": "Plai Phongphang",
            "district_id": 7503,
            "lat": 13.385,
            "long": 99.923,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 750309,
            "zip_code": 75110,
            "name_th": "บางแค",
            "name_en": "Bang Khae",
            "district_id": 7503,
            "lat": 13.407,
            "long": 99.923,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 750310,
            "zip_code": 75110,
            "name_th": "แพรกหนามแดง",
            "name_en": "Phraek Nam Daeng",
            "district_id": 7503,
            "lat": 13.343,
            "long": 99.882,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 750311,
            "zip_code": 75110,
            "name_th": "ยี่สาร",
            "name_en": "Yi San",
            "district_id": 7503,
            "lat": 13.297,
            "long": 99.895,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 750312,
            "zip_code": 75110,
            "name_th": "บางนางลี่",
            "name_en": "Bang Nang Lee",
            "district_id": 7503,
            "lat": 13.414,
            "long": 99.917,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      }
    ]
  },
  {
    "id": 61,
    "name_th": "เพชรบุรี",
    "name_en": "Phetchaburi",
    "geography_id": 4,
    "created_at": "2019-08-09T03:33:09.000+07:00",
    "updated_at": "2025-09-20T06:31:26.000+07:00",
    "deleted_at": null,
    "districts": [
      {
        "id": 7601,
        "name_th": "เมืองเพชรบุรี",
        "name_en": "Mueang Phetchaburi",
        "province_id": 61,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 760101,
            "zip_code": 76000,
            "name_th": "ท่าราบ",
            "name_en": "Tha Rap",
            "district_id": 7601,
            "lat": 13.097,
            "long": 99.949,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 760102,
            "zip_code": 76000,
            "name_th": "คลองกระแชง",
            "name_en": "Khlong Krachaeng",
            "district_id": 7601,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 760103,
            "zip_code": 76000,
            "name_th": "บางจาน",
            "name_en": "Bang Chan",
            "district_id": 7601,
            "lat": 13.13,
            "long": 100.015,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 760104,
            "zip_code": 76000,
            "name_th": "นาพันสาม",
            "name_en": "Na Phan Sam",
            "district_id": 7601,
            "lat": 13.054,
            "long": 100.03,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 760105,
            "zip_code": 76000,
            "name_th": "ธงชัย",
            "name_en": "Thong Chai",
            "district_id": 7601,
            "lat": 13.151,
            "long": 99.918,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 760106,
            "zip_code": 76000,
            "name_th": "บ้านกุ่ม",
            "name_en": "Ban Kum",
            "district_id": 7601,
            "lat": 13.156,
            "long": 99.941,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 760107,
            "zip_code": 76000,
            "name_th": "หนองโสน",
            "name_en": "Nong Sano",
            "district_id": 7601,
            "lat": 13.134,
            "long": 99.973,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 760108,
            "zip_code": 76000,
            "name_th": "ไร่ส้ม",
            "name_en": "Rai Som",
            "district_id": 7601,
            "lat": 13.112,
            "long": 99.916,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 760109,
            "zip_code": 76000,
            "name_th": "เวียงคอย",
            "name_en": "Wiang Khoi",
            "district_id": 7601,
            "lat": 13.121,
            "long": 99.9,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 760110,
            "zip_code": 76000,
            "name_th": "บางจาก",
            "name_en": "Bang Chak",
            "district_id": 7601,
            "lat": 13.158,
            "long": 99.891,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 760111,
            "zip_code": 76000,
            "name_th": "บ้านหม้อ",
            "name_en": "Ban Mo",
            "district_id": 7601,
            "lat": 13.092,
            "long": 99.932,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 760112,
            "zip_code": 76000,
            "name_th": "ต้นมะม่วง",
            "name_en": "Ton Mamuang",
            "district_id": 7601,
            "lat": 13.079,
            "long": 99.958,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 760113,
            "zip_code": 76000,
            "name_th": "ช่องสะแก",
            "name_en": "Chong Sakae",
            "district_id": 7601,
            "lat": 13.105,
            "long": 99.997,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 760114,
            "zip_code": 76000,
            "name_th": "นาวุ้ง",
            "name_en": "Na Wung",
            "district_id": 7601,
            "lat": 13.088,
            "long": 99.977,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 760115,
            "zip_code": 76000,
            "name_th": "สำมะโรง",
            "name_en": "Sam Marong",
            "district_id": 7601,
            "lat": 13.07,
            "long": 99.992,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 760116,
            "zip_code": 76000,
            "name_th": "โพพระ",
            "name_en": "Pho Phra",
            "district_id": 7601,
            "lat": 13.082,
            "long": 100.039,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 760117,
            "zip_code": 76100,
            "name_th": "หาดเจ้าสำราญ",
            "name_en": "Hat Chao Samran",
            "district_id": 7601,
            "lat": 13.007,
            "long": 100.044,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 760118,
            "zip_code": 76000,
            "name_th": "หัวสะพาน",
            "name_en": "Hua Saphan",
            "district_id": 7601,
            "lat": 13.117,
            "long": 99.866,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 760119,
            "zip_code": 76000,
            "name_th": "ต้นมะพร้าว",
            "name_en": "Ton Maphrao",
            "district_id": 7601,
            "lat": 13.146,
            "long": 99.86,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 760120,
            "zip_code": 76000,
            "name_th": "วังตะโก",
            "name_en": "Wang Tako",
            "district_id": 7601,
            "lat": 13.134,
            "long": 99.893,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 760121,
            "zip_code": 76000,
            "name_th": "โพไร่หวาน",
            "name_en": "Pho Rai Wan",
            "district_id": 7601,
            "lat": 13.053,
            "long": 99.974,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 760122,
            "zip_code": 76000,
            "name_th": "ดอนยาง",
            "name_en": "Don Yang",
            "district_id": 7601,
            "lat": 13.015,
            "long": 99.976,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 760123,
            "zip_code": 76000,
            "name_th": "หนองขนาน",
            "name_en": "Nong Khanan",
            "district_id": 7601,
            "lat": 12.995,
            "long": 100.013,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 760124,
            "zip_code": 76000,
            "name_th": "หนองพลับ",
            "name_en": "Nong Phlap",
            "district_id": 7601,
            "lat": 13.048,
            "long": 100.0,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 7602,
        "name_th": "เขาย้อย",
        "name_en": "Khao Yoi",
        "province_id": 61,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 760201,
            "zip_code": 76140,
            "name_th": "เขาย้อย",
            "name_en": "Khao Yoi",
            "district_id": 7602,
            "lat": 13.233,
            "long": 99.819,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 760202,
            "zip_code": 76140,
            "name_th": "สระพัง",
            "name_en": "Sa Phang",
            "district_id": 7602,
            "lat": 13.257,
            "long": 99.811,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 760203,
            "zip_code": 76140,
            "name_th": "บางเค็ม",
            "name_en": "Bang Khem",
            "district_id": 7602,
            "lat": 13.284,
            "long": 99.838,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 760204,
            "zip_code": 76140,
            "name_th": "ทับคาง",
            "name_en": "Thap Khang",
            "district_id": 7602,
            "lat": 13.204,
            "long": 99.833,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 760205,
            "zip_code": 76140,
            "name_th": "หนองปลาไหล",
            "name_en": "Nong Pla Lai",
            "district_id": 7602,
            "lat": 13.194,
            "long": 99.877,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 760206,
            "zip_code": 76140,
            "name_th": "หนองปรง",
            "name_en": "Nong Prong",
            "district_id": 7602,
            "lat": 13.168,
            "long": 99.801,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 760207,
            "zip_code": 76140,
            "name_th": "หนองชุมพล",
            "name_en": "Nong Chumphon",
            "district_id": 7602,
            "lat": 13.295,
            "long": 99.797,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 760208,
            "zip_code": 76140,
            "name_th": "ห้วยโรง",
            "name_en": "Huai Rong",
            "district_id": 7602,
            "lat": 13.316,
            "long": 99.841,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 760209,
            "zip_code": 76140,
            "name_th": "ห้วยท่าช้าง",
            "name_en": "Huai Tha Chang",
            "district_id": 7602,
            "lat": 13.136,
            "long": 99.8,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 760210,
            "zip_code": 76140,
            "name_th": "หนองชุมพลเหนือ",
            "name_en": "Nong Chumphon Nuea",
            "district_id": 7602,
            "lat": 13.301,
            "long": 99.724,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 7603,
        "name_th": "หนองหญ้าปล้อง",
        "name_en": "Nong Ya Plong",
        "province_id": 61,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 760301,
            "zip_code": 76160,
            "name_th": "หนองหญ้าปล้อง",
            "name_en": "Nong Ya Plong",
            "district_id": 7603,
            "lat": 13.201,
            "long": 99.709,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 760302,
            "zip_code": 76160,
            "name_th": "ยางน้ำกลัดเหนือ",
            "name_en": "Yang Nam Klat Nuea",
            "district_id": 7603,
            "lat": 13.158,
            "long": 99.39,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 760303,
            "zip_code": 76160,
            "name_th": "ยางน้ำกลัดใต้",
            "name_en": "Yang Nam Klat Tai",
            "district_id": 7603,
            "lat": 13.07,
            "long": 99.505,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 760304,
            "zip_code": 76160,
            "name_th": "ท่าตะคร้อ",
            "name_en": "Tha Takror",
            "district_id": 7603,
            "lat": 13.099,
            "long": 99.749,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 7604,
        "name_th": "ชะอำ",
        "name_en": "Cha-am",
        "province_id": 61,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 760401,
            "zip_code": 76120,
            "name_th": "ชะอำ",
            "name_en": "Cha-am",
            "district_id": 7604,
            "lat": 12.719,
            "long": 99.939,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 760402,
            "zip_code": 76120,
            "name_th": "บางเก่า",
            "name_en": "Bang Kao",
            "district_id": 7604,
            "lat": 12.856,
            "long": 99.985,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 760403,
            "zip_code": 76120,
            "name_th": "นายาง",
            "name_en": "Na Yang",
            "district_id": 7604,
            "lat": 12.887,
            "long": 99.945,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 760404,
            "zip_code": 76120,
            "name_th": "เขาใหญ่",
            "name_en": "Khao Yai",
            "district_id": 7604,
            "lat": 12.793,
            "long": 99.894,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 760405,
            "zip_code": 76120,
            "name_th": "หนองศาลา",
            "name_en": "Nong Sala",
            "district_id": 7604,
            "lat": 12.891,
            "long": 99.971,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 760406,
            "zip_code": 76120,
            "name_th": "ห้วยทรายเหนือ",
            "name_en": "Huai Sai Nuea",
            "district_id": 7604,
            "lat": 12.715,
            "long": 99.832,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 760407,
            "zip_code": 76120,
            "name_th": "ไร่ใหม่พัฒนา",
            "name_en": "Rai Mai Phatthana",
            "district_id": 7604,
            "lat": 12.655,
            "long": 99.806,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 760408,
            "zip_code": 76120,
            "name_th": "สามพระยา",
            "name_en": "Sam Phraya",
            "district_id": 7604,
            "lat": 12.684,
            "long": 99.882,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 760409,
            "zip_code": 76120,
            "name_th": "ดอนขุนห้วย",
            "name_en": "Don Khun Huai",
            "district_id": 7604,
            "lat": 12.864,
            "long": 99.892,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 7605,
        "name_th": "ท่ายาง",
        "name_en": "Tha Yang",
        "province_id": 61,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 760501,
            "zip_code": 76130,
            "name_th": "ท่ายาง",
            "name_en": "Tha Yang",
            "district_id": 7605,
            "lat": 12.954,
            "long": 99.904,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 760502,
            "zip_code": 76130,
            "name_th": "ท่าคอย",
            "name_en": "Tha Khoi",
            "district_id": 7605,
            "lat": 12.922,
            "long": 99.872,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 760503,
            "zip_code": 76130,
            "name_th": "ยางหย่อง",
            "name_en": "Yang Yong",
            "district_id": 7605,
            "lat": 12.99,
            "long": 99.883,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 760504,
            "zip_code": 76130,
            "name_th": "หนองจอก",
            "name_en": "Nong Chok",
            "district_id": 7605,
            "lat": 12.947,
            "long": 99.989,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 760505,
            "zip_code": 76130,
            "name_th": "มาบปลาเค้า",
            "name_en": "Map Pla Khao",
            "district_id": 7605,
            "lat": 12.981,
            "long": 99.929,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 760506,
            "zip_code": 76130,
            "name_th": "ท่าไม้รวก",
            "name_en": "Tha Mai Ruak",
            "district_id": 7605,
            "lat": 12.847,
            "long": 99.814,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 760507,
            "zip_code": 76130,
            "name_th": "วังไคร้",
            "name_en": "Wang Khrai",
            "district_id": 7605,
            "lat": 12.919,
            "long": 99.82,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 760511,
            "zip_code": 76130,
            "name_th": "กลัดหลวง",
            "name_en": "Klat Luang",
            "district_id": 7605,
            "lat": 12.801,
            "long": 99.732,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 760512,
            "zip_code": 76130,
            "name_th": "ปึกเตียน",
            "name_en": "Puek Tian",
            "district_id": 7605,
            "lat": 12.943,
            "long": 100.014,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 760513,
            "zip_code": 76130,
            "name_th": "เขากระปุก",
            "name_en": "Khao Krapuk",
            "district_id": 7605,
            "lat": 12.693,
            "long": 99.728,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 760514,
            "zip_code": 76130,
            "name_th": "ท่าแลง",
            "name_en": "Tha Laeng",
            "district_id": 7605,
            "lat": 12.961,
            "long": 99.832,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 760515,
            "zip_code": 76130,
            "name_th": "บ้านในดง",
            "name_en": "Ban Nai Dong",
            "district_id": 7605,
            "lat": 12.949,
            "long": 99.941,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 7606,
        "name_th": "บ้านลาด",
        "name_en": "Ban Lat",
        "province_id": 61,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 760601,
            "zip_code": 76150,
            "name_th": "บ้านลาด",
            "name_en": "Ban Lat",
            "district_id": 7606,
            "lat": 13.063,
            "long": 99.928,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 760602,
            "zip_code": 76150,
            "name_th": "บ้านหาด",
            "name_en": "Ban Hat",
            "district_id": 7606,
            "lat": 13.076,
            "long": 99.918,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 760603,
            "zip_code": 76150,
            "name_th": "บ้านทาน",
            "name_en": "Ban Than",
            "district_id": 7606,
            "lat": 13.081,
            "long": 99.842,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 760604,
            "zip_code": 76150,
            "name_th": "ตำหรุ",
            "name_en": "Tamru",
            "district_id": 7606,
            "lat": 13.027,
            "long": 99.893,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 760605,
            "zip_code": 76150,
            "name_th": "สมอพลือ",
            "name_en": "Samo Phlue",
            "district_id": 7606,
            "lat": 13.06,
            "long": 99.952,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 760606,
            "zip_code": 76150,
            "name_th": "ไร่มะขาม",
            "name_en": "Rai Makham",
            "district_id": 7606,
            "lat": 13.017,
            "long": 99.939,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 760607,
            "zip_code": 76150,
            "name_th": "ท่าเสน",
            "name_en": "Tha Sen",
            "district_id": 7606,
            "lat": 13.046,
            "long": 99.948,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 760608,
            "zip_code": 76150,
            "name_th": "หนองกระเจ็ด",
            "name_en": "Nong Krachet",
            "district_id": 7606,
            "lat": 13.001,
            "long": 99.953,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 760609,
            "zip_code": 76150,
            "name_th": "หนองกะปุ",
            "name_en": "Nong Kapu",
            "district_id": 7606,
            "lat": 13.065,
            "long": 99.786,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 760610,
            "zip_code": 76150,
            "name_th": "ลาดโพธิ์",
            "name_en": "Lat Pho",
            "district_id": 7606,
            "lat": 13.102,
            "long": 99.895,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 760611,
            "zip_code": 76150,
            "name_th": "สะพานไกร",
            "name_en": "Saphan Krai",
            "district_id": 7606,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 760612,
            "zip_code": 76150,
            "name_th": "ไร่โคก",
            "name_en": "Rai Khok",
            "district_id": 7606,
            "lat": 13.112,
            "long": 99.821,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 760613,
            "zip_code": 76150,
            "name_th": "โรงเข้",
            "name_en": "Rong Khe",
            "district_id": 7606,
            "lat": 13.081,
            "long": 99.891,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 760614,
            "zip_code": 76150,
            "name_th": "ไร่สะท้อน",
            "name_en": "Rai Sathon",
            "district_id": 7606,
            "lat": 13.03,
            "long": 99.866,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 760615,
            "zip_code": 76150,
            "name_th": "ห้วยข้อง",
            "name_en": "Huai Khong",
            "district_id": 7606,
            "lat": 13.035,
            "long": 99.829,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 760616,
            "zip_code": 76150,
            "name_th": "ท่าช้าง",
            "name_en": "Tha Chang",
            "district_id": 7606,
            "lat": 13.057,
            "long": 99.898,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 760617,
            "zip_code": 76150,
            "name_th": "ถ้ำรงค์",
            "name_en": "Tham Rong",
            "district_id": 7606,
            "lat": 13.022,
            "long": 99.911,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 760618,
            "zip_code": 76150,
            "name_th": "ห้วยลึก",
            "name_en": "Huay Lueg",
            "district_id": 7606,
            "lat": 13.008,
            "long": 99.793,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 7607,
        "name_th": "บ้านแหลม",
        "name_en": "Ban Laem",
        "province_id": 61,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 760701,
            "zip_code": 76110,
            "name_th": "บ้านแหลม",
            "name_en": "Ban Laem",
            "district_id": 7607,
            "lat": 13.206,
            "long": 99.98,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 760702,
            "zip_code": 76110,
            "name_th": "บางขุนไทร",
            "name_en": "Bang Khun Sai",
            "district_id": 7607,
            "lat": 13.161,
            "long": 100.018,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 760703,
            "zip_code": 76110,
            "name_th": "ปากทะเล",
            "name_en": "Pak Thale",
            "district_id": 7607,
            "lat": 13.144,
            "long": 100.04,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 760704,
            "zip_code": 76110,
            "name_th": "บางแก้ว",
            "name_en": "Bang Kaeo",
            "district_id": 7607,
            "lat": 13.111,
            "long": 100.045,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 760705,
            "zip_code": 76100,
            "name_th": "แหลมผักเบี้ย",
            "name_en": "Laem Phak Bia",
            "district_id": 7607,
            "lat": 13.044,
            "long": 100.076,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 760706,
            "zip_code": 76110,
            "name_th": "บางตะบูน",
            "name_en": "Bang Tabun",
            "district_id": 7607,
            "lat": 13.259,
            "long": 99.912,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 760707,
            "zip_code": 76110,
            "name_th": "บางตะบูนออก",
            "name_en": "Bang Tabun Ok",
            "district_id": 7607,
            "lat": 13.247,
            "long": 99.95,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 760708,
            "zip_code": 76110,
            "name_th": "บางครก",
            "name_en": "Bang Khrok",
            "district_id": 7607,
            "lat": 13.204,
            "long": 99.933,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 760709,
            "zip_code": 76110,
            "name_th": "ท่าแร้ง",
            "name_en": "Tha Raeng",
            "district_id": 7607,
            "lat": 13.159,
            "long": 99.96,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 760710,
            "zip_code": 76110,
            "name_th": "ท่าแร้งออก",
            "name_en": "Tha Raeng Ok",
            "district_id": 7607,
            "lat": 13.155,
            "long": 99.976,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 7608,
        "name_th": "แก่งกระจาน",
        "name_en": "Kaeng Krachan",
        "province_id": 61,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 760801,
            "zip_code": 76170,
            "name_th": "แก่งกระจาน",
            "name_en": "Kaeng Krachan",
            "district_id": 7608,
            "lat": 12.979,
            "long": 99.609,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 760802,
            "zip_code": 76170,
            "name_th": "สองพี่น้อง",
            "name_en": "Song Phi Nong",
            "district_id": 7608,
            "lat": 12.853,
            "long": 99.614,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 760803,
            "zip_code": 76170,
            "name_th": "วังจันทร์",
            "name_en": "Wang Chan",
            "district_id": 7608,
            "lat": 12.942,
            "long": 99.735,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 760804,
            "zip_code": 76170,
            "name_th": "ป่าเด็ง",
            "name_en": "Pa Deng",
            "district_id": 7608,
            "lat": 12.651,
            "long": 99.48,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 760805,
            "zip_code": 76170,
            "name_th": "พุสวรรค์",
            "name_en": "Phu Sawan",
            "district_id": 7608,
            "lat": 12.997,
            "long": 99.743,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 760806,
            "zip_code": 76170,
            "name_th": "ห้วยแม่เพรียง",
            "name_en": "Huai Mae Phriang",
            "district_id": 7608,
            "lat": 12.913,
            "long": 99.284,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      }
    ]
  },
  {
    "id": 62,
    "name_th": "ประจวบคีรีขันธ์",
    "name_en": "Prachuap Khiri Khan",
    "geography_id": 4,
    "created_at": "2019-08-09T03:33:09.000+07:00",
    "updated_at": "2025-09-20T06:31:26.000+07:00",
    "deleted_at": null,
    "districts": [
      {
        "id": 7701,
        "name_th": "เมืองประจวบคีรีขันธ์",
        "name_en": "Mueang Prachuap Khiri Khan",
        "province_id": 62,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 770101,
            "zip_code": 77000,
            "name_th": "ประจวบคีรีขันธ์",
            "name_en": "Prachuap Khiri Khan",
            "district_id": 7701,
            "lat": 11.805,
            "long": 99.784,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 770102,
            "zip_code": 77000,
            "name_th": "เกาะหลัก",
            "name_en": "Ko Lak",
            "district_id": 7701,
            "lat": 11.808,
            "long": 99.729,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 770103,
            "zip_code": 77000,
            "name_th": "คลองวาฬ",
            "name_en": "Khlong Wan",
            "district_id": 7701,
            "lat": 11.756,
            "long": 99.725,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 770104,
            "zip_code": 77000,
            "name_th": "ห้วยทราย",
            "name_en": "Huai Sai",
            "district_id": 7701,
            "lat": 11.709,
            "long": 99.672,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 770105,
            "zip_code": 77000,
            "name_th": "อ่าวน้อย",
            "name_en": "Ao Noi",
            "district_id": 7701,
            "lat": 11.904,
            "long": 99.701,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 770106,
            "zip_code": 77210,
            "name_th": "บ่อนอก",
            "name_en": "Bo Nok",
            "district_id": 7701,
            "lat": 11.996,
            "long": 99.771,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 7702,
        "name_th": "กุยบุรี",
        "name_en": "Kui Buri",
        "province_id": 62,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 770201,
            "zip_code": 77150,
            "name_th": "กุยบุรี",
            "name_en": "Kui Buri",
            "district_id": 7702,
            "lat": 12.052,
            "long": 99.763,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 770202,
            "zip_code": 77150,
            "name_th": "กุยเหนือ",
            "name_en": "Kui Nuea",
            "district_id": 7702,
            "lat": 12.086,
            "long": 99.908,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 770203,
            "zip_code": 77150,
            "name_th": "เขาแดง",
            "name_en": "Khao Daeng",
            "district_id": 7702,
            "lat": 12.159,
            "long": 99.98,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 770204,
            "zip_code": 77150,
            "name_th": "ดอนยายหนู",
            "name_en": "Don Yai Nu",
            "district_id": 7702,
            "lat": 12.136,
            "long": 99.929,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 770206,
            "zip_code": 77150,
            "name_th": "สามกระทาย",
            "name_en": "Sam Krathai",
            "district_id": 7702,
            "lat": 12.148,
            "long": 99.843,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 770207,
            "zip_code": 77150,
            "name_th": "หาดขาม",
            "name_en": "Hat Kham",
            "district_id": 7702,
            "lat": 12.108,
            "long": 99.659,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 7703,
        "name_th": "ทับสะแก",
        "name_en": "Thap Sakae",
        "province_id": 62,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 770301,
            "zip_code": 77130,
            "name_th": "ทับสะแก",
            "name_en": "Thap Sakae",
            "district_id": 7703,
            "lat": 11.516,
            "long": 99.627,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 770302,
            "zip_code": 77130,
            "name_th": "อ่างทอง",
            "name_en": "Ang Thong",
            "district_id": 7703,
            "lat": 11.454,
            "long": 99.508,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 770303,
            "zip_code": 77130,
            "name_th": "นาหูกวาง",
            "name_en": "Na Hukwang",
            "district_id": 7703,
            "lat": 11.537,
            "long": 99.499,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 770304,
            "zip_code": 77130,
            "name_th": "เขาล้าน",
            "name_en": "Khao Lan",
            "district_id": 7703,
            "lat": 11.606,
            "long": 99.501,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 770305,
            "zip_code": 77130,
            "name_th": "ห้วยยาง",
            "name_en": "Huai Yang",
            "district_id": 7703,
            "lat": 11.637,
            "long": 99.641,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 770306,
            "zip_code": 77130,
            "name_th": "แสงอรุณ",
            "name_en": "Saeng Arun",
            "district_id": 7703,
            "lat": 11.573,
            "long": 99.628,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 7704,
        "name_th": "บางสะพาน",
        "name_en": "Bang Saphan",
        "province_id": 62,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 770401,
            "zip_code": 77140,
            "name_th": "กำเนิดนพคุณ",
            "name_en": "Kamnoet Nopphakhun",
            "district_id": 7704,
            "lat": 11.248,
            "long": 99.516,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 770402,
            "zip_code": 77140,
            "name_th": "พงศ์ประศาสน์",
            "name_en": "Phong Prasat",
            "district_id": 7704,
            "lat": 11.188,
            "long": 99.466,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 770403,
            "zip_code": 77230,
            "name_th": "ร่อนทอง",
            "name_en": "Ron Thong",
            "district_id": 7704,
            "lat": 11.299,
            "long": 99.393,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 770404,
            "zip_code": 77190,
            "name_th": "ธงชัย",
            "name_en": "Thong Chai",
            "district_id": 7704,
            "lat": 11.318,
            "long": 99.525,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 770405,
            "zip_code": 77190,
            "name_th": "ชัยเกษม",
            "name_en": "Chai Kasem",
            "district_id": 7704,
            "lat": 11.375,
            "long": 99.473,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 770406,
            "zip_code": 77230,
            "name_th": "ทองมงคล",
            "name_en": "Thong Mongkhon",
            "district_id": 7704,
            "lat": 11.204,
            "long": 99.369,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 770407,
            "zip_code": 77140,
            "name_th": "แม่รำพึง",
            "name_en": "Mae Ramphueng",
            "district_id": 7704,
            "lat": 11.227,
            "long": 99.544,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 7705,
        "name_th": "บางสะพานน้อย",
        "name_en": "Bang Saphan Noi",
        "province_id": 62,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 770501,
            "zip_code": 77170,
            "name_th": "ปากแพรก",
            "name_en": "Pak Phraek",
            "district_id": 7705,
            "lat": 11.063,
            "long": 99.436,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 770502,
            "zip_code": 77170,
            "name_th": "บางสะพาน",
            "name_en": "Bang Saphan",
            "district_id": 7705,
            "lat": 11.107,
            "long": 99.443,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 770503,
            "zip_code": 77170,
            "name_th": "ทรายทอง",
            "name_en": "Sai Thong",
            "district_id": 7705,
            "lat": 11.011,
            "long": 99.424,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 770504,
            "zip_code": 77170,
            "name_th": "ช้างแรก",
            "name_en": "Chang Raek",
            "district_id": 7705,
            "lat": 11.103,
            "long": 99.306,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 770505,
            "zip_code": 77170,
            "name_th": "ไชยราช",
            "name_en": "Chaiyarat",
            "district_id": 7705,
            "lat": 11.012,
            "long": 99.256,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 7706,
        "name_th": "ปราณบุรี",
        "name_en": "Pran Buri",
        "province_id": 62,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 770601,
            "zip_code": 77120,
            "name_th": "ปราณบุรี",
            "name_en": "Pran Buri",
            "district_id": 7706,
            "lat": 12.354,
            "long": 99.932,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 770602,
            "zip_code": 77120,
            "name_th": "เขาน้อย",
            "name_en": "Khao Noi",
            "district_id": 7706,
            "lat": 12.405,
            "long": 99.898,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 770604,
            "zip_code": 77220,
            "name_th": "ปากน้ำปราณ",
            "name_en": "Pak Nam Pran",
            "district_id": 7706,
            "lat": 12.381,
            "long": 99.981,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 770607,
            "zip_code": 77120,
            "name_th": "หนองตาแต้ม",
            "name_en": "Nong Ta Taem",
            "district_id": 7706,
            "lat": 12.38,
            "long": 99.814,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 770608,
            "zip_code": 77120,
            "name_th": "วังก์พง",
            "name_en": "Wang Phong",
            "district_id": 7706,
            "lat": 12.447,
            "long": 99.911,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 770609,
            "zip_code": 77120,
            "name_th": "เขาจ้าว",
            "name_en": "Khao Chao",
            "district_id": 7706,
            "lat": 12.396,
            "long": 99.52,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 7707,
        "name_th": "หัวหิน",
        "name_en": "Hua Hin",
        "province_id": 62,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 770701,
            "zip_code": 77110,
            "name_th": "หัวหิน",
            "name_en": "Hua Hin",
            "district_id": 7707,
            "lat": 12.592,
            "long": 99.94,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 770702,
            "zip_code": 77110,
            "name_th": "หนองแก",
            "name_en": "Nong Kae",
            "district_id": 7707,
            "lat": 12.502,
            "long": 99.958,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 770703,
            "zip_code": 77110,
            "name_th": "หินเหล็กไฟ",
            "name_en": "Hin Lek Fai",
            "district_id": 7707,
            "lat": 12.592,
            "long": 99.862,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 770704,
            "zip_code": 77110,
            "name_th": "หนองพลับ",
            "name_en": "Nong Phlap",
            "district_id": 7707,
            "lat": 12.53,
            "long": 99.704,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 770705,
            "zip_code": 77110,
            "name_th": "ทับใต้",
            "name_en": "Thap Tai",
            "district_id": 7707,
            "lat": 12.516,
            "long": 99.863,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 770706,
            "zip_code": 77110,
            "name_th": "ห้วยสัตว์ใหญ่",
            "name_en": "Huai Sat Yai",
            "district_id": 7707,
            "lat": 12.512,
            "long": 99.526,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 770707,
            "zip_code": 77110,
            "name_th": "บึงนคร",
            "name_en": "Bueng Nakhon",
            "district_id": 7707,
            "lat": 12.403,
            "long": 99.655,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 7708,
        "name_th": "สามร้อยยอด",
        "name_en": "Sam Roi Yot",
        "province_id": 62,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 770801,
            "zip_code": 77120,
            "name_th": "สามร้อยยอด",
            "name_en": "Sam Roi Yot",
            "district_id": 7708,
            "lat": 12.266,
            "long": 99.946,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 770802,
            "zip_code": 77180,
            "name_th": "ศิลาลอย",
            "name_en": "Sila Loi",
            "district_id": 7708,
            "lat": 12.309,
            "long": 99.56,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 770803,
            "zip_code": 77180,
            "name_th": "ไร่เก่า",
            "name_en": "Rai Kao",
            "district_id": 7708,
            "lat": 12.252,
            "long": 99.706,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 770804,
            "zip_code": 77180,
            "name_th": "ศาลาลัย",
            "name_en": "Salalai",
            "district_id": 7708,
            "lat": 12.271,
            "long": 99.593,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 770805,
            "zip_code": 77180,
            "name_th": "ไร่ใหม่",
            "name_en": "Rai Mai",
            "district_id": 7708,
            "lat": 12.214,
            "long": 99.746,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      }
    ]
  },
  {
    "id": 63,
    "name_th": "นครศรีธรรมราช",
    "name_en": "Nakhon Si Thammarat",
    "geography_id": 6,
    "created_at": "2019-08-09T03:33:09.000+07:00",
    "updated_at": "2025-09-20T06:31:26.000+07:00",
    "deleted_at": null,
    "districts": [
      {
        "id": 8001,
        "name_th": "เมืองนครศรีธรรมราช",
        "name_en": "Mueang Nakhon Si Thammarat",
        "province_id": 63,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 800101,
            "zip_code": 80000,
            "name_th": "ในเมือง",
            "name_en": "Nai Mueang",
            "district_id": 8001,
            "lat": 8.408,
            "long": 99.972,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 800102,
            "zip_code": 80000,
            "name_th": "ท่าวัง",
            "name_en": "Tha Wang",
            "district_id": 8001,
            "lat": 8.449,
            "long": 99.961,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 800103,
            "zip_code": 80000,
            "name_th": "คลัง",
            "name_en": "Khlang",
            "district_id": 8001,
            "lat": 8.434,
            "long": 99.966,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 800106,
            "zip_code": 80000,
            "name_th": "ท่าไร่",
            "name_en": "Tha Rai",
            "district_id": 8001,
            "lat": 8.43,
            "long": 100.041,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 800107,
            "zip_code": 80000,
            "name_th": "ปากนคร",
            "name_en": "Pak Nakhon",
            "district_id": 8001,
            "lat": 8.421,
            "long": 99.996,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 800108,
            "zip_code": 80280,
            "name_th": "นาทราย",
            "name_en": "Na Sai",
            "district_id": 8001,
            "lat": 8.479,
            "long": 99.932,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 800112,
            "zip_code": 80280,
            "name_th": "กำแพงเซา",
            "name_en": "Kamphaeng Sao",
            "district_id": 8001,
            "lat": 8.401,
            "long": 99.868,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 800113,
            "zip_code": 80000,
            "name_th": "ไชยมนตรี",
            "name_en": "Chai Montri",
            "district_id": 8001,
            "lat": 8.401,
            "long": 99.914,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 800114,
            "zip_code": 80000,
            "name_th": "มะม่วงสองต้น",
            "name_en": "Mamuang Song Ton",
            "district_id": 8001,
            "lat": 8.397,
            "long": 99.952,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 800115,
            "zip_code": 80000,
            "name_th": "นาเคียน",
            "name_en": "Na Khian",
            "district_id": 8001,
            "lat": 8.452,
            "long": 99.919,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 800116,
            "zip_code": 80280,
            "name_th": "ท่างิ้ว",
            "name_en": "Tha Ngio",
            "district_id": 8001,
            "lat": 8.452,
            "long": 99.835,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 800118,
            "zip_code": 80000,
            "name_th": "โพธิ์เสด็จ",
            "name_en": "Pho Sadet",
            "district_id": 8001,
            "lat": 8.428,
            "long": 99.92,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 800119,
            "zip_code": 80330,
            "name_th": "บางจาก",
            "name_en": "Bang Chak",
            "district_id": 8001,
            "lat": 8.376,
            "long": 100.061,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 800120,
            "zip_code": 80000,
            "name_th": "ปากพูน",
            "name_en": "Pak Phun",
            "district_id": 8001,
            "lat": 8.529,
            "long": 99.997,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 800121,
            "zip_code": 80000,
            "name_th": "ท่าซัก",
            "name_en": "Tha Sak",
            "district_id": 8001,
            "lat": 8.51,
            "long": 100.032,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 800122,
            "zip_code": 80290,
            "name_th": "ท่าเรือ",
            "name_en": "Tha Ruea",
            "district_id": 8001,
            "lat": 8.321,
            "long": 100.013,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 8002,
        "name_th": "พรหมคีรี",
        "name_en": "Phrom Khiri",
        "province_id": 63,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 800201,
            "zip_code": 80320,
            "name_th": "พรหมโลก",
            "name_en": "Phrommalok",
            "district_id": 8002,
            "lat": 8.5,
            "long": 99.793,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 800202,
            "zip_code": 80320,
            "name_th": "บ้านเกาะ",
            "name_en": "Ban Ko",
            "district_id": 8002,
            "lat": 8.539,
            "long": 99.814,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 800203,
            "zip_code": 80320,
            "name_th": "อินคีรี",
            "name_en": "In Khiri",
            "district_id": 8002,
            "lat": 8.54,
            "long": 99.874,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 800204,
            "zip_code": 80320,
            "name_th": "ทอนหงส์",
            "name_en": "Thon Hong",
            "district_id": 8002,
            "lat": 8.58,
            "long": 99.776,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 800205,
            "zip_code": 80320,
            "name_th": "นาเรียง",
            "name_en": "Na Reang",
            "district_id": 8002,
            "lat": 8.504,
            "long": 99.866,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 8003,
        "name_th": "ลานสกา",
        "name_en": "Lan Saka",
        "province_id": 63,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 800301,
            "zip_code": 80230,
            "name_th": "เขาแก้ว",
            "name_en": "Khao Kaeo",
            "district_id": 8003,
            "lat": 8.374,
            "long": 99.742,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 800302,
            "zip_code": 80230,
            "name_th": "ลานสกา",
            "name_en": "Lan Saka",
            "district_id": 8003,
            "lat": 8.305,
            "long": 99.771,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 800303,
            "zip_code": 80230,
            "name_th": "ท่าดี",
            "name_en": "Tha Di",
            "district_id": 8003,
            "lat": 8.443,
            "long": 99.804,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 800304,
            "zip_code": 80230,
            "name_th": "กำโลน",
            "name_en": "Kamlon",
            "district_id": 8003,
            "lat": 8.442,
            "long": 99.757,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 800305,
            "zip_code": 80230,
            "name_th": "ขุนทะเล",
            "name_en": "Khun Thale",
            "district_id": 8003,
            "lat": 8.344,
            "long": 99.848,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 8004,
        "name_th": "ฉวาง",
        "name_en": "Chawang",
        "province_id": 63,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 800401,
            "zip_code": 80150,
            "name_th": "ฉวาง",
            "name_en": "Chawang",
            "district_id": 8004,
            "lat": 8.397,
            "long": 99.501,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 800403,
            "zip_code": 80250,
            "name_th": "ละอาย",
            "name_en": "La-ai",
            "district_id": 8004,
            "lat": 8.472,
            "long": 99.632,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 800404,
            "zip_code": 80260,
            "name_th": "นาแว",
            "name_en": "Na Wae",
            "district_id": 8004,
            "lat": 8.483,
            "long": 99.523,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 800405,
            "zip_code": 80150,
            "name_th": "ไม้เรียง",
            "name_en": "Mai Riang",
            "district_id": 8004,
            "lat": 8.457,
            "long": 99.477,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 800406,
            "zip_code": 80260,
            "name_th": "กะเปียด",
            "name_en": "Kapiat",
            "district_id": 8004,
            "lat": 8.519,
            "long": 99.46,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 800407,
            "zip_code": 80150,
            "name_th": "นากะชะ",
            "name_en": "Na Kacha",
            "district_id": 8004,
            "lat": 8.415,
            "long": 99.476,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 800409,
            "zip_code": 80260,
            "name_th": "ห้วยปริก",
            "name_en": "Huai Prik",
            "district_id": 8004,
            "lat": 8.569,
            "long": 99.44,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 800410,
            "zip_code": 80150,
            "name_th": "ไสหร้า",
            "name_en": "Saira",
            "district_id": 8004,
            "lat": 8.437,
            "long": 99.547,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 800415,
            "zip_code": 80260,
            "name_th": "นาเขลียง",
            "name_en": "Na Khliang",
            "district_id": 8004,
            "lat": 8.533,
            "long": 99.5,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 800416,
            "zip_code": 80250,
            "name_th": "จันดี",
            "name_en": "Chan Di",
            "district_id": 8004,
            "lat": 8.391,
            "long": 99.554,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 8005,
        "name_th": "พิปูน",
        "name_en": "Phipun",
        "province_id": 63,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 800501,
            "zip_code": 80270,
            "name_th": "พิปูน",
            "name_en": "Phipun",
            "district_id": 8005,
            "lat": 8.555,
            "long": 99.653,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 800502,
            "zip_code": 80270,
            "name_th": "กะทูน",
            "name_en": "Kathun",
            "district_id": 8005,
            "lat": 8.638,
            "long": 99.53,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 800503,
            "zip_code": 80270,
            "name_th": "เขาพระ",
            "name_en": "Khao Phra",
            "district_id": 8005,
            "lat": 8.634,
            "long": 99.615,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 800504,
            "zip_code": 80270,
            "name_th": "ยางค้อม",
            "name_en": "Yang Khom",
            "district_id": 8005,
            "lat": 8.52,
            "long": 99.701,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 800505,
            "zip_code": 80270,
            "name_th": "ควนกลาง",
            "name_en": "Khuan Klang",
            "district_id": 8005,
            "lat": 8.534,
            "long": 99.553,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 8006,
        "name_th": "เชียรใหญ่",
        "name_en": "Chian Yai",
        "province_id": 63,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 800601,
            "zip_code": 80190,
            "name_th": "เชียรใหญ่",
            "name_en": "Chian Yai",
            "district_id": 8006,
            "lat": 8.202,
            "long": 100.116,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 800603,
            "zip_code": 80190,
            "name_th": "ท่าขนาน",
            "name_en": "Tha Khanan",
            "district_id": 8006,
            "lat": 8.14,
            "long": 100.165,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 800604,
            "zip_code": 80190,
            "name_th": "บ้านกลาง",
            "name_en": "Ban Klang",
            "district_id": 8006,
            "lat": 8.156,
            "long": 100.197,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 800605,
            "zip_code": 80190,
            "name_th": "บ้านเนิน",
            "name_en": "Ban Noen",
            "district_id": 8006,
            "lat": 8.166,
            "long": 100.17,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 800606,
            "zip_code": 80190,
            "name_th": "ไสหมาก",
            "name_en": "Sai Mak",
            "district_id": 8006,
            "lat": 8.203,
            "long": 100.163,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 800607,
            "zip_code": 80190,
            "name_th": "ท้องลำเจียก",
            "name_en": "Thong Lamchiak",
            "district_id": 8006,
            "lat": 8.147,
            "long": 100.117,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 800610,
            "zip_code": 80190,
            "name_th": "เสือหึง",
            "name_en": "Suea Hueng",
            "district_id": 8006,
            "lat": 8.189,
            "long": 100.242,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 800611,
            "zip_code": 80190,
            "name_th": "การะเกด",
            "name_en": "Karaket",
            "district_id": 8006,
            "lat": 8.073,
            "long": 100.154,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 800612,
            "zip_code": 80190,
            "name_th": "เขาพระบาท",
            "name_en": "Khao Phra Bat",
            "district_id": 8006,
            "lat": 8.084,
            "long": 100.191,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 800613,
            "zip_code": 80190,
            "name_th": "แม่เจ้าอยู่หัว",
            "name_en": "Mae Chao Yu Hua",
            "district_id": 8006,
            "lat": 8.075,
            "long": 100.094,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 8007,
        "name_th": "ชะอวด",
        "name_en": "Cha-uat",
        "province_id": 63,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 800701,
            "zip_code": 80180,
            "name_th": "ชะอวด",
            "name_en": "Cha-uat",
            "district_id": 8007,
            "lat": 7.996,
            "long": 100.02,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 800702,
            "zip_code": 80180,
            "name_th": "ท่าเสม็ด",
            "name_en": "Tha Samet",
            "district_id": 8007,
            "lat": 7.949,
            "long": 100.017,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 800703,
            "zip_code": 80180,
            "name_th": "ท่าประจะ",
            "name_en": "Tha Pracha",
            "district_id": 8007,
            "lat": 7.973,
            "long": 99.96,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 800704,
            "zip_code": 80180,
            "name_th": "เคร็ง",
            "name_en": "Khreng",
            "district_id": 8007,
            "lat": 7.952,
            "long": 100.103,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 800705,
            "zip_code": 80180,
            "name_th": "วังอ่าง",
            "name_en": "Wang Ang",
            "district_id": 8007,
            "lat": 7.927,
            "long": 99.886,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 800706,
            "zip_code": 80180,
            "name_th": "บ้านตูล",
            "name_en": "Ban Tun",
            "district_id": 8007,
            "lat": 8.07,
            "long": 100.0,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 800707,
            "zip_code": 80180,
            "name_th": "ขอนหาด",
            "name_en": "Khon Hat",
            "district_id": 8007,
            "lat": 7.872,
            "long": 100.059,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 800708,
            "zip_code": 80180,
            "name_th": "เกาะขันธ์",
            "name_en": "Khuan Nong Hong",
            "district_id": 8007,
            "lat": 7.91,
            "long": 99.935,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 800709,
            "zip_code": 80180,
            "name_th": "ควนหนองหงษ์",
            "name_en": "Khao Phra Thong",
            "district_id": 8007,
            "lat": 8.009,
            "long": 99.885,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 800710,
            "zip_code": 80180,
            "name_th": "เขาพระทอง",
            "name_en": "Nang Long",
            "district_id": 8007,
            "lat": 7.974,
            "long": 99.905,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 800711,
            "zip_code": 80180,
            "name_th": "นางหลง",
            "name_en": "Nang Long",
            "district_id": 8007,
            "lat": 7.901,
            "long": 99.988,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 8008,
        "name_th": "ท่าศาลา",
        "name_en": "Tha Sala",
        "province_id": 63,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 800801,
            "zip_code": 80160,
            "name_th": "ท่าศาลา",
            "name_en": "Tha Sala",
            "district_id": 8008,
            "lat": 8.669,
            "long": 99.926,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 800802,
            "zip_code": 80160,
            "name_th": "กลาย",
            "name_en": "Klai",
            "district_id": 8008,
            "lat": 8.812,
            "long": 99.902,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 800803,
            "zip_code": 80160,
            "name_th": "ท่าขึ้น",
            "name_en": "Tha Khuen",
            "district_id": 8008,
            "lat": 8.714,
            "long": 99.887,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 800804,
            "zip_code": 80160,
            "name_th": "หัวตะพาน",
            "name_en": "Hua Taphan",
            "district_id": 8008,
            "lat": 8.628,
            "long": 99.889,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 800806,
            "zip_code": 80160,
            "name_th": "สระแก้ว",
            "name_en": "Sa Kaeo",
            "district_id": 8008,
            "lat": 8.752,
            "long": 99.867,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 800807,
            "zip_code": 80160,
            "name_th": "โมคลาน",
            "name_en": "Mokkhalan",
            "district_id": 8008,
            "lat": 8.589,
            "long": 99.885,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 800809,
            "zip_code": 80160,
            "name_th": "ไทยบุรี",
            "name_en": "Thai buri",
            "district_id": 8008,
            "lat": 8.665,
            "long": 99.879,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 800810,
            "zip_code": 80160,
            "name_th": "ดอนตะโก",
            "name_en": "Don tako",
            "district_id": 8008,
            "lat": 8.56,
            "long": 99.903,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 800811,
            "zip_code": 80160,
            "name_th": "ตลิ่งชัน",
            "name_en": "Taling Chan",
            "district_id": 8008,
            "lat": 8.783,
            "long": 99.821,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 800813,
            "zip_code": 80160,
            "name_th": "โพธิ์ทอง",
            "name_en": "Pho Thong",
            "district_id": 8008,
            "lat": 8.613,
            "long": 99.923,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 8009,
        "name_th": "ทุ่งสง",
        "name_en": "Thung Song",
        "province_id": 63,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 800901,
            "zip_code": 80110,
            "name_th": "ปากแพรก",
            "name_en": "Pak Phraek",
            "district_id": 8009,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 800902,
            "zip_code": 80110,
            "name_th": "ชะมาย",
            "name_en": "Chamai",
            "district_id": 8009,
            "lat": 8.148,
            "long": 99.673,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 800903,
            "zip_code": 80110,
            "name_th": "หนองหงส์",
            "name_en": "Nong Hong",
            "district_id": 8009,
            "lat": 8.195,
            "long": 99.614,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 800904,
            "zip_code": 80110,
            "name_th": "ควนกรด",
            "name_en": "Khuan Krot",
            "district_id": 8009,
            "lat": 8.149,
            "long": 99.632,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 800905,
            "zip_code": 80110,
            "name_th": "นาไม้ไผ่",
            "name_en": "Na Mai Phai",
            "district_id": 8009,
            "lat": 8.119,
            "long": 99.59,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 800906,
            "zip_code": 80110,
            "name_th": "นาหลวงเสน",
            "name_en": "Na Luang Sen",
            "district_id": 8009,
            "lat": 8.24,
            "long": 99.705,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 800907,
            "zip_code": 80110,
            "name_th": "เขาโร",
            "name_en": "Khao Ro",
            "district_id": 8009,
            "lat": 8.047,
            "long": 99.594,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 800908,
            "zip_code": 80310,
            "name_th": "กะปาง",
            "name_en": "Kapang",
            "district_id": 8009,
            "lat": 8.029,
            "long": 99.683,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 800909,
            "zip_code": 80110,
            "name_th": "ที่วัง",
            "name_en": "Thi Wang",
            "district_id": 8009,
            "lat": 8.099,
            "long": 99.67,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 800910,
            "zip_code": 80110,
            "name_th": "น้ำตก",
            "name_en": "Namtok",
            "district_id": 8009,
            "lat": 7.971,
            "long": 99.78,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 800911,
            "zip_code": 80110,
            "name_th": "ถ้ำใหญ่",
            "name_en": "Tham Yai",
            "district_id": 8009,
            "lat": 8.164,
            "long": 99.742,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 800912,
            "zip_code": 80110,
            "name_th": "นาโพธิ์",
            "name_en": "Na Pho",
            "district_id": 8009,
            "lat": 8.209,
            "long": 99.574,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 800913,
            "zip_code": 80110,
            "name_th": "เขาขาว",
            "name_en": "Khao Khao",
            "district_id": 8009,
            "lat": 8.173,
            "long": 99.5,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 8010,
        "name_th": "นาบอน",
        "name_en": "Na Bon",
        "province_id": 63,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 801001,
            "zip_code": 80220,
            "name_th": "นาบอน",
            "name_en": "Na Bon",
            "district_id": 8010,
            "lat": 8.243,
            "long": 99.6,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 801002,
            "zip_code": 80220,
            "name_th": "ทุ่งสง",
            "name_en": "Thung Song",
            "district_id": 8010,
            "lat": 8.255,
            "long": 99.487,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 801003,
            "zip_code": 80220,
            "name_th": "แก้วแสน",
            "name_en": "Kaeo Saen",
            "district_id": 8010,
            "lat": 8.282,
            "long": 99.528,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 8011,
        "name_th": "ทุ่งใหญ่",
        "name_en": "Thung Yai",
        "province_id": 63,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 801101,
            "zip_code": 80240,
            "name_th": "ท่ายาง",
            "name_en": "Tha Yang",
            "district_id": 8011,
            "lat": 8.305,
            "long": 99.346,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 801102,
            "zip_code": 80240,
            "name_th": "ทุ่งสัง",
            "name_en": "Thung Sang",
            "district_id": 8011,
            "lat": 8.372,
            "long": 99.342,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 801103,
            "zip_code": 80240,
            "name_th": "ทุ่งใหญ่",
            "name_en": "Thung Yai",
            "district_id": 8011,
            "lat": 8.366,
            "long": 99.429,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 801104,
            "zip_code": 80240,
            "name_th": "กุแหระ",
            "name_en": "Kurae",
            "district_id": 8011,
            "lat": 8.194,
            "long": 99.337,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 801105,
            "zip_code": 80240,
            "name_th": "ปริก",
            "name_en": "Prik",
            "district_id": 8011,
            "lat": 8.28,
            "long": 99.432,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 801106,
            "zip_code": 80240,
            "name_th": "บางรูป",
            "name_en": "Bang Rup",
            "district_id": 8011,
            "lat": 8.4,
            "long": 99.279,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 801107,
            "zip_code": 80240,
            "name_th": "กรุงหยัน",
            "name_en": "Krung Yan",
            "district_id": 8011,
            "lat": 8.187,
            "long": 99.403,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 8012,
        "name_th": "ปากพนัง",
        "name_en": "Pak Phanang",
        "province_id": 63,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 801201,
            "zip_code": 80140,
            "name_th": "ปากพนัง",
            "name_en": "Pak Phanang",
            "district_id": 8012,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 801202,
            "zip_code": 80330,
            "name_th": "คลองน้อย",
            "name_en": "Khlong Noi",
            "district_id": 8012,
            "lat": 8.358,
            "long": 100.108,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 801203,
            "zip_code": 80140,
            "name_th": "ป่าระกำ",
            "name_en": "Pa Rakam",
            "district_id": 8012,
            "lat": 8.244,
            "long": 100.12,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 801204,
            "zip_code": 80330,
            "name_th": "ชะเมา",
            "name_en": "Chamao",
            "district_id": 8012,
            "lat": 8.275,
            "long": 100.054,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 801205,
            "zip_code": 80140,
            "name_th": "คลองกระบือ",
            "name_en": "Khlong Krabue",
            "district_id": 8012,
            "lat": 8.317,
            "long": 100.143,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 801206,
            "zip_code": 80330,
            "name_th": "เกาะทวด",
            "name_en": "Ko Thuat",
            "district_id": 8012,
            "lat": 8.283,
            "long": 100.092,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 801207,
            "zip_code": 80140,
            "name_th": "บ้านใหม่",
            "name_en": "Ban Mai",
            "district_id": 8012,
            "lat": 8.277,
            "long": 100.154,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 801208,
            "zip_code": 80140,
            "name_th": "หูล่อง",
            "name_en": "Hu Long",
            "district_id": 8012,
            "lat": 8.314,
            "long": 100.184,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 801209,
            "zip_code": 80140,
            "name_th": "แหลมตะลุมพุก",
            "name_en": "Laem Talumphuk",
            "district_id": 8012,
            "lat": 8.458,
            "long": 100.196,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 801210,
            "zip_code": 80140,
            "name_th": "ปากพนังฝั่งตะวันตก",
            "name_en": "Pak Phanang Fang Tawantok",
            "district_id": 8012,
            "lat": 8.36,
            "long": 100.165,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 801211,
            "zip_code": 80140,
            "name_th": "บางศาลา",
            "name_en": "Bang Sala",
            "district_id": 8012,
            "lat": 8.246,
            "long": 100.185,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 801212,
            "zip_code": 80140,
            "name_th": "บางพระ",
            "name_en": "Bang Phra",
            "district_id": 8012,
            "lat": 8.326,
            "long": 100.23,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 801213,
            "zip_code": 80140,
            "name_th": "บางตะพง",
            "name_en": "Bang Taphong",
            "district_id": 8012,
            "lat": 8.232,
            "long": 100.153,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 801214,
            "zip_code": 80140,
            "name_th": "ปากพนังฝั่งตะวันออก",
            "name_en": "Pak Phanang Fang Tawan-ok",
            "district_id": 8012,
            "lat": 8.397,
            "long": 100.2,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 801215,
            "zip_code": 80140,
            "name_th": "บ้านเพิง",
            "name_en": "Ban Phoeng",
            "district_id": 8012,
            "lat": 8.294,
            "long": 100.227,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 801216,
            "zip_code": 80140,
            "name_th": "ท่าพยา",
            "name_en": "Tha Phaya",
            "district_id": 8012,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 801217,
            "zip_code": 80140,
            "name_th": "ปากแพรก",
            "name_en": "Pak Phraek",
            "district_id": 8012,
            "lat": 8.244,
            "long": 100.212,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 801218,
            "zip_code": 80140,
            "name_th": "ขนาบนาก",
            "name_en": "Khanap Nak",
            "district_id": 8012,
            "lat": 8.22,
            "long": 100.247,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 8013,
        "name_th": "ร่อนพิบูลย์",
        "name_en": "Ron Phibun",
        "province_id": 63,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 801301,
            "zip_code": 80130,
            "name_th": "ร่อนพิบูลย์",
            "name_en": "Ron Phibun",
            "district_id": 8013,
            "lat": 8.189,
            "long": 99.832,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 801302,
            "zip_code": 80350,
            "name_th": "หินตก",
            "name_en": "Hin Tok",
            "district_id": 8013,
            "lat": 8.237,
            "long": 99.88,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 801303,
            "zip_code": 80350,
            "name_th": "เสาธง",
            "name_en": "Sao Thong",
            "district_id": 8013,
            "lat": 8.252,
            "long": 99.924,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 801304,
            "zip_code": 80130,
            "name_th": "ควนเกย",
            "name_en": "Khuan Koei",
            "district_id": 8013,
            "lat": 8.14,
            "long": 99.9,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 801305,
            "zip_code": 80130,
            "name_th": "ควนพัง",
            "name_en": "Khuan Phang",
            "district_id": 8013,
            "lat": 8.159,
            "long": 99.977,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 801306,
            "zip_code": 80130,
            "name_th": "ควนชุม",
            "name_en": "Khuan Chum",
            "district_id": 8013,
            "lat": 8.183,
            "long": 99.919,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 8014,
        "name_th": "สิชล",
        "name_en": "Sichon",
        "province_id": 63,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 801401,
            "zip_code": 80120,
            "name_th": "สิชล",
            "name_en": "Sichon",
            "district_id": 8014,
            "lat": 9.008,
            "long": 99.902,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 801402,
            "zip_code": 80120,
            "name_th": "ทุ่งปรัง",
            "name_en": "Thung Prang",
            "district_id": 8014,
            "lat": 8.958,
            "long": 99.876,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 801403,
            "zip_code": 80120,
            "name_th": "ฉลอง",
            "name_en": "Chalong",
            "district_id": 8014,
            "lat": 8.89,
            "long": 99.773,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 801404,
            "zip_code": 80340,
            "name_th": "เสาเภา",
            "name_en": "Sao Phao",
            "district_id": 8014,
            "lat": 8.89,
            "long": 99.904,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 801405,
            "zip_code": 80120,
            "name_th": "เปลี่ยน",
            "name_en": "Plian",
            "district_id": 8014,
            "lat": 8.833,
            "long": 99.87,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 801406,
            "zip_code": 80120,
            "name_th": "สี่ขีด",
            "name_en": "Si Khit",
            "district_id": 8014,
            "lat": 9.023,
            "long": 99.786,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 801407,
            "zip_code": 80340,
            "name_th": "เทพราช",
            "name_en": "Theppharat",
            "district_id": 8014,
            "lat": 8.841,
            "long": 99.735,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 801408,
            "zip_code": 80120,
            "name_th": "เขาน้อย",
            "name_en": "Khao Noi",
            "district_id": 8014,
            "lat": 8.945,
            "long": 99.787,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 801409,
            "zip_code": 80120,
            "name_th": "ทุ่งใส",
            "name_en": "Thung Sai",
            "district_id": 8014,
            "lat": 9.06,
            "long": 99.89,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 8015,
        "name_th": "ขนอม",
        "name_en": "Khanom",
        "province_id": 63,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 801501,
            "zip_code": 80210,
            "name_th": "ขนอม",
            "name_en": "Khanom",
            "district_id": 8015,
            "lat": 9.166,
            "long": 99.838,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 801502,
            "zip_code": 80210,
            "name_th": "ควนทอง",
            "name_en": "Khuan Thong",
            "district_id": 8015,
            "lat": 9.181,
            "long": 99.782,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 801503,
            "zip_code": 80210,
            "name_th": "ท้องเนียน",
            "name_en": "Thong Nian",
            "district_id": 8015,
            "lat": 9.324,
            "long": 99.775,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 8016,
        "name_th": "หัวไทร",
        "name_en": "Hua Sai",
        "province_id": 63,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 801601,
            "zip_code": 80170,
            "name_th": "หัวไทร",
            "name_en": "Hua Sai",
            "district_id": 8016,
            "lat": 8.037,
            "long": 100.286,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 801602,
            "zip_code": 80170,
            "name_th": "หน้าสตน",
            "name_en": "Na Saton",
            "district_id": 8016,
            "lat": 7.969,
            "long": 100.322,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 801603,
            "zip_code": 80170,
            "name_th": "ทรายขาว",
            "name_en": "Sai Khao",
            "district_id": 8016,
            "lat": 8.04,
            "long": 100.226,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 801604,
            "zip_code": 80170,
            "name_th": "แหลม",
            "name_en": "Laem",
            "district_id": 8016,
            "lat": 7.97,
            "long": 100.192,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 801605,
            "zip_code": 80170,
            "name_th": "เขาพังไกร",
            "name_en": "Khao Phang Krai",
            "district_id": 8016,
            "lat": 7.976,
            "long": 100.272,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 801606,
            "zip_code": 80170,
            "name_th": "บ้านราม",
            "name_en": "Ban Ram",
            "district_id": 8016,
            "lat": 8.081,
            "long": 100.257,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 801607,
            "zip_code": 80170,
            "name_th": "บางนบ",
            "name_en": "Bang Nop",
            "district_id": 8016,
            "lat": 8.104,
            "long": 100.261,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 801608,
            "zip_code": 80170,
            "name_th": "ท่าซอม",
            "name_en": "Tha Som",
            "district_id": 8016,
            "lat": 8.146,
            "long": 100.246,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 801609,
            "zip_code": 80170,
            "name_th": "ควนชะลิก",
            "name_en": "Khuan Chalik",
            "district_id": 8016,
            "lat": 7.907,
            "long": 100.206,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 801610,
            "zip_code": 80170,
            "name_th": "รามแก้ว",
            "name_en": "Ram Kaeo",
            "district_id": 8016,
            "lat": 7.932,
            "long": 100.276,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 801611,
            "zip_code": 80170,
            "name_th": "เกาะเพชร",
            "name_en": "Ko Phet",
            "district_id": 8016,
            "lat": 8.112,
            "long": 100.291,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 8017,
        "name_th": "บางขัน",
        "name_en": "Bang Khan",
        "province_id": 63,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 801701,
            "zip_code": 80360,
            "name_th": "บางขัน",
            "name_en": "Bang Khan",
            "district_id": 8017,
            "lat": 8.069,
            "long": 99.422,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 801702,
            "zip_code": 80360,
            "name_th": "บ้านลำนาว",
            "name_en": "Ban Lamnao",
            "district_id": 8017,
            "lat": 7.968,
            "long": 99.417,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 801703,
            "zip_code": 80360,
            "name_th": "วังหิน",
            "name_en": "Wang Hin",
            "district_id": 8017,
            "lat": 7.984,
            "long": 99.554,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 801704,
            "zip_code": 80360,
            "name_th": "บ้านนิคม",
            "name_en": "Ban Nikhom",
            "district_id": 8017,
            "lat": 7.933,
            "long": 99.507,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 8018,
        "name_th": "ถ้ำพรรณรา",
        "name_en": "Tham Phannara",
        "province_id": 63,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 801801,
            "zip_code": 80260,
            "name_th": "ถ้ำพรรณรา",
            "name_en": "Tham Phannara",
            "district_id": 8018,
            "lat": 8.414,
            "long": 99.373,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 801802,
            "zip_code": 80260,
            "name_th": "คลองเส",
            "name_en": "Khlong Se",
            "district_id": 8018,
            "lat": 8.491,
            "long": 99.419,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 801803,
            "zip_code": 80260,
            "name_th": "ดุสิต",
            "name_en": "Dusit",
            "district_id": 8018,
            "lat": 8.466,
            "long": 99.347,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 8019,
        "name_th": "จุฬาภรณ์",
        "name_en": "Chulabhorn",
        "province_id": 63,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 801901,
            "zip_code": 80180,
            "name_th": "บ้านควนมุด",
            "name_en": "Ban Khuan Mut",
            "district_id": 8019,
            "lat": 8.028,
            "long": 99.924,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 801902,
            "zip_code": 80180,
            "name_th": "บ้านชะอวด",
            "name_en": "Ban Cha-uat",
            "district_id": 8019,
            "lat": 8.058,
            "long": 99.933,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 801903,
            "zip_code": 80130,
            "name_th": "ควนหนองคว้า",
            "name_en": "Khuan Nong Khwa",
            "district_id": 8019,
            "lat": 8.103,
            "long": 99.935,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 801904,
            "zip_code": 80130,
            "name_th": "ทุ่งโพธิ์",
            "name_en": "Thung Pho",
            "district_id": 8019,
            "lat": 8.109,
            "long": 99.829,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 801905,
            "zip_code": 80130,
            "name_th": "นาหมอบุญ",
            "name_en": "Na Mo Bun",
            "district_id": 8019,
            "lat": 8.03,
            "long": 99.813,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 801906,
            "zip_code": 80130,
            "name_th": "สามตำบล",
            "name_en": "Sam Tambon",
            "district_id": 8019,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 8020,
        "name_th": "พระพรหม",
        "name_en": "Phra Phrom",
        "province_id": 63,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 802001,
            "zip_code": 80000,
            "name_th": "นาพรุ",
            "name_en": "Na Phru",
            "district_id": 8020,
            "lat": 8.331,
            "long": 99.907,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 802002,
            "zip_code": 80000,
            "name_th": "นาสาร",
            "name_en": "Na San",
            "district_id": 8020,
            "lat": 8.37,
            "long": 99.92,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 802003,
            "zip_code": 80000,
            "name_th": "ท้ายสำเภา",
            "name_en": "Thai Samphao",
            "district_id": 8020,
            "lat": 8.302,
            "long": 99.909,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 802004,
            "zip_code": 80000,
            "name_th": "ช้างซ้าย",
            "name_en": "Chang Sai",
            "district_id": 8020,
            "lat": 8.311,
            "long": 99.966,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 8021,
        "name_th": "นบพิตำ",
        "name_en": "Nopphitam",
        "province_id": 63,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 802101,
            "zip_code": 80160,
            "name_th": "นบพิตำ",
            "name_en": "Nopphitam",
            "district_id": 8021,
            "lat": 8.744,
            "long": 99.772,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 802102,
            "zip_code": 80160,
            "name_th": "กรุงชิง",
            "name_en": "Krung Ching",
            "district_id": 8021,
            "lat": 8.804,
            "long": 99.635,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 802103,
            "zip_code": 80160,
            "name_th": "กะหรอ",
            "name_en": "Karo",
            "district_id": 8021,
            "lat": 8.666,
            "long": 99.827,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 802104,
            "zip_code": 80160,
            "name_th": "นาเหรง",
            "name_en": "Na Reng",
            "district_id": 8021,
            "lat": 8.66,
            "long": 99.745,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 8022,
        "name_th": "ช้างกลาง",
        "name_en": "Chang Klang",
        "province_id": 63,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 802201,
            "zip_code": 80250,
            "name_th": "ช้างกลาง",
            "name_en": "Chang Klang",
            "district_id": 8022,
            "lat": 8.336,
            "long": 99.638,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 802202,
            "zip_code": 80250,
            "name_th": "หลักช้าง",
            "name_en": "Lak Chang",
            "district_id": 8022,
            "lat": 8.354,
            "long": 99.535,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 802203,
            "zip_code": 80250,
            "name_th": "สวนขัน",
            "name_en": "Suan Kan",
            "district_id": 8022,
            "lat": 8.416,
            "long": 99.643,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 8023,
        "name_th": "เฉลิมพระเกียรติ",
        "name_en": "Chaloem Phra Kiat",
        "province_id": 63,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 802301,
            "zip_code": 80190,
            "name_th": "เชียรเขา",
            "name_en": "Chian Khao",
            "district_id": 8023,
            "lat": 8.184,
            "long": 100.078,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 802302,
            "zip_code": 80290,
            "name_th": "ดอนตรอ",
            "name_en": "Don Tro",
            "district_id": 8023,
            "lat": 8.213,
            "long": 100.039,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 802303,
            "zip_code": 80190,
            "name_th": "สวนหลวง",
            "name_en": "Suan Luang",
            "district_id": 8023,
            "lat": 8.139,
            "long": 100.037,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 802304,
            "zip_code": 80190,
            "name_th": "ทางพูน",
            "name_en": "Thang Phun",
            "district_id": 8023,
            "lat": 8.239,
            "long": 99.981,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      }
    ]
  },
  {
    "id": 64,
    "name_th": "กระบี่",
    "name_en": "Krabi",
    "geography_id": 6,
    "created_at": "2019-08-09T03:33:09.000+07:00",
    "updated_at": "2025-09-20T06:31:26.000+07:00",
    "deleted_at": null,
    "districts": [
      {
        "id": 8101,
        "name_th": "เมืองกระบี่",
        "name_en": "Mueang Krabi",
        "province_id": 64,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 810101,
            "zip_code": 81000,
            "name_th": "ปากน้ำ",
            "name_en": "Pak Nam",
            "district_id": 8101,
            "lat": 8.09,
            "long": 98.905,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 810102,
            "zip_code": 81000,
            "name_th": "กระบี่ใหญ่",
            "name_en": "Krabi Yai",
            "district_id": 8101,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 810103,
            "zip_code": 81000,
            "name_th": "กระบี่น้อย",
            "name_en": "Krabi Noi",
            "district_id": 8101,
            "lat": 8.176,
            "long": 98.959,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 810105,
            "zip_code": 81000,
            "name_th": "เขาคราม",
            "name_en": "Khao Khram",
            "district_id": 8101,
            "lat": 8.21,
            "long": 98.729,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 810106,
            "zip_code": 81000,
            "name_th": "เขาทอง",
            "name_en": "Khao Thong",
            "district_id": 8101,
            "lat": 8.049,
            "long": 98.676,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 810111,
            "zip_code": 81000,
            "name_th": "ทับปริก",
            "name_en": "Thap Prik",
            "district_id": 8101,
            "lat": 8.203,
            "long": 98.886,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 810115,
            "zip_code": 81000,
            "name_th": "ไสไทย",
            "name_en": "Sai Thai",
            "district_id": 8101,
            "lat": 8.064,
            "long": 98.872,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 810116,
            "zip_code": 81000,
            "name_th": "อ่าวนาง",
            "name_en": "Ao Nang",
            "district_id": 8101,
            "lat": 7.616,
            "long": 98.863,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 810117,
            "zip_code": 81000,
            "name_th": "หนองทะเล",
            "name_en": "Nong Thale",
            "district_id": 8101,
            "lat": 8.088,
            "long": 98.785,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 810118,
            "zip_code": 81000,
            "name_th": "คลองประสงค์",
            "name_en": "Khlong Prasong",
            "district_id": 8101,
            "lat": 7.972,
            "long": 98.809,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 8102,
        "name_th": "เขาพนม",
        "name_en": "Khao Phanom",
        "province_id": 64,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 810201,
            "zip_code": 81140,
            "name_th": "เขาพนม",
            "name_en": "Khao Phanom",
            "district_id": 8102,
            "lat": 8.227,
            "long": 99.045,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 810202,
            "zip_code": 81140,
            "name_th": "เขาดิน",
            "name_en": "Khao Din",
            "district_id": 8102,
            "lat": 8.342,
            "long": 99.167,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 810203,
            "zip_code": 80240,
            "name_th": "สินปุน",
            "name_en": "Sin Pun",
            "district_id": 8102,
            "lat": 8.277,
            "long": 99.295,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 810204,
            "zip_code": 81140,
            "name_th": "พรุเตียว",
            "name_en": "Phru Tiao",
            "district_id": 8102,
            "lat": 8.258,
            "long": 99.128,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 810205,
            "zip_code": 81140,
            "name_th": "หน้าเขา",
            "name_en": "Na Khao",
            "district_id": 8102,
            "lat": 8.343,
            "long": 98.966,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 810206,
            "zip_code": 80240,
            "name_th": "โคกหาร",
            "name_en": "Khok Han",
            "district_id": 8102,
            "lat": 8.188,
            "long": 99.252,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 8103,
        "name_th": "เกาะลันตา",
        "name_en": "Ko Lanta",
        "province_id": 64,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 810301,
            "zip_code": 81150,
            "name_th": "เกาะลันตาใหญ่",
            "name_en": "Ko Lanta Yai",
            "district_id": 8103,
            "lat": 7.496,
            "long": 99.12,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 810302,
            "zip_code": 81150,
            "name_th": "เกาะลันตาน้อย",
            "name_en": "Ko Lanta Noi",
            "district_id": 8103,
            "lat": 7.576,
            "long": 99.142,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 810303,
            "zip_code": 81120,
            "name_th": "เกาะกลาง",
            "name_en": "Ko Klang",
            "district_id": 8103,
            "lat": 7.746,
            "long": 99.126,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 810304,
            "zip_code": 81120,
            "name_th": "คลองยาง",
            "name_en": "Khlong Yang",
            "district_id": 8103,
            "lat": 7.855,
            "long": 99.053,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 810305,
            "zip_code": 81150,
            "name_th": "ศาลาด่าน",
            "name_en": "Sala Dan",
            "district_id": 8103,
            "lat": 7.603,
            "long": 99.05,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 8104,
        "name_th": "คลองท่อม",
        "name_en": "Khlong Thom",
        "province_id": 64,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 810401,
            "zip_code": 81120,
            "name_th": "คลองท่อมใต้",
            "name_en": "Khlong Thom Tai",
            "district_id": 8104,
            "lat": 7.933,
            "long": 99.172,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 810402,
            "zip_code": 81120,
            "name_th": "คลองท่อมเหนือ",
            "name_en": "Khlong Thom Nuea",
            "district_id": 8104,
            "lat": 7.93,
            "long": 99.263,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 810403,
            "zip_code": 81170,
            "name_th": "คลองพน",
            "name_en": "Khlong Phon",
            "district_id": 8104,
            "lat": 7.758,
            "long": 99.172,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 810404,
            "zip_code": 81170,
            "name_th": "ทรายขาว",
            "name_en": "Sai Khao",
            "district_id": 8104,
            "lat": 7.711,
            "long": 99.241,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 810405,
            "zip_code": 81120,
            "name_th": "ห้วยน้ำขาว",
            "name_en": "Huai Nam Khao",
            "district_id": 8104,
            "lat": 7.866,
            "long": 99.126,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 810406,
            "zip_code": 81120,
            "name_th": "พรุดินนา",
            "name_en": "Phru Din Na",
            "district_id": 8104,
            "lat": 8.06,
            "long": 99.219,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 810407,
            "zip_code": 81120,
            "name_th": "เพหลา",
            "name_en": "Phela",
            "district_id": 8104,
            "lat": 8.075,
            "long": 99.139,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 8105,
        "name_th": "อ่าวลึก",
        "name_en": "Ao Luek",
        "province_id": 64,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 810501,
            "zip_code": 81110,
            "name_th": "อ่าวลึกใต้",
            "name_en": "Ao Luek Tai",
            "district_id": 8105,
            "lat": 8.386,
            "long": 98.707,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 810502,
            "zip_code": 81110,
            "name_th": "แหลมสัก",
            "name_en": "Laem Sak",
            "district_id": 8105,
            "lat": 8.292,
            "long": 98.616,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 810503,
            "zip_code": 81110,
            "name_th": "นาเหนือ",
            "name_en": "Na Nuea",
            "district_id": 8105,
            "lat": 8.529,
            "long": 98.736,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 810504,
            "zip_code": 81110,
            "name_th": "คลองหิน",
            "name_en": "Khlong Hin",
            "district_id": 8105,
            "lat": 8.324,
            "long": 98.837,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 810505,
            "zip_code": 81110,
            "name_th": "อ่าวลึกน้อย",
            "name_en": "Ao Luek Noi",
            "district_id": 8105,
            "lat": 8.211,
            "long": 98.687,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 810506,
            "zip_code": 81110,
            "name_th": "อ่าวลึกเหนือ",
            "name_en": "Ao Luek Nuea",
            "district_id": 8105,
            "lat": 8.399,
            "long": 98.825,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 810507,
            "zip_code": 81110,
            "name_th": "เขาใหญ่",
            "name_en": "Khao Yai",
            "district_id": 8105,
            "lat": 8.465,
            "long": 98.719,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 810508,
            "zip_code": 81110,
            "name_th": "คลองยา",
            "name_en": "Khlong Ya",
            "district_id": 8105,
            "lat": 8.379,
            "long": 98.883,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 810509,
            "zip_code": 81110,
            "name_th": "บ้านกลาง",
            "name_en": "Ban Klang",
            "district_id": 8105,
            "lat": 8.352,
            "long": 98.792,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 8106,
        "name_th": "ปลายพระยา",
        "name_en": "Plai Phraya",
        "province_id": 64,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 810601,
            "zip_code": 81160,
            "name_th": "ปลายพระยา",
            "name_en": "Plai Phraya",
            "district_id": 8106,
            "lat": 8.564,
            "long": 98.879,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 810602,
            "zip_code": 81160,
            "name_th": "เขาเขน",
            "name_en": "Khao Khen",
            "district_id": 8106,
            "lat": 8.56,
            "long": 98.798,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 810603,
            "zip_code": 81160,
            "name_th": "เขาต่อ",
            "name_en": "Khao To",
            "district_id": 8106,
            "lat": 8.612,
            "long": 98.739,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 810604,
            "zip_code": 81160,
            "name_th": "คีรีวง",
            "name_en": "Khiri Wong",
            "district_id": 8106,
            "lat": 8.445,
            "long": 98.841,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 8107,
        "name_th": "ลำทับ",
        "name_en": "Lam Thap",
        "province_id": 64,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 810701,
            "zip_code": 81120,
            "name_th": "ลำทับ",
            "name_en": "Lam Thap",
            "district_id": 8107,
            "lat": 7.96,
            "long": 99.348,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 810702,
            "zip_code": 81120,
            "name_th": "ดินอุดม",
            "name_en": "Din Udom",
            "district_id": 8107,
            "lat": 8.1,
            "long": 99.358,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 810703,
            "zip_code": 81120,
            "name_th": "ทุ่งไทรทอง",
            "name_en": "Thung Sai Thong",
            "district_id": 8107,
            "lat": 8.004,
            "long": 99.311,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 810704,
            "zip_code": 81120,
            "name_th": "ดินแดง",
            "name_en": "Din Daeng",
            "district_id": 8107,
            "lat": 8.011,
            "long": 99.373,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 8108,
        "name_th": "เหนือคลอง",
        "name_en": "Nuea Khlong",
        "province_id": 64,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 810801,
            "zip_code": 81130,
            "name_th": "เหนือคลอง",
            "name_en": "Nuea Khlong",
            "district_id": 8108,
            "lat": 8.086,
            "long": 98.99,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 810802,
            "zip_code": 81130,
            "name_th": "เกาะศรีบอยา",
            "name_en": "Ko Si Boya",
            "district_id": 8108,
            "lat": 7.801,
            "long": 98.995,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 810803,
            "zip_code": 81130,
            "name_th": "คลองขนาน",
            "name_en": "Khlong Khanan",
            "district_id": 8108,
            "lat": 7.941,
            "long": 99.072,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 810804,
            "zip_code": 81130,
            "name_th": "คลองเขม้า",
            "name_en": "Khlong Khamao",
            "district_id": 8108,
            "lat": 8.036,
            "long": 98.976,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 810805,
            "zip_code": 81130,
            "name_th": "โคกยาง",
            "name_en": "Khok Yang",
            "district_id": 8108,
            "lat": 8.09,
            "long": 99.087,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 810806,
            "zip_code": 81130,
            "name_th": "ตลิ่งชัน",
            "name_en": "Taling Chan",
            "district_id": 8108,
            "lat": 7.963,
            "long": 98.969,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 810807,
            "zip_code": 81130,
            "name_th": "ปกาสัย",
            "name_en": "Pakasai",
            "district_id": 8108,
            "lat": 8.015,
            "long": 99.062,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 810808,
            "zip_code": 81130,
            "name_th": "ห้วยยูง",
            "name_en": "Huai Yung",
            "district_id": 8108,
            "lat": 8.12,
            "long": 99.026,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      }
    ]
  },
  {
    "id": 65,
    "name_th": "พังงา",
    "name_en": "Phangnga",
    "geography_id": 6,
    "created_at": "2019-08-09T03:33:09.000+07:00",
    "updated_at": "2025-09-20T06:31:26.000+07:00",
    "deleted_at": null,
    "districts": [
      {
        "id": 8201,
        "name_th": "เมืองพังงา",
        "name_en": "Mueang Phang-nga",
        "province_id": 65,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 820101,
            "zip_code": 82000,
            "name_th": "ท้ายช้าง",
            "name_en": "Thai Chang",
            "district_id": 8201,
            "lat": 8.446,
            "long": 98.524,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 820102,
            "zip_code": 82000,
            "name_th": "นบปริง",
            "name_en": "Nop Pring",
            "district_id": 8201,
            "lat": 8.536,
            "long": 98.514,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 820103,
            "zip_code": 82000,
            "name_th": "ถ้ำน้ำผุด",
            "name_en": "Tham Nam Phut",
            "district_id": 8201,
            "lat": 8.427,
            "long": 98.527,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 820104,
            "zip_code": 82000,
            "name_th": "บางเตย",
            "name_en": "Bang Toei",
            "district_id": 8201,
            "lat": 8.407,
            "long": 98.575,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 820105,
            "zip_code": 82000,
            "name_th": "ตากแดด",
            "name_en": "Tak Daet",
            "district_id": 8201,
            "lat": 8.433,
            "long": 98.489,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 820106,
            "zip_code": 82000,
            "name_th": "สองแพรก",
            "name_en": "Song Phraek",
            "district_id": 8201,
            "lat": 8.603,
            "long": 98.554,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 820107,
            "zip_code": 82000,
            "name_th": "ทุ่งคาโงก",
            "name_en": "Thung Kha Ngok",
            "district_id": 8201,
            "lat": 8.554,
            "long": 98.438,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 820108,
            "zip_code": 82000,
            "name_th": "เกาะปันหยี",
            "name_en": "Ko Panyi",
            "district_id": 8201,
            "lat": 8.317,
            "long": 98.539,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 820109,
            "zip_code": 82000,
            "name_th": "ป่ากอ",
            "name_en": "Pa Ko",
            "district_id": 8201,
            "lat": 8.5,
            "long": 98.466,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 8202,
        "name_th": "เกาะยาว",
        "name_en": "Ko Yao",
        "province_id": 65,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 820201,
            "zip_code": 82160,
            "name_th": "เกาะยาวน้อย",
            "name_en": "Ko Yao Noi",
            "district_id": 8202,
            "lat": 8.131,
            "long": 98.61,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 820202,
            "zip_code": 82160,
            "name_th": "เกาะยาวใหญ่",
            "name_en": "Ko Yao Yai",
            "district_id": 8202,
            "lat": 8.061,
            "long": 98.567,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 820203,
            "zip_code": 83000,
            "name_th": "พรุใน",
            "name_en": "Pru Nai",
            "district_id": 8202,
            "lat": 7.892,
            "long": 98.581,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 8203,
        "name_th": "กะปง",
        "name_en": "Kapong",
        "province_id": 65,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 820301,
            "zip_code": 82170,
            "name_th": "กะปง",
            "name_en": "Kapong",
            "district_id": 8203,
            "lat": 8.648,
            "long": 98.468,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 820302,
            "zip_code": 82170,
            "name_th": "ท่านา",
            "name_en": "Tha Na",
            "district_id": 8203,
            "lat": 8.713,
            "long": 98.419,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 820303,
            "zip_code": 82170,
            "name_th": "เหมาะ",
            "name_en": "Mo",
            "district_id": 8203,
            "lat": 8.695,
            "long": 98.362,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 820304,
            "zip_code": 82170,
            "name_th": "เหล",
            "name_en": "Le",
            "district_id": 8203,
            "lat": 8.734,
            "long": 98.507,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 820305,
            "zip_code": 82170,
            "name_th": "รมณีย์",
            "name_en": "Rommani",
            "district_id": 8203,
            "lat": 8.829,
            "long": 98.501,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 8204,
        "name_th": "ตะกั่วทุ่ง",
        "name_en": "Takua Thung",
        "province_id": 65,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 820401,
            "zip_code": 82130,
            "name_th": "ถ้ำ",
            "name_en": "Tham",
            "district_id": 8204,
            "lat": 8.409,
            "long": 98.412,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 820402,
            "zip_code": 82130,
            "name_th": "กระโสม",
            "name_en": "Krasom",
            "district_id": 8204,
            "lat": 8.331,
            "long": 98.483,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 820403,
            "zip_code": 82130,
            "name_th": "กะไหล",
            "name_en": "Kalai",
            "district_id": 8204,
            "lat": 8.285,
            "long": 98.477,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 820404,
            "zip_code": 82130,
            "name_th": "ท่าอยู่",
            "name_en": "Tha Yu",
            "district_id": 8204,
            "lat": 8.261,
            "long": 98.398,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 820405,
            "zip_code": 82140,
            "name_th": "หล่อยูง",
            "name_en": "Lo Yung",
            "district_id": 8204,
            "lat": 8.198,
            "long": 98.358,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 820406,
            "zip_code": 82140,
            "name_th": "โคกกลอย",
            "name_en": "Khok Kloi",
            "district_id": 8204,
            "lat": 8.252,
            "long": 98.306,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 820407,
            "zip_code": 82130,
            "name_th": "คลองเคียน",
            "name_en": "Khlong Khian",
            "district_id": 8204,
            "lat": 8.179,
            "long": 98.455,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 8205,
        "name_th": "ตะกั่วป่า",
        "name_en": "Takua Pa",
        "province_id": 65,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 820501,
            "zip_code": 82110,
            "name_th": "ตะกั่วป่า",
            "name_en": "Takua Pa",
            "district_id": 8205,
            "lat": 8.829,
            "long": 98.362,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 820502,
            "zip_code": 82110,
            "name_th": "บางนายสี",
            "name_en": "Bang Nai Si",
            "district_id": 8205,
            "lat": 8.914,
            "long": 98.324,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 820503,
            "zip_code": 82110,
            "name_th": "บางไทร",
            "name_en": "Bang Sai",
            "district_id": 8205,
            "lat": 8.773,
            "long": 98.312,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 820504,
            "zip_code": 82110,
            "name_th": "บางม่วง",
            "name_en": "Bang Muang",
            "district_id": 8205,
            "lat": 8.819,
            "long": 98.289,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 820505,
            "zip_code": 82110,
            "name_th": "ตำตัว",
            "name_en": "Tam Tua",
            "district_id": 8205,
            "lat": 8.784,
            "long": 98.377,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 820506,
            "zip_code": 82110,
            "name_th": "โคกเคียน",
            "name_en": "Khok Khian",
            "district_id": 8205,
            "lat": 8.851,
            "long": 98.388,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 820507,
            "zip_code": 82190,
            "name_th": "คึกคัก",
            "name_en": "Khuekkhak",
            "district_id": 8205,
            "lat": 8.698,
            "long": 98.28,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 820508,
            "zip_code": 82190,
            "name_th": "เกาะคอเขา",
            "name_en": "Ko Kho Khao",
            "district_id": 8205,
            "lat": 8.962,
            "long": 98.284,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 8206,
        "name_th": "คุระบุรี",
        "name_en": "Khura Buri",
        "province_id": 65,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 820601,
            "zip_code": 82150,
            "name_th": "คุระ",
            "name_en": "Khura",
            "district_id": 8206,
            "lat": 9.262,
            "long": 98.414,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 820602,
            "zip_code": 82150,
            "name_th": "บางวัน",
            "name_en": "Bang Wan",
            "district_id": 8206,
            "lat": 9.046,
            "long": 98.405,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 820603,
            "zip_code": 82150,
            "name_th": "เกาะพระทอง",
            "name_en": "Ko Phra Thong",
            "district_id": 8206,
            "lat": 9.406,
            "long": 97.901,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 820605,
            "zip_code": 82150,
            "name_th": "แม่นางขาว",
            "name_en": "Mae Nang Khao",
            "district_id": 8206,
            "lat": 9.154,
            "long": 98.404,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 8207,
        "name_th": "ทับปุด",
        "name_en": "Thap Put",
        "province_id": 65,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 820701,
            "zip_code": 82180,
            "name_th": "ทับปุด",
            "name_en": "Thap Put",
            "district_id": 8207,
            "lat": 8.517,
            "long": 98.632,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 820702,
            "zip_code": 82180,
            "name_th": "มะรุ่ย",
            "name_en": "Marui",
            "district_id": 8207,
            "lat": 8.431,
            "long": 98.639,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 820703,
            "zip_code": 82180,
            "name_th": "บ่อแสน",
            "name_en": "Bo Saen",
            "district_id": 8207,
            "lat": 8.472,
            "long": 98.605,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 820704,
            "zip_code": 82180,
            "name_th": "ถ้ำทองหลาง",
            "name_en": "Tham Thonglang",
            "district_id": 8207,
            "lat": 8.556,
            "long": 98.598,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 820705,
            "zip_code": 82180,
            "name_th": "โคกเจริญ",
            "name_en": "Khok Charoen",
            "district_id": 8207,
            "lat": 8.543,
            "long": 98.664,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 820706,
            "zip_code": 82180,
            "name_th": "บางเหรียง",
            "name_en": "Bang Riang",
            "district_id": 8207,
            "lat": 8.61,
            "long": 98.654,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 8208,
        "name_th": "ท้ายเหมือง",
        "name_en": "Thai Mueang",
        "province_id": 65,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 820801,
            "zip_code": 82120,
            "name_th": "ท้ายเหมือง",
            "name_en": "Thai Mueang",
            "district_id": 8208,
            "lat": 8.442,
            "long": 98.275,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 820802,
            "zip_code": 82120,
            "name_th": "นาเตย",
            "name_en": "Na Toei",
            "district_id": 8208,
            "lat": 8.344,
            "long": 98.303,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 820803,
            "zip_code": 82120,
            "name_th": "บางทอง",
            "name_en": "Bang Thong",
            "district_id": 8208,
            "lat": 8.418,
            "long": 98.354,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 820804,
            "zip_code": 82120,
            "name_th": "ทุ่งมะพร้าว",
            "name_en": "Thung Maphrao",
            "district_id": 8208,
            "lat": 8.536,
            "long": 98.277,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 820805,
            "zip_code": 82120,
            "name_th": "ลำภี",
            "name_en": "Lam Phi",
            "district_id": 8208,
            "lat": 8.59,
            "long": 98.36,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 820806,
            "zip_code": 82120,
            "name_th": "ลำแก่น",
            "name_en": "Lam Kaen",
            "district_id": 8208,
            "lat": 8.578,
            "long": 98.258,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      }
    ]
  },
  {
    "id": 66,
    "name_th": "ภูเก็ต",
    "name_en": "Phuket",
    "geography_id": 6,
    "created_at": "2019-08-09T03:33:09.000+07:00",
    "updated_at": "2025-09-20T06:31:26.000+07:00",
    "deleted_at": null,
    "districts": [
      {
        "id": 8301,
        "name_th": "เมืองภูเก็ต",
        "name_en": "Mueang Phuket",
        "province_id": 66,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 830101,
            "zip_code": 83000,
            "name_th": "ตลาดใหญ่",
            "name_en": "Talat Yai",
            "district_id": 8301,
            "lat": 7.888,
            "long": 98.394,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 830102,
            "zip_code": 83000,
            "name_th": "ตลาดเหนือ",
            "name_en": "Talat Nuea",
            "district_id": 8301,
            "lat": 7.879,
            "long": 98.381,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 830103,
            "zip_code": 83000,
            "name_th": "เกาะแก้ว",
            "name_en": "Ko Kaeo",
            "district_id": 8301,
            "lat": 7.924,
            "long": 98.455,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 830104,
            "zip_code": 83000,
            "name_th": "รัษฎา",
            "name_en": "Ratsada",
            "district_id": 8301,
            "lat": 7.834,
            "long": 98.423,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 830105,
            "zip_code": 83000,
            "name_th": "วิชิต",
            "name_en": "Wichit",
            "district_id": 8301,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 830106,
            "zip_code": 83130,
            "name_th": "ฉลอง",
            "name_en": "Chalong",
            "district_id": 8301,
            "lat": 7.843,
            "long": 98.341,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 830107,
            "zip_code": 83130,
            "name_th": "ราไวย์",
            "name_en": "Rawai",
            "district_id": 8301,
            "lat": 7.767,
            "long": 98.3,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 830108,
            "zip_code": 83100,
            "name_th": "กะรน",
            "name_en": "Karon",
            "district_id": 8301,
            "lat": 7.821,
            "long": 98.285,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 8302,
        "name_th": "กะทู้",
        "name_en": "Kathu",
        "province_id": 66,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 830201,
            "zip_code": 83120,
            "name_th": "กะทู้",
            "name_en": "Kathu",
            "district_id": 8302,
            "lat": 7.914,
            "long": 98.338,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 830202,
            "zip_code": 83150,
            "name_th": "ป่าตอง",
            "name_en": "Pa Tong",
            "district_id": 8302,
            "lat": 7.904,
            "long": 98.308,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 830203,
            "zip_code": 83150,
            "name_th": "กมลา",
            "name_en": "Kamala",
            "district_id": 8302,
            "lat": 7.945,
            "long": 98.289,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 8303,
        "name_th": "ถลาง",
        "name_en": "Thalang",
        "province_id": 66,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 830301,
            "zip_code": 83110,
            "name_th": "เทพกระษัตรี",
            "name_en": "Thep Krasattri",
            "district_id": 8303,
            "lat": 8.116,
            "long": 98.425,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 830302,
            "zip_code": 83110,
            "name_th": "ศรีสุนทร",
            "name_en": "Si Sunthon",
            "district_id": 8303,
            "lat": 7.984,
            "long": 98.346,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 830303,
            "zip_code": 83110,
            "name_th": "เชิงทะเล",
            "name_en": "Choeng Thale",
            "district_id": 8303,
            "lat": 7.996,
            "long": 98.309,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 830304,
            "zip_code": 83110,
            "name_th": "ป่าคลอก",
            "name_en": "Pa Khlok",
            "district_id": 8303,
            "lat": 8.028,
            "long": 98.461,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 830305,
            "zip_code": 83110,
            "name_th": "ไม้ขาว",
            "name_en": "Mai Khao",
            "district_id": 8303,
            "lat": 8.147,
            "long": 98.318,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 830306,
            "zip_code": 83110,
            "name_th": "สาคู",
            "name_en": "Sakhu",
            "district_id": 8303,
            "lat": 8.093,
            "long": 98.315,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      }
    ]
  },
  {
    "id": 67,
    "name_th": "สุราษฎร์ธานี",
    "name_en": "Surat Thani",
    "geography_id": 6,
    "created_at": "2019-08-09T03:33:09.000+07:00",
    "updated_at": "2025-09-20T06:31:26.000+07:00",
    "deleted_at": null,
    "districts": [
      {
        "id": 8401,
        "name_th": "เมืองสุราษฎร์ธานี",
        "name_en": "Mueang Surat Thani",
        "province_id": 67,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 840101,
            "zip_code": 84000,
            "name_th": "ตลาด",
            "name_en": "Talat",
            "district_id": 8401,
            "lat": 9.137,
            "long": 99.32,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 840102,
            "zip_code": 84000,
            "name_th": "มะขามเตี้ย",
            "name_en": "Makham Tia",
            "district_id": 8401,
            "lat": 9.112,
            "long": 99.347,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 840103,
            "zip_code": 84000,
            "name_th": "วัดประดู่",
            "name_en": "Wat Pradu",
            "district_id": 8401,
            "lat": 8.979,
            "long": 99.328,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 840104,
            "zip_code": 84100,
            "name_th": "ขุนทะเล",
            "name_en": "Khun Thale",
            "district_id": 8401,
            "lat": 9.023,
            "long": 99.353,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 840105,
            "zip_code": 84000,
            "name_th": "บางใบไม้",
            "name_en": "Bang Bai Mai",
            "district_id": 8401,
            "lat": 9.152,
            "long": 99.295,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 840106,
            "zip_code": 84000,
            "name_th": "บางชนะ",
            "name_en": "Bang Chana",
            "district_id": 8401,
            "lat": 9.155,
            "long": 99.311,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 840107,
            "zip_code": 84000,
            "name_th": "คลองน้อย",
            "name_en": "Khlong Noi",
            "district_id": 8401,
            "lat": 9.135,
            "long": 99.251,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 840108,
            "zip_code": 84000,
            "name_th": "บางไทร",
            "name_en": "Bang Sai",
            "district_id": 8401,
            "lat": 9.188,
            "long": 99.3,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 840109,
            "zip_code": 84000,
            "name_th": "บางโพธิ์",
            "name_en": "Bang Pho",
            "district_id": 8401,
            "lat": 9.185,
            "long": 99.278,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 840110,
            "zip_code": 84000,
            "name_th": "บางกุ้ง",
            "name_en": "Bang Kung",
            "district_id": 8401,
            "lat": 9.159,
            "long": 99.36,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 840111,
            "zip_code": 84000,
            "name_th": "คลองฉนาก",
            "name_en": "Khlong Chanak",
            "district_id": 8401,
            "lat": 9.191,
            "long": 99.351,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 8402,
        "name_th": "กาญจนดิษฐ์",
        "name_en": "Kanchanadit",
        "province_id": 67,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 840201,
            "zip_code": 84290,
            "name_th": "ท่าทองใหม่",
            "name_en": "Tha Thong",
            "district_id": 8402,
            "lat": 9.174,
            "long": 99.396,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 840202,
            "zip_code": 84160,
            "name_th": "ท่าทอง",
            "name_en": "Tha Thong Mai",
            "district_id": 8402,
            "lat": 9.255,
            "long": 99.539,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 840203,
            "zip_code": 84160,
            "name_th": "กะแดะ",
            "name_en": "Kadae",
            "district_id": 8402,
            "lat": 9.181,
            "long": 99.465,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 840204,
            "zip_code": 84290,
            "name_th": "ทุ่งกง",
            "name_en": "Thung Kong",
            "district_id": 8402,
            "lat": 9.122,
            "long": 99.405,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 840205,
            "zip_code": 84160,
            "name_th": "กรูด",
            "name_en": "Krut",
            "district_id": 8402,
            "lat": 9.103,
            "long": 99.549,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 840206,
            "zip_code": 84160,
            "name_th": "ช้างซ้าย",
            "name_en": "Chang Sai",
            "district_id": 8402,
            "lat": 9.02,
            "long": 99.478,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 840207,
            "zip_code": 84160,
            "name_th": "พลายวาส",
            "name_en": "Phlai Wat",
            "district_id": 8402,
            "lat": 9.184,
            "long": 99.518,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 840208,
            "zip_code": 84160,
            "name_th": "ป่าร่อน",
            "name_en": "Pa Ron",
            "district_id": 8402,
            "lat": 8.97,
            "long": 99.521,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 840209,
            "zip_code": 84160,
            "name_th": "ตะเคียนทอง",
            "name_en": "Takhian Thong",
            "district_id": 8402,
            "lat": 9.176,
            "long": 99.43,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 840210,
            "zip_code": 84160,
            "name_th": "ช้างขวา",
            "name_en": "Chang Khwa",
            "district_id": 8402,
            "lat": 9.103,
            "long": 99.442,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 840211,
            "zip_code": 84160,
            "name_th": "ท่าอุแท",
            "name_en": "Tha Uthae",
            "district_id": 8402,
            "lat": 9.113,
            "long": 99.639,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 840212,
            "zip_code": 84290,
            "name_th": "ทุ่งรัง",
            "name_en": "Thung Rung",
            "district_id": 8402,
            "lat": 9.042,
            "long": 99.403,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 840213,
            "zip_code": 84160,
            "name_th": "คลองสระ",
            "name_en": "Khlong Sa",
            "district_id": 8402,
            "lat": 8.976,
            "long": 99.626,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 8403,
        "name_th": "ดอนสัก",
        "name_en": "Don Sak",
        "province_id": 67,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 840301,
            "zip_code": 84220,
            "name_th": "ดอนสัก",
            "name_en": "Don Sak",
            "district_id": 8403,
            "lat": 9.31,
            "long": 99.66,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 840302,
            "zip_code": 84160,
            "name_th": "ชลคราม",
            "name_en": "Chonlakhram",
            "district_id": 8403,
            "lat": 9.248,
            "long": 99.605,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 840303,
            "zip_code": 84220,
            "name_th": "ไชยคราม",
            "name_en": "Chaiyakhram",
            "district_id": 8403,
            "lat": 9.182,
            "long": 99.653,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 840304,
            "zip_code": 84340,
            "name_th": "ปากแพรก",
            "name_en": "Pak Phraek",
            "district_id": 8403,
            "lat": 9.134,
            "long": 99.701,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 8404,
        "name_th": "เกาะสมุย",
        "name_en": "Ko Samui",
        "province_id": 67,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 840401,
            "zip_code": 84140,
            "name_th": "อ่างทอง",
            "name_en": "Ang Thong",
            "district_id": 8404,
            "lat": 9.708,
            "long": 99.675,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 840402,
            "zip_code": 84140,
            "name_th": "ลิปะน้อย",
            "name_en": "Lipa Noi",
            "district_id": 8404,
            "lat": 9.502,
            "long": 99.959,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 840403,
            "zip_code": 84140,
            "name_th": "ตลิ่งงาม",
            "name_en": "Taling Ngam",
            "district_id": 8404,
            "lat": 9.31,
            "long": 99.892,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 840404,
            "zip_code": 84140,
            "name_th": "หน้าเมือง",
            "name_en": "Na Mueang",
            "district_id": 8404,
            "lat": 9.461,
            "long": 99.996,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 840405,
            "zip_code": 84310,
            "name_th": "มะเร็ต",
            "name_en": "Maret",
            "district_id": 8404,
            "lat": 9.468,
            "long": 100.032,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 840406,
            "zip_code": 84320,
            "name_th": "บ่อผุด",
            "name_en": "Bo Phut",
            "district_id": 8404,
            "lat": 9.539,
            "long": 100.081,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 840407,
            "zip_code": 84330,
            "name_th": "แม่น้ำ",
            "name_en": "Mae Nam",
            "district_id": 8404,
            "lat": 9.563,
            "long": 99.967,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 8405,
        "name_th": "เกาะพะงัน",
        "name_en": "Ko Pha-ngan",
        "province_id": 67,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 840501,
            "zip_code": 84280,
            "name_th": "เกาะพะงัน",
            "name_en": "Ko Pha-ngan",
            "district_id": 8405,
            "lat": 9.802,
            "long": 99.979,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 840502,
            "zip_code": 84280,
            "name_th": "บ้านใต้",
            "name_en": "Ban Tai",
            "district_id": 8405,
            "lat": 9.723,
            "long": 100.062,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 840503,
            "zip_code": 84280,
            "name_th": "เกาะเต่า",
            "name_en": "Koh Tao",
            "district_id": 8405,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 8406,
        "name_th": "ไชยา",
        "name_en": "Chaiya",
        "province_id": 67,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 840601,
            "zip_code": 84110,
            "name_th": "ตลาดไชยา",
            "name_en": "Talat Chaiya",
            "district_id": 8406,
            "lat": 9.391,
            "long": 99.198,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 840602,
            "zip_code": 84110,
            "name_th": "พุมเรียง",
            "name_en": "Phumriang",
            "district_id": 8406,
            "lat": 9.395,
            "long": 99.261,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 840603,
            "zip_code": 84110,
            "name_th": "เลม็ด",
            "name_en": "Lamet",
            "district_id": 8406,
            "lat": 9.365,
            "long": 99.172,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 840604,
            "zip_code": 84110,
            "name_th": "เวียง",
            "name_en": "Wiang",
            "district_id": 8406,
            "lat": 9.388,
            "long": 99.148,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 840605,
            "zip_code": 84110,
            "name_th": "ทุ่ง",
            "name_en": "Thung",
            "district_id": 8406,
            "lat": 9.424,
            "long": 99.215,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 840606,
            "zip_code": 84110,
            "name_th": "ป่าเว",
            "name_en": "Pa We",
            "district_id": 8406,
            "lat": 9.447,
            "long": 99.144,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 840607,
            "zip_code": 84110,
            "name_th": "ตะกรบ",
            "name_en": "Takrop",
            "district_id": 8406,
            "lat": 9.464,
            "long": 99.229,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 840608,
            "zip_code": 84110,
            "name_th": "โมถ่าย",
            "name_en": "Mo Thai",
            "district_id": 8406,
            "lat": 9.407,
            "long": 99.084,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 840609,
            "zip_code": 84110,
            "name_th": "ปากหมาก",
            "name_en": "Pak Mak",
            "district_id": 8406,
            "lat": 9.477,
            "long": 98.948,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 8407,
        "name_th": "ท่าชนะ",
        "name_en": "Tha Chana",
        "province_id": 67,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 840701,
            "zip_code": 84170,
            "name_th": "ท่าชนะ",
            "name_en": "Tha Chana",
            "district_id": 8407,
            "lat": 9.593,
            "long": 99.183,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 840702,
            "zip_code": 84170,
            "name_th": "สมอทอง",
            "name_en": "Samo Thong",
            "district_id": 8407,
            "lat": 9.581,
            "long": 99.053,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 840703,
            "zip_code": 84170,
            "name_th": "ประสงค์",
            "name_en": "Prasong",
            "district_id": 8407,
            "lat": 9.586,
            "long": 98.851,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 840704,
            "zip_code": 84170,
            "name_th": "คันธุลี",
            "name_en": "Khan Thuli",
            "district_id": 8407,
            "lat": 9.661,
            "long": 99.088,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 840705,
            "zip_code": 84170,
            "name_th": "วัง",
            "name_en": "Wang",
            "district_id": 8407,
            "lat": 9.52,
            "long": 99.198,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 840706,
            "zip_code": 84170,
            "name_th": "คลองพา",
            "name_en": "Khlong Pha",
            "district_id": 8407,
            "lat": 9.685,
            "long": 98.865,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 8408,
        "name_th": "คีรีรัฐนิคม",
        "name_en": "Khiri Rat Nikhom",
        "province_id": 67,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 840801,
            "zip_code": 84180,
            "name_th": "ท่าขนอน",
            "name_en": "Tha Khanon",
            "district_id": 8408,
            "lat": 9.075,
            "long": 98.874,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 840802,
            "zip_code": 84180,
            "name_th": "บ้านยาง",
            "name_en": "Ban Yang",
            "district_id": 8408,
            "lat": 9.051,
            "long": 99.012,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 840803,
            "zip_code": 84180,
            "name_th": "น้ำหัก",
            "name_en": "Nam Hak",
            "district_id": 8408,
            "lat": 9.157,
            "long": 98.824,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 840806,
            "zip_code": 84180,
            "name_th": "กะเปา",
            "name_en": "Kapao",
            "district_id": 8408,
            "lat": 9.011,
            "long": 98.89,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 840807,
            "zip_code": 84180,
            "name_th": "ท่ากระดาน",
            "name_en": "Tha Kradan",
            "district_id": 8408,
            "lat": 9.063,
            "long": 99.025,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 840808,
            "zip_code": 84180,
            "name_th": "ย่านยาว",
            "name_en": "Yan Yao",
            "district_id": 8408,
            "lat": 8.992,
            "long": 98.977,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 840809,
            "zip_code": 84180,
            "name_th": "ถ้ำสิงขร",
            "name_en": "Tham Singkhon",
            "district_id": 8408,
            "lat": 8.993,
            "long": 99.038,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 840810,
            "zip_code": 84180,
            "name_th": "บ้านทำเนียบ",
            "name_en": "Ban Thamniap",
            "district_id": 8408,
            "lat": 8.868,
            "long": 98.968,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 8409,
        "name_th": "บ้านตาขุน",
        "name_en": "Ban Ta Khun",
        "province_id": 67,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 840901,
            "zip_code": 84230,
            "name_th": "เขาวง",
            "name_en": "Khao Wong",
            "district_id": 8409,
            "lat": 8.923,
            "long": 98.929,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 840902,
            "zip_code": 84230,
            "name_th": "พระแสง",
            "name_en": "Phasaeng",
            "district_id": 8409,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 840903,
            "zip_code": 84230,
            "name_th": "พรุไทย",
            "name_en": "Phru Thai",
            "district_id": 8409,
            "lat": 8.949,
            "long": 98.896,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 840904,
            "zip_code": 84230,
            "name_th": "เขาพัง",
            "name_en": "Khao Phang",
            "district_id": 8409,
            "lat": 9.115,
            "long": 98.645,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 8410,
        "name_th": "พนม",
        "name_en": "Phanom",
        "province_id": 67,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 841001,
            "zip_code": 84250,
            "name_th": "พนม",
            "name_en": "Phanom",
            "district_id": 8410,
            "lat": 8.828,
            "long": 98.781,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 841002,
            "zip_code": 84250,
            "name_th": "ต้นยวน",
            "name_en": "Ton Yuan",
            "district_id": 8410,
            "lat": 8.776,
            "long": 98.9,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 841003,
            "zip_code": 84250,
            "name_th": "คลองศก",
            "name_en": "Khlong Sok",
            "district_id": 8410,
            "lat": 8.857,
            "long": 98.688,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 841004,
            "zip_code": 84250,
            "name_th": "พลูเถื่อน",
            "name_en": "Phlu Thuean",
            "district_id": 8410,
            "lat": 8.735,
            "long": 98.738,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 841005,
            "zip_code": 84250,
            "name_th": "พังกาญจน์",
            "name_en": "Phang Kan",
            "district_id": 8410,
            "lat": 8.878,
            "long": 98.806,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 841006,
            "zip_code": 84250,
            "name_th": "คลองชะอุ่น",
            "name_en": "Khlong Cha-un",
            "district_id": 8410,
            "lat": 8.727,
            "long": 98.865,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 8411,
        "name_th": "ท่าฉาง",
        "name_en": "Tha Chang",
        "province_id": 67,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 841101,
            "zip_code": 84150,
            "name_th": "ท่าฉาง",
            "name_en": "Tha Chang",
            "district_id": 8411,
            "lat": 9.258,
            "long": 99.175,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 841102,
            "zip_code": 84150,
            "name_th": "ท่าเคย",
            "name_en": "Tha Khoei",
            "district_id": 8411,
            "lat": 9.228,
            "long": 99.181,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 841103,
            "zip_code": 84150,
            "name_th": "คลองไทร",
            "name_en": "Khlong Sai",
            "district_id": 8411,
            "lat": 9.2,
            "long": 99.165,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 841104,
            "zip_code": 84150,
            "name_th": "เขาถ่าน",
            "name_en": "Khao Than",
            "district_id": 8411,
            "lat": 9.31,
            "long": 99.188,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 841105,
            "zip_code": 84150,
            "name_th": "เสวียด",
            "name_en": "Sawiat",
            "district_id": 8411,
            "lat": 9.311,
            "long": 99.101,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 841106,
            "zip_code": 84150,
            "name_th": "ปากฉลุย",
            "name_en": "Pak Chalui",
            "district_id": 8411,
            "lat": 9.442,
            "long": 98.752,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 8412,
        "name_th": "บ้านนาสาร",
        "name_en": "Ban Na San",
        "province_id": 67,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 841201,
            "zip_code": 84120,
            "name_th": "นาสาร",
            "name_en": "Na San",
            "district_id": 8412,
            "lat": 8.812,
            "long": 99.359,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 841202,
            "zip_code": 84270,
            "name_th": "พรุพี",
            "name_en": "Phru Phi",
            "district_id": 8412,
            "lat": 8.707,
            "long": 99.391,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 841203,
            "zip_code": 84120,
            "name_th": "ทุ่งเตา",
            "name_en": "Thung Tao",
            "district_id": 8412,
            "lat": 8.917,
            "long": 99.357,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 841204,
            "zip_code": 84120,
            "name_th": "ลำพูน",
            "name_en": "Lamphun",
            "district_id": 8412,
            "lat": 8.845,
            "long": 99.461,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 841205,
            "zip_code": 84120,
            "name_th": "ท่าชี",
            "name_en": "Tha Chi",
            "district_id": 8412,
            "lat": 8.756,
            "long": 99.275,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 841206,
            "zip_code": 84270,
            "name_th": "ควนศรี",
            "name_en": "Khuan Si",
            "district_id": 8412,
            "lat": 8.713,
            "long": 99.303,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 841207,
            "zip_code": 84120,
            "name_th": "ควนสุบรรณ",
            "name_en": "Khuan Suban",
            "district_id": 8412,
            "lat": 8.876,
            "long": 99.367,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 841208,
            "zip_code": 84120,
            "name_th": "คลองปราบ",
            "name_en": "Khlong Prap",
            "district_id": 8412,
            "lat": 8.749,
            "long": 99.348,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 841209,
            "zip_code": 84120,
            "name_th": "น้ำพุ",
            "name_en": "Nam Phu",
            "district_id": 8412,
            "lat": 8.781,
            "long": 99.3,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 841210,
            "zip_code": 84120,
            "name_th": "ทุ่งเตาใหม่",
            "name_en": "Thung Tao Mai",
            "district_id": 8412,
            "lat": 8.952,
            "long": 99.408,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 841211,
            "zip_code": 84120,
            "name_th": "เพิ่มพูนทรัพย์",
            "name_en": "Phoem Phun Sap",
            "district_id": 8412,
            "lat": 8.746,
            "long": 99.462,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 8413,
        "name_th": "บ้านนาเดิม",
        "name_en": "Ban Na Doem",
        "province_id": 67,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 841301,
            "zip_code": 84240,
            "name_th": "บ้านนา",
            "name_en": "Ban Na",
            "district_id": 8413,
            "lat": 8.856,
            "long": 99.293,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 841302,
            "zip_code": 84240,
            "name_th": "ท่าเรือ",
            "name_en": "Tha Ruea",
            "district_id": 8413,
            "lat": 8.947,
            "long": 99.269,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 841303,
            "zip_code": 84240,
            "name_th": "ทรัพย์ทวี",
            "name_en": "Sap Thawi",
            "district_id": 8413,
            "lat": 8.914,
            "long": 99.226,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 841304,
            "zip_code": 84240,
            "name_th": "นาใต้",
            "name_en": "Na Tai",
            "district_id": 8413,
            "lat": 8.906,
            "long": 99.324,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 8414,
        "name_th": "เคียนซา",
        "name_en": "Khian Sa",
        "province_id": 67,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 841401,
            "zip_code": 84260,
            "name_th": "เคียนซา",
            "name_en": "Khian Sa",
            "district_id": 8414,
            "lat": 8.817,
            "long": 99.18,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 841402,
            "zip_code": 84210,
            "name_th": "พ่วงพรมคร",
            "name_en": "Phuang Phromkhon",
            "district_id": 8414,
            "lat": 8.665,
            "long": 99.227,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 841403,
            "zip_code": 84260,
            "name_th": "เขาตอก",
            "name_en": "Khao Tok",
            "district_id": 8414,
            "lat": 8.845,
            "long": 99.251,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 841404,
            "zip_code": 84260,
            "name_th": "อรัญคามวารี",
            "name_en": "Aranyakham Wari",
            "district_id": 8414,
            "lat": 8.745,
            "long": 99.19,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 841405,
            "zip_code": 84260,
            "name_th": "บ้านเสด็จ",
            "name_en": "Ban Sadet",
            "district_id": 8414,
            "lat": 8.736,
            "long": 99.024,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 8415,
        "name_th": "เวียงสระ",
        "name_en": "Wiang Sa",
        "province_id": 67,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 841501,
            "zip_code": 84190,
            "name_th": "เวียงสระ",
            "name_en": "Wiang Sa",
            "district_id": 8415,
            "lat": 8.649,
            "long": 99.342,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 841502,
            "zip_code": 84190,
            "name_th": "บ้านส้อง",
            "name_en": "Ban Song",
            "district_id": 8415,
            "lat": 8.645,
            "long": 99.42,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 841503,
            "zip_code": 84190,
            "name_th": "คลองฉนวน",
            "name_en": "Khlong Chanuan",
            "district_id": 8415,
            "lat": 8.517,
            "long": 99.321,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 841504,
            "zip_code": 84190,
            "name_th": "ทุ่งหลวง",
            "name_en": "Thung Luang",
            "district_id": 8415,
            "lat": 8.592,
            "long": 99.298,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 841505,
            "zip_code": 84190,
            "name_th": "เขานิพันธ์",
            "name_en": "*Khao Niphan",
            "district_id": 8415,
            "lat": 8.584,
            "long": 99.348,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 8416,
        "name_th": "พระแสง",
        "name_en": "Phrasaeng",
        "province_id": 67,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 841601,
            "zip_code": 84210,
            "name_th": "อิปัน",
            "name_en": "Ipan",
            "district_id": 8416,
            "lat": 8.584,
            "long": 99.224,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 841602,
            "zip_code": 84210,
            "name_th": "สินปุน",
            "name_en": "Sin Pun",
            "district_id": 8416,
            "lat": 8.514,
            "long": 99.238,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 841603,
            "zip_code": 84210,
            "name_th": "บางสวรรค์",
            "name_en": "Bang Sawan",
            "district_id": 8416,
            "lat": 8.616,
            "long": 98.975,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 841604,
            "zip_code": 84210,
            "name_th": "ไทรขึง",
            "name_en": "Sai Khueng",
            "district_id": 8416,
            "lat": 8.538,
            "long": 99.063,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 841605,
            "zip_code": 84210,
            "name_th": "สินเจริญ",
            "name_en": "Sin Charoen",
            "district_id": 8416,
            "lat": 8.339,
            "long": 99.245,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 841606,
            "zip_code": 84210,
            "name_th": "ไทรโสภา",
            "name_en": "Sai Sopha",
            "district_id": 8416,
            "lat": 8.597,
            "long": 99.066,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 841607,
            "zip_code": 84210,
            "name_th": "สาคู",
            "name_en": "Sakhu",
            "district_id": 8416,
            "lat": 8.59,
            "long": 99.166,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 8417,
        "name_th": "พุนพิน",
        "name_en": "Phunphin",
        "province_id": 67,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 841701,
            "zip_code": 84130,
            "name_th": "ท่าข้าม",
            "name_en": "Tha Kham",
            "district_id": 8417,
            "lat": 9.062,
            "long": 99.218,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 841702,
            "zip_code": 84130,
            "name_th": "ท่าสะท้อน",
            "name_en": "Tha Sathon",
            "district_id": 8417,
            "lat": 8.994,
            "long": 99.227,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 841703,
            "zip_code": 84130,
            "name_th": "ลีเล็ด",
            "name_en": "Lilet",
            "district_id": 8417,
            "lat": 9.203,
            "long": 99.242,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 841704,
            "zip_code": 84130,
            "name_th": "บางมะเดื่อ",
            "name_en": "Bang Maduea",
            "district_id": 8417,
            "lat": 9.031,
            "long": 99.123,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 841705,
            "zip_code": 84130,
            "name_th": "บางเดือน",
            "name_en": "Bang Duean",
            "district_id": 8417,
            "lat": 9.026,
            "long": 99.087,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 841706,
            "zip_code": 84130,
            "name_th": "ท่าโรงช้าง",
            "name_en": "Tha Rong Chang",
            "district_id": 8417,
            "lat": 9.031,
            "long": 99.175,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 841707,
            "zip_code": 84130,
            "name_th": "กรูด",
            "name_en": "Krut",
            "district_id": 8417,
            "lat": 8.949,
            "long": 99.126,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 841708,
            "zip_code": 84130,
            "name_th": "พุนพิน",
            "name_en": "Phunphin",
            "district_id": 8417,
            "lat": 9.125,
            "long": 99.199,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 841709,
            "zip_code": 84130,
            "name_th": "บางงอน",
            "name_en": "Bang Ngon",
            "district_id": 8417,
            "lat": 9.116,
            "long": 99.06,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 841710,
            "zip_code": 84130,
            "name_th": "ศรีวิชัย",
            "name_en": "Si Wichai",
            "district_id": 8417,
            "lat": 9.162,
            "long": 99.213,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 841711,
            "zip_code": 84130,
            "name_th": "น้ำรอบ",
            "name_en": "Nam Rop",
            "district_id": 8417,
            "lat": 9.099,
            "long": 99.112,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 841712,
            "zip_code": 84130,
            "name_th": "มะลวน",
            "name_en": "Maluan",
            "district_id": 8417,
            "lat": 9.166,
            "long": 99.106,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 841713,
            "zip_code": 84130,
            "name_th": "หัวเตย",
            "name_en": "Hua Toei",
            "district_id": 8417,
            "lat": 9.136,
            "long": 99.163,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 841714,
            "zip_code": 84130,
            "name_th": "หนองไทร",
            "name_en": "Nong Sai",
            "district_id": 8417,
            "lat": 9.096,
            "long": 99.159,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 841715,
            "zip_code": 84130,
            "name_th": "เขาหัวควาย",
            "name_en": "Khao Hua Khwai",
            "district_id": 8417,
            "lat": 9.039,
            "long": 99.267,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 841716,
            "zip_code": 84130,
            "name_th": "ตะปาน",
            "name_en": "Tapan",
            "district_id": 8417,
            "lat": 8.866,
            "long": 99.087,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 8418,
        "name_th": "ชัยบุรี",
        "name_en": "Chai Buri",
        "province_id": 67,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 841801,
            "zip_code": 84350,
            "name_th": "สองแพรก",
            "name_en": "Song Phraek",
            "district_id": 8418,
            "lat": 8.483,
            "long": 99.125,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 841802,
            "zip_code": 84350,
            "name_th": "ชัยบุรี",
            "name_en": "Chai Buri",
            "district_id": 8418,
            "lat": 8.434,
            "long": 99.071,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 841803,
            "zip_code": 84350,
            "name_th": "คลองน้อย",
            "name_en": "Khlong Noi",
            "district_id": 8418,
            "lat": 8.503,
            "long": 98.997,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 841804,
            "zip_code": 84350,
            "name_th": "ไทรทอง",
            "name_en": "Sai Thong",
            "district_id": 8418,
            "lat": 8.389,
            "long": 99.073,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 8419,
        "name_th": "วิภาวดี",
        "name_en": "Vibhavadi",
        "province_id": 67,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 841901,
            "zip_code": 84180,
            "name_th": "ตะกุกใต้",
            "name_en": "Takuk Tai",
            "district_id": 8419,
            "lat": 9.227,
            "long": 98.807,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 841902,
            "zip_code": 84180,
            "name_th": "ตะกุกเหนือ",
            "name_en": "Takuk Nuea",
            "district_id": 8419,
            "lat": 9.252,
            "long": 98.909,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      }
    ]
  },
  {
    "id": 68,
    "name_th": "ระนอง",
    "name_en": "Ranong",
    "geography_id": 6,
    "created_at": "2019-08-09T03:33:09.000+07:00",
    "updated_at": "2025-09-20T06:31:26.000+07:00",
    "deleted_at": null,
    "districts": [
      {
        "id": 8501,
        "name_th": "เมืองระนอง",
        "name_en": "Mueang Ranong",
        "province_id": 68,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 850101,
            "zip_code": 85000,
            "name_th": "เขานิเวศน์",
            "name_en": "Khao Niwet",
            "district_id": 8501,
            "lat": 9.96,
            "long": 98.621,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 850102,
            "zip_code": 85000,
            "name_th": "ราชกรูด",
            "name_en": "Ratchakrut",
            "district_id": 8501,
            "lat": 9.721,
            "long": 98.578,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 850103,
            "zip_code": 85000,
            "name_th": "หงาว",
            "name_en": "Ngao",
            "district_id": 8501,
            "lat": 9.767,
            "long": 98.547,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 850104,
            "zip_code": 85000,
            "name_th": "บางริ้น",
            "name_en": "Bang Rin",
            "district_id": 8501,
            "lat": 9.909,
            "long": 98.644,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 850105,
            "zip_code": 85000,
            "name_th": "ปากน้ำ",
            "name_en": "Pak Nam",
            "district_id": 8501,
            "lat": 9.914,
            "long": 98.526,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 850106,
            "zip_code": 85000,
            "name_th": "บางนอน",
            "name_en": "Bang Non",
            "district_id": 8501,
            "lat": 10.005,
            "long": 98.647,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 850107,
            "zip_code": 85000,
            "name_th": "หาดส้มแป้น",
            "name_en": "Hat Som Paen",
            "district_id": 8501,
            "lat": 9.916,
            "long": 98.699,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 850108,
            "zip_code": 85130,
            "name_th": "ทรายแดง",
            "name_en": "Sai Daeng",
            "district_id": 8501,
            "lat": 10.13,
            "long": 98.68,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 850109,
            "zip_code": 85000,
            "name_th": "เกาะพยาม",
            "name_en": "Ko Phayam",
            "district_id": 8501,
            "lat": 9.877,
            "long": 98.442,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 8502,
        "name_th": "ละอุ่น",
        "name_en": "La-un",
        "province_id": 68,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 850201,
            "zip_code": 85130,
            "name_th": "ละอุ่นใต้",
            "name_en": "La-un Tai",
            "district_id": 8502,
            "lat": 10.124,
            "long": 98.769,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 850202,
            "zip_code": 85130,
            "name_th": "ละอุ่นเหนือ",
            "name_en": "La-un Nuea",
            "district_id": 8502,
            "lat": 10.027,
            "long": 98.806,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 850203,
            "zip_code": 85130,
            "name_th": "บางพระใต้",
            "name_en": "Bang Phra Tai",
            "district_id": 8502,
            "lat": 10.126,
            "long": 98.73,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 850204,
            "zip_code": 85130,
            "name_th": "บางพระเหนือ",
            "name_en": "Bang Phra Nuea",
            "district_id": 8502,
            "lat": 10.022,
            "long": 98.731,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 850205,
            "zip_code": 85130,
            "name_th": "บางแก้ว",
            "name_en": "Bang Kaeo",
            "district_id": 8502,
            "lat": 10.179,
            "long": 98.78,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 850206,
            "zip_code": 85130,
            "name_th": "ในวงเหนือ",
            "name_en": "Nai Wong Nuea",
            "district_id": 8502,
            "lat": 10.02,
            "long": 98.842,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 850207,
            "zip_code": 85130,
            "name_th": "ในวงใต้",
            "name_en": "Nai Wong Tai",
            "district_id": 8502,
            "lat": 10.029,
            "long": 98.884,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 8503,
        "name_th": "กะเปอร์",
        "name_en": "Kapoe",
        "province_id": 68,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 850301,
            "zip_code": 85120,
            "name_th": "ม่วงกลวง",
            "name_en": "Muang Kluang",
            "district_id": 8503,
            "lat": 9.606,
            "long": 98.515,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 850302,
            "zip_code": 85120,
            "name_th": "กะเปอร์",
            "name_en": "Kapoe",
            "district_id": 8503,
            "lat": 9.623,
            "long": 98.621,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 850303,
            "zip_code": 85120,
            "name_th": "เชี่ยวเหลียง",
            "name_en": "Chiao Liang",
            "district_id": 8503,
            "lat": 9.562,
            "long": 98.664,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 850304,
            "zip_code": 85120,
            "name_th": "บ้านนา",
            "name_en": "Ban Na",
            "district_id": 8503,
            "lat": 9.553,
            "long": 98.74,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 850305,
            "zip_code": 85120,
            "name_th": "บางหิน",
            "name_en": "Bang Hin",
            "district_id": 8503,
            "lat": 9.595,
            "long": 98.469,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 8504,
        "name_th": "กระบุรี",
        "name_en": "Kra Buri",
        "province_id": 68,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 850401,
            "zip_code": 85110,
            "name_th": "น้ำจืด",
            "name_en": "Nam Chuet",
            "district_id": 8504,
            "lat": 10.394,
            "long": 98.842,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 850402,
            "zip_code": 85110,
            "name_th": "น้ำจืดน้อย",
            "name_en": "Nam Chuet Noi",
            "district_id": 8504,
            "lat": 10.427,
            "long": 98.793,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 850403,
            "zip_code": 85110,
            "name_th": "มะมุ",
            "name_en": "Mamu",
            "district_id": 8504,
            "lat": 10.457,
            "long": 98.846,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 850404,
            "zip_code": 85110,
            "name_th": "ปากจั่น",
            "name_en": "Pak Chan",
            "district_id": 8504,
            "lat": 10.575,
            "long": 98.832,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 850405,
            "zip_code": 85110,
            "name_th": "ลำเลียง",
            "name_en": "Lamliang",
            "district_id": 8504,
            "lat": 10.287,
            "long": 98.842,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 850406,
            "zip_code": 85110,
            "name_th": "จ.ป.ร.",
            "name_en": "Choporo",
            "district_id": 8504,
            "lat": 10.648,
            "long": 98.883,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 850407,
            "zip_code": 85110,
            "name_th": "บางใหญ่",
            "name_en": "Bang Yai",
            "district_id": 8504,
            "lat": 10.265,
            "long": 98.757,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 8505,
        "name_th": "สุขสำราญ",
        "name_en": "Suk Samran",
        "province_id": 68,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 850501,
            "zip_code": 85120,
            "name_th": "นาคา",
            "name_en": "Nakha",
            "district_id": 8505,
            "lat": 9.514,
            "long": 98.36,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 850502,
            "zip_code": 85120,
            "name_th": "กำพวน",
            "name_en": "Kamphuan",
            "district_id": 8505,
            "lat": 9.401,
            "long": 98.392,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      }
    ]
  },
  {
    "id": 69,
    "name_th": "ชุมพร",
    "name_en": "Chumphon",
    "geography_id": 6,
    "created_at": "2019-08-09T03:33:09.000+07:00",
    "updated_at": "2025-09-20T06:31:26.000+07:00",
    "deleted_at": null,
    "districts": [
      {
        "id": 8601,
        "name_th": "เมืองชุมพร",
        "name_en": "Mueang Chumphon",
        "province_id": 69,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 860101,
            "zip_code": 86000,
            "name_th": "ท่าตะเภา",
            "name_en": "Tha Taphao",
            "district_id": 8601,
            "lat": 10.498,
            "long": 99.179,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 860102,
            "zip_code": 86120,
            "name_th": "ปากน้ำ",
            "name_en": "Pak Nam",
            "district_id": 8601,
            "lat": 10.448,
            "long": 99.253,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 860103,
            "zip_code": 86000,
            "name_th": "ท่ายาง",
            "name_en": "Tha Yang",
            "district_id": 8601,
            "lat": 10.434,
            "long": 99.217,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 860104,
            "zip_code": 86000,
            "name_th": "บางหมาก",
            "name_en": "Bang Mak",
            "district_id": 8601,
            "lat": 10.449,
            "long": 99.185,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 860105,
            "zip_code": 86000,
            "name_th": "นาทุ่ง",
            "name_en": "Na Thung",
            "district_id": 8601,
            "lat": 10.5,
            "long": 99.196,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 860106,
            "zip_code": 86000,
            "name_th": "นาชะอัง",
            "name_en": "Na Cha-ang",
            "district_id": 8601,
            "lat": 10.557,
            "long": 99.379,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 860107,
            "zip_code": 86000,
            "name_th": "ตากแดด",
            "name_en": "Tak Daet",
            "district_id": 8601,
            "lat": 10.467,
            "long": 99.153,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 860108,
            "zip_code": 86000,
            "name_th": "บางลึก",
            "name_en": "Bang Luek",
            "district_id": 8601,
            "lat": 10.551,
            "long": 99.185,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 860109,
            "zip_code": 86000,
            "name_th": "หาดพันไกร",
            "name_en": "Hat Phan Krai",
            "district_id": 8601,
            "lat": 10.561,
            "long": 99.143,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 860110,
            "zip_code": 86000,
            "name_th": "วังไผ่",
            "name_en": "Wang Phai",
            "district_id": 8601,
            "lat": 10.525,
            "long": 99.123,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 860111,
            "zip_code": 86190,
            "name_th": "วังใหม่",
            "name_en": "Wang Mai",
            "district_id": 8601,
            "lat": 10.523,
            "long": 99.054,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 860112,
            "zip_code": 86190,
            "name_th": "บ้านนา",
            "name_en": "Ban Na",
            "district_id": 8601,
            "lat": 10.437,
            "long": 98.952,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 860113,
            "zip_code": 86000,
            "name_th": "ขุนกระทิง",
            "name_en": "Khun Krathing",
            "district_id": 8601,
            "lat": 10.457,
            "long": 99.104,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 860114,
            "zip_code": 86100,
            "name_th": "ทุ่งคา",
            "name_en": "Thung Kha",
            "district_id": 8601,
            "lat": 10.398,
            "long": 99.14,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 860115,
            "zip_code": 86100,
            "name_th": "วิสัยเหนือ",
            "name_en": "Wisai Nuea",
            "district_id": 8601,
            "lat": 10.367,
            "long": 99.09,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 860116,
            "zip_code": 86120,
            "name_th": "หาดทรายรี",
            "name_en": "Hat Sai Ri",
            "district_id": 8601,
            "lat": 10.459,
            "long": 99.403,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 860117,
            "zip_code": 86100,
            "name_th": "ถ้ำสิงห์",
            "name_en": "Tham Sing",
            "district_id": 8601,
            "lat": 10.418,
            "long": 99.058,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 8602,
        "name_th": "ท่าแซะ",
        "name_en": "Tha Sae",
        "province_id": 69,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 860201,
            "zip_code": 86140,
            "name_th": "ท่าแซะ",
            "name_en": "Tha Sae",
            "district_id": 8602,
            "lat": 10.663,
            "long": 99.166,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 860202,
            "zip_code": 86140,
            "name_th": "คุริง",
            "name_en": "Khuring",
            "district_id": 8602,
            "lat": 10.744,
            "long": 99.118,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 860203,
            "zip_code": 86140,
            "name_th": "สลุย",
            "name_en": "Salui",
            "district_id": 8602,
            "lat": 10.835,
            "long": 99.233,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 860204,
            "zip_code": 86140,
            "name_th": "นากระตาม",
            "name_en": "Na Kratam",
            "district_id": 8602,
            "lat": 10.606,
            "long": 99.184,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 860205,
            "zip_code": 86190,
            "name_th": "รับร่อ",
            "name_en": "Rap Ro",
            "district_id": 8602,
            "lat": 10.768,
            "long": 99.011,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 860206,
            "zip_code": 86140,
            "name_th": "ท่าข้าม",
            "name_en": "Tha Kham",
            "district_id": 8602,
            "lat": 10.66,
            "long": 99.105,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 860207,
            "zip_code": 86140,
            "name_th": "หงษ์เจริญ",
            "name_en": "Hong Charoen",
            "district_id": 8602,
            "lat": 10.808,
            "long": 99.134,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 860208,
            "zip_code": 86190,
            "name_th": "หินแก้ว",
            "name_en": "Hin Kaeo",
            "district_id": 8602,
            "lat": 10.622,
            "long": 98.992,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 860209,
            "zip_code": 86140,
            "name_th": "ทรัพย์อนันต์",
            "name_en": "Sap Anan",
            "district_id": 8602,
            "lat": 10.713,
            "long": 99.202,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 860210,
            "zip_code": 86140,
            "name_th": "สองพี่น้อง",
            "name_en": "Song Phi Nong",
            "district_id": 8602,
            "lat": 10.949,
            "long": 99.189,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 8603,
        "name_th": "ปะทิว",
        "name_en": "Pathio",
        "province_id": 69,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 860301,
            "zip_code": 86160,
            "name_th": "บางสน",
            "name_en": "Bang Song",
            "district_id": 8603,
            "lat": 10.658,
            "long": 99.264,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 860302,
            "zip_code": 86160,
            "name_th": "ทะเลทรัพย์",
            "name_en": "Thale Sap",
            "district_id": 8603,
            "lat": 10.727,
            "long": 99.267,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 860303,
            "zip_code": 86230,
            "name_th": "สะพลี",
            "name_en": "Saphli",
            "district_id": 8603,
            "lat": 10.608,
            "long": 99.25,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 860304,
            "zip_code": 86160,
            "name_th": "ชุมโค",
            "name_en": "Chum Kho",
            "district_id": 8603,
            "lat": 10.701,
            "long": 99.41,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 860305,
            "zip_code": 86210,
            "name_th": "ดอนยาง",
            "name_en": "Don Yang",
            "district_id": 8603,
            "lat": 10.861,
            "long": 99.354,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 860306,
            "zip_code": 86210,
            "name_th": "ปากคลอง",
            "name_en": "Pak Khlong",
            "district_id": 8603,
            "lat": 10.862,
            "long": 99.486,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 860307,
            "zip_code": 86210,
            "name_th": "เขาไชยราช",
            "name_en": "Khao Chai Rat",
            "district_id": 8603,
            "lat": 10.939,
            "long": 99.349,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 8604,
        "name_th": "หลังสวน",
        "name_en": "Lang Suan",
        "province_id": 69,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 860401,
            "zip_code": 86110,
            "name_th": "หลังสวน",
            "name_en": "Lang Suan",
            "district_id": 8604,
            "lat": 9.95,
            "long": 99.09,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 860402,
            "zip_code": 86110,
            "name_th": "ขันเงิน",
            "name_en": "Khan Ngoen",
            "district_id": 8604,
            "lat": 9.934,
            "long": 99.074,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 860403,
            "zip_code": 86110,
            "name_th": "ท่ามะพลา",
            "name_en": "Tha Maphla",
            "district_id": 8604,
            "lat": 9.929,
            "long": 99.045,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 860404,
            "zip_code": 86110,
            "name_th": "นาขา",
            "name_en": "Na Kha",
            "district_id": 8604,
            "lat": 10.009,
            "long": 99.081,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 860405,
            "zip_code": 86110,
            "name_th": "นาพญา",
            "name_en": "Na Phaya",
            "district_id": 8604,
            "lat": 9.872,
            "long": 99.12,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 860406,
            "zip_code": 86110,
            "name_th": "บ้านควน",
            "name_en": "Ban Khuan",
            "district_id": 8604,
            "lat": 9.85,
            "long": 99.028,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 860407,
            "zip_code": 86110,
            "name_th": "บางมะพร้าว",
            "name_en": "Bang Maphrao",
            "district_id": 8604,
            "lat": 9.918,
            "long": 99.147,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 860408,
            "zip_code": 86150,
            "name_th": "บางน้ำจืด",
            "name_en": "Bang Nam Chuet",
            "district_id": 8604,
            "lat": 10.051,
            "long": 99.188,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 860409,
            "zip_code": 86150,
            "name_th": "ปากน้ำ",
            "name_en": "Pak Nam",
            "district_id": 8604,
            "lat": 9.955,
            "long": 99.151,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 860410,
            "zip_code": 86110,
            "name_th": "พ้อแดง",
            "name_en": "Pho Daeng",
            "district_id": 8604,
            "lat": 9.926,
            "long": 99.099,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 860411,
            "zip_code": 86110,
            "name_th": "แหลมทราย",
            "name_en": "Laem Sai",
            "district_id": 8604,
            "lat": 9.962,
            "long": 99.118,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 860412,
            "zip_code": 86110,
            "name_th": "วังตะกอ",
            "name_en": "Wang Tako",
            "district_id": 8604,
            "lat": 9.986,
            "long": 98.984,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 860413,
            "zip_code": 86110,
            "name_th": "หาดยาย",
            "name_en": "Hat Yai",
            "district_id": 8604,
            "lat": 9.96,
            "long": 98.956,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 8605,
        "name_th": "ละแม",
        "name_en": "Lamae",
        "province_id": 69,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 860501,
            "zip_code": 86170,
            "name_th": "ละแม",
            "name_en": "Lamae",
            "district_id": 8605,
            "lat": 9.752,
            "long": 98.945,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 860502,
            "zip_code": 86170,
            "name_th": "ทุ่งหลวง",
            "name_en": "Thung Luang",
            "district_id": 8605,
            "lat": 9.8,
            "long": 99.065,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 860503,
            "zip_code": 86170,
            "name_th": "สวนแตง",
            "name_en": "Suan Taeng",
            "district_id": 8605,
            "lat": 9.723,
            "long": 99.108,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 860504,
            "zip_code": 86170,
            "name_th": "ทุ่งคาวัด",
            "name_en": "Thung Kha Wat",
            "district_id": 8605,
            "lat": 9.748,
            "long": 99.0,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 8606,
        "name_th": "พะโต๊ะ",
        "name_en": "Phato",
        "province_id": 69,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 860601,
            "zip_code": 86180,
            "name_th": "พะโต๊ะ",
            "name_en": "Phato",
            "district_id": 8606,
            "lat": 9.816,
            "long": 98.8,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 860602,
            "zip_code": 86180,
            "name_th": "ปากทรง",
            "name_en": "Pak Song",
            "district_id": 8606,
            "lat": 9.741,
            "long": 98.703,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 860603,
            "zip_code": 86180,
            "name_th": "ปังหวาน",
            "name_en": "Pang Wan",
            "district_id": 8606,
            "lat": 9.951,
            "long": 98.866,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 860604,
            "zip_code": 86180,
            "name_th": "พระรักษ์",
            "name_en": "Phra Rak",
            "district_id": 8606,
            "lat": 9.852,
            "long": 98.923,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 8607,
        "name_th": "สวี",
        "name_en": "Sawi",
        "province_id": 69,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 860701,
            "zip_code": 86130,
            "name_th": "นาโพธิ์",
            "name_en": "Na Pho",
            "district_id": 8607,
            "lat": 10.198,
            "long": 99.107,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 860702,
            "zip_code": 86130,
            "name_th": "สวี",
            "name_en": "Sawi",
            "district_id": 8607,
            "lat": 10.247,
            "long": 99.081,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 860703,
            "zip_code": 86130,
            "name_th": "ทุ่งระยะ",
            "name_en": "Thung Raya",
            "district_id": 8607,
            "lat": 10.277,
            "long": 98.945,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 860704,
            "zip_code": 86130,
            "name_th": "ท่าหิน",
            "name_en": "Tha Hin",
            "district_id": 8607,
            "lat": 10.213,
            "long": 99.151,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 860705,
            "zip_code": 86130,
            "name_th": "ปากแพรก",
            "name_en": "Pak Phraek",
            "district_id": 8607,
            "lat": 10.291,
            "long": 99.148,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 860706,
            "zip_code": 86130,
            "name_th": "ด่านสวี",
            "name_en": "Dan Sawi",
            "district_id": 8607,
            "lat": 10.291,
            "long": 99.241,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 860707,
            "zip_code": 86130,
            "name_th": "ครน",
            "name_en": "Khron",
            "district_id": 8607,
            "lat": 10.311,
            "long": 99.063,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 860708,
            "zip_code": 86130,
            "name_th": "วิสัยใต้",
            "name_en": "Wisai Tai",
            "district_id": 8607,
            "lat": 10.36,
            "long": 99.04,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 860709,
            "zip_code": 86130,
            "name_th": "นาสัก",
            "name_en": "Na Sak",
            "district_id": 8607,
            "lat": 10.177,
            "long": 99.0,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 860710,
            "zip_code": 86130,
            "name_th": "เขาทะลุ",
            "name_en": "Khao Thalu",
            "district_id": 8607,
            "lat": 10.197,
            "long": 98.915,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 860711,
            "zip_code": 86130,
            "name_th": "เขาค่าย",
            "name_en": "Khao Khai",
            "district_id": 8607,
            "lat": 10.104,
            "long": 98.891,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 8608,
        "name_th": "ทุ่งตะโก",
        "name_en": "Thung Tako",
        "province_id": 69,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 860801,
            "zip_code": 86220,
            "name_th": "ปากตะโก",
            "name_en": "Pak Tako",
            "district_id": 8608,
            "lat": 10.165,
            "long": 99.176,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 860802,
            "zip_code": 86220,
            "name_th": "ทุ่งตะไคร",
            "name_en": "Thung Takhrai",
            "district_id": 8608,
            "lat": 10.131,
            "long": 99.097,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 860803,
            "zip_code": 86220,
            "name_th": "ตะโก",
            "name_en": "Tako",
            "district_id": 8608,
            "lat": 10.056,
            "long": 98.974,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 860804,
            "zip_code": 86220,
            "name_th": "ช่องไม้แก้ว",
            "name_en": "Chong Mai Kaeo",
            "district_id": 8608,
            "lat": 10.117,
            "long": 99.024,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      }
    ]
  },
  {
    "id": 70,
    "name_th": "สงขลา",
    "name_en": "Songkhla",
    "geography_id": 6,
    "created_at": "2019-08-09T03:33:09.000+07:00",
    "updated_at": "2025-09-20T06:31:26.000+07:00",
    "deleted_at": null,
    "districts": [
      {
        "id": 9001,
        "name_th": "เมืองสงขลา",
        "name_en": "Mueang Songkhla",
        "province_id": 70,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 900101,
            "zip_code": 90000,
            "name_th": "บ่อยาง",
            "name_en": "Bo Yang",
            "district_id": 9001,
            "lat": 7.198,
            "long": 100.596,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 900102,
            "zip_code": 90000,
            "name_th": "เขารูปช้าง",
            "name_en": "Khao Rup Chang",
            "district_id": 9001,
            "lat": 7.154,
            "long": 100.612,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 900103,
            "zip_code": 90000,
            "name_th": "เกาะแต้ว",
            "name_en": "Ko Taeo",
            "district_id": 9001,
            "lat": 7.112,
            "long": 100.638,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 900104,
            "zip_code": 90100,
            "name_th": "พะวง",
            "name_en": "Phawong",
            "district_id": 9001,
            "lat": 7.105,
            "long": 100.588,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 900105,
            "zip_code": 90000,
            "name_th": "ทุ่งหวัง",
            "name_en": "Thung Wang",
            "district_id": 9001,
            "lat": 7.069,
            "long": 100.657,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 900106,
            "zip_code": 90100,
            "name_th": "เกาะยอ",
            "name_en": "Ko Yo",
            "district_id": 9001,
            "lat": 7.163,
            "long": 100.542,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 9002,
        "name_th": "สทิงพระ",
        "name_en": "Sathing Phra",
        "province_id": 70,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 900201,
            "zip_code": 90190,
            "name_th": "จะทิ้งพระ",
            "name_en": "Chathing Phra",
            "district_id": 9002,
            "lat": 7.469,
            "long": 100.437,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 900202,
            "zip_code": 90190,
            "name_th": "กระดังงา",
            "name_en": "Kradangnga",
            "district_id": 9002,
            "lat": 7.509,
            "long": 100.427,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 900203,
            "zip_code": 90190,
            "name_th": "สนามชัย",
            "name_en": "Sanam Chai",
            "district_id": 9002,
            "lat": 7.547,
            "long": 100.417,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 900204,
            "zip_code": 90190,
            "name_th": "ดีหลวง",
            "name_en": "Di Luang",
            "district_id": 9002,
            "lat": 7.58,
            "long": 100.406,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 900205,
            "zip_code": 90190,
            "name_th": "ชุมพล",
            "name_en": "Chumphon",
            "district_id": 9002,
            "lat": 7.603,
            "long": 100.385,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 900206,
            "zip_code": 90190,
            "name_th": "คลองรี",
            "name_en": "Khlong Ri",
            "district_id": 9002,
            "lat": 7.542,
            "long": 100.388,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 900207,
            "zip_code": 90190,
            "name_th": "คูขุด",
            "name_en": "Khu Khut",
            "district_id": 9002,
            "lat": 7.458,
            "long": 100.406,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 900208,
            "zip_code": 90190,
            "name_th": "ท่าหิน",
            "name_en": "Tha Hin",
            "district_id": 9002,
            "lat": 7.395,
            "long": 100.419,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 900209,
            "zip_code": 90190,
            "name_th": "วัดจันทร์",
            "name_en": "Wat Chan",
            "district_id": 9002,
            "lat": 7.382,
            "long": 100.461,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 900210,
            "zip_code": 90190,
            "name_th": "บ่อแดง",
            "name_en": "Bo Daeng",
            "district_id": 9002,
            "lat": 7.406,
            "long": 100.454,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 900211,
            "zip_code": 90190,
            "name_th": "บ่อดาน",
            "name_en": "Bor Dan",
            "district_id": 9002,
            "lat": 7.435,
            "long": 100.447,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 9003,
        "name_th": "จะนะ",
        "name_en": "Chana",
        "province_id": 70,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 900301,
            "zip_code": 90130,
            "name_th": "บ้านนา",
            "name_en": "Ban Na",
            "district_id": 9003,
            "lat": 6.901,
            "long": 100.742,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 900302,
            "zip_code": 90130,
            "name_th": "ป่าชิง",
            "name_en": "Pa Ching",
            "district_id": 9003,
            "lat": 6.939,
            "long": 100.686,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 900303,
            "zip_code": 90130,
            "name_th": "สะพานไม้แก่น",
            "name_en": "Saphan Mai Kaen",
            "district_id": 9003,
            "lat": 6.826,
            "long": 100.783,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 900304,
            "zip_code": 90130,
            "name_th": "สะกอม",
            "name_en": "Sakom",
            "district_id": 9003,
            "lat": 6.935,
            "long": 100.794,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 900305,
            "zip_code": 90130,
            "name_th": "นาหว้า",
            "name_en": "Na Wa",
            "district_id": 9003,
            "lat": 6.896,
            "long": 100.655,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 900306,
            "zip_code": 90130,
            "name_th": "นาทับ",
            "name_en": "Na Thap",
            "district_id": 9003,
            "lat": 7.035,
            "long": 100.7,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 900307,
            "zip_code": 90130,
            "name_th": "น้ำขาว",
            "name_en": "Nam Khao",
            "district_id": 9003,
            "lat": 6.805,
            "long": 100.609,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 900308,
            "zip_code": 90130,
            "name_th": "ขุนตัดหวาย",
            "name_en": "Khun Tat Wai",
            "district_id": 9003,
            "lat": 6.794,
            "long": 100.7,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 900309,
            "zip_code": 90130,
            "name_th": "ท่าหมอไทร",
            "name_en": "Tha Mo Sai",
            "district_id": 9003,
            "lat": 6.794,
            "long": 100.751,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 900310,
            "zip_code": 90130,
            "name_th": "จะโหนง",
            "name_en": "Chanong",
            "district_id": 9003,
            "lat": 7.006,
            "long": 100.67,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 900311,
            "zip_code": 90130,
            "name_th": "คู",
            "name_en": "Khu",
            "district_id": 9003,
            "lat": 6.842,
            "long": 100.695,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 900312,
            "zip_code": 90130,
            "name_th": "แค",
            "name_en": "Khae",
            "district_id": 9003,
            "lat": 6.853,
            "long": 100.618,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 900313,
            "zip_code": 90130,
            "name_th": "คลองเปียะ",
            "name_en": "Khlong Pia",
            "district_id": 9003,
            "lat": 6.952,
            "long": 100.632,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 900314,
            "zip_code": 90130,
            "name_th": "ตลิ่งชัน",
            "name_en": "Taling Chan",
            "district_id": 9003,
            "lat": 6.969,
            "long": 100.742,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 9004,
        "name_th": "นาทวี",
        "name_en": "Na Thawi",
        "province_id": 70,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 900401,
            "zip_code": 90160,
            "name_th": "นาทวี",
            "name_en": "Na Thawi",
            "district_id": 9004,
            "lat": 6.693,
            "long": 100.777,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 900402,
            "zip_code": 90160,
            "name_th": "ฉาง",
            "name_en": "Chang",
            "district_id": 9004,
            "lat": 6.762,
            "long": 100.709,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 900403,
            "zip_code": 90160,
            "name_th": "นาหมอศรี",
            "name_en": "Na Mo Si",
            "district_id": 9004,
            "lat": 6.781,
            "long": 100.67,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 900404,
            "zip_code": 90160,
            "name_th": "คลองทราย",
            "name_en": "Khlong Sai",
            "district_id": 9004,
            "lat": 6.741,
            "long": 100.603,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 900405,
            "zip_code": 90160,
            "name_th": "ปลักหนู",
            "name_en": "Plak Nu",
            "district_id": 9004,
            "lat": 6.676,
            "long": 100.663,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 900406,
            "zip_code": 90160,
            "name_th": "ท่าประดู่",
            "name_en": "Tha Pradu",
            "district_id": 9004,
            "lat": 6.681,
            "long": 100.73,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 900407,
            "zip_code": 90160,
            "name_th": "สะท้อน",
            "name_en": "Sathon",
            "district_id": 9004,
            "lat": 6.622,
            "long": 100.673,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 900408,
            "zip_code": 90160,
            "name_th": "ทับช้าง",
            "name_en": "Thap Chang",
            "district_id": 9004,
            "lat": 6.586,
            "long": 100.695,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 900409,
            "zip_code": 90160,
            "name_th": "ประกอบ",
            "name_en": "Prakop",
            "district_id": 9004,
            "lat": 6.483,
            "long": 100.643,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 900410,
            "zip_code": 90160,
            "name_th": "คลองกวาง",
            "name_en": "Khlong Kwang",
            "district_id": 9004,
            "lat": 6.636,
            "long": 100.61,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 9005,
        "name_th": "เทพา",
        "name_en": "Thepha",
        "province_id": 70,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 900501,
            "zip_code": 90150,
            "name_th": "เทพา",
            "name_en": "Thepha",
            "district_id": 9005,
            "lat": 6.82,
            "long": 100.94,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 900502,
            "zip_code": 90150,
            "name_th": "ปากบาง",
            "name_en": "Pak Bang",
            "district_id": 9005,
            "lat": 6.826,
            "long": 101.009,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 900503,
            "zip_code": 90150,
            "name_th": "เกาะสะบ้า",
            "name_en": "Ko Saba",
            "district_id": 9005,
            "lat": 6.863,
            "long": 100.891,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 900504,
            "zip_code": 90260,
            "name_th": "ลำไพล",
            "name_en": "Lam Phlai",
            "district_id": 9005,
            "lat": 6.721,
            "long": 100.93,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 900505,
            "zip_code": 90260,
            "name_th": "ท่าม่วง",
            "name_en": "Tha Muang",
            "district_id": 9005,
            "lat": 6.742,
            "long": 101.001,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 900506,
            "zip_code": 90260,
            "name_th": "วังใหญ่",
            "name_en": "Wang Yai",
            "district_id": 9005,
            "lat": 6.763,
            "long": 100.853,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 900507,
            "zip_code": 90150,
            "name_th": "สะกอม",
            "name_en": "Sakom",
            "district_id": 9005,
            "lat": 6.88,
            "long": 100.818,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 9006,
        "name_th": "สะบ้าย้อย",
        "name_en": "Saba Yoi",
        "province_id": 70,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 900601,
            "zip_code": 90210,
            "name_th": "สะบ้าย้อย",
            "name_en": "Saba Yoi",
            "district_id": 9006,
            "lat": 6.632,
            "long": 100.929,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 900602,
            "zip_code": 90210,
            "name_th": "ทุ่งพอ",
            "name_en": "Thung Pho",
            "district_id": 9006,
            "lat": 6.553,
            "long": 100.91,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 900603,
            "zip_code": 90210,
            "name_th": "เปียน",
            "name_en": "Pian",
            "district_id": 9006,
            "lat": 6.634,
            "long": 101.003,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 900604,
            "zip_code": 90210,
            "name_th": "บ้านโหนด",
            "name_en": "Ban Not",
            "district_id": 9006,
            "lat": 6.624,
            "long": 101.057,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 900605,
            "zip_code": 90210,
            "name_th": "จะแหน",
            "name_en": "Chanae",
            "district_id": 9006,
            "lat": 6.517,
            "long": 100.962,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 900606,
            "zip_code": 90210,
            "name_th": "คูหา",
            "name_en": "Khuha",
            "district_id": 9006,
            "lat": 6.61,
            "long": 100.833,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 900607,
            "zip_code": 90210,
            "name_th": "เขาแดง",
            "name_en": "Khao Daeng",
            "district_id": 9006,
            "lat": 6.505,
            "long": 100.802,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 900608,
            "zip_code": 90210,
            "name_th": "บาโหย",
            "name_en": "Ba Hoi",
            "district_id": 9006,
            "lat": 6.396,
            "long": 100.884,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 900609,
            "zip_code": 90210,
            "name_th": "ธารคีรี",
            "name_en": "Than Khiri",
            "district_id": 9006,
            "lat": 6.559,
            "long": 101.059,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 9007,
        "name_th": "ระโนด",
        "name_en": "Ranot",
        "province_id": 70,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 900701,
            "zip_code": 90140,
            "name_th": "ระโนด",
            "name_en": "Ranot",
            "district_id": 9007,
            "lat": 7.754,
            "long": 100.325,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 900702,
            "zip_code": 90140,
            "name_th": "คลองแดน",
            "name_en": "Khlong Daen",
            "district_id": 9007,
            "lat": 7.912,
            "long": 100.319,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 900703,
            "zip_code": 90140,
            "name_th": "ตะเครียะ",
            "name_en": "Takhria",
            "district_id": 9007,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 900704,
            "zip_code": 90140,
            "name_th": "ท่าบอน",
            "name_en": "Tha Bon",
            "district_id": 9007,
            "lat": 7.842,
            "long": 100.342,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 900705,
            "zip_code": 90140,
            "name_th": "บ้านใหม่",
            "name_en": "Ban Mai",
            "district_id": 9007,
            "lat": 7.78,
            "long": 100.288,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 900706,
            "zip_code": 90140,
            "name_th": "บ่อตรุ",
            "name_en": "Bo Tru",
            "district_id": 9007,
            "lat": 7.631,
            "long": 100.374,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 900707,
            "zip_code": 90140,
            "name_th": "ปากแตระ",
            "name_en": "Pak Trae",
            "district_id": 9007,
            "lat": 7.766,
            "long": 100.358,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 900708,
            "zip_code": 90140,
            "name_th": "พังยาง",
            "name_en": "Phang Yang",
            "district_id": 9007,
            "lat": 7.721,
            "long": 100.354,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 900709,
            "zip_code": 90140,
            "name_th": "ระวะ",
            "name_en": "Rawa",
            "district_id": 9007,
            "lat": 7.713,
            "long": 100.378,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 900710,
            "zip_code": 90140,
            "name_th": "วัดสน",
            "name_en": "Wat Son",
            "district_id": 9007,
            "lat": 7.668,
            "long": 100.372,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 900711,
            "zip_code": 90140,
            "name_th": "บ้านขาว",
            "name_en": "Ban Khao",
            "district_id": 9007,
            "lat": 7.761,
            "long": 100.247,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 900712,
            "zip_code": 90140,
            "name_th": "แดนสงวน",
            "name_en": "Daen Sa-nguan",
            "district_id": 9007,
            "lat": 7.878,
            "long": 100.291,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 9008,
        "name_th": "กระแสสินธุ์",
        "name_en": "Krasae Sin",
        "province_id": 70,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 900801,
            "zip_code": 90270,
            "name_th": "เกาะใหญ่",
            "name_en": "Ko Yai",
            "district_id": 9008,
            "lat": 7.552,
            "long": 100.287,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 900802,
            "zip_code": 90270,
            "name_th": "โรง",
            "name_en": "Rong",
            "district_id": 9008,
            "lat": 7.683,
            "long": 100.338,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 900803,
            "zip_code": 90270,
            "name_th": "เชิงแส",
            "name_en": "Choeng Sae",
            "district_id": 9008,
            "lat": 7.561,
            "long": 100.356,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 900804,
            "zip_code": 90270,
            "name_th": "กระแสสินธุ์",
            "name_en": "Krasae Sin",
            "district_id": 9008,
            "lat": 7.609,
            "long": 100.307,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 9009,
        "name_th": "รัตภูมิ",
        "name_en": "Rattaphum",
        "province_id": 70,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 900901,
            "zip_code": 90180,
            "name_th": "กำแพงเพชร",
            "name_en": "Kamphaeng Phet",
            "district_id": 9009,
            "lat": 7.087,
            "long": 100.287,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 900902,
            "zip_code": 90180,
            "name_th": "ท่าชะมวง",
            "name_en": "Tha Chamuang",
            "district_id": 9009,
            "lat": 7.132,
            "long": 100.106,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 900903,
            "zip_code": 90180,
            "name_th": "คูหาใต้",
            "name_en": "Khuha Tai",
            "district_id": 9009,
            "lat": 7.173,
            "long": 100.263,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 900904,
            "zip_code": 90180,
            "name_th": "ควนรู",
            "name_en": "Khuan Ru",
            "district_id": 9009,
            "lat": 7.183,
            "long": 100.313,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 900909,
            "zip_code": 90180,
            "name_th": "เขาพระ",
            "name_en": "Khao Phra",
            "district_id": 9009,
            "lat": 7.011,
            "long": 100.141,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 9010,
        "name_th": "สะเดา",
        "name_en": "Sadao",
        "province_id": 70,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 901001,
            "zip_code": 90120,
            "name_th": "สะเดา",
            "name_en": "Sadao",
            "district_id": 9010,
            "lat": 6.636,
            "long": 100.416,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 901002,
            "zip_code": 90120,
            "name_th": "ปริก",
            "name_en": "Prik",
            "district_id": 9010,
            "lat": 6.694,
            "long": 100.473,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 901003,
            "zip_code": 90170,
            "name_th": "พังลา",
            "name_en": "Phang La",
            "district_id": 9010,
            "lat": 6.773,
            "long": 100.464,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 901004,
            "zip_code": 90120,
            "name_th": "สำนักแต้ว",
            "name_en": "Samnak Taeo",
            "district_id": 9010,
            "lat": 6.567,
            "long": 100.516,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 901005,
            "zip_code": 90240,
            "name_th": "ทุ่งหมอ",
            "name_en": "Thung Mo",
            "district_id": 9010,
            "lat": 6.745,
            "long": 100.378,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 901006,
            "zip_code": 90170,
            "name_th": "ท่าโพธิ์",
            "name_en": "Tha Pho",
            "district_id": 9010,
            "lat": 6.796,
            "long": 100.416,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 901007,
            "zip_code": 90240,
            "name_th": "ปาดังเบซาร์",
            "name_en": "Padang Besa",
            "district_id": 9010,
            "lat": 6.74,
            "long": 100.241,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 901008,
            "zip_code": 90320,
            "name_th": "สำนักขาม",
            "name_en": "Samnak Kham",
            "district_id": 9010,
            "lat": 6.584,
            "long": 100.382,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 901009,
            "zip_code": 90170,
            "name_th": "เขามีเกียรติ",
            "name_en": "Khao Mi Kiat",
            "district_id": 9010,
            "lat": 6.774,
            "long": 100.524,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 9011,
        "name_th": "หาดใหญ่",
        "name_en": "Hat Yai",
        "province_id": 70,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 901101,
            "zip_code": 90110,
            "name_th": "หาดใหญ่",
            "name_en": "Hat Yai",
            "district_id": 9011,
            "lat": 7.01,
            "long": 100.474,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 901102,
            "zip_code": 90110,
            "name_th": "ควนลัง",
            "name_en": "Khuan Lang",
            "district_id": 9011,
            "lat": 6.973,
            "long": 100.421,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 901103,
            "zip_code": 90110,
            "name_th": "คูเต่า",
            "name_en": "Khu Tao",
            "district_id": 9011,
            "lat": 7.133,
            "long": 100.481,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 901104,
            "zip_code": 90110,
            "name_th": "คอหงส์",
            "name_en": "Kho Hong",
            "district_id": 9011,
            "lat": 7.006,
            "long": 100.503,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 901105,
            "zip_code": 90110,
            "name_th": "คลองแห",
            "name_en": "Khlong Hae",
            "district_id": 9011,
            "lat": 7.055,
            "long": 100.48,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 901107,
            "zip_code": 90110,
            "name_th": "คลองอู่ตะเภา",
            "name_en": "Khlong U Taphao",
            "district_id": 9011,
            "lat": 7.045,
            "long": 100.446,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 901108,
            "zip_code": 90110,
            "name_th": "ฉลุง",
            "name_en": "Chalung",
            "district_id": 9011,
            "lat": 7.007,
            "long": 100.296,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 901111,
            "zip_code": 90110,
            "name_th": "ทุ่งใหญ่",
            "name_en": "Thung Yai",
            "district_id": 9011,
            "lat": 7.03,
            "long": 100.537,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 901112,
            "zip_code": 90110,
            "name_th": "ทุ่งตำเสา",
            "name_en": "Thung Tamsao",
            "district_id": 9011,
            "lat": 6.9,
            "long": 100.244,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 901113,
            "zip_code": 90110,
            "name_th": "ท่าข้าม",
            "name_en": "Tha Kham",
            "district_id": 9011,
            "lat": 7.041,
            "long": 100.574,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 901114,
            "zip_code": 90110,
            "name_th": "น้ำน้อย",
            "name_en": "Nam Noi",
            "district_id": 9011,
            "lat": 7.108,
            "long": 100.53,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 901116,
            "zip_code": 90250,
            "name_th": "บ้านพรุ",
            "name_en": "Ban Phru",
            "district_id": 9011,
            "lat": 6.929,
            "long": 100.49,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 901118,
            "zip_code": 90230,
            "name_th": "พะตง",
            "name_en": "Phatong",
            "district_id": 9011,
            "lat": 6.837,
            "long": 100.558,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 9012,
        "name_th": "นาหม่อม",
        "name_en": "Na Mom",
        "province_id": 70,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 901201,
            "zip_code": 90310,
            "name_th": "นาหม่อม",
            "name_en": "Na Mom",
            "district_id": 9012,
            "lat": 6.965,
            "long": 100.529,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 901202,
            "zip_code": 90310,
            "name_th": "พิจิตร",
            "name_en": "Phichit",
            "district_id": 9012,
            "lat": 6.991,
            "long": 100.561,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 901203,
            "zip_code": 90310,
            "name_th": "ทุ่งขมิ้น",
            "name_en": "Thung Khamin",
            "district_id": 9012,
            "lat": 6.916,
            "long": 100.547,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 901204,
            "zip_code": 90310,
            "name_th": "คลองหรัง",
            "name_en": "Khlong Rhang",
            "district_id": 9012,
            "lat": 6.924,
            "long": 100.591,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 9013,
        "name_th": "ควนเนียง",
        "name_en": "Khuan Niang",
        "province_id": 70,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 901301,
            "zip_code": 90220,
            "name_th": "รัตภูมิ",
            "name_en": "Rattaphum",
            "district_id": 9013,
            "lat": 7.182,
            "long": 100.37,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 901302,
            "zip_code": 90220,
            "name_th": "ควนโส",
            "name_en": "Khuan So",
            "district_id": 9013,
            "lat": 7.229,
            "long": 100.402,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 901303,
            "zip_code": 90220,
            "name_th": "ห้วยลึก",
            "name_en": "Huai Luek",
            "district_id": 9013,
            "lat": 7.267,
            "long": 100.366,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 901304,
            "zip_code": 90220,
            "name_th": "บางเหรียง",
            "name_en": "Bang Rieang",
            "district_id": 9013,
            "lat": 7.112,
            "long": 100.364,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 9014,
        "name_th": "บางกล่ำ",
        "name_en": "Bang Klam",
        "province_id": 70,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 901401,
            "zip_code": 90110,
            "name_th": "บางกล่ำ",
            "name_en": "Bang Klam",
            "district_id": 9014,
            "lat": 7.135,
            "long": 100.446,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 901402,
            "zip_code": 90110,
            "name_th": "ท่าช้าง",
            "name_en": "Tha Chang",
            "district_id": 9014,
            "lat": 7.048,
            "long": 100.378,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 901403,
            "zip_code": 90110,
            "name_th": "แม่ทอม",
            "name_en": "Mae Thom",
            "district_id": 9014,
            "lat": 7.1,
            "long": 100.456,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 901404,
            "zip_code": 90110,
            "name_th": "บ้านหาร",
            "name_en": "Ban Han",
            "district_id": 9014,
            "lat": 7.075,
            "long": 100.45,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 9015,
        "name_th": "สิงหนคร",
        "name_en": "Singhanakhon",
        "province_id": 70,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 901501,
            "zip_code": 90280,
            "name_th": "ชิงโค",
            "name_en": "Ching Kho",
            "district_id": 9015,
            "lat": 7.266,
            "long": 100.524,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 901502,
            "zip_code": 90280,
            "name_th": "สทิงหม้อ",
            "name_en": "Sathing Mo",
            "district_id": 9015,
            "lat": 7.21,
            "long": 100.524,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 901503,
            "zip_code": 90280,
            "name_th": "ทำนบ",
            "name_en": "Thamnop",
            "district_id": 9015,
            "lat": 7.246,
            "long": 100.506,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 901504,
            "zip_code": 90330,
            "name_th": "รำแดง",
            "name_en": "Ram Daeng",
            "district_id": 9015,
            "lat": 7.29,
            "long": 100.486,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 901505,
            "zip_code": 90330,
            "name_th": "วัดขนุน",
            "name_en": "Wat Khanun",
            "district_id": 9015,
            "lat": 7.304,
            "long": 100.497,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 901506,
            "zip_code": 90330,
            "name_th": "ชะแล้",
            "name_en": "Chalae",
            "district_id": 9015,
            "lat": 7.308,
            "long": 100.441,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 901507,
            "zip_code": 90330,
            "name_th": "ปากรอ",
            "name_en": "Pak Ro",
            "district_id": 9015,
            "lat": 7.277,
            "long": 100.441,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 901508,
            "zip_code": 90330,
            "name_th": "ป่าขาด",
            "name_en": "Pa Khat",
            "district_id": 9015,
            "lat": 7.241,
            "long": 100.469,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 901509,
            "zip_code": 90280,
            "name_th": "หัวเขา",
            "name_en": "Hua Khao",
            "district_id": 9015,
            "lat": 7.214,
            "long": 100.567,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 901510,
            "zip_code": 90330,
            "name_th": "บางเขียด",
            "name_en": "Bang Khiat",
            "district_id": 9015,
            "lat": 7.346,
            "long": 100.437,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 901511,
            "zip_code": 90330,
            "name_th": "ม่วงงาม",
            "name_en": "Muang Ngam",
            "district_id": 9015,
            "lat": 7.347,
            "long": 100.476,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 9016,
        "name_th": "คลองหอยโข่ง",
        "name_en": "Khlong Hoi Khong",
        "province_id": 70,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 901601,
            "zip_code": 90230,
            "name_th": "คลองหอยโข่ง",
            "name_en": "Khlong Hoi Khong",
            "district_id": 9016,
            "lat": 6.83,
            "long": 100.313,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 901602,
            "zip_code": 90230,
            "name_th": "ทุ่งลาน",
            "name_en": "Thung Lan",
            "district_id": 9016,
            "lat": 6.886,
            "long": 100.442,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 901603,
            "zip_code": 90230,
            "name_th": "โคกม่วง",
            "name_en": "Khok Muang",
            "district_id": 9016,
            "lat": 6.875,
            "long": 100.406,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 901604,
            "zip_code": 90115,
            "name_th": "คลองหลา",
            "name_en": "Khlong La",
            "district_id": 9016,
            "lat": 6.882,
            "long": 100.31,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 9077,
        "name_th": "ท้องถิ่นเทศบาลตำบลสำนักขาม",
        "name_en": "Sum Nung Kam",
        "province_id": 70,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": []
      }
    ]
  },
  {
    "id": 71,
    "name_th": "สตูล",
    "name_en": "Satun",
    "geography_id": 6,
    "created_at": "2019-08-09T03:33:09.000+07:00",
    "updated_at": "2025-09-20T06:31:26.000+07:00",
    "deleted_at": null,
    "districts": [
      {
        "id": 9101,
        "name_th": "เมืองสตูล",
        "name_en": "Mueang Satun",
        "province_id": 71,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 910101,
            "zip_code": 91000,
            "name_th": "พิมาน",
            "name_en": "Phiman",
            "district_id": 9101,
            "lat": 6.615,
            "long": 100.071,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 910102,
            "zip_code": 91000,
            "name_th": "คลองขุด",
            "name_en": "Khlong Khut",
            "district_id": 9101,
            "lat": 6.625,
            "long": 100.12,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 910103,
            "zip_code": 91000,
            "name_th": "ควนขัน",
            "name_en": "Khuan Khan",
            "district_id": 9101,
            "lat": 6.633,
            "long": 100.036,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 910104,
            "zip_code": 91140,
            "name_th": "บ้านควน",
            "name_en": "Ban Khuan",
            "district_id": 9101,
            "lat": 6.691,
            "long": 100.049,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 910105,
            "zip_code": 91140,
            "name_th": "ฉลุง",
            "name_en": "Chalung",
            "district_id": 9101,
            "lat": 6.725,
            "long": 100.035,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 910106,
            "zip_code": 91000,
            "name_th": "เกาะสาหร่าย",
            "name_en": "Ko Sarai",
            "district_id": 9101,
            "lat": 6.672,
            "long": 99.844,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 910107,
            "zip_code": 91000,
            "name_th": "ตันหยงโป",
            "name_en": "Tanyong Po",
            "district_id": 9101,
            "lat": 6.589,
            "long": 99.936,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 910108,
            "zip_code": 91000,
            "name_th": "เจ๊ะบิลัง",
            "name_en": "Che Bilang",
            "district_id": 9101,
            "lat": 6.687,
            "long": 99.965,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 910109,
            "zip_code": 91000,
            "name_th": "ตำมะลัง",
            "name_en": "Tam Malang",
            "district_id": 9101,
            "lat": 6.556,
            "long": 100.044,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 910110,
            "zip_code": 91000,
            "name_th": "ปูยู",
            "name_en": "Puyu",
            "district_id": 9101,
            "lat": 6.517,
            "long": 100.124,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 910111,
            "zip_code": 91140,
            "name_th": "ควนโพธิ์",
            "name_en": "Khuan Pho",
            "district_id": 9101,
            "lat": 6.769,
            "long": 100.018,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 910112,
            "zip_code": 91140,
            "name_th": "เกตรี",
            "name_en": "Ketri",
            "district_id": 9101,
            "lat": 6.702,
            "long": 100.095,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 9102,
        "name_th": "ควนโดน",
        "name_en": "Khuan Don",
        "province_id": 71,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 910201,
            "zip_code": 91160,
            "name_th": "ควนโดน",
            "name_en": "Khuan Don",
            "district_id": 9102,
            "lat": 6.814,
            "long": 100.06,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 910202,
            "zip_code": 91160,
            "name_th": "ควนสตอ",
            "name_en": "Khuan Sato",
            "district_id": 9102,
            "lat": 6.764,
            "long": 100.101,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 910203,
            "zip_code": 91160,
            "name_th": "ย่านซื่อ",
            "name_en": "Yan Sue",
            "district_id": 9102,
            "lat": 6.767,
            "long": 100.065,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 910204,
            "zip_code": 91160,
            "name_th": "วังประจัน",
            "name_en": "Wang Prachan",
            "district_id": 9102,
            "lat": 6.753,
            "long": 100.16,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 9103,
        "name_th": "ควนกาหลง",
        "name_en": "Khuan Kalong",
        "province_id": 71,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 910301,
            "zip_code": 91130,
            "name_th": "ทุ่งนุ้ย",
            "name_en": "Thung Nui",
            "district_id": 9103,
            "lat": 6.871,
            "long": 100.144,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 910302,
            "zip_code": 91130,
            "name_th": "ควนกาหลง",
            "name_en": "Khuan Kalong",
            "district_id": 9103,
            "lat": 6.953,
            "long": 100.03,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 910303,
            "zip_code": 91130,
            "name_th": "อุใดเจริญ",
            "name_en": "Udai Charoen",
            "district_id": 9103,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 9104,
        "name_th": "ท่าแพ",
        "name_en": "Tha Phae",
        "province_id": 71,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 910401,
            "zip_code": 91150,
            "name_th": "ท่าแพ",
            "name_en": "Tha Phae",
            "district_id": 9104,
            "lat": 6.791,
            "long": 99.964,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 910402,
            "zip_code": 91150,
            "name_th": "แป-ระ",
            "name_en": "Paera",
            "district_id": 9104,
            "lat": 6.855,
            "long": 99.927,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 910403,
            "zip_code": 91150,
            "name_th": "สาคร",
            "name_en": "Sakhon",
            "district_id": 9104,
            "lat": 6.787,
            "long": 99.865,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 910404,
            "zip_code": 91150,
            "name_th": "ท่าเรือ",
            "name_en": "Tha Rua",
            "district_id": 9104,
            "lat": 6.803,
            "long": 99.917,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 9105,
        "name_th": "ละงู",
        "name_en": "La-ngu",
        "province_id": 71,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 910501,
            "zip_code": 91110,
            "name_th": "กำแพง",
            "name_en": "Kamphaeng",
            "district_id": 9105,
            "lat": 6.933,
            "long": 99.777,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 910502,
            "zip_code": 91110,
            "name_th": "ละงู",
            "name_en": "La-ngu",
            "district_id": 9105,
            "lat": 6.842,
            "long": 99.826,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 910503,
            "zip_code": 91110,
            "name_th": "เขาขาว",
            "name_en": "Khao Khao",
            "district_id": 9105,
            "lat": 6.923,
            "long": 99.848,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 910504,
            "zip_code": 91110,
            "name_th": "ปากน้ำ",
            "name_en": "Pak Nam",
            "district_id": 9105,
            "lat": 6.834,
            "long": 99.691,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 910505,
            "zip_code": 91110,
            "name_th": "น้ำผุด",
            "name_en": "Nam Phut",
            "district_id": 9105,
            "lat": 6.973,
            "long": 99.85,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 910506,
            "zip_code": 91110,
            "name_th": "แหลมสน",
            "name_en": "Laem Son",
            "district_id": 9105,
            "lat": 6.946,
            "long": 99.713,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 9106,
        "name_th": "ทุ่งหว้า",
        "name_en": "Thung Wa",
        "province_id": 71,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 910601,
            "zip_code": 91120,
            "name_th": "ทุ่งหว้า",
            "name_en": "Thung Wa",
            "district_id": 9106,
            "lat": 7.108,
            "long": 99.807,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 910602,
            "zip_code": 91120,
            "name_th": "นาทอน",
            "name_en": "Na Thon",
            "district_id": 9106,
            "lat": 7.032,
            "long": 99.743,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 910603,
            "zip_code": 91120,
            "name_th": "ขอนคลาน",
            "name_en": "Khon Khlan",
            "district_id": 9106,
            "lat": 6.998,
            "long": 99.691,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 910604,
            "zip_code": 91120,
            "name_th": "ทุ่งบุหลัง",
            "name_en": "Thung Bulang",
            "district_id": 9106,
            "lat": 7.047,
            "long": 99.692,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 910605,
            "zip_code": 91120,
            "name_th": "ป่าแก่บ่อหิน",
            "name_en": "Pa Kae Bo Hin",
            "district_id": 9106,
            "lat": 7.048,
            "long": 99.817,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 9107,
        "name_th": "มะนัง",
        "name_en": "Manang",
        "province_id": 71,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 910701,
            "zip_code": 91130,
            "name_th": "ปาล์มพัฒนา",
            "name_en": "Palm Phatthana",
            "district_id": 9107,
            "lat": 7.038,
            "long": 99.934,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 910702,
            "zip_code": 91130,
            "name_th": "นิคมพัฒนา",
            "name_en": "Nikhom Phatthana",
            "district_id": 9107,
            "lat": 6.95,
            "long": 99.931,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      }
    ]
  },
  {
    "id": 72,
    "name_th": "ตรัง",
    "name_en": "Trang",
    "geography_id": 6,
    "created_at": "2019-08-09T03:33:09.000+07:00",
    "updated_at": "2025-09-20T06:31:26.000+07:00",
    "deleted_at": null,
    "districts": [
      {
        "id": 9201,
        "name_th": "เมืองตรัง",
        "name_en": "Mueang Trang",
        "province_id": 72,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 920101,
            "zip_code": 92000,
            "name_th": "ทับเที่ยง",
            "name_en": "Thap Thiang",
            "district_id": 9201,
            "lat": 7.559,
            "long": 99.616,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 920104,
            "zip_code": 92000,
            "name_th": "นาพละ",
            "name_en": "Na Phala",
            "district_id": 9201,
            "lat": 7.599,
            "long": 99.664,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 920105,
            "zip_code": 92000,
            "name_th": "บ้านควน",
            "name_en": "Ban Khuan",
            "district_id": 9201,
            "lat": 7.529,
            "long": 99.636,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 920106,
            "zip_code": 92000,
            "name_th": "นาบินหลา",
            "name_en": "Na Bin La",
            "district_id": 9201,
            "lat": 7.541,
            "long": 99.662,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 920107,
            "zip_code": 92000,
            "name_th": "ควนปริง",
            "name_en": "Khuan Pring",
            "district_id": 9201,
            "lat": 7.521,
            "long": 99.596,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 920108,
            "zip_code": 92170,
            "name_th": "นาโยงใต้",
            "name_en": "Na Yong Tai",
            "district_id": 9201,
            "lat": 7.571,
            "long": 99.669,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 920109,
            "zip_code": 92000,
            "name_th": "บางรัก",
            "name_en": "Bang Rak",
            "district_id": 9201,
            "lat": 7.558,
            "long": 99.577,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 920110,
            "zip_code": 92000,
            "name_th": "โคกหล่อ",
            "name_en": "Khok Lo",
            "district_id": 9201,
            "lat": 7.524,
            "long": 99.615,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 920113,
            "zip_code": 92000,
            "name_th": "นาโต๊ะหมิง",
            "name_en": "Na To Ming",
            "district_id": 9201,
            "lat": 7.556,
            "long": 99.527,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 920114,
            "zip_code": 92000,
            "name_th": "หนองตรุด",
            "name_en": "Nong Trut",
            "district_id": 9201,
            "lat": 7.594,
            "long": 99.523,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 920115,
            "zip_code": 92000,
            "name_th": "น้ำผุด",
            "name_en": "Nam Phut",
            "district_id": 9201,
            "lat": 7.673,
            "long": 99.726,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 920117,
            "zip_code": 92000,
            "name_th": "นาตาล่วง",
            "name_en": "Na Ta Luang",
            "district_id": 9201,
            "lat": 7.584,
            "long": 99.596,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 920118,
            "zip_code": 92000,
            "name_th": "บ้านโพธิ์",
            "name_en": "Ban Pho",
            "district_id": 9201,
            "lat": 7.604,
            "long": 99.627,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 920119,
            "zip_code": 92190,
            "name_th": "นาท่ามเหนือ",
            "name_en": "Na Tham Nuea",
            "district_id": 9201,
            "lat": 7.652,
            "long": 99.613,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 920120,
            "zip_code": 92190,
            "name_th": "นาท่ามใต้",
            "name_en": "Na Tham Tai",
            "district_id": 9201,
            "lat": 7.635,
            "long": 99.551,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 9202,
        "name_th": "กันตัง",
        "name_en": "Kantang",
        "province_id": 72,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 920201,
            "zip_code": 92110,
            "name_th": "กันตัง",
            "name_en": "Kantang",
            "district_id": 9202,
            "lat": 7.41,
            "long": 99.519,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 920202,
            "zip_code": 92110,
            "name_th": "ควนธานี",
            "name_en": "Khuan Thani",
            "district_id": 9202,
            "lat": 7.512,
            "long": 99.563,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 920203,
            "zip_code": 92110,
            "name_th": "บางหมาก",
            "name_en": "Bang Mak",
            "district_id": 9202,
            "lat": 7.465,
            "long": 99.554,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 920204,
            "zip_code": 92110,
            "name_th": "บางเป้า",
            "name_en": "Bang Pao",
            "district_id": 9202,
            "lat": 7.402,
            "long": 99.549,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 920205,
            "zip_code": 92110,
            "name_th": "วังวน",
            "name_en": "Wang Won",
            "district_id": 9202,
            "lat": 7.358,
            "long": 99.558,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 920206,
            "zip_code": 92110,
            "name_th": "กันตังใต้",
            "name_en": "Kantang Tai",
            "district_id": 9202,
            "lat": 7.338,
            "long": 99.515,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 920207,
            "zip_code": 92110,
            "name_th": "โคกยาง",
            "name_en": "Khok Yang",
            "district_id": 9202,
            "lat": 7.509,
            "long": 99.48,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 920208,
            "zip_code": 92110,
            "name_th": "คลองลุ",
            "name_en": "Khlong Lu",
            "district_id": 9202,
            "lat": 7.482,
            "long": 99.495,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 920209,
            "zip_code": 92110,
            "name_th": "ย่านซื่อ",
            "name_en": "Yan Sue",
            "district_id": 9202,
            "lat": 7.473,
            "long": 99.541,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 920210,
            "zip_code": 92110,
            "name_th": "บ่อน้ำร้อน",
            "name_en": "Bo Nam Ron",
            "district_id": 9202,
            "lat": 7.425,
            "long": 99.474,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 920211,
            "zip_code": 92110,
            "name_th": "บางสัก",
            "name_en": "Bang Sak",
            "district_id": 9202,
            "lat": 7.397,
            "long": 99.383,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 920212,
            "zip_code": 92110,
            "name_th": "นาเกลือ",
            "name_en": "Na Kluea",
            "district_id": 9202,
            "lat": 7.326,
            "long": 99.466,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 920213,
            "zip_code": 92110,
            "name_th": "เกาะลิบง",
            "name_en": "Ko Libong",
            "district_id": 9202,
            "lat": 7.303,
            "long": 99.394,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 920214,
            "zip_code": 92110,
            "name_th": "คลองชีล้อม",
            "name_en": "Khlong Chi Lom",
            "district_id": 9202,
            "lat": 7.433,
            "long": 99.587,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 9203,
        "name_th": "ย่านตาขาว",
        "name_en": "Yan Ta Khao",
        "province_id": 72,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 920301,
            "zip_code": 92140,
            "name_th": "ย่านตาขาว",
            "name_en": "Yan Ta Khao",
            "district_id": 9203,
            "lat": 7.406,
            "long": 99.674,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 920302,
            "zip_code": 92140,
            "name_th": "หนองบ่อ",
            "name_en": "Nong Bo",
            "district_id": 9203,
            "lat": 7.416,
            "long": 99.718,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 920303,
            "zip_code": 92140,
            "name_th": "นาชุมเห็ด",
            "name_en": "Na Chum Het",
            "district_id": 9203,
            "lat": 7.477,
            "long": 99.822,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 920304,
            "zip_code": 92140,
            "name_th": "ในควน",
            "name_en": "Nai Khuan",
            "district_id": 9203,
            "lat": 7.376,
            "long": 99.768,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 920305,
            "zip_code": 92140,
            "name_th": "โพรงจระเข้",
            "name_en": "Phrong Chorakhe",
            "district_id": 9203,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 920306,
            "zip_code": 92140,
            "name_th": "ทุ่งกระบือ",
            "name_en": "Thung Krabue",
            "district_id": 9203,
            "lat": 7.404,
            "long": 99.626,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 920307,
            "zip_code": 92140,
            "name_th": "ทุ่งค่าย",
            "name_en": "Thung Khai",
            "district_id": 9203,
            "lat": 7.474,
            "long": 99.648,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 920308,
            "zip_code": 92140,
            "name_th": "เกาะเปียะ",
            "name_en": "Ko Pia",
            "district_id": 9203,
            "lat": 7.453,
            "long": 99.701,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 9204,
        "name_th": "ปะเหลียน",
        "name_en": "Palian",
        "province_id": 72,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 920401,
            "zip_code": 92120,
            "name_th": "ท่าข้าม",
            "name_en": "Tha Kham",
            "district_id": 9204,
            "lat": 7.127,
            "long": 99.699,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 920402,
            "zip_code": 92180,
            "name_th": "ทุ่งยาว",
            "name_en": "Thung Yao",
            "district_id": 9204,
            "lat": 7.241,
            "long": 99.753,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 920403,
            "zip_code": 92180,
            "name_th": "ปะเหลียน",
            "name_en": "Palian",
            "district_id": 9204,
            "lat": 7.288,
            "long": 99.862,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 920404,
            "zip_code": 92140,
            "name_th": "บางด้วน",
            "name_en": "Bang Duan",
            "district_id": 9204,
            "lat": 7.35,
            "long": 99.699,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 920407,
            "zip_code": 92140,
            "name_th": "บ้านนา",
            "name_en": "Ban Na",
            "district_id": 9204,
            "lat": 7.302,
            "long": 99.699,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 920409,
            "zip_code": 92120,
            "name_th": "สุโสะ",
            "name_en": "Suso",
            "district_id": 9204,
            "lat": 7.236,
            "long": 99.673,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 920410,
            "zip_code": 92180,
            "name_th": "ลิพัง",
            "name_en": "Liphang",
            "district_id": 9204,
            "lat": 7.184,
            "long": 99.81,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 920411,
            "zip_code": 92120,
            "name_th": "เกาะสุกร",
            "name_en": "Ko Sukon",
            "district_id": 9204,
            "lat": 7.101,
            "long": 99.581,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 920412,
            "zip_code": 92140,
            "name_th": "ท่าพญา",
            "name_en": "Tha Phaya",
            "district_id": 9204,
            "lat": 7.354,
            "long": 99.674,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 920413,
            "zip_code": 92180,
            "name_th": "แหลมสอม",
            "name_en": "Laem Som",
            "district_id": 9204,
            "lat": 7.287,
            "long": 99.763,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 9205,
        "name_th": "สิเกา",
        "name_en": "Sikao",
        "province_id": 72,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 920501,
            "zip_code": 92150,
            "name_th": "บ่อหิน",
            "name_en": "Bo Hin",
            "district_id": 9205,
            "lat": 7.549,
            "long": 99.283,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 920502,
            "zip_code": 92150,
            "name_th": "เขาไม้แก้ว",
            "name_en": "Khao Mai Kaeo",
            "district_id": 9205,
            "lat": 7.645,
            "long": 99.306,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 920503,
            "zip_code": 92150,
            "name_th": "กะลาเส",
            "name_en": "Kalase",
            "district_id": 9205,
            "lat": 7.744,
            "long": 99.326,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 920504,
            "zip_code": 92150,
            "name_th": "ไม้ฝาด",
            "name_en": "Mai Fat",
            "district_id": 9205,
            "lat": 7.47,
            "long": 99.32,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 920505,
            "zip_code": 92000,
            "name_th": "นาเมืองเพชร",
            "name_en": "Na Mueang Phet",
            "district_id": 9205,
            "lat": 7.559,
            "long": 99.465,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 9206,
        "name_th": "ห้วยยอด",
        "name_en": "Huai Yot",
        "province_id": 72,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 920601,
            "zip_code": 92130,
            "name_th": "ห้วยยอด",
            "name_en": "Huai Yot",
            "district_id": 9206,
            "lat": 7.776,
            "long": 99.632,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 920602,
            "zip_code": 92130,
            "name_th": "หนองช้างแล่น",
            "name_en": "Nong Chang Laen",
            "district_id": 9206,
            "lat": 7.84,
            "long": 99.585,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 920605,
            "zip_code": 92210,
            "name_th": "บางดี",
            "name_en": "Bang Di",
            "district_id": 9206,
            "lat": 7.841,
            "long": 99.494,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 920606,
            "zip_code": 92210,
            "name_th": "บางกุ้ง",
            "name_en": "Bang Kung",
            "district_id": 9206,
            "lat": 7.762,
            "long": 99.457,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 920607,
            "zip_code": 92130,
            "name_th": "เขากอบ",
            "name_en": "Khao Kop",
            "district_id": 9206,
            "lat": 7.798,
            "long": 99.563,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 920608,
            "zip_code": 92130,
            "name_th": "เขาขาว",
            "name_en": "Khao Khao",
            "district_id": 9206,
            "lat": 7.811,
            "long": 99.618,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 920609,
            "zip_code": 92130,
            "name_th": "เขาปูน",
            "name_en": "Khao Pun",
            "district_id": 9206,
            "lat": 7.803,
            "long": 99.668,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 920610,
            "zip_code": 92190,
            "name_th": "ปากแจ่ม",
            "name_en": "Pak Chaem",
            "district_id": 9206,
            "lat": 7.737,
            "long": 99.724,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 920611,
            "zip_code": 92130,
            "name_th": "ปากคม",
            "name_en": "Pak Khom",
            "district_id": 9206,
            "lat": 7.732,
            "long": 99.607,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 920614,
            "zip_code": 92130,
            "name_th": "ท่างิ้ว",
            "name_en": "Tha Ngio",
            "district_id": 9206,
            "lat": 7.845,
            "long": 99.651,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 920615,
            "zip_code": 92190,
            "name_th": "ลำภูรา",
            "name_en": "Lamphu Ra",
            "district_id": 9206,
            "lat": 7.698,
            "long": 99.583,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 920616,
            "zip_code": 92210,
            "name_th": "นาวง",
            "name_en": "Na Wong",
            "district_id": 9206,
            "lat": 7.74,
            "long": 99.511,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 920617,
            "zip_code": 92130,
            "name_th": "ห้วยนาง",
            "name_en": "Huai Nang",
            "district_id": 9206,
            "lat": 7.893,
            "long": 99.576,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 920619,
            "zip_code": 92130,
            "name_th": "ในเตา",
            "name_en": "Nai Tao",
            "district_id": 9206,
            "lat": 7.86,
            "long": 99.727,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 920620,
            "zip_code": 92130,
            "name_th": "ทุ่งต่อ",
            "name_en": "Thung To",
            "district_id": 9206,
            "lat": 7.759,
            "long": 99.575,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 920621,
            "zip_code": 92210,
            "name_th": "วังคีรี",
            "name_en": "Wang Khiri",
            "district_id": 9206,
            "lat": 7.79,
            "long": 99.472,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 9207,
        "name_th": "วังวิเศษ",
        "name_en": "Wang Wiset",
        "province_id": 72,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 920701,
            "zip_code": 92220,
            "name_th": "เขาวิเศษ",
            "name_en": "Khao Wiset",
            "district_id": 9207,
            "lat": 7.651,
            "long": 99.459,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 920702,
            "zip_code": 92220,
            "name_th": "วังมะปราง",
            "name_en": "Wang Maprang",
            "district_id": 9207,
            "lat": 7.656,
            "long": 99.382,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 920703,
            "zip_code": 92220,
            "name_th": "อ่าวตง",
            "name_en": "Ao Tong",
            "district_id": 9207,
            "lat": 7.862,
            "long": 99.365,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 920704,
            "zip_code": 92000,
            "name_th": "ท่าสะบ้า",
            "name_en": "Tha Saba",
            "district_id": 9207,
            "lat": 7.69,
            "long": 99.523,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 920705,
            "zip_code": 92220,
            "name_th": "วังมะปรางเหนือ",
            "name_en": "Wang Maprang Nuea",
            "district_id": 9207,
            "lat": 7.746,
            "long": 99.398,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 9208,
        "name_th": "นาโยง",
        "name_en": "Na Yong",
        "province_id": 72,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 920801,
            "zip_code": 92170,
            "name_th": "นาโยงเหนือ",
            "name_en": "Na Yong Nuea",
            "district_id": 9208,
            "lat": 7.566,
            "long": 99.699,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 920802,
            "zip_code": 92170,
            "name_th": "ช่อง",
            "name_en": "Chong",
            "district_id": 9208,
            "lat": 7.546,
            "long": 99.793,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 920803,
            "zip_code": 92170,
            "name_th": "ละมอ",
            "name_en": "Lamo",
            "district_id": 9208,
            "lat": 7.597,
            "long": 99.753,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 920804,
            "zip_code": 92170,
            "name_th": "โคกสะบ้า",
            "name_en": "Khok Saba",
            "district_id": 9208,
            "lat": 7.49,
            "long": 99.714,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 920805,
            "zip_code": 92170,
            "name_th": "นาหมื่นศรี",
            "name_en": "Na Muen Si",
            "district_id": 9208,
            "lat": 7.609,
            "long": 99.699,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 920806,
            "zip_code": 92170,
            "name_th": "นาข้าวเสีย",
            "name_en": "Na Khao Sia",
            "district_id": 9208,
            "lat": 7.532,
            "long": 99.71,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 9209,
        "name_th": "รัษฎา",
        "name_en": "Ratsada",
        "province_id": 72,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 920901,
            "zip_code": 92160,
            "name_th": "ควนเมา",
            "name_en": "Khuan Mao",
            "district_id": 9209,
            "lat": 7.938,
            "long": 99.596,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 920902,
            "zip_code": 92160,
            "name_th": "คลองปาง",
            "name_en": "Khlong Pang",
            "district_id": 9209,
            "lat": 7.987,
            "long": 99.645,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 920903,
            "zip_code": 92160,
            "name_th": "หนองบัว",
            "name_en": "Nong Bua",
            "district_id": 9209,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 920904,
            "zip_code": 92130,
            "name_th": "หนองปรือ",
            "name_en": "Nong Prue",
            "district_id": 9209,
            "lat": 7.9,
            "long": 99.669,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 920905,
            "zip_code": 92160,
            "name_th": "เขาไพร",
            "name_en": "Khao Phrai",
            "district_id": 9209,
            "lat": 7.96,
            "long": 99.661,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 9210,
        "name_th": "หาดสำราญ",
        "name_en": "Hat Samran",
        "province_id": 72,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 921001,
            "zip_code": 92120,
            "name_th": "หาดสำราญ",
            "name_en": "Hat Samran",
            "district_id": 9210,
            "lat": 7.256,
            "long": 99.552,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 921002,
            "zip_code": 92120,
            "name_th": "บ้าหวี",
            "name_en": "Ba Wi",
            "district_id": 9210,
            "lat": 7.283,
            "long": 99.597,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 921003,
            "zip_code": 92120,
            "name_th": "ตะเสะ",
            "name_en": "Ta Se",
            "district_id": 9210,
            "lat": 7.033,
            "long": 99.449,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      }
    ]
  },
  {
    "id": 73,
    "name_th": "พัทลุง",
    "name_en": "Phatthalung",
    "geography_id": 6,
    "created_at": "2019-08-09T03:33:09.000+07:00",
    "updated_at": "2025-09-20T06:31:26.000+07:00",
    "deleted_at": null,
    "districts": [
      {
        "id": 9301,
        "name_th": "เมืองพัทลุง",
        "name_en": "Mueang Phatthalung",
        "province_id": 73,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 930101,
            "zip_code": 93000,
            "name_th": "คูหาสวรรค์",
            "name_en": "Khuha Sawan",
            "district_id": 9301,
            "lat": 7.625,
            "long": 100.085,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 930103,
            "zip_code": 93000,
            "name_th": "เขาเจียก",
            "name_en": "Khao Chiak",
            "district_id": 9301,
            "lat": 7.624,
            "long": 100.039,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 930104,
            "zip_code": 93000,
            "name_th": "ท่ามิหรำ",
            "name_en": "Tha Miram",
            "district_id": 9301,
            "lat": 7.589,
            "long": 100.05,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 930105,
            "zip_code": 93000,
            "name_th": "โคกชะงาย",
            "name_en": "Khok Cha-ngai",
            "district_id": 9301,
            "lat": 7.615,
            "long": 100.003,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 930106,
            "zip_code": 93000,
            "name_th": "นาท่อม",
            "name_en": "Na Thom",
            "district_id": 9301,
            "lat": 7.585,
            "long": 100.002,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 930107,
            "zip_code": 93000,
            "name_th": "ปรางหมู่",
            "name_en": "Prang Mu",
            "district_id": 9301,
            "lat": 7.647,
            "long": 100.068,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 930108,
            "zip_code": 93000,
            "name_th": "ท่าแค",
            "name_en": "Tha Khae",
            "district_id": 9301,
            "lat": 7.545,
            "long": 100.05,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 930109,
            "zip_code": 93000,
            "name_th": "ลำปำ",
            "name_en": "Lampam",
            "district_id": 9301,
            "lat": 7.651,
            "long": 100.141,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 930110,
            "zip_code": 93000,
            "name_th": "ตำนาน",
            "name_en": "Tamnan",
            "district_id": 9301,
            "lat": 7.572,
            "long": 100.083,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 930111,
            "zip_code": 93000,
            "name_th": "ควนมะพร้าว",
            "name_en": "Khuan Maphrao",
            "district_id": 9301,
            "lat": 7.588,
            "long": 100.124,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 930112,
            "zip_code": 93000,
            "name_th": "ร่มเมือง",
            "name_en": "Rom Mueang",
            "district_id": 9301,
            "lat": 7.556,
            "long": 100.008,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 930113,
            "zip_code": 93000,
            "name_th": "ชัยบุรี",
            "name_en": "Chai Buri",
            "district_id": 9301,
            "lat": 7.697,
            "long": 100.093,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 930114,
            "zip_code": 93000,
            "name_th": "นาโหนด",
            "name_en": "Na Not",
            "district_id": 9301,
            "lat": 7.507,
            "long": 100.061,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 930115,
            "zip_code": 93000,
            "name_th": "พญาขัน",
            "name_en": "Phaya Khan",
            "district_id": 9301,
            "lat": 7.652,
            "long": 100.107,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 9302,
        "name_th": "กงหรา",
        "name_en": "Kong Ra",
        "province_id": 73,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 930201,
            "zip_code": 93180,
            "name_th": "กงหรา",
            "name_en": "Kong Ra",
            "district_id": 9302,
            "lat": 7.463,
            "long": 99.877,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 930202,
            "zip_code": 93000,
            "name_th": "ชะรัด",
            "name_en": "Charat",
            "district_id": 9302,
            "lat": 7.473,
            "long": 99.989,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 930203,
            "zip_code": 93180,
            "name_th": "คลองเฉลิม",
            "name_en": "Khlong Chaloem",
            "district_id": 9302,
            "lat": 7.349,
            "long": 99.958,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 930204,
            "zip_code": 93180,
            "name_th": "คลองทรายขาว",
            "name_en": "Khlong Sai Khao",
            "district_id": 9302,
            "lat": 7.423,
            "long": 99.921,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 930205,
            "zip_code": 93000,
            "name_th": "สมหวัง",
            "name_en": "Som Wang",
            "district_id": 9302,
            "lat": 7.509,
            "long": 99.99,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 9303,
        "name_th": "เขาชัยสน",
        "name_en": "Khao Chaison",
        "province_id": 73,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 930301,
            "zip_code": 93130,
            "name_th": "เขาชัยสน",
            "name_en": "Khao Chaison",
            "district_id": 9303,
            "lat": 7.433,
            "long": 100.111,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 930302,
            "zip_code": 93130,
            "name_th": "ควนขนุน",
            "name_en": "Khuan Khanun",
            "district_id": 9303,
            "lat": 7.491,
            "long": 100.095,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 930305,
            "zip_code": 93130,
            "name_th": "จองถนน",
            "name_en": "Chong Thanon",
            "district_id": 9303,
            "lat": 7.489,
            "long": 100.194,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 930306,
            "zip_code": 93130,
            "name_th": "หานโพธิ์",
            "name_en": "Han Pho",
            "district_id": 9303,
            "lat": 7.525,
            "long": 100.145,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 930307,
            "zip_code": 93130,
            "name_th": "โคกม่วง",
            "name_en": "Khok Muang",
            "district_id": 9303,
            "lat": 7.389,
            "long": 100.067,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 9304,
        "name_th": "ตะโหมด",
        "name_en": "Tamot",
        "province_id": 73,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 930401,
            "zip_code": 93160,
            "name_th": "แม่ขรี",
            "name_en": "Mae Khari",
            "district_id": 9304,
            "lat": 7.338,
            "long": 100.097,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 930402,
            "zip_code": 93160,
            "name_th": "ตะโหมด",
            "name_en": "Tamod",
            "district_id": 9304,
            "lat": 7.278,
            "long": 100.007,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 930403,
            "zip_code": 93160,
            "name_th": "คลองใหญ่",
            "name_en": "Khlong Yai",
            "district_id": 9304,
            "lat": 7.26,
            "long": 100.074,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 9305,
        "name_th": "ควนขนุน",
        "name_en": "Khuan Khanun",
        "province_id": 73,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 930501,
            "zip_code": 93110,
            "name_th": "ควนขนุน",
            "name_en": "Khuan Khanun",
            "district_id": 9305,
            "lat": 7.756,
            "long": 100.003,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 930502,
            "zip_code": 93150,
            "name_th": "ทะเลน้อย",
            "name_en": "Thale Noi",
            "district_id": 9305,
            "lat": 7.824,
            "long": 100.145,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 930504,
            "zip_code": 93110,
            "name_th": "นาขยาด",
            "name_en": "Na Khayat",
            "district_id": 9305,
            "lat": 7.687,
            "long": 99.948,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 930505,
            "zip_code": 93110,
            "name_th": "พนมวังก์",
            "name_en": "Phanom Wang",
            "district_id": 9305,
            "lat": 7.684,
            "long": 100.023,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 930506,
            "zip_code": 93110,
            "name_th": "แหลมโตนด",
            "name_en": "Laem Tanot",
            "district_id": 9305,
            "lat": 7.826,
            "long": 100.03,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 930508,
            "zip_code": 93110,
            "name_th": "ปันแต",
            "name_en": "Pan Tae",
            "district_id": 9305,
            "lat": 7.783,
            "long": 100.051,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 930509,
            "zip_code": 93110,
            "name_th": "โตนดด้วน",
            "name_en": "Tanot Duan",
            "district_id": 9305,
            "lat": 7.718,
            "long": 100.036,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 930510,
            "zip_code": 93110,
            "name_th": "ดอนทราย",
            "name_en": "Don Sai",
            "district_id": 9305,
            "lat": 7.716,
            "long": 99.975,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 930511,
            "zip_code": 93150,
            "name_th": "มะกอกเหนือ",
            "name_en": "Makok Nuea",
            "district_id": 9305,
            "lat": 7.746,
            "long": 100.073,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 930512,
            "zip_code": 93150,
            "name_th": "พนางตุง",
            "name_en": "Phanang Tung",
            "district_id": 9305,
            "lat": 7.759,
            "long": 100.14,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 930513,
            "zip_code": 93110,
            "name_th": "ชะมวง",
            "name_en": "Chamuang",
            "district_id": 9305,
            "lat": 7.765,
            "long": 99.956,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 930516,
            "zip_code": 93110,
            "name_th": "แพรกหา",
            "name_en": "Phraek Ha",
            "district_id": 9305,
            "lat": 7.654,
            "long": 100.01,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 9306,
        "name_th": "ปากพะยูน",
        "name_en": "Pak Phayun",
        "province_id": 73,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 930601,
            "zip_code": 93120,
            "name_th": "ปากพะยูน",
            "name_en": "Pak Phayun",
            "district_id": 9306,
            "lat": 7.33,
            "long": 100.336,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 930602,
            "zip_code": 93120,
            "name_th": "ดอนประดู่",
            "name_en": "Don Pradu",
            "district_id": 9306,
            "lat": 7.279,
            "long": 100.318,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 930603,
            "zip_code": 93120,
            "name_th": "เกาะนางคำ",
            "name_en": "Ko Nang Kham",
            "district_id": 9306,
            "lat": 7.343,
            "long": 100.389,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 930604,
            "zip_code": 93120,
            "name_th": "เกาะหมาก",
            "name_en": "Ko Mak",
            "district_id": 9306,
            "lat": 7.435,
            "long": 100.329,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 930605,
            "zip_code": 93120,
            "name_th": "ฝาละมี",
            "name_en": "Falami",
            "district_id": 9306,
            "lat": 7.371,
            "long": 100.261,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 930606,
            "zip_code": 93120,
            "name_th": "หารเทา",
            "name_en": "Han Thao",
            "district_id": 9306,
            "lat": 7.288,
            "long": 100.267,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 930607,
            "zip_code": 93120,
            "name_th": "ดอนทราย",
            "name_en": "Don Sai",
            "district_id": 9306,
            "lat": 7.244,
            "long": 100.321,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 9307,
        "name_th": "ศรีบรรพต",
        "name_en": "Si Banphot",
        "province_id": 73,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 930701,
            "zip_code": 93190,
            "name_th": "เขาย่า",
            "name_en": "Khao Ya",
            "district_id": 9307,
            "lat": 7.746,
            "long": 99.864,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 930702,
            "zip_code": 93190,
            "name_th": "เขาปู่",
            "name_en": "Khao Pu",
            "district_id": 9307,
            "lat": 7.701,
            "long": 99.833,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 930703,
            "zip_code": 93190,
            "name_th": "ตะแพน",
            "name_en": "Taphaen",
            "district_id": 9307,
            "lat": 7.645,
            "long": 99.878,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 9308,
        "name_th": "ป่าบอน",
        "name_en": "Pa Bon",
        "province_id": 73,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 930801,
            "zip_code": 93170,
            "name_th": "ป่าบอน",
            "name_en": "Pa Bon",
            "district_id": 9308,
            "lat": 7.337,
            "long": 100.171,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 930802,
            "zip_code": 93170,
            "name_th": "โคกทราย",
            "name_en": "Khok Sai",
            "district_id": 9308,
            "lat": 7.229,
            "long": 100.229,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 930803,
            "zip_code": 93170,
            "name_th": "หนองธง",
            "name_en": "Nong Thong",
            "district_id": 9308,
            "lat": 7.162,
            "long": 100.008,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 930804,
            "zip_code": 93170,
            "name_th": "ทุ่งนารี",
            "name_en": "Thung Nari",
            "district_id": 9308,
            "lat": 7.191,
            "long": 100.13,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 930806,
            "zip_code": 93170,
            "name_th": "วังใหม่",
            "name_en": "Wang Mai",
            "district_id": 9308,
            "lat": 7.318,
            "long": 100.23,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 9309,
        "name_th": "บางแก้ว",
        "name_en": "Bang Kaeo",
        "province_id": 73,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 930901,
            "zip_code": 93140,
            "name_th": "ท่ามะเดื่อ",
            "name_en": "Tha Maduea",
            "district_id": 9309,
            "lat": 7.451,
            "long": 100.157,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 930902,
            "zip_code": 93140,
            "name_th": "นาปะขอ",
            "name_en": "Na Pakho",
            "district_id": 9309,
            "lat": 7.435,
            "long": 100.197,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 930903,
            "zip_code": 93140,
            "name_th": "โคกสัก",
            "name_en": "Khok Sak",
            "district_id": 9309,
            "lat": 7.39,
            "long": 100.145,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 9310,
        "name_th": "ป่าพะยอม",
        "name_en": "Pa Phayom",
        "province_id": 73,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 931001,
            "zip_code": 93110,
            "name_th": "ป่าพะยอม",
            "name_en": "Pa Phayom",
            "district_id": 9310,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 931002,
            "zip_code": 93110,
            "name_th": "ลานข่อย",
            "name_en": "Lan Khoi",
            "district_id": 9310,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 931003,
            "zip_code": 93110,
            "name_th": "เกาะเต่า",
            "name_en": "Ko Tao",
            "district_id": 9310,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 931004,
            "zip_code": 93110,
            "name_th": "บ้านพร้าว",
            "name_en": "Ban Phrao",
            "district_id": 9310,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 9311,
        "name_th": "ศรีนครินทร์",
        "name_en": "Srinagarindra",
        "province_id": 73,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 931101,
            "zip_code": 93000,
            "name_th": "ชุมพล",
            "name_en": "Chumphon",
            "district_id": 9311,
            "lat": 7.608,
            "long": 99.948,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 931102,
            "zip_code": 93000,
            "name_th": "บ้านนา",
            "name_en": "Ban Na",
            "district_id": 9311,
            "lat": 7.559,
            "long": 99.868,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 931103,
            "zip_code": 93000,
            "name_th": "อ่างทอง",
            "name_en": "Ang Thong",
            "district_id": 9311,
            "lat": 7.554,
            "long": 99.971,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 931104,
            "zip_code": 93000,
            "name_th": "ลำสินธุ์",
            "name_en": "Lam Sin",
            "district_id": 9311,
            "lat": 7.495,
            "long": 99.875,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      }
    ]
  },
  {
    "id": 74,
    "name_th": "ปัตตานี",
    "name_en": "Pattani",
    "geography_id": 6,
    "created_at": "2019-08-09T03:33:09.000+07:00",
    "updated_at": "2025-09-20T06:31:26.000+07:00",
    "deleted_at": null,
    "districts": [
      {
        "id": 9401,
        "name_th": "เมืองปัตตานี",
        "name_en": "Mueang Pattani",
        "province_id": 74,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 940101,
            "zip_code": 94000,
            "name_th": "สะบารัง",
            "name_en": "Sabarang",
            "district_id": 9401,
            "lat": 6.876,
            "long": 101.251,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 940102,
            "zip_code": 94000,
            "name_th": "อาเนาะรู",
            "name_en": "Ano Ru",
            "district_id": 9401,
            "lat": 6.87,
            "long": 101.256,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 940103,
            "zip_code": 94000,
            "name_th": "จะบังติกอ",
            "name_en": "Chabang Tiko",
            "district_id": 9401,
            "lat": 6.857,
            "long": 101.251,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 940104,
            "zip_code": 94000,
            "name_th": "บานา",
            "name_en": "Bana",
            "district_id": 9401,
            "lat": 6.866,
            "long": 101.289,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 940105,
            "zip_code": 94000,
            "name_th": "ตันหยงลุโละ",
            "name_en": "Tanyong Lulo",
            "district_id": 9401,
            "lat": 6.877,
            "long": 101.305,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 940106,
            "zip_code": 94000,
            "name_th": "คลองมานิง",
            "name_en": "Khlong Maning",
            "district_id": 9401,
            "lat": 6.845,
            "long": 101.293,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 940107,
            "zip_code": 94000,
            "name_th": "กะมิยอ",
            "name_en": "Kamiyo",
            "district_id": 9401,
            "lat": 6.854,
            "long": 101.318,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 940108,
            "zip_code": 94000,
            "name_th": "บาราโหม",
            "name_en": "Barahom",
            "district_id": 9401,
            "lat": 6.873,
            "long": 101.317,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 940109,
            "zip_code": 94000,
            "name_th": "ปะกาฮะรัง",
            "name_en": "Paka Harang",
            "district_id": 9401,
            "lat": 6.833,
            "long": 101.232,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 940110,
            "zip_code": 94000,
            "name_th": "รูสะมิแล",
            "name_en": "Ru Samilae",
            "district_id": 9401,
            "lat": 6.864,
            "long": 101.207,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 940111,
            "zip_code": 94000,
            "name_th": "ตะลุโบะ",
            "name_en": "Talubo",
            "district_id": 9401,
            "lat": 6.853,
            "long": 101.267,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 940112,
            "zip_code": 94000,
            "name_th": "บาราเฮาะ",
            "name_en": "Baraho",
            "district_id": 9401,
            "lat": 6.829,
            "long": 101.267,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 940113,
            "zip_code": 94000,
            "name_th": "ปุยุด",
            "name_en": "Puyut",
            "district_id": 9401,
            "lat": 6.811,
            "long": 101.268,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 9402,
        "name_th": "โคกโพธิ์",
        "name_en": "Khok Pho",
        "province_id": 74,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 940201,
            "zip_code": 94120,
            "name_th": "โคกโพธิ์",
            "name_en": "Khok Pho",
            "district_id": 9402,
            "lat": 6.732,
            "long": 101.061,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 940202,
            "zip_code": 94120,
            "name_th": "มะกรูด",
            "name_en": "Makrut",
            "district_id": 9402,
            "lat": 6.738,
            "long": 101.119,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 940203,
            "zip_code": 94120,
            "name_th": "บางโกระ",
            "name_en": "Bang Kro",
            "district_id": 9402,
            "lat": 6.76,
            "long": 101.108,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 940204,
            "zip_code": 94120,
            "name_th": "ป่าบอน",
            "name_en": "Pa Bon",
            "district_id": 9402,
            "lat": 6.701,
            "long": 101.116,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 940205,
            "zip_code": 94120,
            "name_th": "ทรายขาว",
            "name_en": "Sai Khao",
            "district_id": 9402,
            "lat": 6.665,
            "long": 101.096,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 940206,
            "zip_code": 94180,
            "name_th": "นาประดู่",
            "name_en": "Na Pradu",
            "district_id": 9402,
            "lat": 6.689,
            "long": 101.142,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 940207,
            "zip_code": 94180,
            "name_th": "ปากล่อ",
            "name_en": "Pak Lo",
            "district_id": 9402,
            "lat": 6.62,
            "long": 101.187,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 940208,
            "zip_code": 94180,
            "name_th": "ทุ่งพลา",
            "name_en": "Thung Phala",
            "district_id": 9402,
            "lat": 6.641,
            "long": 101.152,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 940211,
            "zip_code": 94120,
            "name_th": "ท่าเรือ",
            "name_en": "Tha Ruea",
            "district_id": 9402,
            "lat": 6.78,
            "long": 101.053,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 940213,
            "zip_code": 94120,
            "name_th": "นาเกตุ",
            "name_en": "Na Ket",
            "district_id": 9402,
            "lat": 6.744,
            "long": 101.155,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 940214,
            "zip_code": 94180,
            "name_th": "ควนโนรี",
            "name_en": "Khuan Nori",
            "district_id": 9402,
            "lat": 6.719,
            "long": 101.199,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 940215,
            "zip_code": 94120,
            "name_th": "ช้างให้ตก",
            "name_en": "Chang Hai Tok",
            "district_id": 9402,
            "lat": 6.672,
            "long": 101.062,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 9403,
        "name_th": "หนองจิก",
        "name_en": "Nong Chik",
        "province_id": 74,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 940301,
            "zip_code": 94170,
            "name_th": "เกาะเปาะ",
            "name_en": "Ko Po",
            "district_id": 9403,
            "lat": 6.815,
            "long": 101.201,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 940302,
            "zip_code": 94170,
            "name_th": "คอลอตันหยง",
            "name_en": "Kholo Tanyong",
            "district_id": 9403,
            "lat": 6.744,
            "long": 101.222,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 940303,
            "zip_code": 94170,
            "name_th": "ดอนรัก",
            "name_en": "Don Rak",
            "district_id": 9403,
            "lat": 6.848,
            "long": 101.22,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 940304,
            "zip_code": 94170,
            "name_th": "ดาโต๊ะ",
            "name_en": "Dato",
            "district_id": 9403,
            "lat": 6.717,
            "long": 101.244,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 940305,
            "zip_code": 94170,
            "name_th": "ตุยง",
            "name_en": "Tuyong",
            "district_id": 9403,
            "lat": 6.832,
            "long": 101.178,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 940306,
            "zip_code": 94170,
            "name_th": "ท่ากำชำ",
            "name_en": "Tha Kamcham",
            "district_id": 9403,
            "lat": 6.826,
            "long": 101.072,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 940307,
            "zip_code": 94170,
            "name_th": "บ่อทอง",
            "name_en": "Bo Thong",
            "district_id": 9403,
            "lat": 6.789,
            "long": 101.135,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 940308,
            "zip_code": 94170,
            "name_th": "บางเขา",
            "name_en": "Bang Khao",
            "district_id": 9403,
            "lat": 6.834,
            "long": 101.13,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 940309,
            "zip_code": 94170,
            "name_th": "บางตาวา",
            "name_en": "Bang Tawa",
            "district_id": 9403,
            "lat": 6.858,
            "long": 101.158,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 940310,
            "zip_code": 94170,
            "name_th": "ปุโละปุโย",
            "name_en": "Pulo Puyo",
            "district_id": 9403,
            "lat": 6.774,
            "long": 101.194,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 940311,
            "zip_code": 94170,
            "name_th": "ยาบี",
            "name_en": "Yabi",
            "district_id": 9403,
            "lat": 6.782,
            "long": 101.246,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 940312,
            "zip_code": 94170,
            "name_th": "ลิปะสะโง",
            "name_en": "Lipa Sa-ngo",
            "district_id": 9403,
            "lat": 6.805,
            "long": 101.231,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 9404,
        "name_th": "ปะนาเระ",
        "name_en": "Panare",
        "province_id": 74,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 940401,
            "zip_code": 94130,
            "name_th": "ปะนาเระ",
            "name_en": "Panare",
            "district_id": 9404,
            "lat": 6.86,
            "long": 101.484,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 940402,
            "zip_code": 94130,
            "name_th": "ท่าข้าม",
            "name_en": "Tha Kham",
            "district_id": 9404,
            "lat": 6.838,
            "long": 101.477,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 940403,
            "zip_code": 94130,
            "name_th": "บ้านนอก",
            "name_en": "Ban Nok",
            "district_id": 9404,
            "lat": 6.812,
            "long": 101.479,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 940404,
            "zip_code": 94130,
            "name_th": "ดอน",
            "name_en": "Don",
            "district_id": 9404,
            "lat": 6.786,
            "long": 101.482,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 940405,
            "zip_code": 94190,
            "name_th": "ควน",
            "name_en": "Khuan",
            "district_id": 9404,
            "lat": 6.762,
            "long": 101.493,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 940406,
            "zip_code": 94130,
            "name_th": "ท่าน้ำ",
            "name_en": "Tha Nam",
            "district_id": 9404,
            "lat": 6.771,
            "long": 101.515,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 940407,
            "zip_code": 94130,
            "name_th": "คอกกระบือ",
            "name_en": "Khok Krabue",
            "district_id": 9404,
            "lat": 6.8,
            "long": 101.52,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 940408,
            "zip_code": 94130,
            "name_th": "พ่อมิ่ง",
            "name_en": "Pho Ming",
            "district_id": 9404,
            "lat": 6.786,
            "long": 101.554,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 940409,
            "zip_code": 94130,
            "name_th": "บ้านกลาง",
            "name_en": "Ban Klang",
            "district_id": 9404,
            "lat": 6.839,
            "long": 101.521,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 940410,
            "zip_code": 94130,
            "name_th": "บ้านน้ำบ่อ",
            "name_en": "Ban Nam Bo",
            "district_id": 9404,
            "lat": 6.817,
            "long": 101.563,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 9405,
        "name_th": "มายอ",
        "name_en": "Mayo",
        "province_id": 74,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 940501,
            "zip_code": 94140,
            "name_th": "มายอ",
            "name_en": "Mayo",
            "district_id": 9405,
            "lat": 6.71,
            "long": 101.425,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 940502,
            "zip_code": 94140,
            "name_th": "ถนน",
            "name_en": "Thanon",
            "district_id": 9405,
            "lat": 6.75,
            "long": 101.419,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 940503,
            "zip_code": 94140,
            "name_th": "ตรัง",
            "name_en": "Trang",
            "district_id": 9405,
            "lat": 6.693,
            "long": 101.375,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 940504,
            "zip_code": 94140,
            "name_th": "กระหวะ",
            "name_en": "Krawa",
            "district_id": 9405,
            "lat": 6.759,
            "long": 101.441,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 940505,
            "zip_code": 94140,
            "name_th": "ลุโบะยิไร",
            "name_en": "Lubo Yirai",
            "district_id": 9405,
            "lat": 6.666,
            "long": 101.417,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 940506,
            "zip_code": 94190,
            "name_th": "ลางา",
            "name_en": "La-nga",
            "district_id": 9405,
            "lat": 6.735,
            "long": 101.478,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 940507,
            "zip_code": 94140,
            "name_th": "กระเสาะ",
            "name_en": "Kra So",
            "district_id": 9405,
            "lat": 6.749,
            "long": 101.397,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 940508,
            "zip_code": 94140,
            "name_th": "เกาะจัน",
            "name_en": "Ko Chan",
            "district_id": 9405,
            "lat": 6.723,
            "long": 101.382,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 940509,
            "zip_code": 94140,
            "name_th": "ปะโด",
            "name_en": "Pado",
            "district_id": 9405,
            "lat": 6.666,
            "long": 101.359,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 940510,
            "zip_code": 94140,
            "name_th": "สาคอบน",
            "name_en": "Sakho Bon",
            "district_id": 9405,
            "lat": 6.73,
            "long": 101.352,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 940511,
            "zip_code": 94140,
            "name_th": "สาคอใต้",
            "name_en": "Sakho Tai",
            "district_id": 9405,
            "lat": 6.749,
            "long": 101.357,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 940512,
            "zip_code": 94140,
            "name_th": "สะกำ",
            "name_en": "Sakam",
            "district_id": 9405,
            "lat": 6.72,
            "long": 101.462,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 940513,
            "zip_code": 94140,
            "name_th": "ปานัน",
            "name_en": "Panan",
            "district_id": 9405,
            "lat": 6.721,
            "long": 101.334,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 9406,
        "name_th": "ทุ่งยางแดง",
        "name_en": "Thung Yang Daeng",
        "province_id": 74,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 940601,
            "zip_code": 94140,
            "name_th": "ตะโละแมะนา",
            "name_en": "Talo Mae Na",
            "district_id": 9406,
            "lat": 6.604,
            "long": 101.401,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 940602,
            "zip_code": 94140,
            "name_th": "พิเทน",
            "name_en": "Phithen",
            "district_id": 9406,
            "lat": 6.679,
            "long": 101.467,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 940603,
            "zip_code": 94140,
            "name_th": "น้ำดำ",
            "name_en": "Nam Dam",
            "district_id": 9406,
            "lat": 6.605,
            "long": 101.448,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 940604,
            "zip_code": 94140,
            "name_th": "ปากู",
            "name_en": "Paku",
            "district_id": 9406,
            "lat": 6.624,
            "long": 101.474,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 9407,
        "name_th": "สายบุรี",
        "name_en": "Sai Buri",
        "province_id": 74,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 940701,
            "zip_code": 94110,
            "name_th": "ตะลุบัน",
            "name_en": "Taluban",
            "district_id": 9407,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 940702,
            "zip_code": 94110,
            "name_th": "ตะบิ้ง",
            "name_en": "Tabing",
            "district_id": 9407,
            "lat": 6.681,
            "long": 101.589,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 940703,
            "zip_code": 94110,
            "name_th": "ปะเสยะวอ",
            "name_en": "Pase Yawo",
            "district_id": 9407,
            "lat": 6.733,
            "long": 101.606,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 940704,
            "zip_code": 94110,
            "name_th": "บางเก่า",
            "name_en": "Bang Kao",
            "district_id": 9407,
            "lat": 6.764,
            "long": 101.591,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 940705,
            "zip_code": 94110,
            "name_th": "บือเระ",
            "name_en": "Bue Re",
            "district_id": 9407,
            "lat": 6.704,
            "long": 101.584,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 940706,
            "zip_code": 94110,
            "name_th": "เตราะบอน",
            "name_en": "Tro Bon",
            "district_id": 9407,
            "lat": 6.688,
            "long": 101.543,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 940707,
            "zip_code": 94110,
            "name_th": "กะดุนง",
            "name_en": "Kadunong",
            "district_id": 9407,
            "lat": 6.646,
            "long": 101.554,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 940708,
            "zip_code": 94110,
            "name_th": "ละหาร",
            "name_en": "Lahan",
            "district_id": 9407,
            "lat": 6.659,
            "long": 101.627,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 940709,
            "zip_code": 94110,
            "name_th": "มะนังดาลำ",
            "name_en": "Manang Dalam",
            "district_id": 9407,
            "lat": 6.649,
            "long": 101.599,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 940710,
            "zip_code": 94110,
            "name_th": "แป้น",
            "name_en": "Paen",
            "district_id": 9407,
            "lat": 6.747,
            "long": 101.553,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 940711,
            "zip_code": 94190,
            "name_th": "ทุ่งคล้า",
            "name_en": "Thung Khla",
            "district_id": 9407,
            "lat": 6.718,
            "long": 101.528,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 9408,
        "name_th": "ไม้แก่น",
        "name_en": "Mai Kaen",
        "province_id": 74,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 940801,
            "zip_code": 94220,
            "name_th": "ไทรทอง",
            "name_en": "Sai Thong",
            "district_id": 9408,
            "lat": 6.604,
            "long": 101.673,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 940802,
            "zip_code": 94220,
            "name_th": "ไม้แก่น",
            "name_en": "Mai Kaen",
            "district_id": 9408,
            "lat": 6.647,
            "long": 101.669,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 940803,
            "zip_code": 94220,
            "name_th": "ตะโละไกรทอง",
            "name_en": "Talo Krai Thong",
            "district_id": 9408,
            "lat": 6.627,
            "long": 101.64,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 940804,
            "zip_code": 94220,
            "name_th": "ดอนทราย",
            "name_en": "Don Sai",
            "district_id": 9408,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 9409,
        "name_th": "ยะหริ่ง",
        "name_en": "Yaring",
        "province_id": 74,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 940901,
            "zip_code": 94150,
            "name_th": "ตะโละ",
            "name_en": "Talo",
            "district_id": 9409,
            "lat": 6.782,
            "long": 101.353,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 940902,
            "zip_code": 94150,
            "name_th": "ตะโละกาโปร์",
            "name_en": "Talo Kapo",
            "district_id": 9409,
            "lat": 6.872,
            "long": 101.43,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 940903,
            "zip_code": 94150,
            "name_th": "ตันหยงดาลอ",
            "name_en": "Tanyong Dalo",
            "district_id": 9409,
            "lat": 6.808,
            "long": 101.423,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 940904,
            "zip_code": 94190,
            "name_th": "ตันหยงจึงงา",
            "name_en": "Tanyong Chueng-nga",
            "district_id": 9409,
            "lat": 6.787,
            "long": 101.458,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 940905,
            "zip_code": 94150,
            "name_th": "ตอหลัง",
            "name_en": "Tolang",
            "district_id": 9409,
            "lat": 6.802,
            "long": 101.448,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 940906,
            "zip_code": 94150,
            "name_th": "ตาแกะ",
            "name_en": "Ta Kae",
            "district_id": 9409,
            "lat": 6.844,
            "long": 101.336,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 940907,
            "zip_code": 94150,
            "name_th": "ตาลีอายร์",
            "name_en": "Tali-ai",
            "district_id": 9409,
            "lat": 6.789,
            "long": 101.389,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 940908,
            "zip_code": 94150,
            "name_th": "ยามู",
            "name_en": "Yamu",
            "district_id": 9409,
            "lat": 6.855,
            "long": 101.372,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 940909,
            "zip_code": 94150,
            "name_th": "บางปู",
            "name_en": "Bang Pu",
            "district_id": 9409,
            "lat": 6.868,
            "long": 101.335,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 940910,
            "zip_code": 94150,
            "name_th": "หนองแรต",
            "name_en": "Nong Raet",
            "district_id": 9409,
            "lat": 6.849,
            "long": 101.403,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 940911,
            "zip_code": 94150,
            "name_th": "ปิยามุมัง",
            "name_en": "Piya Mumang",
            "district_id": 9409,
            "lat": 6.823,
            "long": 101.376,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 940912,
            "zip_code": 94150,
            "name_th": "ปุลากง",
            "name_en": "Pula Kong",
            "district_id": 9409,
            "lat": 6.769,
            "long": 101.391,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 940913,
            "zip_code": 94190,
            "name_th": "บาโลย",
            "name_en": "Baloi",
            "district_id": 9409,
            "lat": 6.781,
            "long": 101.439,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 940914,
            "zip_code": 94150,
            "name_th": "สาบัน",
            "name_en": "Saban",
            "district_id": 9409,
            "lat": 6.82,
            "long": 101.439,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 940915,
            "zip_code": 94150,
            "name_th": "มะนังยง",
            "name_en": "Manang Yong",
            "district_id": 9409,
            "lat": 6.813,
            "long": 101.402,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 940916,
            "zip_code": 94150,
            "name_th": "ราตาปันยัง",
            "name_en": "Rata Panyang",
            "district_id": 9409,
            "lat": 6.822,
            "long": 101.353,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 940917,
            "zip_code": 94150,
            "name_th": "จะรัง",
            "name_en": "Charang",
            "district_id": 9409,
            "lat": 6.843,
            "long": 101.45,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 940918,
            "zip_code": 94150,
            "name_th": "แหลมโพธิ์",
            "name_en": "Laem Pho",
            "district_id": 9409,
            "lat": 6.942,
            "long": 101.296,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 9410,
        "name_th": "ยะรัง",
        "name_en": "Yarang",
        "province_id": 74,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 941001,
            "zip_code": 94160,
            "name_th": "ยะรัง",
            "name_en": "Yarang",
            "district_id": 9410,
            "lat": 6.769,
            "long": 101.299,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 941002,
            "zip_code": 94160,
            "name_th": "สะดาวา",
            "name_en": "Sadawa",
            "district_id": 9410,
            "lat": 6.821,
            "long": 101.311,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 941003,
            "zip_code": 94160,
            "name_th": "ประจัน",
            "name_en": "Prachan",
            "district_id": 9410,
            "lat": 6.797,
            "long": 101.289,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 941004,
            "zip_code": 94160,
            "name_th": "สะนอ",
            "name_en": "Sano",
            "district_id": 9410,
            "lat": 6.789,
            "long": 101.323,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 941005,
            "zip_code": 94160,
            "name_th": "ระแว้ง",
            "name_en": "Rawaeng",
            "district_id": 9410,
            "lat": 6.755,
            "long": 101.324,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 941006,
            "zip_code": 94160,
            "name_th": "ปิตูมุดี",
            "name_en": "Pitu Mudi",
            "district_id": 9410,
            "lat": 6.743,
            "long": 101.284,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 941007,
            "zip_code": 94160,
            "name_th": "วัด",
            "name_en": "Wat",
            "district_id": 9410,
            "lat": 6.735,
            "long": 101.308,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 941008,
            "zip_code": 94160,
            "name_th": "กระโด",
            "name_en": "Krado",
            "district_id": 9410,
            "lat": 6.717,
            "long": 101.299,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 941009,
            "zip_code": 94160,
            "name_th": "คลองใหม่",
            "name_en": "Khlong Mai",
            "district_id": 9410,
            "lat": 6.735,
            "long": 101.262,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 941010,
            "zip_code": 94160,
            "name_th": "เมาะมาวี",
            "name_en": "Mo Mawi",
            "district_id": 9410,
            "lat": 6.67,
            "long": 101.303,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 941011,
            "zip_code": 94160,
            "name_th": "กอลำ",
            "name_en": "Kolam",
            "district_id": 9410,
            "lat": 6.673,
            "long": 101.329,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 941012,
            "zip_code": 94160,
            "name_th": "เขาตูม",
            "name_en": "Khao Tum",
            "district_id": 9410,
            "lat": 6.603,
            "long": 101.314,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 9411,
        "name_th": "กะพ้อ",
        "name_en": "Kapho",
        "province_id": 74,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 941101,
            "zip_code": 94230,
            "name_th": "กะรุบี",
            "name_en": "Karubi",
            "district_id": 9411,
            "lat": 6.57,
            "long": 101.556,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 941102,
            "zip_code": 94230,
            "name_th": "ตะโละดือรามัน",
            "name_en": "Talo Due Raman",
            "district_id": 9411,
            "lat": 6.603,
            "long": 101.554,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 941103,
            "zip_code": 94230,
            "name_th": "ปล่องหอย",
            "name_en": "Plong Hoi",
            "district_id": 9411,
            "lat": 6.638,
            "long": 101.509,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 9412,
        "name_th": "แม่ลาน",
        "name_en": "Mae Lan",
        "province_id": 74,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 941201,
            "zip_code": 94180,
            "name_th": "แม่ลาน",
            "name_en": "Mae Lan",
            "district_id": 9412,
            "lat": 6.647,
            "long": 101.231,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 941202,
            "zip_code": 94180,
            "name_th": "ม่วงเตี้ย",
            "name_en": "Muang Tia",
            "district_id": 9412,
            "lat": 6.677,
            "long": 101.266,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 941203,
            "zip_code": 94180,
            "name_th": "ป่าไร่",
            "name_en": "Pa Rai",
            "district_id": 9412,
            "lat": 6.685,
            "long": 101.214,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      }
    ]
  },
  {
    "id": 75,
    "name_th": "ยะลา",
    "name_en": "Yala",
    "geography_id": 6,
    "created_at": "2019-08-09T03:33:09.000+07:00",
    "updated_at": "2025-09-20T06:31:26.000+07:00",
    "deleted_at": null,
    "districts": [
      {
        "id": 9501,
        "name_th": "เมืองยะลา",
        "name_en": "Mueang Yala",
        "province_id": 75,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 950101,
            "zip_code": 95000,
            "name_th": "สะเตง",
            "name_en": "Sateng",
            "district_id": 9501,
            "lat": 6.547,
            "long": 101.28,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 950102,
            "zip_code": 95000,
            "name_th": "บุดี",
            "name_en": "Budi",
            "district_id": 9501,
            "lat": 6.487,
            "long": 101.305,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 950103,
            "zip_code": 95000,
            "name_th": "ยุโป",
            "name_en": "Yopo",
            "district_id": 9501,
            "lat": 6.597,
            "long": 101.283,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 950104,
            "zip_code": 95160,
            "name_th": "ลิดล",
            "name_en": "Lidon",
            "district_id": 9501,
            "lat": 6.551,
            "long": 101.166,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 950106,
            "zip_code": 95000,
            "name_th": "ยะลา",
            "name_en": "Yala",
            "district_id": 9501,
            "lat": 6.523,
            "long": 101.181,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 950108,
            "zip_code": 95000,
            "name_th": "ท่าสาป",
            "name_en": "Tha Sap",
            "district_id": 9501,
            "lat": 6.538,
            "long": 101.235,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 950109,
            "zip_code": 95160,
            "name_th": "ลำใหม่",
            "name_en": "Lam Mai",
            "district_id": 9501,
            "lat": 6.583,
            "long": 101.205,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 950110,
            "zip_code": 95000,
            "name_th": "หน้าถ้ำ",
            "name_en": "Na Tham",
            "district_id": 9501,
            "lat": 6.525,
            "long": 101.225,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 950111,
            "zip_code": 95160,
            "name_th": "ลำพะยา",
            "name_en": "Lam Phaya",
            "district_id": 9501,
            "lat": 6.584,
            "long": 101.162,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 950112,
            "zip_code": 95000,
            "name_th": "เปาะเส้ง",
            "name_en": "Po Seng",
            "district_id": 9501,
            "lat": 6.511,
            "long": 101.201,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 950114,
            "zip_code": 95160,
            "name_th": "พร่อน",
            "name_en": "Phron",
            "district_id": 9501,
            "lat": 6.563,
            "long": 101.229,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 950115,
            "zip_code": 95000,
            "name_th": "บันนังสาเรง",
            "name_en": "Bannang Sareng",
            "district_id": 9501,
            "lat": 6.48,
            "long": 101.258,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 950116,
            "zip_code": 95000,
            "name_th": "สะเตงนอก",
            "name_en": "Sateng Nok",
            "district_id": 9501,
            "lat": 6.552,
            "long": 101.324,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 950118,
            "zip_code": 95000,
            "name_th": "ตาเซะ",
            "name_en": "Ta Se",
            "district_id": 9501,
            "lat": 6.62,
            "long": 101.253,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 9502,
        "name_th": "เบตง",
        "name_en": "Betong",
        "province_id": 75,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 950201,
            "zip_code": 95110,
            "name_th": "เบตง",
            "name_en": "Betong",
            "district_id": 9502,
            "lat": 5.803,
            "long": 101.009,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 950202,
            "zip_code": 95110,
            "name_th": "ยะรม",
            "name_en": "Yarom",
            "district_id": 9502,
            "lat": 5.771,
            "long": 101.203,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 950203,
            "zip_code": 95110,
            "name_th": "ตาเนาะแมเราะ",
            "name_en": "Tano Maero",
            "district_id": 9502,
            "lat": 5.853,
            "long": 101.099,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 950204,
            "zip_code": 95110,
            "name_th": "อัยเยอร์เวง",
            "name_en": "Aiyoe Weng",
            "district_id": 9502,
            "lat": 5.963,
            "long": 101.398,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 950205,
            "zip_code": 95110,
            "name_th": "ธารน้ำทิพย์",
            "name_en": "Than Nam Thip",
            "district_id": 9502,
            "lat": 5.686,
            "long": 101.141,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 9503,
        "name_th": "บันนังสตา",
        "name_en": "Bannang Sata",
        "province_id": 75,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 950301,
            "zip_code": 95130,
            "name_th": "บันนังสตา",
            "name_en": "Bannang Sata",
            "district_id": 9503,
            "lat": 6.25,
            "long": 101.233,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 950302,
            "zip_code": 95130,
            "name_th": "บาเจาะ",
            "name_en": "Bacho",
            "district_id": 9503,
            "lat": 6.212,
            "long": 101.291,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 950303,
            "zip_code": 95130,
            "name_th": "ตาเนาะปูเต๊ะ",
            "name_en": "Tano Pute",
            "district_id": 9503,
            "lat": 6.355,
            "long": 101.327,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 950304,
            "zip_code": 95130,
            "name_th": "ถ้ำทะลุ",
            "name_en": "Tham Thalu",
            "district_id": 9503,
            "lat": 6.238,
            "long": 101.147,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 950305,
            "zip_code": 95130,
            "name_th": "ตลิ่งชัน",
            "name_en": "Taling Chan",
            "district_id": 9503,
            "lat": 6.271,
            "long": 101.352,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 950306,
            "zip_code": 95130,
            "name_th": "เขื่อนบางลาง",
            "name_en": "Khuean Bang Lang",
            "district_id": 9503,
            "lat": 6.142,
            "long": 101.309,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 9504,
        "name_th": "ธารโต",
        "name_en": "Than To",
        "province_id": 75,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 950401,
            "zip_code": 95150,
            "name_th": "ธารโต",
            "name_en": "Than To",
            "district_id": 9504,
            "lat": 6.167,
            "long": 101.187,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 950402,
            "zip_code": 95150,
            "name_th": "บ้านแหร",
            "name_en": "Ban Rae",
            "district_id": 9504,
            "lat": 6.105,
            "long": 101.204,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 950403,
            "zip_code": 95170,
            "name_th": "แม่หวาด",
            "name_en": "Mae Wat",
            "district_id": 9504,
            "lat": 6.102,
            "long": 101.384,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 950404,
            "zip_code": 95150,
            "name_th": "คีรีเขต",
            "name_en": "Khiri Khet",
            "district_id": 9504,
            "lat": 6.153,
            "long": 101.116,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 9505,
        "name_th": "ยะหา",
        "name_en": "Yaha",
        "province_id": 75,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 950501,
            "zip_code": 95120,
            "name_th": "ยะหา",
            "name_en": "Yaha",
            "district_id": 9505,
            "lat": 6.504,
            "long": 101.125,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 950502,
            "zip_code": 95120,
            "name_th": "ละแอ",
            "name_en": "La-ae",
            "district_id": 9505,
            "lat": 6.466,
            "long": 101.186,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 950503,
            "zip_code": 95120,
            "name_th": "ปะแต",
            "name_en": "Patae",
            "district_id": 9505,
            "lat": 6.344,
            "long": 101.139,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 950504,
            "zip_code": 95120,
            "name_th": "บาโร๊ะ",
            "name_en": "Baro",
            "district_id": 9505,
            "lat": 6.457,
            "long": 101.133,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 950506,
            "zip_code": 95120,
            "name_th": "ตาชี",
            "name_en": "Ta Chi",
            "district_id": 9505,
            "lat": 6.563,
            "long": 101.115,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 950507,
            "zip_code": 95120,
            "name_th": "บาโงยซิแน",
            "name_en": "Ba-ngoi Sinae",
            "district_id": 9505,
            "lat": 6.527,
            "long": 101.153,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 950508,
            "zip_code": 95120,
            "name_th": "กาตอง",
            "name_en": "Ka Tong",
            "district_id": 9505,
            "lat": 6.502,
            "long": 101.063,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 9506,
        "name_th": "รามัน",
        "name_en": "Raman",
        "province_id": 75,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 950601,
            "zip_code": 95140,
            "name_th": "กายูบอเกาะ",
            "name_en": "Kayu Boko",
            "district_id": 9506,
            "lat": 6.476,
            "long": 101.413,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 950602,
            "zip_code": 95140,
            "name_th": "กาลูปัง",
            "name_en": "Kalupang",
            "district_id": 9506,
            "lat": 6.464,
            "long": 101.374,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 950603,
            "zip_code": 95140,
            "name_th": "กาลอ",
            "name_en": "Kalo",
            "district_id": 9506,
            "lat": 6.378,
            "long": 101.383,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 950604,
            "zip_code": 95140,
            "name_th": "กอตอตือร๊ะ",
            "name_en": "Koto Tuera",
            "district_id": 9506,
            "lat": 6.5,
            "long": 101.389,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 950605,
            "zip_code": 95140,
            "name_th": "โกตาบารู",
            "name_en": "Kota Baru",
            "district_id": 9506,
            "lat": 6.452,
            "long": 101.345,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 950606,
            "zip_code": 95140,
            "name_th": "เกะรอ",
            "name_en": "Kero",
            "district_id": 9506,
            "lat": 6.535,
            "long": 101.576,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 950607,
            "zip_code": 95140,
            "name_th": "จะกว๊ะ",
            "name_en": "Cha-kwa",
            "district_id": 9506,
            "lat": 6.498,
            "long": 101.536,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 950608,
            "zip_code": 95140,
            "name_th": "ท่าธง",
            "name_en": "Tha Thong",
            "district_id": 9506,
            "lat": 6.565,
            "long": 101.458,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 950609,
            "zip_code": 95140,
            "name_th": "เนินงาม",
            "name_en": "Noen Ngam",
            "district_id": 9506,
            "lat": 6.508,
            "long": 101.347,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 950610,
            "zip_code": 95140,
            "name_th": "บาลอ",
            "name_en": "Balo",
            "district_id": 9506,
            "lat": 6.448,
            "long": 101.445,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 950611,
            "zip_code": 95140,
            "name_th": "บาโงย",
            "name_en": "Ba-ngoi",
            "district_id": 9506,
            "lat": 6.473,
            "long": 101.349,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 950612,
            "zip_code": 95140,
            "name_th": "บือมัง",
            "name_en": "Buemang",
            "district_id": 9506,
            "lat": 6.411,
            "long": 101.336,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 950613,
            "zip_code": 95140,
            "name_th": "ยะต๊ะ",
            "name_en": "Yata",
            "district_id": 9506,
            "lat": 6.426,
            "long": 101.407,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 950614,
            "zip_code": 95140,
            "name_th": "วังพญา",
            "name_en": "Wang Phaya",
            "district_id": 9506,
            "lat": 6.544,
            "long": 101.375,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 950615,
            "zip_code": 95140,
            "name_th": "อาซ่อง",
            "name_en": "Asong",
            "district_id": 9506,
            "lat": 6.52,
            "long": 101.451,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 950616,
            "zip_code": 95140,
            "name_th": "ตะโล๊ะหะลอ",
            "name_en": "Talo Halo",
            "district_id": 9506,
            "lat": 6.479,
            "long": 101.485,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 9507,
        "name_th": "กาบัง",
        "name_en": "Kabang",
        "province_id": 75,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 950701,
            "zip_code": 95120,
            "name_th": "กาบัง",
            "name_en": "Kabang",
            "district_id": 9507,
            "lat": 6.449,
            "long": 101.0,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 950702,
            "zip_code": 95120,
            "name_th": "บาละ",
            "name_en": "Bala",
            "district_id": 9507,
            "lat": 6.33,
            "long": 101.023,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 9508,
        "name_th": "กรงปินัง",
        "name_en": "Krong Pinang",
        "province_id": 75,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 950801,
            "zip_code": 95000,
            "name_th": "กรงปินัง",
            "name_en": "Krong Pinang",
            "district_id": 9508,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 950802,
            "zip_code": 95000,
            "name_th": "สะเอะ",
            "name_en": "Sa-e",
            "district_id": 9508,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 950803,
            "zip_code": 95000,
            "name_th": "ห้วยกระทิง",
            "name_en": "Huai Krathing",
            "district_id": 9508,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 950804,
            "zip_code": 95000,
            "name_th": "ปุโรง",
            "name_en": "Purong",
            "district_id": 9508,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      }
    ]
  },
  {
    "id": 76,
    "name_th": "นราธิวาส",
    "name_en": "Narathiwat",
    "geography_id": 6,
    "created_at": "2019-08-09T03:33:09.000+07:00",
    "updated_at": "2025-09-20T06:31:26.000+07:00",
    "deleted_at": null,
    "districts": [
      {
        "id": 9601,
        "name_th": "เมืองนราธิวาส",
        "name_en": "Mueang Narathiwat",
        "province_id": 76,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 960101,
            "zip_code": 96000,
            "name_th": "บางนาค",
            "name_en": "Bang Nak",
            "district_id": 9601,
            "lat": 6.424,
            "long": 101.82,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 960102,
            "zip_code": 96000,
            "name_th": "ลำภู",
            "name_en": "Lam Phu",
            "district_id": 9601,
            "lat": 6.379,
            "long": 101.819,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 960103,
            "zip_code": 96000,
            "name_th": "มะนังตายอ",
            "name_en": "Manang Tayo",
            "district_id": 9601,
            "lat": 6.354,
            "long": 101.76,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 960104,
            "zip_code": 96000,
            "name_th": "บางปอ",
            "name_en": "Bang Po",
            "district_id": 9601,
            "lat": 6.33,
            "long": 101.804,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 960105,
            "zip_code": 96000,
            "name_th": "กะลุวอ",
            "name_en": "Kaluwo",
            "district_id": 9601,
            "lat": 6.342,
            "long": 101.874,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 960106,
            "zip_code": 96000,
            "name_th": "กะลุวอเหนือ",
            "name_en": "Kaluwo Nuea",
            "district_id": 9601,
            "lat": 6.404,
            "long": 101.862,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 960107,
            "zip_code": 96000,
            "name_th": "โคกเคียน",
            "name_en": "Khok Khian",
            "district_id": 9601,
            "lat": 6.482,
            "long": 101.763,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 9602,
        "name_th": "ตากใบ",
        "name_en": "Tak Bai",
        "province_id": 76,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 960201,
            "zip_code": 96110,
            "name_th": "เจ๊ะเห",
            "name_en": "Chehe",
            "district_id": 9602,
            "lat": 6.257,
            "long": 102.051,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 960202,
            "zip_code": 96110,
            "name_th": "ไพรวัน",
            "name_en": "Phrai Wan",
            "district_id": 9602,
            "lat": 6.3,
            "long": 101.958,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 960203,
            "zip_code": 96110,
            "name_th": "พร่อน",
            "name_en": "Phron",
            "district_id": 9602,
            "lat": 6.202,
            "long": 102.014,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 960204,
            "zip_code": 96110,
            "name_th": "ศาลาใหม่",
            "name_en": "Sala Mai",
            "district_id": 9602,
            "lat": 6.282,
            "long": 102.008,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 960205,
            "zip_code": 96110,
            "name_th": "บางขุนทอง",
            "name_en": "Bang Khun Thong",
            "district_id": 9602,
            "lat": 6.234,
            "long": 101.967,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 960206,
            "zip_code": 96110,
            "name_th": "เกาะสะท้อน",
            "name_en": "Ko Sathon",
            "district_id": 9602,
            "lat": 6.22,
            "long": 102.059,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 960207,
            "zip_code": 96110,
            "name_th": "นานาค",
            "name_en": "Na Nak",
            "district_id": 9602,
            "lat": 6.142,
            "long": 102.07,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 960208,
            "zip_code": 96110,
            "name_th": "โฆษิต",
            "name_en": "Khosit",
            "district_id": 9602,
            "lat": 6.175,
            "long": 102.052,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 9603,
        "name_th": "บาเจาะ",
        "name_en": "Bacho",
        "province_id": 76,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 960301,
            "zip_code": 96170,
            "name_th": "บาเจาะ",
            "name_en": "Bacho",
            "district_id": 9603,
            "lat": 6.514,
            "long": 101.636,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 960302,
            "zip_code": 96170,
            "name_th": "ลุโบะสาวอ",
            "name_en": "Lubo Sawo",
            "district_id": 9603,
            "lat": 6.486,
            "long": 101.667,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 960303,
            "zip_code": 96170,
            "name_th": "กาเยาะมาตี",
            "name_en": "Kayo Mati",
            "district_id": 9603,
            "lat": 6.545,
            "long": 101.625,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 960304,
            "zip_code": 96170,
            "name_th": "ปะลุกาสาเมาะ",
            "name_en": "Paluka Samo",
            "district_id": 9603,
            "lat": 6.608,
            "long": 101.609,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 960305,
            "zip_code": 96170,
            "name_th": "บาเระเหนือ",
            "name_en": "Bare Nuea",
            "district_id": 9603,
            "lat": 6.571,
            "long": 101.613,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 960306,
            "zip_code": 96170,
            "name_th": "บาเระใต้",
            "name_en": "Ba Re Tai",
            "district_id": 9603,
            "lat": 6.539,
            "long": 101.693,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 9604,
        "name_th": "ยี่งอ",
        "name_en": "Yi-ngo",
        "province_id": 76,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 960401,
            "zip_code": 96180,
            "name_th": "ยี่งอ",
            "name_en": "Yi-ngo",
            "district_id": 9604,
            "lat": 6.382,
            "long": 101.703,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 960402,
            "zip_code": 96180,
            "name_th": "ละหาร",
            "name_en": "Lahan",
            "district_id": 9604,
            "lat": 6.396,
            "long": 101.745,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 960403,
            "zip_code": 96180,
            "name_th": "จอเบาะ",
            "name_en": "Chobo",
            "district_id": 9604,
            "lat": 6.382,
            "long": 101.66,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 960404,
            "zip_code": 96180,
            "name_th": "ลุโบะบายะ",
            "name_en": "Lubo Baya",
            "district_id": 9604,
            "lat": 6.422,
            "long": 101.663,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 960405,
            "zip_code": 96180,
            "name_th": "ลุโบะบือซา",
            "name_en": "Lubo Buesa",
            "district_id": 9604,
            "lat": 6.43,
            "long": 101.725,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 960406,
            "zip_code": 96180,
            "name_th": "ตะปอเยาะ",
            "name_en": "Tapoyo",
            "district_id": 9604,
            "lat": 6.457,
            "long": 101.663,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 9605,
        "name_th": "ระแงะ",
        "name_en": "Ra-ngae",
        "province_id": 76,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 960501,
            "zip_code": 96130,
            "name_th": "ตันหยงมัส",
            "name_en": "Tanyong Mat",
            "district_id": 9605,
            "lat": 6.311,
            "long": 101.724,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 960502,
            "zip_code": 96130,
            "name_th": "ตันหยงลิมอ",
            "name_en": "Tanyong Limo",
            "district_id": 9605,
            "lat": 6.283,
            "long": 101.775,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 960506,
            "zip_code": 96220,
            "name_th": "บองอ",
            "name_en": "Bo-ngo",
            "district_id": 9605,
            "lat": 6.172,
            "long": 101.753,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 960507,
            "zip_code": 96130,
            "name_th": "กาลิซา",
            "name_en": "Kalisa",
            "district_id": 9605,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 960508,
            "zip_code": 96130,
            "name_th": "บาโงสะโต",
            "name_en": "Ba-ngo Sato",
            "district_id": 9605,
            "lat": 6.277,
            "long": 101.691,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 960509,
            "zip_code": 96130,
            "name_th": "เฉลิม",
            "name_en": "Chaloem",
            "district_id": 9605,
            "lat": 6.291,
            "long": 101.641,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 960510,
            "zip_code": 96130,
            "name_th": "มะรือโบตก",
            "name_en": "Maruebo Tok",
            "district_id": 9605,
            "lat": 6.337,
            "long": 101.66,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 9606,
        "name_th": "รือเสาะ",
        "name_en": "Rueso",
        "province_id": 76,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 960601,
            "zip_code": 96150,
            "name_th": "รือเสาะ",
            "name_en": "Rueso",
            "district_id": 9606,
            "lat": 6.369,
            "long": 101.508,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 960602,
            "zip_code": 96150,
            "name_th": "สาวอ",
            "name_en": "Sawo",
            "district_id": 9606,
            "lat": 6.434,
            "long": 101.507,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 960603,
            "zip_code": 96150,
            "name_th": "เรียง",
            "name_en": "Riang",
            "district_id": 9606,
            "lat": 6.398,
            "long": 101.445,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 960604,
            "zip_code": 96150,
            "name_th": "สามัคคี",
            "name_en": "Samakkhi",
            "district_id": 9606,
            "lat": 6.423,
            "long": 101.587,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 960605,
            "zip_code": 96150,
            "name_th": "บาตง",
            "name_en": "Batong",
            "district_id": 9606,
            "lat": 6.336,
            "long": 101.445,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 960606,
            "zip_code": 96150,
            "name_th": "ลาโละ",
            "name_en": "Lalo",
            "district_id": 9606,
            "lat": 6.343,
            "long": 101.59,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 960607,
            "zip_code": 96150,
            "name_th": "รือเสาะออก",
            "name_en": "Rueso Ok",
            "district_id": 9606,
            "lat": 6.394,
            "long": 101.554,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 960608,
            "zip_code": 96150,
            "name_th": "โคกสะตอ",
            "name_en": "Khok Sato",
            "district_id": 9606,
            "lat": 6.282,
            "long": 101.449,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 960609,
            "zip_code": 96150,
            "name_th": "สุวารี",
            "name_en": "Suwari",
            "district_id": 9606,
            "lat": 6.458,
            "long": 101.611,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 9607,
        "name_th": "ศรีสาคร",
        "name_en": "Si Sakhon",
        "province_id": 76,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 960701,
            "zip_code": 96210,
            "name_th": "ซากอ",
            "name_en": "Sako",
            "district_id": 9607,
            "lat": 6.23,
            "long": 101.522,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 960702,
            "zip_code": 96210,
            "name_th": "ตะมะยูง",
            "name_en": "Tamayung",
            "district_id": 9607,
            "lat": 6.282,
            "long": 101.515,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 960703,
            "zip_code": 96210,
            "name_th": "ศรีสาคร",
            "name_en": "Si Sakhon",
            "district_id": 9607,
            "lat": 6.152,
            "long": 101.492,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 960704,
            "zip_code": 96210,
            "name_th": "เชิงคีรี",
            "name_en": "Choeng Khiri",
            "district_id": 9607,
            "lat": 6.27,
            "long": 101.57,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 960705,
            "zip_code": 96210,
            "name_th": "กาหลง",
            "name_en": "Kalong",
            "district_id": 9607,
            "lat": 6.213,
            "long": 101.414,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 960706,
            "zip_code": 96210,
            "name_th": "ศรีบรรพต",
            "name_en": "Si Banphot",
            "district_id": 9607,
            "lat": 6.152,
            "long": 101.574,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 9608,
        "name_th": "แว้ง",
        "name_en": "Waeng",
        "province_id": 76,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 960801,
            "zip_code": 96160,
            "name_th": "แว้ง",
            "name_en": "Waeng",
            "district_id": 9608,
            "lat": 5.936,
            "long": 101.835,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 960802,
            "zip_code": 96160,
            "name_th": "กายูคละ",
            "name_en": "Kayu Khla",
            "district_id": 9608,
            "lat": 5.974,
            "long": 101.911,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 960803,
            "zip_code": 96160,
            "name_th": "ฆอเลาะ",
            "name_en": "Kholo",
            "district_id": 9608,
            "lat": 5.906,
            "long": 101.912,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 960804,
            "zip_code": 96160,
            "name_th": "โละจูด",
            "name_en": "Lochut",
            "district_id": 9608,
            "lat": 5.831,
            "long": 101.834,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 960805,
            "zip_code": 96160,
            "name_th": "แม่ดง",
            "name_en": "Mae Dong",
            "district_id": 9608,
            "lat": 5.892,
            "long": 101.82,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 960806,
            "zip_code": 96160,
            "name_th": "เอราวัณ",
            "name_en": "Erawan",
            "district_id": 9608,
            "lat": 5.973,
            "long": 101.842,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 9609,
        "name_th": "สุคิริน",
        "name_en": "Sukhirin",
        "province_id": 76,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 960901,
            "zip_code": 96190,
            "name_th": "มาโมง",
            "name_en": "Mamong",
            "district_id": 9609,
            "lat": 5.876,
            "long": 101.764,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 960902,
            "zip_code": 96190,
            "name_th": "สุคิริน",
            "name_en": "Sukhirin",
            "district_id": 9609,
            "lat": 5.951,
            "long": 101.697,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 960903,
            "zip_code": 96190,
            "name_th": "เกียร์",
            "name_en": "Kia",
            "district_id": 9609,
            "lat": 5.984,
            "long": 101.775,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 960904,
            "zip_code": 96190,
            "name_th": "ภูเขาทอง",
            "name_en": "Phukhao Thong",
            "district_id": 9609,
            "lat": 5.796,
            "long": 101.7,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 960905,
            "zip_code": 96190,
            "name_th": "ร่มไทร",
            "name_en": "Rom Sai",
            "district_id": 9609,
            "lat": 6.048,
            "long": 101.759,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 9610,
        "name_th": "สุไหงโก-ลก",
        "name_en": "Su-ngai Kolok",
        "province_id": 76,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 961001,
            "zip_code": 96120,
            "name_th": "สุไหงโก-ลก",
            "name_en": "Su-ngai Kolok",
            "district_id": 9610,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 961002,
            "zip_code": 96120,
            "name_th": "ปาเสมัส",
            "name_en": "Pase Mat",
            "district_id": 9610,
            "lat": 6.054,
            "long": 101.975,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 961003,
            "zip_code": 96120,
            "name_th": "มูโนะ",
            "name_en": "Muno",
            "district_id": 9610,
            "lat": 6.108,
            "long": 102.052,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 961004,
            "zip_code": 96120,
            "name_th": "ปูโยะ",
            "name_en": "Puyo",
            "district_id": 9610,
            "lat": 6.109,
            "long": 101.993,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 9611,
        "name_th": "สุไหงปาดี",
        "name_en": "Su-ngai Padi",
        "province_id": 76,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 961101,
            "zip_code": 96140,
            "name_th": "ปะลุรู",
            "name_en": "Paluru",
            "district_id": 9611,
            "lat": 6.073,
            "long": 101.905,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 961102,
            "zip_code": 96140,
            "name_th": "สุไหงปาดี",
            "name_en": "Su-ngai Padi",
            "district_id": 9611,
            "lat": 6.161,
            "long": 101.931,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 961103,
            "zip_code": 96140,
            "name_th": "โต๊ะเด็ง",
            "name_en": "To Deng",
            "district_id": 9611,
            "lat": 6.116,
            "long": 101.849,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 961104,
            "zip_code": 96140,
            "name_th": "สากอ",
            "name_en": "Sako",
            "district_id": 9611,
            "lat": 6.008,
            "long": 101.849,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 961105,
            "zip_code": 96140,
            "name_th": "ริโก๋",
            "name_en": "Riko",
            "district_id": 9611,
            "lat": 6.057,
            "long": 101.845,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 961106,
            "zip_code": 96140,
            "name_th": "กาวะ",
            "name_en": "Ka Wa",
            "district_id": 9611,
            "lat": 6.02,
            "long": 101.889,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 9612,
        "name_th": "จะแนะ",
        "name_en": "Chanae",
        "province_id": 76,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 961201,
            "zip_code": 96220,
            "name_th": "จะแนะ",
            "name_en": "Chanae",
            "district_id": 9612,
            "lat": 6.077,
            "long": 101.693,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 961202,
            "zip_code": 96220,
            "name_th": "ดุซงญอ",
            "name_en": "Dusong Yo",
            "district_id": 9612,
            "lat": 6.123,
            "long": 101.643,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 961203,
            "zip_code": 96220,
            "name_th": "ผดุงมาตร",
            "name_en": "Phadung Mat",
            "district_id": 9612,
            "lat": 6.132,
            "long": 101.728,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 961204,
            "zip_code": 96220,
            "name_th": "ช้างเผือก",
            "name_en": "Chang Phueak",
            "district_id": 9612,
            "lat": 5.997,
            "long": 101.573,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 9613,
        "name_th": "เจาะไอร้อง",
        "name_en": "Cho-airong",
        "province_id": 76,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 961301,
            "zip_code": 96130,
            "name_th": "จวบ",
            "name_en": "Chuap",
            "district_id": 9613,
            "lat": 6.256,
            "long": 101.817,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 961302,
            "zip_code": 96130,
            "name_th": "บูกิต",
            "name_en": "Bukit",
            "district_id": 9613,
            "lat": 6.182,
            "long": 101.828,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 961303,
            "zip_code": 96130,
            "name_th": "มะรือโบออก",
            "name_en": "Maruebo Ok",
            "district_id": 9613,
            "lat": 6.249,
            "long": 101.875,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      }
    ]
  },
  {
    "id": 77,
    "name_th": "บึงกาฬ",
    "name_en": "Bueng Kan",
    "geography_id": 3,
    "created_at": "2019-08-09T03:33:09.000+07:00",
    "updated_at": "2025-09-20T06:31:26.000+07:00",
    "deleted_at": null,
    "districts": [
      {
        "id": 3801,
        "name_th": "เมืองบึงกาฬ",
        "name_en": "Mueang Bueng Kan",
        "province_id": 77,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 380101,
            "zip_code": 38000,
            "name_th": "คำนาดี",
            "name_en": "Kham Na Di",
            "district_id": 3801,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 380102,
            "zip_code": 38000,
            "name_th": "บึงโขงหลง",
            "name_en": "Bueng Khong Long",
            "district_id": 3801,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 380103,
            "zip_code": 38000,
            "name_th": "ไคสี",
            "name_en": "Khai Si",
            "district_id": 3801,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 380104,
            "zip_code": 38000,
            "name_th": "ชัยพร",
            "name_en": "Chaiyaphon",
            "district_id": 3801,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 380105,
            "zip_code": 38000,
            "name_th": "นาสวรรค์",
            "name_en": "Na Sawan",
            "district_id": 3801,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 380106,
            "zip_code": 38000,
            "name_th": "โนนสมบูรณ์",
            "name_en": "Non Sombun",
            "district_id": 3801,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 380107,
            "zip_code": 38000,
            "name_th": "บึงกาฬ",
            "name_en": "Bueng Kan",
            "district_id": 3801,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 380108,
            "zip_code": 38000,
            "name_th": "โป่งเปื่อย",
            "name_en": "Pong Pueai",
            "district_id": 3801,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 380109,
            "zip_code": 38000,
            "name_th": "วิศิษฐ์",
            "name_en": "Wisit",
            "district_id": 3801,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 380110,
            "zip_code": 38000,
            "name_th": "หนองเข็ง",
            "name_en": "Nong Keng",
            "district_id": 3801,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 380111,
            "zip_code": 38000,
            "name_th": "หนองเลิง",
            "name_en": "Nong Loeng",
            "district_id": 3801,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 380112,
            "zip_code": 38000,
            "name_th": "หอคำ",
            "name_en": "Ho Kham",
            "district_id": 3801,
            "lat": null,
            "long": null,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 3802,
        "name_th": "เซกา",
        "name_en": "Seka",
        "province_id": 77,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 380201,
            "zip_code": 38150,
            "name_th": "ซาง",
            "name_en": "Sang",
            "district_id": 3802,
            "lat": 17.839,
            "long": 103.958,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 380202,
            "zip_code": 38150,
            "name_th": "เซกา",
            "name_en": "Seka",
            "district_id": 3802,
            "lat": 17.964,
            "long": 103.945,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 380203,
            "zip_code": 38150,
            "name_th": "ท่ากกแดง",
            "name_en": "Tha Kok Daeng",
            "district_id": 3802,
            "lat": 17.911,
            "long": 103.816,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 380204,
            "zip_code": 38150,
            "name_th": "ท่าสะอาด",
            "name_en": "Tha Sa-at",
            "district_id": 3802,
            "lat": 17.975,
            "long": 103.744,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 380205,
            "zip_code": 38150,
            "name_th": "น้ำจั้น",
            "name_en": "Nam Chan",
            "district_id": 3802,
            "lat": 18.063,
            "long": 103.894,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 380206,
            "zip_code": 38150,
            "name_th": "บ้านต้อง",
            "name_en": "Ban Tong",
            "district_id": 3802,
            "lat": 18.099,
            "long": 103.946,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 380207,
            "zip_code": 38150,
            "name_th": "ป่งไฮ",
            "name_en": "Pong Hai",
            "district_id": 3802,
            "lat": 17.976,
            "long": 103.873,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 380208,
            "zip_code": 38150,
            "name_th": "โสกก่าม",
            "name_en": "Sok Kam",
            "district_id": 3802,
            "lat": 18.075,
            "long": 104.015,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 380209,
            "zip_code": 38150,
            "name_th": "หนองทุ่ม",
            "name_en": "Nong Thum",
            "district_id": 3802,
            "lat": 17.914,
            "long": 103.891,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 3803,
        "name_th": "โซ่พิสัย",
        "name_en": "So Phisai",
        "province_id": 77,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 380301,
            "zip_code": 38170,
            "name_th": "คำแก้ว",
            "name_en": "Kham Kaeo",
            "district_id": 3803,
            "lat": 18.093,
            "long": 103.489,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 380302,
            "zip_code": 38170,
            "name_th": "โซ่",
            "name_en": "So",
            "district_id": 3803,
            "lat": 18.039,
            "long": 103.391,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 380303,
            "zip_code": 38170,
            "name_th": "ถ้ำเจริญ",
            "name_en": "Tham Charoen",
            "district_id": 3803,
            "lat": 18.208,
            "long": 103.497,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 380304,
            "zip_code": 38170,
            "name_th": "บัวตูม",
            "name_en": "Bua Tum",
            "district_id": 3803,
            "lat": 18.072,
            "long": 103.364,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 380305,
            "zip_code": 38170,
            "name_th": "ศรีชมภู",
            "name_en": "Si Chomphu",
            "district_id": 3803,
            "lat": 18.271,
            "long": 103.464,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 380306,
            "zip_code": 38170,
            "name_th": "หนองพันทา",
            "name_en": "Nong Phan Tha",
            "district_id": 3803,
            "lat": 18.129,
            "long": 103.384,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 380307,
            "zip_code": 38170,
            "name_th": "เหล่าทอง",
            "name_en": "Lao Thong",
            "district_id": 3803,
            "lat": 18.144,
            "long": 103.442,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 3804,
        "name_th": "พรเจริญ",
        "name_en": "Phon Charoen",
        "province_id": 77,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 380401,
            "zip_code": 38180,
            "name_th": "ดอนหญ้านาง",
            "name_en": "Don Ya Nang",
            "district_id": 3804,
            "lat": 18.046,
            "long": 103.616,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 380402,
            "zip_code": 38180,
            "name_th": "ป่าแฝก",
            "name_en": "Pa Faek",
            "district_id": 3804,
            "lat": 18.094,
            "long": 103.698,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 380403,
            "zip_code": 38180,
            "name_th": "พรเจริญ",
            "name_en": "Phon Charoen",
            "district_id": 3804,
            "lat": 18.031,
            "long": 103.711,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 380404,
            "zip_code": 38180,
            "name_th": "วังชมภู",
            "name_en": "Wang Chomphu",
            "district_id": 3804,
            "lat": 17.983,
            "long": 103.683,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 380405,
            "zip_code": 38180,
            "name_th": "ศรีชมภู",
            "name_en": "Si Chomphu",
            "district_id": 3804,
            "lat": 18.044,
            "long": 103.679,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 380406,
            "zip_code": 38180,
            "name_th": "ศรีสำราญ",
            "name_en": "Si Samran",
            "district_id": 3804,
            "lat": 18.121,
            "long": 103.646,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 380407,
            "zip_code": 38180,
            "name_th": "หนองหัวช้าง",
            "name_en": "Nong Hua Chang",
            "district_id": 3804,
            "lat": 18.125,
            "long": 103.583,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 3805,
        "name_th": "ศรีวิไล",
        "name_en": "Si Wilai",
        "province_id": 77,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 380501,
            "zip_code": 38210,
            "name_th": "ชุมภูพร",
            "name_en": "Chumphu Phon",
            "district_id": 3805,
            "lat": 18.146,
            "long": 103.714,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 380502,
            "zip_code": 38210,
            "name_th": "นาสะแบง",
            "name_en": "Na Sabaeng",
            "district_id": 3805,
            "lat": 18.14,
            "long": 103.814,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 380503,
            "zip_code": 38210,
            "name_th": "นาสิงห์",
            "name_en": "Na Sing",
            "district_id": 3805,
            "lat": 18.212,
            "long": 103.789,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 380504,
            "zip_code": 38210,
            "name_th": "นาแสง",
            "name_en": "Na Saeng",
            "district_id": 3805,
            "lat": 18.082,
            "long": 103.843,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 380505,
            "zip_code": 38210,
            "name_th": "ศรีวิไล",
            "name_en": "Si Wilai",
            "district_id": 3805,
            "lat": 18.225,
            "long": 103.732,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 3806,
        "name_th": "บึงโขงหลง",
        "name_en": "Bueng Khong Long",
        "province_id": 77,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 380601,
            "zip_code": 38220,
            "name_th": "ดงบัง",
            "name_en": "Dong Bang",
            "district_id": 3806,
            "lat": 18.033,
            "long": 104.133,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 380602,
            "zip_code": 38220,
            "name_th": "ท่าดอกคำ",
            "name_en": "Tha Dok Kham",
            "district_id": 3806,
            "lat": 18.123,
            "long": 104.058,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 380603,
            "zip_code": 38220,
            "name_th": "บึงโขงหลง",
            "name_en": "Bueng Khong Long",
            "district_id": 3806,
            "lat": 18.002,
            "long": 104.045,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 380604,
            "zip_code": 38220,
            "name_th": "โพธิ์หมากแข้ง",
            "name_en": "Pho Mak Khaeng",
            "district_id": 3806,
            "lat": 17.941,
            "long": 104.075,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 3807,
        "name_th": "ปากคาด",
        "name_en": "Pak Khat",
        "province_id": 77,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 380701,
            "zip_code": 38190,
            "name_th": "นากั้ง",
            "name_en": "Na Kang",
            "district_id": 3807,
            "lat": 18.382,
            "long": 103.285,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 380702,
            "zip_code": 38190,
            "name_th": "นาดง",
            "name_en": "Na Dong",
            "district_id": 3807,
            "lat": 18.256,
            "long": 103.304,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 380703,
            "zip_code": 38190,
            "name_th": "โนนศิลา",
            "name_en": "Non Sila",
            "district_id": 3807,
            "lat": 18.292,
            "long": 103.346,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 380704,
            "zip_code": 38190,
            "name_th": "ปากคาด",
            "name_en": "Pak Khat",
            "district_id": 3807,
            "lat": 18.343,
            "long": 103.316,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 380705,
            "zip_code": 38190,
            "name_th": "ศรีวิไล",
            "name_en": "Sri Wi Lai",
            "district_id": 3807,
            "lat": 18.222,
            "long": 103.398,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 380706,
            "zip_code": 38190,
            "name_th": "หนองยอง",
            "name_en": "Nong Yong",
            "district_id": 3807,
            "lat": 18.208,
            "long": 103.351,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      },
      {
        "id": 3808,
        "name_th": "บุ่งคล้า",
        "name_en": "Bung Khla",
        "province_id": 77,
        "created_at": "2019-08-09T03:33:09.000+07:00",
        "updated_at": "2025-09-20T06:31:26.000+07:00",
        "deleted_at": null,
        "sub_districts": [
          {
            "id": 380801,
            "zip_code": 38000,
            "name_th": "โคกกว้าง",
            "name_en": "Khok Kwang",
            "district_id": 3808,
            "lat": 18.218,
            "long": 104.01,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 380802,
            "zip_code": 38000,
            "name_th": "บุ่งคล้า",
            "name_en": "Bung Khla",
            "district_id": 3808,
            "lat": 18.252,
            "long": 103.962,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          },
          {
            "id": 380803,
            "zip_code": 38000,
            "name_th": "หนองเดิน",
            "name_en": "Nong Doen",
            "district_id": 3808,
            "lat": 18.294,
            "long": 103.925,
            "created_at": "2019-08-09T03:33:09.000+07:00",
            "updated_at": "2025-09-20T06:31:26.000+07:00",
            "deleted_at": null
          }
        ]
      }
    ]
  }
]